import moment from "moment-timezone";
import * as React from "react";
import React__default, { Children, Component, createElement as createElement$2, isValidElement, useState, Fragment, useRef, useEffect, createRef } from "react";
import require$$3 from "react-dom";
import "react-dates/initialize";
import DayPickerSingleDateController from "react-dates/lib/components/DayPickerSingleDateController";
import "react-dates/lib/css/_datepicker.css";
import SingleDatePicker$1 from "react-dates/lib/components/SingleDatePicker";
import { Modal, Form as Form$1, InputGroup, Glyphicon, FormControl } from "react-bootstrap";
import Panel from "react-bootstrap/lib/Panel";
import { AdyenCheckout, Klarna, Redirect, ApplePay, GooglePay, Card, Dropin } from "@adyen/adyen-web";
var commonjsGlobal$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var js_cookie = { exports: {} };
var hasRequiredJs_cookie;
function requireJs_cookie() {
  if (hasRequiredJs_cookie) return js_cookie.exports;
  hasRequiredJs_cookie = 1;
  (function(module2, exports2) {
    (function(factory) {
      var registeredInModuleLoader;
      {
        module2.exports = factory();
        registeredInModuleLoader = true;
      }
      if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api2 = window.Cookies = factory();
        api2.noConflict = function() {
          window.Cookies = OldCookies;
          return api2;
        };
      }
    })(function() {
      function extend2() {
        var i = 0;
        var result = {};
        for (; i < arguments.length; i++) {
          var attributes = arguments[i];
          for (var key in attributes) {
            result[key] = attributes[key];
          }
        }
        return result;
      }
      function decode2(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }
      function init(converter) {
        function api2() {
        }
        function set3(key, value, attributes) {
          if (typeof document === "undefined") {
            return;
          }
          attributes = extend2({
            path: "/"
          }, api2.defaults, attributes);
          if (typeof attributes.expires === "number") {
            attributes.expires = new Date(/* @__PURE__ */ new Date() * 1 + attributes.expires * 864e5);
          }
          attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
          try {
            var result = JSON.stringify(value);
            if (/^[\{\[]/.test(result)) {
              value = result;
            }
          } catch (e) {
          }
          value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
          key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var stringifiedAttributes = "";
          for (var attributeName in attributes) {
            if (!attributes[attributeName]) {
              continue;
            }
            stringifiedAttributes += "; " + attributeName;
            if (attributes[attributeName] === true) {
              continue;
            }
            stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
          }
          return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get3(key, json) {
          if (typeof document === "undefined") {
            return;
          }
          var jar = {};
          var cookies = document.cookie ? document.cookie.split("; ") : [];
          var i = 0;
          for (; i < cookies.length; i++) {
            var parts = cookies[i].split("=");
            var cookie = parts.slice(1).join("=");
            if (!json && cookie.charAt(0) === '"') {
              cookie = cookie.slice(1, -1);
            }
            try {
              var name = decode2(parts[0]);
              cookie = (converter.read || converter)(cookie, name) || decode2(cookie);
              if (json) {
                try {
                  cookie = JSON.parse(cookie);
                } catch (e) {
                }
              }
              jar[name] = cookie;
              if (key === name) {
                break;
              }
            } catch (e) {
            }
          }
          return key ? jar[key] : jar;
        }
        api2.set = set3;
        api2.get = function(key) {
          return get3(
            key,
            false
            /* read as raw */
          );
        };
        api2.getJSON = function(key) {
          return get3(
            key,
            true
            /* read as json */
          );
        };
        api2.remove = function(key, attributes) {
          set3(key, "", extend2(attributes, {
            expires: -1
          }));
        };
        api2.defaults = {};
        api2.withConverter = init;
        return api2;
      }
      return init(function() {
      });
    });
  })(js_cookie);
  return js_cookie.exports;
}
var js_cookieExports = requireJs_cookie();
const Cookie = /* @__PURE__ */ getDefaultExportFromCjs(js_cookieExports);
const LOCALE_MAP = {
  en: { moment: "en-gb", intl: "en", intlCountry: "en-GB" },
  es: { moment: "es", intl: "es", intlCountry: "es-ES" },
  ca: { moment: "ca", intl: "ca", intlCountry: "ca-ES" },
  fr: { moment: "fr", intl: "fr", intlCountry: "fr-FR" },
  it: { moment: "it", intl: "it", intlCountry: "it-IT" },
  ru: { moment: "ru", intl: "ru", intlCountry: "ru-RU" },
  de: { moment: "de", intl: "de", intlCountry: "de-DE" },
  zh: { moment: "zh-cn", intl: "zh", intlCountry: "zh-CN" },
  ko: { moment: "ko", intl: "ko", intlCountry: "ko-KR" },
  eu: { moment: "eu", intl: "eu", intlCountry: "eu-ES" },
  gl: { moment: "gl", intl: "gl", intlCountry: "gl-ES" },
  ja: { moment: "ja", intl: "ja", intlCountry: "ja-JP" },
  va: { moment: "ca", intl: "ca", intlCountry: "ca-ES" },
  pt: { moment: "pt", intl: "pt", intlCountry: "pt-PT" },
  mx: { moment: "es-mx", intl: "es", intlCountry: "es-MX" },
  us: { moment: "en", intl: "en", intlCountry: "en-US" },
  cs: { moment: "cs", intl: "cs", intlCountry: "cs-CZ" }
};
const DEFAULT_LOCALE = "en";
function normalizeLocale(locale) {
  if (!locale) return DEFAULT_LOCALE;
  const lower = locale.toLowerCase();
  return LOCALE_MAP[lower] ? lower : DEFAULT_LOCALE;
}
function getMomentLocale(appLocale) {
  const entry = LOCALE_MAP[normalizeLocale(appLocale)];
  return entry ? entry.moment : "en-gb";
}
function getIntlLocale(appLocale) {
  const entry = LOCALE_MAP[normalizeLocale(appLocale)];
  return entry ? entry.intl : "en";
}
function getIntlCountryLocale(appLocale) {
  const entry = LOCALE_MAP[normalizeLocale(appLocale)];
  return entry ? entry.intlCountry : "en-GB";
}
function getAppLocale() {
  const raw = Cookie.get("locale") || Cookie.get("languageCountryCode") || DEFAULT_LOCALE;
  return normalizeLocale(raw);
}
function getFirstDayOfWeek(appLocale) {
  return normalizeLocale(appLocale) === "us" ? 0 : 1;
}
const DATE_FORMAT_YMD = "YYYY-MM-DD";
const DATE_FORMAT_YMD_COMPACT = "YYYYMMDD";
const DATE_FORMAT_DMY = "DD/MM/YYYY";
const DATE_FORMAT_DM = "DD/MM";
const DATE_FORMAT_DMY_COMPACT = "DDMMYYYY";
const DATE_FORMAT_YEAR_MONTH = "YYYY-MM";
const DATE_FORMAT_DAY_FULL = "dddd";
const DATE_FORMAT_DAY_SHORT = "ddd";
const DATE_FORMAT_DM_LONG = "D MMM";
const DATE_FORMAT_MD_LONG = "MMM DD";
const DATETIME_FORMAT_YMDHMS = "YYYY-MM-DD HH:mm:ss";
const DATETIME_FORMAT_YMDHM = "YYYY-MM-DD HH:mm";
const DATETIME_FORMAT_YMDHMS_COMPACT = "YYYYMMDDHHmmss";
const DATETIME_FORMAT_DMYHM = "DD/MM/YYYY HH:mm";
const DATETIME_FORMAT_DMYHM_COMMA = "DD/MM/YYYY, HH:mm";
const DATETIME_FORMAT_ISO_YMDHMS = "YYYY-MM-DDTHH:mm:ssZ";
const DATETIME_FORMAT_ISO_YMDHM = "YYYY-MM-DDTHH:mmZ";
const DATETIME_FORMAT_ISO_YMDHMS_SPACE = "YYYY-MM-DD HH:mm:ss Z";
const TIME_FORMAT_24H = "HH:mm";
const DATETIME_PART_TO_SHOW = {
  DATE_ONLY: "DATE_ONLY",
  TIME_ONLY: "TIME_ONLY",
  DATE_AND_TIME: "DATE_AND_TIME"
};
function getDisplayFormat(appLocale) {
  try {
    const data2 = moment.localeData(getMomentLocale(appLocale));
    return data2.longDateFormat("L") || DATE_FORMAT_DMY;
  } catch {
    return DATE_FORMAT_DMY;
  }
}
let currentLocale = null;
function initMomentLocale(appLocale) {
  const momentLocale = getMomentLocale(appLocale);
  if (momentLocale !== currentLocale) {
    moment.locale(momentLocale);
    currentLocale = momentLocale;
  }
  return momentLocale;
}
function getCalendarLocaleConfig(appLocale) {
  return {
    displayFormat: getDisplayFormat(appLocale) || DATE_FORMAT_DMY,
    firstDayOfWeek: getFirstDayOfWeek(appLocale)
  };
}
function parseDateWithTimeZone(dateInput, timeZone) {
  if (!dateInput) return null;
  if (dateInput instanceof Date) return dateInput;
  if (dateInput.includes("T")) return new Date(dateInput);
  const fakeTime = "T12:00:00";
  const date = new Date(dateInput + fakeTime);
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });
  const parts = formatter.formatToParts(date);
  const year = parts.find((p) => p.type === "year")?.value;
  const month = parts.find((p) => p.type === "month")?.value;
  const day = parts.find((p) => p.type === "day")?.value;
  return /* @__PURE__ */ new Date(`${year}-${month}-${day}T12:00:00`);
}
function toUtcIsoString(value, timeZone) {
  if (!value) return (/* @__PURE__ */ new Date()).toISOString();
  if (value instanceof Date) return moment.tz(moment(value).format("YYYY-MM-DD"), timeZone).toISOString();
  return moment.tz(value, moment.ISO_8601, timeZone).toISOString();
}
function getNowInTimeZone(timeZone) {
  return moment.tz(/* @__PURE__ */ new Date(), timeZone);
}
function formatInTimeZone(date, timeZone, format2) {
  return moment(date).tz(timeZone).format(format2);
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React__default, g = 60103;
  reactJsxRuntime_production_min.Fragment = 60107;
  if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    reactJsxRuntime_production_min.Fragment = h("react.fragment");
  }
  var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for (b in a) n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: g, type: c, key: e, ref: l, props: d, _owner: m.current };
  }
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  (function(exports2) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var React2 = React__default;
        var REACT_ELEMENT_TYPE = 60103;
        var REACT_PORTAL_TYPE = 60106;
        exports2.Fragment = 60107;
        var REACT_STRICT_MODE_TYPE = 60108;
        var REACT_PROFILER_TYPE = 60114;
        var REACT_PROVIDER_TYPE = 60109;
        var REACT_CONTEXT_TYPE = 60110;
        var REACT_FORWARD_REF_TYPE = 60112;
        var REACT_SUSPENSE_TYPE = 60113;
        var REACT_SUSPENSE_LIST_TYPE = 60120;
        var REACT_MEMO_TYPE = 60115;
        var REACT_LAZY_TYPE = 60116;
        var REACT_BLOCK_TYPE = 60121;
        var REACT_SERVER_BLOCK_TYPE = 60122;
        var REACT_FUNDAMENTAL_TYPE = 60117;
        var REACT_DEBUG_TRACING_MODE_TYPE = 60129;
        var REACT_LEGACY_HIDDEN_TYPE = 60131;
        if (typeof Symbol === "function" && Symbol.for) {
          var symbolFor2 = Symbol.for;
          REACT_ELEMENT_TYPE = symbolFor2("react.element");
          REACT_PORTAL_TYPE = symbolFor2("react.portal");
          exports2.Fragment = symbolFor2("react.fragment");
          REACT_STRICT_MODE_TYPE = symbolFor2("react.strict_mode");
          REACT_PROFILER_TYPE = symbolFor2("react.profiler");
          REACT_PROVIDER_TYPE = symbolFor2("react.provider");
          REACT_CONTEXT_TYPE = symbolFor2("react.context");
          REACT_FORWARD_REF_TYPE = symbolFor2("react.forward_ref");
          REACT_SUSPENSE_TYPE = symbolFor2("react.suspense");
          REACT_SUSPENSE_LIST_TYPE = symbolFor2("react.suspense_list");
          REACT_MEMO_TYPE = symbolFor2("react.memo");
          REACT_LAZY_TYPE = symbolFor2("react.lazy");
          REACT_BLOCK_TYPE = symbolFor2("react.block");
          REACT_SERVER_BLOCK_TYPE = symbolFor2("react.server.block");
          REACT_FUNDAMENTAL_TYPE = symbolFor2("react.fundamental");
          symbolFor2("react.scope");
          symbolFor2("react.opaque.id");
          REACT_DEBUG_TRACING_MODE_TYPE = symbolFor2("react.debug_trace_mode");
          symbolFor2("react.offscreen");
          REACT_LEGACY_HIDDEN_TYPE = symbolFor2("react.legacy_hidden");
        }
        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = "@@iterator";
        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable !== "object") {
            return null;
          }
          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
          if (typeof maybeIterator === "function") {
            return maybeIterator;
          }
          return null;
        }
        var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        function error(format2) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format2, args);
          }
        }
        function printWarning(level, format2, args) {
          {
            var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = "";
            if (currentlyValidatingElement) {
              var name = getComponentName(currentlyValidatingElement.type);
              var owner = currentlyValidatingElement._owner;
              stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner.type));
            }
            stack += ReactDebugCurrentFrame.getStackAddendum();
            if (stack !== "") {
              format2 += "%s";
              args = args.concat([stack]);
            }
            var argsWithFormat = args.map(function(item) {
              return "" + item;
            });
            argsWithFormat.unshift("Warning: " + format2);
            Function.prototype.apply.call(console[level], console, argsWithFormat);
          }
        }
        var enableScopeAPI = false;
        function isValidElementType(type) {
          if (typeof type === "string" || typeof type === "function") {
            return true;
          }
          if (type === exports2.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
            return true;
          }
          if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
              return true;
            }
          }
          return false;
        }
        var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
        function describeComponentFrame(name, source, ownerName) {
          var sourceInfo = "";
          if (source) {
            var path = source.fileName;
            var fileName = path.replace(BEFORE_SLASH_RE, "");
            {
              if (/^index\./.test(fileName)) {
                var match2 = path.match(BEFORE_SLASH_RE);
                if (match2) {
                  var pathBeforeSlash = match2[1];
                  if (pathBeforeSlash) {
                    var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, "");
                    fileName = folderName + "/" + fileName;
                  }
                }
              }
            }
            sourceInfo = " (at " + fileName + ":" + source.lineNumber + ")";
          } else if (ownerName) {
            sourceInfo = " (created by " + ownerName + ")";
          }
          return "\n    in " + (name || "Unknown") + sourceInfo;
        }
        var Resolved = 1;
        function refineResolvedLazyComponent(lazyComponent) {
          return lazyComponent._status === Resolved ? lazyComponent._result : null;
        }
        function getWrappedName(outerType, innerType, wrapperName) {
          var functionName2 = innerType.displayName || innerType.name || "";
          return outerType.displayName || (functionName2 !== "" ? wrapperName + "(" + functionName2 + ")" : wrapperName);
        }
        function getComponentName(type) {
          if (type == null) {
            return null;
          }
          {
            if (typeof type.tag === "number") {
              error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
            }
          }
          if (typeof type === "function") {
            return type.displayName || type.name || null;
          }
          if (typeof type === "string") {
            return type;
          }
          switch (type) {
            case exports2.Fragment:
              return "Fragment";
            case REACT_PORTAL_TYPE:
              return "Portal";
            case REACT_PROFILER_TYPE:
              return "Profiler";
            case REACT_STRICT_MODE_TYPE:
              return "StrictMode";
            case REACT_SUSPENSE_TYPE:
              return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
              return "SuspenseList";
          }
          if (typeof type === "object") {
            switch (type.$$typeof) {
              case REACT_CONTEXT_TYPE:
                return "Context.Consumer";
              case REACT_PROVIDER_TYPE:
                return "Context.Provider";
              case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
              case REACT_MEMO_TYPE:
                return getComponentName(type.type);
              case REACT_BLOCK_TYPE:
                return getComponentName(type.render);
              case REACT_LAZY_TYPE: {
                var thenable = type;
                var resolvedThenable = refineResolvedLazyComponent(thenable);
                if (resolvedThenable) {
                  return getComponentName(resolvedThenable);
                }
                break;
              }
            }
          }
          return null;
        }
        var loggedTypeFailures = {};
        ReactSharedInternals.ReactDebugCurrentFrame;
        var currentlyValidatingElement = null;
        function setCurrentlyValidatingElement(element) {
          {
            currentlyValidatingElement = element;
          }
        }
        function checkPropTypes(typeSpecs, values, location, componentName, element) {
          {
            var has2 = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var typeSpecName in typeSpecs) {
              if (has2(typeSpecs, typeSpecName)) {
                var error$1 = void 0;
                try {
                  if (typeof typeSpecs[typeSpecName] !== "function") {
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                  }
                  error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                } catch (ex) {
                  error$1 = ex;
                }
                if (error$1 && !(error$1 instanceof Error)) {
                  setCurrentlyValidatingElement(element);
                  error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                  setCurrentlyValidatingElement(null);
                }
                if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                  loggedTypeFailures[error$1.message] = true;
                  setCurrentlyValidatingElement(element);
                  error("Failed %s type: %s", location, error$1.message);
                  setCurrentlyValidatingElement(null);
                }
              }
            }
          }
        }
        var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
        var hasOwnProperty2 = Object.prototype.hasOwnProperty;
        var RESERVED_PROPS = {
          key: true,
          ref: true,
          __self: true,
          __source: true
        };
        var specialPropKeyWarningShown;
        var specialPropRefWarningShown;
        function hasValidRef(config) {
          {
            if (hasOwnProperty2.call(config, "ref")) {
              var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.ref !== void 0;
        }
        function hasValidKey(config) {
          {
            if (hasOwnProperty2.call(config, "key")) {
              var getter = Object.getOwnPropertyDescriptor(config, "key").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.key !== void 0;
        }
        function warnIfStringRefCannotBeAutoConverted(config, self2) {
          {
            if (typeof config.ref === "string" && ReactCurrentOwner.current && self2) ;
          }
        }
        function defineKeyPropWarningGetter(props, displayName) {
          {
            var warnAboutAccessingKey = function() {
              if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
              }
            };
            warnAboutAccessingKey.isReactWarning = true;
            Object.defineProperty(props, "key", {
              get: warnAboutAccessingKey,
              configurable: true
            });
          }
        }
        function defineRefPropWarningGetter(props, displayName) {
          {
            var warnAboutAccessingRef = function() {
              if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
              }
            };
            warnAboutAccessingRef.isReactWarning = true;
            Object.defineProperty(props, "ref", {
              get: warnAboutAccessingRef,
              configurable: true
            });
          }
        }
        var ReactElement = function(type, key, ref, self2, source, owner, props) {
          var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type,
            key,
            ref,
            props,
            // Record the component responsible for creating this element.
            _owner: owner
          };
          {
            element._store = {};
            Object.defineProperty(element._store, "validated", {
              configurable: false,
              enumerable: false,
              writable: true,
              value: false
            });
            Object.defineProperty(element, "_self", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: self2
            });
            Object.defineProperty(element, "_source", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: source
            });
            if (Object.freeze) {
              Object.freeze(element.props);
              Object.freeze(element);
            }
          }
          return element;
        };
        function jsxDEV(type, config, maybeKey, source, self2) {
          {
            var propName;
            var props = {};
            var key = null;
            var ref = null;
            if (maybeKey !== void 0) {
              key = "" + maybeKey;
            }
            if (hasValidKey(config)) {
              key = "" + config.key;
            }
            if (hasValidRef(config)) {
              ref = config.ref;
              warnIfStringRefCannotBeAutoConverted(config, self2);
            }
            for (propName in config) {
              if (hasOwnProperty2.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                props[propName] = config[propName];
              }
            }
            if (type && type.defaultProps) {
              var defaultProps2 = type.defaultProps;
              for (propName in defaultProps2) {
                if (props[propName] === void 0) {
                  props[propName] = defaultProps2[propName];
                }
              }
            }
            if (key || ref) {
              var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
              if (key) {
                defineKeyPropWarningGetter(props, displayName);
              }
              if (ref) {
                defineRefPropWarningGetter(props, displayName);
              }
            }
            return ReactElement(type, key, ref, self2, source, ReactCurrentOwner.current, props);
          }
        }
        var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
        ReactSharedInternals.ReactDebugCurrentFrame;
        function setCurrentlyValidatingElement$1(element) {
          currentlyValidatingElement = element;
        }
        var propTypesMisspellWarningShown;
        {
          propTypesMisspellWarningShown = false;
        }
        function isValidElement2(object2) {
          {
            return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
          }
        }
        function getDeclarationErrorAddendum() {
          {
            if (ReactCurrentOwner$1.current) {
              var name = getComponentName(ReactCurrentOwner$1.current.type);
              if (name) {
                return "\n\nCheck the render method of `" + name + "`.";
              }
            }
            return "";
          }
        }
        function getSourceInfoErrorAddendum(source) {
          {
            return "";
          }
        }
        var ownerHasKeyUseWarning = {};
        function getCurrentComponentErrorInfo(parentType) {
          {
            var info = getDeclarationErrorAddendum();
            if (!info) {
              var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
              if (parentName) {
                info = "\n\nCheck the top-level render call using <" + parentName + ">.";
              }
            }
            return info;
          }
        }
        function validateExplicitKey(element, parentType) {
          {
            if (!element._store || element._store.validated || element.key != null) {
              return;
            }
            element._store.validated = true;
            var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
            if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
              return;
            }
            ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
            var childOwner = "";
            if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
              childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
            }
            setCurrentlyValidatingElement$1(element);
            error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
            setCurrentlyValidatingElement$1(null);
          }
        }
        function validateChildKeys(node, parentType) {
          {
            if (typeof node !== "object") {
              return;
            }
            if (Array.isArray(node)) {
              for (var i = 0; i < node.length; i++) {
                var child = node[i];
                if (isValidElement2(child)) {
                  validateExplicitKey(child, parentType);
                }
              }
            } else if (isValidElement2(node)) {
              if (node._store) {
                node._store.validated = true;
              }
            } else if (node) {
              var iteratorFn = getIteratorFn(node);
              if (typeof iteratorFn === "function") {
                if (iteratorFn !== node.entries) {
                  var iterator = iteratorFn.call(node);
                  var step;
                  while (!(step = iterator.next()).done) {
                    if (isValidElement2(step.value)) {
                      validateExplicitKey(step.value, parentType);
                    }
                  }
                }
              }
            }
          }
        }
        function validatePropTypes(element) {
          {
            var type = element.type;
            if (type === null || type === void 0 || typeof type === "string") {
              return;
            }
            var propTypes2;
            if (typeof type === "function") {
              propTypes2 = type.propTypes;
            } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
            // Inner props are checked in the reconciler.
            type.$$typeof === REACT_MEMO_TYPE)) {
              propTypes2 = type.propTypes;
            } else {
              return;
            }
            if (propTypes2) {
              var name = getComponentName(type);
              checkPropTypes(propTypes2, element.props, "prop", name, element);
            } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
              propTypesMisspellWarningShown = true;
              var _name = getComponentName(type);
              error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
            }
            if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
              error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
            }
          }
        }
        function validateFragmentProps(fragment) {
          {
            var keys3 = Object.keys(fragment.props);
            for (var i = 0; i < keys3.length; i++) {
              var key = keys3[i];
              if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
              }
            }
            if (fragment.ref !== null) {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid attribute `ref` supplied to `React.Fragment`.");
              setCurrentlyValidatingElement$1(null);
            }
          }
        }
        function jsxWithValidation(type, props, key, isStaticChildren, source, self2) {
          {
            var validType = isValidElementType(type);
            if (!validType) {
              var info = "";
              if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
                info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
              }
              var sourceInfo = getSourceInfoErrorAddendum();
              if (sourceInfo) {
                info += sourceInfo;
              } else {
                info += getDeclarationErrorAddendum();
              }
              var typeString;
              if (type === null) {
                typeString = "null";
              } else if (Array.isArray(type)) {
                typeString = "array";
              } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentName(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
              } else {
                typeString = typeof type;
              }
              error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
            }
            var element = jsxDEV(type, props, key, source, self2);
            if (element == null) {
              return element;
            }
            if (validType) {
              var children = props.children;
              if (children !== void 0) {
                if (isStaticChildren) {
                  if (Array.isArray(children)) {
                    for (var i = 0; i < children.length; i++) {
                      validateChildKeys(children[i], type);
                    }
                    if (Object.freeze) {
                      Object.freeze(children);
                    }
                  } else {
                    error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                  }
                } else {
                  validateChildKeys(children, type);
                }
              }
            }
            if (type === exports2.Fragment) {
              validateFragmentProps(element);
            } else {
              validatePropTypes(element);
            }
            return element;
          }
        }
        function jsxWithValidationStatic(type, props, key) {
          {
            return jsxWithValidation(type, props, key, true);
          }
        }
        function jsxWithValidationDynamic(type, props, key) {
          {
            return jsxWithValidation(type, props, key, false);
          }
        }
        var jsx = jsxWithValidationDynamic;
        var jsxs = jsxWithValidationStatic;
        exports2.jsx = jsx;
        exports2.jsxs = jsxs;
      })();
    }
  })(reactJsxRuntime_development);
  return reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime.exports = requireReactJsxRuntime_production_min();
  } else {
    jsxRuntime.exports = requireReactJsxRuntime_development();
  }
  return jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
var simpleIsEqual = function simpleIsEqual2(a, b) {
  return a === b;
};
function index(resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = simpleIsEqual;
  }
  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;
  var isNewArgEqualToLast = function isNewArgEqualToLast2(newArg, index2) {
    return isEqual(newArg, lastArgs[index2], index2);
  };
  var result = function result2() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }
    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }
    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };
  return result;
}
var _isPrototype;
var hasRequired_isPrototype;
function require_isPrototype() {
  if (hasRequired_isPrototype) return _isPrototype;
  hasRequired_isPrototype = 1;
  var objectProto2 = Object.prototype;
  function isPrototype2(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value === proto;
  }
  _isPrototype = isPrototype2;
  return _isPrototype;
}
var _overArg;
var hasRequired_overArg;
function require_overArg() {
  if (hasRequired_overArg) return _overArg;
  hasRequired_overArg = 1;
  function overArg2(func2, transform) {
    return function(arg) {
      return func2(transform(arg));
    };
  }
  _overArg = overArg2;
  return _overArg;
}
var _nativeKeys;
var hasRequired_nativeKeys;
function require_nativeKeys() {
  if (hasRequired_nativeKeys) return _nativeKeys;
  hasRequired_nativeKeys = 1;
  var overArg2 = require_overArg();
  var nativeKeys2 = overArg2(Object.keys, Object);
  _nativeKeys = nativeKeys2;
  return _nativeKeys;
}
var _baseKeys;
var hasRequired_baseKeys;
function require_baseKeys() {
  if (hasRequired_baseKeys) return _baseKeys;
  hasRequired_baseKeys = 1;
  var isPrototype2 = require_isPrototype(), nativeKeys2 = require_nativeKeys();
  var objectProto2 = Object.prototype;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  function baseKeys2(object2) {
    if (!isPrototype2(object2)) {
      return nativeKeys2(object2);
    }
    var result = [];
    for (var key in Object(object2)) {
      if (hasOwnProperty2.call(object2, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  _baseKeys = baseKeys2;
  return _baseKeys;
}
var _freeGlobal;
var hasRequired_freeGlobal;
function require_freeGlobal() {
  if (hasRequired_freeGlobal) return _freeGlobal;
  hasRequired_freeGlobal = 1;
  var freeGlobal2 = typeof commonjsGlobal$1 == "object" && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;
  _freeGlobal = freeGlobal2;
  return _freeGlobal;
}
var _root;
var hasRequired_root;
function require_root() {
  if (hasRequired_root) return _root;
  hasRequired_root = 1;
  var freeGlobal2 = require_freeGlobal();
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  _root = root2;
  return _root;
}
var _Symbol;
var hasRequired_Symbol;
function require_Symbol() {
  if (hasRequired_Symbol) return _Symbol;
  hasRequired_Symbol = 1;
  var root2 = require_root();
  var Symbol2 = root2.Symbol;
  _Symbol = Symbol2;
  return _Symbol;
}
var _getRawTag;
var hasRequired_getRawTag;
function require_getRawTag() {
  if (hasRequired_getRawTag) return _getRawTag;
  hasRequired_getRawTag = 1;
  var Symbol2 = require_Symbol();
  var objectProto2 = Object.prototype;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var nativeObjectToString2 = objectProto2.toString;
  var symToStringTag2 = Symbol2 ? Symbol2.toStringTag : void 0;
  function getRawTag2(value) {
    var isOwn = hasOwnProperty2.call(value, symToStringTag2), tag = value[symToStringTag2];
    try {
      value[symToStringTag2] = void 0;
      var unmasked = true;
    } catch (e) {
    }
    var result = nativeObjectToString2.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag2] = tag;
      } else {
        delete value[symToStringTag2];
      }
    }
    return result;
  }
  _getRawTag = getRawTag2;
  return _getRawTag;
}
var _objectToString;
var hasRequired_objectToString;
function require_objectToString() {
  if (hasRequired_objectToString) return _objectToString;
  hasRequired_objectToString = 1;
  var objectProto2 = Object.prototype;
  var nativeObjectToString2 = objectProto2.toString;
  function objectToString2(value) {
    return nativeObjectToString2.call(value);
  }
  _objectToString = objectToString2;
  return _objectToString;
}
var _baseGetTag;
var hasRequired_baseGetTag;
function require_baseGetTag() {
  if (hasRequired_baseGetTag) return _baseGetTag;
  hasRequired_baseGetTag = 1;
  var Symbol2 = require_Symbol(), getRawTag2 = require_getRawTag(), objectToString2 = require_objectToString();
  var nullTag2 = "[object Null]", undefinedTag2 = "[object Undefined]";
  var symToStringTag2 = Symbol2 ? Symbol2.toStringTag : void 0;
  function baseGetTag2(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag2 : nullTag2;
    }
    return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag2(value) : objectToString2(value);
  }
  _baseGetTag = baseGetTag2;
  return _baseGetTag;
}
var isObject_1;
var hasRequiredIsObject;
function requireIsObject() {
  if (hasRequiredIsObject) return isObject_1;
  hasRequiredIsObject = 1;
  function isObject3(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
  }
  isObject_1 = isObject3;
  return isObject_1;
}
var isFunction_1;
var hasRequiredIsFunction;
function requireIsFunction() {
  if (hasRequiredIsFunction) return isFunction_1;
  hasRequiredIsFunction = 1;
  var baseGetTag2 = require_baseGetTag(), isObject3 = requireIsObject();
  var asyncTag2 = "[object AsyncFunction]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", proxyTag2 = "[object Proxy]";
  function isFunction3(value) {
    if (!isObject3(value)) {
      return false;
    }
    var tag = baseGetTag2(value);
    return tag == funcTag2 || tag == genTag2 || tag == asyncTag2 || tag == proxyTag2;
  }
  isFunction_1 = isFunction3;
  return isFunction_1;
}
var _coreJsData;
var hasRequired_coreJsData;
function require_coreJsData() {
  if (hasRequired_coreJsData) return _coreJsData;
  hasRequired_coreJsData = 1;
  var root2 = require_root();
  var coreJsData2 = root2["__core-js_shared__"];
  _coreJsData = coreJsData2;
  return _coreJsData;
}
var _isMasked;
var hasRequired_isMasked;
function require_isMasked() {
  if (hasRequired_isMasked) return _isMasked;
  hasRequired_isMasked = 1;
  var coreJsData2 = require_coreJsData();
  var maskSrcKey2 = (function() {
    var uid2 = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
    return uid2 ? "Symbol(src)_1." + uid2 : "";
  })();
  function isMasked2(func2) {
    return !!maskSrcKey2 && maskSrcKey2 in func2;
  }
  _isMasked = isMasked2;
  return _isMasked;
}
var _toSource;
var hasRequired_toSource;
function require_toSource() {
  if (hasRequired_toSource) return _toSource;
  hasRequired_toSource = 1;
  var funcProto2 = Function.prototype;
  var funcToString2 = funcProto2.toString;
  function toSource2(func2) {
    if (func2 != null) {
      try {
        return funcToString2.call(func2);
      } catch (e) {
      }
      try {
        return func2 + "";
      } catch (e) {
      }
    }
    return "";
  }
  _toSource = toSource2;
  return _toSource;
}
var _baseIsNative;
var hasRequired_baseIsNative;
function require_baseIsNative() {
  if (hasRequired_baseIsNative) return _baseIsNative;
  hasRequired_baseIsNative = 1;
  var isFunction3 = requireIsFunction(), isMasked2 = require_isMasked(), isObject3 = requireIsObject(), toSource2 = require_toSource();
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
  var funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var reIsNative2 = RegExp(
    "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function baseIsNative2(value) {
    if (!isObject3(value) || isMasked2(value)) {
      return false;
    }
    var pattern = isFunction3(value) ? reIsNative2 : reIsHostCtor2;
    return pattern.test(toSource2(value));
  }
  _baseIsNative = baseIsNative2;
  return _baseIsNative;
}
var _getValue;
var hasRequired_getValue;
function require_getValue() {
  if (hasRequired_getValue) return _getValue;
  hasRequired_getValue = 1;
  function getValue3(object2, key) {
    return object2 == null ? void 0 : object2[key];
  }
  _getValue = getValue3;
  return _getValue;
}
var _getNative;
var hasRequired_getNative;
function require_getNative() {
  if (hasRequired_getNative) return _getNative;
  hasRequired_getNative = 1;
  var baseIsNative2 = require_baseIsNative(), getValue3 = require_getValue();
  function getNative2(object2, key) {
    var value = getValue3(object2, key);
    return baseIsNative2(value) ? value : void 0;
  }
  _getNative = getNative2;
  return _getNative;
}
var _DataView;
var hasRequired_DataView;
function require_DataView() {
  if (hasRequired_DataView) return _DataView;
  hasRequired_DataView = 1;
  var getNative2 = require_getNative(), root2 = require_root();
  var DataView2 = getNative2(root2, "DataView");
  _DataView = DataView2;
  return _DataView;
}
var _Map;
var hasRequired_Map;
function require_Map() {
  if (hasRequired_Map) return _Map;
  hasRequired_Map = 1;
  var getNative2 = require_getNative(), root2 = require_root();
  var Map2 = getNative2(root2, "Map");
  _Map = Map2;
  return _Map;
}
var _Promise;
var hasRequired_Promise;
function require_Promise() {
  if (hasRequired_Promise) return _Promise;
  hasRequired_Promise = 1;
  var getNative2 = require_getNative(), root2 = require_root();
  var Promise2 = getNative2(root2, "Promise");
  _Promise = Promise2;
  return _Promise;
}
var _Set;
var hasRequired_Set;
function require_Set() {
  if (hasRequired_Set) return _Set;
  hasRequired_Set = 1;
  var getNative2 = require_getNative(), root2 = require_root();
  var Set2 = getNative2(root2, "Set");
  _Set = Set2;
  return _Set;
}
var _WeakMap;
var hasRequired_WeakMap;
function require_WeakMap() {
  if (hasRequired_WeakMap) return _WeakMap;
  hasRequired_WeakMap = 1;
  var getNative2 = require_getNative(), root2 = require_root();
  var WeakMap2 = getNative2(root2, "WeakMap");
  _WeakMap = WeakMap2;
  return _WeakMap;
}
var _getTag;
var hasRequired_getTag;
function require_getTag() {
  if (hasRequired_getTag) return _getTag;
  hasRequired_getTag = 1;
  var DataView2 = require_DataView(), Map2 = require_Map(), Promise2 = require_Promise(), Set2 = require_Set(), WeakMap2 = require_WeakMap(), baseGetTag2 = require_baseGetTag(), toSource2 = require_toSource();
  var mapTag2 = "[object Map]", objectTag2 = "[object Object]", promiseTag2 = "[object Promise]", setTag2 = "[object Set]", weakMapTag2 = "[object WeakMap]";
  var dataViewTag2 = "[object DataView]";
  var dataViewCtorString2 = toSource2(DataView2), mapCtorString2 = toSource2(Map2), promiseCtorString2 = toSource2(Promise2), setCtorString2 = toSource2(Set2), weakMapCtorString2 = toSource2(WeakMap2);
  var getTag2 = baseGetTag2;
  if (DataView2 && getTag2(new DataView2(new ArrayBuffer(1))) != dataViewTag2 || Map2 && getTag2(new Map2()) != mapTag2 || Promise2 && getTag2(Promise2.resolve()) != promiseTag2 || Set2 && getTag2(new Set2()) != setTag2 || WeakMap2 && getTag2(new WeakMap2()) != weakMapTag2) {
    getTag2 = function(value) {
      var result = baseGetTag2(value), Ctor = result == objectTag2 ? value.constructor : void 0, ctorString = Ctor ? toSource2(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString2:
            return dataViewTag2;
          case mapCtorString2:
            return mapTag2;
          case promiseCtorString2:
            return promiseTag2;
          case setCtorString2:
            return setTag2;
          case weakMapCtorString2:
            return weakMapTag2;
        }
      }
      return result;
    };
  }
  _getTag = getTag2;
  return _getTag;
}
var isObjectLike_1;
var hasRequiredIsObjectLike;
function requireIsObjectLike() {
  if (hasRequiredIsObjectLike) return isObjectLike_1;
  hasRequiredIsObjectLike = 1;
  function isObjectLike2(value) {
    return value != null && typeof value == "object";
  }
  isObjectLike_1 = isObjectLike2;
  return isObjectLike_1;
}
var _baseIsArguments;
var hasRequired_baseIsArguments;
function require_baseIsArguments() {
  if (hasRequired_baseIsArguments) return _baseIsArguments;
  hasRequired_baseIsArguments = 1;
  var baseGetTag2 = require_baseGetTag(), isObjectLike2 = requireIsObjectLike();
  var argsTag2 = "[object Arguments]";
  function baseIsArguments2(value) {
    return isObjectLike2(value) && baseGetTag2(value) == argsTag2;
  }
  _baseIsArguments = baseIsArguments2;
  return _baseIsArguments;
}
var isArguments_1;
var hasRequiredIsArguments;
function requireIsArguments() {
  if (hasRequiredIsArguments) return isArguments_1;
  hasRequiredIsArguments = 1;
  var baseIsArguments2 = require_baseIsArguments(), isObjectLike2 = requireIsObjectLike();
  var objectProto2 = Object.prototype;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var propertyIsEnumerable3 = objectProto2.propertyIsEnumerable;
  var isArguments2 = baseIsArguments2(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? baseIsArguments2 : function(value) {
    return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable3.call(value, "callee");
  };
  isArguments_1 = isArguments2;
  return isArguments_1;
}
var isArray_1;
var hasRequiredIsArray;
function requireIsArray() {
  if (hasRequiredIsArray) return isArray_1;
  hasRequiredIsArray = 1;
  var isArray3 = Array.isArray;
  isArray_1 = isArray3;
  return isArray_1;
}
var isLength_1;
var hasRequiredIsLength;
function requireIsLength() {
  if (hasRequiredIsLength) return isLength_1;
  hasRequiredIsLength = 1;
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  function isLength2(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  isLength_1 = isLength2;
  return isLength_1;
}
var isArrayLike_1;
var hasRequiredIsArrayLike;
function requireIsArrayLike() {
  if (hasRequiredIsArrayLike) return isArrayLike_1;
  hasRequiredIsArrayLike = 1;
  var isFunction3 = requireIsFunction(), isLength2 = requireIsLength();
  function isArrayLike2(value) {
    return value != null && isLength2(value.length) && !isFunction3(value);
  }
  isArrayLike_1 = isArrayLike2;
  return isArrayLike_1;
}
var isBuffer$1 = { exports: {} };
var stubFalse_1;
var hasRequiredStubFalse;
function requireStubFalse() {
  if (hasRequiredStubFalse) return stubFalse_1;
  hasRequiredStubFalse = 1;
  function stubFalse2() {
    return false;
  }
  stubFalse_1 = stubFalse2;
  return stubFalse_1;
}
isBuffer$1.exports;
var hasRequiredIsBuffer$1;
function requireIsBuffer$1() {
  if (hasRequiredIsBuffer$1) return isBuffer$1.exports;
  hasRequiredIsBuffer$1 = 1;
  (function(module2, exports2) {
    var root2 = require_root(), stubFalse2 = requireStubFalse();
    var freeExports2 = exports2 && !exports2.nodeType && exports2;
    var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
    var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
    var Buffer2 = moduleExports2 ? root2.Buffer : void 0;
    var nativeIsBuffer2 = Buffer2 ? Buffer2.isBuffer : void 0;
    var isBuffer2 = nativeIsBuffer2 || stubFalse2;
    module2.exports = isBuffer2;
  })(isBuffer$1, isBuffer$1.exports);
  return isBuffer$1.exports;
}
var _baseIsTypedArray;
var hasRequired_baseIsTypedArray;
function require_baseIsTypedArray() {
  if (hasRequired_baseIsTypedArray) return _baseIsTypedArray;
  hasRequired_baseIsTypedArray = 1;
  var baseGetTag2 = require_baseGetTag(), isLength2 = requireIsLength(), isObjectLike2 = requireIsObjectLike();
  var argsTag2 = "[object Arguments]", arrayTag2 = "[object Array]", boolTag2 = "[object Boolean]", dateTag2 = "[object Date]", errorTag2 = "[object Error]", funcTag2 = "[object Function]", mapTag2 = "[object Map]", numberTag2 = "[object Number]", objectTag2 = "[object Object]", regexpTag2 = "[object RegExp]", setTag2 = "[object Set]", stringTag2 = "[object String]", weakMapTag2 = "[object WeakMap]";
  var arrayBufferTag2 = "[object ArrayBuffer]", dataViewTag2 = "[object DataView]", float32Tag2 = "[object Float32Array]", float64Tag2 = "[object Float64Array]", int8Tag2 = "[object Int8Array]", int16Tag2 = "[object Int16Array]", int32Tag2 = "[object Int32Array]", uint8Tag2 = "[object Uint8Array]", uint8ClampedTag2 = "[object Uint8ClampedArray]", uint16Tag2 = "[object Uint16Array]", uint32Tag2 = "[object Uint32Array]";
  var typedArrayTags2 = {};
  typedArrayTags2[float32Tag2] = typedArrayTags2[float64Tag2] = typedArrayTags2[int8Tag2] = typedArrayTags2[int16Tag2] = typedArrayTags2[int32Tag2] = typedArrayTags2[uint8Tag2] = typedArrayTags2[uint8ClampedTag2] = typedArrayTags2[uint16Tag2] = typedArrayTags2[uint32Tag2] = true;
  typedArrayTags2[argsTag2] = typedArrayTags2[arrayTag2] = typedArrayTags2[arrayBufferTag2] = typedArrayTags2[boolTag2] = typedArrayTags2[dataViewTag2] = typedArrayTags2[dateTag2] = typedArrayTags2[errorTag2] = typedArrayTags2[funcTag2] = typedArrayTags2[mapTag2] = typedArrayTags2[numberTag2] = typedArrayTags2[objectTag2] = typedArrayTags2[regexpTag2] = typedArrayTags2[setTag2] = typedArrayTags2[stringTag2] = typedArrayTags2[weakMapTag2] = false;
  function baseIsTypedArray2(value) {
    return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags2[baseGetTag2(value)];
  }
  _baseIsTypedArray = baseIsTypedArray2;
  return _baseIsTypedArray;
}
var _baseUnary;
var hasRequired_baseUnary;
function require_baseUnary() {
  if (hasRequired_baseUnary) return _baseUnary;
  hasRequired_baseUnary = 1;
  function baseUnary2(func2) {
    return function(value) {
      return func2(value);
    };
  }
  _baseUnary = baseUnary2;
  return _baseUnary;
}
var _nodeUtil = { exports: {} };
_nodeUtil.exports;
var hasRequired_nodeUtil;
function require_nodeUtil() {
  if (hasRequired_nodeUtil) return _nodeUtil.exports;
  hasRequired_nodeUtil = 1;
  (function(module2, exports2) {
    var freeGlobal2 = require_freeGlobal();
    var freeExports2 = exports2 && !exports2.nodeType && exports2;
    var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
    var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
    var freeProcess2 = moduleExports2 && freeGlobal2.process;
    var nodeUtil2 = (function() {
      try {
        var types = freeModule2 && freeModule2.require && freeModule2.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess2 && freeProcess2.binding && freeProcess2.binding("util");
      } catch (e) {
      }
    })();
    module2.exports = nodeUtil2;
  })(_nodeUtil, _nodeUtil.exports);
  return _nodeUtil.exports;
}
var isTypedArray_1;
var hasRequiredIsTypedArray;
function requireIsTypedArray() {
  if (hasRequiredIsTypedArray) return isTypedArray_1;
  hasRequiredIsTypedArray = 1;
  var baseIsTypedArray2 = require_baseIsTypedArray(), baseUnary2 = require_baseUnary(), nodeUtil2 = require_nodeUtil();
  var nodeIsTypedArray2 = nodeUtil2 && nodeUtil2.isTypedArray;
  var isTypedArray2 = nodeIsTypedArray2 ? baseUnary2(nodeIsTypedArray2) : baseIsTypedArray2;
  isTypedArray_1 = isTypedArray2;
  return isTypedArray_1;
}
var isEmpty_1;
var hasRequiredIsEmpty;
function requireIsEmpty() {
  if (hasRequiredIsEmpty) return isEmpty_1;
  hasRequiredIsEmpty = 1;
  var baseKeys2 = require_baseKeys(), getTag2 = require_getTag(), isArguments2 = requireIsArguments(), isArray3 = requireIsArray(), isArrayLike2 = requireIsArrayLike(), isBuffer2 = requireIsBuffer$1(), isPrototype2 = require_isPrototype(), isTypedArray2 = requireIsTypedArray();
  var mapTag2 = "[object Map]", setTag2 = "[object Set]";
  var objectProto2 = Object.prototype;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  function isEmpty2(value) {
    if (value == null) {
      return true;
    }
    if (isArrayLike2(value) && (isArray3(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer2(value) || isTypedArray2(value) || isArguments2(value))) {
      return !value.length;
    }
    var tag = getTag2(value);
    if (tag == mapTag2 || tag == setTag2) {
      return !value.size;
    }
    if (isPrototype2(value)) {
      return !baseKeys2(value).length;
    }
    for (var key in value) {
      if (hasOwnProperty2.call(value, key)) {
        return false;
      }
    }
    return true;
  }
  isEmpty_1 = isEmpty2;
  return isEmpty_1;
}
var isEmptyExports = requireIsEmpty();
const isEmpty = /* @__PURE__ */ getDefaultExportFromCjs(isEmptyExports);
function _setPrototypeOf$1(t, e) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf$1(t, e);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf$1(t, o);
}
var propTypes = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? /* @__PURE__ */ Symbol.for("react.element") : 60103, d = b ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, e = b ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, f = b ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, g = b ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, h = b ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, k = b ? /* @__PURE__ */ Symbol.for("react.context") : 60110, l = b ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, m = b ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, n = b ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, p = b ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, q = b ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, r = b ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, t = b ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, v = b ? /* @__PURE__ */ Symbol.for("react.block") : 60121, w = b ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, x = b ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, y = b ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function(a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object2.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object2) {
        return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object2) {
        return typeOf(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object2) {
        return typeOf(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf(object2) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject2(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
        return test2[n];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject2(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty2.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has$1;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has$1;
  hasRequiredHas = 1;
  has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
  return has$1;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = /* @__PURE__ */ requireHas();
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  var has2 = /* @__PURE__ */ requireHas();
  var checkPropTypes = /* @__PURE__ */ requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is2(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message, data2) {
      this.message = message;
      this.data = data2 && typeof data2 === "object" ? data2 : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey2 = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey2] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey2] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is2(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol2(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol2(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  hasRequiredPropTypes = 1;
  if (process.env.NODE_ENV !== "production") {
    var ReactIs = requireReactIs();
    var throwOnDirectAccess = true;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
  } else {
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  }
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var subscriptionShape = PropTypes.shape({
  trySubscribe: PropTypes.func.isRequired,
  tryUnsubscribe: PropTypes.func.isRequired,
  notifyNestedSubs: PropTypes.func.isRequired,
  isSubscribed: PropTypes.func.isRequired
});
var storeShape = PropTypes.shape({
  subscribe: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  getState: PropTypes.func.isRequired
});
function warning$1(message) {
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(message);
  }
  try {
    throw new Error(message);
  } catch (e) {
  }
}
var prefixUnsafeLifecycleMethods$1 = typeof React__default.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;
  warning$1("<Provider> does not support changing `store` on the fly. It is most likely that you see this error because you updated to Redux 2.x and React Redux 2.x which no longer hot reload reducers automatically. See https://github.com/reduxjs/react-redux/releases/tag/v2.0.0 for the migration instructions.");
}
function createProvider(storeKey) {
  var _Provider$childContex;
  if (storeKey === void 0) {
    storeKey = "store";
  }
  var subscriptionKey = storeKey + "Subscription";
  var Provider2 = /* @__PURE__ */ (function(_Component) {
    _inheritsLoose(Provider3, _Component);
    var _proto = Provider3.prototype;
    _proto.getChildContext = function getChildContext() {
      var _ref;
      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };
    function Provider3(props, context) {
      var _this;
      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }
    _proto.render = function render() {
      return Children.only(this.props.children);
    };
    return Provider3;
  })(Component);
  if (process.env.NODE_ENV !== "production") {
    var eventName = prefixUnsafeLifecycleMethods$1 ? "UNSAFE_componentWillReceiveProps" : "componentWillReceiveProps";
    Provider2.prototype[eventName] = function(nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }
  Provider2.propTypes = {
    store: storeShape.isRequired,
    children: PropTypes.element.isRequired
  };
  Provider2.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = storeShape.isRequired, _Provider$childContex[subscriptionKey] = subscriptionShape, _Provider$childContex);
  return Provider2;
}
const Provider = createProvider();
function _assertThisInitialized$1(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _extends$d() {
  return _extends$d = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$d.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var hoistNonReactStatics_cjs$1;
var hasRequiredHoistNonReactStatics_cjs$1;
function requireHoistNonReactStatics_cjs$1() {
  if (hasRequiredHoistNonReactStatics_cjs$1) return hoistNonReactStatics_cjs$1;
  hasRequiredHoistNonReactStatics_cjs$1 = 1;
  var reactIs2 = requireReactIs();
  var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  };
  var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  };
  var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs2.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs2.Memo] = MEMO_STATICS;
  function getStatics(component) {
    if (reactIs2.isMemo(component)) {
      return MEMO_STATICS;
    }
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
  }
  var defineProperty4 = Object.defineProperty;
  var getOwnPropertyNames2 = Object.getOwnPropertyNames;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var getOwnPropertyDescriptor3 = Object.getOwnPropertyDescriptor;
  var getPrototypeOf = Object.getPrototypeOf;
  var objectPrototype = Object.prototype;
  function hoistNonReactStatics2(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
      if (objectPrototype) {
        var inheritedComponent = getPrototypeOf(sourceComponent);
        if (inheritedComponent && inheritedComponent !== objectPrototype) {
          hoistNonReactStatics2(targetComponent, inheritedComponent, blacklist);
        }
      }
      var keys3 = getOwnPropertyNames2(sourceComponent);
      if (getOwnPropertySymbols) {
        keys3 = keys3.concat(getOwnPropertySymbols(sourceComponent));
      }
      var targetStatics = getStatics(targetComponent);
      var sourceStatics = getStatics(sourceComponent);
      for (var i = 0; i < keys3.length; ++i) {
        var key = keys3[i];
        if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
          var descriptor = getOwnPropertyDescriptor3(sourceComponent, key);
          try {
            defineProperty4(targetComponent, key, descriptor);
          } catch (e) {
          }
        }
      }
    }
    return targetComponent;
  }
  hoistNonReactStatics_cjs$1 = hoistNonReactStatics2;
  return hoistNonReactStatics_cjs$1;
}
var hoistNonReactStatics_cjsExports$1 = requireHoistNonReactStatics_cjs$1();
const hoistNonReactStatics = /* @__PURE__ */ getDefaultExportFromCjs(hoistNonReactStatics_cjsExports$1);
var browser;
var hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  var invariant2 = function(condition, format2, a, b, c, d, e, f) {
    if (process.env.NODE_ENV !== "production") {
      if (format2 === void 0) {
        throw new Error("invariant requires an error message argument");
      }
    }
    if (!condition) {
      var error;
      if (format2 === void 0) {
        error = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        error = new Error(
          format2.replace(/%s/g, function() {
            return args[argIndex++];
          })
        );
        error.name = "Invariant Violation";
      }
      error.framesToPop = 1;
      throw error;
    }
  };
  browser = invariant2;
  return browser;
}
var browserExports = requireBrowser();
const invariant = /* @__PURE__ */ getDefaultExportFromCjs(browserExports);
var reactIsExports = requireReactIs();
var CLEARED = null;
var nullListeners = {
  notify: function notify() {
  }
};
function createListenerCollection() {
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify2() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get3() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}
var Subscription = /* @__PURE__ */ (function() {
  function Subscription2(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }
  var _proto = Subscription2.prototype;
  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };
  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };
  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };
  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };
  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };
  return Subscription2;
})();
var prefixUnsafeLifecycleMethods = typeof React__default.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};
function noop$1() {
}
function makeSelectorStateful(sourceSelector, store) {
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}
function connectAdvanced(selectorFactory, _ref) {
  var _contextTypes, _childContextTypes;
  if (_ref === void 0) {
    _ref = {};
  }
  var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName3 = _ref2$getDisplayName === void 0 ? function(name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? void 0 : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, connectOptions = _objectWithoutPropertiesLoose(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);
  var subscriptionKey = storeKey + "Subscription";
  var version2 = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = storeShape, _contextTypes[subscriptionKey] = subscriptionShape, _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = subscriptionShape, _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    invariant(reactIsExports.isValidElementType(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
    var displayName = getDisplayName3(wrappedComponentName);
    var selectorFactoryOptions = _extends$d({}, connectOptions, {
      getDisplayName: getDisplayName3,
      methodName,
      renderCountProp,
      shouldHandleStateChanges,
      storeKey,
      withRef,
      displayName,
      wrappedComponentName,
      WrappedComponent
      // TODO Actually fix our use of componentWillReceiveProps
      /* eslint-disable react/no-deprecated */
    });
    var Connect = /* @__PURE__ */ (function(_Component) {
      _inheritsLoose(Connect2, _Component);
      function Connect2(props, context) {
        var _this;
        _this = _Component.call(this, props, context) || this;
        _this.version = version2;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_assertThisInitialized$1(_assertThisInitialized$1(_this)));
        invariant(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
        _this.initSelector();
        _this.initSubscription();
        return _this;
      }
      var _proto = Connect2.prototype;
      _proto.getChildContext = function getChildContext() {
        var _ref3;
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };
      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };
      _proto.componentWillReceiveProps = function componentWillReceiveProps2(nextProps) {
        this.selector.run(nextProps);
      };
      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop$1;
        this.store = null;
        this.selector.run = noop$1;
        this.selector.shouldComponentUpdate = false;
      };
      _proto.getWrappedInstance = function getWrappedInstance() {
        invariant(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };
      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };
      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };
      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new Subscription(this.store, parentSub, this.onStateChange.bind(this));
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };
      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);
        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };
      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        this.componentDidUpdate = void 0;
        this.notifyNestedSubs();
      };
      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };
      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        var withExtras = _extends$d({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };
      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;
        if (selector.error) {
          throw selector.error;
        } else {
          return createElement$2(WrappedComponent, this.addExtraProps(selector.props));
        }
      };
      return Connect2;
    })(Component);
    if (prefixUnsafeLifecycleMethods) {
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;
    if (process.env.NODE_ENV !== "production") {
      var eventName = prefixUnsafeLifecycleMethods ? "UNSAFE_componentWillUpdate" : "componentWillUpdate";
      Connect.prototype[eventName] = function componentWillUpdate2() {
        var _this2 = this;
        if (this.version !== version2) {
          this.version = version2;
          this.initSelector();
          var oldListeners = [];
          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function(listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }
    return hoistNonReactStatics(Connect, WrappedComponent);
  };
}
var hasOwn$7 = Object.prototype.hasOwnProperty;
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn$7.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$1 = freeGlobal || freeSelf || Function("return this")();
var Symbol$2 = root$1.Symbol;
var objectProto$e = Object.prototype;
var hasOwnProperty$c = objectProto$e.hasOwnProperty;
var nativeObjectToString$1 = objectProto$e.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$c.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$d = Object.prototype;
var nativeObjectToString = objectProto$d.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
function overArg(func2, transform) {
  return function(arg) {
    return func2(transform(arg));
  };
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var objectTag$3 = "[object Object]";
var funcProto$2 = Function.prototype, objectProto$c = Object.prototype;
var funcToString$2 = funcProto$2.toString;
var hasOwnProperty$b = objectProto$c.hasOwnProperty;
var objectCtorString = funcToString$2.call(Object);
function isPlainObject$1(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$b.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}
function symbolObservablePonyfill(root2) {
  var result;
  var Symbol2 = root2.Symbol;
  if (typeof Symbol2 === "function") {
    if (Symbol2.observable) {
      result = Symbol2.observable;
    } else {
      result = Symbol2("observable");
      Symbol2.observable = result;
    }
  } else {
    result = "@@observable";
  }
  return result;
}
var root;
if (typeof self !== "undefined") {
  root = self;
} else if (typeof window !== "undefined") {
  root = window;
} else if (typeof global !== "undefined") {
  root = global;
} else if (typeof module !== "undefined") {
  root = module;
} else {
  root = Function("return this")();
}
symbolObservablePonyfill(root);
function warning(message) {
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(message);
  }
  try {
    throw new Error(message);
  } catch (e) {
  }
}
function bindActionCreator(actionCreator, dispatch) {
  return function() {
    return dispatch(actionCreator.apply(void 0, arguments));
  };
}
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === "function") {
    return bindActionCreator(actionCreators, dispatch);
  }
  if (typeof actionCreators !== "object" || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? "null" : typeof actionCreators) + '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }
  var keys3 = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys3.length; i++) {
    var key = keys3[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === "function") {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}
function isCrushed() {
}
if (process.env.NODE_ENV !== "production" && typeof isCrushed.name === "string" && isCrushed.name !== "isCrushed") {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. This means that you are running a slower development build of Redux. You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) to ensure you have the correct code for your production build.");
}
function isPlainObject(obj) {
  if (typeof obj !== "object" || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;
  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }
  return proto === baseProto;
}
function verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject(value)) {
    warning$1(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}
function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant2 = getConstant(dispatch, options);
    function constantSelector() {
      return constant2;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== void 0 ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;
    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };
    proxy.dependsOnOwnProps = true;
    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);
      if (typeof props === "function") {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }
      if (process.env.NODE_ENV !== "production") verifyPlainObject(props, displayName, methodName);
      return props;
    };
    return proxy;
  };
}
function whenMapDispatchToPropsIsFunction(mapDispatchToProps2) {
  return typeof mapDispatchToProps2 === "function" ? wrapMapToPropsFunc(mapDispatchToProps2, "mapDispatchToProps") : void 0;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps2) {
  return !mapDispatchToProps2 ? wrapMapToPropsConstant(function(dispatch) {
    return {
      dispatch
    };
  }) : void 0;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps2) {
  return mapDispatchToProps2 && typeof mapDispatchToProps2 === "object" ? wrapMapToPropsConstant(function(dispatch) {
    return bindActionCreators(mapDispatchToProps2, dispatch);
  }) : void 0;
}
const defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
function whenMapStateToPropsIsFunction(mapStateToProps2) {
  return typeof mapStateToProps2 === "function" ? wrapMapToPropsFunc(mapStateToProps2, "mapStateToProps") : void 0;
}
function whenMapStateToPropsIsMissing(mapStateToProps2) {
  return !mapStateToProps2 ? wrapMapToPropsConstant(function() {
    return {};
  }) : void 0;
}
const defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends$d({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (process.env.NODE_ENV !== "production") verifyPlainObject(mergedProps, displayName, "mergeProps");
      }
      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === "function" ? wrapMergePropsFunc(mergeProps) : void 0;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function() {
    return defaultMergeProps;
  } : void 0;
}
const defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
    if (!selector.hasOwnProperty("dependsOnOwnProps")) {
      warning$1("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}
function verifySubselectors(mapStateToProps2, mapDispatchToProps2, mergeProps, displayName) {
  verify(mapStateToProps2, "mapStateToProps", displayName);
  verify(mapDispatchToProps2, "mapDispatchToProps", displayName);
  verify(mergeProps, "mergeProps", displayName);
}
function impureFinalPropsSelectorFactory(mapStateToProps2, mapDispatchToProps2, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps2(state, ownProps), mapDispatchToProps2(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps2, mapDispatchToProps2, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;
  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps2(state, ownProps);
    dispatchProps = mapDispatchToProps2(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }
  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps2(state, ownProps);
    if (mapDispatchToProps2.dependsOnOwnProps) dispatchProps = mapDispatchToProps2(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleNewProps() {
    if (mapStateToProps2.dependsOnOwnProps) stateProps = mapStateToProps2(state, ownProps);
    if (mapDispatchToProps2.dependsOnOwnProps) dispatchProps = mapDispatchToProps2(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleNewState() {
    var nextStateProps = mapStateToProps2(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }
  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}
function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = _objectWithoutPropertiesLoose(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
  var mapStateToProps2 = initMapStateToProps(dispatch, options);
  var mapDispatchToProps2 = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);
  if (process.env.NODE_ENV !== "production") {
    verifySubselectors(mapStateToProps2, mapDispatchToProps2, mergeProps, options.displayName);
  }
  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps2, mapDispatchToProps2, mergeProps, dispatch, options);
}
function match$1(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }
  return function(dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}
function strictEqual(a, b) {
  return a === b;
}
function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;
  return function connect2(mapStateToProps2, mapDispatchToProps2, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }
    var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE, extraOptions = _objectWithoutPropertiesLoose(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
    var initMapStateToProps = match$1(mapStateToProps2, mapStateToPropsFactories, "mapStateToProps");
    var initMapDispatchToProps = match$1(mapDispatchToProps2, mapDispatchToPropsFactories, "mapDispatchToProps");
    var initMergeProps = match$1(mergeProps, mergePropsFactories, "mergeProps");
    return connectHOC(selectorFactory, _extends$d({
      // used in error messages
      methodName: "connect",
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName3(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps2),
      // passed through to selectorFactory
      initMapStateToProps,
      initMapDispatchToProps,
      initMergeProps,
      pure,
      areStatesEqual,
      areOwnPropsEqual,
      areStatePropsEqual,
      areMergedPropsEqual
    }, extraOptions));
  };
}
const connect = createConnect();
var getTimezoneOffsetInMilliseconds;
var hasRequiredGetTimezoneOffsetInMilliseconds;
function requireGetTimezoneOffsetInMilliseconds() {
  if (hasRequiredGetTimezoneOffsetInMilliseconds) return getTimezoneOffsetInMilliseconds;
  hasRequiredGetTimezoneOffsetInMilliseconds = 1;
  var MILLISECONDS_IN_MINUTE2 = 6e4;
  getTimezoneOffsetInMilliseconds = function getTimezoneOffsetInMilliseconds2(dirtyDate) {
    var date = new Date(dirtyDate.getTime());
    var baseTimezoneOffset = date.getTimezoneOffset();
    date.setSeconds(0, 0);
    var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE2;
    return baseTimezoneOffset * MILLISECONDS_IN_MINUTE2 + millisecondsPartOfTimezoneOffset;
  };
  return getTimezoneOffsetInMilliseconds;
}
var is_date;
var hasRequiredIs_date;
function requireIs_date() {
  if (hasRequiredIs_date) return is_date;
  hasRequiredIs_date = 1;
  function isDate(argument) {
    return argument instanceof Date;
  }
  is_date = isDate;
  return is_date;
}
var parse_1;
var hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse_1;
  hasRequiredParse = 1;
  var getTimezoneOffsetInMilliseconds2 = requireGetTimezoneOffsetInMilliseconds();
  var isDate = requireIs_date();
  var MILLISECONDS_IN_HOUR = 36e5;
  var MILLISECONDS_IN_MINUTE2 = 6e4;
  var DEFAULT_ADDITIONAL_DIGITS = 2;
  var parseTokenDateTimeDelimeter = /[T ]/;
  var parseTokenPlainTime = /:/;
  var parseTokenYY = /^(\d{2})$/;
  var parseTokensYYY = [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ];
  var parseTokenYYYY = /^(\d{4})/;
  var parseTokensYYYYY = [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ];
  var parseTokenMM = /^-(\d{2})$/;
  var parseTokenDDD = /^-?(\d{3})$/;
  var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/;
  var parseTokenWww = /^-?W(\d{2})$/;
  var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/;
  var parseTokenHH = /^(\d{2}([.,]\d*)?)$/;
  var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/;
  var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/;
  var parseTokenTimezone = /([Z+-].*)$/;
  var parseTokenTimezoneZ = /^(Z)$/;
  var parseTokenTimezoneHH = /^([+-])(\d{2})$/;
  var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/;
  function parse2(argument, dirtyOptions) {
    if (isDate(argument)) {
      return new Date(argument.getTime());
    } else if (typeof argument !== "string") {
      return new Date(argument);
    }
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits;
    if (additionalDigits == null) {
      additionalDigits = DEFAULT_ADDITIONAL_DIGITS;
    } else {
      additionalDigits = Number(additionalDigits);
    }
    var dateStrings = splitDateString(argument);
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = parseDate2(restDateString, year);
    if (date) {
      var timestamp = date.getTime();
      var time = 0;
      var offset;
      if (dateStrings.time) {
        time = parseTime(dateStrings.time);
      }
      if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE2;
      } else {
        var fullTime = timestamp + time;
        var fullTimeDate = new Date(fullTime);
        offset = getTimezoneOffsetInMilliseconds2(fullTimeDate);
        var fullTimeDateNextDay = new Date(fullTime);
        fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1);
        var offsetDiff = getTimezoneOffsetInMilliseconds2(fullTimeDateNextDay) - getTimezoneOffsetInMilliseconds2(fullTimeDate);
        if (offsetDiff > 0) {
          offset += offsetDiff;
        }
      }
      return new Date(timestamp + time + offset);
    } else {
      return new Date(argument);
    }
  }
  function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(parseTokenDateTimeDelimeter);
    var timeString;
    if (parseTokenPlainTime.test(array[0])) {
      dateStrings.date = null;
      timeString = array[0];
    } else {
      dateStrings.date = array[0];
      timeString = array[1];
    }
    if (timeString) {
      var token2 = parseTokenTimezone.exec(timeString);
      if (token2) {
        dateStrings.time = timeString.replace(token2[1], "");
        dateStrings.timezone = token2[1];
      } else {
        dateStrings.time = timeString;
      }
    }
    return dateStrings;
  }
  function parseYear(dateString, additionalDigits) {
    var parseTokenYYY = parseTokensYYY[additionalDigits];
    var parseTokenYYYYY = parseTokensYYYYY[additionalDigits];
    var token2;
    token2 = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString);
    if (token2) {
      var yearString = token2[1];
      return {
        year: parseInt(yearString, 10),
        restDateString: dateString.slice(yearString.length)
      };
    }
    token2 = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString);
    if (token2) {
      var centuryString = token2[1];
      return {
        year: parseInt(centuryString, 10) * 100,
        restDateString: dateString.slice(centuryString.length)
      };
    }
    return {
      year: null
    };
  }
  function parseDate2(dateString, year) {
    if (year === null) {
      return null;
    }
    var token2;
    var date;
    var month;
    var week;
    if (dateString.length === 0) {
      date = /* @__PURE__ */ new Date(0);
      date.setUTCFullYear(year);
      return date;
    }
    token2 = parseTokenMM.exec(dateString);
    if (token2) {
      date = /* @__PURE__ */ new Date(0);
      month = parseInt(token2[1], 10) - 1;
      date.setUTCFullYear(year, month);
      return date;
    }
    token2 = parseTokenDDD.exec(dateString);
    if (token2) {
      date = /* @__PURE__ */ new Date(0);
      var dayOfYear = parseInt(token2[1], 10);
      date.setUTCFullYear(year, 0, dayOfYear);
      return date;
    }
    token2 = parseTokenMMDD.exec(dateString);
    if (token2) {
      date = /* @__PURE__ */ new Date(0);
      month = parseInt(token2[1], 10) - 1;
      var day = parseInt(token2[2], 10);
      date.setUTCFullYear(year, month, day);
      return date;
    }
    token2 = parseTokenWww.exec(dateString);
    if (token2) {
      week = parseInt(token2[1], 10) - 1;
      return dayOfISOYear(year, week);
    }
    token2 = parseTokenWwwD.exec(dateString);
    if (token2) {
      week = parseInt(token2[1], 10) - 1;
      var dayOfWeek = parseInt(token2[2], 10) - 1;
      return dayOfISOYear(year, week, dayOfWeek);
    }
    return null;
  }
  function parseTime(timeString) {
    var token2;
    var hours;
    var minutes;
    token2 = parseTokenHH.exec(timeString);
    if (token2) {
      hours = parseFloat(token2[1].replace(",", "."));
      return hours % 24 * MILLISECONDS_IN_HOUR;
    }
    token2 = parseTokenHHMM.exec(timeString);
    if (token2) {
      hours = parseInt(token2[1], 10);
      minutes = parseFloat(token2[2].replace(",", "."));
      return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE2;
    }
    token2 = parseTokenHHMMSS.exec(timeString);
    if (token2) {
      hours = parseInt(token2[1], 10);
      minutes = parseInt(token2[2], 10);
      var seconds = parseFloat(token2[3].replace(",", "."));
      return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE2 + seconds * 1e3;
    }
    return null;
  }
  function parseTimezone(timezoneString) {
    var token2;
    var absoluteOffset;
    token2 = parseTokenTimezoneZ.exec(timezoneString);
    if (token2) {
      return 0;
    }
    token2 = parseTokenTimezoneHH.exec(timezoneString);
    if (token2) {
      absoluteOffset = parseInt(token2[2], 10) * 60;
      return token2[1] === "+" ? -absoluteOffset : absoluteOffset;
    }
    token2 = parseTokenTimezoneHHMM.exec(timezoneString);
    if (token2) {
      absoluteOffset = parseInt(token2[2], 10) * 60 + parseInt(token2[3], 10);
      return token2[1] === "+" ? -absoluteOffset : absoluteOffset;
    }
    return 0;
  }
  function dayOfISOYear(isoYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = /* @__PURE__ */ new Date(0);
    date.setUTCFullYear(isoYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff2 = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff2);
    return date;
  }
  parse_1 = parse2;
  return parse_1;
}
var add_days;
var hasRequiredAdd_days;
function requireAdd_days() {
  if (hasRequiredAdd_days) return add_days;
  hasRequiredAdd_days = 1;
  var parse2 = requireParse();
  function addDays2(dirtyDate, dirtyAmount) {
    var date = parse2(dirtyDate);
    var amount = Number(dirtyAmount);
    date.setDate(date.getDate() + amount);
    return date;
  }
  add_days = addDays2;
  return add_days;
}
var add_milliseconds;
var hasRequiredAdd_milliseconds;
function requireAdd_milliseconds() {
  if (hasRequiredAdd_milliseconds) return add_milliseconds;
  hasRequiredAdd_milliseconds = 1;
  var parse2 = requireParse();
  function addMilliseconds(dirtyDate, dirtyAmount) {
    var timestamp = parse2(dirtyDate).getTime();
    var amount = Number(dirtyAmount);
    return new Date(timestamp + amount);
  }
  add_milliseconds = addMilliseconds;
  return add_milliseconds;
}
var add_hours;
var hasRequiredAdd_hours;
function requireAdd_hours() {
  if (hasRequiredAdd_hours) return add_hours;
  hasRequiredAdd_hours = 1;
  var addMilliseconds = requireAdd_milliseconds();
  var MILLISECONDS_IN_HOUR = 36e5;
  function addHours(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
  }
  add_hours = addHours;
  return add_hours;
}
var start_of_week;
var hasRequiredStart_of_week;
function requireStart_of_week() {
  if (hasRequiredStart_of_week) return start_of_week;
  hasRequiredStart_of_week = 1;
  var parse2 = requireParse();
  function startOfWeek(dirtyDate, dirtyOptions) {
    var weekStartsOn = dirtyOptions ? Number(dirtyOptions.weekStartsOn) || 0 : 0;
    var date = parse2(dirtyDate);
    var day = date.getDay();
    var diff2 = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff2);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  start_of_week = startOfWeek;
  return start_of_week;
}
var start_of_iso_week;
var hasRequiredStart_of_iso_week;
function requireStart_of_iso_week() {
  if (hasRequiredStart_of_iso_week) return start_of_iso_week;
  hasRequiredStart_of_iso_week = 1;
  var startOfWeek = requireStart_of_week();
  function startOfISOWeek(dirtyDate) {
    return startOfWeek(dirtyDate, { weekStartsOn: 1 });
  }
  start_of_iso_week = startOfISOWeek;
  return start_of_iso_week;
}
var get_iso_year;
var hasRequiredGet_iso_year;
function requireGet_iso_year() {
  if (hasRequiredGet_iso_year) return get_iso_year;
  hasRequiredGet_iso_year = 1;
  var parse2 = requireParse();
  var startOfISOWeek = requireStart_of_iso_week();
  function getISOYear(dirtyDate) {
    var date = parse2(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) {
      return year + 1;
    } else if (date.getTime() >= startOfThisYear.getTime()) {
      return year;
    } else {
      return year - 1;
    }
  }
  get_iso_year = getISOYear;
  return get_iso_year;
}
var start_of_iso_year;
var hasRequiredStart_of_iso_year;
function requireStart_of_iso_year() {
  if (hasRequiredStart_of_iso_year) return start_of_iso_year;
  hasRequiredStart_of_iso_year = 1;
  var getISOYear = requireGet_iso_year();
  var startOfISOWeek = requireStart_of_iso_week();
  function startOfISOYear(dirtyDate) {
    var year = getISOYear(dirtyDate);
    var fourthOfJanuary = /* @__PURE__ */ new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = startOfISOWeek(fourthOfJanuary);
    return date;
  }
  start_of_iso_year = startOfISOYear;
  return start_of_iso_year;
}
var start_of_day;
var hasRequiredStart_of_day;
function requireStart_of_day() {
  if (hasRequiredStart_of_day) return start_of_day;
  hasRequiredStart_of_day = 1;
  var parse2 = requireParse();
  function startOfDay2(dirtyDate) {
    var date = parse2(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  start_of_day = startOfDay2;
  return start_of_day;
}
var difference_in_calendar_days;
var hasRequiredDifference_in_calendar_days;
function requireDifference_in_calendar_days() {
  if (hasRequiredDifference_in_calendar_days) return difference_in_calendar_days;
  hasRequiredDifference_in_calendar_days = 1;
  var startOfDay2 = requireStart_of_day();
  var MILLISECONDS_IN_MINUTE2 = 6e4;
  var MILLISECONDS_IN_DAY2 = 864e5;
  function differenceInCalendarDays2(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = startOfDay2(dirtyDateLeft);
    var startOfDayRight = startOfDay2(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE2;
    var timestampRight = startOfDayRight.getTime() - startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE2;
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY2);
  }
  difference_in_calendar_days = differenceInCalendarDays2;
  return difference_in_calendar_days;
}
var set_iso_year;
var hasRequiredSet_iso_year;
function requireSet_iso_year() {
  if (hasRequiredSet_iso_year) return set_iso_year;
  hasRequiredSet_iso_year = 1;
  var parse2 = requireParse();
  var startOfISOYear = requireStart_of_iso_year();
  var differenceInCalendarDays2 = requireDifference_in_calendar_days();
  function setISOYear(dirtyDate, dirtyISOYear) {
    var date = parse2(dirtyDate);
    var isoYear = Number(dirtyISOYear);
    var diff2 = differenceInCalendarDays2(date, startOfISOYear(date));
    var fourthOfJanuary = /* @__PURE__ */ new Date(0);
    fourthOfJanuary.setFullYear(isoYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    date = startOfISOYear(fourthOfJanuary);
    date.setDate(date.getDate() + diff2);
    return date;
  }
  set_iso_year = setISOYear;
  return set_iso_year;
}
var add_iso_years;
var hasRequiredAdd_iso_years;
function requireAdd_iso_years() {
  if (hasRequiredAdd_iso_years) return add_iso_years;
  hasRequiredAdd_iso_years = 1;
  var getISOYear = requireGet_iso_year();
  var setISOYear = requireSet_iso_year();
  function addISOYears(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount);
  }
  add_iso_years = addISOYears;
  return add_iso_years;
}
var add_minutes;
var hasRequiredAdd_minutes;
function requireAdd_minutes() {
  if (hasRequiredAdd_minutes) return add_minutes;
  hasRequiredAdd_minutes = 1;
  var addMilliseconds = requireAdd_milliseconds();
  var MILLISECONDS_IN_MINUTE2 = 6e4;
  function addMinutes2(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE2);
  }
  add_minutes = addMinutes2;
  return add_minutes;
}
var get_days_in_month;
var hasRequiredGet_days_in_month;
function requireGet_days_in_month() {
  if (hasRequiredGet_days_in_month) return get_days_in_month;
  hasRequiredGet_days_in_month = 1;
  var parse2 = requireParse();
  function getDaysInMonth(dirtyDate) {
    var date = parse2(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = /* @__PURE__ */ new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
  }
  get_days_in_month = getDaysInMonth;
  return get_days_in_month;
}
var add_months;
var hasRequiredAdd_months;
function requireAdd_months() {
  if (hasRequiredAdd_months) return add_months;
  hasRequiredAdd_months = 1;
  var parse2 = requireParse();
  var getDaysInMonth = requireGet_days_in_month();
  function addMonths2(dirtyDate, dirtyAmount) {
    var date = parse2(dirtyDate);
    var amount = Number(dirtyAmount);
    var desiredMonth = date.getMonth() + amount;
    var dateWithDesiredMonth = /* @__PURE__ */ new Date(0);
    dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
    date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
    return date;
  }
  add_months = addMonths2;
  return add_months;
}
var add_quarters;
var hasRequiredAdd_quarters;
function requireAdd_quarters() {
  if (hasRequiredAdd_quarters) return add_quarters;
  hasRequiredAdd_quarters = 1;
  var addMonths2 = requireAdd_months();
  function addQuarters(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    var months = amount * 3;
    return addMonths2(dirtyDate, months);
  }
  add_quarters = addQuarters;
  return add_quarters;
}
var add_seconds;
var hasRequiredAdd_seconds;
function requireAdd_seconds() {
  if (hasRequiredAdd_seconds) return add_seconds;
  hasRequiredAdd_seconds = 1;
  var addMilliseconds = requireAdd_milliseconds();
  function addSeconds(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addMilliseconds(dirtyDate, amount * 1e3);
  }
  add_seconds = addSeconds;
  return add_seconds;
}
var add_weeks;
var hasRequiredAdd_weeks;
function requireAdd_weeks() {
  if (hasRequiredAdd_weeks) return add_weeks;
  hasRequiredAdd_weeks = 1;
  var addDays2 = requireAdd_days();
  function addWeeks2(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    var days = amount * 7;
    return addDays2(dirtyDate, days);
  }
  add_weeks = addWeeks2;
  return add_weeks;
}
var add_years;
var hasRequiredAdd_years;
function requireAdd_years() {
  if (hasRequiredAdd_years) return add_years;
  hasRequiredAdd_years = 1;
  var addMonths2 = requireAdd_months();
  function addYears(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addMonths2(dirtyDate, amount * 12);
  }
  add_years = addYears;
  return add_years;
}
var are_ranges_overlapping;
var hasRequiredAre_ranges_overlapping;
function requireAre_ranges_overlapping() {
  if (hasRequiredAre_ranges_overlapping) return are_ranges_overlapping;
  hasRequiredAre_ranges_overlapping = 1;
  var parse2 = requireParse();
  function areRangesOverlapping(dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
    var initialStartTime = parse2(dirtyInitialRangeStartDate).getTime();
    var initialEndTime = parse2(dirtyInitialRangeEndDate).getTime();
    var comparedStartTime = parse2(dirtyComparedRangeStartDate).getTime();
    var comparedEndTime = parse2(dirtyComparedRangeEndDate).getTime();
    if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
      throw new Error("The start of the range cannot be after the end of the range");
    }
    return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime;
  }
  are_ranges_overlapping = areRangesOverlapping;
  return are_ranges_overlapping;
}
var closest_index_to;
var hasRequiredClosest_index_to;
function requireClosest_index_to() {
  if (hasRequiredClosest_index_to) return closest_index_to;
  hasRequiredClosest_index_to = 1;
  var parse2 = requireParse();
  function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
    if (!(dirtyDatesArray instanceof Array)) {
      throw new TypeError(toString.call(dirtyDatesArray) + " is not an instance of Array");
    }
    var dateToCompare = parse2(dirtyDateToCompare);
    var timeToCompare = dateToCompare.getTime();
    var result;
    var minDistance;
    dirtyDatesArray.forEach(function(dirtyDate, index2) {
      var currentDate = parse2(dirtyDate);
      var distance = Math.abs(timeToCompare - currentDate.getTime());
      if (result === void 0 || distance < minDistance) {
        result = index2;
        minDistance = distance;
      }
    });
    return result;
  }
  closest_index_to = closestIndexTo;
  return closest_index_to;
}
var closest_to;
var hasRequiredClosest_to;
function requireClosest_to() {
  if (hasRequiredClosest_to) return closest_to;
  hasRequiredClosest_to = 1;
  var parse2 = requireParse();
  function closestTo(dirtyDateToCompare, dirtyDatesArray) {
    if (!(dirtyDatesArray instanceof Array)) {
      throw new TypeError(toString.call(dirtyDatesArray) + " is not an instance of Array");
    }
    var dateToCompare = parse2(dirtyDateToCompare);
    var timeToCompare = dateToCompare.getTime();
    var result;
    var minDistance;
    dirtyDatesArray.forEach(function(dirtyDate) {
      var currentDate = parse2(dirtyDate);
      var distance = Math.abs(timeToCompare - currentDate.getTime());
      if (result === void 0 || distance < minDistance) {
        result = currentDate;
        minDistance = distance;
      }
    });
    return result;
  }
  closest_to = closestTo;
  return closest_to;
}
var compare_asc;
var hasRequiredCompare_asc;
function requireCompare_asc() {
  if (hasRequiredCompare_asc) return compare_asc;
  hasRequiredCompare_asc = 1;
  var parse2 = requireParse();
  function compareAsc2(dirtyDateLeft, dirtyDateRight) {
    var dateLeft = parse2(dirtyDateLeft);
    var timeLeft = dateLeft.getTime();
    var dateRight = parse2(dirtyDateRight);
    var timeRight = dateRight.getTime();
    if (timeLeft < timeRight) {
      return -1;
    } else if (timeLeft > timeRight) {
      return 1;
    } else {
      return 0;
    }
  }
  compare_asc = compareAsc2;
  return compare_asc;
}
var compare_desc;
var hasRequiredCompare_desc;
function requireCompare_desc() {
  if (hasRequiredCompare_desc) return compare_desc;
  hasRequiredCompare_desc = 1;
  var parse2 = requireParse();
  function compareDesc(dirtyDateLeft, dirtyDateRight) {
    var dateLeft = parse2(dirtyDateLeft);
    var timeLeft = dateLeft.getTime();
    var dateRight = parse2(dirtyDateRight);
    var timeRight = dateRight.getTime();
    if (timeLeft > timeRight) {
      return -1;
    } else if (timeLeft < timeRight) {
      return 1;
    } else {
      return 0;
    }
  }
  compare_desc = compareDesc;
  return compare_desc;
}
var difference_in_calendar_iso_weeks;
var hasRequiredDifference_in_calendar_iso_weeks;
function requireDifference_in_calendar_iso_weeks() {
  if (hasRequiredDifference_in_calendar_iso_weeks) return difference_in_calendar_iso_weeks;
  hasRequiredDifference_in_calendar_iso_weeks = 1;
  var startOfISOWeek = requireStart_of_iso_week();
  var MILLISECONDS_IN_MINUTE2 = 6e4;
  var MILLISECONDS_IN_WEEK = 6048e5;
  function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
    var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft);
    var startOfISOWeekRight = startOfISOWeek(dirtyDateRight);
    var timestampLeft = startOfISOWeekLeft.getTime() - startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE2;
    var timestampRight = startOfISOWeekRight.getTime() - startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE2;
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
  }
  difference_in_calendar_iso_weeks = differenceInCalendarISOWeeks;
  return difference_in_calendar_iso_weeks;
}
var difference_in_calendar_iso_years;
var hasRequiredDifference_in_calendar_iso_years;
function requireDifference_in_calendar_iso_years() {
  if (hasRequiredDifference_in_calendar_iso_years) return difference_in_calendar_iso_years;
  hasRequiredDifference_in_calendar_iso_years = 1;
  var getISOYear = requireGet_iso_year();
  function differenceInCalendarISOYears(dirtyDateLeft, dirtyDateRight) {
    return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight);
  }
  difference_in_calendar_iso_years = differenceInCalendarISOYears;
  return difference_in_calendar_iso_years;
}
var difference_in_calendar_months;
var hasRequiredDifference_in_calendar_months;
function requireDifference_in_calendar_months() {
  if (hasRequiredDifference_in_calendar_months) return difference_in_calendar_months;
  hasRequiredDifference_in_calendar_months = 1;
  var parse2 = requireParse();
  function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
    var dateLeft = parse2(dirtyDateLeft);
    var dateRight = parse2(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
  }
  difference_in_calendar_months = differenceInCalendarMonths;
  return difference_in_calendar_months;
}
var get_quarter;
var hasRequiredGet_quarter;
function requireGet_quarter() {
  if (hasRequiredGet_quarter) return get_quarter;
  hasRequiredGet_quarter = 1;
  var parse2 = requireParse();
  function getQuarter(dirtyDate) {
    var date = parse2(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
  }
  get_quarter = getQuarter;
  return get_quarter;
}
var difference_in_calendar_quarters;
var hasRequiredDifference_in_calendar_quarters;
function requireDifference_in_calendar_quarters() {
  if (hasRequiredDifference_in_calendar_quarters) return difference_in_calendar_quarters;
  hasRequiredDifference_in_calendar_quarters = 1;
  var getQuarter = requireGet_quarter();
  var parse2 = requireParse();
  function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
    var dateLeft = parse2(dirtyDateLeft);
    var dateRight = parse2(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight);
    return yearDiff * 4 + quarterDiff;
  }
  difference_in_calendar_quarters = differenceInCalendarQuarters;
  return difference_in_calendar_quarters;
}
var difference_in_calendar_weeks;
var hasRequiredDifference_in_calendar_weeks;
function requireDifference_in_calendar_weeks() {
  if (hasRequiredDifference_in_calendar_weeks) return difference_in_calendar_weeks;
  hasRequiredDifference_in_calendar_weeks = 1;
  var startOfWeek = requireStart_of_week();
  var MILLISECONDS_IN_MINUTE2 = 6e4;
  var MILLISECONDS_IN_WEEK = 6048e5;
  function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
    var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions);
    var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions);
    var timestampLeft = startOfWeekLeft.getTime() - startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE2;
    var timestampRight = startOfWeekRight.getTime() - startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE2;
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
  }
  difference_in_calendar_weeks = differenceInCalendarWeeks;
  return difference_in_calendar_weeks;
}
var difference_in_calendar_years;
var hasRequiredDifference_in_calendar_years;
function requireDifference_in_calendar_years() {
  if (hasRequiredDifference_in_calendar_years) return difference_in_calendar_years;
  hasRequiredDifference_in_calendar_years = 1;
  var parse2 = requireParse();
  function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
    var dateLeft = parse2(dirtyDateLeft);
    var dateRight = parse2(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
  }
  difference_in_calendar_years = differenceInCalendarYears;
  return difference_in_calendar_years;
}
var difference_in_days;
var hasRequiredDifference_in_days;
function requireDifference_in_days() {
  if (hasRequiredDifference_in_days) return difference_in_days;
  hasRequiredDifference_in_days = 1;
  var parse2 = requireParse();
  var differenceInCalendarDays2 = requireDifference_in_calendar_days();
  var compareAsc2 = requireCompare_asc();
  function differenceInDays2(dirtyDateLeft, dirtyDateRight) {
    var dateLeft = parse2(dirtyDateLeft);
    var dateRight = parse2(dirtyDateRight);
    var sign = compareAsc2(dateLeft, dateRight);
    var difference = Math.abs(differenceInCalendarDays2(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    var isLastDayNotFull = compareAsc2(dateLeft, dateRight) === -sign;
    return sign * (difference - isLastDayNotFull);
  }
  difference_in_days = differenceInDays2;
  return difference_in_days;
}
var difference_in_milliseconds;
var hasRequiredDifference_in_milliseconds;
function requireDifference_in_milliseconds() {
  if (hasRequiredDifference_in_milliseconds) return difference_in_milliseconds;
  hasRequiredDifference_in_milliseconds = 1;
  var parse2 = requireParse();
  function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
    var dateLeft = parse2(dirtyDateLeft);
    var dateRight = parse2(dirtyDateRight);
    return dateLeft.getTime() - dateRight.getTime();
  }
  difference_in_milliseconds = differenceInMilliseconds;
  return difference_in_milliseconds;
}
var difference_in_hours;
var hasRequiredDifference_in_hours;
function requireDifference_in_hours() {
  if (hasRequiredDifference_in_hours) return difference_in_hours;
  hasRequiredDifference_in_hours = 1;
  var differenceInMilliseconds = requireDifference_in_milliseconds();
  var MILLISECONDS_IN_HOUR = 36e5;
  function differenceInHours(dirtyDateLeft, dirtyDateRight) {
    var diff2 = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR;
    return diff2 > 0 ? Math.floor(diff2) : Math.ceil(diff2);
  }
  difference_in_hours = differenceInHours;
  return difference_in_hours;
}
var sub_iso_years;
var hasRequiredSub_iso_years;
function requireSub_iso_years() {
  if (hasRequiredSub_iso_years) return sub_iso_years;
  hasRequiredSub_iso_years = 1;
  var addISOYears = requireAdd_iso_years();
  function subISOYears(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addISOYears(dirtyDate, -amount);
  }
  sub_iso_years = subISOYears;
  return sub_iso_years;
}
var difference_in_iso_years;
var hasRequiredDifference_in_iso_years;
function requireDifference_in_iso_years() {
  if (hasRequiredDifference_in_iso_years) return difference_in_iso_years;
  hasRequiredDifference_in_iso_years = 1;
  var parse2 = requireParse();
  var differenceInCalendarISOYears = requireDifference_in_calendar_iso_years();
  var compareAsc2 = requireCompare_asc();
  var subISOYears = requireSub_iso_years();
  function differenceInISOYears(dirtyDateLeft, dirtyDateRight) {
    var dateLeft = parse2(dirtyDateLeft);
    var dateRight = parse2(dirtyDateRight);
    var sign = compareAsc2(dateLeft, dateRight);
    var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight));
    dateLeft = subISOYears(dateLeft, sign * difference);
    var isLastISOYearNotFull = compareAsc2(dateLeft, dateRight) === -sign;
    return sign * (difference - isLastISOYearNotFull);
  }
  difference_in_iso_years = differenceInISOYears;
  return difference_in_iso_years;
}
var difference_in_minutes;
var hasRequiredDifference_in_minutes;
function requireDifference_in_minutes() {
  if (hasRequiredDifference_in_minutes) return difference_in_minutes;
  hasRequiredDifference_in_minutes = 1;
  var differenceInMilliseconds = requireDifference_in_milliseconds();
  var MILLISECONDS_IN_MINUTE2 = 6e4;
  function differenceInMinutes(dirtyDateLeft, dirtyDateRight) {
    var diff2 = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE2;
    return diff2 > 0 ? Math.floor(diff2) : Math.ceil(diff2);
  }
  difference_in_minutes = differenceInMinutes;
  return difference_in_minutes;
}
var difference_in_months;
var hasRequiredDifference_in_months;
function requireDifference_in_months() {
  if (hasRequiredDifference_in_months) return difference_in_months;
  hasRequiredDifference_in_months = 1;
  var parse2 = requireParse();
  var differenceInCalendarMonths = requireDifference_in_calendar_months();
  var compareAsc2 = requireCompare_asc();
  function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
    var dateLeft = parse2(dirtyDateLeft);
    var dateRight = parse2(dirtyDateRight);
    var sign = compareAsc2(dateLeft, dateRight);
    var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
    dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
    var isLastMonthNotFull = compareAsc2(dateLeft, dateRight) === -sign;
    return sign * (difference - isLastMonthNotFull);
  }
  difference_in_months = differenceInMonths;
  return difference_in_months;
}
var difference_in_quarters;
var hasRequiredDifference_in_quarters;
function requireDifference_in_quarters() {
  if (hasRequiredDifference_in_quarters) return difference_in_quarters;
  hasRequiredDifference_in_quarters = 1;
  var differenceInMonths = requireDifference_in_months();
  function differenceInQuarters(dirtyDateLeft, dirtyDateRight) {
    var diff2 = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3;
    return diff2 > 0 ? Math.floor(diff2) : Math.ceil(diff2);
  }
  difference_in_quarters = differenceInQuarters;
  return difference_in_quarters;
}
var difference_in_seconds;
var hasRequiredDifference_in_seconds;
function requireDifference_in_seconds() {
  if (hasRequiredDifference_in_seconds) return difference_in_seconds;
  hasRequiredDifference_in_seconds = 1;
  var differenceInMilliseconds = requireDifference_in_milliseconds();
  function differenceInSeconds(dirtyDateLeft, dirtyDateRight) {
    var diff2 = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1e3;
    return diff2 > 0 ? Math.floor(diff2) : Math.ceil(diff2);
  }
  difference_in_seconds = differenceInSeconds;
  return difference_in_seconds;
}
var difference_in_weeks;
var hasRequiredDifference_in_weeks;
function requireDifference_in_weeks() {
  if (hasRequiredDifference_in_weeks) return difference_in_weeks;
  hasRequiredDifference_in_weeks = 1;
  var differenceInDays2 = requireDifference_in_days();
  function differenceInWeeks(dirtyDateLeft, dirtyDateRight) {
    var diff2 = differenceInDays2(dirtyDateLeft, dirtyDateRight) / 7;
    return diff2 > 0 ? Math.floor(diff2) : Math.ceil(diff2);
  }
  difference_in_weeks = differenceInWeeks;
  return difference_in_weeks;
}
var difference_in_years;
var hasRequiredDifference_in_years;
function requireDifference_in_years() {
  if (hasRequiredDifference_in_years) return difference_in_years;
  hasRequiredDifference_in_years = 1;
  var parse2 = requireParse();
  var differenceInCalendarYears = requireDifference_in_calendar_years();
  var compareAsc2 = requireCompare_asc();
  function differenceInYears(dirtyDateLeft, dirtyDateRight) {
    var dateLeft = parse2(dirtyDateLeft);
    var dateRight = parse2(dirtyDateRight);
    var sign = compareAsc2(dateLeft, dateRight);
    var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight));
    dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference);
    var isLastYearNotFull = compareAsc2(dateLeft, dateRight) === -sign;
    return sign * (difference - isLastYearNotFull);
  }
  difference_in_years = differenceInYears;
  return difference_in_years;
}
var build_distance_in_words_locale;
var hasRequiredBuild_distance_in_words_locale;
function requireBuild_distance_in_words_locale() {
  if (hasRequiredBuild_distance_in_words_locale) return build_distance_in_words_locale;
  hasRequiredBuild_distance_in_words_locale = 1;
  function buildDistanceInWordsLocale() {
    var distanceInWordsLocale = {
      lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
      },
      xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
      },
      halfAMinute: "half a minute",
      lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
      },
      xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
      },
      aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
      },
      xHours: {
        one: "1 hour",
        other: "{{count}} hours"
      },
      xDays: {
        one: "1 day",
        other: "{{count}} days"
      },
      aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
      },
      xMonths: {
        one: "1 month",
        other: "{{count}} months"
      },
      aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
      },
      xYears: {
        one: "1 year",
        other: "{{count}} years"
      },
      overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
      },
      almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
      }
    };
    function localize(token2, count, options) {
      options = options || {};
      var result;
      if (typeof distanceInWordsLocale[token2] === "string") {
        result = distanceInWordsLocale[token2];
      } else if (count === 1) {
        result = distanceInWordsLocale[token2].one;
      } else {
        result = distanceInWordsLocale[token2].other.replace("{{count}}", count);
      }
      if (options.addSuffix) {
        if (options.comparison > 0) {
          return "in " + result;
        } else {
          return result + " ago";
        }
      }
      return result;
    }
    return {
      localize
    };
  }
  build_distance_in_words_locale = buildDistanceInWordsLocale;
  return build_distance_in_words_locale;
}
var build_formatting_tokens_reg_exp;
var hasRequiredBuild_formatting_tokens_reg_exp;
function requireBuild_formatting_tokens_reg_exp() {
  if (hasRequiredBuild_formatting_tokens_reg_exp) return build_formatting_tokens_reg_exp;
  hasRequiredBuild_formatting_tokens_reg_exp = 1;
  var commonFormatterKeys = [
    "M",
    "MM",
    "Q",
    "D",
    "DD",
    "DDD",
    "DDDD",
    "d",
    "E",
    "W",
    "WW",
    "YY",
    "YYYY",
    "GG",
    "GGGG",
    "H",
    "HH",
    "h",
    "hh",
    "m",
    "mm",
    "s",
    "ss",
    "S",
    "SS",
    "SSS",
    "Z",
    "ZZ",
    "X",
    "x"
  ];
  function buildFormattingTokensRegExp(formatters) {
    var formatterKeys = [];
    for (var key in formatters) {
      if (formatters.hasOwnProperty(key)) {
        formatterKeys.push(key);
      }
    }
    var formattingTokens = commonFormatterKeys.concat(formatterKeys).sort().reverse();
    var formattingTokensRegExp = new RegExp(
      "(\\[[^\\[]*\\])|(\\\\)?(" + formattingTokens.join("|") + "|.)",
      "g"
    );
    return formattingTokensRegExp;
  }
  build_formatting_tokens_reg_exp = buildFormattingTokensRegExp;
  return build_formatting_tokens_reg_exp;
}
var build_format_locale;
var hasRequiredBuild_format_locale;
function requireBuild_format_locale() {
  if (hasRequiredBuild_format_locale) return build_format_locale;
  hasRequiredBuild_format_locale = 1;
  var buildFormattingTokensRegExp = requireBuild_formatting_tokens_reg_exp();
  function buildFormatLocale() {
    var months3char = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var monthsFull = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var weekdays2char = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    var weekdays3char = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    var weekdaysFull = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var meridiemUppercase = ["AM", "PM"];
    var meridiemLowercase = ["am", "pm"];
    var meridiemFull = ["a.m.", "p.m."];
    var formatters = {
      // Month: Jan, Feb, ..., Dec
      "MMM": function(date) {
        return months3char[date.getMonth()];
      },
      // Month: January, February, ..., December
      "MMMM": function(date) {
        return monthsFull[date.getMonth()];
      },
      // Day of week: Su, Mo, ..., Sa
      "dd": function(date) {
        return weekdays2char[date.getDay()];
      },
      // Day of week: Sun, Mon, ..., Sat
      "ddd": function(date) {
        return weekdays3char[date.getDay()];
      },
      // Day of week: Sunday, Monday, ..., Saturday
      "dddd": function(date) {
        return weekdaysFull[date.getDay()];
      },
      // AM, PM
      "A": function(date) {
        return date.getHours() / 12 >= 1 ? meridiemUppercase[1] : meridiemUppercase[0];
      },
      // am, pm
      "a": function(date) {
        return date.getHours() / 12 >= 1 ? meridiemLowercase[1] : meridiemLowercase[0];
      },
      // a.m., p.m.
      "aa": function(date) {
        return date.getHours() / 12 >= 1 ? meridiemFull[1] : meridiemFull[0];
      }
    };
    var ordinalFormatters = ["M", "D", "DDD", "d", "Q", "W"];
    ordinalFormatters.forEach(function(formatterToken) {
      formatters[formatterToken + "o"] = function(date, formatters2) {
        return ordinal(formatters2[formatterToken](date));
      };
    });
    return {
      formatters,
      formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
    };
  }
  function ordinal(number2) {
    var rem100 = number2 % 100;
    if (rem100 > 20 || rem100 < 10) {
      switch (rem100 % 10) {
        case 1:
          return number2 + "st";
        case 2:
          return number2 + "nd";
        case 3:
          return number2 + "rd";
      }
    }
    return number2 + "th";
  }
  build_format_locale = buildFormatLocale;
  return build_format_locale;
}
var en;
var hasRequiredEn;
function requireEn() {
  if (hasRequiredEn) return en;
  hasRequiredEn = 1;
  var buildDistanceInWordsLocale = requireBuild_distance_in_words_locale();
  var buildFormatLocale = requireBuild_format_locale();
  en = {
    distanceInWords: buildDistanceInWordsLocale(),
    format: buildFormatLocale()
  };
  return en;
}
var distance_in_words;
var hasRequiredDistance_in_words;
function requireDistance_in_words() {
  if (hasRequiredDistance_in_words) return distance_in_words;
  hasRequiredDistance_in_words = 1;
  var compareDesc = requireCompare_desc();
  var parse2 = requireParse();
  var differenceInSeconds = requireDifference_in_seconds();
  var differenceInMonths = requireDifference_in_months();
  var enLocale = requireEn();
  var MINUTES_IN_DAY = 1440;
  var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
  var MINUTES_IN_MONTH = 43200;
  var MINUTES_IN_TWO_MONTHS = 86400;
  function distanceInWords(dirtyDateToCompare, dirtyDate, dirtyOptions) {
    var options = dirtyOptions || {};
    var comparison = compareDesc(dirtyDateToCompare, dirtyDate);
    var locale = options.locale;
    var localize = enLocale.distanceInWords.localize;
    if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
      localize = locale.distanceInWords.localize;
    }
    var localizeOptions = {
      addSuffix: Boolean(options.addSuffix),
      comparison
    };
    var dateLeft, dateRight;
    if (comparison > 0) {
      dateLeft = parse2(dirtyDateToCompare);
      dateRight = parse2(dirtyDate);
    } else {
      dateLeft = parse2(dirtyDate);
      dateRight = parse2(dirtyDateToCompare);
    }
    var seconds = differenceInSeconds(dateRight, dateLeft);
    var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset();
    var minutes = Math.round(seconds / 60) - offset;
    var months;
    if (minutes < 2) {
      if (options.includeSeconds) {
        if (seconds < 5) {
          return localize("lessThanXSeconds", 5, localizeOptions);
        } else if (seconds < 10) {
          return localize("lessThanXSeconds", 10, localizeOptions);
        } else if (seconds < 20) {
          return localize("lessThanXSeconds", 20, localizeOptions);
        } else if (seconds < 40) {
          return localize("halfAMinute", null, localizeOptions);
        } else if (seconds < 60) {
          return localize("lessThanXMinutes", 1, localizeOptions);
        } else {
          return localize("xMinutes", 1, localizeOptions);
        }
      } else {
        if (minutes === 0) {
          return localize("lessThanXMinutes", 1, localizeOptions);
        } else {
          return localize("xMinutes", minutes, localizeOptions);
        }
      }
    } else if (minutes < 45) {
      return localize("xMinutes", minutes, localizeOptions);
    } else if (minutes < 90) {
      return localize("aboutXHours", 1, localizeOptions);
    } else if (minutes < MINUTES_IN_DAY) {
      var hours = Math.round(minutes / 60);
      return localize("aboutXHours", hours, localizeOptions);
    } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
      return localize("xDays", 1, localizeOptions);
    } else if (minutes < MINUTES_IN_MONTH) {
      var days = Math.round(minutes / MINUTES_IN_DAY);
      return localize("xDays", days, localizeOptions);
    } else if (minutes < MINUTES_IN_TWO_MONTHS) {
      months = Math.round(minutes / MINUTES_IN_MONTH);
      return localize("aboutXMonths", months, localizeOptions);
    }
    months = differenceInMonths(dateRight, dateLeft);
    if (months < 12) {
      var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
      return localize("xMonths", nearestMonth, localizeOptions);
    } else {
      var monthsSinceStartOfYear = months % 12;
      var years = Math.floor(months / 12);
      if (monthsSinceStartOfYear < 3) {
        return localize("aboutXYears", years, localizeOptions);
      } else if (monthsSinceStartOfYear < 9) {
        return localize("overXYears", years, localizeOptions);
      } else {
        return localize("almostXYears", years + 1, localizeOptions);
      }
    }
  }
  distance_in_words = distanceInWords;
  return distance_in_words;
}
var distance_in_words_strict;
var hasRequiredDistance_in_words_strict;
function requireDistance_in_words_strict() {
  if (hasRequiredDistance_in_words_strict) return distance_in_words_strict;
  hasRequiredDistance_in_words_strict = 1;
  var compareDesc = requireCompare_desc();
  var parse2 = requireParse();
  var differenceInSeconds = requireDifference_in_seconds();
  var enLocale = requireEn();
  var MINUTES_IN_DAY = 1440;
  var MINUTES_IN_MONTH = 43200;
  var MINUTES_IN_YEAR = 525600;
  function distanceInWordsStrict(dirtyDateToCompare, dirtyDate, dirtyOptions) {
    var options = dirtyOptions || {};
    var comparison = compareDesc(dirtyDateToCompare, dirtyDate);
    var locale = options.locale;
    var localize = enLocale.distanceInWords.localize;
    if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
      localize = locale.distanceInWords.localize;
    }
    var localizeOptions = {
      addSuffix: Boolean(options.addSuffix),
      comparison
    };
    var dateLeft, dateRight;
    if (comparison > 0) {
      dateLeft = parse2(dirtyDateToCompare);
      dateRight = parse2(dirtyDate);
    } else {
      dateLeft = parse2(dirtyDate);
      dateRight = parse2(dirtyDateToCompare);
    }
    var unit;
    var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : "floor"];
    var seconds = differenceInSeconds(dateRight, dateLeft);
    var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset();
    var minutes = mathPartial(seconds / 60) - offset;
    var hours, days, months, years;
    if (options.unit) {
      unit = String(options.unit);
    } else {
      if (minutes < 1) {
        unit = "s";
      } else if (minutes < 60) {
        unit = "m";
      } else if (minutes < MINUTES_IN_DAY) {
        unit = "h";
      } else if (minutes < MINUTES_IN_MONTH) {
        unit = "d";
      } else if (minutes < MINUTES_IN_YEAR) {
        unit = "M";
      } else {
        unit = "Y";
      }
    }
    if (unit === "s") {
      return localize("xSeconds", seconds, localizeOptions);
    } else if (unit === "m") {
      return localize("xMinutes", minutes, localizeOptions);
    } else if (unit === "h") {
      hours = mathPartial(minutes / 60);
      return localize("xHours", hours, localizeOptions);
    } else if (unit === "d") {
      days = mathPartial(minutes / MINUTES_IN_DAY);
      return localize("xDays", days, localizeOptions);
    } else if (unit === "M") {
      months = mathPartial(minutes / MINUTES_IN_MONTH);
      return localize("xMonths", months, localizeOptions);
    } else if (unit === "Y") {
      years = mathPartial(minutes / MINUTES_IN_YEAR);
      return localize("xYears", years, localizeOptions);
    }
    throw new Error("Unknown unit: " + unit);
  }
  distance_in_words_strict = distanceInWordsStrict;
  return distance_in_words_strict;
}
var distance_in_words_to_now;
var hasRequiredDistance_in_words_to_now;
function requireDistance_in_words_to_now() {
  if (hasRequiredDistance_in_words_to_now) return distance_in_words_to_now;
  hasRequiredDistance_in_words_to_now = 1;
  var distanceInWords = requireDistance_in_words();
  function distanceInWordsToNow(dirtyDate, dirtyOptions) {
    return distanceInWords(Date.now(), dirtyDate, dirtyOptions);
  }
  distance_in_words_to_now = distanceInWordsToNow;
  return distance_in_words_to_now;
}
var each_day;
var hasRequiredEach_day;
function requireEach_day() {
  if (hasRequiredEach_day) return each_day;
  hasRequiredEach_day = 1;
  var parse2 = requireParse();
  function eachDay(dirtyStartDate, dirtyEndDate, dirtyStep) {
    var startDate = parse2(dirtyStartDate);
    var endDate = parse2(dirtyEndDate);
    var step = dirtyStep !== void 0 ? dirtyStep : 1;
    var endTime = endDate.getTime();
    if (startDate.getTime() > endTime) {
      throw new Error("The first date cannot be after the second date");
    }
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    while (currentDate.getTime() <= endTime) {
      dates.push(parse2(currentDate));
      currentDate.setDate(currentDate.getDate() + step);
    }
    return dates;
  }
  each_day = eachDay;
  return each_day;
}
var end_of_day;
var hasRequiredEnd_of_day;
function requireEnd_of_day() {
  if (hasRequiredEnd_of_day) return end_of_day;
  hasRequiredEnd_of_day = 1;
  var parse2 = requireParse();
  function endOfDay2(dirtyDate) {
    var date = parse2(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
  }
  end_of_day = endOfDay2;
  return end_of_day;
}
var end_of_hour;
var hasRequiredEnd_of_hour;
function requireEnd_of_hour() {
  if (hasRequiredEnd_of_hour) return end_of_hour;
  hasRequiredEnd_of_hour = 1;
  var parse2 = requireParse();
  function endOfHour(dirtyDate) {
    var date = parse2(dirtyDate);
    date.setMinutes(59, 59, 999);
    return date;
  }
  end_of_hour = endOfHour;
  return end_of_hour;
}
var end_of_week;
var hasRequiredEnd_of_week;
function requireEnd_of_week() {
  if (hasRequiredEnd_of_week) return end_of_week;
  hasRequiredEnd_of_week = 1;
  var parse2 = requireParse();
  function endOfWeek(dirtyDate, dirtyOptions) {
    var weekStartsOn = dirtyOptions ? Number(dirtyOptions.weekStartsOn) || 0 : 0;
    var date = parse2(dirtyDate);
    var day = date.getDay();
    var diff2 = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff2);
    date.setHours(23, 59, 59, 999);
    return date;
  }
  end_of_week = endOfWeek;
  return end_of_week;
}
var end_of_iso_week;
var hasRequiredEnd_of_iso_week;
function requireEnd_of_iso_week() {
  if (hasRequiredEnd_of_iso_week) return end_of_iso_week;
  hasRequiredEnd_of_iso_week = 1;
  var endOfWeek = requireEnd_of_week();
  function endOfISOWeek(dirtyDate) {
    return endOfWeek(dirtyDate, { weekStartsOn: 1 });
  }
  end_of_iso_week = endOfISOWeek;
  return end_of_iso_week;
}
var end_of_iso_year;
var hasRequiredEnd_of_iso_year;
function requireEnd_of_iso_year() {
  if (hasRequiredEnd_of_iso_year) return end_of_iso_year;
  hasRequiredEnd_of_iso_year = 1;
  var getISOYear = requireGet_iso_year();
  var startOfISOWeek = requireStart_of_iso_week();
  function endOfISOYear(dirtyDate) {
    var year = getISOYear(dirtyDate);
    var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var date = startOfISOWeek(fourthOfJanuaryOfNextYear);
    date.setMilliseconds(date.getMilliseconds() - 1);
    return date;
  }
  end_of_iso_year = endOfISOYear;
  return end_of_iso_year;
}
var end_of_minute;
var hasRequiredEnd_of_minute;
function requireEnd_of_minute() {
  if (hasRequiredEnd_of_minute) return end_of_minute;
  hasRequiredEnd_of_minute = 1;
  var parse2 = requireParse();
  function endOfMinute(dirtyDate) {
    var date = parse2(dirtyDate);
    date.setSeconds(59, 999);
    return date;
  }
  end_of_minute = endOfMinute;
  return end_of_minute;
}
var end_of_month;
var hasRequiredEnd_of_month;
function requireEnd_of_month() {
  if (hasRequiredEnd_of_month) return end_of_month;
  hasRequiredEnd_of_month = 1;
  var parse2 = requireParse();
  function endOfMonth(dirtyDate) {
    var date = parse2(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
  }
  end_of_month = endOfMonth;
  return end_of_month;
}
var end_of_quarter;
var hasRequiredEnd_of_quarter;
function requireEnd_of_quarter() {
  if (hasRequiredEnd_of_quarter) return end_of_quarter;
  hasRequiredEnd_of_quarter = 1;
  var parse2 = requireParse();
  function endOfQuarter(dirtyDate) {
    var date = parse2(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3 + 3;
    date.setMonth(month, 0);
    date.setHours(23, 59, 59, 999);
    return date;
  }
  end_of_quarter = endOfQuarter;
  return end_of_quarter;
}
var end_of_second;
var hasRequiredEnd_of_second;
function requireEnd_of_second() {
  if (hasRequiredEnd_of_second) return end_of_second;
  hasRequiredEnd_of_second = 1;
  var parse2 = requireParse();
  function endOfSecond(dirtyDate) {
    var date = parse2(dirtyDate);
    date.setMilliseconds(999);
    return date;
  }
  end_of_second = endOfSecond;
  return end_of_second;
}
var end_of_today;
var hasRequiredEnd_of_today;
function requireEnd_of_today() {
  if (hasRequiredEnd_of_today) return end_of_today;
  hasRequiredEnd_of_today = 1;
  var endOfDay2 = requireEnd_of_day();
  function endOfToday() {
    return endOfDay2(/* @__PURE__ */ new Date());
  }
  end_of_today = endOfToday;
  return end_of_today;
}
var end_of_tomorrow;
var hasRequiredEnd_of_tomorrow;
function requireEnd_of_tomorrow() {
  if (hasRequiredEnd_of_tomorrow) return end_of_tomorrow;
  hasRequiredEnd_of_tomorrow = 1;
  function endOfTomorrow() {
    var now = /* @__PURE__ */ new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = /* @__PURE__ */ new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
  }
  end_of_tomorrow = endOfTomorrow;
  return end_of_tomorrow;
}
var end_of_year;
var hasRequiredEnd_of_year;
function requireEnd_of_year() {
  if (hasRequiredEnd_of_year) return end_of_year;
  hasRequiredEnd_of_year = 1;
  var parse2 = requireParse();
  function endOfYear(dirtyDate) {
    var date = parse2(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
  }
  end_of_year = endOfYear;
  return end_of_year;
}
var end_of_yesterday;
var hasRequiredEnd_of_yesterday;
function requireEnd_of_yesterday() {
  if (hasRequiredEnd_of_yesterday) return end_of_yesterday;
  hasRequiredEnd_of_yesterday = 1;
  function endOfYesterday() {
    var now = /* @__PURE__ */ new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = /* @__PURE__ */ new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
  }
  end_of_yesterday = endOfYesterday;
  return end_of_yesterday;
}
var start_of_year;
var hasRequiredStart_of_year;
function requireStart_of_year() {
  if (hasRequiredStart_of_year) return start_of_year;
  hasRequiredStart_of_year = 1;
  var parse2 = requireParse();
  function startOfYear(dirtyDate) {
    var cleanDate = parse2(dirtyDate);
    var date = /* @__PURE__ */ new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  start_of_year = startOfYear;
  return start_of_year;
}
var get_day_of_year;
var hasRequiredGet_day_of_year;
function requireGet_day_of_year() {
  if (hasRequiredGet_day_of_year) return get_day_of_year;
  hasRequiredGet_day_of_year = 1;
  var parse2 = requireParse();
  var startOfYear = requireStart_of_year();
  var differenceInCalendarDays2 = requireDifference_in_calendar_days();
  function getDayOfYear(dirtyDate) {
    var date = parse2(dirtyDate);
    var diff2 = differenceInCalendarDays2(date, startOfYear(date));
    var dayOfYear = diff2 + 1;
    return dayOfYear;
  }
  get_day_of_year = getDayOfYear;
  return get_day_of_year;
}
var get_iso_week;
var hasRequiredGet_iso_week;
function requireGet_iso_week() {
  if (hasRequiredGet_iso_week) return get_iso_week;
  hasRequiredGet_iso_week = 1;
  var parse2 = requireParse();
  var startOfISOWeek = requireStart_of_iso_week();
  var startOfISOYear = requireStart_of_iso_year();
  var MILLISECONDS_IN_WEEK = 6048e5;
  function getISOWeek(dirtyDate) {
    var date = parse2(dirtyDate);
    var diff2 = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime();
    return Math.round(diff2 / MILLISECONDS_IN_WEEK) + 1;
  }
  get_iso_week = getISOWeek;
  return get_iso_week;
}
var is_valid;
var hasRequiredIs_valid;
function requireIs_valid() {
  if (hasRequiredIs_valid) return is_valid;
  hasRequiredIs_valid = 1;
  var isDate = requireIs_date();
  function isValid2(dirtyDate) {
    if (isDate(dirtyDate)) {
      return !isNaN(dirtyDate);
    } else {
      throw new TypeError(toString.call(dirtyDate) + " is not an instance of Date");
    }
  }
  is_valid = isValid2;
  return is_valid;
}
var format_1;
var hasRequiredFormat;
function requireFormat() {
  if (hasRequiredFormat) return format_1;
  hasRequiredFormat = 1;
  var getDayOfYear = requireGet_day_of_year();
  var getISOWeek = requireGet_iso_week();
  var getISOYear = requireGet_iso_year();
  var parse2 = requireParse();
  var isValid2 = requireIs_valid();
  var enLocale = requireEn();
  function format2(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : "YYYY-MM-DDTHH:mm:ss.SSSZ";
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFormatters = enLocale.format.formatters;
    var formattingTokensRegExp = enLocale.format.formattingTokensRegExp;
    if (locale && locale.format && locale.format.formatters) {
      localeFormatters = locale.format.formatters;
      if (locale.format.formattingTokensRegExp) {
        formattingTokensRegExp = locale.format.formattingTokensRegExp;
      }
    }
    var date = parse2(dirtyDate);
    if (!isValid2(date)) {
      return "Invalid Date";
    }
    var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp);
    return formatFn(date);
  }
  var formatters = {
    // Month: 1, 2, ..., 12
    "M": function(date) {
      return date.getMonth() + 1;
    },
    // Month: 01, 02, ..., 12
    "MM": function(date) {
      return addLeadingZeros(date.getMonth() + 1, 2);
    },
    // Quarter: 1, 2, 3, 4
    "Q": function(date) {
      return Math.ceil((date.getMonth() + 1) / 3);
    },
    // Day of month: 1, 2, ..., 31
    "D": function(date) {
      return date.getDate();
    },
    // Day of month: 01, 02, ..., 31
    "DD": function(date) {
      return addLeadingZeros(date.getDate(), 2);
    },
    // Day of year: 1, 2, ..., 366
    "DDD": function(date) {
      return getDayOfYear(date);
    },
    // Day of year: 001, 002, ..., 366
    "DDDD": function(date) {
      return addLeadingZeros(getDayOfYear(date), 3);
    },
    // Day of week: 0, 1, ..., 6
    "d": function(date) {
      return date.getDay();
    },
    // Day of ISO week: 1, 2, ..., 7
    "E": function(date) {
      return date.getDay() || 7;
    },
    // ISO week: 1, 2, ..., 53
    "W": function(date) {
      return getISOWeek(date);
    },
    // ISO week: 01, 02, ..., 53
    "WW": function(date) {
      return addLeadingZeros(getISOWeek(date), 2);
    },
    // Year: 00, 01, ..., 99
    "YY": function(date) {
      return addLeadingZeros(date.getFullYear(), 4).substr(2);
    },
    // Year: 1900, 1901, ..., 2099
    "YYYY": function(date) {
      return addLeadingZeros(date.getFullYear(), 4);
    },
    // ISO week-numbering year: 00, 01, ..., 99
    "GG": function(date) {
      return String(getISOYear(date)).substr(2);
    },
    // ISO week-numbering year: 1900, 1901, ..., 2099
    "GGGG": function(date) {
      return getISOYear(date);
    },
    // Hour: 0, 1, ... 23
    "H": function(date) {
      return date.getHours();
    },
    // Hour: 00, 01, ..., 23
    "HH": function(date) {
      return addLeadingZeros(date.getHours(), 2);
    },
    // Hour: 1, 2, ..., 12
    "h": function(date) {
      var hours = date.getHours();
      if (hours === 0) {
        return 12;
      } else if (hours > 12) {
        return hours % 12;
      } else {
        return hours;
      }
    },
    // Hour: 01, 02, ..., 12
    "hh": function(date) {
      return addLeadingZeros(formatters["h"](date), 2);
    },
    // Minute: 0, 1, ..., 59
    "m": function(date) {
      return date.getMinutes();
    },
    // Minute: 00, 01, ..., 59
    "mm": function(date) {
      return addLeadingZeros(date.getMinutes(), 2);
    },
    // Second: 0, 1, ..., 59
    "s": function(date) {
      return date.getSeconds();
    },
    // Second: 00, 01, ..., 59
    "ss": function(date) {
      return addLeadingZeros(date.getSeconds(), 2);
    },
    // 1/10 of second: 0, 1, ..., 9
    "S": function(date) {
      return Math.floor(date.getMilliseconds() / 100);
    },
    // 1/100 of second: 00, 01, ..., 99
    "SS": function(date) {
      return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2);
    },
    // Millisecond: 000, 001, ..., 999
    "SSS": function(date) {
      return addLeadingZeros(date.getMilliseconds(), 3);
    },
    // Timezone: -01:00, +00:00, ... +12:00
    "Z": function(date) {
      return formatTimezone(date.getTimezoneOffset(), ":");
    },
    // Timezone: -0100, +0000, ... +1200
    "ZZ": function(date) {
      return formatTimezone(date.getTimezoneOffset());
    },
    // Seconds timestamp: 512969520
    "X": function(date) {
      return Math.floor(date.getTime() / 1e3);
    },
    // Milliseconds timestamp: 512969520900
    "x": function(date) {
      return date.getTime();
    }
  };
  function buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp) {
    var array = formatStr.match(formattingTokensRegExp);
    var length = array.length;
    var i;
    var formatter;
    for (i = 0; i < length; i++) {
      formatter = localeFormatters[array[i]] || formatters[array[i]];
      if (formatter) {
        array[i] = formatter;
      } else {
        array[i] = removeFormattingTokens(array[i]);
      }
    }
    return function(date) {
      var output = "";
      for (var i2 = 0; i2 < length; i2++) {
        if (array[i2] instanceof Function) {
          output += array[i2](date, formatters);
        } else {
          output += array[i2];
        }
      }
      return output;
    };
  }
  function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
      return input.replace(/^\[|]$/g, "");
    }
    return input.replace(/\\/g, "");
  }
  function formatTimezone(offset, delimeter) {
    delimeter = delimeter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2);
  }
  function addLeadingZeros(number2, targetLength) {
    var output = Math.abs(number2).toString();
    while (output.length < targetLength) {
      output = "0" + output;
    }
    return output;
  }
  format_1 = format2;
  return format_1;
}
var get_date;
var hasRequiredGet_date;
function requireGet_date() {
  if (hasRequiredGet_date) return get_date;
  hasRequiredGet_date = 1;
  var parse2 = requireParse();
  function getDate(dirtyDate) {
    var date = parse2(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
  }
  get_date = getDate;
  return get_date;
}
var get_day;
var hasRequiredGet_day;
function requireGet_day() {
  if (hasRequiredGet_day) return get_day;
  hasRequiredGet_day = 1;
  var parse2 = requireParse();
  function getDay2(dirtyDate) {
    var date = parse2(dirtyDate);
    var day = date.getDay();
    return day;
  }
  get_day = getDay2;
  return get_day;
}
var is_leap_year;
var hasRequiredIs_leap_year;
function requireIs_leap_year() {
  if (hasRequiredIs_leap_year) return is_leap_year;
  hasRequiredIs_leap_year = 1;
  var parse2 = requireParse();
  function isLeapYear(dirtyDate) {
    var date = parse2(dirtyDate);
    var year = date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
  }
  is_leap_year = isLeapYear;
  return is_leap_year;
}
var get_days_in_year;
var hasRequiredGet_days_in_year;
function requireGet_days_in_year() {
  if (hasRequiredGet_days_in_year) return get_days_in_year;
  hasRequiredGet_days_in_year = 1;
  var isLeapYear = requireIs_leap_year();
  function getDaysInYear(dirtyDate) {
    return isLeapYear(dirtyDate) ? 366 : 365;
  }
  get_days_in_year = getDaysInYear;
  return get_days_in_year;
}
var get_hours;
var hasRequiredGet_hours;
function requireGet_hours() {
  if (hasRequiredGet_hours) return get_hours;
  hasRequiredGet_hours = 1;
  var parse2 = requireParse();
  function getHours2(dirtyDate) {
    var date = parse2(dirtyDate);
    var hours = date.getHours();
    return hours;
  }
  get_hours = getHours2;
  return get_hours;
}
var get_iso_day;
var hasRequiredGet_iso_day;
function requireGet_iso_day() {
  if (hasRequiredGet_iso_day) return get_iso_day;
  hasRequiredGet_iso_day = 1;
  var parse2 = requireParse();
  function getISODay(dirtyDate) {
    var date = parse2(dirtyDate);
    var day = date.getDay();
    if (day === 0) {
      day = 7;
    }
    return day;
  }
  get_iso_day = getISODay;
  return get_iso_day;
}
var get_iso_weeks_in_year;
var hasRequiredGet_iso_weeks_in_year;
function requireGet_iso_weeks_in_year() {
  if (hasRequiredGet_iso_weeks_in_year) return get_iso_weeks_in_year;
  hasRequiredGet_iso_weeks_in_year = 1;
  var startOfISOYear = requireStart_of_iso_year();
  var addWeeks2 = requireAdd_weeks();
  var MILLISECONDS_IN_WEEK = 6048e5;
  function getISOWeeksInYear(dirtyDate) {
    var thisYear = startOfISOYear(dirtyDate);
    var nextYear = startOfISOYear(addWeeks2(thisYear, 60));
    var diff2 = nextYear.valueOf() - thisYear.valueOf();
    return Math.round(diff2 / MILLISECONDS_IN_WEEK);
  }
  get_iso_weeks_in_year = getISOWeeksInYear;
  return get_iso_weeks_in_year;
}
var get_milliseconds;
var hasRequiredGet_milliseconds;
function requireGet_milliseconds() {
  if (hasRequiredGet_milliseconds) return get_milliseconds;
  hasRequiredGet_milliseconds = 1;
  var parse2 = requireParse();
  function getMilliseconds(dirtyDate) {
    var date = parse2(dirtyDate);
    var milliseconds = date.getMilliseconds();
    return milliseconds;
  }
  get_milliseconds = getMilliseconds;
  return get_milliseconds;
}
var get_minutes;
var hasRequiredGet_minutes;
function requireGet_minutes() {
  if (hasRequiredGet_minutes) return get_minutes;
  hasRequiredGet_minutes = 1;
  var parse2 = requireParse();
  function getMinutes2(dirtyDate) {
    var date = parse2(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
  }
  get_minutes = getMinutes2;
  return get_minutes;
}
var get_month;
var hasRequiredGet_month;
function requireGet_month() {
  if (hasRequiredGet_month) return get_month;
  hasRequiredGet_month = 1;
  var parse2 = requireParse();
  function getMonth2(dirtyDate) {
    var date = parse2(dirtyDate);
    var month = date.getMonth();
    return month;
  }
  get_month = getMonth2;
  return get_month;
}
var get_overlapping_days_in_ranges;
var hasRequiredGet_overlapping_days_in_ranges;
function requireGet_overlapping_days_in_ranges() {
  if (hasRequiredGet_overlapping_days_in_ranges) return get_overlapping_days_in_ranges;
  hasRequiredGet_overlapping_days_in_ranges = 1;
  var parse2 = requireParse();
  var MILLISECONDS_IN_DAY2 = 24 * 60 * 60 * 1e3;
  function getOverlappingDaysInRanges(dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
    var initialStartTime = parse2(dirtyInitialRangeStartDate).getTime();
    var initialEndTime = parse2(dirtyInitialRangeEndDate).getTime();
    var comparedStartTime = parse2(dirtyComparedRangeStartDate).getTime();
    var comparedEndTime = parse2(dirtyComparedRangeEndDate).getTime();
    if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
      throw new Error("The start of the range cannot be after the end of the range");
    }
    var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime;
    if (!isOverlapping) {
      return 0;
    }
    var overlapStartDate = comparedStartTime < initialStartTime ? initialStartTime : comparedStartTime;
    var overlapEndDate = comparedEndTime > initialEndTime ? initialEndTime : comparedEndTime;
    var differenceInMs = overlapEndDate - overlapStartDate;
    return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY2);
  }
  get_overlapping_days_in_ranges = getOverlappingDaysInRanges;
  return get_overlapping_days_in_ranges;
}
var get_seconds;
var hasRequiredGet_seconds;
function requireGet_seconds() {
  if (hasRequiredGet_seconds) return get_seconds;
  hasRequiredGet_seconds = 1;
  var parse2 = requireParse();
  function getSeconds2(dirtyDate) {
    var date = parse2(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
  }
  get_seconds = getSeconds2;
  return get_seconds;
}
var get_time;
var hasRequiredGet_time;
function requireGet_time() {
  if (hasRequiredGet_time) return get_time;
  hasRequiredGet_time = 1;
  var parse2 = requireParse();
  function getTime(dirtyDate) {
    var date = parse2(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
  }
  get_time = getTime;
  return get_time;
}
var get_year;
var hasRequiredGet_year;
function requireGet_year() {
  if (hasRequiredGet_year) return get_year;
  hasRequiredGet_year = 1;
  var parse2 = requireParse();
  function getYear2(dirtyDate) {
    var date = parse2(dirtyDate);
    var year = date.getFullYear();
    return year;
  }
  get_year = getYear2;
  return get_year;
}
var is_after;
var hasRequiredIs_after;
function requireIs_after() {
  if (hasRequiredIs_after) return is_after;
  hasRequiredIs_after = 1;
  var parse2 = requireParse();
  function isAfter2(dirtyDate, dirtyDateToCompare) {
    var date = parse2(dirtyDate);
    var dateToCompare = parse2(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
  }
  is_after = isAfter2;
  return is_after;
}
var is_before;
var hasRequiredIs_before;
function requireIs_before() {
  if (hasRequiredIs_before) return is_before;
  hasRequiredIs_before = 1;
  var parse2 = requireParse();
  function isBefore(dirtyDate, dirtyDateToCompare) {
    var date = parse2(dirtyDate);
    var dateToCompare = parse2(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
  }
  is_before = isBefore;
  return is_before;
}
var is_equal;
var hasRequiredIs_equal;
function requireIs_equal() {
  if (hasRequiredIs_equal) return is_equal;
  hasRequiredIs_equal = 1;
  var parse2 = requireParse();
  function isEqual(dirtyLeftDate, dirtyRightDate) {
    var dateLeft = parse2(dirtyLeftDate);
    var dateRight = parse2(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
  }
  is_equal = isEqual;
  return is_equal;
}
var is_first_day_of_month;
var hasRequiredIs_first_day_of_month;
function requireIs_first_day_of_month() {
  if (hasRequiredIs_first_day_of_month) return is_first_day_of_month;
  hasRequiredIs_first_day_of_month = 1;
  var parse2 = requireParse();
  function isFirstDayOfMonth(dirtyDate) {
    return parse2(dirtyDate).getDate() === 1;
  }
  is_first_day_of_month = isFirstDayOfMonth;
  return is_first_day_of_month;
}
var is_friday;
var hasRequiredIs_friday;
function requireIs_friday() {
  if (hasRequiredIs_friday) return is_friday;
  hasRequiredIs_friday = 1;
  var parse2 = requireParse();
  function isFriday(dirtyDate) {
    return parse2(dirtyDate).getDay() === 5;
  }
  is_friday = isFriday;
  return is_friday;
}
var is_future;
var hasRequiredIs_future;
function requireIs_future() {
  if (hasRequiredIs_future) return is_future;
  hasRequiredIs_future = 1;
  var parse2 = requireParse();
  function isFuture(dirtyDate) {
    return parse2(dirtyDate).getTime() > (/* @__PURE__ */ new Date()).getTime();
  }
  is_future = isFuture;
  return is_future;
}
var is_last_day_of_month;
var hasRequiredIs_last_day_of_month;
function requireIs_last_day_of_month() {
  if (hasRequiredIs_last_day_of_month) return is_last_day_of_month;
  hasRequiredIs_last_day_of_month = 1;
  var parse2 = requireParse();
  var endOfDay2 = requireEnd_of_day();
  var endOfMonth = requireEnd_of_month();
  function isLastDayOfMonth(dirtyDate) {
    var date = parse2(dirtyDate);
    return endOfDay2(date).getTime() === endOfMonth(date).getTime();
  }
  is_last_day_of_month = isLastDayOfMonth;
  return is_last_day_of_month;
}
var is_monday;
var hasRequiredIs_monday;
function requireIs_monday() {
  if (hasRequiredIs_monday) return is_monday;
  hasRequiredIs_monday = 1;
  var parse2 = requireParse();
  function isMonday(dirtyDate) {
    return parse2(dirtyDate).getDay() === 1;
  }
  is_monday = isMonday;
  return is_monday;
}
var is_past;
var hasRequiredIs_past;
function requireIs_past() {
  if (hasRequiredIs_past) return is_past;
  hasRequiredIs_past = 1;
  var parse2 = requireParse();
  function isPast(dirtyDate) {
    return parse2(dirtyDate).getTime() < (/* @__PURE__ */ new Date()).getTime();
  }
  is_past = isPast;
  return is_past;
}
var is_same_day;
var hasRequiredIs_same_day;
function requireIs_same_day() {
  if (hasRequiredIs_same_day) return is_same_day;
  hasRequiredIs_same_day = 1;
  var startOfDay2 = requireStart_of_day();
  function isSameDay2(dirtyDateLeft, dirtyDateRight) {
    var dateLeftStartOfDay = startOfDay2(dirtyDateLeft);
    var dateRightStartOfDay = startOfDay2(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
  }
  is_same_day = isSameDay2;
  return is_same_day;
}
var start_of_hour;
var hasRequiredStart_of_hour;
function requireStart_of_hour() {
  if (hasRequiredStart_of_hour) return start_of_hour;
  hasRequiredStart_of_hour = 1;
  var parse2 = requireParse();
  function startOfHour(dirtyDate) {
    var date = parse2(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
  }
  start_of_hour = startOfHour;
  return start_of_hour;
}
var is_same_hour;
var hasRequiredIs_same_hour;
function requireIs_same_hour() {
  if (hasRequiredIs_same_hour) return is_same_hour;
  hasRequiredIs_same_hour = 1;
  var startOfHour = requireStart_of_hour();
  function isSameHour(dirtyDateLeft, dirtyDateRight) {
    var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
    var dateRightStartOfHour = startOfHour(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
  }
  is_same_hour = isSameHour;
  return is_same_hour;
}
var is_same_week;
var hasRequiredIs_same_week;
function requireIs_same_week() {
  if (hasRequiredIs_same_week) return is_same_week;
  hasRequiredIs_same_week = 1;
  var startOfWeek = requireStart_of_week();
  function isSameWeek(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
    var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions);
    var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
  }
  is_same_week = isSameWeek;
  return is_same_week;
}
var is_same_iso_week;
var hasRequiredIs_same_iso_week;
function requireIs_same_iso_week() {
  if (hasRequiredIs_same_iso_week) return is_same_iso_week;
  hasRequiredIs_same_iso_week = 1;
  var isSameWeek = requireIs_same_week();
  function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
    return isSameWeek(dirtyDateLeft, dirtyDateRight, { weekStartsOn: 1 });
  }
  is_same_iso_week = isSameISOWeek;
  return is_same_iso_week;
}
var is_same_iso_year;
var hasRequiredIs_same_iso_year;
function requireIs_same_iso_year() {
  if (hasRequiredIs_same_iso_year) return is_same_iso_year;
  hasRequiredIs_same_iso_year = 1;
  var startOfISOYear = requireStart_of_iso_year();
  function isSameISOYear(dirtyDateLeft, dirtyDateRight) {
    var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft);
    var dateRightStartOfYear = startOfISOYear(dirtyDateRight);
    return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
  }
  is_same_iso_year = isSameISOYear;
  return is_same_iso_year;
}
var start_of_minute;
var hasRequiredStart_of_minute;
function requireStart_of_minute() {
  if (hasRequiredStart_of_minute) return start_of_minute;
  hasRequiredStart_of_minute = 1;
  var parse2 = requireParse();
  function startOfMinute(dirtyDate) {
    var date = parse2(dirtyDate);
    date.setSeconds(0, 0);
    return date;
  }
  start_of_minute = startOfMinute;
  return start_of_minute;
}
var is_same_minute;
var hasRequiredIs_same_minute;
function requireIs_same_minute() {
  if (hasRequiredIs_same_minute) return is_same_minute;
  hasRequiredIs_same_minute = 1;
  var startOfMinute = requireStart_of_minute();
  function isSameMinute(dirtyDateLeft, dirtyDateRight) {
    var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft);
    var dateRightStartOfMinute = startOfMinute(dirtyDateRight);
    return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
  }
  is_same_minute = isSameMinute;
  return is_same_minute;
}
var is_same_month;
var hasRequiredIs_same_month;
function requireIs_same_month() {
  if (hasRequiredIs_same_month) return is_same_month;
  hasRequiredIs_same_month = 1;
  var parse2 = requireParse();
  function isSameMonth(dirtyDateLeft, dirtyDateRight) {
    var dateLeft = parse2(dirtyDateLeft);
    var dateRight = parse2(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
  }
  is_same_month = isSameMonth;
  return is_same_month;
}
var start_of_quarter;
var hasRequiredStart_of_quarter;
function requireStart_of_quarter() {
  if (hasRequiredStart_of_quarter) return start_of_quarter;
  hasRequiredStart_of_quarter = 1;
  var parse2 = requireParse();
  function startOfQuarter(dirtyDate) {
    var date = parse2(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  start_of_quarter = startOfQuarter;
  return start_of_quarter;
}
var is_same_quarter;
var hasRequiredIs_same_quarter;
function requireIs_same_quarter() {
  if (hasRequiredIs_same_quarter) return is_same_quarter;
  hasRequiredIs_same_quarter = 1;
  var startOfQuarter = requireStart_of_quarter();
  function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
    var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
    var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
  }
  is_same_quarter = isSameQuarter;
  return is_same_quarter;
}
var start_of_second;
var hasRequiredStart_of_second;
function requireStart_of_second() {
  if (hasRequiredStart_of_second) return start_of_second;
  hasRequiredStart_of_second = 1;
  var parse2 = requireParse();
  function startOfSecond(dirtyDate) {
    var date = parse2(dirtyDate);
    date.setMilliseconds(0);
    return date;
  }
  start_of_second = startOfSecond;
  return start_of_second;
}
var is_same_second;
var hasRequiredIs_same_second;
function requireIs_same_second() {
  if (hasRequiredIs_same_second) return is_same_second;
  hasRequiredIs_same_second = 1;
  var startOfSecond = requireStart_of_second();
  function isSameSecond(dirtyDateLeft, dirtyDateRight) {
    var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft);
    var dateRightStartOfSecond = startOfSecond(dirtyDateRight);
    return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
  }
  is_same_second = isSameSecond;
  return is_same_second;
}
var is_same_year;
var hasRequiredIs_same_year;
function requireIs_same_year() {
  if (hasRequiredIs_same_year) return is_same_year;
  hasRequiredIs_same_year = 1;
  var parse2 = requireParse();
  function isSameYear(dirtyDateLeft, dirtyDateRight) {
    var dateLeft = parse2(dirtyDateLeft);
    var dateRight = parse2(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
  }
  is_same_year = isSameYear;
  return is_same_year;
}
var is_saturday;
var hasRequiredIs_saturday;
function requireIs_saturday() {
  if (hasRequiredIs_saturday) return is_saturday;
  hasRequiredIs_saturday = 1;
  var parse2 = requireParse();
  function isSaturday(dirtyDate) {
    return parse2(dirtyDate).getDay() === 6;
  }
  is_saturday = isSaturday;
  return is_saturday;
}
var is_sunday;
var hasRequiredIs_sunday;
function requireIs_sunday() {
  if (hasRequiredIs_sunday) return is_sunday;
  hasRequiredIs_sunday = 1;
  var parse2 = requireParse();
  function isSunday(dirtyDate) {
    return parse2(dirtyDate).getDay() === 0;
  }
  is_sunday = isSunday;
  return is_sunday;
}
var is_this_hour;
var hasRequiredIs_this_hour;
function requireIs_this_hour() {
  if (hasRequiredIs_this_hour) return is_this_hour;
  hasRequiredIs_this_hour = 1;
  var isSameHour = requireIs_same_hour();
  function isThisHour(dirtyDate) {
    return isSameHour(/* @__PURE__ */ new Date(), dirtyDate);
  }
  is_this_hour = isThisHour;
  return is_this_hour;
}
var is_this_iso_week;
var hasRequiredIs_this_iso_week;
function requireIs_this_iso_week() {
  if (hasRequiredIs_this_iso_week) return is_this_iso_week;
  hasRequiredIs_this_iso_week = 1;
  var isSameISOWeek = requireIs_same_iso_week();
  function isThisISOWeek(dirtyDate) {
    return isSameISOWeek(/* @__PURE__ */ new Date(), dirtyDate);
  }
  is_this_iso_week = isThisISOWeek;
  return is_this_iso_week;
}
var is_this_iso_year;
var hasRequiredIs_this_iso_year;
function requireIs_this_iso_year() {
  if (hasRequiredIs_this_iso_year) return is_this_iso_year;
  hasRequiredIs_this_iso_year = 1;
  var isSameISOYear = requireIs_same_iso_year();
  function isThisISOYear(dirtyDate) {
    return isSameISOYear(/* @__PURE__ */ new Date(), dirtyDate);
  }
  is_this_iso_year = isThisISOYear;
  return is_this_iso_year;
}
var is_this_minute;
var hasRequiredIs_this_minute;
function requireIs_this_minute() {
  if (hasRequiredIs_this_minute) return is_this_minute;
  hasRequiredIs_this_minute = 1;
  var isSameMinute = requireIs_same_minute();
  function isThisMinute(dirtyDate) {
    return isSameMinute(/* @__PURE__ */ new Date(), dirtyDate);
  }
  is_this_minute = isThisMinute;
  return is_this_minute;
}
var is_this_month;
var hasRequiredIs_this_month;
function requireIs_this_month() {
  if (hasRequiredIs_this_month) return is_this_month;
  hasRequiredIs_this_month = 1;
  var isSameMonth = requireIs_same_month();
  function isThisMonth(dirtyDate) {
    return isSameMonth(/* @__PURE__ */ new Date(), dirtyDate);
  }
  is_this_month = isThisMonth;
  return is_this_month;
}
var is_this_quarter;
var hasRequiredIs_this_quarter;
function requireIs_this_quarter() {
  if (hasRequiredIs_this_quarter) return is_this_quarter;
  hasRequiredIs_this_quarter = 1;
  var isSameQuarter = requireIs_same_quarter();
  function isThisQuarter(dirtyDate) {
    return isSameQuarter(/* @__PURE__ */ new Date(), dirtyDate);
  }
  is_this_quarter = isThisQuarter;
  return is_this_quarter;
}
var is_this_second;
var hasRequiredIs_this_second;
function requireIs_this_second() {
  if (hasRequiredIs_this_second) return is_this_second;
  hasRequiredIs_this_second = 1;
  var isSameSecond = requireIs_same_second();
  function isThisSecond(dirtyDate) {
    return isSameSecond(/* @__PURE__ */ new Date(), dirtyDate);
  }
  is_this_second = isThisSecond;
  return is_this_second;
}
var is_this_week;
var hasRequiredIs_this_week;
function requireIs_this_week() {
  if (hasRequiredIs_this_week) return is_this_week;
  hasRequiredIs_this_week = 1;
  var isSameWeek = requireIs_same_week();
  function isThisWeek(dirtyDate, dirtyOptions) {
    return isSameWeek(/* @__PURE__ */ new Date(), dirtyDate, dirtyOptions);
  }
  is_this_week = isThisWeek;
  return is_this_week;
}
var is_this_year;
var hasRequiredIs_this_year;
function requireIs_this_year() {
  if (hasRequiredIs_this_year) return is_this_year;
  hasRequiredIs_this_year = 1;
  var isSameYear = requireIs_same_year();
  function isThisYear(dirtyDate) {
    return isSameYear(/* @__PURE__ */ new Date(), dirtyDate);
  }
  is_this_year = isThisYear;
  return is_this_year;
}
var is_thursday;
var hasRequiredIs_thursday;
function requireIs_thursday() {
  if (hasRequiredIs_thursday) return is_thursday;
  hasRequiredIs_thursday = 1;
  var parse2 = requireParse();
  function isThursday(dirtyDate) {
    return parse2(dirtyDate).getDay() === 4;
  }
  is_thursday = isThursday;
  return is_thursday;
}
var is_today;
var hasRequiredIs_today;
function requireIs_today() {
  if (hasRequiredIs_today) return is_today;
  hasRequiredIs_today = 1;
  var startOfDay2 = requireStart_of_day();
  function isToday2(dirtyDate) {
    return startOfDay2(dirtyDate).getTime() === startOfDay2(/* @__PURE__ */ new Date()).getTime();
  }
  is_today = isToday2;
  return is_today;
}
var is_tomorrow;
var hasRequiredIs_tomorrow;
function requireIs_tomorrow() {
  if (hasRequiredIs_tomorrow) return is_tomorrow;
  hasRequiredIs_tomorrow = 1;
  var startOfDay2 = requireStart_of_day();
  function isTomorrow(dirtyDate) {
    var tomorrow = /* @__PURE__ */ new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return startOfDay2(dirtyDate).getTime() === startOfDay2(tomorrow).getTime();
  }
  is_tomorrow = isTomorrow;
  return is_tomorrow;
}
var is_tuesday;
var hasRequiredIs_tuesday;
function requireIs_tuesday() {
  if (hasRequiredIs_tuesday) return is_tuesday;
  hasRequiredIs_tuesday = 1;
  var parse2 = requireParse();
  function isTuesday(dirtyDate) {
    return parse2(dirtyDate).getDay() === 2;
  }
  is_tuesday = isTuesday;
  return is_tuesday;
}
var is_wednesday;
var hasRequiredIs_wednesday;
function requireIs_wednesday() {
  if (hasRequiredIs_wednesday) return is_wednesday;
  hasRequiredIs_wednesday = 1;
  var parse2 = requireParse();
  function isWednesday(dirtyDate) {
    return parse2(dirtyDate).getDay() === 3;
  }
  is_wednesday = isWednesday;
  return is_wednesday;
}
var is_weekend;
var hasRequiredIs_weekend;
function requireIs_weekend() {
  if (hasRequiredIs_weekend) return is_weekend;
  hasRequiredIs_weekend = 1;
  var parse2 = requireParse();
  function isWeekend(dirtyDate) {
    var date = parse2(dirtyDate);
    var day = date.getDay();
    return day === 0 || day === 6;
  }
  is_weekend = isWeekend;
  return is_weekend;
}
var is_within_range;
var hasRequiredIs_within_range;
function requireIs_within_range() {
  if (hasRequiredIs_within_range) return is_within_range;
  hasRequiredIs_within_range = 1;
  var parse2 = requireParse();
  function isWithinRange2(dirtyDate, dirtyStartDate, dirtyEndDate) {
    var time = parse2(dirtyDate).getTime();
    var startTime = parse2(dirtyStartDate).getTime();
    var endTime = parse2(dirtyEndDate).getTime();
    if (startTime > endTime) {
      throw new Error("The start of the range cannot be after the end of the range");
    }
    return time >= startTime && time <= endTime;
  }
  is_within_range = isWithinRange2;
  return is_within_range;
}
var is_yesterday;
var hasRequiredIs_yesterday;
function requireIs_yesterday() {
  if (hasRequiredIs_yesterday) return is_yesterday;
  hasRequiredIs_yesterday = 1;
  var startOfDay2 = requireStart_of_day();
  function isYesterday(dirtyDate) {
    var yesterday = /* @__PURE__ */ new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return startOfDay2(dirtyDate).getTime() === startOfDay2(yesterday).getTime();
  }
  is_yesterday = isYesterday;
  return is_yesterday;
}
var last_day_of_week;
var hasRequiredLast_day_of_week;
function requireLast_day_of_week() {
  if (hasRequiredLast_day_of_week) return last_day_of_week;
  hasRequiredLast_day_of_week = 1;
  var parse2 = requireParse();
  function lastDayOfWeek(dirtyDate, dirtyOptions) {
    var weekStartsOn = dirtyOptions ? Number(dirtyOptions.weekStartsOn) || 0 : 0;
    var date = parse2(dirtyDate);
    var day = date.getDay();
    var diff2 = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + diff2);
    return date;
  }
  last_day_of_week = lastDayOfWeek;
  return last_day_of_week;
}
var last_day_of_iso_week;
var hasRequiredLast_day_of_iso_week;
function requireLast_day_of_iso_week() {
  if (hasRequiredLast_day_of_iso_week) return last_day_of_iso_week;
  hasRequiredLast_day_of_iso_week = 1;
  var lastDayOfWeek = requireLast_day_of_week();
  function lastDayOfISOWeek(dirtyDate) {
    return lastDayOfWeek(dirtyDate, { weekStartsOn: 1 });
  }
  last_day_of_iso_week = lastDayOfISOWeek;
  return last_day_of_iso_week;
}
var last_day_of_iso_year;
var hasRequiredLast_day_of_iso_year;
function requireLast_day_of_iso_year() {
  if (hasRequiredLast_day_of_iso_year) return last_day_of_iso_year;
  hasRequiredLast_day_of_iso_year = 1;
  var getISOYear = requireGet_iso_year();
  var startOfISOWeek = requireStart_of_iso_week();
  function lastDayOfISOYear(dirtyDate) {
    var year = getISOYear(dirtyDate);
    var fourthOfJanuary = /* @__PURE__ */ new Date(0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = startOfISOWeek(fourthOfJanuary);
    date.setDate(date.getDate() - 1);
    return date;
  }
  last_day_of_iso_year = lastDayOfISOYear;
  return last_day_of_iso_year;
}
var last_day_of_month;
var hasRequiredLast_day_of_month;
function requireLast_day_of_month() {
  if (hasRequiredLast_day_of_month) return last_day_of_month;
  hasRequiredLast_day_of_month = 1;
  var parse2 = requireParse();
  function lastDayOfMonth(dirtyDate) {
    var date = parse2(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  last_day_of_month = lastDayOfMonth;
  return last_day_of_month;
}
var last_day_of_quarter;
var hasRequiredLast_day_of_quarter;
function requireLast_day_of_quarter() {
  if (hasRequiredLast_day_of_quarter) return last_day_of_quarter;
  hasRequiredLast_day_of_quarter = 1;
  var parse2 = requireParse();
  function lastDayOfQuarter(dirtyDate) {
    var date = parse2(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3 + 3;
    date.setMonth(month, 0);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  last_day_of_quarter = lastDayOfQuarter;
  return last_day_of_quarter;
}
var last_day_of_year;
var hasRequiredLast_day_of_year;
function requireLast_day_of_year() {
  if (hasRequiredLast_day_of_year) return last_day_of_year;
  hasRequiredLast_day_of_year = 1;
  var parse2 = requireParse();
  function lastDayOfYear(dirtyDate) {
    var date = parse2(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  last_day_of_year = lastDayOfYear;
  return last_day_of_year;
}
var max_1;
var hasRequiredMax;
function requireMax() {
  if (hasRequiredMax) return max_1;
  hasRequiredMax = 1;
  var parse2 = requireParse();
  function max2() {
    var dirtyDates = Array.prototype.slice.call(arguments);
    var dates = dirtyDates.map(function(dirtyDate) {
      return parse2(dirtyDate);
    });
    var latestTimestamp = Math.max.apply(null, dates);
    return new Date(latestTimestamp);
  }
  max_1 = max2;
  return max_1;
}
var min_1;
var hasRequiredMin;
function requireMin() {
  if (hasRequiredMin) return min_1;
  hasRequiredMin = 1;
  var parse2 = requireParse();
  function min2() {
    var dirtyDates = Array.prototype.slice.call(arguments);
    var dates = dirtyDates.map(function(dirtyDate) {
      return parse2(dirtyDate);
    });
    var earliestTimestamp = Math.min.apply(null, dates);
    return new Date(earliestTimestamp);
  }
  min_1 = min2;
  return min_1;
}
var set_date;
var hasRequiredSet_date;
function requireSet_date() {
  if (hasRequiredSet_date) return set_date;
  hasRequiredSet_date = 1;
  var parse2 = requireParse();
  function setDate(dirtyDate, dirtyDayOfMonth) {
    var date = parse2(dirtyDate);
    var dayOfMonth = Number(dirtyDayOfMonth);
    date.setDate(dayOfMonth);
    return date;
  }
  set_date = setDate;
  return set_date;
}
var set_day;
var hasRequiredSet_day;
function requireSet_day() {
  if (hasRequiredSet_day) return set_day;
  hasRequiredSet_day = 1;
  var parse2 = requireParse();
  var addDays2 = requireAdd_days();
  function setDay(dirtyDate, dirtyDay, dirtyOptions) {
    var weekStartsOn = dirtyOptions ? Number(dirtyOptions.weekStartsOn) || 0 : 0;
    var date = parse2(dirtyDate);
    var day = Number(dirtyDay);
    var currentDay = date.getDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff2 = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    return addDays2(date, diff2);
  }
  set_day = setDay;
  return set_day;
}
var set_day_of_year;
var hasRequiredSet_day_of_year;
function requireSet_day_of_year() {
  if (hasRequiredSet_day_of_year) return set_day_of_year;
  hasRequiredSet_day_of_year = 1;
  var parse2 = requireParse();
  function setDayOfYear(dirtyDate, dirtyDayOfYear) {
    var date = parse2(dirtyDate);
    var dayOfYear = Number(dirtyDayOfYear);
    date.setMonth(0);
    date.setDate(dayOfYear);
    return date;
  }
  set_day_of_year = setDayOfYear;
  return set_day_of_year;
}
var set_hours;
var hasRequiredSet_hours;
function requireSet_hours() {
  if (hasRequiredSet_hours) return set_hours;
  hasRequiredSet_hours = 1;
  var parse2 = requireParse();
  function setHours(dirtyDate, dirtyHours) {
    var date = parse2(dirtyDate);
    var hours = Number(dirtyHours);
    date.setHours(hours);
    return date;
  }
  set_hours = setHours;
  return set_hours;
}
var set_iso_day;
var hasRequiredSet_iso_day;
function requireSet_iso_day() {
  if (hasRequiredSet_iso_day) return set_iso_day;
  hasRequiredSet_iso_day = 1;
  var parse2 = requireParse();
  var addDays2 = requireAdd_days();
  var getISODay = requireGet_iso_day();
  function setISODay(dirtyDate, dirtyDay) {
    var date = parse2(dirtyDate);
    var day = Number(dirtyDay);
    var currentDay = getISODay(date);
    var diff2 = day - currentDay;
    return addDays2(date, diff2);
  }
  set_iso_day = setISODay;
  return set_iso_day;
}
var set_iso_week;
var hasRequiredSet_iso_week;
function requireSet_iso_week() {
  if (hasRequiredSet_iso_week) return set_iso_week;
  hasRequiredSet_iso_week = 1;
  var parse2 = requireParse();
  var getISOWeek = requireGet_iso_week();
  function setISOWeek(dirtyDate, dirtyISOWeek) {
    var date = parse2(dirtyDate);
    var isoWeek = Number(dirtyISOWeek);
    var diff2 = getISOWeek(date) - isoWeek;
    date.setDate(date.getDate() - diff2 * 7);
    return date;
  }
  set_iso_week = setISOWeek;
  return set_iso_week;
}
var set_milliseconds;
var hasRequiredSet_milliseconds;
function requireSet_milliseconds() {
  if (hasRequiredSet_milliseconds) return set_milliseconds;
  hasRequiredSet_milliseconds = 1;
  var parse2 = requireParse();
  function setMilliseconds(dirtyDate, dirtyMilliseconds) {
    var date = parse2(dirtyDate);
    var milliseconds = Number(dirtyMilliseconds);
    date.setMilliseconds(milliseconds);
    return date;
  }
  set_milliseconds = setMilliseconds;
  return set_milliseconds;
}
var set_minutes;
var hasRequiredSet_minutes;
function requireSet_minutes() {
  if (hasRequiredSet_minutes) return set_minutes;
  hasRequiredSet_minutes = 1;
  var parse2 = requireParse();
  function setMinutes(dirtyDate, dirtyMinutes) {
    var date = parse2(dirtyDate);
    var minutes = Number(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
  }
  set_minutes = setMinutes;
  return set_minutes;
}
var set_month;
var hasRequiredSet_month;
function requireSet_month() {
  if (hasRequiredSet_month) return set_month;
  hasRequiredSet_month = 1;
  var parse2 = requireParse();
  var getDaysInMonth = requireGet_days_in_month();
  function setMonth(dirtyDate, dirtyMonth) {
    var date = parse2(dirtyDate);
    var month = Number(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = /* @__PURE__ */ new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
  }
  set_month = setMonth;
  return set_month;
}
var set_quarter;
var hasRequiredSet_quarter;
function requireSet_quarter() {
  if (hasRequiredSet_quarter) return set_quarter;
  hasRequiredSet_quarter = 1;
  var parse2 = requireParse();
  var setMonth = requireSet_month();
  function setQuarter(dirtyDate, dirtyQuarter) {
    var date = parse2(dirtyDate);
    var quarter = Number(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff2 = quarter - oldQuarter;
    return setMonth(date, date.getMonth() + diff2 * 3);
  }
  set_quarter = setQuarter;
  return set_quarter;
}
var set_seconds;
var hasRequiredSet_seconds;
function requireSet_seconds() {
  if (hasRequiredSet_seconds) return set_seconds;
  hasRequiredSet_seconds = 1;
  var parse2 = requireParse();
  function setSeconds(dirtyDate, dirtySeconds) {
    var date = parse2(dirtyDate);
    var seconds = Number(dirtySeconds);
    date.setSeconds(seconds);
    return date;
  }
  set_seconds = setSeconds;
  return set_seconds;
}
var set_year;
var hasRequiredSet_year;
function requireSet_year() {
  if (hasRequiredSet_year) return set_year;
  hasRequiredSet_year = 1;
  var parse2 = requireParse();
  function setYear(dirtyDate, dirtyYear) {
    var date = parse2(dirtyDate);
    var year = Number(dirtyYear);
    date.setFullYear(year);
    return date;
  }
  set_year = setYear;
  return set_year;
}
var start_of_month;
var hasRequiredStart_of_month;
function requireStart_of_month() {
  if (hasRequiredStart_of_month) return start_of_month;
  hasRequiredStart_of_month = 1;
  var parse2 = requireParse();
  function startOfMonth(dirtyDate) {
    var date = parse2(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  start_of_month = startOfMonth;
  return start_of_month;
}
var start_of_today;
var hasRequiredStart_of_today;
function requireStart_of_today() {
  if (hasRequiredStart_of_today) return start_of_today;
  hasRequiredStart_of_today = 1;
  var startOfDay2 = requireStart_of_day();
  function startOfToday2() {
    return startOfDay2(/* @__PURE__ */ new Date());
  }
  start_of_today = startOfToday2;
  return start_of_today;
}
var start_of_tomorrow;
var hasRequiredStart_of_tomorrow;
function requireStart_of_tomorrow() {
  if (hasRequiredStart_of_tomorrow) return start_of_tomorrow;
  hasRequiredStart_of_tomorrow = 1;
  function startOfTomorrow() {
    var now = /* @__PURE__ */ new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = /* @__PURE__ */ new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  start_of_tomorrow = startOfTomorrow;
  return start_of_tomorrow;
}
var start_of_yesterday;
var hasRequiredStart_of_yesterday;
function requireStart_of_yesterday() {
  if (hasRequiredStart_of_yesterday) return start_of_yesterday;
  hasRequiredStart_of_yesterday = 1;
  function startOfYesterday() {
    var now = /* @__PURE__ */ new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = /* @__PURE__ */ new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  start_of_yesterday = startOfYesterday;
  return start_of_yesterday;
}
var sub_days;
var hasRequiredSub_days;
function requireSub_days() {
  if (hasRequiredSub_days) return sub_days;
  hasRequiredSub_days = 1;
  var addDays2 = requireAdd_days();
  function subDays(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addDays2(dirtyDate, -amount);
  }
  sub_days = subDays;
  return sub_days;
}
var sub_hours;
var hasRequiredSub_hours;
function requireSub_hours() {
  if (hasRequiredSub_hours) return sub_hours;
  hasRequiredSub_hours = 1;
  var addHours = requireAdd_hours();
  function subHours(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addHours(dirtyDate, -amount);
  }
  sub_hours = subHours;
  return sub_hours;
}
var sub_milliseconds;
var hasRequiredSub_milliseconds;
function requireSub_milliseconds() {
  if (hasRequiredSub_milliseconds) return sub_milliseconds;
  hasRequiredSub_milliseconds = 1;
  var addMilliseconds = requireAdd_milliseconds();
  function subMilliseconds(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addMilliseconds(dirtyDate, -amount);
  }
  sub_milliseconds = subMilliseconds;
  return sub_milliseconds;
}
var sub_minutes;
var hasRequiredSub_minutes;
function requireSub_minutes() {
  if (hasRequiredSub_minutes) return sub_minutes;
  hasRequiredSub_minutes = 1;
  var addMinutes2 = requireAdd_minutes();
  function subMinutes2(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addMinutes2(dirtyDate, -amount);
  }
  sub_minutes = subMinutes2;
  return sub_minutes;
}
var sub_months;
var hasRequiredSub_months;
function requireSub_months() {
  if (hasRequiredSub_months) return sub_months;
  hasRequiredSub_months = 1;
  var addMonths2 = requireAdd_months();
  function subMonths(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addMonths2(dirtyDate, -amount);
  }
  sub_months = subMonths;
  return sub_months;
}
var sub_quarters;
var hasRequiredSub_quarters;
function requireSub_quarters() {
  if (hasRequiredSub_quarters) return sub_quarters;
  hasRequiredSub_quarters = 1;
  var addQuarters = requireAdd_quarters();
  function subQuarters(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addQuarters(dirtyDate, -amount);
  }
  sub_quarters = subQuarters;
  return sub_quarters;
}
var sub_seconds;
var hasRequiredSub_seconds;
function requireSub_seconds() {
  if (hasRequiredSub_seconds) return sub_seconds;
  hasRequiredSub_seconds = 1;
  var addSeconds = requireAdd_seconds();
  function subSeconds(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addSeconds(dirtyDate, -amount);
  }
  sub_seconds = subSeconds;
  return sub_seconds;
}
var sub_weeks;
var hasRequiredSub_weeks;
function requireSub_weeks() {
  if (hasRequiredSub_weeks) return sub_weeks;
  hasRequiredSub_weeks = 1;
  var addWeeks2 = requireAdd_weeks();
  function subWeeks(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addWeeks2(dirtyDate, -amount);
  }
  sub_weeks = subWeeks;
  return sub_weeks;
}
var sub_years;
var hasRequiredSub_years;
function requireSub_years() {
  if (hasRequiredSub_years) return sub_years;
  hasRequiredSub_years = 1;
  var addYears = requireAdd_years();
  function subYears(dirtyDate, dirtyAmount) {
    var amount = Number(dirtyAmount);
    return addYears(dirtyDate, -amount);
  }
  sub_years = subYears;
  return sub_years;
}
var dateFns;
var hasRequiredDateFns;
function requireDateFns() {
  if (hasRequiredDateFns) return dateFns;
  hasRequiredDateFns = 1;
  dateFns = {
    addDays: requireAdd_days(),
    addHours: requireAdd_hours(),
    addISOYears: requireAdd_iso_years(),
    addMilliseconds: requireAdd_milliseconds(),
    addMinutes: requireAdd_minutes(),
    addMonths: requireAdd_months(),
    addQuarters: requireAdd_quarters(),
    addSeconds: requireAdd_seconds(),
    addWeeks: requireAdd_weeks(),
    addYears: requireAdd_years(),
    areRangesOverlapping: requireAre_ranges_overlapping(),
    closestIndexTo: requireClosest_index_to(),
    closestTo: requireClosest_to(),
    compareAsc: requireCompare_asc(),
    compareDesc: requireCompare_desc(),
    differenceInCalendarDays: requireDifference_in_calendar_days(),
    differenceInCalendarISOWeeks: requireDifference_in_calendar_iso_weeks(),
    differenceInCalendarISOYears: requireDifference_in_calendar_iso_years(),
    differenceInCalendarMonths: requireDifference_in_calendar_months(),
    differenceInCalendarQuarters: requireDifference_in_calendar_quarters(),
    differenceInCalendarWeeks: requireDifference_in_calendar_weeks(),
    differenceInCalendarYears: requireDifference_in_calendar_years(),
    differenceInDays: requireDifference_in_days(),
    differenceInHours: requireDifference_in_hours(),
    differenceInISOYears: requireDifference_in_iso_years(),
    differenceInMilliseconds: requireDifference_in_milliseconds(),
    differenceInMinutes: requireDifference_in_minutes(),
    differenceInMonths: requireDifference_in_months(),
    differenceInQuarters: requireDifference_in_quarters(),
    differenceInSeconds: requireDifference_in_seconds(),
    differenceInWeeks: requireDifference_in_weeks(),
    differenceInYears: requireDifference_in_years(),
    distanceInWords: requireDistance_in_words(),
    distanceInWordsStrict: requireDistance_in_words_strict(),
    distanceInWordsToNow: requireDistance_in_words_to_now(),
    eachDay: requireEach_day(),
    endOfDay: requireEnd_of_day(),
    endOfHour: requireEnd_of_hour(),
    endOfISOWeek: requireEnd_of_iso_week(),
    endOfISOYear: requireEnd_of_iso_year(),
    endOfMinute: requireEnd_of_minute(),
    endOfMonth: requireEnd_of_month(),
    endOfQuarter: requireEnd_of_quarter(),
    endOfSecond: requireEnd_of_second(),
    endOfToday: requireEnd_of_today(),
    endOfTomorrow: requireEnd_of_tomorrow(),
    endOfWeek: requireEnd_of_week(),
    endOfYear: requireEnd_of_year(),
    endOfYesterday: requireEnd_of_yesterday(),
    format: requireFormat(),
    getDate: requireGet_date(),
    getDay: requireGet_day(),
    getDayOfYear: requireGet_day_of_year(),
    getDaysInMonth: requireGet_days_in_month(),
    getDaysInYear: requireGet_days_in_year(),
    getHours: requireGet_hours(),
    getISODay: requireGet_iso_day(),
    getISOWeek: requireGet_iso_week(),
    getISOWeeksInYear: requireGet_iso_weeks_in_year(),
    getISOYear: requireGet_iso_year(),
    getMilliseconds: requireGet_milliseconds(),
    getMinutes: requireGet_minutes(),
    getMonth: requireGet_month(),
    getOverlappingDaysInRanges: requireGet_overlapping_days_in_ranges(),
    getQuarter: requireGet_quarter(),
    getSeconds: requireGet_seconds(),
    getTime: requireGet_time(),
    getYear: requireGet_year(),
    isAfter: requireIs_after(),
    isBefore: requireIs_before(),
    isDate: requireIs_date(),
    isEqual: requireIs_equal(),
    isFirstDayOfMonth: requireIs_first_day_of_month(),
    isFriday: requireIs_friday(),
    isFuture: requireIs_future(),
    isLastDayOfMonth: requireIs_last_day_of_month(),
    isLeapYear: requireIs_leap_year(),
    isMonday: requireIs_monday(),
    isPast: requireIs_past(),
    isSameDay: requireIs_same_day(),
    isSameHour: requireIs_same_hour(),
    isSameISOWeek: requireIs_same_iso_week(),
    isSameISOYear: requireIs_same_iso_year(),
    isSameMinute: requireIs_same_minute(),
    isSameMonth: requireIs_same_month(),
    isSameQuarter: requireIs_same_quarter(),
    isSameSecond: requireIs_same_second(),
    isSameWeek: requireIs_same_week(),
    isSameYear: requireIs_same_year(),
    isSaturday: requireIs_saturday(),
    isSunday: requireIs_sunday(),
    isThisHour: requireIs_this_hour(),
    isThisISOWeek: requireIs_this_iso_week(),
    isThisISOYear: requireIs_this_iso_year(),
    isThisMinute: requireIs_this_minute(),
    isThisMonth: requireIs_this_month(),
    isThisQuarter: requireIs_this_quarter(),
    isThisSecond: requireIs_this_second(),
    isThisWeek: requireIs_this_week(),
    isThisYear: requireIs_this_year(),
    isThursday: requireIs_thursday(),
    isToday: requireIs_today(),
    isTomorrow: requireIs_tomorrow(),
    isTuesday: requireIs_tuesday(),
    isValid: requireIs_valid(),
    isWednesday: requireIs_wednesday(),
    isWeekend: requireIs_weekend(),
    isWithinRange: requireIs_within_range(),
    isYesterday: requireIs_yesterday(),
    lastDayOfISOWeek: requireLast_day_of_iso_week(),
    lastDayOfISOYear: requireLast_day_of_iso_year(),
    lastDayOfMonth: requireLast_day_of_month(),
    lastDayOfQuarter: requireLast_day_of_quarter(),
    lastDayOfWeek: requireLast_day_of_week(),
    lastDayOfYear: requireLast_day_of_year(),
    max: requireMax(),
    min: requireMin(),
    parse: requireParse(),
    setDate: requireSet_date(),
    setDay: requireSet_day(),
    setDayOfYear: requireSet_day_of_year(),
    setHours: requireSet_hours(),
    setISODay: requireSet_iso_day(),
    setISOWeek: requireSet_iso_week(),
    setISOYear: requireSet_iso_year(),
    setMilliseconds: requireSet_milliseconds(),
    setMinutes: requireSet_minutes(),
    setMonth: requireSet_month(),
    setQuarter: requireSet_quarter(),
    setSeconds: requireSet_seconds(),
    setYear: requireSet_year(),
    startOfDay: requireStart_of_day(),
    startOfHour: requireStart_of_hour(),
    startOfISOWeek: requireStart_of_iso_week(),
    startOfISOYear: requireStart_of_iso_year(),
    startOfMinute: requireStart_of_minute(),
    startOfMonth: requireStart_of_month(),
    startOfQuarter: requireStart_of_quarter(),
    startOfSecond: requireStart_of_second(),
    startOfToday: requireStart_of_today(),
    startOfTomorrow: requireStart_of_tomorrow(),
    startOfWeek: requireStart_of_week(),
    startOfYear: requireStart_of_year(),
    startOfYesterday: requireStart_of_yesterday(),
    subDays: requireSub_days(),
    subHours: requireSub_hours(),
    subISOYears: requireSub_iso_years(),
    subMilliseconds: requireSub_milliseconds(),
    subMinutes: requireSub_minutes(),
    subMonths: requireSub_months(),
    subQuarters: requireSub_quarters(),
    subSeconds: requireSub_seconds(),
    subWeeks: requireSub_weeks(),
    subYears: requireSub_years()
  };
  return dateFns;
}
var dateFnsExports = requireDateFns();
var is_within_rangeExports = requireIs_within_range();
const isWithinRange = /* @__PURE__ */ getDefaultExportFromCjs(is_within_rangeExports);
var get_hoursExports = requireGet_hours();
const getHours = /* @__PURE__ */ getDefaultExportFromCjs(get_hoursExports);
var get_minutesExports = requireGet_minutes();
const getMinutes = /* @__PURE__ */ getDefaultExportFromCjs(get_minutesExports);
var get_secondsExports = requireGet_seconds();
const getSeconds = /* @__PURE__ */ getDefaultExportFromCjs(get_secondsExports);
var get_dayExports = requireGet_day();
const getDay = /* @__PURE__ */ getDefaultExportFromCjs(get_dayExports);
var add_minutesExports = requireAdd_minutes();
const addMinutes = /* @__PURE__ */ getDefaultExportFromCjs(add_minutesExports);
var _nativeCreate;
var hasRequired_nativeCreate;
function require_nativeCreate() {
  if (hasRequired_nativeCreate) return _nativeCreate;
  hasRequired_nativeCreate = 1;
  var getNative2 = require_getNative();
  var nativeCreate2 = getNative2(Object, "create");
  _nativeCreate = nativeCreate2;
  return _nativeCreate;
}
var _hashClear;
var hasRequired_hashClear;
function require_hashClear() {
  if (hasRequired_hashClear) return _hashClear;
  hasRequired_hashClear = 1;
  var nativeCreate2 = require_nativeCreate();
  function hashClear2() {
    this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
    this.size = 0;
  }
  _hashClear = hashClear2;
  return _hashClear;
}
var _hashDelete;
var hasRequired_hashDelete;
function require_hashDelete() {
  if (hasRequired_hashDelete) return _hashDelete;
  hasRequired_hashDelete = 1;
  function hashDelete2(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  _hashDelete = hashDelete2;
  return _hashDelete;
}
var _hashGet;
var hasRequired_hashGet;
function require_hashGet() {
  if (hasRequired_hashGet) return _hashGet;
  hasRequired_hashGet = 1;
  var nativeCreate2 = require_nativeCreate();
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  var objectProto2 = Object.prototype;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  function hashGet2(key) {
    var data2 = this.__data__;
    if (nativeCreate2) {
      var result = data2[key];
      return result === HASH_UNDEFINED2 ? void 0 : result;
    }
    return hasOwnProperty2.call(data2, key) ? data2[key] : void 0;
  }
  _hashGet = hashGet2;
  return _hashGet;
}
var _hashHas;
var hasRequired_hashHas;
function require_hashHas() {
  if (hasRequired_hashHas) return _hashHas;
  hasRequired_hashHas = 1;
  var nativeCreate2 = require_nativeCreate();
  var objectProto2 = Object.prototype;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  function hashHas2(key) {
    var data2 = this.__data__;
    return nativeCreate2 ? data2[key] !== void 0 : hasOwnProperty2.call(data2, key);
  }
  _hashHas = hashHas2;
  return _hashHas;
}
var _hashSet;
var hasRequired_hashSet;
function require_hashSet() {
  if (hasRequired_hashSet) return _hashSet;
  hasRequired_hashSet = 1;
  var nativeCreate2 = require_nativeCreate();
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  function hashSet2(key, value) {
    var data2 = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data2[key] = nativeCreate2 && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  _hashSet = hashSet2;
  return _hashSet;
}
var _Hash;
var hasRequired_Hash;
function require_Hash() {
  if (hasRequired_Hash) return _Hash;
  hasRequired_Hash = 1;
  var hashClear2 = require_hashClear(), hashDelete2 = require_hashDelete(), hashGet2 = require_hashGet(), hashHas2 = require_hashHas(), hashSet2 = require_hashSet();
  function Hash2(entries) {
    var index2 = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index2 < length) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  Hash2.prototype.clear = hashClear2;
  Hash2.prototype["delete"] = hashDelete2;
  Hash2.prototype.get = hashGet2;
  Hash2.prototype.has = hashHas2;
  Hash2.prototype.set = hashSet2;
  _Hash = Hash2;
  return _Hash;
}
var _listCacheClear;
var hasRequired_listCacheClear;
function require_listCacheClear() {
  if (hasRequired_listCacheClear) return _listCacheClear;
  hasRequired_listCacheClear = 1;
  function listCacheClear2() {
    this.__data__ = [];
    this.size = 0;
  }
  _listCacheClear = listCacheClear2;
  return _listCacheClear;
}
var eq_1;
var hasRequiredEq;
function requireEq() {
  if (hasRequiredEq) return eq_1;
  hasRequiredEq = 1;
  function eq2(value, other) {
    return value === other || value !== value && other !== other;
  }
  eq_1 = eq2;
  return eq_1;
}
var _assocIndexOf;
var hasRequired_assocIndexOf;
function require_assocIndexOf() {
  if (hasRequired_assocIndexOf) return _assocIndexOf;
  hasRequired_assocIndexOf = 1;
  var eq2 = requireEq();
  function assocIndexOf2(array, key) {
    var length = array.length;
    while (length--) {
      if (eq2(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  _assocIndexOf = assocIndexOf2;
  return _assocIndexOf;
}
var _listCacheDelete;
var hasRequired_listCacheDelete;
function require_listCacheDelete() {
  if (hasRequired_listCacheDelete) return _listCacheDelete;
  hasRequired_listCacheDelete = 1;
  var assocIndexOf2 = require_assocIndexOf();
  var arrayProto2 = Array.prototype;
  var splice3 = arrayProto2.splice;
  function listCacheDelete2(key) {
    var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
    if (index2 < 0) {
      return false;
    }
    var lastIndex = data2.length - 1;
    if (index2 == lastIndex) {
      data2.pop();
    } else {
      splice3.call(data2, index2, 1);
    }
    --this.size;
    return true;
  }
  _listCacheDelete = listCacheDelete2;
  return _listCacheDelete;
}
var _listCacheGet;
var hasRequired_listCacheGet;
function require_listCacheGet() {
  if (hasRequired_listCacheGet) return _listCacheGet;
  hasRequired_listCacheGet = 1;
  var assocIndexOf2 = require_assocIndexOf();
  function listCacheGet2(key) {
    var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
    return index2 < 0 ? void 0 : data2[index2][1];
  }
  _listCacheGet = listCacheGet2;
  return _listCacheGet;
}
var _listCacheHas;
var hasRequired_listCacheHas;
function require_listCacheHas() {
  if (hasRequired_listCacheHas) return _listCacheHas;
  hasRequired_listCacheHas = 1;
  var assocIndexOf2 = require_assocIndexOf();
  function listCacheHas2(key) {
    return assocIndexOf2(this.__data__, key) > -1;
  }
  _listCacheHas = listCacheHas2;
  return _listCacheHas;
}
var _listCacheSet;
var hasRequired_listCacheSet;
function require_listCacheSet() {
  if (hasRequired_listCacheSet) return _listCacheSet;
  hasRequired_listCacheSet = 1;
  var assocIndexOf2 = require_assocIndexOf();
  function listCacheSet2(key, value) {
    var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
    if (index2 < 0) {
      ++this.size;
      data2.push([key, value]);
    } else {
      data2[index2][1] = value;
    }
    return this;
  }
  _listCacheSet = listCacheSet2;
  return _listCacheSet;
}
var _ListCache;
var hasRequired_ListCache;
function require_ListCache() {
  if (hasRequired_ListCache) return _ListCache;
  hasRequired_ListCache = 1;
  var listCacheClear2 = require_listCacheClear(), listCacheDelete2 = require_listCacheDelete(), listCacheGet2 = require_listCacheGet(), listCacheHas2 = require_listCacheHas(), listCacheSet2 = require_listCacheSet();
  function ListCache2(entries) {
    var index2 = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index2 < length) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  ListCache2.prototype.clear = listCacheClear2;
  ListCache2.prototype["delete"] = listCacheDelete2;
  ListCache2.prototype.get = listCacheGet2;
  ListCache2.prototype.has = listCacheHas2;
  ListCache2.prototype.set = listCacheSet2;
  _ListCache = ListCache2;
  return _ListCache;
}
var _mapCacheClear;
var hasRequired_mapCacheClear;
function require_mapCacheClear() {
  if (hasRequired_mapCacheClear) return _mapCacheClear;
  hasRequired_mapCacheClear = 1;
  var Hash2 = require_Hash(), ListCache2 = require_ListCache(), Map2 = require_Map();
  function mapCacheClear2() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map2 || ListCache2)(),
      "string": new Hash2()
    };
  }
  _mapCacheClear = mapCacheClear2;
  return _mapCacheClear;
}
var _isKeyable;
var hasRequired_isKeyable;
function require_isKeyable() {
  if (hasRequired_isKeyable) return _isKeyable;
  hasRequired_isKeyable = 1;
  function isKeyable2(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  _isKeyable = isKeyable2;
  return _isKeyable;
}
var _getMapData;
var hasRequired_getMapData;
function require_getMapData() {
  if (hasRequired_getMapData) return _getMapData;
  hasRequired_getMapData = 1;
  var isKeyable2 = require_isKeyable();
  function getMapData2(map, key) {
    var data2 = map.__data__;
    return isKeyable2(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
  }
  _getMapData = getMapData2;
  return _getMapData;
}
var _mapCacheDelete;
var hasRequired_mapCacheDelete;
function require_mapCacheDelete() {
  if (hasRequired_mapCacheDelete) return _mapCacheDelete;
  hasRequired_mapCacheDelete = 1;
  var getMapData2 = require_getMapData();
  function mapCacheDelete2(key) {
    var result = getMapData2(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  _mapCacheDelete = mapCacheDelete2;
  return _mapCacheDelete;
}
var _mapCacheGet;
var hasRequired_mapCacheGet;
function require_mapCacheGet() {
  if (hasRequired_mapCacheGet) return _mapCacheGet;
  hasRequired_mapCacheGet = 1;
  var getMapData2 = require_getMapData();
  function mapCacheGet2(key) {
    return getMapData2(this, key).get(key);
  }
  _mapCacheGet = mapCacheGet2;
  return _mapCacheGet;
}
var _mapCacheHas;
var hasRequired_mapCacheHas;
function require_mapCacheHas() {
  if (hasRequired_mapCacheHas) return _mapCacheHas;
  hasRequired_mapCacheHas = 1;
  var getMapData2 = require_getMapData();
  function mapCacheHas2(key) {
    return getMapData2(this, key).has(key);
  }
  _mapCacheHas = mapCacheHas2;
  return _mapCacheHas;
}
var _mapCacheSet;
var hasRequired_mapCacheSet;
function require_mapCacheSet() {
  if (hasRequired_mapCacheSet) return _mapCacheSet;
  hasRequired_mapCacheSet = 1;
  var getMapData2 = require_getMapData();
  function mapCacheSet2(key, value) {
    var data2 = getMapData2(this, key), size2 = data2.size;
    data2.set(key, value);
    this.size += data2.size == size2 ? 0 : 1;
    return this;
  }
  _mapCacheSet = mapCacheSet2;
  return _mapCacheSet;
}
var _MapCache;
var hasRequired_MapCache;
function require_MapCache() {
  if (hasRequired_MapCache) return _MapCache;
  hasRequired_MapCache = 1;
  var mapCacheClear2 = require_mapCacheClear(), mapCacheDelete2 = require_mapCacheDelete(), mapCacheGet2 = require_mapCacheGet(), mapCacheHas2 = require_mapCacheHas(), mapCacheSet2 = require_mapCacheSet();
  function MapCache2(entries) {
    var index2 = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index2 < length) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  MapCache2.prototype.clear = mapCacheClear2;
  MapCache2.prototype["delete"] = mapCacheDelete2;
  MapCache2.prototype.get = mapCacheGet2;
  MapCache2.prototype.has = mapCacheHas2;
  MapCache2.prototype.set = mapCacheSet2;
  _MapCache = MapCache2;
  return _MapCache;
}
var memoize_1;
var hasRequiredMemoize;
function requireMemoize() {
  if (hasRequiredMemoize) return memoize_1;
  hasRequiredMemoize = 1;
  var MapCache2 = require_MapCache();
  var FUNC_ERROR_TEXT2 = "Expected a function";
  function memoize2(func2, resolver) {
    if (typeof func2 != "function" || resolver != null && typeof resolver != "function") {
      throw new TypeError(FUNC_ERROR_TEXT2);
    }
    var memoized = function() {
      var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func2.apply(this, args);
      memoized.cache = cache.set(key, result) || cache;
      return result;
    };
    memoized.cache = new (memoize2.Cache || MapCache2)();
    return memoized;
  }
  memoize2.Cache = MapCache2;
  memoize_1 = memoize2;
  return memoize_1;
}
var memoizeExports = requireMemoize();
const memoize$1 = /* @__PURE__ */ getDefaultExportFromCjs(memoizeExports);
const roundHalfDownToTwoDecimals = (value) => {
  const scaled = Number((value * 1e3).toFixed(0)) / 10;
  const floor2 = Math.floor(scaled);
  if (scaled - floor2 > 0.5) return (floor2 + 1) / 100;
  return floor2 / 100;
};
const PROMOTION_TYPES = {
  VOLUME: "volume",
  AGREEMENT: "agreement",
  EVENT: "event",
  SELLER_AGREEMENT: "seller_agreement",
  PROMOTIONAL_CODE: "promotional_code"
};
const getAvailableUsesForPromotionCodeEvent = (promotionCodeCode, eventId) => {
  const { promotionalCodeCodeEvents = [] } = promotionCodeCode;
  if (promotionalCodeCodeEvents.length < 1) {
    return null;
  }
  const promotionalCodeCodeEvent = eventId != null && promotionalCodeCodeEvents.find(
    (promoCodeEvent) => promoCodeEvent.eventId === eventId
  ) || promotionalCodeCodeEvents[0];
  return promotionalCodeCodeEvent.quantity - promotionalCodeCodeEvent.redeemed;
};
const availableUsesForPromotionalCode = (promotion, eventId) => {
  let availableUses = 0;
  if (promotion.promotionType === PROMOTION_TYPES.PROMOTIONAL_CODE && promotion.promotionalCodeCodeList) {
    promotion.promotionalCodeCodeList.forEach((promotionCodeCode) => {
      const availableUsesForEvent = getAvailableUsesForPromotionCodeEvent(promotionCodeCode, eventId);
      if (promotionCodeCode.redeemType === "ticket") {
        if (availableUsesForEvent !== null) {
          availableUses = availableUsesForEvent;
        } else {
          availableUses = promotionCodeCode.quantity - promotionCodeCode.redeemed;
        }
      } else if (availableUsesForEvent !== null) {
        availableUses = availableUsesForEvent;
      } else if (promotionCodeCode.quantity - promotionCodeCode.redeemed > 0) {
        availableUses = 100;
      } else {
        availableUses = 0;
      }
    });
  }
  return availableUses;
};
const redeemedTimes = (promotion = {}, ticketQuantity, eventId) => {
  let apply2 = false;
  if (promotion.promotionType === PROMOTION_TYPES.PROMOTIONAL_CODE && promotion.promotionalCodeCodeList) {
    const availableUses = availableUsesForPromotionalCode(promotion, eventId);
    promotion.promotionalCodeCodeList.forEach((promotionCodeCode) => {
      if (promotionCodeCode.redeemType === "ticket") {
        apply2 = availableUses > ticketQuantity;
      } else {
        apply2 = availableUses > 0;
      }
    });
  }
  return apply2;
};
const logAndReturn$1 = (fnName, ...rest) => (response) => {
  return response;
};
const getParsedDay = (date) => `${getDay(date) + 1}`;
const isPromotionWeekDayInRange = ({ date, weekDay }) => logAndReturn$1("isPromotionWeekDayInRange", { date, weekDay })(
  !!date && (!weekDay || weekDay.split(",").indexOf(getParsedDay(date)) !== -1)
);
const getParsedProductDay = (date) => `${getDay(date) === 0 ? 7 : getDay(date)}`;
const isProductWeekDayInRange = ({ date, weekDay }) => logAndReturn$1("isProductWeekDayInRange", { date, weekDay })(
  !!date && (!weekDay || weekDay.split(",").indexOf(getParsedProductDay(date)) !== -1)
);
const isDateInRange$1 = ({ date, startDatetime, endDatetime, timeZone } = {}) => {
  const actualDate = date || moment().tz(timeZone).format();
  return logAndReturn$1("isDateInRange", { date: actualDate, startDatetime, endDatetime })(
    !!actualDate && (!startDatetime || !endDatetime || isWithinRange(actualDate, startDatetime, endDatetime))
  );
};
const setTime = (date, event, timeZone) => {
  let hours;
  let minutes;
  let seconds;
  if (!moment(date).isValid()) {
    [hours, minutes] = date.split(":");
    seconds = 0;
  } else {
    hours = getHours(moment(date, DATETIME_FORMAT_YMDHM).tz(timeZone).toDate());
    minutes = getMinutes(moment(date, DATETIME_FORMAT_YMDHM).tz(timeZone).toDate());
    seconds = getSeconds(moment(date, DATETIME_FORMAT_YMDHM).tz(timeZone).toDate());
  }
  const realhour = moment(event).tz(timeZone).seconds(seconds).minutes(Number(minutes)).hours(Number(hours)).format();
  return realhour;
};
const isTimeInRange = ({ date, startDatetime, endDatetime, timeZone } = {}) => {
  const actualDate = date || moment().tz(timeZone).format();
  return logAndReturn$1("isTimeInRange", { date: actualDate, startDatetime, endDatetime })(
    !!actualDate && (!startDatetime || !endDatetime || isWithinRange(
      actualDate,
      setTime(startDatetime, actualDate, timeZone),
      setTime(endDatetime, actualDate, timeZone)
    ))
  );
};
const isBuyerTypeAllowed = ({ buyerTypeId, allowedBuyerTypeIdList = [] }) => allowedBuyerTypeIdList.includes(buyerTypeId);
const ticketsEnoughtForVolumePromotion = ({ totalTickets = 0, promotion }) => !!promotion.leftPurchased && totalTickets >= promotion.leftPurchased;
const getDiscountForBuyerType = (promotion = {}, buyerType, ticketMap, seat) => {
  const { buyerTypeId } = buyerType;
  let { price } = buyerType;
  if (seat) {
    price = seat.price;
  }
  const { promotionPrices, percentage = 0, amount = 0, leftPurchased, rightPaid } = promotion;
  const promotionPrice = promotionPrices ? Object.values(promotionPrices).filter(
    (promotionPriceFilter) => Number(promotionPriceFilter.buyerTypeId) === Number(buyerTypeId)
  )[0] : void 0;
  if (!promotionPrice) {
    let discount = percentage ? price * percentage : amount;
    if (leftPurchased && rightPaid) {
      discount = price;
    }
    return discount;
  }
  const { percentage: percentageForBt, amount: amountForBt } = promotionPrice;
  const percentageToApply = percentageForBt || percentage;
  const amountToApply = amountForBt || amount;
  const buyerTypeDiscount = percentageToApply ? roundHalfDownToTwoDecimals(price * percentageToApply) : amountToApply;
  return buyerTypeDiscount;
};
const generalValidations = ({
  buyerTypeId,
  promotion = {},
  event = {},
  checkBuyerTypes = true,
  venueList = {},
  timeZone
}) => {
  const { minSecondsBeforeEvent = 0, maxSecondsBeforeEvent = 0, disabledDates = [] } = promotion;
  if (checkBuyerTypes && !isBuyerTypeAllowed({
    buyerTypeId,
    allowedBuyerTypeIdList: promotion.buyerTypeIds
  })) {
    return false;
  }
  if (!isDateInRange$1({
    date: moment().tz(timeZone).format(),
    startDatetime: promotion.startDatetime,
    endDatetime: promotion.endDatetime
  })) {
    return false;
  }
  if (!isEmpty(disabledDates)) {
    if (disabledDates.some(
      (date) => isDateInRange$1({
        date: moment(event.startDatetime).tz(timeZone).format(),
        startDatetime: moment(date).startOf("day").tz(timeZone).format(),
        endDatetime: moment(date).endOf("day").tz(timeZone).format()
      })
    )) {
      return false;
    }
  }
  if (!isDateInRange$1({
    date: moment(event.startDatetime).tz(timeZone).format(),
    startDatetime: promotion.eventStartDatetime,
    endDatetime: promotion.eventEndDatetime
  })) {
    return false;
  }
  if (maxSecondsBeforeEvent && minSecondsBeforeEvent) {
    const start = moment(event.startDatetime).subtract(maxSecondsBeforeEvent, "seconds");
    const end = moment(event.startDatetime).subtract(minSecondsBeforeEvent, "seconds");
    if (!isDateInRange$1({
      date: moment().tz(timeZone).format(),
      startDatetime: start,
      endDatetime: end
    })) {
      return false;
    }
  }
  if (promotion.weekDay && !isPromotionWeekDayInRange({
    date: event.startDatetime,
    weekDay: promotion.weekDay
  })) {
    return false;
  }
  if (promotion.startTime && promotion.endTime && !isTimeInRange({
    date: event.startDatetime,
    startDatetime: promotion.startTime,
    endDatetime: promotion.endTime,
    timeZone
  })) {
    return false;
  }
  if (!isEmpty(venueList[event.venueId]) && venueList[event.venueId].mainVenueId) {
    if (!isDateInRange$1({
      date: event.startDatetime,
      startDatetime: setTime(
        addMinutes(
          promotion.startTime,
          venueList[event.venueId].maxSeparation
        ).toISOString(),
        event.startDatetime,
        timeZone
      ),
      endDatetime: setTime(promotion.endTime, event.startDatetime, timeZone)
    })) {
      return false;
    }
  }
  return true;
};
const generalValidationsMemo = memoize$1(
  (object2) => generalValidations(object2)
);
const validateVolumePromotion = ({
  promotion = {},
  totalTickets
}) => {
  if (!ticketsEnoughtForVolumePromotion({ totalTickets, promotion })) {
    return false;
  }
  return true;
};
const validatePromotionalCodePromotion = ({
  promotion = {},
  totalTickets,
  eventId
}) => redeemedTimes(promotion, totalTickets, eventId);
const isPromotionValid = ({ buyerTypeId, promotion, event, timeZone }) => {
  if (!generalValidations({
    buyerTypeId,
    promotion,
    event,
    timeZone
  })) {
    return false;
  }
  return true;
};
const getUsedTimesByPromotionId = (ticketIndexPromotionMap, promotionId) => Object.values(ticketIndexPromotionMap).map((promotionBuyerType) => promotionBuyerType.promotionId).filter((promoId) => promoId === promotionId).length;
const getTotalPriceWithPercentagePromo = ({
  originalPrice,
  ticketBuyerType,
  extraBuyerType,
  percentage
}) => {
  const ticketTotalPrice = ticketBuyerType.reduce((acc, ticket) => {
    const ticketPriceDiscount = ticket.price * percentage;
    const ticketPriceWithPromo = Math.round((ticket.price - ticketPriceDiscount) * 100 + Number.EPSILON) / 100;
    return acc + ticketPriceWithPromo;
  }, 0);
  let extraTotalPrice = 0;
  if (extraBuyerType) {
    extraTotalPrice = extraBuyerType.reduce((acc, extra) => {
      const ticketExtraDiscount = extra.price * percentage;
      const ticketExtraWithPromo = Math.round((extra.price - ticketExtraDiscount) * 100 + Number.EPSILON) / 100;
      return acc + ticketExtraWithPromo;
    }, 0);
  }
  const amount = extraTotalPrice ? ticketTotalPrice + extraTotalPrice : ticketTotalPrice;
  return {
    discount: roundHalfDownToTwoDecimals(originalPrice - amount),
    amount: roundHalfDownToTwoDecimals(amount)
  };
};
const getPossiblePromotions = (buyerType = {}, promotions2, event, ticketMap = {}, isSamePromo, ticketIndexPromotionMap, timeZone, seats) => {
  const promotionsCouldApply = {};
  const { buyerTypeId } = buyerType;
  promotions2.forEach((promotion, index2) => {
    const {
      promotionId,
      name,
      promotionType,
      isGrouped = false,
      promotionPrices,
      leftPurchased,
      rightPaid
    } = promotion;
    let totalTickets;
    if (promotionType === PROMOTION_TYPES.PROMOTIONAL_CODE) {
      if (ticketIndexPromotionMap) {
        totalTickets = getUsedTimesByPromotionId(ticketIndexPromotionMap, promotionId);
      } else {
        totalTickets = 0;
      }
    } else {
      totalTickets = Object.values(ticketMap).reduce((acc, n) => acc + n, 0);
    }
    let promotionCode;
    if (isPromotionValid({
      buyerTypeId,
      promotion,
      event,
      timeZone
    })) {
      let applied;
      switch (promotionType) {
        case PROMOTION_TYPES.EVENT:
        case PROMOTION_TYPES.AGREEMENT:
        case PROMOTION_TYPES.SELLER_AGREEMENT:
          applied = true;
          break;
        case PROMOTION_TYPES.PROMOTIONAL_CODE:
          if (promotion.promotionalCodeCodeList && promotion.promotionalCodeCodeList[0]) {
            promotionCode = promotion.promotionalCodeCodeList[0].code;
          }
          applied = validatePromotionalCodePromotion({
            promotion,
            totalTickets,
            eventId: event.eventId
          });
          break;
        case PROMOTION_TYPES.VOLUME:
          applied = validateVolumePromotion({ totalTickets, promotion });
          break;
        default:
          applied = false;
          break;
      }
      let discount = getDiscountForBuyerType(promotion, buyerType, ticketMap, seats[index2]);
      const { price } = buyerType;
      let percentagePrice = null;
      if (promotion.percentage) {
        let percentageToApply = promotion.percentage;
        if (promotion.promotionPrices) {
          const { percentage } = promotion.promotionPrices.find(
            (pPrice) => pPrice.buyerTypeId === buyerTypeId
          );
          percentageToApply = percentage || promotion.percentage;
        }
        const { discount: percentageDiscount, amount } = getTotalPriceWithPercentagePromo({
          originalPrice: buyerType.price,
          ticketBuyerType: buyerType.productVenueBuyerTypeList,
          extraBuyerType: buyerType.productExtraBuyerTypeList,
          percentage: percentageToApply
        });
        discount = percentageDiscount;
        percentagePrice = amount;
      }
      promotionsCouldApply[promotionId] = {
        promotionId,
        name,
        promotionType,
        isGrouped,
        // TODO: default false
        discount,
        externalProviderId: promotion.externalProviderId ? promotion.externalProviderId : void 0,
        amount: promotion.percentage ? percentagePrice : Math.round((price - discount) * 100 + Number.EPSILON) / 100,
        price,
        promotionCode,
        promotionPrices,
        leftPurchased,
        rightPaid,
        applied
        // if promotion is applied (promotional code doesn't apply immediately)
      };
    }
  });
  return promotionsCouldApply;
};
const getPromotionsByBuyerType = ({
  ticketMap = {},
  buyerTypesMap = {},
  promotions: promotions2 = [],
  event = {},
  isSamePromo = false,
  ticketIndexPromotionMap = {},
  timeZone = "Europe/Madrid",
  seats
}) => {
  const promotionsByBuyerType = Object.entries(ticketMap).filter(([, ticketQuantityByBuyerType]) => !!ticketQuantityByBuyerType).reduce(
    (accumulate, [buyerTypeId]) => ({
      ...accumulate,
      [buyerTypeId]: getPossiblePromotions(
        buyerTypesMap[buyerTypeId],
        promotions2,
        event,
        ticketMap,
        isSamePromo,
        ticketIndexPromotionMap,
        timeZone,
        seats
      )
    }),
    {}
  );
  return promotionsByBuyerType;
};
function getBestPromotion(promotions2) {
  return promotions2.reduce((accPromos, promo) => {
    if (promo.amount && promo.amount > accPromos.amount || promo.percentage && promo.percentage > accPromos.percentage) {
      return promo;
    }
    return accPromos;
  }, promotions2[0]);
}
const getDefaultEventPromotion = (promotions2, sellerId, ticketMap) => {
  let promotionEvents = promotions2.filter(
    (promotion) => promotion.promotionType === PROMOTION_TYPES.EVENT || promotion.promotionType === PROMOTION_TYPES.SELLER_AGREEMENT || promotion.promotionType === PROMOTION_TYPES.VOLUME
  ).filter((promotion) => {
    if (isEmpty(ticketMap)) return true;
    const btSelected = Object.keys(ticketMap);
    return btSelected.some((bt) => promotion.buyerTypeIds.includes(Number(bt)));
  });
  if (sellerId && promotionEvents.some((promo) => promo.promotionType === PROMOTION_TYPES.SELLER_AGREEMENT)) {
    promotionEvents = promotionEvents.filter(
      (promo) => !isEmpty(promo.sellerIds) && promo.sellerIds.includes(sellerId)
    );
  }
  promotionEvents = promotionEvents.filter((promo) => {
    if (promo.promotionType === PROMOTION_TYPES.VOLUME && !isEmpty(ticketMap)) {
      const btSelected = Object.values(ticketMap).reduce((acc, next) => acc + next, 0);
      return btSelected >= promo.leftPurchased;
    }
    return true;
  });
  const bestPromo = promotionEvents.reduce((accPromos, promo) => {
    const updatedPromos = { ...accPromos };
    promo.buyerTypeIds.forEach((bt) => {
      updatedPromos[bt] = accPromos[bt] ? getBestPromotion([promo, accPromos[bt]]) : promo;
    });
    return updatedPromos;
  }, {});
  return bestPromo || void 0;
};
const getDefaultEventPromotionMemo = memoize$1(
  (promotions2, sellerId, ticketMap) => getDefaultEventPromotion(promotions2, sellerId, ticketMap)
);
const getPromotionsWithPromotionalCode = (promotions2) => promotions2.filter((promotion) => promotion.promotionType === PROMOTION_TYPES.PROMOTIONAL_CODE);
const checkIfPromoCodeChanges = (promotions2, nextPromotions) => {
  const propsPromoCodes = getPromotionsWithPromotionalCode(promotions2);
  const nextPropsPromoCodes = getPromotionsWithPromotionalCode(nextPromotions);
  return propsPromoCodes && propsPromoCodes[0] && nextPropsPromoCodes && nextPropsPromoCodes[0] && propsPromoCodes[0].promotionId === nextPropsPromoCodes[0].promotionId;
};
const getTicketIndexToApplyPromo = (nextPropsPromoCode, promotionsByBuyerType, ticketMap, applyPromotion, showNotification, eventId) => {
  const promoCodeId = nextPropsPromoCode.promotionId;
  const availableUses = availableUsesForPromotionalCode(nextPropsPromoCode, eventId);
  let currentTicketIndex = 0;
  let ticketIndexArray = [];
  Object.entries(ticketMap).forEach(([buyerTypeId, quantity]) => {
    ticketIndexArray = [];
    const promoValidated = promotionsByBuyerType[buyerTypeId][promoCodeId];
    if (promoValidated) {
      for (let i = 0; i < quantity; i++) {
        if (currentTicketIndex < availableUses) {
          ticketIndexArray.push(`buyerTypePromo-${buyerTypeId}-${i}`);
          currentTicketIndex++;
        }
      }
      applyPromotion(
        {
          ...promoValidated,
          buyerTypeId: Number(buyerTypeId),
          quantity: 1,
          applied: true
        },
        ticketIndexArray
      );
    } else {
      currentTicketIndex += quantity;
    }
  });
  if (ticketIndexArray.length > 0) {
    showNotification("success", void 0, ticketIndexArray.length);
  }
  return currentTicketIndex;
};
var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  }
  return getRandomValues(rnds8);
}
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 256).toString(16).substr(1);
}
function bytesToUuid(buf, offset) {
  var i = 0;
  var bth = byteToHex;
  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], "-", bth[buf[i++]], bth[buf[i++]], "-", bth[buf[i++]], bth[buf[i++]], "-", bth[buf[i++]], bth[buf[i++]], "-", bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join("");
}
function v4(options, buf, offset) {
  var i = buf && offset || 0;
  if (typeof options == "string") {
    buf = options === "binary" ? new Array(16) : null;
    options = null;
  }
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }
  return buf || bytesToUuid(rnds);
}
function ownKeys$2(object2, enumerableOnly) {
  var keys3 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys3.push.apply(keys3, symbols);
  }
  return keys3;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$2(Object(source), true).forEach(function(key) {
      _defineProperty$5(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _classCallCheck$8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$6(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$c() {
  _extends$c = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$c.apply(this, arguments);
}
function _inherits$8(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn$8(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$8(this, result);
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike) {
      if (it) o = it;
      var i = 0;
      var F = function() {
      };
      return {
        s: F,
        n: function() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function(e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function() {
      it = it.call(o);
    },
    n: function() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function(e) {
      didErr = true;
      err = e;
    },
    f: function() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var check = function(it) {
  return it && it.Math == Math && it;
};
var global$a = (
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == "object" && self) || check(typeof commonjsGlobal == "object" && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ (function() {
    return this;
  })() || Function("return this")()
);
var objectGetOwnPropertyDescriptor = {};
var fails$9 = function(exec2) {
  try {
    return !!exec2();
  } catch (error) {
    return true;
  }
};
var fails$8 = fails$9;
var descriptors = !fails$8(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] != 7;
});
var fails$7 = fails$9;
var functionBindNative = !fails$7(function() {
  var test2 = (function() {
  }).bind();
  return typeof test2 != "function" || test2.hasOwnProperty("prototype");
});
var NATIVE_BIND$2 = functionBindNative;
var call$4 = Function.prototype.call;
var functionCall = NATIVE_BIND$2 ? call$4.bind(call$4) : function() {
  return call$4.apply(call$4, arguments);
};
var objectPropertyIsEnumerable = {};
var $propertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;
var createPropertyDescriptor$2 = function(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value
  };
};
var NATIVE_BIND$1 = functionBindNative;
var FunctionPrototype$1 = Function.prototype;
var call$3 = FunctionPrototype$1.call;
var uncurryThisWithBind = NATIVE_BIND$1 && FunctionPrototype$1.bind.bind(call$3, call$3);
var functionUncurryThisRaw = function(fn) {
  return NATIVE_BIND$1 ? uncurryThisWithBind(fn) : function() {
    return call$3.apply(fn, arguments);
  };
};
var uncurryThisRaw$1 = functionUncurryThisRaw;
var toString$1$1 = uncurryThisRaw$1({}.toString);
var stringSlice = uncurryThisRaw$1("".slice);
var classofRaw$2 = function(it) {
  return stringSlice(toString$1$1(it), 8, -1);
};
var classofRaw$1 = classofRaw$2;
var uncurryThisRaw = functionUncurryThisRaw;
var functionUncurryThis = function(fn) {
  if (classofRaw$1(fn) === "Function") return uncurryThisRaw(fn);
};
var uncurryThis$9 = functionUncurryThis;
var fails$6 = fails$9;
var classof$3 = classofRaw$2;
var $Object$3 = Object;
var split = uncurryThis$9("".split);
var indexedObject = fails$6(function() {
  return !$Object$3("z").propertyIsEnumerable(0);
}) ? function(it) {
  return classof$3(it) == "String" ? split(it, "") : $Object$3(it);
} : $Object$3;
var isNullOrUndefined$2 = function(it) {
  return it === null || it === void 0;
};
var isNullOrUndefined$1 = isNullOrUndefined$2;
var $TypeError$5 = TypeError;
var requireObjectCoercible$2 = function(it) {
  if (isNullOrUndefined$1(it)) throw $TypeError$5("Can't call method on " + it);
  return it;
};
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;
var toIndexedObject$4 = function(it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};
var documentAll$2 = typeof document == "object" && document.all;
var IS_HTMLDDA = typeof documentAll$2 == "undefined" && documentAll$2 !== void 0;
var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA
};
var $documentAll$1 = documentAll_1;
var documentAll$1 = $documentAll$1.all;
var isCallable$c = $documentAll$1.IS_HTMLDDA ? function(argument) {
  return typeof argument == "function" || argument === documentAll$1;
} : function(argument) {
  return typeof argument == "function";
};
var isCallable$b = isCallable$c;
var $documentAll = documentAll_1;
var documentAll = $documentAll.all;
var isObject$6 = $documentAll.IS_HTMLDDA ? function(it) {
  return typeof it == "object" ? it !== null : isCallable$b(it) || it === documentAll;
} : function(it) {
  return typeof it == "object" ? it !== null : isCallable$b(it);
};
var global$9 = global$a;
var isCallable$a = isCallable$c;
var aFunction = function(argument) {
  return isCallable$a(argument) ? argument : void 0;
};
var getBuiltIn$5 = function(namespace, method) {
  return arguments.length < 2 ? aFunction(global$9[namespace]) : global$9[namespace] && global$9[namespace][method];
};
var uncurryThis$8 = functionUncurryThis;
var objectIsPrototypeOf = uncurryThis$8({}.isPrototypeOf);
var getBuiltIn$4 = getBuiltIn$5;
var engineUserAgent = getBuiltIn$4("navigator", "userAgent") || "";
var global$8 = global$a;
var userAgent = engineUserAgent;
var process$1 = global$8.process;
var Deno = global$8.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
  match = v8.split(".");
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}
var engineV8Version = version;
var V8_VERSION = engineV8Version;
var fails$5 = fails$9;
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$5(function() {
  var symbol = /* @__PURE__ */ Symbol();
  return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var useSymbolAsUid = NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var getBuiltIn$3 = getBuiltIn$5;
var isCallable$9 = isCallable$c;
var isPrototypeOf = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;
var $Object$2 = Object;
var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function(it) {
  return typeof it == "symbol";
} : function(it) {
  var $Symbol = getBuiltIn$3("Symbol");
  return isCallable$9($Symbol) && isPrototypeOf($Symbol.prototype, $Object$2(it));
};
var $String$1 = String;
var tryToString$1 = function(argument) {
  try {
    return $String$1(argument);
  } catch (error) {
    return "Object";
  }
};
var isCallable$8 = isCallable$c;
var tryToString = tryToString$1;
var $TypeError$4 = TypeError;
var aCallable$2 = function(argument) {
  if (isCallable$8(argument)) return argument;
  throw $TypeError$4(tryToString(argument) + " is not a function");
};
var aCallable$1 = aCallable$2;
var isNullOrUndefined$3 = isNullOrUndefined$2;
var getMethod$1 = function(V, P) {
  var func2 = V[P];
  return isNullOrUndefined$3(func2) ? void 0 : aCallable$1(func2);
};
var call$2 = functionCall;
var isCallable$7 = isCallable$c;
var isObject$5 = isObject$6;
var $TypeError$3 = TypeError;
var ordinaryToPrimitive$1 = function(input, pref) {
  var fn, val;
  if (pref === "string" && isCallable$7(fn = input.toString) && !isObject$5(val = call$2(fn, input))) return val;
  if (isCallable$7(fn = input.valueOf) && !isObject$5(val = call$2(fn, input))) return val;
  if (pref !== "string" && isCallable$7(fn = input.toString) && !isObject$5(val = call$2(fn, input))) return val;
  throw $TypeError$3("Can't convert object to primitive value");
};
var shared$3 = { exports: {} };
var global$7 = global$a;
var defineProperty$2$1 = Object.defineProperty;
var defineGlobalProperty$3 = function(key, value) {
  try {
    defineProperty$2$1(global$7, key, { value, configurable: true, writable: true });
  } catch (error) {
    global$7[key] = value;
  }
  return value;
};
var global$6 = global$a;
var defineGlobalProperty$2 = defineGlobalProperty$3;
var SHARED = "__core-js_shared__";
var store$3 = global$6[SHARED] || defineGlobalProperty$2(SHARED, {});
var sharedStore = store$3;
var store$2 = sharedStore;
(shared$3.exports = function(key, value) {
  return store$2[key] || (store$2[key] = value !== void 0 ? value : {});
})("versions", []).push({
  version: "3.25.5",
  mode: "global",
  copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var requireObjectCoercible = requireObjectCoercible$2;
var $Object$1 = Object;
var toObject$2 = function(argument) {
  return $Object$1(requireObjectCoercible(argument));
};
var uncurryThis$7 = functionUncurryThis;
var toObject$1 = toObject$2;
var hasOwnProperty$a = uncurryThis$7({}.hasOwnProperty);
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty$a(toObject$1(it), key);
};
var uncurryThis$6 = functionUncurryThis;
var id = 0;
var postfix = Math.random();
var toString$3 = uncurryThis$6(1 .toString);
var uid$2 = function(key) {
  return "Symbol(" + (key === void 0 ? "" : key) + ")_" + toString$3(++id + postfix, 36);
};
var global$5 = global$a;
var shared$2 = shared$3.exports;
var hasOwn$6 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;
var WellKnownSymbolsStore = shared$2("wks");
var Symbol$1 = global$5.Symbol;
var symbolFor = Symbol$1 && Symbol$1["for"];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;
var wellKnownSymbol$5 = function(name) {
  if (!hasOwn$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == "string")) {
    var description = "Symbol." + name;
    if (NATIVE_SYMBOL && hasOwn$6(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  }
  return WellKnownSymbolsStore[name];
};
var call$1 = functionCall;
var isObject$4 = isObject$6;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$4 = wellKnownSymbol$5;
var $TypeError$2 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$4("toPrimitive");
var toPrimitive$1 = function(input, pref) {
  if (!isObject$4(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === void 0) pref = "default";
    result = call$1(exoticToPrim, input, pref);
    if (!isObject$4(result) || isSymbol$1(result)) return result;
    throw $TypeError$2("Can't convert object to primitive value");
  }
  if (pref === void 0) pref = "number";
  return ordinaryToPrimitive(input, pref);
};
var toPrimitive = toPrimitive$1;
var isSymbol$3 = isSymbol$2;
var toPropertyKey$2 = function(argument) {
  var key = toPrimitive(argument, "string");
  return isSymbol$3(key) ? key : key + "";
};
var global$4 = global$a;
var isObject$3 = isObject$6;
var document$1 = global$4.document;
var EXISTS$1 = isObject$3(document$1) && isObject$3(document$1.createElement);
var documentCreateElement$1 = function(it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};
var DESCRIPTORS$7 = descriptors;
var fails$4 = fails$9;
var createElement$1 = documentCreateElement$1;
var ie8DomDefine = !DESCRIPTORS$7 && !fails$4(function() {
  return Object.defineProperty(createElement$1("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
});
var DESCRIPTORS$6 = descriptors;
var call = functionCall;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$3 = toIndexedObject$4;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$5 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) {
  }
  if (hasOwn$5(O, P)) return createPropertyDescriptor$1(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};
var objectDefineProperty = {};
var DESCRIPTORS$5 = descriptors;
var fails$3 = fails$9;
var v8PrototypeDefineBug = DESCRIPTORS$5 && fails$3(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: false
  }).prototype != 42;
});
var isObject$2 = isObject$6;
var $String = String;
var $TypeError$1 = TypeError;
var anObject$4 = function(argument) {
  if (isObject$2(argument)) return argument;
  throw $TypeError$1($String(argument) + " is not an object");
};
var DESCRIPTORS$4 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$3 = anObject$4;
var toPropertyKey = toPropertyKey$2;
var $TypeError = TypeError;
var $defineProperty = Object.defineProperty;
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = "enumerable";
var CONFIGURABLE$1 = "configurable";
var WRITABLE = "writable";
objectDefineProperty.f = DESCRIPTORS$4 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$3(O);
  P = toPropertyKey(P);
  anObject$3(Attributes);
  if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  }
  return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty2(O, P, Attributes) {
  anObject$3(O);
  P = toPropertyKey(P);
  anObject$3(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) {
  }
  if ("get" in Attributes || "set" in Attributes) throw $TypeError("Accessors not supported");
  if ("value" in Attributes) O[P] = Attributes.value;
  return O;
};
var DESCRIPTORS$3 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;
var createNonEnumerableProperty$2 = DESCRIPTORS$3 ? function(object2, key, value) {
  return definePropertyModule$3.f(object2, key, createPropertyDescriptor(1, value));
} : function(object2, key, value) {
  object2[key] = value;
  return object2;
};
var makeBuiltIn$2 = { exports: {} };
var DESCRIPTORS$2 = descriptors;
var hasOwn$4 = hasOwnProperty_1;
var FunctionPrototype = Function.prototype;
var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn$4(FunctionPrototype, "name");
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || DESCRIPTORS$2 && getDescriptor(FunctionPrototype, "name").configurable);
var functionName = {
  CONFIGURABLE
};
var uncurryThis$5 = functionUncurryThis;
var isCallable$6 = isCallable$c;
var store$1 = sharedStore;
var functionToString = uncurryThis$5(Function.toString);
if (!isCallable$6(store$1.inspectSource)) {
  store$1.inspectSource = function(it) {
    return functionToString(it);
  };
}
var inspectSource$2 = store$1.inspectSource;
var global$3 = global$a;
var isCallable$5 = isCallable$c;
var WeakMap$1 = global$3.WeakMap;
var weakMapBasicDetection = isCallable$5(WeakMap$1) && /native code/.test(String(WeakMap$1));
var shared$1 = shared$3.exports;
var uid = uid$2;
var keys$2 = shared$1("keys");
var sharedKey$2 = function(key) {
  return keys$2[key] || (keys$2[key] = uid(key));
};
var hiddenKeys$4 = {};
var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$2 = global$a;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$2;
var hasOwn$3 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$1 = sharedKey$2;
var hiddenKeys$3 = hiddenKeys$4;
var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var TypeError$1 = global$2.TypeError;
var WeakMap$2 = global$2.WeakMap;
var set, get$1, has;
var enforce = function(it) {
  return has(it) ? get$1(it) : set(it, {});
};
if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap$2());
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  set = function(it, metadata) {
    if (store.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get$1 = function(it) {
    return store.get(it) || {};
  };
  has = function(it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$1("state");
  hiddenKeys$3[STATE] = true;
  set = function(it, metadata) {
    if (hasOwn$3(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$1(it, STATE, metadata);
    return metadata;
  };
  get$1 = function(it) {
    return hasOwn$3(it, STATE) ? it[STATE] : {};
  };
  has = function(it) {
    return hasOwn$3(it, STATE);
  };
}
var internalState = {
  get: get$1,
  enforce
};
var fails$2 = fails$9;
var isCallable$4 = isCallable$c;
var hasOwn$2 = hasOwnProperty_1;
var DESCRIPTORS$1 = descriptors;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var inspectSource$1 = inspectSource$2;
var InternalStateModule = internalState;
var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var defineProperty$1$1 = Object.defineProperty;
var CONFIGURABLE_LENGTH = DESCRIPTORS$1 && !fails$2(function() {
  return defineProperty$1$1(function() {
  }, "length", { value: 8 }).length !== 8;
});
var TEMPLATE = String(String).split("String");
var makeBuiltIn$1 = makeBuiltIn$2.exports = function(value, name, options) {
  if (String(name).slice(0, 7) === "Symbol(") {
    name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
  }
  if (options && options.getter) name = "get " + name;
  if (options && options.setter) name = "set " + name;
  if (!hasOwn$2(value, "name") || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
    if (DESCRIPTORS$1) defineProperty$1$1(value, "name", { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$2(options, "arity") && value.length !== options.arity) {
    defineProperty$1$1(value, "length", { value: options.arity });
  }
  try {
    if (options && hasOwn$2(options, "constructor") && options.constructor) {
      if (DESCRIPTORS$1) defineProperty$1$1(value, "prototype", { writable: false });
    } else if (value.prototype) value.prototype = void 0;
  } catch (error) {
  }
  var state = enforceInternalState(value);
  if (!hasOwn$2(state, "source")) {
    state.source = TEMPLATE.join(typeof name == "string" ? name : "");
  }
  return value;
};
Function.prototype.toString = makeBuiltIn$1(function toString2() {
  return isCallable$4(this) && getInternalState(this).source || inspectSource$1(this);
}, "toString");
var isCallable$3 = isCallable$c;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;
var defineBuiltIn$1 = function(O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== void 0 ? options.name : key;
  if (isCallable$3(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) {
    }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  }
  return O;
};
var objectGetOwnPropertyNames = {};
var ceil = Math.ceil;
var floor = Math.floor;
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};
var trunc2 = mathTrunc;
var toIntegerOrInfinity$2 = function(argument) {
  var number2 = +argument;
  return number2 !== number2 || number2 === 0 ? 0 : trunc2(number2);
};
var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;
var max$1 = Math.max;
var min$1 = Math.min;
var toAbsoluteIndex$1 = function(index2, length) {
  var integer = toIntegerOrInfinity$1(index2);
  return integer < 0 ? max$1(integer + length, 0) : min$1(integer, length);
};
var toIntegerOrInfinity = toIntegerOrInfinity$2;
var min$2 = Math.min;
var toLength$1 = function(argument) {
  return argument > 0 ? min$2(toIntegerOrInfinity(argument), 9007199254740991) : 0;
};
var toLength = toLength$1;
var lengthOfArrayLike$2 = function(obj) {
  return toLength(obj.length);
};
var toIndexedObject$2 = toIndexedObject$4;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$2;
var createMethod$1 = function(IS_INCLUDES) {
  return function($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = lengthOfArrayLike$1(O);
    var index2 = toAbsoluteIndex(fromIndex, length);
    var value;
    if (IS_INCLUDES && el != el) while (length > index2) {
      value = O[index2++];
      if (value != value) return true;
    }
    else for (; length > index2; index2++) {
      if ((IS_INCLUDES || index2 in O) && O[index2] === el) return IS_INCLUDES || index2 || 0;
    }
    return !IS_INCLUDES && -1;
  };
};
var arrayIncludes = {
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};
var uncurryThis$4 = functionUncurryThis;
var hasOwn$1 = hasOwnProperty_1;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;
var push$1 = uncurryThis$4([].push);
var objectKeysInternal = function(object2, names) {
  var O = toIndexedObject$1(object2);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$1(hiddenKeys$2, key) && hasOwn$1(O, key) && push$1(result, key);
  while (names.length > i) if (hasOwn$1(O, key = names[i++])) {
    ~indexOf(result, key) || push$1(result, key);
  }
  return result;
};
var enumBugKeys$3 = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
];
var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;
var hiddenKeys$1 = enumBugKeys$2.concat("length", "prototype");
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};
var objectGetOwnPropertySymbols = {};
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var getBuiltIn$2 = getBuiltIn$5;
var uncurryThis$3 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var anObject$2 = anObject$4;
var concat = uncurryThis$3([].concat);
var ownKeys$1 = getBuiltIn$2("Reflect", "ownKeys") || function ownKeys(it) {
  var keys3 = getOwnPropertyNamesModule.f(anObject$2(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys3, getOwnPropertySymbols(it)) : keys3;
};
var hasOwn2 = hasOwnProperty_1;
var ownKeys2 = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;
var copyConstructorProperties$1 = function(target, source, exceptions) {
  var keys3 = ownKeys2(source);
  var defineProperty4 = definePropertyModule$1.f;
  var getOwnPropertyDescriptor3 = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys3.length; i++) {
    var key = keys3[i];
    if (!hasOwn2(target, key) && !(exceptions && hasOwn2(exceptions, key))) {
      defineProperty4(target, key, getOwnPropertyDescriptor3(source, key));
    }
  }
};
var fails$1 = fails$9;
var isCallable$2 = isCallable$c;
var replacement = /#|\.prototype\./;
var isForced$1 = function(feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true : value == NATIVE ? false : isCallable$2(detection) ? fails$1(detection) : !!detection;
};
var normalize = isForced$1.normalize = function(string2) {
  return String(string2).replace(replacement, ".").toLowerCase();
};
var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = "N";
var POLYFILL = isForced$1.POLYFILL = "P";
var isForced_1 = isForced$1;
var global$1 = global$a;
var getOwnPropertyDescriptor2 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty = createNonEnumerableProperty$2;
var defineBuiltIn = defineBuiltIn$1;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;
var _export = function(options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$1;
  } else if (STATIC) {
    target = global$1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor2(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
    if (!FORCED && targetProperty !== void 0) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    if (options.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty(sourceProperty, "sham", true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};
var uncurryThis$2 = functionUncurryThis;
var aCallable = aCallable$2;
var NATIVE_BIND = functionBindNative;
var bind$1 = uncurryThis$2(uncurryThis$2.bind);
var functionBindContext = function(fn, that) {
  aCallable(fn);
  return that === void 0 ? fn : NATIVE_BIND ? bind$1(fn, that) : function() {
    return fn.apply(that, arguments);
  };
};
var classof$2 = classofRaw$2;
var isArray$1$1 = Array.isArray || function isArray(argument) {
  return classof$2(argument) == "Array";
};
var wellKnownSymbol$3 = wellKnownSymbol$5;
var TO_STRING_TAG$1 = wellKnownSymbol$3("toStringTag");
var test = {};
test[TO_STRING_TAG$1] = "z";
var toStringTagSupport = String(test) === "[object z]";
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$1 = isCallable$c;
var classofRaw = classofRaw$2;
var wellKnownSymbol$2 = wellKnownSymbol$5;
var TO_STRING_TAG = wellKnownSymbol$2("toStringTag");
var $Object = Object;
var CORRECT_ARGUMENTS = classofRaw(/* @__PURE__ */ (function() {
  return arguments;
})()) == "Arguments";
var tryGet = function(it, key) {
  try {
    return it[key];
  } catch (error) {
  }
};
var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
  var O, tag, result;
  return it === void 0 ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == "Object" && isCallable$1(O.callee) ? "Arguments" : result;
};
var uncurryThis$1 = functionUncurryThis;
var fails = fails$9;
var isCallable = isCallable$c;
var classof = classof$1;
var getBuiltIn$1 = getBuiltIn$5;
var inspectSource = inspectSource$2;
var noop = function() {
};
var empty = [];
var construct = getBuiltIn$1("Reflect", "construct");
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$1(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};
var isConstructorLegacy = function isConstructor2(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return false;
  }
  try {
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};
isConstructorLegacy.sham = true;
var isConstructor$1 = !construct || fails(function() {
  var called;
  return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
    called = true;
  }) || called;
}) ? isConstructorLegacy : isConstructorModern;
var isArray$2 = isArray$1$1;
var isConstructor3 = isConstructor$1;
var isObject$7 = isObject$6;
var wellKnownSymbol$1 = wellKnownSymbol$5;
var SPECIES = wellKnownSymbol$1("species");
var $Array = Array;
var arraySpeciesConstructor$1 = function(originalArray) {
  var C;
  if (isArray$2(originalArray)) {
    C = originalArray.constructor;
    if (isConstructor3(C) && (C === $Array || isArray$2(C.prototype))) C = void 0;
    else if (isObject$7(C)) {
      C = C[SPECIES];
      if (C === null) C = void 0;
    }
  }
  return C === void 0 ? $Array : C;
};
var arraySpeciesConstructor = arraySpeciesConstructor$1;
var arraySpeciesCreate$1 = function(originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var bind = functionBindContext;
var uncurryThis = functionUncurryThis;
var IndexedObject = indexedObject;
var toObject = toObject$2;
var lengthOfArrayLike = lengthOfArrayLike$2;
var arraySpeciesCreate = arraySpeciesCreate$1;
var push = uncurryThis([].push);
var createMethod = function(TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self2 = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self2);
    var index2 = 0;
    var create3 = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create3($this, length) : IS_FILTER || IS_FILTER_REJECT ? create3($this, 0) : void 0;
    var value, result;
    for (; length > index2; index2++) if (NO_HOLES || index2 in self2) {
      value = self2[index2];
      result = boundFunction(value, index2, O);
      if (TYPE) {
        if (IS_MAP) target[index2] = result;
        else if (result) switch (TYPE) {
          case 3:
            return true;
          // some
          case 5:
            return value;
          // find
          case 6:
            return index2;
          // findIndex
          case 2:
            push(target, value);
        }
        else switch (TYPE) {
          case 4:
            return false;
          // every
          case 7:
            push(target, value);
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};
var arrayIteration = {
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5)
};
var objectDefineProperties = {};
var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};
var DESCRIPTORS = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$1 = anObject$4;
var toIndexedObject = toIndexedObject$4;
var objectKeys = objectKeys$1;
objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$1(O);
  var props = toIndexedObject(Properties);
  var keys3 = objectKeys(Properties);
  var length = keys3.length;
  var index2 = 0;
  var key;
  while (length > index2) definePropertyModule.f(O, key = keys3[index2++], props[key]);
  return O;
};
var getBuiltIn = getBuiltIn$5;
var html$1 = getBuiltIn("document", "documentElement");
var anObject = anObject$4;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement = documentCreateElement$1;
var sharedKey = sharedKey$2;
var GT = ">";
var LT = "<";
var PROTOTYPE = "prototype";
var SCRIPT = "script";
var IE_PROTO = sharedKey("IE_PROTO");
var EmptyConstructor = function() {
};
var scriptTag = function(content) {
  return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
};
var NullProtoObjectViaActiveX = function(activeXDocument2) {
  activeXDocument2.write(scriptTag(""));
  activeXDocument2.close();
  var temp = activeXDocument2.parentWindow.Object;
  activeXDocument2 = null;
  return temp;
};
var NullProtoObjectViaIFrame = function() {
  var iframe = documentCreateElement("iframe");
  var JS = "java" + SCRIPT + ":";
  var iframeDocument;
  iframe.style.display = "none";
  html.appendChild(iframe);
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag("document.F=Object"));
  iframeDocument.close();
  return iframeDocument.F;
};
var activeXDocument;
var NullProtoObject = function() {
  try {
    activeXDocument = new ActiveXObject("htmlfile");
  } catch (error) {
  }
  NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument);
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};
hiddenKeys[IE_PROTO] = true;
var objectCreate$1 = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === void 0 ? result : definePropertiesModule.f(result, Properties);
};
var wellKnownSymbol = wellKnownSymbol$5;
var create2 = objectCreate$1;
var defineProperty$4 = objectDefineProperty.f;
var UNSCOPABLES = wellKnownSymbol("unscopables");
var ArrayPrototype = Array.prototype;
if (ArrayPrototype[UNSCOPABLES] == void 0) {
  defineProperty$4(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create2(null)
  });
}
var addToUnscopables$1 = function(key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};
var $ = _export;
var $find = arrayIteration.find;
var addToUnscopables = addToUnscopables$1;
var FIND = "find";
var SKIPS_HOLES = true;
if (FIND in []) Array(1)[FIND](function() {
  SKIPS_HOLES = false;
});
$({ target: "Array", proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
  }
});
addToUnscopables(FIND);
var CONSTANT = {
  GLOBAL: {
    HIDE: "__react_tooltip_hide_event",
    REBUILD: "__react_tooltip_rebuild_event",
    SHOW: "__react_tooltip_show_event"
  }
};
var dispatchGlobalEvent = function dispatchGlobalEvent2(eventName, opts) {
  var event;
  if (typeof window.CustomEvent === "function") {
    event = new window.CustomEvent(eventName, {
      detail: opts
    });
  } else {
    event = document.createEvent("Event");
    event.initEvent(eventName, false, true, opts);
  }
  window.dispatchEvent(event);
};
function staticMethods(target) {
  target.hide = function(target2) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
      target: target2
    });
  };
  target.rebuild = function() {
    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
  };
  target.show = function(target2) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
      target: target2
    });
  };
  target.prototype.globalRebuild = function() {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };
  target.prototype.globalShow = function(event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.showTooltip({
        currentTarget: hasTarget && event.detail.target
      }, true);
    }
  };
  target.prototype.globalHide = function(event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.hideTooltip({
        currentTarget: hasTarget && event.detail.target
      }, hasTarget);
    }
  };
}
function windowListener(target) {
  target.prototype.bindWindowEvents = function(resizeHide) {
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false);
    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false);
    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false);
    if (resizeHide) {
      window.removeEventListener("resize", this.onWindowResize);
      window.addEventListener("resize", this.onWindowResize, false);
    }
  };
  target.prototype.unbindWindowEvents = function() {
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener("resize", this.onWindowResize);
  };
  target.prototype.onWindowResize = function() {
    if (!this.mount) return;
    this.hideTooltip();
  };
}
var checkStatus$1 = function checkStatus(dataEventOff, e) {
  var show2 = this.state.show;
  var id2 = this.props.id;
  var isCapture2 = this.isCapture(e.currentTarget);
  var currentItem = e.currentTarget.getAttribute("currentItem");
  if (!isCapture2) e.stopPropagation();
  if (show2 && currentItem === "true") {
    if (!dataEventOff) this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute("currentItem", "true");
    setUntargetItems(e.currentTarget, this.getTargetArray(id2));
    this.showTooltip(e);
  }
};
var setUntargetItems = function setUntargetItems2(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute("currentItem", "false");
    } else {
      targetArray[i].setAttribute("currentItem", "true");
    }
  }
};
var customListeners = {
  id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
  set: function set2(target, event, listener) {
    if (this.id in target) {
      var map = target[this.id];
      map[event] = listener;
    } else {
      Object.defineProperty(target, this.id, {
        configurable: true,
        value: _defineProperty$5({}, event, listener)
      });
    }
  },
  get: function get(target, event) {
    var map = target[this.id];
    if (map !== void 0) {
      return map[event];
    }
  }
};
function customEvent(target) {
  target.prototype.isCustomEvent = function(ele) {
    var event = this.state.event;
    return event || !!ele.getAttribute("data-event");
  };
  target.prototype.customBindListener = function(ele) {
    var _this = this;
    var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
    var dataEvent = ele.getAttribute("data-event") || event;
    var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
    dataEvent.split(" ").forEach(function(event2) {
      ele.removeEventListener(event2, customListeners.get(ele, event2));
      var customListener = checkStatus$1.bind(_this, dataEventOff);
      customListeners.set(ele, event2, customListener);
      ele.addEventListener(event2, customListener, false);
    });
    if (dataEventOff) {
      dataEventOff.split(" ").forEach(function(event2) {
        ele.removeEventListener(event2, _this.hideTooltip);
        ele.addEventListener(event2, _this.hideTooltip, false);
      });
    }
  };
  target.prototype.customUnbindListener = function(ele) {
    var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
    var dataEvent = event || ele.getAttribute("data-event");
    var dataEventOff = eventOff || ele.getAttribute("data-event-off");
    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
}
function isCapture(target) {
  target.prototype.isCapture = function(currentTarget) {
    return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
  };
}
function getEffect(target) {
  target.prototype.getEffect = function(currentTarget) {
    var dataEffect = currentTarget.getAttribute("data-effect");
    return dataEffect || this.props.effect || "float";
  };
}
var makeProxy = function makeProxy2(e) {
  var proxy = {};
  for (var key in e) {
    if (typeof e[key] === "function") {
      proxy[key] = e[key].bind(e);
    } else {
      proxy[key] = e[key];
    }
  }
  return proxy;
};
var bodyListener = function bodyListener2(callback, options, e) {
  var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, customEvent2 = _options$customEvent === void 0 ? false : _options$customEvent;
  var id2 = this.props.id;
  var tip = null;
  var forId;
  var target = e.target;
  var lastTarget;
  while (tip === null && target !== null) {
    lastTarget = target;
    tip = target.getAttribute("data-tip") || null;
    forId = target.getAttribute("data-for") || null;
    target = target.parentElement;
  }
  target = lastTarget || e.target;
  if (this.isCustomEvent(target) && !customEvent2) {
    return;
  }
  var isTargetBelongsToTooltip = id2 == null && forId == null || forId === id2;
  if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
    var proxy = makeProxy(e);
    proxy.currentTarget = target;
    callback(proxy);
  }
};
var findCustomEvents = function findCustomEvents2(targetArray, dataAttribute) {
  var events2 = {};
  targetArray.forEach(function(target) {
    var event = target.getAttribute(dataAttribute);
    if (event) event.split(" ").forEach(function(event2) {
      return events2[event2] = true;
    });
  });
  return events2;
};
var getBody = function getBody2() {
  return document.getElementsByTagName("body")[0];
};
function bodyMode(target) {
  target.prototype.isBodyMode = function() {
    return !!this.props.bodyMode;
  };
  target.prototype.bindBodyListener = function(targetArray) {
    var _this = this;
    var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
    var body = getBody();
    var customEvents = findCustomEvents(targetArray, "data-event");
    var customEventsOff = findCustomEvents(targetArray, "data-event-off");
    if (event != null) customEvents[event] = true;
    if (eventOff != null) customEventsOff[eventOff] = true;
    possibleCustomEvents.split(" ").forEach(function(event2) {
      return customEvents[event2] = true;
    });
    possibleCustomEventsOff.split(" ").forEach(function(event2) {
      return customEventsOff[event2] = true;
    });
    this.unbindBodyListener(body);
    var listeners = this.bodyModeListeners = {};
    if (event == null) {
      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
        respectEffect: true
      });
      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
    }
    for (var _event in customEvents) {
      listeners[_event] = bodyListener.bind(this, function(e) {
        var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
        checkStatus$1.call(_this, targetEventOff, e);
      }, {
        customEvent: true
      });
    }
    for (var _event2 in customEventsOff) {
      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
        customEvent: true
      });
    }
    for (var _event3 in listeners) {
      body.addEventListener(_event3, listeners[_event3]);
    }
  };
  target.prototype.unbindBodyListener = function(body) {
    body = body || getBody();
    var listeners = this.bodyModeListeners;
    for (var event in listeners) {
      body.removeEventListener(event, listeners[event]);
    }
  };
}
var getMutationObserverClass = function getMutationObserverClass2() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function trackRemoval(target) {
  target.prototype.bindRemovalTracker = function() {
    var _this = this;
    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null) return;
    var observer = new MutationObserver(function(mutations) {
      for (var m1 = 0; m1 < mutations.length; m1++) {
        var mutation = mutations[m1];
        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
          var element = mutation.removedNodes[m2];
          if (element === _this.state.currentTarget) {
            _this.hideTooltip();
            return;
          }
        }
      }
    });
    observer.observe(window.document, {
      childList: true,
      subtree: true
    });
    this.removalTracker = observer;
  };
  target.prototype.unbindRemovalTracker = function() {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
}
function getPosition(e, target, node, place, desiredPlace, effect, offset) {
  var _getDimensions = getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
  var _getDimensions2 = getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
  var _getCurrentOffset = getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
  var _calculateOffset = calculateOffset(offset), extraOffsetX = _calculateOffset.extraOffsetX, extraOffsetY = _calculateOffset.extraOffsetY;
  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;
  var _getParent = getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft;
  var getTipOffsetLeft = function getTipOffsetLeft2(place2) {
    var offsetX = defaultOffset[place2].l;
    return mouseX + offsetX + extraOffsetX;
  };
  var getTipOffsetRight = function getTipOffsetRight2(place2) {
    var offsetX = defaultOffset[place2].r;
    return mouseX + offsetX + extraOffsetX;
  };
  var getTipOffsetTop = function getTipOffsetTop2(place2) {
    var offsetY = defaultOffset[place2].t;
    return mouseY + offsetY + extraOffsetY;
  };
  var getTipOffsetBottom = function getTipOffsetBottom2(place2) {
    var offsetY = defaultOffset[place2].b;
    return mouseY + offsetY + extraOffsetY;
  };
  var outsideLeft = function outsideLeft2(p) {
    return getTipOffsetLeft(p) < 0;
  };
  var outsideRight = function outsideRight2(p) {
    return getTipOffsetRight(p) > windowWidth;
  };
  var outsideTop = function outsideTop2(p) {
    return getTipOffsetTop(p) < 0;
  };
  var outsideBottom = function outsideBottom2(p) {
    return getTipOffsetBottom(p) > windowHeight;
  };
  var outside = function outside2(p) {
    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
  };
  var inside = function inside2(p) {
    return !outside(p);
  };
  var placeIsInside = {
    top: inside("top"),
    bottom: inside("bottom"),
    left: inside("left"),
    right: inside("right")
  };
  function choose() {
    var allPlaces = desiredPlace.split(",").concat(place, ["top", "bottom", "left", "right"]);
    var _iterator = _createForOfIteratorHelper(allPlaces), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var d = _step.value;
        if (placeIsInside[d]) return d;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return place;
  }
  var chosen = choose();
  var isNewState = false;
  var newPlace;
  if (chosen && chosen !== place) {
    isNewState = true;
    newPlace = chosen;
  }
  if (isNewState) {
    return {
      isNewState: true,
      newState: {
        place: newPlace
      }
    };
  }
  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
}
var getDimensions = function getDimensions2(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
  return {
    height: parseInt(height, 10),
    width: parseInt(width, 10)
  };
};
var getCurrentOffset = function getCurrentOffset2(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;
  var _getDimensions3 = getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
  if (effect === "float") {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }
  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
};
var getDefaultPosition = function getDefaultPosition2(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top;
  var right;
  var bottom;
  var left;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12;
  if (effect === "float") {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === "solid") {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }
  return {
    top,
    bottom,
    left,
    right
  };
};
var calculateOffset = function calculateOffset2(offset) {
  var extraOffsetX = 0;
  var extraOffsetY = 0;
  if (Object.prototype.toString.apply(offset) === "[object String]") {
    offset = JSON.parse(offset.toString().replace(/'/g, '"'));
  }
  for (var key in offset) {
    if (key === "top") {
      extraOffsetY -= parseInt(offset[key], 10);
    } else if (key === "bottom") {
      extraOffsetY += parseInt(offset[key], 10);
    } else if (key === "left") {
      extraOffsetX -= parseInt(offset[key], 10);
    } else if (key === "right") {
      extraOffsetX += parseInt(offset[key], 10);
    }
  }
  return {
    extraOffsetX,
    extraOffsetY
  };
};
var getParent = function getParent2(currentTarget) {
  var currentParent = currentTarget;
  while (currentParent) {
    var computedStyle = window.getComputedStyle(currentParent);
    if (computedStyle.getPropertyValue("transform") !== "none" || computedStyle.getPropertyValue("will-change") === "transform") break;
    currentParent = currentParent.parentElement;
  }
  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
  return {
    parentTop,
    parentLeft
  };
};
function TipContent(tip, children, getContent, multiline) {
  if (children) return children;
  if (getContent !== void 0 && getContent !== null) return getContent;
  if (getContent === null) return null;
  var regexp = /<br\s*\/?>/;
  if (!multiline || multiline === "false" || !regexp.test(tip)) {
    return tip;
  }
  return tip.split(regexp).map(function(d, i) {
    return /* @__PURE__ */ React__default.createElement("span", {
      key: i,
      className: "multi-line"
    }, d);
  });
}
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function(prop) {
    return /(^aria-\w+$|^role$)/.test(prop);
  }).forEach(function(prop) {
    ariaObj[prop] = props[prop];
  });
  return ariaObj;
}
function nodeListToArray(nodeList) {
  var length = nodeList.length;
  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }
  return new Array(length).fill().map(function(index2) {
    return nodeList[index2];
  });
}
function generateUUID() {
  return "t" + v4();
}
var baseCss = '.__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: "";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  bottom: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-bottom::before {\n  top: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-left::before {\n  right: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip.place-right::before {\n  left: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}';
var defaultColors = {
  dark: {
    text: "#fff",
    background: "#222",
    border: "transparent",
    arrow: "#222"
  },
  success: {
    text: "#fff",
    background: "#8DC572",
    border: "transparent",
    arrow: "#8DC572"
  },
  warning: {
    text: "#fff",
    background: "#F0AD4E",
    border: "transparent",
    arrow: "#F0AD4E"
  },
  error: {
    text: "#fff",
    background: "#BE6464",
    border: "transparent",
    arrow: "#BE6464"
  },
  info: {
    text: "#fff",
    background: "#337AB7",
    border: "transparent",
    arrow: "#337AB7"
  },
  light: {
    text: "#222",
    background: "#fff",
    border: "transparent",
    arrow: "#fff"
  }
};
function getDefaultPopupColors(type) {
  return defaultColors[type] ? _objectSpread2({}, defaultColors[type]) : void 0;
}
var DEFAULT_PADDING = "8px 21px";
var DEFAULT_RADIUS = {
  tooltip: 3,
  arrow: 0
};
function generateTooltipStyle(uuid, customColors, type, hasBorder, padding, radius) {
  return generateStyle(uuid, getPopupColors(customColors, type, hasBorder), padding, radius);
}
function generateStyle(uuid, colors) {
  var padding = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : DEFAULT_PADDING;
  var radius = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : DEFAULT_RADIUS;
  var textColor = colors.text;
  var backgroundColor = colors.background;
  var borderColor = colors.border;
  var arrowColor = colors.arrow;
  var arrowRadius = radius.arrow;
  var tooltipRadius = radius.tooltip;
  return "\n  	.".concat(uuid, " {\n	    color: ").concat(textColor, ";\n	    background: ").concat(backgroundColor, ";\n	    border: 1px solid ").concat(borderColor, ";\n	    border-radius: ").concat(tooltipRadius, "px;\n	    padding: ").concat(padding, ";\n  	}\n\n  	.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, '.place-top::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 20px;\n        height: 12px;\n    }\n    .').concat(uuid, '.place-top::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(135deg);\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, '.place-bottom::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 18px;\n        height: 10px;\n    }\n    .').concat(uuid, '.place-bottom::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        top: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, '.place-left::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .').concat(uuid, '.place-left::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        right: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, '.place-right::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .').concat(uuid, '.place-right::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        left: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(-135deg);\n    }\n  ");
}
function getPopupColors(customColors, type, hasBorder) {
  var textColor = customColors.text;
  var backgroundColor = customColors.background;
  var borderColor = customColors.border;
  var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
  var colors = getDefaultPopupColors(type);
  if (textColor) {
    colors.text = textColor;
  }
  if (backgroundColor) {
    colors.background = backgroundColor;
  }
  if (hasBorder) {
    if (borderColor) {
      colors.border = borderColor;
    } else {
      colors.border = type === "light" ? "black" : "white";
    }
  }
  if (arrowColor) {
    colors.arrow = arrowColor;
  }
  return colors;
}
var _class, _class2;
var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_class2 = /* @__PURE__ */ (function(_React$Component) {
  _inherits$8(ReactTooltip2, _React$Component);
  var _super = _createSuper(ReactTooltip2);
  function ReactTooltip2(props) {
    var _this;
    _classCallCheck$8(this, ReactTooltip2);
    _this = _super.call(this, props);
    _this.state = {
      uuid: props.uuid || generateUUID(),
      place: props.place || "top",
      // Direction of tooltip
      desiredPlace: props.place || "top",
      type: props.type || "dark",
      // Color theme of tooltip
      effect: props.effect || "float",
      // float or fixed
      show: false,
      border: false,
      borderClass: "border",
      customColors: {},
      customRadius: {},
      offset: {},
      padding: props.padding,
      extraClass: "",
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null,
      // Current mouse event
      currentTarget: null,
      // Current target of mouse event
      ariaProps: parseAria(props),
      // aria- and role attributes
      isEmptyTip: false,
      disable: false,
      possibleCustomEvents: props.possibleCustomEvents || "",
      possibleCustomEventsOff: props.possibleCustomEventsOff || "",
      originTooltip: null,
      isMultiline: false
    };
    _this.bind(["showTooltip", "updateTooltip", "hideTooltip", "hideTooltipOnScroll", "getTooltipContent", "globalRebuild", "globalShow", "globalHide", "onWindowResize", "mouseOnToolTip"]);
    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.delayReshow = null;
    _this.intervalUpdateContent = null;
    return _this;
  }
  _createClass$6(ReactTooltip2, [{
    key: "bind",
    value: function bind2(methodArray) {
      var _this2 = this;
      methodArray.forEach(function(method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props;
      _this$props.insecure;
      var resizeHide = _this$props.resizeHide, disableInternalStyle = _this$props.disableInternalStyle;
      this.mount = true;
      this.bindListener();
      this.bindWindowEvents(resizeHide);
      if (!disableInternalStyle) {
        this.injectStyles();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mount = false;
      this.clearTimer();
      this.unbindListener();
      this.removeScrollListener(this.state.currentTarget);
      this.unbindWindowEvents();
    }
    /* Look for the closest DOM root having tooltip and inject styles. */
  }, {
    key: "injectStyles",
    value: function injectStyles() {
      var tooltipRef = this.tooltipRef;
      if (!tooltipRef) {
        return;
      }
      var parentNode = tooltipRef.parentNode;
      while (parentNode.parentNode) {
        parentNode = parentNode.parentNode;
      }
      var domRoot;
      switch (parentNode.constructor.name) {
        case "Document":
        case "HTMLDocument":
        case void 0:
          domRoot = parentNode.head;
          break;
        case "ShadowRoot":
        default:
          domRoot = parentNode;
          break;
      }
      if (!domRoot.querySelector("style[data-react-tooltip]")) {
        var style = document.createElement("style");
        style.textContent = baseCss;
        style.setAttribute("data-react-tooltip", "true");
        domRoot.appendChild(style);
      }
    }
    /**
     * Return if the mouse is on the tooltip.
     * @returns {boolean} true - mouse is on the tooltip
     */
  }, {
    key: "mouseOnToolTip",
    value: function mouseOnToolTip() {
      var show2 = this.state.show;
      if (show2 && this.tooltipRef) {
        if (!this.tooltipRef.matches) {
          if (this.tooltipRef.msMatchesSelector) {
            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
          } else {
            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
          }
        }
        return this.tooltipRef.matches(":hover");
      }
      return false;
    }
    /**
     * Pick out corresponded target elements
     */
  }, {
    key: "getTargetArray",
    value: function getTargetArray(id2) {
      var targetArray = [];
      var selector;
      if (!id2) {
        selector = "[data-tip]:not([data-for])";
      } else {
        var escaped = id2.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        selector = '[data-tip][data-for="'.concat(escaped, '"]');
      }
      nodeListToArray(document.getElementsByTagName("*")).filter(function(element) {
        return element.shadowRoot;
      }).forEach(function(element) {
        targetArray = targetArray.concat(nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
      });
      return targetArray.concat(nodeListToArray(document.querySelectorAll(selector)));
    }
    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */
  }, {
    key: "bindListener",
    value: function bindListener() {
      var _this3 = this;
      var _this$props2 = this.props, id2 = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture2 = _this$props2.isCapture;
      var targetArray = this.getTargetArray(id2);
      targetArray.forEach(function(target) {
        if (target.getAttribute("currentItem") === null) {
          target.setAttribute("currentItem", "false");
        }
        _this3.unbindBasicListener(target);
        if (_this3.isCustomEvent(target)) {
          _this3.customUnbindListener(target);
        }
      });
      if (this.isBodyMode()) {
        this.bindBodyListener(targetArray);
      } else {
        targetArray.forEach(function(target) {
          var isCaptureMode = _this3.isCapture(target);
          var effect = _this3.getEffect(target);
          if (_this3.isCustomEvent(target)) {
            _this3.customBindListener(target);
            return;
          }
          target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
          target.addEventListener("focus", _this3.showTooltip, isCaptureMode);
          if (effect === "float") {
            target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
          }
          target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
          target.addEventListener("blur", _this3.hideTooltip, isCaptureMode);
        });
      }
      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, isCapture2);
      }
      this.bindRemovalTracker();
    }
    /**
     * Unbind listeners on target elements
     */
  }, {
    key: "unbindListener",
    value: function unbindListener() {
      var _this4 = this;
      var _this$props3 = this.props, id2 = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
      if (this.isBodyMode()) {
        this.unbindBodyListener();
      } else {
        var targetArray = this.getTargetArray(id2);
        targetArray.forEach(function(target) {
          _this4.unbindBasicListener(target);
          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
        });
      }
      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }
    /**
     * Invoke this before bind listener and unmount the component
     * it is necessary to invoke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */
  }, {
    key: "unbindBasicListener",
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
      target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
      target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
    }
  }, {
    key: "getTooltipContent",
    value: function getTooltipContent() {
      var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children;
      var content;
      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0](this.state.originTooltip);
        } else {
          content = getContent(this.state.originTooltip);
        }
      }
      return TipContent(this.state.originTooltip, children, content, this.state.isMultiline);
    }
  }, {
    key: "isEmptyTip",
    value: function isEmptyTip(placeholder) {
      return typeof placeholder === "string" && placeholder === "" || placeholder === null;
    }
    /**
     * When mouse enter, show the tooltip
     */
  }, {
    key: "showTooltip",
    value: function showTooltip(e, isGlobalCall) {
      if (!this.tooltipRef) {
        return;
      }
      if (isGlobalCall) {
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function(ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement) return;
      }
      var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
      var originTooltip = e.currentTarget.getAttribute("data-tip");
      var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false;
      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
      var scrollHide = true;
      if (e.currentTarget.getAttribute("data-scroll-hide")) {
        scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      }
      if (e && e.currentTarget && e.currentTarget.setAttribute) {
        e.currentTarget.setAttribute("aria-describedby", this.props.id || this.state.uuid);
      }
      var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
      var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
      var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
      var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace.split(",")[0], desiredPlace, effect, offset);
      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
      }
      var place = result.isNewState ? result.newState.place : desiredPlace.split(",")[0];
      this.clearTimer();
      var target = e.currentTarget;
      var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
      var self2 = this;
      var updateState = function updateState2() {
        self2.setState({
          originTooltip,
          isMultiline,
          desiredPlace,
          place,
          type: target.getAttribute("data-type") || self2.props.type || "dark",
          customColors: {
            text: target.getAttribute("data-text-color") || self2.props.textColor || null,
            background: target.getAttribute("data-background-color") || self2.props.backgroundColor || null,
            border: target.getAttribute("data-border-color") || self2.props.borderColor || null,
            arrow: target.getAttribute("data-arrow-color") || self2.props.arrowColor || null
          },
          customRadius: {
            tooltip: target.getAttribute("data-tooltip-radius") || self2.props.tooltipRadius || "3",
            arrow: target.getAttribute("data-arrow-radius") || self2.props.arrowRadius || "0"
          },
          effect,
          offset,
          padding: target.getAttribute("data-padding") || self2.props.padding,
          html: (target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self2.props.html) || false,
          delayShow: target.getAttribute("data-delay-show") || self2.props.delayShow || 0,
          delayHide: target.getAttribute("data-delay-hide") || self2.props.delayHide || 0,
          delayUpdate: target.getAttribute("data-delay-update") || self2.props.delayUpdate || 0,
          border: (target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self2.props.border) || false,
          borderClass: target.getAttribute("data-border-class") || self2.props.borderClass || "border",
          extraClass: target.getAttribute("data-class") || self2.props["class"] || self2.props.className || "",
          disable: (target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self2.props.disable) || false,
          currentTarget: target
        }, function() {
          if (scrollHide) {
            self2.addScrollListener(self2.state.currentTarget);
          }
          self2.updateTooltip(e);
          if (getContent && Array.isArray(getContent)) {
            self2.intervalUpdateContent = setInterval(function() {
              if (self2.mount) {
                var _getContent = self2.props.getContent;
                var placeholder = TipContent(originTooltip, "", _getContent[0](), isMultiline);
                var isEmptyTip = self2.isEmptyTip(placeholder);
                self2.setState({
                  isEmptyTip
                });
                self2.updatePosition();
              }
            }, getContent[1]);
          }
        });
      };
      if (reshowDelay) {
        this.delayReshow = setTimeout(updateState, reshowDelay);
      } else {
        updateState();
      }
    }
    /**
     * When mouse hover, update tool tip
     */
  }, {
    key: "updateTooltip",
    value: function updateTooltip(e) {
      var _this5 = this;
      var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
      var _this$props6 = this.props, afterShow = _this$props6.afterShow, disableProp = _this$props6.disable;
      var placeholder = this.getTooltipContent();
      var eventTarget = e.currentTarget || e.target;
      if (this.mouseOnToolTip()) {
        return;
      }
      if (this.isEmptyTip(placeholder) || disable || disableProp) {
        return;
      }
      var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
      var updateState = function updateState2() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          var isInvisible = !_this5.state.show;
          _this5.setState({
            currentEvent: e,
            currentTarget: eventTarget,
            show: true
          }, function() {
            _this5.updatePosition(function() {
              if (isInvisible && afterShow) {
                afterShow(e);
              }
            });
          });
        }
      };
      if (this.delayShowLoop) {
        clearTimeout(this.delayShowLoop);
      }
      if (delayTime) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        this.delayShowLoop = null;
        updateState();
      }
    }
    /*
     * If we're mousing over the tooltip remove it when we leave.
     */
  }, {
    key: "listenForTooltipExit",
    value: function listenForTooltipExit() {
      var show2 = this.state.show;
      if (show2 && this.tooltipRef) {
        this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
      }
    }
  }, {
    key: "removeListenerForTooltipExit",
    value: function removeListenerForTooltipExit() {
      var show2 = this.state.show;
      if (show2 && this.tooltipRef) {
        this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
      }
    }
    /**
     * When mouse leave, hide tooltip
     */
  }, {
    key: "hideTooltip",
    value: function hideTooltip(e, hasTarget) {
      var _this6 = this;
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        isScroll: false
      };
      var disable = this.state.disable;
      var isScroll = options.isScroll;
      var delayHide = isScroll ? 0 : this.state.delayHide;
      var _this$props7 = this.props, afterHide = _this$props7.afterHide, disableProp = _this$props7.disable;
      var placeholder = this.getTooltipContent();
      if (!this.mount) return;
      if (this.isEmptyTip(placeholder) || disable || disableProp) return;
      if (hasTarget) {
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function(ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show) return;
      }
      if (e && e.currentTarget && e.currentTarget.removeAttribute) {
        e.currentTarget.removeAttribute("aria-describedby");
      }
      var resetState = function resetState2() {
        var isVisible = _this6.state.show;
        if (_this6.mouseOnToolTip()) {
          _this6.listenForTooltipExit();
          return;
        }
        _this6.removeListenerForTooltipExit();
        _this6.setState({
          show: false
        }, function() {
          _this6.removeScrollListener(_this6.state.currentTarget);
          if (isVisible && afterHide) {
            afterHide(e);
          }
        });
      };
      this.clearTimer();
      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }
    /**
     * When scroll, hide tooltip
     */
  }, {
    key: "hideTooltipOnScroll",
    value: function hideTooltipOnScroll(event, hasTarget) {
      this.hideTooltip(event, hasTarget, {
        isScroll: true
      });
    }
    /**
     * Add scroll event listener when tooltip show
     * automatically hide the tooltip when scrolling
     */
  }, {
    key: "addScrollListener",
    value: function addScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
    }
  }, {
    key: "removeScrollListener",
    value: function removeScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.removeEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
    }
    // Calculation the position
  }, {
    key: "updatePosition",
    value: function updatePosition(callbackAfter) {
      var _this7 = this;
      var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
      var node = this.tooltipRef;
      var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
      }
      if (result.isNewState) {
        return this.setState(result.newState, function() {
          _this7.updatePosition(callbackAfter);
        });
      }
      if (callbackAfter && typeof callbackAfter === "function") {
        callbackAfter();
      }
      node.style.left = result.position.left + "px";
      node.style.top = result.position.top + "px";
    }
    /**
     * CLear all kinds of timeout of interval
     */
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      if (this.delayShowLoop) {
        clearTimeout(this.delayShowLoop);
        this.delayShowLoop = null;
      }
      if (this.delayHideLoop) {
        clearTimeout(this.delayHideLoop);
        this.delayHideLoop = null;
      }
      if (this.delayReshow) {
        clearTimeout(this.delayReshow);
        this.delayReshow = null;
      }
      if (this.intervalUpdateContent) {
        clearInterval(this.intervalUpdateContent);
        this.intervalUpdateContent = null;
      }
    }
  }, {
    key: "hasCustomColors",
    value: function hasCustomColors() {
      var _this8 = this;
      return Boolean(Object.keys(this.state.customColors).find(function(color) {
        return color !== "border" && _this8.state.customColors[color];
      }) || this.state.border && this.state.customColors["border"]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;
      var _this$state3 = this.state, extraClass = _this$state3.extraClass, html2 = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable, uuid = _this$state3.uuid;
      var content = this.getTooltipContent();
      var isEmptyTip = this.isEmptyTip(content);
      var style = this.props.disableInternalStyle ? "" : generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border, this.state.padding, this.state.customRadius);
      var tooltipClass = "__react_component_tooltip" + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " " + this.state.borderClass : "") + " place-".concat(this.state.place) + // top, bottom, left, right
      " type-".concat(this.hasCustomColors() ? "custom" : this.state.type) + // dark, success, warning, error, info, light, custom
      (this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
      var Wrapper = this.props.wrapper;
      if (ReactTooltip2.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip2.defaultProps.wrapper;
      }
      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(" ");
      if (html2) {
        var htmlContent = "".concat(content).concat(style ? '\n<style aria-hidden="true">'.concat(style, "</style>") : "");
        return /* @__PURE__ */ React__default.createElement(Wrapper, _extends$c({
          className: "".concat(wrapperClassName),
          id: this.props.id || uuid,
          ref: function ref(_ref) {
            return _this9.tooltipRef = _ref;
          }
        }, ariaProps, {
          "data-id": "tooltip",
          dangerouslySetInnerHTML: {
            __html: htmlContent
          }
        }));
      } else {
        return /* @__PURE__ */ React__default.createElement(Wrapper, _extends$c({
          className: "".concat(wrapperClassName),
          id: this.props.id || uuid
        }, ariaProps, {
          ref: function ref(_ref2) {
            return _this9.tooltipRef = _ref2;
          },
          "data-id": "tooltip"
        }), style && /* @__PURE__ */ React__default.createElement("style", {
          dangerouslySetInnerHTML: {
            __html: style
          },
          "aria-hidden": "true"
        }), content);
      }
    }
  }], [{
    key: "propTypes",
    get: function get3() {
      return {
        uuid: PropTypes.string,
        children: PropTypes.any,
        place: PropTypes.string,
        type: PropTypes.string,
        effect: PropTypes.string,
        offset: PropTypes.object,
        padding: PropTypes.string,
        multiline: PropTypes.bool,
        border: PropTypes.bool,
        borderClass: PropTypes.string,
        textColor: PropTypes.string,
        backgroundColor: PropTypes.string,
        borderColor: PropTypes.string,
        arrowColor: PropTypes.string,
        arrowRadius: PropTypes.string,
        tooltipRadius: PropTypes.string,
        insecure: PropTypes.bool,
        "class": PropTypes.string,
        className: PropTypes.string,
        id: PropTypes.string,
        html: PropTypes.bool,
        delayHide: PropTypes.number,
        delayUpdate: PropTypes.number,
        delayShow: PropTypes.number,
        event: PropTypes.string,
        eventOff: PropTypes.string,
        isCapture: PropTypes.bool,
        globalEventOff: PropTypes.string,
        getContent: PropTypes.any,
        afterShow: PropTypes.func,
        afterHide: PropTypes.func,
        overridePosition: PropTypes.func,
        disable: PropTypes.bool,
        scrollHide: PropTypes.bool,
        resizeHide: PropTypes.bool,
        wrapper: PropTypes.string,
        bodyMode: PropTypes.bool,
        possibleCustomEvents: PropTypes.string,
        possibleCustomEventsOff: PropTypes.string,
        clickable: PropTypes.bool,
        disableInternalStyle: PropTypes.bool
      };
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var ariaProps = prevState.ariaProps;
      var newAriaProps = parseAria(nextProps);
      var isChanged = Object.keys(newAriaProps).some(function(props) {
        return newAriaProps[props] !== ariaProps[props];
      });
      if (!isChanged) {
        return null;
      }
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        ariaProps: newAriaProps
      });
    }
  }]);
  return ReactTooltip2;
})(React__default.Component), _defineProperty$5(_class2, "defaultProps", {
  insecure: true,
  resizeHide: true,
  wrapper: "div",
  clickable: false
}), _defineProperty$5(_class2, "supportedWrappers", ["div", "span"]), _defineProperty$5(_class2, "displayName", "ReactTooltip"), _class2)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;
const allLocaleData = {};
var hop$1 = Object.prototype.hasOwnProperty;
function extend(obj) {
  var sources = Array.prototype.slice.call(arguments, 1), i, len, source, key;
  for (i = 0, len = sources.length; i < len; i += 1) {
    source = sources[i];
    if (!source) {
      continue;
    }
    for (key in source) {
      if (hop$1.call(source, key)) {
        obj[key] = source[key];
      }
    }
  }
  return obj;
}
var realDefineProp$1 = (function() {
  try {
    return !!Object.defineProperty({}, "a", {});
  } catch (e) {
    return false;
  }
})();
var defineProperty$3 = realDefineProp$1 ? Object.defineProperty : function(obj, name, desc) {
  if ("get" in desc && obj.__defineGetter__) {
    obj.__defineGetter__(name, desc.get);
  } else if (!hop$1.call(obj, name) || "value" in desc) {
    obj[name] = desc.value;
  }
};
var objCreate$1 = Object.create || function(proto, props) {
  var obj, k;
  function F() {
  }
  F.prototype = proto;
  obj = new F();
  for (k in props) {
    if (hop$1.call(props, k)) {
      defineProperty$3(obj, k, props[k]);
    }
  }
  return obj;
};
function Compiler(locales, formats, pluralFn) {
  this.locales = locales;
  this.formats = formats;
  this.pluralFn = pluralFn;
}
Compiler.prototype.compile = function(ast) {
  this.pluralStack = [];
  this.currentPlural = null;
  this.pluralNumberFormat = null;
  return this.compileMessage(ast);
};
Compiler.prototype.compileMessage = function(ast) {
  if (!(ast && ast.type === "messageFormatPattern")) {
    throw new Error('Message AST is not of type: "messageFormatPattern"');
  }
  var elements = ast.elements, pattern = [];
  var i, len, element;
  for (i = 0, len = elements.length; i < len; i += 1) {
    element = elements[i];
    switch (element.type) {
      case "messageTextElement":
        pattern.push(this.compileMessageText(element));
        break;
      case "argumentElement":
        pattern.push(this.compileArgument(element));
        break;
      default:
        throw new Error("Message element does not have a valid type");
    }
  }
  return pattern;
};
Compiler.prototype.compileMessageText = function(element) {
  if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
    if (!this.pluralNumberFormat) {
      this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
    }
    return new PluralOffsetString(
      this.currentPlural.id,
      this.currentPlural.format.offset,
      this.pluralNumberFormat,
      element.value
    );
  }
  return element.value.replace(/\\#/g, "#");
};
Compiler.prototype.compileArgument = function(element) {
  var format2 = element.format;
  if (!format2) {
    return new StringFormat(element.id);
  }
  var formats = this.formats, locales = this.locales, pluralFn = this.pluralFn, options;
  switch (format2.type) {
    case "numberFormat":
      options = formats.number[format2.style];
      return {
        id: element.id,
        format: new Intl.NumberFormat(locales, options).format
      };
    case "dateFormat":
      options = formats.date[format2.style];
      return {
        id: element.id,
        format: new Intl.DateTimeFormat(locales, options).format
      };
    case "timeFormat":
      options = formats.time[format2.style];
      return {
        id: element.id,
        format: new Intl.DateTimeFormat(locales, options).format
      };
    case "pluralFormat":
      options = this.compileOptions(element);
      return new PluralFormat(
        element.id,
        format2.ordinal,
        format2.offset,
        options,
        pluralFn
      );
    case "selectFormat":
      options = this.compileOptions(element);
      return new SelectFormat(element.id, options);
    default:
      throw new Error("Message element does not have a valid format type");
  }
};
Compiler.prototype.compileOptions = function(element) {
  var format2 = element.format, options = format2.options, optionsHash = {};
  this.pluralStack.push(this.currentPlural);
  this.currentPlural = format2.type === "pluralFormat" ? element : null;
  var i, len, option;
  for (i = 0, len = options.length; i < len; i += 1) {
    option = options[i];
    optionsHash[option.selector] = this.compileMessage(option.value);
  }
  this.currentPlural = this.pluralStack.pop();
  return optionsHash;
};
function StringFormat(id2) {
  this.id = id2;
}
StringFormat.prototype.format = function(value) {
  if (!value && typeof value !== "number") {
    return "";
  }
  return typeof value === "string" ? value : String(value);
};
function PluralFormat(id2, useOrdinal, offset, options, pluralFn) {
  this.id = id2;
  this.useOrdinal = useOrdinal;
  this.offset = offset;
  this.options = options;
  this.pluralFn = pluralFn;
}
PluralFormat.prototype.getOption = function(value) {
  var options = this.options;
  var option = options["=" + value] || options[this.pluralFn(value - this.offset, this.useOrdinal)];
  return option || options.other;
};
function PluralOffsetString(id2, offset, numberFormat, string2) {
  this.id = id2;
  this.offset = offset;
  this.numberFormat = numberFormat;
  this.string = string2;
}
PluralOffsetString.prototype.format = function(value) {
  var number2 = this.numberFormat.format(value - this.offset);
  return this.string.replace(/(^|[^\\])#/g, "$1" + number2).replace(/\\#/g, "#");
};
function SelectFormat(id2, options) {
  this.id = id2;
  this.options = options;
}
SelectFormat.prototype.getOption = function(value) {
  var options = this.options;
  return options[value] || options.other;
};
const parser = (function() {
  function peg$subclass(child, parent) {
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }
  function peg$SyntaxError(message, expected, found, location) {
    this.message = message;
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }
  peg$subclass(peg$SyntaxError, Error);
  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {}, peg$FAILED = {}, peg$startRuleFunctions = { start: peg$parsestart }, peg$startRuleFunction = peg$parsestart, peg$c0 = function(elements) {
      return {
        type: "messageFormatPattern",
        elements,
        location: location()
      };
    }, peg$c1 = function(text) {
      var string2 = "", i, j, outerLen, inner, innerLen;
      for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
        inner = text[i];
        for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
          string2 += inner[j];
        }
      }
      return string2;
    }, peg$c2 = function(messageText) {
      return {
        type: "messageTextElement",
        value: messageText,
        location: location()
      };
    }, peg$c3 = /^[^ \t\n\r,.+={}#]/, peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" }, peg$c5 = "{", peg$c6 = { type: "literal", value: "{", description: '"{"' }, peg$c7 = ",", peg$c8 = { type: "literal", value: ",", description: '","' }, peg$c9 = "}", peg$c10 = { type: "literal", value: "}", description: '"}"' }, peg$c11 = function(id2, format2) {
      return {
        type: "argumentElement",
        id: id2,
        format: format2 && format2[2],
        location: location()
      };
    }, peg$c12 = "number", peg$c13 = { type: "literal", value: "number", description: '"number"' }, peg$c14 = "date", peg$c15 = { type: "literal", value: "date", description: '"date"' }, peg$c16 = "time", peg$c17 = { type: "literal", value: "time", description: '"time"' }, peg$c18 = function(type, style) {
      return {
        type: type + "Format",
        style: style && style[2],
        location: location()
      };
    }, peg$c19 = "plural", peg$c20 = { type: "literal", value: "plural", description: '"plural"' }, peg$c21 = function(pluralStyle) {
      return {
        type: pluralStyle.type,
        ordinal: false,
        offset: pluralStyle.offset || 0,
        options: pluralStyle.options,
        location: location()
      };
    }, peg$c22 = "selectordinal", peg$c23 = { type: "literal", value: "selectordinal", description: '"selectordinal"' }, peg$c24 = function(pluralStyle) {
      return {
        type: pluralStyle.type,
        ordinal: true,
        offset: pluralStyle.offset || 0,
        options: pluralStyle.options,
        location: location()
      };
    }, peg$c25 = "select", peg$c26 = { type: "literal", value: "select", description: '"select"' }, peg$c27 = function(options2) {
      return {
        type: "selectFormat",
        options: options2,
        location: location()
      };
    }, peg$c28 = "=", peg$c29 = { type: "literal", value: "=", description: '"="' }, peg$c30 = function(selector, pattern) {
      return {
        type: "optionalFormatPattern",
        selector,
        value: pattern,
        location: location()
      };
    }, peg$c31 = "offset:", peg$c32 = { type: "literal", value: "offset:", description: '"offset:"' }, peg$c33 = function(number2) {
      return number2;
    }, peg$c34 = function(offset, options2) {
      return {
        type: "pluralFormat",
        offset,
        options: options2,
        location: location()
      };
    }, peg$c35 = { type: "other", description: "whitespace" }, peg$c36 = /^[ \t\n\r]/, peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" }, peg$c38 = { type: "other", description: "optionalWhitespace" }, peg$c39 = /^[0-9]/, peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" }, peg$c41 = /^[0-9a-f]/i, peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" }, peg$c43 = "0", peg$c44 = { type: "literal", value: "0", description: '"0"' }, peg$c45 = /^[1-9]/, peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" }, peg$c47 = function(digits) {
      return parseInt(digits, 10);
    }, peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/, peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" }, peg$c50 = "\\\\", peg$c51 = { type: "literal", value: "\\\\", description: '"\\\\\\\\"' }, peg$c52 = function() {
      return "\\";
    }, peg$c53 = "\\#", peg$c54 = { type: "literal", value: "\\#", description: '"\\\\#"' }, peg$c55 = function() {
      return "\\#";
    }, peg$c56 = "\\{", peg$c57 = { type: "literal", value: "\\{", description: '"\\\\{"' }, peg$c58 = function() {
      return "{";
    }, peg$c59 = "\\}", peg$c60 = { type: "literal", value: "\\}", description: '"\\\\}"' }, peg$c61 = function() {
      return "}";
    }, peg$c62 = "\\u", peg$c63 = { type: "literal", value: "\\u", description: '"\\\\u"' }, peg$c64 = function(digits) {
      return String.fromCharCode(parseInt(digits, 16));
    }, peg$c65 = function(chars) {
      return chars.join("");
    }, peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [{ line: 1, column: 1, seenCR: false }], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error(`Can't start parsing from rule "` + options.startRule + '".');
      }
      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }
    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }
    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos], p, ch;
      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }
        details = peg$posDetailsCache[p];
        details = {
          line: details.line,
          column: details.column,
          seenCR: details.seenCR
        };
        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) {
              details.line++;
            }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }
          p++;
        }
        peg$posDetailsCache[pos] = details;
        return details;
      }
    }
    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
      return {
        start: {
          offset: startPos,
          line: startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line: endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }
    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) {
        return;
      }
      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }
      peg$maxFailExpected.push(expected);
    }
    function peg$buildException(message, expected, found, location2) {
      function cleanupExpected(expected2) {
        var i = 1;
        expected2.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });
        while (i < expected2.length) {
          if (expected2[i - 1] === expected2[i]) {
            expected2.splice(i, 1);
          } else {
            i++;
          }
        }
      }
      function buildMessage(expected2, found2) {
        function stringEscape(s) {
          function hex(ch) {
            return ch.charCodeAt(0).toString(16).toUpperCase();
          }
          return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\x08/g, "\\b").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\f/g, "\\f").replace(/\r/g, "\\r").replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) {
            return "\\x0" + hex(ch);
          }).replace(/[\x10-\x1F\x80-\xFF]/g, function(ch) {
            return "\\x" + hex(ch);
          }).replace(/[\u0100-\u0FFF]/g, function(ch) {
            return "\\u0" + hex(ch);
          }).replace(/[\u1000-\uFFFF]/g, function(ch) {
            return "\\u" + hex(ch);
          });
        }
        var expectedDescs = new Array(expected2.length), expectedDesc, foundDesc, i;
        for (i = 0; i < expected2.length; i++) {
          expectedDescs[i] = expected2[i].description;
        }
        expectedDesc = expected2.length > 1 ? expectedDescs.slice(0, -1).join(", ") + " or " + expectedDescs[expected2.length - 1] : expectedDescs[0];
        foundDesc = found2 ? '"' + stringEscape(found2) + '"' : "end of input";
        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }
      if (expected !== null) {
        cleanupExpected(expected);
      }
      return new peg$SyntaxError(
        buildMessage(expected, found),
        expected,
        found,
        location2
      );
    }
    function peg$parsestart() {
      var s0;
      s0 = peg$parsemessageFormatPattern();
      return s0;
    }
    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;
      return s0;
    }
    function peg$parsemessageFormatElement() {
      var s0;
      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }
      return s0;
    }
    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }
      return s0;
    }
    function peg$parsemessageTextElement() {
      var s0, s1;
      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;
      return s0;
    }
    function peg$parseargument() {
      var s0, s1, s2;
      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c4);
          }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c4);
              }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }
      return s0;
    }
    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c6);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c8);
                }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c10);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      return s0;
    }
    function peg$parseelementFormat() {
      var s0;
      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }
      return s0;
    }
    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c13);
        }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c15);
          }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c17);
            }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c8);
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      return s0;
    }
    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c20);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c8);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      return s0;
    }
    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c23);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c8);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      return s0;
    }
    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c26);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c8);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      return s0;
    }
    function peg$parseselector() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c29);
        }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }
      return s0;
    }
    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c6);
              }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c10);
                      }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      return s0;
    }
    function peg$parseoffset() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c32);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      return s0;
    }
    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;
      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      return s0;
    }
    function peg$parsews() {
      var s0, s1;
      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c37);
        }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c37);
            }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c35);
        }
      }
      return s0;
    }
    function peg$parse_() {
      var s0, s1, s2;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c38);
        }
      }
      return s0;
    }
    function peg$parsedigit() {
      var s0;
      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c40);
        }
      }
      return s0;
    }
    function peg$parsehexDigit() {
      var s0;
      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c42);
        }
      }
      return s0;
    }
    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c44);
        }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c46);
          }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;
      return s0;
    }
    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;
      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c49);
        }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c51);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c54);
            }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c57);
              }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c60);
                }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c63);
                  }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }
      return s0;
    }
    function peg$parsechars() {
      var s0, s1, s2;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;
      return s0;
    }
    peg$result = peg$startRuleFunction();
    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }
      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }
  return {
    SyntaxError: peg$SyntaxError,
    parse: peg$parse
  };
})();
function MessageFormat(message, locales, formats) {
  var ast = typeof message === "string" ? MessageFormat.__parse(message) : message;
  if (!(ast && ast.type === "messageFormatPattern")) {
    throw new TypeError("A message must be provided as a String or AST.");
  }
  formats = this._mergeFormats(MessageFormat.formats, formats);
  defineProperty$3(this, "_locale", { value: this._resolveLocale(locales) });
  var pluralFn = this._findPluralRuleFunction(this._locale);
  var pattern = this._compilePattern(ast, locales, formats, pluralFn);
  var messageFormat = this;
  this.format = function(values) {
    try {
      return messageFormat._format(pattern, values);
    } catch (e) {
      if (e.variableId) {
        throw new Error(
          "The intl string context variable '" + e.variableId + "' was not provided to the string '" + message + "'"
        );
      } else {
        throw e;
      }
    }
  };
}
defineProperty$3(MessageFormat, "formats", {
  enumerable: true,
  value: {
    number: {
      "currency": {
        style: "currency"
      },
      "percent": {
        style: "percent"
      }
    },
    date: {
      "short": {
        month: "numeric",
        day: "numeric",
        year: "2-digit"
      },
      "medium": {
        month: "short",
        day: "numeric",
        year: "numeric"
      },
      "long": {
        month: "long",
        day: "numeric",
        year: "numeric"
      },
      "full": {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric"
      }
    },
    time: {
      "short": {
        hour: "numeric",
        minute: "numeric"
      },
      "medium": {
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      },
      "long": {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZoneName: "short"
      },
      "full": {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZoneName: "short"
      }
    }
  }
});
defineProperty$3(MessageFormat, "__localeData__", { value: objCreate$1(null) });
defineProperty$3(MessageFormat, "__addLocaleData", { value: function(data2) {
  if (!(data2 && data2.locale)) {
    throw new Error(
      "Locale data provided to IntlMessageFormat is missing a `locale` property"
    );
  }
  MessageFormat.__localeData__[data2.locale.toLowerCase()] = data2;
} });
defineProperty$3(MessageFormat, "__parse", { value: parser.parse });
defineProperty$3(MessageFormat, "defaultLocale", {
  enumerable: true,
  writable: true,
  value: void 0
});
MessageFormat.prototype.resolvedOptions = function() {
  return {
    locale: this._locale
  };
};
MessageFormat.prototype._compilePattern = function(ast, locales, formats, pluralFn) {
  var compiler = new Compiler(locales, formats, pluralFn);
  return compiler.compile(ast);
};
MessageFormat.prototype._findPluralRuleFunction = function(locale) {
  var localeData = MessageFormat.__localeData__;
  var data2 = localeData[locale.toLowerCase()];
  while (data2) {
    if (data2.pluralRuleFunction) {
      return data2.pluralRuleFunction;
    }
    data2 = data2.parentLocale && localeData[data2.parentLocale.toLowerCase()];
  }
  throw new Error(
    "Locale data added to IntlMessageFormat is missing a `pluralRuleFunction` for :" + locale
  );
};
MessageFormat.prototype._format = function(pattern, values) {
  var result = "", i, len, part, id2, value, err;
  for (i = 0, len = pattern.length; i < len; i += 1) {
    part = pattern[i];
    if (typeof part === "string") {
      result += part;
      continue;
    }
    id2 = part.id;
    if (!(values && hop$1.call(values, id2))) {
      err = new Error("A value must be provided for: " + id2);
      err.variableId = id2;
      throw err;
    }
    value = values[id2];
    if (part.options) {
      result += this._format(part.getOption(value), values);
    } else {
      result += part.format(value);
    }
  }
  return result;
};
MessageFormat.prototype._mergeFormats = function(defaults, formats) {
  var mergedFormats = {}, type, mergedType;
  for (type in defaults) {
    if (!hop$1.call(defaults, type)) {
      continue;
    }
    mergedFormats[type] = mergedType = objCreate$1(defaults[type]);
    if (formats && hop$1.call(formats, type)) {
      extend(mergedType, formats[type]);
    }
  }
  return mergedFormats;
};
MessageFormat.prototype._resolveLocale = function(locales) {
  if (typeof locales === "string") {
    locales = [locales];
  }
  locales = (locales || []).concat(MessageFormat.defaultLocale);
  var localeData = MessageFormat.__localeData__;
  var i, len, localeParts, data2;
  for (i = 0, len = locales.length; i < len; i += 1) {
    localeParts = locales[i].toLowerCase().split("-");
    while (localeParts.length) {
      data2 = localeData[localeParts.join("-")];
      if (data2) {
        return data2.locale;
      }
      localeParts.pop();
    }
  }
  var defaultLocale2 = locales.pop();
  throw new Error(
    "No locale data has been added to IntlMessageFormat for: " + locales.join(", ") + ", or the default locale: " + defaultLocale2
  );
};
const defaultLocale$1 = { "locale": "en", "pluralRuleFunction": function(n, ord) {
  var s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";
  return n == 1 && v0 ? "one" : "other";
} };
MessageFormat.__addLocaleData(defaultLocale$1);
MessageFormat.defaultLocale = "en";
var round = Math.round;
function daysToYears(days) {
  return days * 400 / 146097;
}
var MILLISECONDS_IN_MINUTE = 6e4;
var MILLISECONDS_IN_DAY = 864e5;
function startOfDay$1(dirtyDate) {
  var date = new Date(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay$1(dirtyDateLeft);
  var startOfDayRight = startOfDay$1(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
  var timestampRight = startOfDayRight.getTime() - startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function diff(from, to) {
  from = +from;
  to = +to;
  var millisecond = round(to - from), second = round(millisecond / 1e3), minute = round(second / 60), hour = round(minute / 60);
  var day = differenceInCalendarDays(to, from);
  var week = round(day / 7);
  var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
  return {
    millisecond,
    second,
    "second-short": second,
    minute,
    "minute-short": minute,
    hour,
    "hour-short": hour,
    day,
    "day-short": day,
    week,
    "week-short": week,
    month,
    "month-short": month,
    year,
    "year-short": year
  };
}
var hop = Object.prototype.hasOwnProperty;
var toString$2 = Object.prototype.toString;
var realDefineProp = (function() {
  try {
    return !!Object.defineProperty({}, "a", {});
  } catch (e) {
    return false;
  }
})();
var defineProperty$2 = realDefineProp ? Object.defineProperty : function(obj, name, desc) {
  if ("get" in desc && obj.__defineGetter__) {
    obj.__defineGetter__(name, desc.get);
  } else if (!hop.call(obj, name) || "value" in desc) {
    obj[name] = desc.value;
  }
};
var objCreate = Object.create || function(proto, props) {
  var obj, k;
  function F() {
  }
  F.prototype = proto;
  obj = new F();
  for (k in props) {
    if (hop.call(props, k)) {
      defineProperty$2(obj, k, props[k]);
    }
  }
  return obj;
};
var arrIndexOf = Array.prototype.indexOf || function(search, fromIndex) {
  var arr = this;
  if (!arr.length) {
    return -1;
  }
  for (var i = fromIndex || 0, max2 = arr.length; i < max2; i++) {
    if (arr[i] === search) {
      return i;
    }
  }
  return -1;
};
var isArray$1 = Array.isArray || function(obj) {
  return toString$2.call(obj) === "[object Array]";
};
var dateNow = Date.now || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
var FIELDS = [
  "second",
  "second-short",
  "minute",
  "minute-short",
  "hour",
  "hour-short",
  "day",
  "day-short",
  "month",
  "month-short",
  "year",
  "year-short"
];
var STYLES = ["best fit", "numeric"];
function RelativeFormat(locales, options) {
  options = options || {};
  if (isArray$1(locales)) {
    locales = locales.concat();
  }
  defineProperty$2(this, "_locale", { value: this._resolveLocale(locales) });
  defineProperty$2(this, "_options", { value: {
    style: this._resolveStyle(options.style),
    units: this._isValidUnits(options.units) && options.units
  } });
  defineProperty$2(this, "_locales", { value: locales });
  defineProperty$2(this, "_fields", { value: this._findFields(this._locale) });
  defineProperty$2(this, "_messages", { value: objCreate(null) });
  var relativeFormat = this;
  this.format = function format2(date, options2) {
    return relativeFormat._format(date, options2);
  };
}
defineProperty$2(RelativeFormat, "__localeData__", { value: objCreate(null) });
defineProperty$2(RelativeFormat, "__addLocaleData", { value: function() {
  for (var i = 0; i < arguments.length; i++) {
    var datum = arguments[i];
    if (!(datum && datum.locale)) {
      throw new Error(
        "Locale data provided to IntlRelativeFormat is missing a `locale` property value"
      );
    }
    RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
    MessageFormat.__addLocaleData(datum);
  }
} });
defineProperty$2(RelativeFormat, "defaultLocale", {
  enumerable: true,
  writable: true,
  value: void 0
});
defineProperty$2(RelativeFormat, "thresholds", {
  enumerable: true,
  value: {
    second: 45,
    "second-short": 45,
    // seconds to minute
    minute: 45,
    "minute-short": 45,
    // minutes to hour
    hour: 22,
    "hour-short": 22,
    // hours to day
    day: 26,
    "day-short": 26,
    // days to month
    month: 11,
    "month-short": 11
    // months to year
  }
});
RelativeFormat.prototype.resolvedOptions = function() {
  return {
    locale: this._locale,
    style: this._options.style,
    units: this._options.units
  };
};
RelativeFormat.prototype._compileMessage = function(units) {
  var locales = this._locales;
  this._locale;
  var field = this._fields[units];
  var relativeTime = field.relativeTime;
  var future = "";
  var past = "";
  var i;
  for (i in relativeTime.future) {
    if (relativeTime.future.hasOwnProperty(i)) {
      future += " " + i + " {" + relativeTime.future[i].replace("{0}", "#") + "}";
    }
  }
  for (i in relativeTime.past) {
    if (relativeTime.past.hasOwnProperty(i)) {
      past += " " + i + " {" + relativeTime.past[i].replace("{0}", "#") + "}";
    }
  }
  var message = "{when, select, future {{0, plural, " + future + "}}past {{0, plural, " + past + "}}}";
  return new MessageFormat(message, locales);
};
RelativeFormat.prototype._getMessage = function(units) {
  var messages2 = this._messages;
  if (!messages2[units]) {
    messages2[units] = this._compileMessage(units);
  }
  return messages2[units];
};
RelativeFormat.prototype._getRelativeUnits = function(diff2, units) {
  var field = this._fields[units];
  if (field.relative) {
    return field.relative[diff2];
  }
};
RelativeFormat.prototype._findFields = function(locale) {
  var localeData = RelativeFormat.__localeData__;
  var data2 = localeData[locale.toLowerCase()];
  while (data2) {
    if (data2.fields) {
      return data2.fields;
    }
    data2 = data2.parentLocale && localeData[data2.parentLocale.toLowerCase()];
  }
  throw new Error(
    "Locale data added to IntlRelativeFormat is missing `fields` for :" + locale
  );
};
RelativeFormat.prototype._format = function(date, options) {
  var now = options && options.now !== void 0 ? options.now : dateNow();
  if (date === void 0) {
    date = now;
  }
  if (!isFinite(now)) {
    throw new RangeError(
      "The `now` option provided to IntlRelativeFormat#format() is not in valid range."
    );
  }
  if (!isFinite(date)) {
    throw new RangeError(
      "The date value provided to IntlRelativeFormat#format() is not in valid range."
    );
  }
  var diffReport = diff(now, date);
  var units = this._options.units || this._selectUnits(diffReport);
  var diffInUnits = diffReport[units];
  if (this._options.style !== "numeric") {
    var relativeUnits = this._getRelativeUnits(diffInUnits, units);
    if (relativeUnits) {
      return relativeUnits;
    }
  }
  return this._getMessage(units).format({
    "0": Math.abs(diffInUnits),
    when: diffInUnits < 0 ? "past" : "future"
  });
};
RelativeFormat.prototype._isValidUnits = function(units) {
  if (!units || arrIndexOf.call(FIELDS, units) >= 0) {
    return true;
  }
  if (typeof units === "string") {
    var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
    if (suggestion && arrIndexOf.call(FIELDS, suggestion) >= 0) {
      throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, did you mean: ' + suggestion
      );
    }
  }
  throw new Error(
    '"' + units + '" is not a valid IntlRelativeFormat `units` value, it must be one of: "' + FIELDS.join('", "') + '"'
  );
};
RelativeFormat.prototype._resolveLocale = function(locales) {
  if (typeof locales === "string") {
    locales = [locales];
  }
  locales = (locales || []).concat(RelativeFormat.defaultLocale);
  var localeData = RelativeFormat.__localeData__;
  var i, len, localeParts, data2;
  for (i = 0, len = locales.length; i < len; i += 1) {
    localeParts = locales[i].toLowerCase().split("-");
    while (localeParts.length) {
      data2 = localeData[localeParts.join("-")];
      if (data2) {
        return data2.locale;
      }
      localeParts.pop();
    }
  }
  var defaultLocale2 = locales.pop();
  throw new Error(
    "No locale data has been added to IntlRelativeFormat for: " + locales.join(", ") + ", or the default locale: " + defaultLocale2
  );
};
RelativeFormat.prototype._resolveStyle = function(style) {
  if (!style) {
    return STYLES[0];
  }
  if (arrIndexOf.call(STYLES, style) >= 0) {
    return style;
  }
  throw new Error(
    '"' + style + '" is not a valid IntlRelativeFormat `style` value, it must be one of: "' + STYLES.join('", "') + '"'
  );
};
RelativeFormat.prototype._selectUnits = function(diffReport) {
  var i, l, units;
  var fields = FIELDS.filter(function(field) {
    return field.indexOf("-short") < 1;
  });
  for (i = 0, l = fields.length; i < l; i += 1) {
    units = fields[i];
    if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
      break;
    }
  }
  return units;
};
const defaultLocale = { "locale": "en", "pluralRuleFunction": function(n, ord) {
  var s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";
  return n == 1 && v0 ? "one" : "other";
}, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
RelativeFormat.__addLocaleData(defaultLocale);
RelativeFormat.defaultLocale = "en";
function getCacheId(inputs) {
  return JSON.stringify(inputs.map(function(input) {
    return input && typeof input === "object" ? orderedProps(input) : input;
  }));
}
function orderedProps(obj) {
  return Object.keys(obj).sort().map(function(k) {
    var _a;
    return _a = {}, _a[k] = obj[k], _a;
  });
}
var memoizeFormatConstructor = function(FormatConstructor, cache) {
  if (cache === void 0) {
    cache = {};
  }
  return function() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var cacheId = getCacheId(args);
    var format2 = cacheId && cache[cacheId];
    if (!format2) {
      format2 = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
      if (cacheId) {
        cache[cacheId] = format2;
      }
    }
    return format2;
  };
};
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
  var s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";
  return n == 1 && v0 ? "one" : "other";
}, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
function addLocaleData() {
  var data2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var locales = Array.isArray(data2) ? data2 : [data2];
  locales.forEach(function(localeData) {
    if (localeData && localeData.locale) {
      MessageFormat.__addLocaleData(localeData);
      RelativeFormat.__addLocaleData(localeData);
    }
  });
}
function hasLocaleData(locale) {
  var localeParts = (locale || "").split("-");
  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join("-"))) {
      return true;
    }
    localeParts.pop();
  }
  return false;
}
function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();
  return !!(MessageFormat.__localeData__[normalizedLocale] && RelativeFormat.__localeData__[normalizedLocale]);
}
var _typeof$2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = /* @__PURE__ */ (function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties2(Constructor.prototype, protoProps);
    if (staticProps) defineProperties2(Constructor, staticProps);
    return Constructor;
  };
})();
var defineProperty$1 = function(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
};
var _extends$b = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var inherits = function(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var objectWithoutProperties = function(obj, keys3) {
  var target = {};
  for (var i in obj) {
    if (keys3.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
};
var possibleConstructorReturn = function(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
};
var toConsumableArray = function(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
    return arr2;
  } else {
    return Array.from(arr);
  }
};
var bool = PropTypes.bool;
var number = PropTypes.number;
var string = PropTypes.string;
var func = PropTypes.func;
var object = PropTypes.object;
var oneOf = PropTypes.oneOf;
var shape = PropTypes.shape;
var any = PropTypes.any;
var oneOfType = PropTypes.oneOfType;
var localeMatcher = oneOf(["best fit", "lookup"]);
var narrowShortLong = oneOf(["narrow", "short", "long"]);
var numeric2digit = oneOf(["numeric", "2-digit"]);
var funcReq = func.isRequired;
var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,
  defaultLocale: string,
  defaultFormats: object,
  onError: func
};
var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};
var intlShape = shape(_extends$b({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));
var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};
var dateTimeFormatPropTypes = {
  localeMatcher,
  formatMatcher: oneOf(["basic", "best fit"]),
  timeZone: string,
  hour12: bool,
  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(["numeric", "2-digit", "narrow", "short", "long"]),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(["short", "long"])
};
var numberFormatPropTypes = {
  localeMatcher,
  style: oneOf(["decimal", "currency", "percent"]),
  currency: string,
  currencyDisplay: oneOf(["symbol", "code", "name"]),
  useGrouping: bool,
  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};
var relativeFormatPropTypes = {
  style: oneOf(["best fit", "numeric"]),
  units: oneOf(["second", "minute", "hour", "day", "month", "year", "second-short", "minute-short", "hour-short", "day-short", "month-short", "year-short"])
};
var pluralFormatPropTypes = {
  style: oneOf(["cardinal", "ordinal"])
};
var intlConfigPropNames = Object.keys(intlConfigPropTypes);
var ESCAPED_CHARS = {
  "&": "&amp;",
  ">": "&gt;",
  "<": "&lt;",
  '"': "&quot;",
  "'": "&#x27;"
};
var UNSAFE_CHARS_REGEX = /[&><"']/g;
function escape$1(str) {
  return ("" + str).replace(UNSAFE_CHARS_REGEX, function(match2) {
    return ESCAPED_CHARS[match2];
  });
}
function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return whitelist.reduce(function(filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }
    return filtered;
  }, {});
}
function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, intl = _ref.intl;
  invariant(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }
  if ((typeof objA === "undefined" ? "undefined" : _typeof$2(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof$2(objB)) !== "object" || objB === null) {
    return false;
  }
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }
  return true;
}
function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props, state = _ref2.state, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var _context$intl = context.intl, intl = _context$intl === void 0 ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl, nextIntl = _nextContext$intl === void 0 ? {} : _nextContext$intl;
  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}
function createError(message, exception) {
  var eMsg = exception ? "\n" + exception : "";
  return "[React Intl] " + message + eMsg;
}
function defaultErrorHandler(error) {
  if (process.env.NODE_ENV !== "production") {
    console.error(error);
  }
}
function getDisplayName$1(Component$$1) {
  return Component$$1.displayName || Component$$1.name || "Component";
}
function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName, intlPropName = _options$intlPropName === void 0 ? "intl" : _options$intlPropName, _options$withRef = options.withRef, withRef = _options$withRef === void 0 ? false : _options$withRef;
  var InjectIntl = (function(_Component) {
    inherits(InjectIntl2, _Component);
    function InjectIntl2(props, context) {
      classCallCheck(this, InjectIntl2);
      var _this = possibleConstructorReturn(this, (InjectIntl2.__proto__ || Object.getPrototypeOf(InjectIntl2)).call(this, props, context));
      invariantIntlContext(context);
      return _this;
    }
    createClass(InjectIntl2, [{
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        invariant(withRef, "[React Intl] To access the wrapped instance, the `{withRef: true}` option must be set when calling: `injectIntl()`");
        return this._wrappedInstance;
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        return React__default.createElement(WrappedComponent, _extends$b({}, this.props, defineProperty$1({}, intlPropName, this.context.intl), {
          ref: withRef ? (
            /* istanbul ignore next */
            function(ref) {
              return _this2._wrappedInstance = ref;
            }
          ) : null
        }));
      }
    }]);
    return InjectIntl2;
  })(Component);
  InjectIntl.displayName = "InjectIntl(" + getDisplayName$1(WrappedComponent) + ")";
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;
  return hoistNonReactStatics(InjectIntl, WrappedComponent);
}
function defineMessages(messageDescriptors) {
  return messageDescriptors;
}
function resolveLocale(locales) {
  return MessageFormat.prototype._resolveLocale(locales);
}
function findPluralFunction(locale) {
  return MessageFormat.prototype._findPluralRuleFunction(locale);
}
var IntlPluralFormat = function IntlPluralFormat2(locales) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat2);
  var useOrdinal = options.style === "ordinal";
  var pluralFn = findPluralFunction(resolveLocale(locales));
  this.format = function(value) {
    return pluralFn(value, useOrdinal);
  };
};
var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60,
  // seconds to minute
  minute: 60,
  // minutes to hour
  hour: 24,
  // hours to day
  day: 30,
  // days to month
  month: 12
};
function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = RelativeFormat.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds["second-short"] = newThresholds["second-short"];
  thresholds["minute-short"] = newThresholds["minute-short"];
  thresholds["hour-short"] = newThresholds["hour-short"];
  thresholds["day-short"] = newThresholds["day-short"];
  thresholds["month-short"] = newThresholds["month-short"];
}
function getNamedFormat(formats, type, name, onError) {
  var format2 = formats && formats[type] && formats[type][name];
  if (format2) {
    return format2;
  }
  onError(createError("No " + type + " format named: " + name));
}
function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var locale = config.locale, formats = config.formats, timeZone = config.timeZone;
  var format2 = options.format;
  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends$b({}, timeZone && { timeZone }, format2 && getNamedFormat(formats, "date", format2, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError("Error formatting date.", e));
  }
  return String(date);
}
function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var locale = config.locale, formats = config.formats, timeZone = config.timeZone;
  var format2 = options.format;
  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends$b({}, timeZone && { timeZone }, format2 && getNamedFormat(formats, "time", format2, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    filteredOptions = _extends$b({}, filteredOptions, { hour: "numeric", minute: "numeric" });
  }
  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError("Error formatting time.", e));
  }
  return String(date);
}
function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var locale = config.locale, formats = config.formats;
  var format2 = options.format;
  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format2 && getNamedFormat(formats, "relative", format2, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);
  var oldThresholds = _extends$b({}, RelativeFormat.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError("Error formatting relative time.", e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }
  return String(date);
}
function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var locale = config.locale, formats = config.formats;
  var format2 = options.format;
  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format2 && getNamedFormat(formats, "number", format2, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);
  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError("Error formatting number.", e));
  }
  return String(value);
}
function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var locale = config.locale;
  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;
  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError("Error formatting plural.", e));
  }
  return "other";
}
function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var locale = config.locale, formats = config.formats, messages2 = config.messages, defaultLocale2 = config.defaultLocale, defaultFormats = config.defaultFormats;
  var id2 = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
  if (process.env.NODE_ENV !== "production") {
    invariant(!isValidElement(config), "[React Intl] Don't pass React elements to formatMessage(), pass `.props`.");
  }
  invariant(id2, "[React Intl] An `id` must be provided to format a message.");
  var message = messages2 && messages2[id2];
  var hasValues = Object.keys(values).length > 0;
  if (!hasValues && process.env.NODE_ENV === "production") {
    return message || defaultMessage || id2;
  }
  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;
  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);
      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id2 + '" for locale: "' + locale + '"' + (defaultMessage ? ", using default message as fallback." : ""), e));
    }
  } else {
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale2.toLowerCase()) {
      onError(createError('Missing message: "' + id2 + '" for locale: "' + locale + '"' + (defaultMessage ? ", using default message as fallback." : "")));
    }
  }
  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale2, defaultFormats);
      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id2 + '"', e));
    }
  }
  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id2 + '", ' + ("using message " + (message || defaultMessage ? "source" : "id") + " as fallback.")));
  }
  return formattedMessage || message || defaultMessage || id2;
}
function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var escapedValues = Object.keys(rawValues).reduce(function(escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === "string" ? escape$1(value) : value;
    return escaped;
  }, {});
  return formatMessage(config, state, messageDescriptor, escapedValues);
}
var format$1 = Object.freeze({
  formatDate,
  formatTime,
  formatRelative,
  formatNumber,
  formatPlural,
  formatMessage,
  formatHTMLMessage
});
var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: "span",
  defaultLocale: "en",
  defaultFormats: {},
  onError: defaultErrorHandler
};
var IntlProvider = (function(_Component) {
  inherits(IntlProvider2, _Component);
  function IntlProvider2(props) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    classCallCheck(this, IntlProvider2);
    var _this = possibleConstructorReturn(this, (IntlProvider2.__proto__ || Object.getPrototypeOf(IntlProvider2)).call(this, props, context));
    invariant(typeof Intl !== "undefined", "[React Intl] The `Intl` APIs must be available in the runtime, and do not appear to be built-in. An `Intl` polyfill should be loaded.\nSee: http://formatjs.io/guides/runtime-environments/");
    var intlContext = context.intl;
    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      initialNow = intlContext ? intlContext.now() : Date.now();
    }
    var _ref = intlContext || {}, _ref$formatters = _ref.formatters, formatters = _ref$formatters === void 0 ? {
      getDateTimeFormat: memoizeFormatConstructor(Intl.DateTimeFormat),
      getNumberFormat: memoizeFormatConstructor(Intl.NumberFormat),
      getMessageFormat: memoizeFormatConstructor(MessageFormat),
      getRelativeFormat: memoizeFormatConstructor(RelativeFormat),
      getPluralFormat: memoizeFormatConstructor(IntlPluralFormat)
    } : _ref$formatters;
    _this.state = _extends$b({}, formatters, {
      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }
  createClass(IntlProvider2, [{
    key: "getConfig",
    value: function getConfig() {
      var intlContext = this.context.intl;
      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
      for (var propName in defaultProps) {
        if (config[propName] === void 0) {
          config[propName] = defaultProps[propName];
        }
      }
      if (!hasLocaleData(config.locale)) {
        var _config = config, locale = _config.locale, defaultLocale2 = _config.defaultLocale, defaultFormats = _config.defaultFormats, onError = _config.onError;
        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale2 + '" as fallback.')));
        config = _extends$b({}, config, {
          locale: defaultLocale2,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }
      return config;
    }
  }, {
    key: "getBoundFormatFns",
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function(boundFormatFns, name) {
        boundFormatFns[name] = format$1[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      var config = this.getConfig();
      var boundFormatFns = this.getBoundFormatFns(config, this.state);
      var _state = this.state, now = _state.now, formatters = objectWithoutProperties(_state, ["now"]);
      return {
        intl: _extends$b({}, config, boundFormatFns, {
          formatters,
          now
        })
      };
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }
      return shouldIntlComponentUpdate.apply(void 0, [this].concat(next));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: "render",
    value: function render() {
      return Children.only(this.props.children);
    }
  }]);
  return IntlProvider2;
})(Component);
IntlProvider.displayName = "IntlProvider";
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
process.env.NODE_ENV !== "production" ? IntlProvider.propTypes = _extends$b({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;
var FormattedDate$1 = (function(_Component) {
  inherits(FormattedDate2, _Component);
  function FormattedDate2(props, context) {
    classCallCheck(this, FormattedDate2);
    var _this = possibleConstructorReturn(this, (FormattedDate2.__proto__ || Object.getPrototypeOf(FormattedDate2)).call(this, props, context));
    invariantIntlContext(context);
    return _this;
  }
  createClass(FormattedDate2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }
      return shouldIntlComponentUpdate.apply(void 0, [this].concat(next));
    }
  }, {
    key: "render",
    value: function render() {
      var _context$intl = this.context.intl, formatDate2 = _context$intl.formatDate, Text = _context$intl.textComponent;
      var _props = this.props, value = _props.value, children = _props.children;
      var formattedDate = formatDate2(value, this.props);
      if (typeof children === "function") {
        return children(formattedDate);
      }
      return React__default.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate2;
})(Component);
FormattedDate$1.displayName = "FormattedDate";
FormattedDate$1.contextTypes = {
  intl: intlShape
};
process.env.NODE_ENV !== "production" ? FormattedDate$1.propTypes = _extends$b({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;
var FormattedTime$2 = (function(_Component) {
  inherits(FormattedTime2, _Component);
  function FormattedTime2(props, context) {
    classCallCheck(this, FormattedTime2);
    var _this = possibleConstructorReturn(this, (FormattedTime2.__proto__ || Object.getPrototypeOf(FormattedTime2)).call(this, props, context));
    invariantIntlContext(context);
    return _this;
  }
  createClass(FormattedTime2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }
      return shouldIntlComponentUpdate.apply(void 0, [this].concat(next));
    }
  }, {
    key: "render",
    value: function render() {
      var _context$intl = this.context.intl, formatTime2 = _context$intl.formatTime, Text = _context$intl.textComponent;
      var _props = this.props, value = _props.value, children = _props.children;
      var formattedTime = formatTime2(value, this.props);
      if (typeof children === "function") {
        return children(formattedTime);
      }
      return React__default.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime2;
})(Component);
FormattedTime$2.displayName = "FormattedTime";
FormattedTime$2.contextTypes = {
  intl: intlShape
};
process.env.NODE_ENV !== "production" ? FormattedTime$2.propTypes = _extends$b({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;
var SECOND = 1e3;
var MINUTE = 1e3 * 60;
var HOUR = 1e3 * 60 * 60;
var DAY = 1e3 * 60 * 60 * 24;
var MAX_TIMER_DELAY = 2147483647;
function selectUnits(delta) {
  var absDelta = Math.abs(delta);
  if (absDelta < MINUTE) {
    return "second";
  }
  if (absDelta < HOUR) {
    return "minute";
  }
  if (absDelta < DAY) {
    return "hour";
  }
  return "day";
}
function getUnitDelay(units) {
  switch (units) {
    case "second":
      return SECOND;
    case "minute":
      return MINUTE;
    case "hour":
      return HOUR;
    case "day":
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}
function isSameDate(a, b) {
  if (a === b) {
    return true;
  }
  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();
  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}
var FormattedRelative = (function(_Component) {
  inherits(FormattedRelative2, _Component);
  function FormattedRelative2(props, context) {
    classCallCheck(this, FormattedRelative2);
    var _this = possibleConstructorReturn(this, (FormattedRelative2.__proto__ || Object.getPrototypeOf(FormattedRelative2)).call(this, props, context));
    invariantIntlContext(context);
    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
    _this.state = { now };
    return _this;
  }
  createClass(FormattedRelative2, [{
    key: "scheduleNextUpdate",
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;
      clearTimeout(this._timer);
      var value = props.value, units = props.units, updateInterval = props.updateInterval;
      var time = new Date(value).getTime();
      if (!updateInterval || !isFinite(time)) {
        return;
      }
      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
      this._timer = setTimeout(function() {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps2(_ref) {
      var nextValue = _ref.value;
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }
      return shouldIntlComponentUpdate.apply(void 0, [this].concat(next));
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate2(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _context$intl = this.context.intl, formatRelative2 = _context$intl.formatRelative, Text = _context$intl.textComponent;
      var _props = this.props, value = _props.value, children = _props.children;
      var formattedRelative = formatRelative2(value, _extends$b({}, this.props, this.state));
      if (typeof children === "function") {
        return children(formattedRelative);
      }
      return React__default.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative2;
})(Component);
FormattedRelative.displayName = "FormattedRelative";
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1e3 * 10
};
process.env.NODE_ENV !== "production" ? FormattedRelative.propTypes = _extends$b({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;
var FormattedNumber = (function(_Component) {
  inherits(FormattedNumber2, _Component);
  function FormattedNumber2(props, context) {
    classCallCheck(this, FormattedNumber2);
    var _this = possibleConstructorReturn(this, (FormattedNumber2.__proto__ || Object.getPrototypeOf(FormattedNumber2)).call(this, props, context));
    invariantIntlContext(context);
    return _this;
  }
  createClass(FormattedNumber2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }
      return shouldIntlComponentUpdate.apply(void 0, [this].concat(next));
    }
  }, {
    key: "render",
    value: function render() {
      var _context$intl = this.context.intl, formatNumber2 = _context$intl.formatNumber, Text = _context$intl.textComponent;
      var _props = this.props, value = _props.value, children = _props.children;
      var formattedNumber = formatNumber2(value, this.props);
      if (typeof children === "function") {
        return children(formattedNumber);
      }
      return React__default.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber2;
})(Component);
FormattedNumber.displayName = "FormattedNumber";
FormattedNumber.contextTypes = {
  intl: intlShape
};
process.env.NODE_ENV !== "production" ? FormattedNumber.propTypes = _extends$b({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;
var FormattedPlural = (function(_Component) {
  inherits(FormattedPlural2, _Component);
  function FormattedPlural2(props, context) {
    classCallCheck(this, FormattedPlural2);
    var _this = possibleConstructorReturn(this, (FormattedPlural2.__proto__ || Object.getPrototypeOf(FormattedPlural2)).call(this, props, context));
    invariantIntlContext(context);
    return _this;
  }
  createClass(FormattedPlural2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }
      return shouldIntlComponentUpdate.apply(void 0, [this].concat(next));
    }
  }, {
    key: "render",
    value: function render() {
      var _context$intl = this.context.intl, formatPlural2 = _context$intl.formatPlural, Text = _context$intl.textComponent;
      var _props = this.props, value = _props.value, other = _props.other, children = _props.children;
      var pluralCategory = formatPlural2(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;
      if (typeof children === "function") {
        return children(formattedPlural);
      }
      return React__default.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural2;
})(Component);
FormattedPlural.displayName = "FormattedPlural";
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: "cardinal"
};
process.env.NODE_ENV !== "production" ? FormattedPlural.propTypes = _extends$b({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,
  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,
  children: PropTypes.func
}) : void 0;
var defaultFormatMessage = function defaultFormatMessage2(descriptor, values) {
  if (process.env.NODE_ENV !== "production") {
    console.error("[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.");
  }
  return formatMessage({}, { getMessageFormat: memoizeFormatConstructor(MessageFormat) }, descriptor, values);
};
var FormattedMessage = (function(_Component) {
  inherits(FormattedMessage2, _Component);
  function FormattedMessage2(props, context) {
    classCallCheck(this, FormattedMessage2);
    var _this = possibleConstructorReturn(this, (FormattedMessage2.__proto__ || Object.getPrototypeOf(FormattedMessage2)).call(this, props, context));
    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }
  createClass(FormattedMessage2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;
      if (!shallowEquals(nextValues, values)) {
        return true;
      }
      var nextPropsToCheck = _extends$b({}, nextProps, {
        values
      });
      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }
      return shouldIntlComponentUpdate.apply(void 0, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: "render",
    value: function render() {
      var _ref = this.context.intl || {}, _ref$formatMessage = _ref.formatMessage, formatMessage$$1 = _ref$formatMessage === void 0 ? defaultFormatMessage : _ref$formatMessage, _ref$textComponent = _ref.textComponent, Text = _ref$textComponent === void 0 ? "span" : _ref$textComponent;
      var _props = this.props, id2 = _props.id, description = _props.description, defaultMessage = _props.defaultMessage, values = _props.values, _props$tagName = _props.tagName, Component$$1 = _props$tagName === void 0 ? Text : _props$tagName, children = _props.children;
      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;
      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        var uid2 = Math.floor(Math.random() * 1099511627776).toString(16);
        var generateToken = /* @__PURE__ */ (function() {
          var counter = 0;
          return function() {
            return "ELEMENT-" + uid2 + "-" + (counter += 1);
          };
        })();
        tokenDelimiter = "@__" + uid2 + "__@";
        tokenizedValues = {};
        elements = {};
        Object.keys(values).forEach(function(name) {
          var value = values[name];
          if (isValidElement(value)) {
            var token2 = generateToken();
            tokenizedValues[name] = tokenDelimiter + token2 + tokenDelimiter;
            elements[token2] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }
      var descriptor = { id: id2, description, defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);
      var nodes = void 0;
      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        nodes = formattedMessage.split(tokenDelimiter).filter(function(part) {
          return !!part;
        }).map(function(part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }
      if (typeof children === "function") {
        return children.apply(void 0, toConsumableArray(nodes));
      }
      return createElement$2.apply(void 0, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage2;
})(Component);
FormattedMessage.displayName = "FormattedMessage";
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
process.env.NODE_ENV !== "production" ? FormattedMessage.propTypes = _extends$b({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;
var FormattedHTMLMessage = (function(_Component) {
  inherits(FormattedHTMLMessage2, _Component);
  function FormattedHTMLMessage2(props, context) {
    classCallCheck(this, FormattedHTMLMessage2);
    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage2.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage2)).call(this, props, context));
    invariantIntlContext(context);
    return _this;
  }
  createClass(FormattedHTMLMessage2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;
      if (!shallowEquals(nextValues, values)) {
        return true;
      }
      var nextPropsToCheck = _extends$b({}, nextProps, {
        values
      });
      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }
      return shouldIntlComponentUpdate.apply(void 0, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: "render",
    value: function render() {
      var _context$intl = this.context.intl, formatHTMLMessage2 = _context$intl.formatHTMLMessage, Text = _context$intl.textComponent;
      var _props = this.props, id2 = _props.id, description = _props.description, defaultMessage = _props.defaultMessage, rawValues = _props.values, _props$tagName = _props.tagName, Component$$1 = _props$tagName === void 0 ? Text : _props$tagName, children = _props.children;
      var descriptor = { id: id2, description, defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage2(descriptor, rawValues);
      if (typeof children === "function") {
        return children(formattedHTMLMessage);
      }
      var html2 = { __html: formattedHTMLMessage };
      return React__default.createElement(Component$$1, { dangerouslySetInnerHTML: html2 });
    }
  }]);
  return FormattedHTMLMessage2;
})(Component);
FormattedHTMLMessage.displayName = "FormattedHTMLMessage";
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
process.env.NODE_ENV !== "production" ? FormattedHTMLMessage.propTypes = _extends$b({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;
addLocaleData(defaultLocaleData);
addLocaleData(allLocaleData);
const CountryCode = {
  UK: "UK",
  GB: "GB",
  JE: "JE",
  GG: "GG",
  IM: "IM",
  US: "US",
  CA: "CA",
  IE: "IE",
  DE: "DE",
  JP: "JP",
  FR: "FR",
  AU: "AU",
  IT: "IT",
  CH: "CH",
  AT: "AT",
  ES: "ES",
  NL: "NL",
  BE: "BE",
  DK: "DK",
  SE: "SE",
  NO: "NO",
  BR: "BR",
  PT: "PT",
  FI: "FI",
  AX: "AX",
  KR: "KR",
  CN: "CN",
  TW: "TW",
  SG: "SG",
  DZ: "DZ",
  AD: "AD",
  AR: "AR",
  AM: "AM",
  AZ: "AZ",
  BH: "BH",
  BD: "BD",
  BB: "BB",
  BY: "BY",
  BM: "BM",
  BA: "BA",
  IO: "IO",
  BN: "BN",
  BG: "BG",
  KH: "KH",
  CV: "CV",
  CL: "CL",
  CR: "CR",
  HR: "HR",
  CY: "CY",
  CZ: "CZ",
  DO: "DO",
  EC: "EC",
  EG: "EG",
  EE: "EE",
  FO: "FO",
  GE: "GE",
  GR: "GR",
  GL: "GL",
  GT: "GT",
  HT: "HT",
  HN: "HN",
  HU: "HU",
  IS: "IS",
  IN: "IN",
  ID: "ID",
  IL: "IL",
  JO: "JO",
  KZ: "KZ",
  KE: "KE",
  KW: "KW",
  KY: "KY",
  LA: "LA",
  LV: "LV",
  LB: "LB",
  LI: "LI",
  LT: "LT",
  LU: "LU",
  MK: "MK",
  MY: "MY",
  MV: "MV",
  MT: "MT",
  MU: "MU",
  MX: "MX",
  MD: "MD",
  MC: "MC",
  MA: "MA",
  NP: "NP",
  NZ: "NZ",
  NI: "NI",
  NG: "NG",
  OM: "OM",
  PA: "PA",
  PK: "PK",
  PY: "PY",
  PH: "PH",
  PL: "PL",
  PR: "PR",
  RO: "RO",
  RU: "RU",
  SM: "SM",
  SA: "SA",
  SN: "SN",
  SK: "SK",
  SI: "SI",
  ZA: "ZA",
  LK: "LK",
  TJ: "TJ",
  TH: "TH",
  TN: "TN",
  TR: "TR",
  TM: "TM",
  UA: "UA",
  UY: "UY",
  UZ: "UZ",
  VA: "VA",
  VE: "VE",
  ZM: "ZM",
  AS: "AS",
  CC: "CC",
  CK: "CK",
  RS: "RS",
  ME: "ME",
  CS: "CS",
  YU: "YU",
  CX: "CX",
  ET: "ET",
  FK: "FK",
  NF: "NF",
  FM: "FM",
  GF: "GF",
  GN: "GN",
  GP: "GP",
  GS: "GS",
  GU: "GU",
  GW: "GW",
  HM: "HM",
  IQ: "IQ",
  KG: "KG",
  LR: "LR",
  LS: "LS",
  MG: "MG",
  MH: "MH",
  MN: "MN",
  MP: "MP",
  MQ: "MQ",
  NC: "NC",
  NE: "NE",
  VI: "VI",
  VN: "VN",
  PF: "PF",
  PG: "PG",
  PM: "PM",
  PN: "PN",
  PW: "PW",
  RE: "RE",
  SH: "SH",
  SJ: "SJ",
  SO: "SO",
  SZ: "SZ",
  TC: "TC",
  WF: "WF",
  XK: "XK",
  YT: "YT",
  GI: "GI",
  BT: "BT",
  AL: "AL",
  CU: "CU",
  UM: "UM",
  AI: "AI",
  AF: "AF",
  SD: "SD",
  VC: "VC",
  TA: "TA",
  NA: "NA",
  EH: "EH",
  BL: "BL",
  TZ: "TZ",
  AC: "AC",
  VG: "VG",
  MZ: "MZ",
  MF: "MF",
  MM: "MM",
  SV: "SV",
  IR: "IR",
  PE: "PE",
  INTL: "INTL",
  CO: "CO"
};
const POSTCODE_REGEXES = {
  [CountryCode.UK]: /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-z][A-z]){1}$/i,
  [CountryCode.GB]: /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-z][A-z]){1}$/i,
  [CountryCode.JE]: /^JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  [CountryCode.GG]: /^GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  [CountryCode.IM]: /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  [CountryCode.US]: /^([0-9]{5})(?:-([0-9]{4}))?$/,
  [CountryCode.CA]: /^([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ])\s*([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])$/i,
  [CountryCode.IE]: /^([AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/,
  [CountryCode.DE]: /^\d{5}$/,
  [CountryCode.JP]: /^\d{3}-\d{4}$/,
  [CountryCode.FR]: /^\d{2}[ ]?\d{3}$/,
  [CountryCode.AU]: /^\d{4}$/,
  [CountryCode.IT]: /^\d{5}$/,
  [CountryCode.CH]: /^\d{4}$/,
  [CountryCode.AT]: /^(?!0)\d{4}$/,
  [CountryCode.ES]: /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/,
  [CountryCode.NL]: /^\d{4}[ ]?[A-Z]{2}$/,
  [CountryCode.BE]: /^\d{4}$/,
  [CountryCode.DK]: /^\d{4}$/,
  [CountryCode.SE]: /^(SE-)?\d{3}[ ]?\d{2}$/,
  [CountryCode.NO]: /^\d{4}$/,
  [CountryCode.BR]: /^\d{5}[-]?\d{3}$/,
  [CountryCode.PT]: /^\d{4}-\d{3}$/,
  [CountryCode.FI]: /^(FI-|AX-)?\d{5}$/,
  [CountryCode.AX]: /^22\d{3}$/,
  [CountryCode.KR]: /^\d{5}$/,
  [CountryCode.CN]: /^\d{6}$/,
  [CountryCode.TW]: /^\d{3}(\d{2,3})?$/,
  [CountryCode.SG]: /^\d{6}$/,
  [CountryCode.DZ]: /^\d{5}$/,
  [CountryCode.AD]: /^AD\d{3}$/,
  [CountryCode.AR]: /^([A-HJ-NP-Z])?\d{4}([A-Z]{3})?$/,
  [CountryCode.AM]: /^(37)?\d{4}$/,
  [CountryCode.AZ]: /^\d{4}$/,
  [CountryCode.BH]: /^((1[0-2]|[2-9])\d{2})?$/,
  [CountryCode.BD]: /^\d{4}$/,
  [CountryCode.BB]: /^(BB\d{5})?$/,
  [CountryCode.BY]: /^\d{6}$/,
  [CountryCode.BM]: /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/,
  [CountryCode.BA]: /^\d{5}$/,
  [CountryCode.IO]: /^BBND 1ZZ$/,
  [CountryCode.BN]: /^[A-Z]{2}[ ]?\d{4}$/,
  [CountryCode.BG]: /^\d{4}$/,
  [CountryCode.KH]: /^\d{5}$/,
  [CountryCode.CV]: /^\d{4}$/,
  [CountryCode.CL]: /^\d{7}$/,
  [CountryCode.CR]: /^(\d{4,5}|\d{3}-\d{4})$/,
  [CountryCode.HR]: /^(HR-)?\d{5}$/,
  [CountryCode.CY]: /^\d{4}$/,
  [CountryCode.CZ]: /^\d{3}[ ]?\d{2}$/,
  [CountryCode.DO]: /^\d{5}$/,
  [CountryCode.EC]: /^([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/,
  [CountryCode.EG]: /^\d{5}$/,
  [CountryCode.EE]: /^\d{5}$/,
  [CountryCode.FO]: /^\d{3}$/,
  [CountryCode.GE]: /^\d{4}$/,
  [CountryCode.GR]: /^\d{3}[ ]?\d{2}$/,
  [CountryCode.GL]: /^39\d{2}$/,
  [CountryCode.GT]: /^\d{5}$/,
  [CountryCode.HT]: /^\d{4}$/,
  [CountryCode.HN]: /^(?:\d{5})?$/,
  [CountryCode.HU]: /^\d{4}$/,
  [CountryCode.IS]: /^\d{3}$/,
  [CountryCode.IN]: /^\d{6}$/,
  [CountryCode.ID]: /^\d{5}$/,
  [CountryCode.IL]: /^\d{5,7}$/,
  [CountryCode.JO]: /^\d{5}$/,
  [CountryCode.KZ]: /^\d{6}$/,
  [CountryCode.KE]: /^\d{5}$/,
  [CountryCode.KW]: /^\d{5}$/,
  [CountryCode.KY]: /^KY[123]-\d{4}$/,
  [CountryCode.LA]: /^\d{5}$/,
  [CountryCode.LV]: /^(LV-)?\d{4}$/,
  [CountryCode.LB]: /^(\d{4}([ ]?\d{4})?)?$/,
  [CountryCode.LI]: /^(948[5-9])|(949[0-7])$/,
  [CountryCode.LT]: /^(LT-)?\d{5}$/,
  [CountryCode.LU]: /^(L-)?\d{4}$/,
  [CountryCode.MK]: /^\d{4}$/,
  [CountryCode.MY]: /^\d{5}$/,
  [CountryCode.MV]: /^\d{5}$/,
  [CountryCode.MT]: /^[A-Z]{3}[ ]?\d{2,4}$/,
  [CountryCode.MU]: /^((\d|[A-Z])\d{4})?$/,
  [CountryCode.MX]: /^\d{5}$/,
  [CountryCode.MD]: /^\d{4}$/,
  [CountryCode.MC]: /^980\d{2}$/,
  [CountryCode.MA]: /^\d{5}$/,
  [CountryCode.NP]: /^\d{5}$/,
  [CountryCode.NZ]: /^\d{4}$/,
  [CountryCode.NI]: /^((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?$/,
  [CountryCode.NG]: /^(\d{6})?$/,
  [CountryCode.OM]: /^(PC )?\d{3}$/,
  [CountryCode.PA]: /^\d{4}$/,
  [CountryCode.PK]: /^\d{5}$/,
  [CountryCode.PY]: /^\d{4}$/,
  [CountryCode.PH]: /^\d{4}$/,
  [CountryCode.PL]: /^\d{2}-\d{3}$/,
  [CountryCode.PR]: /^00[679]\d{2}([ -]\d{4})?$/,
  [CountryCode.RO]: /^\d{6}$/,
  [CountryCode.RU]: /^\d{6}$/,
  [CountryCode.SM]: /^4789\d$/,
  [CountryCode.SA]: /^\d{5}$/,
  [CountryCode.SN]: /^\d{5}$/,
  [CountryCode.SK]: /^\d{3}[ ]?\d{2}$/,
  [CountryCode.SI]: /^(SI-)?\d{4}$/,
  [CountryCode.ZA]: /^\d{4}$/,
  [CountryCode.LK]: /^\d{5}$/,
  [CountryCode.TJ]: /^\d{6}$/,
  [CountryCode.TH]: /^\d{5}$/,
  [CountryCode.TN]: /^\d{4}$/,
  [CountryCode.TR]: /^\d{5}$/,
  [CountryCode.TM]: /^\d{6}$/,
  [CountryCode.UA]: /^\d{5}$/,
  [CountryCode.UY]: /^\d{5}$/,
  [CountryCode.UZ]: /^\d{6}$/,
  [CountryCode.VA]: /^00120$/,
  [CountryCode.VE]: /^\d{4}$/,
  [CountryCode.ZM]: /^\d{5}$/,
  [CountryCode.AS]: /^96799$/,
  [CountryCode.CC]: /^6799$/,
  [CountryCode.CK]: /^\d{4}$/,
  [CountryCode.RS]: /^\d{5,6}$/,
  [CountryCode.ME]: /^8\d{4}$/,
  [CountryCode.CS]: /^\d{5}$/,
  [CountryCode.YU]: /^\d{5}$/,
  [CountryCode.CX]: /^6798$/,
  [CountryCode.ET]: /^\d{4}$/,
  [CountryCode.FK]: /^FIQQ 1ZZ$/,
  [CountryCode.NF]: /^2899$/,
  [CountryCode.FM]: /^(9694[1-4])([ -]\d{4})?$/,
  [CountryCode.GF]: /^9[78]3\d{2}$/,
  [CountryCode.GN]: /^\d{3}$/,
  [CountryCode.GP]: /^9[78][01]\d{2}$/,
  [CountryCode.GS]: /^SIQQ 1ZZ$/,
  [CountryCode.GU]: /^969[123]\d([ -]\d{4})?$/,
  [CountryCode.GW]: /^\d{4}$/,
  [CountryCode.HM]: /^\d{4}$/,
  [CountryCode.IQ]: /^\d{5}$/,
  [CountryCode.KG]: /^\d{6}$/,
  [CountryCode.LR]: /^\d{4}$/,
  [CountryCode.LS]: /^\d{3}$/,
  [CountryCode.MG]: /^\d{3}$/,
  [CountryCode.MH]: /^969[67]\d([ -]\d{4})?$/,
  [CountryCode.MN]: /^\d{5}$/,
  [CountryCode.MP]: /^9695[012]([ -]\d{4})?$/,
  [CountryCode.MQ]: /^9[78]2\d{2}$/,
  [CountryCode.NC]: /^988\d{2}$/,
  [CountryCode.NE]: /^\d{4}$/,
  [CountryCode.VI]: /^008(([0-4]\d)|(5[01]))([ -]\d{4})?$/,
  [CountryCode.VN]: /^\d{6}$/,
  [CountryCode.PF]: /^987\d{2}$/,
  [CountryCode.PG]: /^\d{3}$/,
  [CountryCode.PM]: /^9[78]5\d{2}$/,
  [CountryCode.PN]: /^PCRN 1ZZ$/,
  [CountryCode.PW]: /^96940$/,
  [CountryCode.RE]: /^9[78]4\d{2}$/,
  [CountryCode.SH]: /^(ASCN|STHL) 1ZZ$/,
  [CountryCode.SJ]: /^\d{4}$/,
  [CountryCode.SO]: /^\d{5}$/,
  [CountryCode.SZ]: /^[HLMS]\d{3}$/,
  [CountryCode.TC]: /^TKCA 1ZZ$/,
  [CountryCode.WF]: /^986\d{2}$/,
  [CountryCode.XK]: /^\d{5}$/,
  [CountryCode.YT]: /^976\d{2}$/,
  [CountryCode.GI]: /^GX11 1AA/,
  [CountryCode.BT]: /^\d{5}/,
  [CountryCode.AL]: /^\d{4}/,
  [CountryCode.CU]: /^\d{5}/,
  [CountryCode.UM]: /^96898/,
  [CountryCode.AI]: /^(?:AI-)?2640/,
  [CountryCode.AF]: /^\d{4}/,
  [CountryCode.SD]: /^\d{5}/,
  [CountryCode.VC]: /^VC\d{4}/,
  [CountryCode.TA]: /^TDCU 1ZZ/,
  [CountryCode.NA]: /^\d{5}/,
  [CountryCode.EH]: /^\d{5}/,
  [CountryCode.BL]: /^9[78][01]\d{2}/,
  [CountryCode.TZ]: /^\d{4,5}/,
  [CountryCode.AC]: /^ASCN 1ZZ/,
  [CountryCode.VG]: /^VG\d{4}/,
  [CountryCode.MZ]: /^\d{4}/,
  [CountryCode.MF]: /^9[78][01]\d{2}/,
  [CountryCode.MM]: /^\d{5}/,
  [CountryCode.SV]: /^CP [1-3][1-7][0-2]\d/,
  [CountryCode.IR]: /^\d{5}-?\d{5}/,
  [CountryCode.PE]: /^[0-2]\d{4}$/,
  [CountryCode.INTL]: /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/i,
  [CountryCode.CO]: /^(0[58]|1[135789]|2[0357]|4[147]|5[024]|6[368]|7[036]|8[1568]|9[4579])\d{4}$/
};
const postcodeValidator = (postalCode, country) => {
  if (!country || !postalCode) {
    return false;
  }
  if (!POSTCODE_REGEXES[country]) {
    return true;
  }
  const regex = POSTCODE_REGEXES[country];
  return regex.test(postalCode);
};
const validationControl = (valid, touched, type, value) => {
  let classField = "";
  if (!valid && touched) {
    classField = "has-error";
  } else if (valid && touched) {
    classField = "has-success";
  } else if (value) {
    classField = "has-value";
  }
  if (type === "hidden") {
    return "hidden";
  }
  return classField;
};
const getFieldValues = (value, fieldId, formFieldsetId, formList) => {
  const isInFieldSet = (formfield) => formfield.formFieldsetId === Number(formFieldsetId);
  const formIndex = formList.findIndex((form2) => form2.formFieldsetSet.find((formfield) => isInFieldSet(formfield)));
  const formFieldsetIndex = formList[formIndex]?.formFieldsetSet.findIndex((formfield) => isInFieldSet(formfield));
  const fieldFromForm = formList[formIndex]?.formFieldsetSet[formFieldsetIndex]?.genericFieldSet.find(
    (fields) => fields.genericFieldId === Number(fieldId)
  );
  const isSelectFormType = fieldFromForm?.fieldType?.toLowerCase() === "select";
  return fieldFromForm?.fieldOptions?.split(",").find((option) => (isSelectFormType ? option.split("::")[1] : option) === value.trim());
};
const generateAnswerList = (answersMap, formList) => {
  let answerList = [];
  if (answersMap) {
    Object.entries(answersMap).forEach(([formFieldset, form2]) => {
      Object.keys(form2).forEach((field) => {
        const value = form2[field];
        const [, fieldId, , ownerId, idx] = field.split("-");
        if (Array.isArray(value)) {
          answerList = [
            ...answerList,
            ...value.filter((v) => !!v.value).map((v) => {
              const [, formFieldsetId] = formFieldset.split("-");
              const option = getFieldValues(v.value, fieldId, formFieldsetId, formList);
              const [answer, answerValue] = option ? option.split("::") : v.value.split("::");
              return {
                genericFieldId: fieldId ? Number(fieldId) : void 0,
                buyerTypeId: ownerId ? Number(ownerId) : void 0,
                groupIndex: idx ? Number(idx) : void 0,
                answer,
                answerValue
              };
            })
          ];
        }
      });
    });
  }
  return answerList;
};
const getFormInitialValuesFromUrl = (genericFieldAnswerList) => {
  let fieldAnswerList = {};
  if (genericFieldAnswerList) {
    const anwerListJson = JSON.parse(genericFieldAnswerList);
    Object.keys(anwerListJson).forEach((key) => {
      const fieldInfo = key.split("_");
      if (`formsection-${fieldInfo[1]}` in fieldAnswerList) {
        fieldAnswerList[`formsection-${fieldInfo[1]}`] = {
          ...fieldAnswerList[`formsection-${fieldInfo[1]}`],
          [`field-${fieldInfo[2]}-0`]: [{ value: anwerListJson[key], qty: 1 }]
        };
      } else {
        fieldAnswerList = {
          ...fieldAnswerList,
          [`formsection-${fieldInfo[1]}`]: {
            [`field-${fieldInfo[2]}-0`]: [{ value: anwerListJson[key], qty: 1 }]
          }
        };
      }
    });
    return fieldAnswerList;
  }
  return void 0;
};
const getFormDetails = (formlist, values) => {
  const getFormFieldset = (form2, valuesFormFieldSet) => form2.genericFieldSet.find((field2) => field2.genericFieldId === valuesFormFieldSet.genericFieldId);
  const formListIndex = formlist.findIndex(
    (formItem) => formItem.formFieldsetSet.find((form2) => getFormFieldset(form2, values))
  );
  const formSection = formlist[formListIndex] && formlist[formListIndex].formFieldsetSet.find((form2) => getFormFieldset(form2, values));
  const field = formSection && formSection.genericFieldSet.find((fieldSet) => fieldSet.genericFieldId === values.genericFieldId);
  const { ticketId } = values;
  const answer = values.answerValue ? values.answerValue : values.answer;
  if (field && field.fieldType === "select" && !field.fieldOptions?.split(",").some((value) => value.includes(answer))) {
    return { field: false };
  }
  return { field, answer, formSection, ticketId };
};
const hasCallCenterRole = () => {
  const rolesString = sessionStorage.getItem("roles");
  if (rolesString) {
    return rolesString.includes("ROLE_CALL_CENTER");
  }
  return false;
};
const hasOnlyBuyerRole = () => {
  const roles = sessionStorage.getItem("roles");
  if (roles) {
    return roles.includes("ROLE_SELLER_ONLY_BUYER");
  }
  return false;
};
const isValidPostalCode = (postalCode, country) => postcodeValidator(postalCode, country);
const formattedPriceString = ({ locale, value, currency }) => {
  try {
    const localeCountry = Cookie.get("locale");
    let normalizedLocale = locale || localeCountry;
    let currencyDisplay = "symbol";
    if (locale) {
      const localeLower = locale.toLowerCase();
      if (currency === "USD") {
        if (localeLower === "es-mx" || localeLower === "mx") {
          normalizedLocale = "en-US";
          currencyDisplay = "symbol";
        } else if (localeLower === "es-es" || localeLower === "es") {
          normalizedLocale = "es-ES";
          currencyDisplay = "code";
        } else if (localeLower === "en-us" || localeLower === "en") {
          normalizedLocale = "en-US";
          currencyDisplay = "symbol";
        }
      } else {
        normalizedLocale = localeLower;
      }
    }
    return new Intl.NumberFormat(normalizedLocale, {
      style: "currency",
      currency,
      currencyDisplay,
      useGrouping: true
    }).format(value);
  } catch (error) {
    console.error("Error formatting number with currency:", error);
    return "";
  }
};
function FormattedPrice({ locale, value, currency }) {
  if (hasOnlyBuyerRole()) return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: formattedPriceString({ locale, value, currency }) });
}
const getAmountTaxTotal = (amountTaxList) => (amountTaxList || []).reduce((total, amountTax) => total + (amountTax.amount || 0), 0);
const getProductConfig = (productConfig, allProductsConfig, productId) => allProductsConfig && allProductsConfig.length > 0 ? allProductsConfig.filter((pc) => pc.productId === productId) : productConfig;
const HIDE_PRICE_PURCHASE_CONFIG_VALUE = "PURCHASE_PROCESS_HIDE_PRICE";
const needsToHidePriceField = (productConfigurations = [], hidePrice = false) => hidePrice || productConfigurations.filter((c) => c.configKey === HIDE_PRICE_PURCHASE_CONFIG_VALUE && c.configValue === "1")[0];
const isOpenTimeAndMultiVenue = (product) => {
  if (!product) return false;
  return product.openTime && product.productVenueSet && product.productVenueSet.length > 1;
};
const BUYER_TYPES_AUTO_SELECTABLES = [10461, 10462, 10512, 10535];
function BuyerTypeItem({
  id: id2,
  name,
  description,
  price,
  commission,
  amountTaxList,
  buyerTypeInfo,
  value = 0,
  min: min2 = 0,
  max: max2 = Number.MAX_VALUE,
  increment,
  decrement,
  currency,
  shortName,
  authSalesGroupList,
  loginUrl,
  discount,
  change: change3,
  maxTickets,
  minTickets,
  showBuyerTypesAsSelect,
  hidePrice,
  percentage,
  buyerTypeListSorted,
  promotionList
}) {
  const isExternal = loginUrl && loginUrl.includes("state");
  const locale = Cookie.get("languageCountryCode");
  const newSalesgroup = authSalesGroupList && authSalesGroupList.length > 0 && authSalesGroupList[0];
  const regex = /\d+-\w*/;
  const url = window.location.href;
  const redirectUrl = newSalesgroup ? url.replace(regex, `${newSalesgroup.salesGroupId}-${newSalesgroup.slug}`) : "";
  let newUrl = loginUrl;
  if (isExternal) {
    newUrl = loginUrl ? `${loginUrl.split("&state=")[0]}&state=${redirectUrl}` : "";
  }
  const disabled = newSalesgroup && newUrl;
  const options = [
    /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: 0, children: "0" }, 0)
  ];
  let i;
  for (i = 1; i <= maxTickets; i++) {
    if (!(i > max2 + value || (minTickets ?? 0) > i)) {
      options.push(
        /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: i, children: i }, i)
      );
    }
  }
  const getFixedPercentage = () => {
    let fixedPercentage2 = percentage;
    if (!percentage && Array.isArray(buyerTypeListSorted) && Array.isArray(promotionList)) {
      const currentBuyerType = buyerTypeListSorted.find((bt) => bt.buyerTypeId === id2);
      const allSameProductId = buyerTypeListSorted.every((bt) => bt.productId === currentBuyerType?.productId);
      if (currentBuyerType && allSameProductId) {
        const matchingPromotion = promotionList.find(
          (promo) => Array.isArray(promo.buyerTypeIds) && promo.buyerTypeIds.includes(id2) && Array.isArray(promo.productIds) && promo.productIds.includes(currentBuyerType.productId)
        );
        if (matchingPromotion && Array.isArray(matchingPromotion.promotionPrices)) {
          const promoPrice = matchingPromotion.promotionPrices.find((pp) => pp.buyerTypeId === id2);
          if (promoPrice && typeof promoPrice.percentage === "number") {
            fixedPercentage2 = promoPrice.percentage;
          }
        }
      }
    }
    return fixedPercentage2;
  };
  const fixedPercentage = getFixedPercentage();
  const hasPercentage = typeof fixedPercentage === "number" && !Number.isNaN(fixedPercentage);
  const calculatePriceToShow = hasPercentage ? price - price * fixedPercentage : price - (discount || 0);
  const finalPriceShow = calculatePriceToShow >= 0 ? calculatePriceToShow : 0;
  const amountTax = getAmountTaxTotal(amountTaxList);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "buyerType", "data-buyertype-id": shortName, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `buyerType-item form-horizontal ${disabled ? "buyerType-item-auth" : null}`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "form-group", title: buyerTypeInfo && buyerTypeInfo.description, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "control-label col-md-8 col-sm-8 col-xs-6", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: `quantity_${id2}`, children: name }),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: `buyerType-price ${hidePrice ? "hidden" : ""}`, children: [
        (discount ?? 0) > 0 && price > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "buyerType-price-strike", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormattedPrice,
          {
            locale,
            value: price + (price && commission || 0) + (price && amountTax || 0),
            currency
          }
        ) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormattedPrice,
          {
            locale,
            value: price + commission + amountTax >= 0 ? price + commission + amountTax : 0,
            currency
          }
        ),
        (discount ?? 0) > 0 && price > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: finalPriceShow, currency }),
        commission || amountTax ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "buyerType-tooltip", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "span",
            {
              "data-for": `tooltip_buyer_${id2}`,
              "aria-label": `${commission}€ booking fees`,
              className: "clickable icon-own-info_outline",
              "data-event": "click focus",
              "data-tip": ""
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(ReactTooltip, { id: `tooltip_buyer_${id2}`, globalEventOff: "click", children: [
            commission ? /* @__PURE__ */ jsxRuntimeExports.jsx(
              FormattedMessage,
              {
                id: "tooltip.commission",
                defaultMessage: "{price} + {commission} gastos de gestión",
                values: {
                  price: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    FormattedPrice,
                    {
                      locale,
                      value: price - (discount ?? 0) >= 0 ? price - (discount ?? 0) : 0,
                      currency
                    }
                  ),
                  commission: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: commission, currency })
                }
              }
            ) : amountTaxList && amountTaxList.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
              FormattedPrice,
              {
                locale,
                value: price - (discount ?? 0) >= 0 ? price - (discount ?? 0) : 0,
                currency
              }
            ),
            amountTaxList && amountTaxList.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "buyerType-tooltip-taxes", children: amountTaxList.map((tax, index2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
              " ",
              "+ ",
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: tax.amount, currency }),
              " ",
              tax.description
            ] }, tax.taxId ?? index2)) })
          ] })
        ] }) : ""
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "buyerType-description", children: !disabled ? description : /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: newUrl, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "link.buyertypes.login", defaultMessage: "Login" }) }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: `col-md-4 col-sm-4 col-xs-6 buyer-selector ${showBuyerTypesAsSelect && `buyer-selector-secondary`}`,
        children: showBuyerTypesAsSelect ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          "select",
          {
            value,
            className: "form-control",
            disabled: options.length <= 1,
            onChange: (event) => {
              change3(Number(event.target.value));
            },
            children: options
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-group", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-group-btn", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              className: "btn btn-default",
              "data-action-id": "decrement",
              onClick: disabled ? () => {
              } : decrement,
              disabled: min2 >= value || !!disabled,
              type: "button",
              "aria-label": "-",
              children: "-"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              id: `quantity_${id2}`,
              type: "text",
              value: value || 0,
              className: "form-control",
              name: "quantity",
              "aria-label": `${value} ${name}`,
              readOnly: true
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-group-btn", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              className: "btn btn-default",
              onClick: disabled ? () => {
              } : increment,
              "data-action-id": "increment",
              disabled: !max2 && max2 <= 0 || !!disabled,
              type: "button",
              "aria-label": "+",
              children: "+"
            }
          ) })
        ] })
      }
    )
  ] }) }) }, `buyerType_${id2}`);
}
const BuyerTypeItem$1 = injectIntl(BuyerTypeItem);
const token = "%[a-f0-9]{2}";
const multiMatcher = new RegExp(`(${token})+`, "gi");
const hexPair = /^[a-f\d]{2}$/i;
function parsePercentByte(input, position) {
  if (input.codePointAt(position) !== 37 || position + 3 > input.length) {
    return;
  }
  const digits = input.slice(position + 1, position + 3);
  if (!hexPair.test(digits)) {
    return;
  }
  return { byte: Number.parseInt(digits, 16), next: position + 3 };
}
function utf8SequenceLength(byte) {
  if (byte <= 127) {
    return 1;
  }
  if (byte >= 194 && byte <= 223) {
    return 2;
  }
  if (byte >= 224 && byte <= 239) {
    return 3;
  }
  if (byte >= 240 && byte <= 244) {
    return 4;
  }
  return 0;
}
function isContinuationByte(byte) {
  return byte >= 128 && byte <= 191;
}
function decode$1(input) {
  try {
    return decodeURIComponent(input);
  } catch {
    let output = "";
    let position = 0;
    while (position < input.length) {
      if (input.codePointAt(position) !== 37) {
        output += input.charAt(position);
        position++;
        continue;
      }
      const firstByte = parsePercentByte(input, position);
      if (!firstByte) {
        output += input.charAt(position);
        position++;
        continue;
      }
      const sequenceLength = utf8SequenceLength(firstByte.byte);
      if (sequenceLength === 0) {
        output += input.slice(position, position + 3);
        position += 3;
        continue;
      }
      let end = firstByte.next;
      let validSequence = true;
      for (let index2 = 1; index2 < sequenceLength; index2++) {
        const nextByte = parsePercentByte(input, end);
        if (!nextByte || !isContinuationByte(nextByte.byte)) {
          validSequence = false;
          break;
        }
        end = nextByte.next;
      }
      if (validSequence) {
        const encodedSequence = input.slice(position, end);
        try {
          output += decodeURIComponent(encodedSequence);
          position = end;
          continue;
        } catch {
        }
      }
      output += input.slice(position, position + 3);
      position += 3;
    }
    return output;
  }
}
function customDecodeURIComponent(input) {
  const replaceMap = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let match2 = multiMatcher.exec(input);
  while (match2) {
    try {
      replaceMap[match2[0]] = decodeURIComponent(match2[0]);
    } catch {
      const result = decode$1(match2[0]);
      if (result !== match2[0]) {
        replaceMap[match2[0]] = result;
      }
    }
    match2 = multiMatcher.exec(input);
  }
  replaceMap["%C2"] = "�";
  const entries = Object.keys(replaceMap);
  for (const key of entries) {
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
  }
  return input;
}
function decodeUriComponent(encodedURI) {
  if (typeof encodedURI !== "string") {
    throw new TypeError(`Expected \`encodedURI\` to be of type \`string\`, got \`${typeof encodedURI}\``);
  }
  try {
    return decodeURIComponent(encodedURI);
  } catch {
    return customDecodeURIComponent(encodedURI);
  }
}
function includeKeys(object2, predicate) {
  const result = {};
  if (Array.isArray(predicate)) {
    for (const key of predicate) {
      const descriptor = Object.getOwnPropertyDescriptor(object2, key);
      if (descriptor?.enumerable) {
        Object.defineProperty(result, key, descriptor);
      }
    }
  } else {
    for (const key of Reflect.ownKeys(object2)) {
      const descriptor = Object.getOwnPropertyDescriptor(object2, key);
      if (descriptor.enumerable) {
        const value = object2[key];
        if (predicate(key, value, object2)) {
          Object.defineProperty(result, key, descriptor);
        }
      }
    }
  }
  return result;
}
function splitOnFirst(string2, separator) {
  if (!(typeof string2 === "string" && typeof separator === "string")) {
    throw new TypeError("Expected the arguments to be of type `string`");
  }
  if (string2 === "" || separator === "") {
    return [];
  }
  const separatorIndex = string2.indexOf(separator);
  if (separatorIndex === -1) {
    return [];
  }
  return [
    string2.slice(0, separatorIndex),
    string2.slice(separatorIndex + separator.length)
  ];
}
const isNullOrUndefined = (value) => value === null || value === void 0;
const strictUriEncode = (string2) => encodeURIComponent(string2).replaceAll(/[!'()*]/g, (x) => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const encodeFragmentIdentifier = /* @__PURE__ */ Symbol("encodeFragmentIdentifier");
function encoderForArrayFormat(options) {
  switch (options.arrayFormat) {
    case "index": {
      return (key) => (result, value) => {
        const index2 = result.length;
        if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
          return result;
        }
        if (value === null) {
          result.push([encode(key, options), "[", index2, "]"].join(""));
          return result;
        }
        result.push([encode(key, options), "[", encode(index2, options), "]=", encode(value, options)].join(""));
        return result;
      };
    }
    case "bracket": {
      return (key) => (result, value) => {
        if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
          return result;
        }
        if (value === null) {
          result.push([encode(key, options), "[]"].join(""));
          return result;
        }
        result.push([encode(key, options), "[]=", encode(value, options)].join(""));
        return result;
      };
    }
    case "colon-list-separator": {
      return (key) => (result, value) => {
        if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
          return result;
        }
        if (value === null) {
          result.push([encode(key, options), ":list="].join(""));
          return result;
        }
        result.push([encode(key, options), ":list=", encode(value, options)].join(""));
        return result;
      };
    }
    case "comma":
    case "separator":
    case "bracket-separator": {
      const keyValueSeparator = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (key) => (result, value) => {
        if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
          return result;
        }
        value = value === null ? "" : value;
        if (result.length === 0) {
          result.push([encode(key, options), keyValueSeparator, encode(value, options)].join(""));
          return result;
        }
        result.push(encode(value, options));
        return result;
      };
    }
    default: {
      return (key) => (result, value) => {
        if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
          return result;
        }
        if (value === null) {
          result.push(encode(key, options));
          return result;
        }
        result.push([encode(key, options), "=", encode(value, options)].join(""));
        return result;
      };
    }
  }
}
function parserForArrayFormat(options) {
  let result;
  switch (options.arrayFormat) {
    case "index": {
      return (key, value, accumulator) => {
        result = /\[(\d*)]$/.exec(key);
        key = key.replace(/\[\d*]$/, "");
        if (!result) {
          accumulator[key] = value;
          return;
        }
        if (accumulator[key] === void 0) {
          accumulator[key] = {};
        }
        accumulator[key][result[1]] = value;
      };
    }
    case "bracket": {
      return (key, value, accumulator) => {
        result = /(\[])$/.exec(key);
        key = key.replace(/\[]$/, "");
        if (!result) {
          accumulator[key] = value;
          return;
        }
        if (accumulator[key] === void 0) {
          accumulator[key] = [value];
          return;
        }
        if (!Array.isArray(accumulator[key])) {
          accumulator[key] = [accumulator[key], value];
          return;
        }
        accumulator[key].push(value);
      };
    }
    case "colon-list-separator": {
      return (key, value, accumulator) => {
        result = /(:list)$/.exec(key);
        key = key.replace(/:list$/, "");
        if (!result) {
          accumulator[key] = value;
          return;
        }
        if (accumulator[key] === void 0) {
          accumulator[key] = [value];
          return;
        }
        if (!Array.isArray(accumulator[key])) {
          accumulator[key] = [accumulator[key], value];
          return;
        }
        accumulator[key].push(value);
      };
    }
    case "comma":
    case "separator": {
      return (key, value, accumulator) => {
        const isArray3 = typeof value === "string" && value.includes(options.arrayFormatSeparator);
        const newValue = isArray3 ? value.split(options.arrayFormatSeparator).map((item) => decode(item, options)) : value === null ? value : decode(value, options);
        accumulator[key] = newValue;
      };
    }
    case "bracket-separator": {
      return (key, value, accumulator) => {
        const isArray3 = /(\[])$/.test(key);
        key = key.replace(/\[]$/, "");
        if (!isArray3) {
          accumulator[key] = value ? decode(value, options) : value;
          return;
        }
        const arrayValue = value === null ? [] : decode(value, options).split(options.arrayFormatSeparator);
        if (accumulator[key] === void 0) {
          accumulator[key] = arrayValue;
          return;
        }
        if (!Array.isArray(accumulator[key])) {
          accumulator[key] = [accumulator[key]];
        }
        for (const item of arrayValue) {
          accumulator[key].push(item);
        }
      };
    }
    default: {
      return (key, value, accumulator) => {
        if (accumulator[key] === void 0) {
          accumulator[key] = value;
          return;
        }
        if (Array.isArray(accumulator[key])) {
          accumulator[key].push(value);
          return;
        }
        accumulator[key] = [accumulator[key], value];
      };
    }
  }
}
function validateArrayFormatSeparator(value) {
  if (typeof value !== "string" || value.length !== 1) {
    throw new TypeError("arrayFormatSeparator must be single character string");
  }
}
function encode(value, options) {
  if (options.encode) {
    return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
  }
  return value;
}
function decode(value, options) {
  if (options.decode) {
    return decodeUriComponent(value);
  }
  return value;
}
function keysSorter(input) {
  if (Array.isArray(input)) {
    return input.sort();
  }
  if (typeof input === "object") {
    return keysSorter(Object.keys(input)).sort((a, b) => Number(a) - Number(b)).map((key) => input[key]);
  }
  return input;
}
function removeHash(input) {
  const hashStart = input.indexOf("#");
  if (hashStart !== -1) {
    input = input.slice(0, hashStart);
  }
  return input;
}
function getHash(url) {
  let hash = "";
  const hashStart = url.indexOf("#");
  if (hashStart !== -1) {
    hash = url.slice(hashStart);
  }
  return hash;
}
function getUrlWithoutQuery(url) {
  const queryStart = url.indexOf("?");
  return queryStart === -1 ? url : url.slice(0, queryStart);
}
function parseValue(value, options, type) {
  if (type === "string" && typeof value === "string") {
    return value;
  }
  if (typeof type === "function" && typeof value === "string") {
    return type(value);
  }
  if (type === "boolean" && value === null) {
    return true;
  }
  if (type === "boolean" && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) {
    return value.toLowerCase() === "true";
  }
  if (type === "boolean" && value !== null && (value.toLowerCase() === "1" || value.toLowerCase() === "0")) {
    return value.toLowerCase() === "1";
  }
  if (type === "string[]" && options.arrayFormat !== "none" && typeof value === "string") {
    return [value];
  }
  if (type === "number[]" && options.arrayFormat !== "none" && !Number.isNaN(Number(value)) && (typeof value === "string" && value.trim() !== "")) {
    return [Number(value)];
  }
  if (type === "number" && !Number.isNaN(Number(value)) && (typeof value === "string" && value.trim() !== "")) {
    return Number(value);
  }
  if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) {
    return value.toLowerCase() === "true";
  }
  if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === "string" && value.trim() !== "")) {
    return Number(value);
  }
  return value;
}
function extract(input) {
  input = removeHash(input);
  const queryStart = input.indexOf("?");
  if (queryStart === -1) {
    return "";
  }
  return input.slice(queryStart + 1);
}
function parse$1(query2, options) {
  options = {
    decode: true,
    sort: true,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: false,
    parseBooleans: false,
    types: /* @__PURE__ */ Object.create(null),
    ...options
  };
  validateArrayFormatSeparator(options.arrayFormatSeparator);
  const formatter = parserForArrayFormat(options);
  const returnValue = /* @__PURE__ */ Object.create(null);
  if (typeof query2 !== "string") {
    return returnValue;
  }
  query2 = query2.trim().replace(/^[?#&]/, "");
  if (!query2) {
    return returnValue;
  }
  if (/^&+$/.test(query2)) {
    return returnValue;
  }
  let parameterStart = 0;
  let firstSeparator = query2.indexOf("&");
  if (firstSeparator === -1) {
    firstSeparator = query2.length;
  }
  for (let index2 = firstSeparator; index2 <= query2.length; index2++) {
    if (index2 < query2.length && query2[index2] !== "&") {
      continue;
    }
    if (index2 === parameterStart) {
      parameterStart = index2 + 1;
      continue;
    }
    const parameter = query2.slice(parameterStart, index2);
    const parameter_ = options.decode ? parameter.replaceAll("+", " ") : parameter;
    let [key, value] = splitOnFirst(parameter_, "=");
    if (key === void 0) {
      key = parameter_;
    }
    value = value === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(options.arrayFormat) ? value : decode(value, options);
    formatter(decode(key, options), value, returnValue);
    parameterStart = index2 + 1;
  }
  for (const [key, value] of Object.entries(returnValue)) {
    if (typeof value === "object" && value !== null && options.types[key] !== "string") {
      for (const [key2, value2] of Object.entries(value)) {
        const typeOption = options.types[key];
        const type = typeof typeOption === "function" ? typeOption : typeOption ? typeOption.replace("[]", "") : void 0;
        value[key2] = parseValue(value2, options, type);
      }
    } else if (typeof value === "object" && value !== null && options.types[key] === "string") {
      returnValue[key] = Object.values(value).join(options.arrayFormatSeparator);
    } else {
      returnValue[key] = parseValue(value, options, options.types[key]);
    }
  }
  if (options.sort === false) {
    return returnValue;
  }
  return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key) => {
    const value = returnValue[key];
    result[key] = Boolean(value) && typeof value === "object" && !Array.isArray(value) ? keysSorter(value) : value;
    return result;
  }, /* @__PURE__ */ Object.create(null));
}
function stringify(object2, options) {
  if (!object2) {
    return "";
  }
  options = {
    encode: true,
    strict: true,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...options
  };
  validateArrayFormatSeparator(options.arrayFormatSeparator);
  const shouldFilter = (key) => options.skipNull && isNullOrUndefined(object2[key]) || options.skipEmptyString && object2[key] === "";
  const formatter = encoderForArrayFormat(options);
  const objectCopy = {};
  for (const [key, value] of Object.entries(object2)) {
    if (!shouldFilter(key)) {
      objectCopy[key] = value;
    }
  }
  const keys3 = Object.keys(objectCopy);
  if (options.sort !== false) {
    keys3.sort(options.sort);
  }
  return keys3.map((key) => {
    let value = object2[key];
    if (options.replacer) {
      value = options.replacer(key, value);
      if (value === void 0) {
        return "";
      }
    }
    if (value === void 0) {
      return "";
    }
    if (value === null) {
      return encode(key, options);
    }
    if (Array.isArray(value)) {
      if (value.length === 0 && options.arrayFormat === "bracket-separator") {
        return encode(key, options) + "[]";
      }
      let processedArray = value;
      if (options.replacer) {
        processedArray = value.map(
          (item, index2) => options.replacer(`${key}[${index2}]`, item)
        ).filter((item) => item !== void 0);
      }
      const result = processedArray.reduce(formatter(key), []);
      const arrayFormatSeparator = ["comma", "separator", "bracket-separator"].includes(options.arrayFormat) ? options.arrayFormatSeparator : "&";
      return result.join(arrayFormatSeparator);
    }
    return encode(key, options) + "=" + encode(value, options);
  }).filter((x) => x.length > 0).join("&");
}
function parseUrl(url, options) {
  options = {
    decode: true,
    ...options
  };
  let [url_, hash] = splitOnFirst(url, "#");
  if (url_ === void 0) {
    url_ = url;
  }
  return {
    url: getUrlWithoutQuery(url_ ?? ""),
    query: parse$1(extract(url), options),
    ...options && options.parseFragmentIdentifier && hash ? { fragmentIdentifier: decode(hash, options) } : {}
  };
}
function stringifyUrl(object2, options) {
  options = {
    encode: true,
    strict: true,
    [encodeFragmentIdentifier]: true,
    ...options
  };
  const url = getUrlWithoutQuery(removeHash(object2.url)) || "";
  const queryFromUrl = extract(object2.url);
  const query2 = {
    ...parse$1(queryFromUrl, { sort: false, ...options }),
    ...object2.query
  };
  let queryString2 = stringify(query2, options);
  queryString2 &&= `?${queryString2}`;
  let hash = getHash(object2.url);
  if (typeof object2.fragmentIdentifier === "string") {
    hash = `#${object2.fragmentIdentifier}`;
    if (options[encodeFragmentIdentifier]) {
      const throwawayUrl = new URL("https://query-string.invalid");
      throwawayUrl.hash = hash;
      hash = throwawayUrl.hash;
    }
  }
  return `${url}${queryString2}${hash}`;
}
function pick(input, filter, options) {
  options = {
    parseFragmentIdentifier: true,
    [encodeFragmentIdentifier]: false,
    ...options
  };
  const { url, query: query2, fragmentIdentifier } = parseUrl(input, options);
  return stringifyUrl({
    url,
    query: includeKeys(query2, filter),
    fragmentIdentifier
  }, options);
}
function exclude(input, filter, options) {
  if (Array.isArray(filter)) {
    const filterSet = new Set(filter);
    return pick(input, (key) => !filterSet.has(key), options);
  }
  return pick(input, (key, value) => !filter(key, value), options);
}
const queryString = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude,
  extract,
  parse: parse$1,
  parseUrl,
  pick,
  stringify,
  stringifyUrl
}, Symbol.toStringTag, { value: "Module" }));
const AUTH_URL = () => window.serviceUrls.user;
const CATALOG_SERVICE_URL = () => window.serviceUrls.catalog;
const ORDER_SERVICE_URL = () => window.serviceUrls.order;
const LOYALTY_SERVICE_URL = () => window.serviceUrls.loyalty;
const CLIENT_OAUTH = "frontend";
const CLIENT_SECRET_OAUTH = "1234";
const NUMBERED_IFRAME_URL = () => window.serviceUrls.seat;
var actions$1 = {};
var _const = {};
var hasRequired_const;
function require_const() {
  if (hasRequired_const) return _const;
  hasRequired_const = 1;
  Object.defineProperty(_const, "__esModule", {
    value: true
  });
  _const.RNS_SHOW_NOTIFICATION = "RNS_SHOW_NOTIFICATION";
  _const.RNS_HIDE_NOTIFICATION = "RNS_HIDE_NOTIFICATION";
  _const.RNS_REMOVE_ALL_NOTIFICATIONS = "RNS_REMOVE_ALL_NOTIFICATIONS";
  return _const;
}
var hasRequiredActions;
function requireActions() {
  if (hasRequiredActions) return actions$1;
  hasRequiredActions = 1;
  Object.defineProperty(actions$1, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  actions$1.show = show2;
  actions$1.success = success;
  actions$1.error = error;
  actions$1.warning = warning2;
  actions$1.info = info;
  actions$1.hide = hide2;
  actions$1.removeAll = removeAll;
  var _const2 = require_const();
  function show2() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "success";
    return _extends2({
      type: _const2.RNS_SHOW_NOTIFICATION
    }, opts, {
      uid: opts.uid || Date.now(),
      level
    });
  }
  function success(opts) {
    return show2(opts, "success");
  }
  function error(opts) {
    return show2(opts, "error");
  }
  function warning2(opts) {
    return show2(opts, "warning");
  }
  function info(opts) {
    return show2(opts, "info");
  }
  function hide2(uid2) {
    return {
      type: _const2.RNS_HIDE_NOTIFICATION,
      uid: uid2
    };
  }
  function removeAll() {
    return { type: _const2.RNS_REMOVE_ALL_NOTIFICATIONS };
  }
  return actions$1;
}
var reducer = {};
var hasRequiredReducer;
function requireReducer() {
  if (hasRequiredReducer) return reducer;
  hasRequiredReducer = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _extends2 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    exports2["default"] = Notifications;
    var _const2 = require_const();
    function _toConsumableArray2(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      } else {
        return Array.from(arr);
      }
    }
    function _objectWithoutProperties2(obj, keys3) {
      var target = {};
      for (var i in obj) {
        if (keys3.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    }
    function Notifications() {
      var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      var action = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      switch (action.type) {
        case _const2.RNS_SHOW_NOTIFICATION:
          action.type;
          var rest = _objectWithoutProperties2(action, ["type"]);
          return [].concat(_toConsumableArray2(state), [_extends2({}, rest, { uid: action.uid })]);
        case _const2.RNS_HIDE_NOTIFICATION:
          return state.filter(function(notification) {
            return notification.uid !== action.uid;
          });
        case _const2.RNS_REMOVE_ALL_NOTIFICATIONS:
          return [];
      }
      return state;
    }
  })(reducer);
  return reducer;
}
var factory_1;
var hasRequiredFactory;
function requireFactory() {
  if (hasRequiredFactory) return factory_1;
  hasRequiredFactory = 1;
  var _assign = requireObjectAssign();
  var emptyObject = {};
  if (process.env.NODE_ENV !== "production") {
    Object.freeze(emptyObject);
  }
  var validateFormat = function validateFormat2(format2) {
  };
  if (process.env.NODE_ENV !== "production") {
    validateFormat = function validateFormat2(format2) {
      if (format2 === void 0) {
        throw new Error("invariant requires an error message argument");
      }
    };
  }
  function _invariant(condition, format2, a, b, c, d, e, f) {
    validateFormat(format2);
    if (!condition) {
      var error;
      if (format2 === void 0) {
        error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        error = new Error(format2.replace(/%s/g, function() {
          return args[argIndex++];
        }));
        error.name = "Invariant Violation";
      }
      error.framesToPop = 1;
      throw error;
    }
  }
  var warning2 = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var printWarning = function printWarning2(format2) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var argIndex = 0;
      var message = "Warning: " + format2.replace(/%s/g, function() {
        return args[argIndex++];
      });
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
    warning2 = function warning3(condition, format2) {
      if (format2 === void 0) {
        throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
      }
      if (format2.indexOf("Failed Composite propType: ") === 0) {
        return;
      }
      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }
        printWarning.apply(void 0, [format2].concat(args));
      }
    };
  }
  var MIXINS_KEY = "mixins";
  function identity2(fn) {
    return fn;
  }
  var ReactPropTypeLocationNames;
  if (process.env.NODE_ENV !== "production") {
    ReactPropTypeLocationNames = {
      prop: "prop",
      context: "context",
      childContext: "child context"
    };
  } else {
    ReactPropTypeLocationNames = {};
  }
  function factory(ReactComponent, isValidElement2, ReactNoopUpdateQueue) {
    var injectedMixins = [];
    var ReactClassInterface = {
      /**
       * An array of Mixin objects to include when defining your component.
       *
       * @type {array}
       * @optional
       */
      mixins: "DEFINE_MANY",
      /**
       * An object containing properties and methods that should be defined on
       * the component's constructor instead of its prototype (static methods).
       *
       * @type {object}
       * @optional
       */
      statics: "DEFINE_MANY",
      /**
       * Definition of prop types for this component.
       *
       * @type {object}
       * @optional
       */
      propTypes: "DEFINE_MANY",
      /**
       * Definition of context types for this component.
       *
       * @type {object}
       * @optional
       */
      contextTypes: "DEFINE_MANY",
      /**
       * Definition of context types this component sets for its children.
       *
       * @type {object}
       * @optional
       */
      childContextTypes: "DEFINE_MANY",
      // ==== Definition methods ====
      /**
       * Invoked when the component is mounted. Values in the mapping will be set on
       * `this.props` if that prop is not specified (i.e. using an `in` check).
       *
       * This method is invoked before `getInitialState` and therefore cannot rely
       * on `this.state` or use `this.setState`.
       *
       * @return {object}
       * @optional
       */
      getDefaultProps: "DEFINE_MANY_MERGED",
      /**
       * Invoked once before the component is mounted. The return value will be used
       * as the initial value of `this.state`.
       *
       *   getInitialState: function() {
       *     return {
       *       isOn: false,
       *       fooBaz: new BazFoo()
       *     }
       *   }
       *
       * @return {object}
       * @optional
       */
      getInitialState: "DEFINE_MANY_MERGED",
      /**
       * @return {object}
       * @optional
       */
      getChildContext: "DEFINE_MANY_MERGED",
      /**
       * Uses props from `this.props` and state from `this.state` to render the
       * structure of the component.
       *
       * No guarantees are made about when or how often this method is invoked, so
       * it must not have side effects.
       *
       *   render: function() {
       *     var name = this.props.name;
       *     return <div>Hello, {name}!</div>;
       *   }
       *
       * @return {ReactComponent}
       * @required
       */
      render: "DEFINE_ONCE",
      // ==== Delegate methods ====
      /**
       * Invoked when the component is initially created and about to be mounted.
       * This may have side effects, but any external subscriptions or data created
       * by this method must be cleaned up in `componentWillUnmount`.
       *
       * @optional
       */
      componentWillMount: "DEFINE_MANY",
      /**
       * Invoked when the component has been mounted and has a DOM representation.
       * However, there is no guarantee that the DOM node is in the document.
       *
       * Use this as an opportunity to operate on the DOM when the component has
       * been mounted (initialized and rendered) for the first time.
       *
       * @param {DOMElement} rootNode DOM element representing the component.
       * @optional
       */
      componentDidMount: "DEFINE_MANY",
      /**
       * Invoked before the component receives new props.
       *
       * Use this as an opportunity to react to a prop transition by updating the
       * state using `this.setState`. Current props are accessed via `this.props`.
       *
       *   componentWillReceiveProps: function(nextProps, nextContext) {
       *     this.setState({
       *       likesIncreasing: nextProps.likeCount > this.props.likeCount
       *     });
       *   }
       *
       * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
       * transition may cause a state change, but the opposite is not true. If you
       * need it, you are probably looking for `componentWillUpdate`.
       *
       * @param {object} nextProps
       * @optional
       */
      componentWillReceiveProps: "DEFINE_MANY",
      /**
       * Invoked while deciding if the component should be updated as a result of
       * receiving new props, state and/or context.
       *
       * Use this as an opportunity to `return false` when you're certain that the
       * transition to the new props/state/context will not require a component
       * update.
       *
       *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
       *     return !equal(nextProps, this.props) ||
       *       !equal(nextState, this.state) ||
       *       !equal(nextContext, this.context);
       *   }
       *
       * @param {object} nextProps
       * @param {?object} nextState
       * @param {?object} nextContext
       * @return {boolean} True if the component should update.
       * @optional
       */
      shouldComponentUpdate: "DEFINE_ONCE",
      /**
       * Invoked when the component is about to update due to a transition from
       * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
       * and `nextContext`.
       *
       * Use this as an opportunity to perform preparation before an update occurs.
       *
       * NOTE: You **cannot** use `this.setState()` in this method.
       *
       * @param {object} nextProps
       * @param {?object} nextState
       * @param {?object} nextContext
       * @param {ReactReconcileTransaction} transaction
       * @optional
       */
      componentWillUpdate: "DEFINE_MANY",
      /**
       * Invoked when the component's DOM representation has been updated.
       *
       * Use this as an opportunity to operate on the DOM when the component has
       * been updated.
       *
       * @param {object} prevProps
       * @param {?object} prevState
       * @param {?object} prevContext
       * @param {DOMElement} rootNode DOM element representing the component.
       * @optional
       */
      componentDidUpdate: "DEFINE_MANY",
      /**
       * Invoked when the component is about to be removed from its parent and have
       * its DOM representation destroyed.
       *
       * Use this as an opportunity to deallocate any external resources.
       *
       * NOTE: There is no `componentDidUnmount` since your component will have been
       * destroyed by that point.
       *
       * @optional
       */
      componentWillUnmount: "DEFINE_MANY",
      /**
       * Replacement for (deprecated) `componentWillMount`.
       *
       * @optional
       */
      UNSAFE_componentWillMount: "DEFINE_MANY",
      /**
       * Replacement for (deprecated) `componentWillReceiveProps`.
       *
       * @optional
       */
      UNSAFE_componentWillReceiveProps: "DEFINE_MANY",
      /**
       * Replacement for (deprecated) `componentWillUpdate`.
       *
       * @optional
       */
      UNSAFE_componentWillUpdate: "DEFINE_MANY",
      // ==== Advanced methods ====
      /**
       * Updates the component's currently mounted DOM representation.
       *
       * By default, this implements React's rendering and reconciliation algorithm.
       * Sophisticated clients may wish to override this.
       *
       * @param {ReactReconcileTransaction} transaction
       * @internal
       * @overridable
       */
      updateComponent: "OVERRIDE_BASE"
    };
    var ReactClassStaticInterface = {
      /**
       * This method is invoked after a component is instantiated and when it
       * receives new props. Return an object to update state in response to
       * prop changes. Return null to indicate no change to state.
       *
       * If an object is returned, its keys will be merged into the existing state.
       *
       * @return {object || null}
       * @optional
       */
      getDerivedStateFromProps: "DEFINE_MANY_MERGED"
    };
    var RESERVED_SPEC_KEYS = {
      displayName: function(Constructor, displayName) {
        Constructor.displayName = displayName;
      },
      mixins: function(Constructor, mixins) {
        if (mixins) {
          for (var i = 0; i < mixins.length; i++) {
            mixSpecIntoComponent(Constructor, mixins[i]);
          }
        }
      },
      childContextTypes: function(Constructor, childContextTypes) {
        if (process.env.NODE_ENV !== "production") {
          validateTypeDef(Constructor, childContextTypes, "childContext");
        }
        Constructor.childContextTypes = _assign(
          {},
          Constructor.childContextTypes,
          childContextTypes
        );
      },
      contextTypes: function(Constructor, contextTypes) {
        if (process.env.NODE_ENV !== "production") {
          validateTypeDef(Constructor, contextTypes, "context");
        }
        Constructor.contextTypes = _assign(
          {},
          Constructor.contextTypes,
          contextTypes
        );
      },
      /**
       * Special case getDefaultProps which should move into statics but requires
       * automatic merging.
       */
      getDefaultProps: function(Constructor, getDefaultProps) {
        if (Constructor.getDefaultProps) {
          Constructor.getDefaultProps = createMergedResultFunction(
            Constructor.getDefaultProps,
            getDefaultProps
          );
        } else {
          Constructor.getDefaultProps = getDefaultProps;
        }
      },
      propTypes: function(Constructor, propTypes2) {
        if (process.env.NODE_ENV !== "production") {
          validateTypeDef(Constructor, propTypes2, "prop");
        }
        Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes2);
      },
      statics: function(Constructor, statics) {
        mixStaticSpecIntoComponent(Constructor, statics);
      },
      autobind: function() {
      }
    };
    function validateTypeDef(Constructor, typeDef, location) {
      for (var propName in typeDef) {
        if (typeDef.hasOwnProperty(propName)) {
          if (process.env.NODE_ENV !== "production") {
            warning2(
              typeof typeDef[propName] === "function",
              "%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.",
              Constructor.displayName || "ReactClass",
              ReactPropTypeLocationNames[location],
              propName
            );
          }
        }
      }
    }
    function validateMethodOverride(isAlreadyDefined, name) {
      var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
      if (ReactClassMixin.hasOwnProperty(name)) {
        _invariant(
          specPolicy === "OVERRIDE_BASE",
          "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.",
          name
        );
      }
      if (isAlreadyDefined) {
        _invariant(
          specPolicy === "DEFINE_MANY" || specPolicy === "DEFINE_MANY_MERGED",
          "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
          name
        );
      }
    }
    function mixSpecIntoComponent(Constructor, spec) {
      if (!spec) {
        if (process.env.NODE_ENV !== "production") {
          var typeofSpec = typeof spec;
          var isMixinValid = typeofSpec === "object" && spec !== null;
          if (process.env.NODE_ENV !== "production") {
            warning2(
              isMixinValid,
              "%s: You're attempting to include a mixin that is either null or not an object. Check the mixins included by the component, as well as any mixins they include themselves. Expected object but got %s.",
              Constructor.displayName || "ReactClass",
              spec === null ? null : typeofSpec
            );
          }
        }
        return;
      }
      _invariant(
        typeof spec !== "function",
        "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object."
      );
      _invariant(
        !isValidElement2(spec),
        "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object."
      );
      var proto = Constructor.prototype;
      var autoBindPairs = proto.__reactAutoBindPairs;
      if (spec.hasOwnProperty(MIXINS_KEY)) {
        RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
      }
      for (var name in spec) {
        if (!spec.hasOwnProperty(name)) {
          continue;
        }
        if (name === MIXINS_KEY) {
          continue;
        }
        var property2 = spec[name];
        var isAlreadyDefined = proto.hasOwnProperty(name);
        validateMethodOverride(isAlreadyDefined, name);
        if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
          RESERVED_SPEC_KEYS[name](Constructor, property2);
        } else {
          var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
          var isFunction3 = typeof property2 === "function";
          var shouldAutoBind = isFunction3 && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
          if (shouldAutoBind) {
            autoBindPairs.push(name, property2);
            proto[name] = property2;
          } else {
            if (isAlreadyDefined) {
              var specPolicy = ReactClassInterface[name];
              _invariant(
                isReactClassMethod && (specPolicy === "DEFINE_MANY_MERGED" || specPolicy === "DEFINE_MANY"),
                "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.",
                specPolicy,
                name
              );
              if (specPolicy === "DEFINE_MANY_MERGED") {
                proto[name] = createMergedResultFunction(proto[name], property2);
              } else if (specPolicy === "DEFINE_MANY") {
                proto[name] = createChainedFunction(proto[name], property2);
              }
            } else {
              proto[name] = property2;
              if (process.env.NODE_ENV !== "production") {
                if (typeof property2 === "function" && spec.displayName) {
                  proto[name].displayName = spec.displayName + "_" + name;
                }
              }
            }
          }
        }
      }
    }
    function mixStaticSpecIntoComponent(Constructor, statics) {
      if (!statics) {
        return;
      }
      for (var name in statics) {
        var property2 = statics[name];
        if (!statics.hasOwnProperty(name)) {
          continue;
        }
        var isReserved = name in RESERVED_SPEC_KEYS;
        _invariant(
          !isReserved,
          'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.',
          name
        );
        var isAlreadyDefined = name in Constructor;
        if (isAlreadyDefined) {
          var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;
          _invariant(
            specPolicy === "DEFINE_MANY_MERGED",
            "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
            name
          );
          Constructor[name] = createMergedResultFunction(Constructor[name], property2);
          return;
        }
        Constructor[name] = property2;
      }
    }
    function mergeIntoWithNoDuplicateKeys(one, two) {
      _invariant(
        one && two && typeof one === "object" && typeof two === "object",
        "mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects."
      );
      for (var key in two) {
        if (two.hasOwnProperty(key)) {
          _invariant(
            one[key] === void 0,
            "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.",
            key
          );
          one[key] = two[key];
        }
      }
      return one;
    }
    function createMergedResultFunction(one, two) {
      return function mergedResult() {
        var a = one.apply(this, arguments);
        var b = two.apply(this, arguments);
        if (a == null) {
          return b;
        } else if (b == null) {
          return a;
        }
        var c = {};
        mergeIntoWithNoDuplicateKeys(c, a);
        mergeIntoWithNoDuplicateKeys(c, b);
        return c;
      };
    }
    function createChainedFunction(one, two) {
      return function chainedFunction() {
        one.apply(this, arguments);
        two.apply(this, arguments);
      };
    }
    function bindAutoBindMethod(component, method) {
      var boundMethod = method.bind(component);
      if (process.env.NODE_ENV !== "production") {
        boundMethod.__reactBoundContext = component;
        boundMethod.__reactBoundMethod = method;
        boundMethod.__reactBoundArguments = null;
        var componentName = component.constructor.displayName;
        var _bind = boundMethod.bind;
        boundMethod.bind = function(newThis) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          if (newThis !== component && newThis !== null) {
            if (process.env.NODE_ENV !== "production") {
              warning2(
                false,
                "bind(): React component methods may only be bound to the component instance. See %s",
                componentName
              );
            }
          } else if (!args.length) {
            if (process.env.NODE_ENV !== "production") {
              warning2(
                false,
                "bind(): You are binding a component method to the component. React does this for you automatically in a high-performance way, so you can safely remove this call. See %s",
                componentName
              );
            }
            return boundMethod;
          }
          var reboundMethod = _bind.apply(boundMethod, arguments);
          reboundMethod.__reactBoundContext = component;
          reboundMethod.__reactBoundMethod = method;
          reboundMethod.__reactBoundArguments = args;
          return reboundMethod;
        };
      }
      return boundMethod;
    }
    function bindAutoBindMethods(component) {
      var pairs = component.__reactAutoBindPairs;
      for (var i = 0; i < pairs.length; i += 2) {
        var autoBindKey = pairs[i];
        var method = pairs[i + 1];
        component[autoBindKey] = bindAutoBindMethod(component, method);
      }
    }
    var IsMountedPreMixin = {
      componentDidMount: function() {
        this.__isMounted = true;
      }
    };
    var IsMountedPostMixin = {
      componentWillUnmount: function() {
        this.__isMounted = false;
      }
    };
    var ReactClassMixin = {
      /**
       * TODO: This will be deprecated because state should always keep a consistent
       * type signature and the only use case for this, is to avoid that.
       */
      replaceState: function(newState, callback) {
        this.updater.enqueueReplaceState(this, newState, callback);
      },
      /**
       * Checks whether or not this composite component is mounted.
       * @return {boolean} True if mounted, false otherwise.
       * @protected
       * @final
       */
      isMounted: function() {
        if (process.env.NODE_ENV !== "production") {
          warning2(
            this.__didWarnIsMounted,
            "%s: isMounted is deprecated. Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks.",
            this.constructor && this.constructor.displayName || this.name || "Component"
          );
          this.__didWarnIsMounted = true;
        }
        return !!this.__isMounted;
      }
    };
    var ReactClassComponent = function() {
    };
    _assign(
      ReactClassComponent.prototype,
      ReactComponent.prototype,
      ReactClassMixin
    );
    function createClass2(spec) {
      var Constructor = identity2(function(props, context, updater) {
        if (process.env.NODE_ENV !== "production") {
          warning2(
            this instanceof Constructor,
            "Something is calling a React component directly. Use a factory or JSX instead. See: https://fb.me/react-legacyfactory"
          );
        }
        if (this.__reactAutoBindPairs.length) {
          bindAutoBindMethods(this);
        }
        this.props = props;
        this.context = context;
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
        this.state = null;
        var initialState2 = this.getInitialState ? this.getInitialState() : null;
        if (process.env.NODE_ENV !== "production") {
          if (initialState2 === void 0 && this.getInitialState._isMockFunction) {
            initialState2 = null;
          }
        }
        _invariant(
          typeof initialState2 === "object" && !Array.isArray(initialState2),
          "%s.getInitialState(): must return an object or null",
          Constructor.displayName || "ReactCompositeComponent"
        );
        this.state = initialState2;
      });
      Constructor.prototype = new ReactClassComponent();
      Constructor.prototype.constructor = Constructor;
      Constructor.prototype.__reactAutoBindPairs = [];
      injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
      mixSpecIntoComponent(Constructor, IsMountedPreMixin);
      mixSpecIntoComponent(Constructor, spec);
      mixSpecIntoComponent(Constructor, IsMountedPostMixin);
      if (Constructor.getDefaultProps) {
        Constructor.defaultProps = Constructor.getDefaultProps();
      }
      if (process.env.NODE_ENV !== "production") {
        if (Constructor.getDefaultProps) {
          Constructor.getDefaultProps.isReactClassApproved = {};
        }
        if (Constructor.prototype.getInitialState) {
          Constructor.prototype.getInitialState.isReactClassApproved = {};
        }
      }
      _invariant(
        Constructor.prototype.render,
        "createClass(...): Class specification must implement a `render` method."
      );
      if (process.env.NODE_ENV !== "production") {
        warning2(
          !Constructor.prototype.componentShouldUpdate,
          "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
          spec.displayName || "A component"
        );
        warning2(
          !Constructor.prototype.componentWillRecieveProps,
          "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
          spec.displayName || "A component"
        );
        warning2(
          !Constructor.prototype.UNSAFE_componentWillRecieveProps,
          "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
          spec.displayName || "A component"
        );
      }
      for (var methodName in ReactClassInterface) {
        if (!Constructor.prototype[methodName]) {
          Constructor.prototype[methodName] = null;
        }
      }
      return Constructor;
    }
    return createClass2;
  }
  factory_1 = factory;
  return factory_1;
}
var createReactClass;
var hasRequiredCreateReactClass;
function requireCreateReactClass() {
  if (hasRequiredCreateReactClass) return createReactClass;
  hasRequiredCreateReactClass = 1;
  var React2 = React__default;
  var factory = requireFactory();
  if (typeof React2 === "undefined") {
    throw Error(
      "create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class."
    );
  }
  var ReactNoopUpdateQueue = new React2.Component().updater;
  createReactClass = factory(
    React2.Component,
    React2.isValidElement,
    ReactNoopUpdateQueue
  );
  return createReactClass;
}
var constants;
var hasRequiredConstants;
function requireConstants() {
  if (hasRequiredConstants) return constants;
  hasRequiredConstants = 1;
  var CONSTANTS = {
    // Positions
    positions: {
      tl: "tl",
      tr: "tr",
      tc: "tc",
      bl: "bl",
      br: "br",
      bc: "bc"
    },
    // Levels
    levels: {
      success: "success",
      error: "error",
      warning: "warning",
      info: "info"
    },
    // Notification defaults
    notification: {
      title: null,
      message: null,
      level: null,
      position: "tr",
      autoDismiss: 5,
      dismissible: "both",
      action: null
    }
  };
  constants = CONSTANTS;
  return constants;
}
var helpers;
var hasRequiredHelpers;
function requireHelpers() {
  if (hasRequiredHelpers) return helpers;
  hasRequiredHelpers = 1;
  var Helpers = {
    Timer: function(callback, delay) {
      var timerId;
      var start;
      var remaining = delay;
      this.pause = function() {
        clearTimeout(timerId);
        remaining -= /* @__PURE__ */ new Date() - start;
      };
      this.resume = function() {
        start = /* @__PURE__ */ new Date();
        clearTimeout(timerId);
        timerId = setTimeout(callback, remaining);
      };
      this.clear = function() {
        clearTimeout(timerId);
      };
      this.resume();
    }
  };
  helpers = Helpers;
  return helpers;
}
var NotificationItem_1;
var hasRequiredNotificationItem;
function requireNotificationItem() {
  if (hasRequiredNotificationItem) return NotificationItem_1;
  hasRequiredNotificationItem = 1;
  var React2 = React__default;
  var createReactClass2 = requireCreateReactClass();
  var PropTypes2 = /* @__PURE__ */ requirePropTypes();
  var ReactDOM = require$$3;
  var Constants = requireConstants();
  var Helpers = requireHelpers();
  var merge2 = requireObjectAssign();
  var whichTransitionEvent = function() {
    var el = document.createElement("fakeelement");
    var transition;
    var transitions = {
      transition: "transitionend",
      OTransition: "oTransitionEnd",
      MozTransition: "transitionend",
      WebkitTransition: "webkitTransitionEnd"
    };
    Object.keys(transitions).forEach(function(transitionKey) {
      if (el.style[transitionKey] !== void 0) {
        transition = transitions[transitionKey];
      }
    });
    return transition;
  };
  var NotificationItem = createReactClass2({
    propTypes: {
      notification: PropTypes2.object,
      getStyles: PropTypes2.object,
      onRemove: PropTypes2.func,
      allowHTML: PropTypes2.bool,
      noAnimation: PropTypes2.bool,
      children: PropTypes2.oneOfType([
        PropTypes2.string,
        PropTypes2.element
      ])
    },
    getDefaultProps: function() {
      return {
        noAnimation: false,
        onRemove: function() {
        },
        allowHTML: false
      };
    },
    getInitialState: function() {
      return {
        visible: void 0,
        removed: false
      };
    },
    componentWillMount: function() {
      var getStyles = this.props.getStyles;
      var level = this.props.notification.level;
      var dismissible = this.props.notification.dismissible;
      this._noAnimation = this.props.noAnimation;
      this._styles = {
        notification: getStyles.byElement("notification")(level),
        title: getStyles.byElement("title")(level),
        dismiss: getStyles.byElement("dismiss")(level),
        messageWrapper: getStyles.byElement("messageWrapper")(level),
        actionWrapper: getStyles.byElement("actionWrapper")(level),
        action: getStyles.byElement("action")(level)
      };
      if (!dismissible || dismissible === "none" || dismissible === "button") {
        this._styles.notification.cursor = "default";
      }
    },
    _styles: {},
    _notificationTimer: null,
    _height: 0,
    _noAnimation: null,
    _isMounted: false,
    _removeCount: 0,
    _getCssPropertyByPosition: function() {
      var position = this.props.notification.position;
      var css = {};
      switch (position) {
        case Constants.positions.tl:
        case Constants.positions.bl:
          css = {
            property: "left",
            value: -200
          };
          break;
        case Constants.positions.tr:
        case Constants.positions.br:
          css = {
            property: "right",
            value: -200
          };
          break;
        case Constants.positions.tc:
          css = {
            property: "top",
            value: -100
          };
          break;
        case Constants.positions.bc:
          css = {
            property: "bottom",
            value: -100
          };
          break;
      }
      return css;
    },
    _defaultAction: function(event) {
      var notification = this.props.notification;
      event.preventDefault();
      this._hideNotification();
      if (typeof notification.action.callback === "function") {
        notification.action.callback();
      }
    },
    _hideNotification: function() {
      if (this._notificationTimer) {
        this._notificationTimer.clear();
      }
      if (this._isMounted) {
        this.setState({
          visible: false,
          removed: true
        });
      }
      if (this._noAnimation) {
        this._removeNotification();
      }
    },
    _removeNotification: function() {
      this.props.onRemove(this.props.notification.uid);
    },
    _dismiss: function() {
      if (!this.props.notification.dismissible) {
        return;
      }
      this._hideNotification();
    },
    _showNotification: function() {
      var self2 = this;
      setTimeout(function() {
        if (self2._isMounted) {
          self2.setState({
            visible: true
          });
        }
      }, 50);
    },
    _onTransitionEnd: function() {
      if (this._removeCount > 0) return;
      if (this.state.removed) {
        this._removeCount += 1;
        this._removeNotification();
      }
    },
    componentDidMount: function() {
      var self2 = this;
      var transitionEvent = whichTransitionEvent();
      var notification = this.props.notification;
      var element = ReactDOM.findDOMNode(this);
      this._height = element.offsetHeight;
      this._isMounted = true;
      if (!this._noAnimation) {
        if (transitionEvent) {
          element.addEventListener(transitionEvent, this._onTransitionEnd);
        } else {
          this._noAnimation = true;
        }
      }
      if (notification.autoDismiss) {
        this._notificationTimer = new Helpers.Timer(function() {
          self2._hideNotification();
        }, notification.autoDismiss * 1e3);
      }
      this._showNotification();
    },
    _handleMouseEnter: function() {
      var notification = this.props.notification;
      if (notification.autoDismiss) {
        this._notificationTimer.pause();
      }
    },
    _handleMouseLeave: function() {
      var notification = this.props.notification;
      if (notification.autoDismiss) {
        this._notificationTimer.resume();
      }
    },
    _handleNotificationClick: function() {
      var dismissible = this.props.notification.dismissible;
      if (dismissible === "both" || dismissible === "click" || dismissible === true) {
        this._dismiss();
      }
    },
    componentWillUnmount: function() {
      var element = ReactDOM.findDOMNode(this);
      var transitionEvent = whichTransitionEvent();
      element.removeEventListener(transitionEvent, this._onTransitionEnd);
      this._isMounted = false;
    },
    _allowHTML: function(string2) {
      return { __html: string2 };
    },
    render: function() {
      var notification = this.props.notification;
      var className = "notification notification-" + notification.level;
      var notificationStyle = merge2({}, this._styles.notification);
      var cssByPos = this._getCssPropertyByPosition();
      var dismiss = null;
      var actionButton = null;
      var title = null;
      var message = null;
      if (this.state.visible) {
        className += " notification-visible";
      } else if (this.state.visible === false) {
        className += " notification-hidden";
      }
      if (notification.dismissible === "none") {
        className += " notification-not-dismissible";
      }
      if (this.props.getStyles.overrideStyle) {
        if (!this.state.visible && !this.state.removed) {
          notificationStyle[cssByPos.property] = cssByPos.value;
        }
        if (this.state.visible && !this.state.removed) {
          notificationStyle.height = this._height;
          notificationStyle[cssByPos.property] = 0;
        }
        if (this.state.removed) {
          notificationStyle.overlay = "hidden";
          notificationStyle.height = 0;
          notificationStyle.marginTop = 0;
          notificationStyle.paddingTop = 0;
          notificationStyle.paddingBottom = 0;
        }
        notificationStyle.opacity = this.state.visible ? this._styles.notification.isVisible.opacity : this._styles.notification.isHidden.opacity;
      }
      if (notification.title) {
        title = React2.createElement("h4", { className: "notification-title", style: this._styles.title }, notification.title);
      }
      if (notification.message) {
        if (this.props.allowHTML) {
          message = React2.createElement("div", { className: "notification-message", style: this._styles.messageWrapper, dangerouslySetInnerHTML: this._allowHTML(notification.message) });
        } else {
          message = React2.createElement("div", { className: "notification-message", style: this._styles.messageWrapper }, notification.message);
        }
      }
      if (notification.dismissible === "both" || notification.dismissible === "button" || notification.dismissible === true) {
        dismiss = React2.createElement("span", { className: "notification-dismiss", onClick: this._dismiss, style: this._styles.dismiss }, "×");
      }
      if (notification.action) {
        actionButton = React2.createElement(
          "div",
          { className: "notification-action-wrapper", style: this._styles.actionWrapper },
          React2.createElement(
            "button",
            {
              className: "notification-action-button",
              onClick: this._defaultAction,
              style: this._styles.action
            },
            notification.action.label
          )
        );
      }
      if (notification.children) {
        actionButton = notification.children;
      }
      return React2.createElement(
        "div",
        { className, onClick: this._handleNotificationClick, onMouseEnter: this._handleMouseEnter, onMouseLeave: this._handleMouseLeave, style: notificationStyle },
        title,
        message,
        dismiss,
        actionButton
      );
    }
  });
  NotificationItem_1 = NotificationItem;
  return NotificationItem_1;
}
var NotificationContainer_1;
var hasRequiredNotificationContainer;
function requireNotificationContainer() {
  if (hasRequiredNotificationContainer) return NotificationContainer_1;
  hasRequiredNotificationContainer = 1;
  var React2 = React__default;
  var createReactClass2 = requireCreateReactClass();
  var PropTypes2 = /* @__PURE__ */ requirePropTypes();
  var NotificationItem = requireNotificationItem();
  var Constants = requireConstants();
  var NotificationContainer = createReactClass2({
    propTypes: {
      position: PropTypes2.string.isRequired,
      notifications: PropTypes2.array.isRequired,
      getStyles: PropTypes2.object
    },
    _style: {},
    componentWillMount: function() {
      this._style = this.props.getStyles.container(this.props.position);
      if (this.props.getStyles.overrideWidth && (this.props.position === Constants.positions.tc || this.props.position === Constants.positions.bc)) {
        this._style.marginLeft = -(this.props.getStyles.overrideWidth / 2);
      }
    },
    render: function() {
      var self2 = this;
      var notifications2;
      if ([Constants.positions.bl, Constants.positions.br, Constants.positions.bc].indexOf(this.props.position) > -1) {
        this.props.notifications.reverse();
      }
      notifications2 = this.props.notifications.map(function(notification) {
        return React2.createElement(
          NotificationItem,
          {
            ref: "notification-" + notification.uid,
            key: notification.uid,
            notification,
            getStyles: self2.props.getStyles,
            onRemove: self2.props.onRemove,
            noAnimation: self2.props.noAnimation,
            allowHTML: self2.props.allowHTML,
            children: self2.props.children
          }
        );
      });
      return React2.createElement(
        "div",
        { className: "notifications-" + this.props.position, style: this._style },
        notifications2
      );
    }
  });
  NotificationContainer_1 = NotificationContainer;
  return NotificationContainer_1;
}
var styles;
var hasRequiredStyles;
function requireStyles() {
  if (hasRequiredStyles) return styles;
  hasRequiredStyles = 1;
  var defaultWidth = 320;
  var defaultColors2 = {
    success: {
      rgb: "94, 164, 0",
      hex: "#5ea400"
    },
    error: {
      rgb: "236, 61, 61",
      hex: "#ec3d3d"
    },
    warning: {
      rgb: "235, 173, 23",
      hex: "#ebad1a"
    },
    info: {
      rgb: "54, 156, 199",
      hex: "#369cc7"
    }
  };
  var defaultShadowOpacity = "0.9";
  var STYLES2 = {
    Wrapper: {},
    Containers: {
      DefaultStyle: {
        fontFamily: "inherit",
        position: "fixed",
        width: defaultWidth,
        padding: "0 10px 10px 10px",
        zIndex: 9998,
        WebkitBoxSizing: "border-box",
        MozBoxSizing: "border-box",
        boxSizing: "border-box",
        height: "auto"
      },
      tl: {
        top: "0px",
        bottom: "auto",
        left: "0px",
        right: "auto"
      },
      tr: {
        top: "0px",
        bottom: "auto",
        left: "auto",
        right: "0px"
      },
      tc: {
        top: "0px",
        bottom: "auto",
        margin: "0 auto",
        left: "50%",
        marginLeft: -160
      },
      bl: {
        top: "auto",
        bottom: "0px",
        left: "0px",
        right: "auto"
      },
      br: {
        top: "auto",
        bottom: "0px",
        left: "auto",
        right: "0px"
      },
      bc: {
        top: "auto",
        bottom: "0px",
        margin: "0 auto",
        left: "50%",
        marginLeft: -160
      }
    },
    NotificationItem: {
      DefaultStyle: {
        position: "relative",
        width: "100%",
        cursor: "pointer",
        borderRadius: "2px",
        fontSize: "13px",
        margin: "10px 0 0",
        padding: "10px",
        display: "block",
        WebkitBoxSizing: "border-box",
        MozBoxSizing: "border-box",
        boxSizing: "border-box",
        opacity: 0,
        transition: "0.3s ease-in-out",
        WebkitTransform: "translate3d(0, 0, 0)",
        transform: "translate3d(0, 0, 0)",
        willChange: "transform, opacity",
        isHidden: {
          opacity: 0
        },
        isVisible: {
          opacity: 1
        }
      },
      success: {
        borderTop: "2px solid " + defaultColors2.success.hex,
        backgroundColor: "#f0f5ea",
        color: "#4b583a",
        WebkitBoxShadow: "0 0 1px rgba(" + defaultColors2.success.rgb + "," + defaultShadowOpacity + ")",
        MozBoxShadow: "0 0 1px rgba(" + defaultColors2.success.rgb + "," + defaultShadowOpacity + ")",
        boxShadow: "0 0 1px rgba(" + defaultColors2.success.rgb + "," + defaultShadowOpacity + ")"
      },
      error: {
        borderTop: "2px solid " + defaultColors2.error.hex,
        backgroundColor: "#f4e9e9",
        color: "#412f2f",
        WebkitBoxShadow: "0 0 1px rgba(" + defaultColors2.error.rgb + "," + defaultShadowOpacity + ")",
        MozBoxShadow: "0 0 1px rgba(" + defaultColors2.error.rgb + "," + defaultShadowOpacity + ")",
        boxShadow: "0 0 1px rgba(" + defaultColors2.error.rgb + "," + defaultShadowOpacity + ")"
      },
      warning: {
        borderTop: "2px solid " + defaultColors2.warning.hex,
        backgroundColor: "#f9f6f0",
        color: "#5a5343",
        WebkitBoxShadow: "0 0 1px rgba(" + defaultColors2.warning.rgb + "," + defaultShadowOpacity + ")",
        MozBoxShadow: "0 0 1px rgba(" + defaultColors2.warning.rgb + "," + defaultShadowOpacity + ")",
        boxShadow: "0 0 1px rgba(" + defaultColors2.warning.rgb + "," + defaultShadowOpacity + ")"
      },
      info: {
        borderTop: "2px solid " + defaultColors2.info.hex,
        backgroundColor: "#e8f0f4",
        color: "#41555d",
        WebkitBoxShadow: "0 0 1px rgba(" + defaultColors2.info.rgb + "," + defaultShadowOpacity + ")",
        MozBoxShadow: "0 0 1px rgba(" + defaultColors2.info.rgb + "," + defaultShadowOpacity + ")",
        boxShadow: "0 0 1px rgba(" + defaultColors2.info.rgb + "," + defaultShadowOpacity + ")"
      }
    },
    Title: {
      DefaultStyle: {
        fontSize: "14px",
        margin: "0 0 5px 0",
        padding: 0,
        fontWeight: "bold"
      },
      success: {
        color: defaultColors2.success.hex
      },
      error: {
        color: defaultColors2.error.hex
      },
      warning: {
        color: defaultColors2.warning.hex
      },
      info: {
        color: defaultColors2.info.hex
      }
    },
    MessageWrapper: {
      DefaultStyle: {
        margin: 0,
        padding: 0
      }
    },
    Dismiss: {
      DefaultStyle: {
        cursor: "pointer",
        fontFamily: "Arial",
        fontSize: "17px",
        position: "absolute",
        top: "4px",
        right: "5px",
        lineHeight: "15px",
        backgroundColor: "#dededf",
        color: "#ffffff",
        borderRadius: "50%",
        width: "14px",
        height: "14px",
        fontWeight: "bold",
        textAlign: "center"
      },
      success: {
        color: "#f0f5ea",
        backgroundColor: "#b0ca92"
      },
      error: {
        color: "#f4e9e9",
        backgroundColor: "#e4bebe"
      },
      warning: {
        color: "#f9f6f0",
        backgroundColor: "#e1cfac"
      },
      info: {
        color: "#e8f0f4",
        backgroundColor: "#a4becb"
      }
    },
    Action: {
      DefaultStyle: {
        background: "#ffffff",
        borderRadius: "2px",
        padding: "6px 20px",
        fontWeight: "bold",
        margin: "10px 0 0 0",
        border: 0
      },
      success: {
        backgroundColor: defaultColors2.success.hex,
        color: "#ffffff"
      },
      error: {
        backgroundColor: defaultColors2.error.hex,
        color: "#ffffff"
      },
      warning: {
        backgroundColor: defaultColors2.warning.hex,
        color: "#ffffff"
      },
      info: {
        backgroundColor: defaultColors2.info.hex,
        color: "#ffffff"
      }
    },
    ActionWrapper: {
      DefaultStyle: {
        margin: 0,
        padding: 0
      }
    }
  };
  styles = STYLES2;
  return styles;
}
var NotificationSystem_1;
var hasRequiredNotificationSystem;
function requireNotificationSystem() {
  if (hasRequiredNotificationSystem) return NotificationSystem_1;
  hasRequiredNotificationSystem = 1;
  var React2 = React__default;
  var createReactClass2 = requireCreateReactClass();
  var PropTypes2 = /* @__PURE__ */ requirePropTypes();
  var merge2 = requireObjectAssign();
  var NotificationContainer = requireNotificationContainer();
  var Constants = requireConstants();
  var Styles = requireStyles();
  var NotificationSystem = createReactClass2({
    uid: 3400,
    _isMounted: false,
    _getStyles: {
      overrideStyle: {},
      overrideWidth: null,
      setOverrideStyle: function(style) {
        this.overrideStyle = style;
      },
      wrapper: function() {
        if (!this.overrideStyle) return {};
        return merge2({}, Styles.Wrapper, this.overrideStyle.Wrapper);
      },
      container: function(position) {
        var override = this.overrideStyle.Containers || {};
        if (!this.overrideStyle) return {};
        this.overrideWidth = Styles.Containers.DefaultStyle.width;
        if (override.DefaultStyle && override.DefaultStyle.width) {
          this.overrideWidth = override.DefaultStyle.width;
        }
        if (override[position] && override[position].width) {
          this.overrideWidth = override[position].width;
        }
        return merge2({}, Styles.Containers.DefaultStyle, Styles.Containers[position], override.DefaultStyle, override[position]);
      },
      elements: {
        notification: "NotificationItem",
        title: "Title",
        messageWrapper: "MessageWrapper",
        dismiss: "Dismiss",
        action: "Action",
        actionWrapper: "ActionWrapper"
      },
      byElement: function(element) {
        var self2 = this;
        return function(level) {
          var _element = self2.elements[element];
          var override = self2.overrideStyle[_element] || {};
          if (!self2.overrideStyle) return {};
          return merge2({}, Styles[_element].DefaultStyle, Styles[_element][level], override.DefaultStyle, override[level]);
        };
      }
    },
    _didNotificationRemoved: function(uid2) {
      var notification;
      var notifications2 = this.state.notifications.filter(function(toCheck) {
        if (toCheck.uid === uid2) {
          notification = toCheck;
          return false;
        }
        return true;
      });
      if (this._isMounted) {
        this.setState({ notifications: notifications2 });
      }
      if (notification && notification.onRemove) {
        notification.onRemove(notification);
      }
    },
    getInitialState: function() {
      return {
        notifications: []
      };
    },
    propTypes: {
      style: PropTypes2.oneOfType([
        PropTypes2.bool,
        PropTypes2.object
      ]),
      noAnimation: PropTypes2.bool,
      allowHTML: PropTypes2.bool
    },
    getDefaultProps: function() {
      return {
        style: {},
        noAnimation: false,
        allowHTML: false
      };
    },
    addNotification: function(notification) {
      var _notification = merge2({}, Constants.notification, notification);
      var notifications2 = this.state.notifications;
      var i;
      if (!_notification.level) {
        throw new Error("notification level is required.");
      }
      if (Object.keys(Constants.levels).indexOf(_notification.level) === -1) {
        throw new Error("'" + _notification.level + "' is not a valid level.");
      }
      if (isNaN(_notification.autoDismiss)) {
        throw new Error("'autoDismiss' must be a number.");
      }
      if (Object.keys(Constants.positions).indexOf(_notification.position) === -1) {
        throw new Error("'" + _notification.position + "' is not a valid position.");
      }
      _notification.position = _notification.position.toLowerCase();
      _notification.level = _notification.level.toLowerCase();
      _notification.autoDismiss = parseInt(_notification.autoDismiss, 10);
      _notification.uid = _notification.uid || this.uid;
      _notification.ref = "notification-" + _notification.uid;
      this.uid += 1;
      for (i = 0; i < notifications2.length; i += 1) {
        if (notifications2[i].uid === _notification.uid) {
          return false;
        }
      }
      notifications2.push(_notification);
      if (typeof _notification.onAdd === "function") {
        notification.onAdd(_notification);
      }
      this.setState({
        notifications: notifications2
      });
      return _notification;
    },
    getNotificationRef: function(notification) {
      var self2 = this;
      var foundNotification = null;
      Object.keys(this.refs).forEach(function(container) {
        if (container.indexOf("container") > -1) {
          Object.keys(self2.refs[container].refs).forEach(function(_notification) {
            var uid2 = notification.uid ? notification.uid : notification;
            if (_notification === "notification-" + uid2) {
              foundNotification = self2.refs[container].refs[_notification];
            }
          });
        }
      });
      return foundNotification;
    },
    removeNotification: function(notification) {
      var foundNotification = this.getNotificationRef(notification);
      return foundNotification && foundNotification._hideNotification();
    },
    editNotification: function(notification, newNotification) {
      var foundNotification = null;
      var uid2 = notification.uid ? notification.uid : notification;
      var newNotifications = this.state.notifications.filter(function(stateNotification) {
        if (uid2 === stateNotification.uid) {
          foundNotification = stateNotification;
          return false;
        }
        return true;
      });
      if (!foundNotification) {
        return;
      }
      newNotifications.push(merge2(
        {},
        foundNotification,
        newNotification
      ));
      this.setState({
        notifications: newNotifications
      });
    },
    clearNotifications: function() {
      var self2 = this;
      Object.keys(this.refs).forEach(function(container) {
        if (container.indexOf("container") > -1) {
          Object.keys(self2.refs[container].refs).forEach(function(_notification) {
            self2.refs[container].refs[_notification]._hideNotification();
          });
        }
      });
    },
    componentDidMount: function() {
      this._getStyles.setOverrideStyle(this.props.style);
      this._isMounted = true;
    },
    componentWillUnmount: function() {
      this._isMounted = false;
    },
    render: function() {
      var self2 = this;
      var containers = null;
      var notifications2 = this.state.notifications;
      if (notifications2.length) {
        containers = Object.keys(Constants.positions).map(function(position) {
          var _notifications = notifications2.filter(function(notification) {
            return position === notification.position;
          });
          if (!_notifications.length) {
            return null;
          }
          return React2.createElement(
            NotificationContainer,
            {
              ref: "container-" + position,
              key: position,
              position,
              notifications: _notifications,
              getStyles: self2._getStyles,
              onRemove: self2._didNotificationRemoved,
              noAnimation: self2.props.noAnimation,
              allowHTML: self2.props.allowHTML
            }
          );
        });
      }
      return React2.createElement(
        "div",
        { className: "notifications-wrapper", style: this._getStyles.wrapper() },
        containers
      );
    }
  });
  NotificationSystem_1 = NotificationSystem;
  return NotificationSystem_1;
}
var notifications;
var hasRequiredNotifications;
function requireNotifications() {
  if (hasRequiredNotifications) return notifications;
  hasRequiredNotifications = 1;
  var _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _createClass2 = /* @__PURE__ */ (function() {
    function defineProperties2(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties2(Constructor.prototype, protoProps);
      if (staticProps) defineProperties2(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _react = React__default;
  var _react2 = _interopRequireDefault(_react);
  var _propTypes = /* @__PURE__ */ requirePropTypes();
  var _propTypes2 = _interopRequireDefault(_propTypes);
  var _actions = requireActions();
  var actions2 = _interopRequireWildcard(_actions);
  var _reducer = requireReducer();
  var _reducer2 = _interopRequireDefault(_reducer);
  var _reactNotificationSystem = requireNotificationSystem();
  var _reactNotificationSystem2 = _interopRequireDefault(_reactNotificationSystem);
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }
      newObj["default"] = obj;
      return newObj;
    }
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _objectWithoutProperties2(obj, keys3) {
    var target = {};
    for (var i in obj) {
      if (keys3.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }
    return target;
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call2) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var Notifications = (function(_React$Component) {
    _inherits2(Notifications2, _React$Component);
    function Notifications2() {
      _classCallCheck2(this, Notifications2);
      return _possibleConstructorReturn2(this, (Notifications2.__proto__ || Object.getPrototypeOf(Notifications2)).apply(this, arguments));
    }
    _createClass2(Notifications2, [{
      key: "system",
      value: /* @__PURE__ */ (function() {
        function system() {
          return this.refs.notify;
        }
        return system;
      })()
    }, {
      key: "componentWillReceiveProps",
      value: /* @__PURE__ */ (function() {
        function componentWillReceiveProps2(nextProps) {
          var _this2 = this;
          var notifications2 = nextProps.notifications;
          var notificationIds = notifications2.map(function(notification) {
            return notification.uid;
          });
          var systemNotifications = this.system().state.notifications || [];
          if (notifications2.length > 0) {
            systemNotifications.forEach(function(notification) {
              if (notificationIds.indexOf(notification.uid) < 0) {
                _this2.system().removeNotification(notification.uid);
              }
            });
            notifications2.forEach(function(notification) {
              _this2.system().addNotification(_extends2({}, notification, {
                onRemove: /* @__PURE__ */ (function() {
                  function onRemove() {
                    _this2.context.store.dispatch(actions2.hide(notification.uid));
                    notification.onRemove && notification.onRemove();
                  }
                  return onRemove;
                })()
              }));
            });
          }
          if (this.props.notifications !== notifications2 && notifications2.length === 0) {
            this.system().clearNotifications();
          }
        }
        return componentWillReceiveProps2;
      })()
    }, {
      key: "shouldComponentUpdate",
      value: /* @__PURE__ */ (function() {
        function shouldComponentUpdate(nextProps) {
          return this.props !== nextProps;
        }
        return shouldComponentUpdate;
      })()
    }, {
      key: "render",
      value: /* @__PURE__ */ (function() {
        function render() {
          var _props = this.props;
          _props.notifications;
          var rest = _objectWithoutProperties2(_props, ["notifications"]);
          return _react2["default"].createElement(_reactNotificationSystem2["default"], _extends2({ ref: "notify" }, rest));
        }
        return render;
      })()
    }]);
    return Notifications2;
  })(_react2["default"].Component);
  Notifications.propTypes = {
    notifications: _propTypes2["default"].array
  };
  Notifications.contextTypes = {
    store: _propTypes2["default"].object
  };
  Object.keys(actions2).forEach(function(key) {
    Notifications[key] = actions2[key];
  });
  Notifications.reducer = _reducer2["default"];
  notifications = Notifications;
  return notifications;
}
var notificationsExports = requireNotifications();
const setCookie = (name, value, options = {}) => Cookie.set(name, value, {
  path: "/",
  sameSite: "lax",
  secure: typeof window !== "undefined" && window.location.protocol === "https:",
  ...options
});
const CMP = {
  CookieBot: {
    name: "CookieConsent",
    trigger: "statistics:true"
  },
  OneTrust: {
    name: "OptanonConsent",
    trigger: "C0002:1"
  },
  CookieFirst: {
    name: "cookiefirst-consent",
    trigger: '"performance":true'
  },
  CookiesYes: {
    name: "cookieyes-consent",
    trigger: "analytics:yes"
  },
  Hubspot: {
    name: "__hs_cookie_cat_pref",
    trigger: "1:true"
  },
  Complianz: {
    name: "cmplz_statistics",
    trigger: "allow"
  },
  Tealium: {
    name: "CONSENTMGR",
    trigger: "c1:1"
  }
};
const getExtCookie = () => {
  const entry = Object.entries(CMP).find(([, { name }]) => Cookie.get(name));
  return entry ? entry[0] : "";
};
const allowSendCookie = (gtmEventsStrictMode2) => {
  const cookieClorian = Cookie.get("cookielawinfo-checkbox-non-necessary") || "true";
  const externalCookie = getExtCookie();
  const externalCookieValue = externalCookie && Cookie.get(CMP[externalCookie].name);
  let sendCookie = false;
  switch (gtmEventsStrictMode2) {
    case "always":
      return "true";
    case "never":
      return "false";
    case "strict":
      if (cookieClorian === "true") {
        const userHasAcceptedCookies = Cookie.get("user-has-accepted-cookies") === "true";
        const nonNecessaryCookies = Cookie.get("cookielawinfo-checkbox-non-necessary") === "true";
        return userHasAcceptedCookies && nonNecessaryCookies ? "true" : "false";
      }
      return externalCookieValue && externalCookieValue.indexOf(decodeURIComponent(CMP[externalCookie].trigger)) !== -1 ? "true" : "false";
    default:
      if (externalCookie) {
        sendCookie = !!externalCookieValue && externalCookieValue.indexOf(decodeURIComponent(CMP[externalCookie].trigger)) !== -1;
      } else {
        sendCookie = cookieClorian === "true";
      }
      return sendCookie.toString();
  }
};
var add_daysExports = requireAdd_days();
const addDays = /* @__PURE__ */ getDefaultExportFromCjs(add_daysExports);
const CONFIGURATION_ADD = "CONFIGURATION_ADD";
const LOGIN_REQUEST = "LOGIN_REQUEST";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_FAILURE = "LOGIN_FAILURE";
const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
const CLIENT_CONFIGURATION_REQUEST = "CLIENT_CONFIGURATION_REQUEST";
const CLIENT_CONFIGURATION_SUCCESS = "CLIENT_CONFIGURATION_SUCCESS";
const CLIENT_CONFIGURATION_FAILURE = "CLIENT_CONFIGURATION_FAILURE";
const CLIENT_EMAIL_CONFIGURATION_REQUEST = "CLIENT_EMAIL_CONFIGURATION_REQUEST";
const CLIENT_EMAIL_CONFIGURATION_SUCCESS = "CLIENT_EMAIL_CONFIGURATION_SUCCESS";
const CLIENT_EMAIL_CONFIGURATION_FAILURE = "CLIENT_EMAIL_CONFIGURATION_FAILURE";
const LANGUAGE_REQUEST = "LANGUAGE_REQUEST";
const LANGUAGE_SUCCESS = "LANGUAGE_SUCCESS";
const LANGUAGE_FAILURE = "LANGUAGE_FAILURE";
const POINT_OF_SALE_REQUEST = "POINT_OF_SALE_REQUEST";
const POINT_OF_SALE_SUCCESS = "POINT_OF_SALE_SUCCESS";
const POINT_OF_SALE_FAILURE = "POINT_OF_SALE_FAILURE";
const SALES_GROUP_REQUEST = "SALES_GROUP_REQUEST";
const SALES_GROUP_SUCCESS = "SALES_GROUP_SUCCESS";
const SALES_GROUP_FAILURE = "SALES_GROUP_FAILURE";
const PAYMENT_METHOD_SALES_GROUP_REQUEST = "PAYMENT_METHOD_SALES_GROUP_REQUEST";
const PAYMENT_METHOD_SALES_GROUP_SUCCESS = "PAYMENT_METHOD_SALES_GROUP_SUCCESS";
const PAYMENT_METHOD_SALES_GROUP_FAILURE = "PAYMENT_METHOD_SALES_GROUP_FAILURE";
const ADDITIONAL_SITE_INFO_REQUEST = "ADDITIONAL_SITE_INFO_REQUEST";
const ADDITIONAL_SITE_INFO_SUCCESS = "ADDITIONAL_SITE_INFO_SUCCESS";
const ADDITIONAL_SITE_INFO_FAILURE = "ADDITIONAL_SITE_INFO_FAILURE";
const PRODUCT_REQUEST = "PRODUCT_REQUEST";
const PRODUCT_SUCCESS = "PRODUCT_SUCCESS";
const PRODUCT_FAILURE = "PRODUCT_FAILURE";
const PARENT_PRODUCT_REQUEST = "PARENT_PRODUCT_REQUEST";
const PARENT_PRODUCT_SUCCESS = "PARENT_PRODUCT_SUCCESS";
const PARENT_PRODUCT_FAILURE = "PARENT_PRODUCT_FAILURE";
const TIME_SLOTS_REQUEST = "TIME_SLOTS_REQUEST";
const TIME_SLOTS_SUCCESS = "TIME_SLOTS_SUCCESS";
const TIME_SLOTS_FAILURE = "TIME_SLOTS_FAILURE";
const PRODUCT_LIST_REQUEST = "PRODUCT_LIST_REQUEST";
const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
const PRODUCT_LIST_FAILURE = "PRODUCT_LIST_FAILURE";
const SUB_PRODUCT_LIST_REQUEST = "SUB_PRODUCT_LIST_REQUEST";
const SUB_PRODUCT_LIST_SUCCESS = "SUB_PRODUCT_LIST_SUCCESS";
const SUB_PRODUCT_LIST_FAILURE = "SUB_PRODUCT_LIST_FAILURE";
const PRODUCT_SERVICES_REQUEST = "PRODUCT_SERVICES_REQUEST";
const PRODUCT_SERVICES_SUCCESS = "PRODUCT_SERVICES_SUCCESS";
const PRODUCT_SERVICES_FAILURE = "PRODUCT_SERVICES_FAILURE";
const SERVICE_PRICES_REQUEST = "SERVICE_PRICES_REQUEST";
const SERVICE_PRICES_SUCCESS = "SERVICE_PRICES_SUCCESS";
const SERVICE_PRICES_FAILURE = "SERVICE_PRICES_FAILURE";
const SERVICE_PRICES_CLEAN = "SERVICE_PRICES_CLEAN";
const PRODUCT_INFO_REQUEST = "PRODUCT_INFO_REQUEST";
const PRODUCT_INFO_SUCCESS = "PRODUCT_INFO_SUCCESS";
const PRODUCT_INFO_FAILURE = "PRODUCT_INFO_FAILURE";
const PRODUCT_RECENT_EVENTS_REQUEST = "PRODUCT_RECENT_EVENTS_REQUEST";
const PRODUCT_RECENT_EVENTS_SUCCESS = "PRODUCT_RECENT_EVENTS_SUCCESS";
const PRODUCT_RECENT_EVENTS_FAILURE = "PRODUCT_RECENT_EVENTS_FAILURE";
const PRODUCT_RECENT_EVENTS_WITH_AVAILABILITY_REQUEST = "PRODUCT_RECENT_EVENTS_WITH_AVAILABILITY_REQUEST";
const PRODUCT_RECENT_EVENTS_WITH_AVAILABILITY_SUCCESS = "PRODUCT_RECENT_EVENTS_WITH_AVAILABILITY_SUCCESS";
const PRODUCT_RECENT_EVENTS_WITH_AVAILABILITY_FAILURE = "PRODUCT_RECENT_EVENTS_WITH_AVAILABILITY_FAILURE";
const GET_EVENT_BY_ID_WITH_AVAILABILITY_REQUEST = "GET_EVENT_BY_ID_WITH_AVAILABILITY_REQUEST";
const GET_EVENT_BY_ID_WITH_AVAILABILITY_SUCCESS = "GET_EVENT_BY_ID_WITH_AVAILABILITY_SUCCESS";
const GET_EVENT_BY_ID_WITH_AVAILABILITY_FAILURE = "GET_EVENT_BY_ID_WITH_AVAILABILITY_FAILURE";
const PRODUCT_RECOMMENDATION_REQUEST = "PRODUCT_RECOMMENDATION_REQUEST";
const PRODUCT_RECOMMENDATION_SUCCESS = "PRODUCT_RECOMMENDATION_SUCCESS";
const PRODUCT_RECOMMENDATION_FAILURE = "PRODUCT_RECOMMENDATION_FAILURE";
const PRODUCT_RECOMMENDATION_CLEAN = "PRODUCT_RECOMMENDATION_CLEAN";
const PRODUCT_FORMS_REQUEST = "PRODUCT_FORMS_REQUEST";
const PRODUCT_FORMS_SUCCESS = "PRODUCT_FORMS_SUCCESS";
const PRODUCT_FORMS_FAILURE = "PRODUCT_FORMS_FAILURE";
const PRODUCT_CATEGORIES_REQUEST = "PRODUCT_CATEGORIES_REQUEST";
const PRODUCT_CATEGORIES_SUCCESS = "PRODUCT_CATEGORIES_SUCCESS";
const PRODUCT_CATEGORIES_FAILURE = "PRODUCT_CATEGORIES_FAILURE";
const PRODUCT_CONFIGURATIONS_REQUEST = "PRODUCT_CONFIGURATIONS_REQUEST";
const PRODUCT_CONFIGURATIONS_SUCCESS = "PRODUCT_CONFIGURATIONS_SUCCESS";
const PRODUCT_CONFIGURATIONS_FAILURE = "PRODUCT_CONFIGURATIONS_FAILURE";
const RESERVATION_REQUEST = "RESERVATION_REQUEST";
const RESERVATION_SUCCESS = "RESERVATION_SUCCESS";
const RESERVATION_FAILURE = "RESERVATION_FAILURE";
const DELETE_RESERVATION_REQUEST = "DELETE_RESERVATION_REQUEST";
const DELETE_RESERVATION_SUCCESS = "DELETE_RESERVATION_SUCCESS";
const DELETE_RESERVATION_FAILURE = "DELETE_RESERVATION_FAILURE";
const PUT_PURCHASE_REQUEST = "PUT_PURCHASE_REQUEST";
const PUT_PURCHASE_SUCCESS = "PUT_PURCHASE_SUCCESS";
const PUT_PURCHASE_FAILURE = "PUT_PURCHASE_FAILURE";
const POST_PAYMENT_REQUEST = "POST_PAYMENT_REQUEST";
const POST_PAYMENT_SUCCESS = "POST_PAYMENT_SUCCESS";
const POST_PAYMENT_FAILURE = "POST_PAYMENT_FAILURE";
const GET_PAYMENT_REQUEST = "GET_PAYMENT_REQUEST";
const GET_PAYMENT_SUCCESS = "GET_PAYMENT_SUCCESS";
const GET_PAYMENT_FAILURE = "GET_PAYMENT_FAILURE";
const ADYEN_REQUEST = "ADYEN_REQUEST";
const ADYEN_SUCCESS = "ADYEN_SUCCESS";
const ADYEN_FAILURE = "ADYEN_FAILURE";
const ADYEN_PAYMENT_REQUEST = "ADYEN_PAYMENT_REQUEST";
const ADYEN_PAYMENT_SUCCESS = "ADYEN_PAYMENT_SUCCESS";
const ADYEN_PAYMENT_FAILURE = "ADYEN_PAYMENT_FAILURE";
const ADYEN_PAYMENT_DETAILS_REQUEST = "ADYEN_PAYMENT_DETAILS_REQUEST";
const ADYEN_PAYMENT_DETAILS_SUCCESS = "ADYEN_PAYMENT_DETAILS_SUCCESS";
const ADYEN_PAYMENT_DETAILS_FAILURE = "ADYEN_PAYMENT_DETAILS_FAILURE";
const REDSYS_INIT_REQUEST = "REDSYS_INIT_REQUEST";
const REDSYS_INIT_SUCCESS = "REDSYS_INIT_SUCCESS";
const REDSYS_INIT_FAILURE = "REDSYS_INIT_FAILURE";
const REDSYS_AUTHENTICATION_REQUEST = "REDSYS_AUTHENTICATION_REQUEST";
const REDSYS_AUTHENTICATION_SUCCESS = "REDSYS_AUTHENTICATION_SUCCESS";
const REDSYS_AUTHENTICATION_FAILURE = "REDSYS_AUTHENTICATION_FAILURE";
const YUNO_CHECKOUT_REQUEST = "YUNO_CHECKOUT_REQUEST";
const YUNO_CHECKOUT_SUCCESS = "YUNO_CHECKOUT_SUCCESS";
const YUNO_CHECKOUT_FAILURE = "YUNO_CHECKOUT_FAILURE";
const YUNO_CHECKOUT_RESET = "YUNO_CHECKOUT_RESET";
const YUNO_CREATE_PAYMENT_REQUEST = "YUNO_CREATE_PAYMENT_REQUEST";
const YUNO_CREATE_PAYMENT_SUCCESS = "YUNO_CREATE_PAYMENT_SUCCESS";
const YUNO_CREATE_PAYMENT_FAILURE = "YUNO_CREATE_PAYMENT_FAILURE";
const GET_PROSA_PAYMENT_STATUS_REQUEST = "GET_PROSA_PAYMENT_STATUS_REQUEST";
const GET_PROSA_PAYMENT_STATUS_SUCCESS = "GET_PROSA_PAYMENT_STATUS_SUCCESS";
const GET_PROSA_PAYMENT_STATUS_FAILURE = "GET_PROSA_PAYMENT_STATUS_FAILURE";
const POST_STRIPE_PAYMENT_REQUEST = "POST_STRIPE_PAYMENT_REQUEST";
const POST_STRIPE_PAYMENT_SUCCESS = "POST_STRIPE_PAYMENT_SUCCESS";
const POST_STRIPE_PAYMENT_FAILURE = "POST_STRIPE_PAYMENT_FAILURE";
const POST_RETRYPAYMENT_REQUEST = "POST_RETRYPAYMENT_REQUEST";
const POST_RETRYPAYMENT_SUCCESS = "POST_RETRYPAYMENT_SUCCESS";
const POST_RETRYPAYMENT_FAILURE = "POST_RETRYPAYMENT_FAILURE";
const GET_PURCHASE_REQUEST = "GET_PURCHASE_REQUEST";
const GET_PURCHASE_SUCCESS = "GET_PURCHASE_SUCCESS";
const GET_PURCHASE_FAILURE = "GET_PURCHASE_FAILURE";
const DELETE_PURCHASE_REQUEST = "DELETE_PURCHASE_REQUEST";
const DELETE_PURCHASE_SUCCESS = "DELETE_PURCHASE_SUCCESS";
const DELETE_PURCHASE_FAILURE = "DELETE_PURCHASE_FAILURE";
const DELETE_PURCHASE = "DELETE_PURCHASE";
const DELETE_PAYMENT_DETAILS = "DELETE_PAYMENT_DETAILS";
const BUYER_TYPES_REQUEST = "BUYER_TYPES_REQUEST";
const BUYER_TYPES_SUCCESS = "BUYER_TYPES_SUCCESS";
const BUYER_TYPES_FAILURE = "BUYER_TYPES_FAILURE";
const BUYER_TYPES_CLEAN = "BUYER_TYPES_CLEAN";
const PROMOTIONS_REQUEST = "PROMOTIONS_REQUEST";
const PROMOTIONS_SUCCESS = "PROMOTIONS_SUCCESS";
const PROMOTIONS_FAILURE = "PROMOTIONS_FAILURE";
const PROMOTION_CODE_CLEAN = "PROMOTION_CODE_CLEAN";
const PROMOTION_CODE_REQUEST = "PROMOTION_CODE_REQUEST";
const PROMOTION_CODE_SUCCESS = "PROMOTION_CODE_SUCCESS";
const PROMOTION_CODE_FAILURE = "PROMOTION_CODE_FAILURE";
const PROMOTION_EXTERNAL_REQUEST = "PROMOTION_EXTERNAL_REQUEST";
const PROMOTION_EXTERNAL_SUCCESS = "PROMOTION_EXTERNAL_SUCCESS";
const PROMOTION_EXTERNAL_FAILURE = "PROMOTION_EXTERNAL_FAILURE";
const BUYER_TYPES_INFO_REQUEST = "BUYER_TYPES_INFO_REQUEST";
const BUYER_TYPES_INFO_SUCCESS = "BUYER_TYPES_INFO_SUCCESS";
const BUYER_TYPES_INFO_FAILURE = "BUYER_TYPES_INFO_FAILURE";
const EVENTS_REQUEST = "EVENTS_REQUEST";
const EVENTS_SUCCESS = "EVENTS_SUCCESS";
const EVENTS_FAILURE = "EVENTS_FAILURE";
const EVENTS_BY_VENUE_REQUEST = "EVENTS_BY_VENUE_REQUEST";
const EVENTS_BY_VENUE_SUCCESS = "EVENTS_BY_VENUE_SUCCESS";
const EVENTS_BY_VENUE_FAILURE = "EVENTS_BY_VENUE_FAILURE";
const EVENT_REQUEST = "EVENT_REQUEST";
const EVENT_SUCCESS = "EVENT_SUCCESS";
const EVENT_FAILURE = "EVENT_FAILURE";
const EVENT_CODE_REQUEST = "EVENT_CODE_REQUEST";
const EVENT_CODE_SUCCESS = "EVENT_CODE_SUCCESS";
const EVENT_CODE_FAILURE = "EVENT_CODE_FAILURE";
const CART_CLEAN = "CART_CLEAN";
const CART_UPDATE = "CART_UPDATE";
const CART_UPDATE_SALES_GROUP = "CART_UPDATE_SALES_GROUP";
const CART_UPDATE_PRODUCT = "CART_UPDATE_PRODUCT";
const CART_UPDATE_DATE = "CART_UPDATE_DATE";
const CART_UPDATE_HOUR = "CART_UPDATE_HOUR";
const CART_UPDATE_EVENTS = "CART_UPDATE_EVENTS";
const CART_ADD_EVENT = "CART_ADD_EVENT";
const CART_UPDATE_BT = "CART_UPDATE_BT";
const CART_UPDATE_PROMOTIONS = "CART_UPDATE_PROMOTIONS";
const CART_UPDATE_SERVICES = "CART_UPDATE_SERVICES";
const CART_UPDATE_SEATS = "CART_UPDATE_SEATS";
const CART_ADD_SEATS = "CART_ADD_SEATS";
const CART_REMOVE_SEATS = "CART_REMOVE_SEATS";
const CART_RECOMMENDATION_ASKED = "CART_RECOMMENDATION_ASKED";
const CART_RECOMMENDATION_NOT_ASKED = "CART_RECOMMENDATION_NOT_ASKED";
const CART_ADD_ANSWERS = "CART_ADD_ANSWERS";
const CART_ADD_MEMBERS = "CART_ADD_MEMBERS";
const CART_ADD_RECAPTCHA = "CART_ADD_RECAPTCHA";
const CART_CLEAN_PROMOTIONS = "CART_CLEAN_PROMOTIONS";
const CART_CLEAN_SERVICES = "CART_CLEAN_SERVICES";
const CART_UPDATE_DISTRIBUTOR_REFERENCE = "CART_UPDATE_DISTRIBUTOR_REFERENCE";
const CART_UPDATE_RESERVATION_OBSERVATION = "CART_UPDATE_RESERVATION_OBSERVATION";
const CART_UPDATE_TICKET_GROUPING_TYPE = "CART_UPDATE_TICKET_GROUPING_TYPE";
const CART_UPDATE_TYPE_OF_CUSTOMER = "CART_UPDATE_TYPE_OF_CUSTOMER";
const LOADER_SHOW = "LOADER_SHOW";
const LOADER_HIDE = "LOADER_HIDE";
const CALENDAR_INFO_REQUEST = "CALENDAR_INFO_REQUEST";
const CALENDAR_INFO_SUCCESS = "CALENDAR_INFO_SUCCESS";
const CALENDAR_INFO_FAILURE = "CALENDAR_INFO_FAILURE";
const POST_BILL_REQUEST = "POST_BILL_REQUEST";
const POST_BILL_SUCCESS = "POST_BILL_SUCCESS";
const POST_BILL_FAILURE = "POST_BILL_FAILURE";
const CALENDAR_AVAILABILITY_REQUEST = "CALENDAR_AVAILABILITY_REQUEST";
const CALENDAR_AVAILABILITY_SUCCESS = "CALENDAR_AVAILABILITY_SUCCESS";
const CALENDAR_AVAILABILITY_FAILURE = "CALENDAR_AVAILABILITY_FAILURE";
const CALENDAR_PRICING_REQUEST = "CALENDAR_PRICING_REQUEST";
const CALENDAR_PRICING_SUCCESS = "CALENDAR_PRICING_SUCCESS";
const CALENDAR_PRICING_FAILURE = "CALENDAR_PRICING_FAILURE";
const CALENDAR_PRICING_CLEAN = "CALENDAR_PRICING_CLEAN";
const GET_TERMS_AND_CONDITIONS_REQUEST = "TERMS_AND_CONDITIONS_REQUEST";
const GET_TERMS_AND_CONDITIONS_SUCCESS = "TERMS_AND_CONDITIONS_SUCCESS";
const GET_TERMS_AND_CONDITIONS_FAILURE = "TERMS_AND_CONDITIONS_FAILURE";
const GET_PAYMENT_TERMS_AND_CONDITIONS_REQUEST = "PAYMENT_TERMS_AND_CONDITIONS_REQUEST";
const GET_PAYMENT_TERMS_AND_CONDITIONS_SUCCESS = "PAYMENT_TERMS_AND_CONDITIONS_SUCCESS";
const GET_PAYMENT_TERMS_AND_CONDITIONS_FAILURE = "PAYMENT_TERMS_AND_CONDITIONS_FAILURE";
const ACCEPT_TERM = "ACCEPT_TERM";
const ACCEPT_SUBSCRIPTION = "ACCEPT_SUBSCRIPTION";
const HAS_COOKIE_LOCALE = "HAS_COOKIE_LOCALE";
const RESERVATION_TO_BILL_SUCCESS = " RESERVATION_TO_BILL_SUCCESS";
const RESERVATION_TO_BILL_REQUEST = "RESERVATION_TO_BILL_REQUEST";
const RESERVATION_TO_BILL_FAILURE = "RESERVATION_TO_BILL_FAILURE";
const GET_PARENT_RESERVATION_SUCCESS = " GET_PARENT_RESERVATION_SUCCESS";
const GET_PARENT_RESERVATION_REQUEST = "GET_PARENT_RESERVATION_REQUEST";
const GET_PARENT_RESERVATION_FAILURE = "GET_PARENT_RESERVATION_FAILURE";
const POST_BILL_DATA = "POST_BILL_DATA";
const SET_SPECIAL_PRODUCTS_FILTERS = "SET_SPECIAL_PRODUCTS_FILTERS";
const GET_RECOMMENDATION_RULE_REQUEST = "GET_RECOMMENDATION_RULE_REQUEST";
const GET_RECOMMENDATION_RULE_SUCCESS = "GET_RECOMMENDATION_RULE_SUCCESS";
const GET_RECOMMENDATION_RULE_FAILURE = "GET_RECOMMENDATION_RULE_FAILURE ";
const RESERVATION_TO_RESCHEDULE_SUCCESS = "RESERVATION_TO_RESCHEDULE_SUCCESS";
const RESERVATION_TO_RESCHEDULE_REQUEST = "RESERVATION_TO_RESCHEDULE_REQUEST";
const RESERVATION_TO_RESCHEDULE_FAILURE = "RESERVATION_TO_RESCHEDULE_FAILURE";
const RESCHEDULE_REQUEST = "RESCHEDULE_REQUEST";
const RESCHEDULE_SUCCESS = "RESCHEDULE_SUCCESS";
const RESCHEDULE_FAILURE = "RESCHEDULE_FAILURE";
const RESERVATIONSUMMARY_REQUEST = "RESERVATIONSUMMARY_REQUEST";
const RESERVATIONSUMMARY_SUCCESS = "RESERVATIONSUMMARY_SUCCESS";
const RESERVATIONSUMMARY_FAILURE = "RESERVATIONSUMMARY_FAILURE";
const PERFORM_RESCHEDULE = "PERFORM_RESCHEDULE";
const RESCHEDULE_DIALOG = "RESCHEDULE_DIALOG";
const SELLER_FORM_REQUEST = "SELLER_FORM_REQUEST";
const SELLER_FORM_SUCCESS = "SELLER_FORM_SUCCESS";
const SELLER_FORM_FAILURE = "SELLER_FORM_FAILURE";
const FORM_FIELDS_REQUEST = "FORM_FIELDS_REQUEST";
const FORM_FIELDS_SUCCESS = "FORM_FIELDS_SUCCES";
const FORM_FIELDS_FAILURE = "FORM_FIELDS_FAILURE";
const GET_RESERVATION_STATE = "GET_RESERVATION_STATE";
const SET_SELECTED_DATE_FOR_VENUE = "SET_SELECTED_DATE_FOR_VENUE";
const SET_SELECTED_EVENT_FOR_VENUE = "SET_SELECTED_EVENT_FOR_VENUE";
const SET_INITIAL_RESERVATION_STATE = "SET_INITIAL_RESERVATION_STATE";
const SET_SELECTED_BUYER_TYPES = "SET_SELECTED_BUYER_TYPES";
const SET_SELECTED_SERVICES = "SET_SELECTED_SERVICES";
const REMOVE_SELECTED_SERVICES = "REMOVE_SELECTED_SERVICES";
const SET_INITIAL_ANSWERS = "SET_INITIAL_ANSWERS";
const SET_COOKIE_LIFETIME = "SET_COOKIE_LIFETIME";
const CLEAN_RESERVATION = "CLEAN_RESERVATION";
const CART_SET_CUSTOMER_ID = "CART_SET_CUSTOMER_ID";
const CART_CLEAR_CUSTOMER_ID = "CART_CLEAR_CUSTOMER_ID";
const ADDONS_REQUEST = "ADDONS_REQUEST";
const ADDONS_SUCCESS = "ADDONS_SUCCESS";
const ADDONS_FAILURE = "ADDONS_FAILURE";
const SET_AUTO_SELECT_EVENT = "SET_AUTO_SELECT_EVENT";
const SET_PROMOTION_SELECTED = "SET_PROMOTION_SELECTED";
const CLEAN_PROMOTION_SELECTED = "CLEAN_PROMOTION_SELECTED";
const FETCH_LOGIN_SESSION = "FETCH_LOGIN_SESSION";
const FETCH_LOGIN_SESSION_SUCCESS = "FETCH_LOGIN_SESSION_SUCCESS";
const FETCH_LOGIN_SESSION_FAILED = "FETCH_LOGIN_SESSION_FAILED";
const PRODUCT_ANALYTICS_CONFIG_REQUEST = "PRODUCT_ANALYTICS_CONFIG_REQUEST";
const PRODUCT_ANALYTICS_CONFIG_SUCCESS = "PRODUCT_ANALYTICS_CONFIG_SUCCESS";
const PRODUCT_ANALYTICS_CONFIG_FAILURE = "PRODUCT_ANALYTICS_CONFIG_FAILURE";
const ActionTypes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACCEPT_SUBSCRIPTION,
  ACCEPT_TERM,
  ADDITIONAL_SITE_INFO_FAILURE,
  ADDITIONAL_SITE_INFO_REQUEST,
  ADDITIONAL_SITE_INFO_SUCCESS,
  ADDONS_FAILURE,
  ADDONS_REQUEST,
  ADDONS_SUCCESS,
  ADYEN_FAILURE,
  ADYEN_PAYMENT_DETAILS_FAILURE,
  ADYEN_PAYMENT_DETAILS_REQUEST,
  ADYEN_PAYMENT_DETAILS_SUCCESS,
  ADYEN_PAYMENT_FAILURE,
  ADYEN_PAYMENT_REQUEST,
  ADYEN_PAYMENT_SUCCESS,
  ADYEN_REQUEST,
  ADYEN_SUCCESS,
  BUYER_TYPES_CLEAN,
  BUYER_TYPES_FAILURE,
  BUYER_TYPES_INFO_FAILURE,
  BUYER_TYPES_INFO_REQUEST,
  BUYER_TYPES_INFO_SUCCESS,
  BUYER_TYPES_REQUEST,
  BUYER_TYPES_SUCCESS,
  CALENDAR_AVAILABILITY_FAILURE,
  CALENDAR_AVAILABILITY_REQUEST,
  CALENDAR_AVAILABILITY_SUCCESS,
  CALENDAR_INFO_FAILURE,
  CALENDAR_INFO_REQUEST,
  CALENDAR_INFO_SUCCESS,
  CALENDAR_PRICING_CLEAN,
  CALENDAR_PRICING_FAILURE,
  CALENDAR_PRICING_REQUEST,
  CALENDAR_PRICING_SUCCESS,
  CART_ADD_ANSWERS,
  CART_ADD_EVENT,
  CART_ADD_MEMBERS,
  CART_ADD_RECAPTCHA,
  CART_ADD_SEATS,
  CART_CLEAN,
  CART_CLEAN_PROMOTIONS,
  CART_CLEAN_SERVICES,
  CART_CLEAR_CUSTOMER_ID,
  CART_RECOMMENDATION_ASKED,
  CART_RECOMMENDATION_NOT_ASKED,
  CART_REMOVE_SEATS,
  CART_SET_CUSTOMER_ID,
  CART_UPDATE,
  CART_UPDATE_BT,
  CART_UPDATE_DATE,
  CART_UPDATE_DISTRIBUTOR_REFERENCE,
  CART_UPDATE_EVENTS,
  CART_UPDATE_HOUR,
  CART_UPDATE_PRODUCT,
  CART_UPDATE_PROMOTIONS,
  CART_UPDATE_RESERVATION_OBSERVATION,
  CART_UPDATE_SALES_GROUP,
  CART_UPDATE_SEATS,
  CART_UPDATE_SERVICES,
  CART_UPDATE_TICKET_GROUPING_TYPE,
  CART_UPDATE_TYPE_OF_CUSTOMER,
  CLEAN_PROMOTION_SELECTED,
  CLEAN_RESERVATION,
  CLIENT_CONFIGURATION_FAILURE,
  CLIENT_CONFIGURATION_REQUEST,
  CLIENT_CONFIGURATION_SUCCESS,
  CLIENT_EMAIL_CONFIGURATION_FAILURE,
  CLIENT_EMAIL_CONFIGURATION_REQUEST,
  CLIENT_EMAIL_CONFIGURATION_SUCCESS,
  CONFIGURATION_ADD,
  DELETE_PAYMENT_DETAILS,
  DELETE_PURCHASE,
  DELETE_PURCHASE_FAILURE,
  DELETE_PURCHASE_REQUEST,
  DELETE_PURCHASE_SUCCESS,
  DELETE_RESERVATION_FAILURE,
  DELETE_RESERVATION_REQUEST,
  DELETE_RESERVATION_SUCCESS,
  EVENTS_BY_VENUE_FAILURE,
  EVENTS_BY_VENUE_REQUEST,
  EVENTS_BY_VENUE_SUCCESS,
  EVENTS_FAILURE,
  EVENTS_REQUEST,
  EVENTS_SUCCESS,
  EVENT_CODE_FAILURE,
  EVENT_CODE_REQUEST,
  EVENT_CODE_SUCCESS,
  EVENT_FAILURE,
  EVENT_REQUEST,
  EVENT_SUCCESS,
  FETCH_LOGIN_SESSION,
  FETCH_LOGIN_SESSION_FAILED,
  FETCH_LOGIN_SESSION_SUCCESS,
  FORM_FIELDS_FAILURE,
  FORM_FIELDS_REQUEST,
  FORM_FIELDS_SUCCESS,
  GET_EVENT_BY_ID_WITH_AVAILABILITY_FAILURE,
  GET_EVENT_BY_ID_WITH_AVAILABILITY_REQUEST,
  GET_EVENT_BY_ID_WITH_AVAILABILITY_SUCCESS,
  GET_PARENT_RESERVATION_FAILURE,
  GET_PARENT_RESERVATION_REQUEST,
  GET_PARENT_RESERVATION_SUCCESS,
  GET_PAYMENT_FAILURE,
  GET_PAYMENT_REQUEST,
  GET_PAYMENT_SUCCESS,
  GET_PAYMENT_TERMS_AND_CONDITIONS_FAILURE,
  GET_PAYMENT_TERMS_AND_CONDITIONS_REQUEST,
  GET_PAYMENT_TERMS_AND_CONDITIONS_SUCCESS,
  GET_PROSA_PAYMENT_STATUS_FAILURE,
  GET_PROSA_PAYMENT_STATUS_REQUEST,
  GET_PROSA_PAYMENT_STATUS_SUCCESS,
  GET_PURCHASE_FAILURE,
  GET_PURCHASE_REQUEST,
  GET_PURCHASE_SUCCESS,
  GET_RECOMMENDATION_RULE_FAILURE,
  GET_RECOMMENDATION_RULE_REQUEST,
  GET_RECOMMENDATION_RULE_SUCCESS,
  GET_RESERVATION_STATE,
  GET_TERMS_AND_CONDITIONS_FAILURE,
  GET_TERMS_AND_CONDITIONS_REQUEST,
  GET_TERMS_AND_CONDITIONS_SUCCESS,
  HAS_COOKIE_LOCALE,
  LANGUAGE_FAILURE,
  LANGUAGE_REQUEST,
  LANGUAGE_SUCCESS,
  LOADER_HIDE,
  LOADER_SHOW,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  PARENT_PRODUCT_FAILURE,
  PARENT_PRODUCT_REQUEST,
  PARENT_PRODUCT_SUCCESS,
  PAYMENT_METHOD_SALES_GROUP_FAILURE,
  PAYMENT_METHOD_SALES_GROUP_REQUEST,
  PAYMENT_METHOD_SALES_GROUP_SUCCESS,
  PERFORM_RESCHEDULE,
  POINT_OF_SALE_FAILURE,
  POINT_OF_SALE_REQUEST,
  POINT_OF_SALE_SUCCESS,
  POST_BILL_DATA,
  POST_BILL_FAILURE,
  POST_BILL_REQUEST,
  POST_BILL_SUCCESS,
  POST_PAYMENT_FAILURE,
  POST_PAYMENT_REQUEST,
  POST_PAYMENT_SUCCESS,
  POST_RETRYPAYMENT_FAILURE,
  POST_RETRYPAYMENT_REQUEST,
  POST_RETRYPAYMENT_SUCCESS,
  POST_STRIPE_PAYMENT_FAILURE,
  POST_STRIPE_PAYMENT_REQUEST,
  POST_STRIPE_PAYMENT_SUCCESS,
  PRODUCT_ANALYTICS_CONFIG_FAILURE,
  PRODUCT_ANALYTICS_CONFIG_REQUEST,
  PRODUCT_ANALYTICS_CONFIG_SUCCESS,
  PRODUCT_CATEGORIES_FAILURE,
  PRODUCT_CATEGORIES_REQUEST,
  PRODUCT_CATEGORIES_SUCCESS,
  PRODUCT_CONFIGURATIONS_FAILURE,
  PRODUCT_CONFIGURATIONS_REQUEST,
  PRODUCT_CONFIGURATIONS_SUCCESS,
  PRODUCT_FAILURE,
  PRODUCT_FORMS_FAILURE,
  PRODUCT_FORMS_REQUEST,
  PRODUCT_FORMS_SUCCESS,
  PRODUCT_INFO_FAILURE,
  PRODUCT_INFO_REQUEST,
  PRODUCT_INFO_SUCCESS,
  PRODUCT_LIST_FAILURE,
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_RECENT_EVENTS_FAILURE,
  PRODUCT_RECENT_EVENTS_REQUEST,
  PRODUCT_RECENT_EVENTS_SUCCESS,
  PRODUCT_RECENT_EVENTS_WITH_AVAILABILITY_FAILURE,
  PRODUCT_RECENT_EVENTS_WITH_AVAILABILITY_REQUEST,
  PRODUCT_RECENT_EVENTS_WITH_AVAILABILITY_SUCCESS,
  PRODUCT_RECOMMENDATION_CLEAN,
  PRODUCT_RECOMMENDATION_FAILURE,
  PRODUCT_RECOMMENDATION_REQUEST,
  PRODUCT_RECOMMENDATION_SUCCESS,
  PRODUCT_REQUEST,
  PRODUCT_SERVICES_FAILURE,
  PRODUCT_SERVICES_REQUEST,
  PRODUCT_SERVICES_SUCCESS,
  PRODUCT_SUCCESS,
  PROMOTIONS_FAILURE,
  PROMOTIONS_REQUEST,
  PROMOTIONS_SUCCESS,
  PROMOTION_CODE_CLEAN,
  PROMOTION_CODE_FAILURE,
  PROMOTION_CODE_REQUEST,
  PROMOTION_CODE_SUCCESS,
  PROMOTION_EXTERNAL_FAILURE,
  PROMOTION_EXTERNAL_REQUEST,
  PROMOTION_EXTERNAL_SUCCESS,
  PUT_PURCHASE_FAILURE,
  PUT_PURCHASE_REQUEST,
  PUT_PURCHASE_SUCCESS,
  REDSYS_AUTHENTICATION_FAILURE,
  REDSYS_AUTHENTICATION_REQUEST,
  REDSYS_AUTHENTICATION_SUCCESS,
  REDSYS_INIT_FAILURE,
  REDSYS_INIT_REQUEST,
  REDSYS_INIT_SUCCESS,
  REMOVE_SELECTED_SERVICES,
  RESCHEDULE_DIALOG,
  RESCHEDULE_FAILURE,
  RESCHEDULE_REQUEST,
  RESCHEDULE_SUCCESS,
  RESERVATIONSUMMARY_FAILURE,
  RESERVATIONSUMMARY_REQUEST,
  RESERVATIONSUMMARY_SUCCESS,
  RESERVATION_FAILURE,
  RESERVATION_REQUEST,
  RESERVATION_SUCCESS,
  RESERVATION_TO_BILL_FAILURE,
  RESERVATION_TO_BILL_REQUEST,
  RESERVATION_TO_BILL_SUCCESS,
  RESERVATION_TO_RESCHEDULE_FAILURE,
  RESERVATION_TO_RESCHEDULE_REQUEST,
  RESERVATION_TO_RESCHEDULE_SUCCESS,
  SALES_GROUP_FAILURE,
  SALES_GROUP_REQUEST,
  SALES_GROUP_SUCCESS,
  SELLER_FORM_FAILURE,
  SELLER_FORM_REQUEST,
  SELLER_FORM_SUCCESS,
  SERVICE_PRICES_CLEAN,
  SERVICE_PRICES_FAILURE,
  SERVICE_PRICES_REQUEST,
  SERVICE_PRICES_SUCCESS,
  SET_AUTO_SELECT_EVENT,
  SET_COOKIE_LIFETIME,
  SET_INITIAL_ANSWERS,
  SET_INITIAL_RESERVATION_STATE,
  SET_PROMOTION_SELECTED,
  SET_SELECTED_BUYER_TYPES,
  SET_SELECTED_DATE_FOR_VENUE,
  SET_SELECTED_EVENT_FOR_VENUE,
  SET_SELECTED_SERVICES,
  SET_SPECIAL_PRODUCTS_FILTERS,
  SUB_PRODUCT_LIST_FAILURE,
  SUB_PRODUCT_LIST_REQUEST,
  SUB_PRODUCT_LIST_SUCCESS,
  TIME_SLOTS_FAILURE,
  TIME_SLOTS_REQUEST,
  TIME_SLOTS_SUCCESS,
  YUNO_CHECKOUT_FAILURE,
  YUNO_CHECKOUT_REQUEST,
  YUNO_CHECKOUT_RESET,
  YUNO_CHECKOUT_SUCCESS,
  YUNO_CREATE_PAYMENT_FAILURE,
  YUNO_CREATE_PAYMENT_REQUEST,
  YUNO_CREATE_PAYMENT_SUCCESS
}, Symbol.toStringTag, { value: "Module" }));
const clientAuthBase64 = btoa(`${CLIENT_OAUTH}:${CLIENT_SECRET_OAUTH}`);
function requestLogin() {
  return {
    type: LOGIN_REQUEST,
    isFetching: true,
    isAuthenticated: false
  };
}
function receiveLogin(user2, posId) {
  return {
    type: LOGIN_SUCCESS,
    isFetching: false,
    isAuthenticated: true,
    user: user2,
    // id_token: user.id_token
    id_token: user2.jti,
    pos: posId
  };
}
function loginError(message) {
  return {
    type: LOGIN_FAILURE,
    isFetching: false,
    isAuthenticated: false,
    message
  };
}
function succesToken({ user: user2, response, dispatch, posId }) {
  if (!response.ok) {
    dispatch(loginError(user2.message));
    return Promise.reject(user2);
  }
  sessionStorage.setItem("id_token", user2.jti);
  sessionStorage.setItem("access_token", user2.access_token);
  sessionStorage.setItem("refresh_token", user2.refresh_token);
  if (user2.loyalty) {
    setCookie("loyalty", user2.loyalty, {
      path: "/",
      expires: addDays(/* @__PURE__ */ new Date(), 1)
    });
  }
  let newPosId = posId;
  if (newPosId) {
    sessionStorage.setItem("id_pos", newPosId);
  } else {
    newPosId = sessionStorage.getItem("id_pos");
  }
  dispatch(receiveLogin(user2, newPosId));
  return response;
}
const loginUser = (posId, apiKey) => (dispatch) => {
  const params = {
    secretKey: sessionStorage.getItem("api_key")
  };
  const url = `${AUTH_URL()}/api/oauth/token?${queryString.stringify(params)}`;
  const config = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  };
  dispatch(requestLogin());
  return fetch(url, config).then((response) => response.json().then((user2) => ({ user: user2, response }))).then(({ user: user2, response }) => succesToken({ user: user2, response, dispatch, posId }));
};
const refreshUser = (posId) => (dispatch) => {
  const refreshToken = sessionStorage.getItem("refresh_token");
  if (refreshToken) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Basic ${clientAuthBase64}`
      },
      body: `grant_type=refresh_token&refresh_token=${refreshToken}`
    };
    dispatch(requestLogin());
    return fetch(`${AUTH_URL()}/oauth/token`, config).then((response) => {
      if ([401, 403].indexOf(response.status) !== -1) {
        return dispatch(loginUser(posId));
      }
      return response.json().then(
        ({ user: user2, response: responseJson }) => succesToken({ user: user2, response: responseJson, dispatch, posId })
      );
    });
  }
  return Promise.resolve();
};
const fetchRetry = (url, { retries = 3, retryDelay = 1e3, retryOn = [], ...options } = {}) => {
  if (retryOn && !Array.isArray(retryOn)) {
    const err = new Error("retryOn property expects an array");
    err.name = "ArgumentError";
    return Promise.reject(err);
  }
  return new Promise((resolve, reject) => {
    function wrappedFetch(n) {
      fetch(url, options).then((response) => {
        if (!retryOn.length || retryOn.indexOf(response.status) === -1) {
          resolve(response);
        } else if (n > 0) {
          setTimeout(() => {
            wrappedFetch(n - 1);
          }, retryDelay);
        } else {
          reject(response);
        }
      }).catch((error) => {
        if (n > 0) {
          setTimeout(() => {
            wrappedFetch(n - 1);
          }, retryDelay);
        } else {
          reject(error);
        }
      });
    }
    wrappedFetch(retries);
  });
};
const errorCodeMessageId = (errorCode, defaultErrorMessage = "Error") => {
  let errorMessage = "";
  switch (errorCode) {
    case "ORD-0":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Purchase form with no responses",
          id: "notification.error.text.emptyRequiredFormField"
        }
      );
      break;
    case "ORD-003":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Something goes wrong when processing petition",
          id: "notification.error.text.errorFromBackend"
        }
      );
      break;
    case "ORD-002":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "There is no response from backend service",
          id: "notification.error.text.noResponseFromBackend"
        }
      );
      break;
    case "ORD-102":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "The code was not found", id: "notification.error.text.eventCode" });
      break;
    case "ORD-117":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "This purchase has no valid status",
          id: "notification.error.text.purchaseHasNotValidStatus"
        }
      );
      Cookie.remove("tiqueteoSession");
      sessionStorage.removeItem("paymentId");
      sessionStorage.removeItem("paymentProperties");
      break;
    case "ORD-113":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "The purchase was not found or payment doesn't belongs to purchase",
          id: "notification.error.text.purchaseOrPaymentNotFound"
        }
      );
      Cookie.remove("tiqueteoSession");
      break;
    case "ORD-026":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Only one purchase per customer is allowed",
          id: "notification.error.text.preventMultiPurchase"
        }
      );
      Cookie.remove("tiqueteoSession");
      break;
    case "ORD-0-1":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "This event has not availability left",
          id: "notification.error.text.notAvailabilityLeft"
        }
      );
      break;
    case "ORD-0-21":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Something goes wrong when processing petition",
          id: "notification.error.text.errorFromBackend"
        }
      );
      break;
    case "ORD-0-44":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "This product disables cart, and purchase can not has more reservations",
          id: "notification.error.text.productDisablesCart"
        }
      );
      break;
    case "ORD-0-30":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "The product is valid to buy only by a invitation",
          id: "notification.error.text.productInviteOnly"
        }
      );
      break;
    case "ORD-036":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "The payment has not been processed correctly. Please contact your provider",
          id: "notification.error.text.paymentStatusUnexpected"
        }
      );
      break;
    case "ORD-064":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "The provided school id is not valid",
          id: "notification.error.text.notValidSchoolProvided"
        }
      );
      break;
    case "CAT-008":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Prices for product not found",
          id: "notification.error.text.noPricesForProduct"
        }
      );
      break;
    case "CAT-005":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "The expected response has not been obtained",
          id: "notification.error.text.notExpectedResponse"
        }
      );
      break;
    case "CLOR-002":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "The resource was not found", id: "notification.error.text.resourceNotFound" });
      break;
    case "CAT-020":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "No more tickets available",
          id: "notification.error.text.no.tickets.available"
        }
      );
      break;
    case "CAT-104":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "The resource was not found", id: "notification.error.text.resourceNotFound" });
      break;
    case "CAT-108":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "There's an other seller with this email account",
          id: "notification.error.text.email.used.seller"
        }
      );
      break;
    case "ORD-165":
      errorMessage = defaultErrorMessage;
      break;
    case "ORD-153":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Invalid code", id: "notification.error.text.invalid.code" });
      break;
    case "ORD-060":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Error checking benefits", id: "notification.error.text.check.benefits" });
      break;
    case "ORD-061":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "User does not exist", id: "notification.error.text.user.not.exist" });
      break;
    case "ORD-062":
      errorMessage = defaultErrorMessage;
      break;
    case "ORD-124":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "The requested reservation is already billed and can not be billed again",
          id: "notification.error.text.billing.billed"
        }
      );
      break;
    case "ORD-125":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "The payment can not be billed due it's status",
          id: "notification.error.text.paymentWrongStatusForBill"
        }
      );
      Cookie.remove("tiqueteoSession");
      break;
    case "ORD-172":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "No purchases with this email", id: "notification.error.text.billing.notfound" });
      break;
    case "ORD-063":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "DNI is invalid or has already been used",
          id: "notification.error.text.validation.dni"
        }
      );
      break;
    case "ORD-151":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "The payment can not be billed. Out of billing allowed period",
          id: "notification.error.text.validation.billing.period"
        }
      );
      break;
    case "CLOR-005":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Maximum sending rate exceeded", id: "notification.error.text.throttling" });
      break;
    case "ORD-065":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Email address not valid", id: "notification.error.text.email.not.valid" });
      break;
    case "ORD-069":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "School not registered", id: "notification.error.text.school.not.registered" });
      break;
    case "ORD-070":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "You have exceeded the maximum number of bookings allowed per school",
          id: "notification.error.text.school.bookings.exceeded"
        }
      );
      break;
    case "ORD-207":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Proxy not allowed", id: "notification.error.text.proxy" });
      break;
    case "CLOR-007":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "There was an error in the form", id: "notification.error.text.forms" });
      break;
    case "ORD-253":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "The reservation has already been rescheduled more times than allowed.",
          id: "notification.error.text.rescheduled"
        }
      );
      break;
    case "ORD-257":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "There's already a payment approved with this reference",
          id: "notification.error.text.payment.approved"
        }
      );
      break;
    case "ORD-228":
      errorMessage = defaultErrorMessage;
      break;
    case "ORD-0-65":
    case "ORD-059":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "User has spent his/her loyalty benefits",
          id: "notification.error.loyalty.benefits.spent"
        }
      );
      break;
    case "LOY-023":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Incorrect ID number or password",
          id: "notification.error.loyalty.wrong.password"
        }
      );
      break;
    case "LOY-040":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Only Madridistas are permitted access",
          id: "notification.error.loyalty.tourBernabeu.madridistasOnly"
        }
      );
      break;
    case "LOY-067":
      errorMessage = defaultErrorMessage;
      break;
    case "LOY-069":
      errorMessage = defaultErrorMessage;
      break;
    case "LOY-085":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "A loyalty program form answer has incorrect regex format",
          id: "notification.error.loyalty.form.regex"
        }
      );
      break;
    case "LOY-086":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "A loyalty program form answer has incorrect birth date",
          id: "notification.error.loyalty.form.birthDate"
        }
      );
      break;
    case "ORD-0-55":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "The current event does not allow more reservations, maximum reached",
          id: "notification.error.text.event.max"
        }
      );
      break;
    case "USR-001":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Bad credentials", id: "login.error.badCredentials" });
      break;
    case "USR-002":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Email address already registered in the system",
          id: "notification.error.text.email.registered"
        }
      );
      break;
    case "ORD-284":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "This personal ID number has already been used",
          id: "notification.error.text.dni.already"
        }
      );
      break;
    case "ORD-285":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Invalid personal ID number", id: "notification.error.text.dni.invalid" });
      break;
    case "ORD-307":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Reservation not found", id: "notification.error.reservation.notFound" });
      break;
    case "ORD-308":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Client configuration does not allow to manage reservations",
          id: "notification.error.reservation.manage.notAllowed"
        }
      );
      break;
    case "ORD-309":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Client configuration does not allow to bill",
          id: "notification.error.reservation.bill.notAllowed"
        }
      );
      break;
    case "ORD-310":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Client configuration does not allow to cancel.",
          id: "notification.error.reservation.cancel.notAllowed"
        }
      );
      break;
    case "ORD-311":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Product configuration does not allow to cancel. ",
          id: "notification.error.reservation.cancel.product.notAllowed"
        }
      );
      break;
    case "ORD-312":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Client configuration does not allow to reschedule",
          id: "notification.error.reservation.rechedule.notAllowed"
        }
      );
      break;
    case "ORD-313":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Client configuration does not allow to resend",
          id: "notification.error.reservation.resend.notAllowed"
        }
      );
      break;
    case "ORD-325":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Solo se admite una reserva por día",
          id: "notification.error.one.reservation.per.day"
        }
      );
      break;
    case "ORD-326":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Form fields do not match", id: "notification.error.form.fields.not.match" });
      break;
    case "ORD-350":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Your selection is no longer available. Please retry the reservation again",
          id: "notification.error.selection.not.available"
        }
      );
      break;
    case "ORD-403":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Loyalty code format error", id: "loyalty.code.format.error" });
      break;
    case "CAT-016":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Your selection is no longer available. Please retry the reservation again",
          id: "notification.error.selection.not.available"
        }
      );
      break;
    case "CAT-159":
    case "ORD-352":
    case "CAT-176":
    case "ORD-397":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Los datos fiscales introducidos no son válidos",
          id: "notification.error.text.incorrectFiscalData"
        }
      );
      break;
    case "ORD-372":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "It is not possible to exchange pesetas after June 30, 2021.",
          id: "notification.error.exchange.not.available"
        }
      );
      break;
    case "ORD-385":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "For operational reasons, the exchange of euro banknotes and coins transactions will be performed again as from 1 July 2021.",
          id: "notification.error.exchange.postponed"
        }
      );
      break;
    case "ORD-432":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "The postal code of your place of residence must belong to the autonomous community of the Basque Country.",
          id: "notification.error.form.wrong.euskera.postal.code"
        }
      );
      break;
    case "ORD-161":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Code already used.", id: "notification.error.promo.code.not.valid" });
      break;
    case "ORD-436":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Code not valid for the selected fare",
          id: "notification.error.promo.selection.not.valid"
        }
      );
      break;
    case "ORD-457":
    case "ORD-458":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "No existe ningún socio con el DNI especificado",
          id: "notification.error.promo.credentials.not.service"
        }
      );
      break;
    case "ORD-459":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "La clave no es correcta",
          id: "notification.error.promo.credentials.not.valid"
        }
      );
      break;
    case "ORD-460":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "El socio está dado de alta pero tiene la cuenta sin confirmar",
          id: "notification.error.promo.credentials.not.confirmed"
        }
      );
      break;
    case "ORD-461":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "El socio no está dado de alta en la web de donostiakultura.eus",
          id: "notification.error.promo.credentials.not.available"
        }
      );
      break;
    case "ORD-489":
    case "CAT-201":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Vat Number is invalid for this country",
          id: "notification.error.text.invalid.vatnumber"
        }
      );
      break;
    case "ORD-490":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Se ha alcanzado el número máximo de reservas para esta compra",
          id: "notification.error.reservation.maximum"
        }
      );
      break;
    case "ORD-566":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Código erróneo", id: "notification.error.code" });
      break;
    case "ORD-567":
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Código ya utilizado", id: "notification.error.code.used" });
      break;
    case "ORD-574":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "error.daily.reservation.limit.exceeded",
          defaultMessage: "Seller client max reservations per day exceeded"
        }
      );
    case "ORD-575":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "error.daily.ticket.limit.exceeded",
          defaultMessage: "Seller client max tickets per day exceeded"
        }
      );
    case "ORD-594":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "error.id.number.already.used.faro",
          defaultMessage: "Ya has comprado una entrada para ese día con tu número de empleado."
        }
      );
    case "ORD-595":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "error.employee.not.found.faro",
          defaultMessage: "Por favor, comprueba que tu número de empleado o identificador es correcto"
        }
      );
    default:
      errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "There was an error creating the reservation",
          id: "notification.error.text.reservation"
        }
      );
  }
  return errorMessage;
};
const errorCodeTitleId = (errorCode) => {
  let errorTitle = "";
  switch (errorCode) {
    case "ORD-003":
    // Something goes wrong when processing petition on backend
    case "ORD-002":
    // there is no response from backend service
    case "ORD-102":
    // the event code was not found
    case "ORD-117":
    // the purchase has no valid status for the current step
    case "ORD-113":
    // the purchase has no valid status for the current step
    case "ORD-0":
    // A required form field have no answer
    case "ORD-0-1":
    // the event has no availability
    case "ORD-0-44":
    // PRODUCT_DISABLES_CART_AND_PURCHASE_HAS_OTHER_RESERVATIONS_CODE
    case "ORD-036":
    // Unexpected Payment status
    case "CAT-008":
    // PRODUCT_DISABLES_CART_AND_PURCHASE_HAS_OTHER_RESERVATIONS_CODE
    case "CAT-005":
    // The expected response has not been obtained
    case "CAT-104":
    // The Promotion code was not found
    case "CAT-108":
    // There is an other seller with this email
    case "ORD-0-30":
    // The Product is invite only
    case "CLOR-002":
    // Promotion code not found
    case "ORD-165":
    // Error with nashorn validations
    case "ORD-059":
    case "ORD-060":
    case "ORD-061":
    case "ORD-124":
    case "ORD-125":
    // The payment can not be billed due its status
    case "ORD-153":
    case "ORD-064":
    case "ORD-307":
    case "ORD-308":
    case "ORD-309":
    case "ORD-310":
    case "ORD-311":
    case "ORD-312":
    case "ORD-313":
    case "ORD-457":
    case "ORD-458":
    case "ORD-459":
    case "ORD-460":
    case "ORD-461":
    case "ORD-594":
    case "ORD-595":
    case "ORD-325":
    // only one reservation per
    case "CLOR-005":
    // throttling
    case "CLOR-007":
    // Wrong form response
    case "CLOR-000":
    //
    case "LOY-085":
    // A loyalty program form answer has incorrect regex format
    case "LOY-086":
      errorTitle = errorCode;
      break;
    default:
      errorTitle = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Error", id: "notification.error.title" });
  }
  return errorTitle;
};
const getResponseCode = (code) => {
  switch (code) {
    case 101:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.101", defaultMessage: "Tarjeta caducada" });
    case 102:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "redsys.error.102",
          defaultMessage: "Tarjeta en excepción transitoria o bajo sospecha de fraude"
        }
      );
    case 104:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.104", defaultMessage: "Operación no permitida para esa tarjeta o terminal." });
    case 106:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.106", defaultMessage: "Intentos de PIN excedidos" });
    case 125:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.125", defaultMessage: "Tarjeta no efectiva" });
    case 129:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.129", defaultMessage: "Código de seguridad (CVV2/CVC2) incorrecto" });
    case 180:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.180", defaultMessage: "Tarjeta ajena al servicio" });
    case 184:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.184", defaultMessage: "Error en la autenticación del titular" });
    case 190:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.190", defaultMessage: "Denegación del emisor sin especificar motivo" });
    case 191:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.191", defaultMessage: "Fecha de caducidad errónea" });
    case 202:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "redsys.error.202",
          defaultMessage: "Tarjeta en excepción transitoria o bajo sospecha de fraude con retirada de tarjeta"
        }
      );
    case 904:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.904", defaultMessage: "Comercio no registrado en FUC" });
    case 909:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.909", defaultMessage: "Error de sistema" });
    case 913:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.913", defaultMessage: "Pedido repetido" });
    case 944:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.944", defaultMessage: "Sesión Incorrecta" });
    case 950:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.950", defaultMessage: "Operación de devolución no permitida" });
    case 9912:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.9912", defaultMessage: "Emisor no disponible" });
    case 912:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.9912" });
    case 9064:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.9064", defaultMessage: "Número de posiciones de la tarjeta incorrecto" });
    case 9078:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.9078", defaultMessage: "Tipo de operación no permitida para esa tarjeta" });
    case 9093:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.9093", defaultMessage: "Tarjeta no existente" });
    case 9094:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.9094", defaultMessage: "Rechazo servidores internacionales" });
    case 9104:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "redsys.error.9104",
          defaultMessage: "Comercio con “titular seguro” y titular sin clave de compra segura"
        }
      );
    case 9218:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "redsys.error.9218",
          defaultMessage: "El comercio no permite op. seguras por entrada /operaciones"
        }
      );
    case 9253:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.9253", defaultMessage: "Tarjeta no cumple el check-digit" });
    case 9256:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.9256", defaultMessage: "El comercio no puede realizar preautorizaciones" });
    case 9257:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "redsys.error.9257",
          defaultMessage: "Esta tarjeta no permite operativa de preautorizaciones"
        }
      );
    case 9261:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "redsys.error.9261",
          defaultMessage: "Operación detenida por superar el control de restricciones en la entrada al SIS"
        }
      );
    case 9551:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.9551", defaultMessage: "Error en el proceso de autenticación" });
    case 9913:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.9913", defaultMessage: "Error en la confirmación" });
    case 9914:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.9914", defaultMessage: "Confirmación “KO” del comercio" });
    case 9915:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.error.9915", defaultMessage: "A petición del usuario se ha cancelado el pago" });
    case 9928:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "redsys.error.9928",
          defaultMessage: "Anulación de autorización en diferido realizada por el SIS"
        }
      );
    case 9929:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "redsys.error.9929",
          defaultMessage: "Anulación de autorización en diferido realizada por el comercio"
        }
      );
    case 9997:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "redsys.error.9997",
          defaultMessage: "Se está procesando otra transacción en SIS con la misma tarjeta"
        }
      );
    case 9998:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "redsys.error.9998",
          defaultMessage: "Operación en proceso de solicitud de datos de tarjeta"
        }
      );
    case 9999:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "redsys.error.9999",
          defaultMessage: "Operación que hasido redirigida al emisor a autenticar"
        }
      );
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "redsys.success.0000", defaultMessage: "Transacción completada" });
  }
};
const errorCodesSilenced = ["CAT-206"];
let refreshing = false;
const defaultFetch = (url, config) => fetchRetry(url, {
  retryOn: [503, 504],
  ...config
});
let buffer = [];
let tries = 3;
let triesToken = 6;
const checkStatus2 = (response, actionParam) => (dispatch) => {
  if (response.status >= 200 && response.status < 300) {
    if (buffer && !!buffer.length) {
      buffer.forEach((action) => {
        dispatch(action);
      });
      buffer = [];
    }
    return response;
  }
  if (response.status === 401) {
    if (refreshing) {
      buffer.push(actionParam);
    } else if (tries > 0 && triesToken > 0) {
      refreshing = true;
      tries--;
      triesToken--;
      dispatch(refreshUser()).then(() => {
        tries = 3;
        refreshing = false;
        dispatch(actionParam);
      });
    } else {
      throw new Error("Something goes wrong, unavailable token");
    }
    return Promise.reject(new Error("token_refreshing"));
  }
  if (response.status === 403) {
    if (refreshing) {
      buffer.push(actionParam);
    } else if (tries > 0 && triesToken > 0) {
      refreshing = true;
      tries--;
      triesToken--;
      dispatch(loginUser()).then(() => {
        tries = 3;
        refreshing = false;
        dispatch(actionParam);
      });
    } else {
      throw new Error("Something goes wrong, unavailable token");
    }
    return Promise.reject(new Error("token_refreshing"));
  }
  return response.json().then((responseJson) => {
    const error = new Error(String(responseJson));
    error.response = responseJson;
    return Promise.reject(error);
  });
};
const callApi = (endpoint, authenticated, config = {}, params, action) => (dispatch) => {
  const token2 = sessionStorage.getItem("access_token");
  const posId = sessionStorage.getItem("id_pos");
  const { headers: configHeaders, ...restConfig } = config;
  const newConfig = {
    ...restConfig,
    headers: {
      Accept: "application/json",
      "Accept-Language": Cookie.get("locale") || "en",
      "Content-Type": "application/json",
      ...configHeaders
    }
  };
  if (authenticated) {
    if (token2 && posId) {
      newConfig.headers = {
        Authorization: `Bearer ${token2}`,
        pos: posId,
        "Accept-Language": Cookie.get("locale") || "en",
        ...newConfig.headers
      };
    } else {
      throw new Error("No token or pos saved!");
    }
  }
  let url = endpoint;
  if (params) {
    url += `?${queryString.stringify(params)}`;
  }
  return defaultFetch(url, newConfig).then((response) => dispatch(checkStatus2(response, action))).then((response) => {
    if (response) {
      return response.json().catch(() => response);
    }
    return Promise.reject(new Error("token_refreshing"));
  });
};
const fetchApiDirect = (endpoint, authenticated, config = {}, params) => {
  const token2 = sessionStorage.getItem("access_token");
  const posId = sessionStorage.getItem("id_pos");
  const { headers: configHeaders, ...restConfig } = config;
  const newConfig = {
    ...restConfig,
    headers: {
      Accept: "application/json",
      "Accept-Language": Cookie.get("locale") || "en",
      "Content-Type": "application/json",
      ...configHeaders
    }
  };
  {
    if (token2 && posId) {
      newConfig.headers = {
        Authorization: `Bearer ${token2}`,
        pos: posId,
        "Accept-Language": Cookie.get("locale") || "en",
        ...newConfig.headers
      };
    } else {
      throw new Error("No token or pos saved!");
    }
  }
  let url = endpoint;
  if (params) {
    url += `?${queryString.stringify(params)}`;
  }
  return defaultFetch(url, newConfig).then((response) => response).then((response) => {
    if (response) {
      return response.json().catch(() => response);
    }
    return Promise.reject(new Error("token_refreshing"));
  });
};
const CALL_API = /* @__PURE__ */ Symbol("Call API");
const api = ({ dispatch }) => (next) => (action) => {
  const callAPI = action[CALL_API];
  if (typeof callAPI === "undefined") {
    return next(action);
  }
  const { endpoint, types, authenticated, config, showError = true, params, ...rest } = callAPI;
  const [requestType, successType, errorType] = types;
  next({
    type: requestType
  });
  return dispatch(callApi(endpoint, authenticated, config, params, action)).then(
    (response) => next({
      response,
      authenticated,
      type: successType,
      ...rest
    }),
    (error) => {
      const err = error;
      if (showError && err.message !== "token_refreshing") {
        const errorCode2 = err.response?.errorCode ?? "YYY-XXX";
        const errorTitle = errorCodeTitleId(errorCode2);
        const errorMessage = errorCodeMessageId(errorCode2, err.response?.message);
        if (errorCode2 === "CAT-107") {
          let newUrl;
          if (/&state=/.test(window.pos?.externalLogin ?? "")) {
            newUrl = `${window.pos.externalLogin.split("&state=")[0]}&state=${encodeURIComponent(window.location.href)}`;
          } else {
            newUrl = window.pos?.externalLogin ?? "";
          }
          Cookie.remove("tiqueteoSession");
          Cookie.remove("loyalty");
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = window.pos?.externalLogin ? newUrl : "/login";
          return;
        }
        if (!errorCodesSilenced.includes(errorCode2)) {
          dispatch(
            notificationsExports.error({
              title: errorTitle || /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "notification.error.title.general", defaultMessage: "Sorry,there was an error." }),
              message: errorMessage || "There was an error",
              level: "error",
              children: err.response?.uuid && errorTitle === "CLOR-000" ? err.response.uuid : "",
              position: "bc"
            })
          );
        }
      }
      const errorCode = error.response?.errorCode ?? "YYY-XXX";
      next({
        error: error.response?.message ?? "There was an error.",
        type: errorType,
        errorCode
      });
    }
  );
};
function throwIfMissing$1(name) {
  throw new Error(`Missing parameter: ${name}`);
}
const query$3 = queryString.parse(window.location.search);
function fetchBuyerTypesWithPrice({
  salesGroupId = throwIfMissing$1("salesGroupId"),
  productId = throwIfMissing$1("productId"),
  date = throwIfMissing$1("date"),
  isNumbered = false,
  eventId = null,
  ...params
}) {
  const hasDynamicPricing = window.pos?.hasDynamicPricing === true;
  let paramsRequest = {
    salesGroupId,
    productId,
    date,
    isNumbered,
    eventId,
    ...params
  };
  if (hasDynamicPricing) {
    const dynamicPricingMapObj = {
      pricingWebCookie: Cookie.get("UUID_CB") || null,
      ...query$3.ta && { ta: query$3.ta },
      ...query$3.ap && { ap: query$3.ap },
      ...date && { date }
    };
    if (Object.keys(dynamicPricingMapObj).length > 0) {
      const dynamicPricingMap = JSON.stringify(dynamicPricingMapObj);
      paramsRequest = { ...paramsRequest, dynamicPricingMap };
    }
  }
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL()}/buyerTypes/views/pricing`,
      types: [BUYER_TYPES_REQUEST, BUYER_TYPES_SUCCESS, BUYER_TYPES_FAILURE],
      authenticated: true,
      params: paramsRequest
    }
  };
}
function cleanBuyerTypesWithPrice() {
  return {
    type: BUYER_TYPES_CLEAN
  };
}
const toListSorted = index(
  (buyerTypesByIdMap, isEditMode, app, reservation) => {
    const ticketList = reservation?.reservation?.ticketList || [];
    const shouldShowInEditMode = app === "cgr" && isEditMode;
    return Object.values(buyerTypesByIdMap).filter(
      ({ status, buyerTypeId }) => status === "enabled" || shouldShowInEditMode && ticketList.some((ticket) => ticket.buyerTypeId === buyerTypeId)
    ).sort((a, b) => a.displayOrder - b.displayOrder);
  }
);
class BuyerTypeSelector extends Component {
  static canUpdateBuyerTypesForSpecificProducts(productId) {
    return BUYER_TYPES_AUTO_SELECTABLES.find((value) => value === productId);
  }
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      price: 0,
      discount: 0,
      selected: {},
      countAvailability: 0,
      isLocalChange: false
    };
    this.increment = this.increment.bind(this);
    this.decrement = this.decrement.bind(this);
    this.updateTicketsSelectionForSpecificProducts = this.updateTicketsSelectionForSpecificProducts.bind(this);
    this.updateInternalState = this.updateInternalState.bind(this);
  }
  componentDidMount() {
    const {
      ticketsSelected,
      buyerTypesMap = {},
      productId,
      product,
      event,
      date,
      salesGroupId,
      fetchBuyerTypesPrice
    } = this.props;
    const prod = product;
    const { showCalendar, showEvents, openDate } = prod;
    const generalProduct = prod.productCategory?.general;
    if (salesGroupId && generalProduct && (openDate && event && event.eventId || !showCalendar && !showEvents && !openDate)) {
      fetchBuyerTypesPrice({
        salesGroupId,
        productId,
        date: dateFnsExports.format(date, DATETIME_FORMAT_YMDHMS),
        eventId: event?.eventId
      });
    }
    if ((!productId || !BuyerTypeSelector.canUpdateBuyerTypesForSpecificProducts(productId)) && ticketsSelected && !isEmpty(buyerTypesMap)) {
      this.updateInternalState(ticketsSelected, buyerTypesMap);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      ticketsSelected,
      buyerTypesMap,
      isEditMode,
      productId,
      event,
      date = /* @__PURE__ */ new Date(),
      salesGroupId,
      fetchBuyerTypesPrice,
      product
    } = this.props;
    const { isLocalChange, selected } = this.state;
    const prod = product;
    const hasEvent = event?.eventId;
    const eventChanged = event?.eventId !== prevProps.event?.eventId;
    const hasCalendar = prod.showCalendar;
    if (hasEvent && eventChanged && prod.openDate && !hasCalendar) {
      fetchBuyerTypesPrice({
        salesGroupId,
        productId,
        date: dateFnsExports.format(date, DATETIME_FORMAT_YMDHMS),
        eventId: event?.eventId
      });
    }
    if (isLocalChange) {
      if (JSON.stringify(selected) === JSON.stringify(ticketsSelected)) {
        this.setState({ isLocalChange: false });
      }
      return;
    }
    if (productId && BuyerTypeSelector.canUpdateBuyerTypesForSpecificProducts(productId) && buyerTypesMap && !isEmpty(buyerTypesMap) && (prevProps.buyerTypesMap !== buyerTypesMap || prevProps.productId !== productId)) {
      this.updateTicketsSelectionForSpecificProducts(Object.values(buyerTypesMap), productId, false);
    } else if (productId && !BuyerTypeSelector.canUpdateBuyerTypesForSpecificProducts(productId) && ticketsSelected && !isEmpty(ticketsSelected) && buyerTypesMap && !isEmpty(buyerTypesMap) && !isEditMode && (prevProps.buyerTypesMap !== buyerTypesMap || prevProps.ticketsSelected !== ticketsSelected || prevProps.isEditMode !== isEditMode)) {
      if (JSON.stringify(selected) !== JSON.stringify(ticketsSelected)) {
        this.updateInternalState(ticketsSelected, buyerTypesMap);
      }
    }
  }
  componentWillUnmount() {
    const { cleanBuyerTypes } = this.props;
    cleanBuyerTypes();
    this.setState({
      count: 0,
      price: 0,
      discount: 0,
      selected: {},
      countAvailability: 0,
      isLocalChange: false
    });
    sessionStorage.removeItem("cartSelectedAndCount");
  }
  getUpdatedBuyerTypeSelection(buyerTypeId, step, isSelector) {
    const {
      maxTickets: maxTicketsWithAvailability = Number.MAX_VALUE,
      maxTicketsBySalesGroup = Number.MAX_VALUE,
      app,
      buyerTypesMap = {}
    } = this.props;
    const { count = 0, price: total = 0, selected = {}, countAvailability = 0 } = this.state;
    const isCGR = app === "cgr";
    const buyerType = buyerTypesMap[buyerTypeId];
    const { name, shortName, displayOrder, price, commission, amountTaxList, noHandleAvailability, productId } = buyerType;
    const amountTax = getAmountTaxTotal(amountTaxList);
    let { minTickets, maxTickets } = buyerType;
    const selectedBtDefaults = { n: 0, price, commission, amountTax, buyerTypeId };
    const selectedBt = { ...selectedBtDefaults, ...selected[buyerTypeId] ?? {} };
    maxTickets = isCGR ? Number.MAX_VALUE : maxTickets;
    minTickets = isCGR ? 0 : minTickets;
    let maxDiff = noHandleAvailability ? maxTicketsBySalesGroup - count : Math.min(maxTicketsWithAvailability - countAvailability, maxTicketsBySalesGroup - count);
    const productBuyerType = {
      minTickets
    };
    const min2 = productBuyerType.minTickets;
    maxDiff = Math.min(maxDiff - (min2 <= selectedBt.n ? 0 : min2) < 0 ? 0 : maxDiff, maxTickets - selectedBt.n);
    let newStep = step;
    if (selectedBt.n + newStep < min2) {
      if (step > 0) {
        if (min2 <= maxDiff) {
          newStep = min2;
        } else {
          newStep = 0;
        }
      } else {
        newStep = selectedBt.n * -1;
      }
    }
    if (maxDiff < step && !isSelector) {
      newStep = 0;
    }
    const newSelected = {
      ...selected,
      [buyerTypeId]: {
        buyerTypeId,
        name,
        shortName,
        displayOrder,
        price,
        commission,
        amountTax,
        noHandleAvailability,
        n: isSelector ? newStep : selectedBt.n + newStep
      }
    };
    Object.keys(newSelected).forEach((key) => {
      if (!newSelected[key].n) {
        delete newSelected[key];
      }
    });
    const totalTicketsNoAvailability = Object.values(newSelected).filter((t) => t.noHandleAvailability).reduce((prev, next) => next.n + prev, 0);
    const totalTickets = Object.values(newSelected).reduce((prev, next) => next.n + prev, 0);
    return {
      totalTickets,
      totalTicketsNoAvailability,
      price,
      commission,
      amountTax,
      total,
      newSelected
    };
  }
  updateTicketsSelectionForSpecificProducts(buyerTypesMap, _productId, selector) {
    let totalTicketsFinal = 0;
    let totalTicketsNoAvailabilityFinal = 0;
    let priceFinal = 0;
    let commissionFinal = 0;
    let amountTaxFinal = 0;
    let totalFinal = 0;
    let newSelectedFinal = {};
    buyerTypesMap.forEach((buyer, index2) => {
      const { totalTickets, totalTicketsNoAvailability, price, commission, amountTax, total, newSelected } = this.getUpdatedBuyerTypeSelection(buyer.buyerTypeId, index2 + 1, selector);
      totalTicketsFinal += totalTickets;
      totalTicketsNoAvailabilityFinal += totalTicketsNoAvailability;
      priceFinal += price;
      commissionFinal += commission;
      amountTaxFinal += amountTax;
      totalFinal += total;
      newSelectedFinal = { ...newSelected, ...newSelectedFinal };
    });
    this.setState(
      {
        count: totalTicketsFinal,
        countNoAvailability: totalTicketsNoAvailabilityFinal,
        countAvailability: totalTicketsFinal - totalTicketsNoAvailabilityFinal,
        price: totalFinal + (priceFinal + (priceFinal && commissionFinal) + (priceFinal && amountTaxFinal)),
        selected: newSelectedFinal
      },
      this.manageBuyerTypes
    );
  }
  updateInternalState(ticketsSelected, buyerTypesMap) {
    let count = 0;
    let price = 0;
    Object.values(ticketsSelected).forEach((buyerType) => {
      const buyerTypeFilter = buyerTypesMap[buyerType.buyerTypeId];
      count += buyerType.n;
      price += buyerTypeFilter && buyerTypeFilter.price * buyerType.n;
      if (buyerTypeFilter && buyerTypeFilter.price > 0 && buyerTypeFilter.commission && buyerType.n > 0) {
        price += buyerTypeFilter.commission * buyerType.n;
      }
      const amountTax = buyerTypeFilter && getAmountTaxTotal(buyerTypeFilter.amountTaxList);
      if (buyerTypeFilter && buyerTypeFilter.price > 0 && amountTax && buyerType.n > 0) {
        price += amountTax * buyerType.n;
      }
    });
    this.setState({
      count,
      price,
      selected: ticketsSelected
    });
  }
  manageBuyerTypes() {
    const { handleSelection } = this.props;
    handleSelection(this.state);
  }
  increment(buyerTypeId, step, isSelector) {
    const { totalTickets, totalTicketsNoAvailability, price, commission, amountTax, total, newSelected } = this.getUpdatedBuyerTypeSelection(buyerTypeId, step, !!isSelector);
    this.setState(
      {
        count: totalTickets,
        countNoAvailability: totalTicketsNoAvailability,
        countAvailability: totalTickets - totalTicketsNoAvailability,
        price: total + step * (price + (price && commission) + (price && amountTax)),
        selected: newSelected,
        isLocalChange: true
      },
      this.manageBuyerTypes
    );
  }
  decrement(buyerTypeId, n) {
    this.increment(buyerTypeId, n * -1);
  }
  render() {
    const {
      buyerTypeInfoList,
      productInfo,
      buyerTypesMap = {},
      headerText,
      currency,
      loginUrl,
      promotionList = [],
      event,
      maxTicketsBySalesGroup = Number.MAX_VALUE,
      sellerIdSelected,
      showBuyerTypesAsSelect,
      app,
      maxTickets: maxTicketsWithAvailability = Number.MAX_VALUE,
      hidePrice,
      timeZone = "Europe/Madrid",
      showCommissionSummary,
      productConfigurations
    } = this.props;
    const isCGR = app === "cgr";
    const { selected, count, countAvailability } = this.state;
    const step = 1;
    const buyerTypeListSorted = toListSorted(buyerTypesMap);
    sessionStorage.setItem("cartSelectedAndCount", JSON.stringify({ selected, count }));
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      headerText && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel-body-header-text", children: headerText }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "panel-body-content", children: [
        productInfo && productInfo.top,
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "buyerTypes", children: buyerTypeListSorted && buyerTypeListSorted.length ? buyerTypeListSorted.map(
          ({
            buyerTypeId,
            name,
            description,
            price,
            commission,
            amountTaxList,
            maxTickets,
            shortName,
            authSalesGroups,
            minTickets,
            noHandleAvailability,
            productVenueBuyerTypeList,
            productExtraBuyerTypeList
          }) => {
            let newComission = 0;
            if (!showCommissionSummary) {
              newComission = commission;
            }
            const selectedBtDefaults = { n: 0, price, commission, buyerTypeId };
            const selectedBt = { ...selectedBtDefaults, ...selected[buyerTypeId] ?? {} };
            let maxDiff = noHandleAvailability ? maxTicketsBySalesGroup - count : Math.min(maxTicketsWithAvailability - countAvailability, maxTicketsBySalesGroup - count);
            if (maxTickets && !isCGR) {
              const productBuyerType = {
                minTickets: 0
              };
              const min2 = productBuyerType.minTickets;
              const quantity = selectedBt.n || 0;
              const firstValue = maxDiff - (min2 <= quantity ? 0 : min2) < 0 ? 0 : maxDiff;
              const secondValue = maxTickets - quantity;
              maxDiff = Math.min(firstValue, secondValue);
            }
            let promoBuyerTypes = promotionList.filter(
              (promo) => generalValidationsMemo({
                buyerTypeId,
                promotion: promo,
                event,
                timeZone
              })
            ) || [];
            promoBuyerTypes = getDefaultEventPromotionMemo(
              promoBuyerTypes,
              sellerIdSelected ?? void 0,
              void 0
            ) || {};
            let discount;
            let percentage;
            const promoBTMap = promoBuyerTypes;
            if (promoBTMap && promoBTMap[buyerTypeId]) {
              if (promoBTMap[buyerTypeId].promotionPrices && promoBTMap[buyerTypeId].promotionPrices.length > 0) {
                const promoPriceBuyerType = promoBTMap[buyerTypeId].promotionPrices.find(
                  (promoPrice) => promoPrice.buyerTypeId === buyerTypeId
                );
                if (promoPriceBuyerType && promoPriceBuyerType.amount) {
                  discount = promoPriceBuyerType.amount;
                } else if (promoPriceBuyerType && promoPriceBuyerType.percentage) {
                  const { discount: promoDiscount } = getTotalPriceWithPercentagePromo({
                    originalPrice: price,
                    ticketBuyerType: productVenueBuyerTypeList,
                    extraBuyerType: productExtraBuyerTypeList,
                    percentage: promoPriceBuyerType.percentage
                  });
                  discount = promoDiscount;
                } else {
                  discount = 0;
                }
              } else if (promoBTMap[buyerTypeId].percentage) {
                const { discount: promoDiscount } = getTotalPriceWithPercentagePromo({
                  originalPrice: price,
                  ticketBuyerType: productVenueBuyerTypeList,
                  extraBuyerType: productExtraBuyerTypeList,
                  percentage: promoBTMap[buyerTypeId].percentage
                });
                discount = promoDiscount;
                percentage = promoBTMap[buyerTypeId].percentage;
              } else {
                discount = promoBTMap[buyerTypeId].amount;
              }
            } else {
              discount = 0;
            }
            return /* @__PURE__ */ jsxRuntimeExports.jsx(
              BuyerTypeItem$1,
              {
                showBuyerTypesAsSelect,
                name,
                hidePrice: !!needsToHidePriceField(
                  productConfigurations,
                  hidePrice
                ),
                description,
                buyerTypeInfo: buyerTypeInfoList ? buyerTypeInfoList.find((bt) => bt.buyerTypeId === buyerTypeId) : void 0,
                buyerTypeListSorted,
                promotionList,
                discount,
                price,
                commission: newComission,
                amountTaxList,
                percentage,
                id: buyerTypeId,
                shortName,
                authSalesGroupList: authSalesGroups,
                value: selectedBt.n,
                currency: currency ?? "",
                minTickets: isCGR ? 0 : minTickets,
                loginUrl: loginUrl ?? "",
                max: maxDiff,
                maxTickets: noHandleAvailability ? maxTicketsBySalesGroup : maxTicketsWithAvailability,
                change: (value) => {
                  this.increment(buyerTypeId, value, true);
                },
                increment: () => {
                  this.increment(buyerTypeId, step);
                },
                decrement: () => {
                  this.decrement(buyerTypeId, step);
                }
              },
              `bt-selector-${buyerTypeId}`
            );
          }
        ) : null }),
        productInfo && productInfo.bottom
      ] })
    ] });
  }
}
const mapDispatchToProps$j = (dispatch) => ({
  fetchBuyerTypesPrice: ({ salesGroupId, productId, date, eventId }) => dispatch(
    fetchBuyerTypesWithPrice({
      salesGroupId,
      productId,
      date,
      eventId,
      isNumbered: false
    })
  ),
  cleanBuyerTypes: () => dispatch(cleanBuyerTypesWithPrice())
});
const mapStateToProps$v = (state) => {
  const { pointOfSales, products: products2, cart: cart2 } = state;
  const { product, date, salesGroup } = cart2;
  const { configurations } = pointOfSales ?? {};
  const { productConfigurations } = products2;
  return {
    showCommissionSummary: !!(configurations && configurations.showCommissionSummary),
    productConfigurations,
    productId: product.productId,
    timeZone: pointOfSales?.clientList?.[0]?.timeZone,
    product,
    salesGroupId: salesGroup.salesGroupId,
    date
  };
};
const BuyerTypeSelector$1 = connect(mapStateToProps$v, mapDispatchToProps$j)(BuyerTypeSelector);
var classnames$1 = { exports: {} };
var hasRequiredClassnames;
function requireClassnames() {
  if (hasRequiredClassnames) return classnames$1.exports;
  hasRequiredClassnames = 1;
  (function(module2) {
    (function() {
      var hasOwn3 = {}.hasOwnProperty;
      function classNames() {
        var classes = "";
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            classes = appendClass(classes, parseValue2(arg));
          }
        }
        return classes;
      }
      function parseValue2(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn3.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (module2.exports) {
        classNames.default = classNames;
        module2.exports = classNames;
      } else {
        window.classNames = classNames;
      }
    })();
  })(classnames$1);
  return classnames$1.exports;
}
var classnamesExports = requireClassnames();
const classnames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
function loadImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve();
    image.onerror = () => reject(new Error(`Error when loading ${url}`));
    image.src = url;
  });
}
const modern = window.CSS && CSS.supports && CSS.supports("object-fit", "cover");
class FittedImage extends Component {
  static defaultProps = {
    background: false,
    fit: "auto",
    style: {},
    onLoad: () => {
    },
    onError: () => {
    }
  };
  constructor(props) {
    super(props);
    this.onLoadSuccess = this.onLoadSuccess.bind(this);
    this.onLoadError = this.onLoadError.bind(this);
  }
  componentDidMount() {
    const { loader: loader2 } = this.props;
    if (loader2) {
      this.loadImage();
    }
  }
  componentDidUpdate(prevProps) {
    const { src } = this.props;
    const { src: srcPrevProp } = prevProps;
    if (src !== srcPrevProp) {
      this.loadImage();
    }
  }
  onLoadSuccess() {
    const { onLoad } = this.props;
    if (onLoad) onLoad();
  }
  onLoadError() {
    const { onError } = this.props;
    if (onError) onError();
  }
  getClassName(background) {
    const { fit, className } = this.props;
    return classnames("FittedImage", background ? "FittedImage--background" : null, `FittedImage--${fit}`, className);
  }
  getImage() {
    const { background, src, alt, ...props } = this.props;
    if (!background && modern) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "img",
        {
          ...props,
          src,
          alt,
          className: this.getClassName(false)
        }
      );
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        ...props,
        style: this.getStyle(),
        className: this.getClassName(true)
      }
    );
  }
  getStyle() {
    const { src } = this.props;
    return {
      backgroundImage: `url(${src})`
    };
  }
  loadImage() {
    const { src } = this.props;
    if (src) {
      loadImage(src).then(this.onLoadSuccess, this.onLoadError);
    }
  }
  render() {
    return this.getImage();
  }
}
function ProductItem({
  name,
  shortDescription,
  description,
  image,
  basePrice,
  publicPriceText,
  showPrice,
  buttons,
  currency,
  displayClass
}) {
  const locale = Cookie.get("languageCountryCode");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("article", { className: `product ${displayClass}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "block-image", style: { backgroundImage: `url(${image})` }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FittedImage, { fit: "cover", alt: name, src: image }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "block-description-price", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "block-description", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "product-title", children: name }),
        shortDescription && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "description", dangerouslySetInnerHTML: { __html: shortDescription } }),
        description && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "description-large", dangerouslySetInnerHTML: { __html: description } })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "block-price", children: [
        showPrice && /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: "price", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "price-text", dangerouslySetInnerHTML: { __html: publicPriceText ?? "" } }),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: basePrice, currency })
        ] }),
        buttons && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "buttons", children: buttons })
      ] })
    ] })
  ] });
}
function ProductSubscription({ name, productId, handlerMethod, checked }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-checkbox", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        id: `subscription${productId}`,
        type: "checkbox",
        name: `subscription${productId}`,
        onChange: (e) => {
          handlerMethod(e.target.checked, productId);
        },
        defaultChecked: checked
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "checkbox-inline", htmlFor: `subscription${productId}`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", {}),
      name,
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", {})
    ] })
  ] }) });
}
var reactResponsive$1 = { exports: {} };
var reactResponsive = reactResponsive$1.exports;
var hasRequiredReactResponsive;
function requireReactResponsive() {
  if (hasRequiredReactResponsive) return reactResponsive$1.exports;
  hasRequiredReactResponsive = 1;
  (function(module2, exports2) {
    !(function(root2, factory) {
      module2.exports = factory(React__default);
    })("undefined" != typeof self ? self : reactResponsive, function(__WEBPACK_EXTERNAL_MODULE_6__) {
      return (function(modules) {
        function __webpack_require__(moduleId) {
          if (installedModules[moduleId]) return installedModules[moduleId].exports;
          var module3 = installedModules[moduleId] = {
            i: moduleId,
            l: false,
            exports: {}
          };
          return modules[moduleId].call(module3.exports, module3, module3.exports, __webpack_require__), module3.l = true, module3.exports;
        }
        var installedModules = {};
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function(exports3, name, getter) {
          __webpack_require__.o(exports3, name) || Object.defineProperty(exports3, name, {
            configurable: false,
            enumerable: true,
            get: getter
          });
        }, __webpack_require__.n = function(module3) {
          var getter = module3 && module3.__esModule ? function() {
            return module3.default;
          } : function() {
            return module3;
          };
          return __webpack_require__.d(getter, "a", getter), getter;
        }, __webpack_require__.o = function(object2, property2) {
          return Object.prototype.hasOwnProperty.call(object2, property2);
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 5);
      })([function(module3, exports3, __webpack_require__) {
        var ReactIs = __webpack_require__(1);
        module3.exports = __webpack_require__(8)(ReactIs.isElement, true);
      }, function(module3, exports3, __webpack_require__) {
        module3.exports = __webpack_require__(7);
      }, function(module3, exports3, __webpack_require__) {
        module3.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      }, function(module3, __webpack_exports__, __webpack_require__) {
        function toHyphenLower(match2) {
          return "-" + match2.toLowerCase();
        }
        function hyphenateStyleName(name) {
          if (cache.hasOwnProperty(name)) return cache[name];
          var hName = name.replace(uppercasePattern, toHyphenLower);
          return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
        }
        var uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
        __webpack_exports__.a = hyphenateStyleName;
      }, function(module3, __webpack_exports__, __webpack_require__) {
        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = null != arguments[i] ? arguments[i] : {}, ownKeys3 = Object.keys(source);
            "function" == typeof Object.getOwnPropertySymbols && (ownKeys3 = ownKeys3.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
              return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }))), ownKeys3.forEach(function(key) {
              _defineProperty2(target, key, source[key]);
            });
          }
          return target;
        }
        function _defineProperty2(obj, key, value) {
          return key in obj ? Object.defineProperty(obj, key, {
            value,
            enumerable: true,
            configurable: true,
            writable: true
          }) : obj[key] = value, obj;
        }
        var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0), __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__), stringOrNumber = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]), matchers = {
          orientation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(["portrait", "landscape"]),
          scan: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(["progressive", "interlace"]),
          aspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
          deviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
          height: stringOrNumber,
          deviceHeight: stringOrNumber,
          width: stringOrNumber,
          deviceWidth: stringOrNumber,
          color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
          colorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
          monochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
          resolution: stringOrNumber
        }, features = _objectSpread({
          minAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
          maxAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
          minDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
          maxDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
          minHeight: stringOrNumber,
          maxHeight: stringOrNumber,
          minDeviceHeight: stringOrNumber,
          maxDeviceHeight: stringOrNumber,
          minWidth: stringOrNumber,
          maxWidth: stringOrNumber,
          minDeviceWidth: stringOrNumber,
          maxDeviceWidth: stringOrNumber,
          minColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
          maxColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
          minColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
          maxColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
          minMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
          maxMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
          minResolution: stringOrNumber,
          maxResolution: stringOrNumber
        }, matchers), types = {
          all: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
          grid: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
          aural: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
          braille: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
          handheld: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
          print: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
          projection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
          screen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
          tty: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
          tv: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
          embossed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
        }, all = _objectSpread({}, types, features);
        matchers.type = Object.keys(types), __webpack_exports__.a = {
          all,
          types,
          matchers,
          features
        };
      }, function(module3, __webpack_exports__, __webpack_require__) {
        function _typeof2(obj) {
          return (_typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
            return typeof obj2;
          } : function(obj2) {
            return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
          })(obj);
        }
        function _classCallCheck2(instance, Constructor) {
          if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function _defineProperties2(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false, descriptor.configurable = true, "value" in descriptor && (descriptor.writable = true), Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass2(Constructor, protoProps, staticProps) {
          return staticProps && _defineProperties2(Constructor, staticProps), Constructor;
        }
        function _possibleConstructorReturn2(self2, call2) {
          return !call2 || "object" !== _typeof2(call2) && "function" != typeof call2 ? _assertThisInitialized2(self2) : call2;
        }
        function _getPrototypeOf2(o) {
          return (_getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function(o2) {
            return o2.__proto__ || Object.getPrototypeOf(o2);
          })(o);
        }
        function _assertThisInitialized2(self2) {
          if (void 0 === self2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return self2;
        }
        function _inherits2(subClass, superClass) {
          if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true
            }
          }), superClass && _setPrototypeOf2(subClass, superClass);
        }
        function _setPrototypeOf2(o, p) {
          return (_setPrototypeOf2 = Object.setPrototypeOf || function(o2, p2) {
            return o2.__proto__ = p2, o2;
          })(o, p);
        }
        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = null != arguments[i] ? arguments[i] : {}, ownKeys3 = Object.keys(source);
            "function" == typeof Object.getOwnPropertySymbols && (ownKeys3 = ownKeys3.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
              return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }))), ownKeys3.forEach(function(key) {
              _defineProperty2(target, key, source[key]);
            });
          }
          return target;
        }
        function _defineProperty2(obj, key, value) {
          return key in obj ? Object.defineProperty(obj, key, {
            value,
            enumerable: true,
            configurable: true,
            writable: true
          }) : obj[key] = value, obj;
        }
        Object.defineProperty(__webpack_exports__, "__esModule", {
          value: true
        }), __webpack_require__.d(__webpack_exports__, "default", function() {
          return MediaQuery2;
        });
        var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6), __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__), __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0), __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__), __WEBPACK_IMPORTED_MODULE_2_matchmediaquery__ = __webpack_require__(11), __WEBPACK_IMPORTED_MODULE_2_matchmediaquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_matchmediaquery__), __WEBPACK_IMPORTED_MODULE_3_hyphenate_style_name__ = __webpack_require__(3), __WEBPACK_IMPORTED_MODULE_4__mediaQuery__ = __webpack_require__(4), __WEBPACK_IMPORTED_MODULE_5__toQuery__ = __webpack_require__(13);
        __webpack_require__.d(__webpack_exports__, "toQuery", function() {
          return __WEBPACK_IMPORTED_MODULE_5__toQuery__.a;
        });
        var defaultTypes = {
          component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
          query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_4__mediaQuery__.a.matchers),
          children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
          onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
        }, excludedQueryKeys = Object.keys(defaultTypes), omit = function(object2, keys3) {
          var newObject = _objectSpread({}, object2);
          return keys3.forEach(function(key) {
            return delete newObject[key];
          }), newObject;
        }, getValues = function(_ref) {
          var values = _ref.values;
          if (!values) return null;
          var keys3 = Object.keys(values);
          return 0 === keys3.length ? null : keys3.reduce(function(result, key) {
            return result[Object(__WEBPACK_IMPORTED_MODULE_3_hyphenate_style_name__.a)(key)] = values[key], result;
          }, {});
        }, getQuery = function(props) {
          return props.query || Object(__WEBPACK_IMPORTED_MODULE_5__toQuery__.a)(omit(props, excludedQueryKeys));
        }, MediaQuery2 = (function(_React$Component) {
          function MediaQuery3() {
            var _getPrototypeOf22, _this;
            _classCallCheck2(this, MediaQuery3);
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _this = _possibleConstructorReturn2(this, (_getPrototypeOf22 = _getPrototypeOf2(MediaQuery3)).call.apply(_getPrototypeOf22, [this].concat(args))), _defineProperty2(_assertThisInitialized2(_this), "state", {
              matches: false,
              mq: null,
              query: "",
              values: null
            }), _defineProperty2(_assertThisInitialized2(_this), "componentDidMount", function() {
              _this.state.mq.addListener(_this.updateMatches), _this.updateMatches();
            }), _defineProperty2(_assertThisInitialized2(_this), "componentDidUpdate", function(prevProps, prevState) {
              _this.state.mq !== prevState.mq && (_this.cleanupMediaQuery(prevState.mq), _this.state.mq.addListener(_this.updateMatches)), _this.props.onChange && prevState.matches !== _this.state.matches && _this.props.onChange(_this.state.matches);
            }), _defineProperty2(_assertThisInitialized2(_this), "componentWillUnmount", function() {
              _this._unmounted = true, _this.cleanupMediaQuery(_this.state.mq);
            }), _defineProperty2(_assertThisInitialized2(_this), "cleanupMediaQuery", function(mq) {
              mq && (mq.removeListener(_this.updateMatches), mq.dispose());
            }), _defineProperty2(_assertThisInitialized2(_this), "updateMatches", function() {
              _this._unmounted || _this.state.mq.matches !== _this.state.matches && _this.setState({
                matches: _this.state.mq.matches
              });
            }), _defineProperty2(_assertThisInitialized2(_this), "render", function() {
              return "function" == typeof _this.props.children ? _this.props.children(_this.state.matches) : _this.state.matches ? _this.props.children : null;
            }), _this;
          }
          return _inherits2(MediaQuery3, _React$Component), _createClass2(MediaQuery3, null, [{
            key: "getDerivedStateFromProps",
            value: function(props, state) {
              var query2 = getQuery(props);
              if (!query2) throw new Error("Invalid or missing MediaQuery!");
              var values = getValues(props);
              if (query2 === state.query && values === state.values) return null;
              var mq = __WEBPACK_IMPORTED_MODULE_2_matchmediaquery___default()(query2, values || {}, !!values);
              return {
                matches: mq.matches,
                mq,
                query: query2,
                values
              };
            }
          }]), MediaQuery3;
        })(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
        _defineProperty2(MediaQuery2, "displayName", "MediaQuery"), _defineProperty2(MediaQuery2, "defaultProps", {
          values: null
        });
      }, function(module3, exports3) {
        module3.exports = __WEBPACK_EXTERNAL_MODULE_6__;
      }, function(module3, exports3, __webpack_require__) {
        !(function() {
          function isValidElementType(type) {
            return "string" == typeof type || "function" == typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || "object" == typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
          }
          function typeOf(object2) {
            if ("object" == typeof object2 && null !== object2) {
              var $$typeof = object2.$$typeof;
              switch ($$typeof) {
                case REACT_ELEMENT_TYPE:
                  var type = object2.type;
                  switch (type) {
                    case REACT_ASYNC_MODE_TYPE:
                    case REACT_CONCURRENT_MODE_TYPE:
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                      return type;
                    default:
                      var $$typeofType = type && type.$$typeof;
                      switch ($$typeofType) {
                        case REACT_CONTEXT_TYPE:
                        case REACT_FORWARD_REF_TYPE:
                        case REACT_PROVIDER_TYPE:
                          return $$typeofType;
                        default:
                          return $$typeof;
                      }
                  }
                case REACT_LAZY_TYPE:
                case REACT_MEMO_TYPE:
                case REACT_PORTAL_TYPE:
                  return $$typeof;
              }
            }
          }
          function isAsyncMode(object2) {
            return hasWarnedAboutDeprecatedIsAsyncMode || (hasWarnedAboutDeprecatedIsAsyncMode = true, lowPriorityWarning$1(false, "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
          }
          function isConcurrentMode(object2) {
            return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
          }
          function isContextConsumer(object2) {
            return typeOf(object2) === REACT_CONTEXT_TYPE;
          }
          function isContextProvider(object2) {
            return typeOf(object2) === REACT_PROVIDER_TYPE;
          }
          function isElement(object2) {
            return "object" == typeof object2 && null !== object2 && object2.$$typeof === REACT_ELEMENT_TYPE;
          }
          function isForwardRef(object2) {
            return typeOf(object2) === REACT_FORWARD_REF_TYPE;
          }
          function isFragment(object2) {
            return typeOf(object2) === REACT_FRAGMENT_TYPE;
          }
          function isLazy(object2) {
            return typeOf(object2) === REACT_LAZY_TYPE;
          }
          function isMemo(object2) {
            return typeOf(object2) === REACT_MEMO_TYPE;
          }
          function isPortal(object2) {
            return typeOf(object2) === REACT_PORTAL_TYPE;
          }
          function isProfiler(object2) {
            return typeOf(object2) === REACT_PROFILER_TYPE;
          }
          function isStrictMode(object2) {
            return typeOf(object2) === REACT_STRICT_MODE_TYPE;
          }
          function isSuspense(object2) {
            return typeOf(object2) === REACT_SUSPENSE_TYPE;
          }
          Object.defineProperty(exports3, "__esModule", {
            value: true
          });
          var hasSymbol = "function" == typeof Symbol && Symbol.for, REACT_ELEMENT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.element") : 60103, REACT_PORTAL_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, REACT_FRAGMENT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, REACT_STRICT_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, REACT_PROFILER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, REACT_PROVIDER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, REACT_CONTEXT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.context") : 60110, REACT_ASYNC_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, REACT_CONCURRENT_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, REACT_FORWARD_REF_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, REACT_SUSPENSE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, REACT_MEMO_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, REACT_LAZY_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, lowPriorityWarning = function() {
          }, printWarning = function(format2) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
            var argIndex = 0, message = "Warning: " + format2.replace(/%s/g, function() {
              return args[argIndex++];
            });
            "undefined" != typeof console && console.warn(message);
            try {
              throw new Error(message);
            } catch (x) {
            }
          };
          lowPriorityWarning = function(condition, format2) {
            if (void 0 === format2) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");
            if (!condition) {
              for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) args[_key2 - 2] = arguments[_key2];
              printWarning.apply(void 0, [format2].concat(args));
            }
          };
          var lowPriorityWarning$1 = lowPriorityWarning, AsyncMode = REACT_ASYNC_MODE_TYPE, ConcurrentMode = REACT_CONCURRENT_MODE_TYPE, ContextConsumer = REACT_CONTEXT_TYPE, ContextProvider = REACT_PROVIDER_TYPE, Element = REACT_ELEMENT_TYPE, ForwardRef = REACT_FORWARD_REF_TYPE, Fragment2 = REACT_FRAGMENT_TYPE, Lazy = REACT_LAZY_TYPE, Memo = REACT_MEMO_TYPE, Portal = REACT_PORTAL_TYPE, Profiler = REACT_PROFILER_TYPE, StrictMode = REACT_STRICT_MODE_TYPE, Suspense = REACT_SUSPENSE_TYPE, hasWarnedAboutDeprecatedIsAsyncMode = false;
          exports3.typeOf = typeOf, exports3.AsyncMode = AsyncMode, exports3.ConcurrentMode = ConcurrentMode, exports3.ContextConsumer = ContextConsumer, exports3.ContextProvider = ContextProvider, exports3.Element = Element, exports3.ForwardRef = ForwardRef, exports3.Fragment = Fragment2, exports3.Lazy = Lazy, exports3.Memo = Memo, exports3.Portal = Portal, exports3.Profiler = Profiler, exports3.StrictMode = StrictMode, exports3.Suspense = Suspense, exports3.isValidElementType = isValidElementType, exports3.isAsyncMode = isAsyncMode, exports3.isConcurrentMode = isConcurrentMode, exports3.isContextConsumer = isContextConsumer, exports3.isContextProvider = isContextProvider, exports3.isElement = isElement, exports3.isForwardRef = isForwardRef, exports3.isFragment = isFragment, exports3.isLazy = isLazy, exports3.isMemo = isMemo, exports3.isPortal = isPortal, exports3.isProfiler = isProfiler, exports3.isStrictMode = isStrictMode, exports3.isSuspense = isSuspense;
        })();
      }, function(module3, exports3, __webpack_require__) {
        function emptyFunctionThatReturnsNull() {
          return null;
        }
        var ReactIs = __webpack_require__(1), assign = __webpack_require__(9), ReactPropTypesSecret = __webpack_require__(2), checkPropTypes = __webpack_require__(10), has2 = Function.call.bind(Object.prototype.hasOwnProperty), printWarning = function() {
        };
        printWarning = function(text) {
          var message = "Warning: " + text;
          "undefined" != typeof console && console.error(message);
          try {
            throw new Error(message);
          } catch (x) {
          }
        }, module3.exports = function(isValidElement2, throwOnDirectAccess) {
          function getIteratorFn(maybeIterable) {
            var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
            if ("function" == typeof iteratorFn) return iteratorFn;
          }
          function is2(x, y) {
            return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
          }
          function PropTypeError(message) {
            this.message = message, this.stack = "";
          }
          function createChainableTypeChecker(validate) {
            function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
              if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, secret !== ReactPropTypesSecret) {
                if (throwOnDirectAccess) {
                  var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                  throw err.name = "Invariant Violation", err;
                }
                if ("undefined" != typeof console) {
                  var cacheKey2 = componentName + ":" + propName;
                  !manualPropTypeCallCache[cacheKey2] && manualPropTypeWarningCount < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), manualPropTypeCallCache[cacheKey2] = true, manualPropTypeWarningCount++);
                }
              }
              return null == props[propName] ? isRequired ? new PropTypeError(null === props[propName] ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
            }
            var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0, chainedCheckType = checkType.bind(null, false);
            return chainedCheckType.isRequired = checkType.bind(null, true), chainedCheckType;
          }
          function createPrimitiveTypeChecker(expectedType) {
            function validate(props, propName, componentName, location, propFullName, secret) {
              var propValue = props[propName];
              if (getPropType(propValue) !== expectedType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.");
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createArrayOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
              if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
              var propValue = props[propName];
              if (!Array.isArray(propValue)) {
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
              }
              for (var i = 0; i < propValue.length; i++) {
                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                if (error instanceof Error) return error;
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createInstanceTypeChecker(expectedClass) {
            function validate(props, propName, componentName, location, propFullName) {
              if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createEnumTypeChecker(expectedValues) {
            function validate(props, propName, componentName, location, propFullName) {
              for (var propValue = props[propName], i = 0; i < expectedValues.length; i++) if (is2(propValue, expectedValues[i])) return null;
              var valuesString = JSON.stringify(expectedValues, function(key, value) {
                return "symbol" === getPreciseType(value) ? String(value) : value;
              });
              return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` supplied to `" + componentName + "`, expected one of " + valuesString + ".");
            }
            return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (printWarning(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), emptyFunctionThatReturnsNull);
          }
          function createObjectOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
              if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
              var propValue = props[propName], propType = getPropType(propValue);
              if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
              for (var key in propValue) if (has2(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                if (error instanceof Error) return error;
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createUnionTypeChecker(arrayOfTypeCheckers) {
            function validate(props, propName, componentName, location, propFullName) {
              for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
                if (null == (0, arrayOfTypeCheckers[i2])(props, propName, componentName, location, propFullName, ReactPropTypesSecret)) return null;
              }
              return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`.");
            }
            if (!Array.isArray(arrayOfTypeCheckers)) return printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), emptyFunctionThatReturnsNull;
            for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
              var checker = arrayOfTypeCheckers[i];
              if ("function" != typeof checker) return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."), emptyFunctionThatReturnsNull;
            }
            return createChainableTypeChecker(validate);
          }
          function createShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName], propType = getPropType(propValue);
              if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
              for (var key in shapeTypes) {
                var checker = shapeTypes[key];
                if (checker) {
                  var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                  if (error) return error;
                }
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createStrictShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName], propType = getPropType(propValue);
              if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
              var allKeys = assign({}, props[propName], shapeTypes);
              for (var key in allKeys) {
                var checker = shapeTypes[key];
                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                if (error) return error;
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function isNode(propValue) {
            switch (typeof propValue) {
              case "number":
              case "string":
              case "undefined":
                return true;
              case "boolean":
                return !propValue;
              case "object":
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (null === propValue || isValidElement2(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (!iteratorFn) return false;
                var step, iterator = iteratorFn.call(propValue);
                if (iteratorFn !== propValue.entries) {
                  for (; !(step = iterator.next()).done; ) if (!isNode(step.value)) return false;
                } else for (; !(step = iterator.next()).done; ) {
                  var entry = step.value;
                  if (entry && !isNode(entry[1])) return false;
                }
                return true;
              default:
                return false;
            }
          }
          function isSymbol2(propType, propValue) {
            return "symbol" === propType || !!propValue && ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
          }
          function getPropType(propValue) {
            var propType = typeof propValue;
            return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol2(propType, propValue) ? "symbol" : propType;
          }
          function getPreciseType(propValue) {
            if (void 0 === propValue || null === propValue) return "" + propValue;
            var propType = getPropType(propValue);
            if ("object" === propType) {
              if (propValue instanceof Date) return "date";
              if (propValue instanceof RegExp) return "regexp";
            }
            return propType;
          }
          function getPostfixForTypeWarning(value) {
            var type = getPreciseType(value);
            switch (type) {
              case "array":
              case "object":
                return "an " + type;
              case "boolean":
              case "date":
              case "regexp":
                return "a " + type;
              default:
                return type;
            }
          }
          function getClassName(propValue) {
            return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
          }
          var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
            array: createPrimitiveTypeChecker("array"),
            bool: createPrimitiveTypeChecker("boolean"),
            func: createPrimitiveTypeChecker("function"),
            number: createPrimitiveTypeChecker("number"),
            object: createPrimitiveTypeChecker("object"),
            string: createPrimitiveTypeChecker("string"),
            symbol: createPrimitiveTypeChecker("symbol"),
            any: (function() {
              return createChainableTypeChecker(emptyFunctionThatReturnsNull);
            })(),
            arrayOf: createArrayOfTypeChecker,
            element: (function() {
              function validate(props, propName, componentName, location, propFullName) {
                var propValue = props[propName];
                if (!isValidElement2(propValue)) {
                  return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
                }
                return null;
              }
              return createChainableTypeChecker(validate);
            })(),
            elementType: (function() {
              function validate(props, propName, componentName, location, propFullName) {
                var propValue = props[propName];
                if (!ReactIs.isValidElementType(propValue)) {
                  return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement type.");
                }
                return null;
              }
              return createChainableTypeChecker(validate);
            })(),
            instanceOf: createInstanceTypeChecker,
            node: (function() {
              function validate(props, propName, componentName, location, propFullName) {
                return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
              }
              return createChainableTypeChecker(validate);
            })(),
            objectOf: createObjectOfTypeChecker,
            oneOf: createEnumTypeChecker,
            oneOfType: createUnionTypeChecker,
            shape: createShapeTypeChecker,
            exact: createStrictShapeTypeChecker
          };
          return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache, ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
        };
      }, function(module3, exports3, __webpack_require__) {
        function toObject2(val) {
          if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
          return Object(val);
        }
        var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty2 = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
        module3.exports = (function() {
          try {
            if (!Object.assign) return false;
            var test1 = new String("abc");
            if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return false;
            for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
            if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function(n) {
              return test2[n];
            }).join("")) return false;
            var test3 = {};
            return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
              test3[letter] = letter;
            }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
          } catch (err) {
            return false;
          }
        })() ? Object.assign : function(target, source) {
          for (var from, symbols, to = toObject2(target), s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);
            for (var key in from) hasOwnProperty2.call(from, key) && (to[key] = from[key]);
            if (getOwnPropertySymbols) {
              symbols = getOwnPropertySymbols(from);
              for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
            }
          }
          return to;
        };
      }, function(module3, exports3, __webpack_require__) {
        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
          for (var typeSpecName in typeSpecs) if (has2(typeSpecs, typeSpecName)) {
            var error;
            try {
              if ("function" != typeof typeSpecs[typeSpecName]) {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.");
                throw err.name = "Invariant Violation", err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (!error || error instanceof Error || printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning("Failed " + location + " type: " + error.message + (null != stack ? stack : ""));
            }
          }
        }
        var printWarning = function() {
        }, ReactPropTypesSecret = __webpack_require__(2), loggedTypeFailures = {}, has2 = Function.call.bind(Object.prototype.hasOwnProperty);
        printWarning = function(text) {
          var message = "Warning: " + text;
          "undefined" != typeof console && console.error(message);
          try {
            throw new Error(message);
          } catch (x) {
          }
        }, checkPropTypes.resetWarningCache = function() {
          loggedTypeFailures = {};
        }, module3.exports = checkPropTypes;
      }, function(module3, exports3, __webpack_require__) {
        function Mql(query2, values, forceStatic) {
          function addListener(listener) {
            mql && mql.addListener(listener);
          }
          function removeListener(listener) {
            mql && mql.removeListener(listener);
          }
          function update2(evt) {
            self2.matches = evt.matches, self2.media = evt.media;
          }
          function dispose() {
            mql && mql.removeListener(update2);
          }
          var self2 = this;
          if (dynamicMatch && !forceStatic) {
            var mql = dynamicMatch.call(window, query2);
            this.matches = mql.matches, this.media = mql.media, mql.addListener(update2);
          } else this.matches = staticMatch(query2, values), this.media = query2;
          this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
        }
        function matchMedia(query2, values, forceStatic) {
          return new Mql(query2, values, forceStatic);
        }
        var staticMatch = __webpack_require__(12).match, dynamicMatch = "undefined" != typeof window ? window.matchMedia : null;
        module3.exports = matchMedia;
      }, function(module3, exports3, __webpack_require__) {
        function matchQuery(mediaQuery, values) {
          return parseQuery(mediaQuery).some(function(query2) {
            var inverse = query2.inverse, typeMatch = "all" === query2.type || values.type === query2.type;
            if (typeMatch && inverse || !typeMatch && !inverse) return false;
            var expressionsMatch = query2.expressions.every(function(expression) {
              var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
              if (!value) return false;
              switch (feature) {
                case "orientation":
                case "scan":
                  return value.toLowerCase() === expValue.toLowerCase();
                case "width":
                case "height":
                case "device-width":
                case "device-height":
                  expValue = toPx(expValue), value = toPx(value);
                  break;
                case "resolution":
                  expValue = toDpi(expValue), value = toDpi(value);
                  break;
                case "aspect-ratio":
                case "device-aspect-ratio":
                case "device-pixel-ratio":
                  expValue = toDecimal(expValue), value = toDecimal(value);
                  break;
                case "grid":
                case "color":
                case "color-index":
                case "monochrome":
                  expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
              }
              switch (modifier) {
                case "min":
                  return value >= expValue;
                case "max":
                  return value <= expValue;
                default:
                  return value === expValue;
              }
            });
            return expressionsMatch && !inverse || !expressionsMatch && inverse;
          });
        }
        function parseQuery(mediaQuery) {
          return mediaQuery.split(",").map(function(query2) {
            query2 = query2.trim();
            var captures = query2.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
            return parsed.inverse = !!modifier && "not" === modifier.toLowerCase(), parsed.type = type ? type.toLowerCase() : "all", expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function(expression) {
              var captures2 = expression.match(RE_MQ_EXPRESSION), feature = captures2[1].toLowerCase().match(RE_MQ_FEATURE);
              return {
                modifier: feature[1],
                feature: feature[2],
                value: captures2[2]
              };
            }), parsed;
          });
        }
        function toDecimal(ratio) {
          var numbers, decimal = Number(ratio);
          return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), decimal;
        }
        function toDpi(resolution) {
          var value = parseFloat(resolution);
          switch (String(resolution).match(RE_RESOLUTION_UNIT)[1]) {
            case "dpcm":
              return value / 2.54;
            case "dppx":
              return 96 * value;
            default:
              return value;
          }
        }
        function toPx(length) {
          var value = parseFloat(length);
          switch (String(length).match(RE_LENGTH_UNIT)[1]) {
            case "em":
            case "rem":
              return 16 * value;
            case "cm":
              return 96 * value / 2.54;
            case "mm":
              return 96 * value / 2.54 / 10;
            case "in":
              return 96 * value;
            case "pt":
              return 72 * value;
            case "pc":
              return 72 * value / 12;
            default:
              return value;
          }
        }
        exports3.match = matchQuery, exports3.parse = parseQuery;
        var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
      }, function(module3, __webpack_exports__, __webpack_require__) {
        function keyVal(k, v) {
          var realKey = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__.a)(k);
          return "number" == typeof v && (v = "".concat(v, "px")), true === v ? k : false === v ? negate(k) : "(".concat(realKey, ": ").concat(v, ")");
        }
        function join(conds) {
          return conds.join(" and ");
        }
        var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(3), __WEBPACK_IMPORTED_MODULE_1__mediaQuery__ = __webpack_require__(4), negate = function(cond) {
          return "not ".concat(cond);
        };
        __webpack_exports__.a = function(obj) {
          var rules = [];
          return Object.keys(__WEBPACK_IMPORTED_MODULE_1__mediaQuery__.a.all).forEach(function(k) {
            var v = obj[k];
            null != v && rules.push(keyVal(k, v));
          }), join(rules);
        };
      }]);
    });
  })(reactResponsive$1);
  return reactResponsive$1.exports;
}
var reactResponsiveExports = requireReactResponsive();
const MediaQuery = /* @__PURE__ */ getDefaultExportFromCjs(reactResponsiveExports);
var start_of_todayExports = requireStart_of_today();
const startOfToday = /* @__PURE__ */ getDefaultExportFromCjs(start_of_todayExports);
var formatExports = requireFormat();
const format = /* @__PURE__ */ getDefaultExportFromCjs(formatExports);
var compare_ascExports = requireCompare_asc();
const compareAsc = /* @__PURE__ */ getDefaultExportFromCjs(compare_ascExports);
var _stackClear;
var hasRequired_stackClear;
function require_stackClear() {
  if (hasRequired_stackClear) return _stackClear;
  hasRequired_stackClear = 1;
  var ListCache2 = require_ListCache();
  function stackClear2() {
    this.__data__ = new ListCache2();
    this.size = 0;
  }
  _stackClear = stackClear2;
  return _stackClear;
}
var _stackDelete;
var hasRequired_stackDelete;
function require_stackDelete() {
  if (hasRequired_stackDelete) return _stackDelete;
  hasRequired_stackDelete = 1;
  function stackDelete2(key) {
    var data2 = this.__data__, result = data2["delete"](key);
    this.size = data2.size;
    return result;
  }
  _stackDelete = stackDelete2;
  return _stackDelete;
}
var _stackGet;
var hasRequired_stackGet;
function require_stackGet() {
  if (hasRequired_stackGet) return _stackGet;
  hasRequired_stackGet = 1;
  function stackGet2(key) {
    return this.__data__.get(key);
  }
  _stackGet = stackGet2;
  return _stackGet;
}
var _stackHas;
var hasRequired_stackHas;
function require_stackHas() {
  if (hasRequired_stackHas) return _stackHas;
  hasRequired_stackHas = 1;
  function stackHas2(key) {
    return this.__data__.has(key);
  }
  _stackHas = stackHas2;
  return _stackHas;
}
var _stackSet;
var hasRequired_stackSet;
function require_stackSet() {
  if (hasRequired_stackSet) return _stackSet;
  hasRequired_stackSet = 1;
  var ListCache2 = require_ListCache(), Map2 = require_Map(), MapCache2 = require_MapCache();
  var LARGE_ARRAY_SIZE2 = 200;
  function stackSet2(key, value) {
    var data2 = this.__data__;
    if (data2 instanceof ListCache2) {
      var pairs = data2.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
        pairs.push([key, value]);
        this.size = ++data2.size;
        return this;
      }
      data2 = this.__data__ = new MapCache2(pairs);
    }
    data2.set(key, value);
    this.size = data2.size;
    return this;
  }
  _stackSet = stackSet2;
  return _stackSet;
}
var _Stack;
var hasRequired_Stack;
function require_Stack() {
  if (hasRequired_Stack) return _Stack;
  hasRequired_Stack = 1;
  var ListCache2 = require_ListCache(), stackClear2 = require_stackClear(), stackDelete2 = require_stackDelete(), stackGet2 = require_stackGet(), stackHas2 = require_stackHas(), stackSet2 = require_stackSet();
  function Stack2(entries) {
    var data2 = this.__data__ = new ListCache2(entries);
    this.size = data2.size;
  }
  Stack2.prototype.clear = stackClear2;
  Stack2.prototype["delete"] = stackDelete2;
  Stack2.prototype.get = stackGet2;
  Stack2.prototype.has = stackHas2;
  Stack2.prototype.set = stackSet2;
  _Stack = Stack2;
  return _Stack;
}
var _setCacheAdd;
var hasRequired_setCacheAdd;
function require_setCacheAdd() {
  if (hasRequired_setCacheAdd) return _setCacheAdd;
  hasRequired_setCacheAdd = 1;
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  function setCacheAdd2(value) {
    this.__data__.set(value, HASH_UNDEFINED2);
    return this;
  }
  _setCacheAdd = setCacheAdd2;
  return _setCacheAdd;
}
var _setCacheHas;
var hasRequired_setCacheHas;
function require_setCacheHas() {
  if (hasRequired_setCacheHas) return _setCacheHas;
  hasRequired_setCacheHas = 1;
  function setCacheHas2(value) {
    return this.__data__.has(value);
  }
  _setCacheHas = setCacheHas2;
  return _setCacheHas;
}
var _SetCache;
var hasRequired_SetCache;
function require_SetCache() {
  if (hasRequired_SetCache) return _SetCache;
  hasRequired_SetCache = 1;
  var MapCache2 = require_MapCache(), setCacheAdd2 = require_setCacheAdd(), setCacheHas2 = require_setCacheHas();
  function SetCache2(values) {
    var index2 = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache2();
    while (++index2 < length) {
      this.add(values[index2]);
    }
  }
  SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
  SetCache2.prototype.has = setCacheHas2;
  _SetCache = SetCache2;
  return _SetCache;
}
var _arraySome;
var hasRequired_arraySome;
function require_arraySome() {
  if (hasRequired_arraySome) return _arraySome;
  hasRequired_arraySome = 1;
  function arraySome2(array, predicate) {
    var index2 = -1, length = array == null ? 0 : array.length;
    while (++index2 < length) {
      if (predicate(array[index2], index2, array)) {
        return true;
      }
    }
    return false;
  }
  _arraySome = arraySome2;
  return _arraySome;
}
var _cacheHas;
var hasRequired_cacheHas;
function require_cacheHas() {
  if (hasRequired_cacheHas) return _cacheHas;
  hasRequired_cacheHas = 1;
  function cacheHas2(cache, key) {
    return cache.has(key);
  }
  _cacheHas = cacheHas2;
  return _cacheHas;
}
var _equalArrays;
var hasRequired_equalArrays;
function require_equalArrays() {
  if (hasRequired_equalArrays) return _equalArrays;
  hasRequired_equalArrays = 1;
  var SetCache2 = require_SetCache(), arraySome2 = require_arraySome(), cacheHas2 = require_cacheHas();
  var COMPARE_PARTIAL_FLAG2 = 1, COMPARE_UNORDERED_FLAG2 = 2;
  function equalArrays2(array, other, bitmask, customizer4, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) {
      return arrStacked == other && othStacked == array;
    }
    var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG2 ? new SetCache2() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while (++index2 < arrLength) {
      var arrValue = array[index2], othValue = other[index2];
      if (customizer4) {
        var compared = isPartial ? customizer4(othValue, arrValue, index2, other, array, stack) : customizer4(arrValue, othValue, index2, array, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome2(other, function(othValue2, othIndex) {
          if (!cacheHas2(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer4, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer4, stack))) {
        result = false;
        break;
      }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
  }
  _equalArrays = equalArrays2;
  return _equalArrays;
}
var _Uint8Array;
var hasRequired_Uint8Array;
function require_Uint8Array() {
  if (hasRequired_Uint8Array) return _Uint8Array;
  hasRequired_Uint8Array = 1;
  var root2 = require_root();
  var Uint8Array2 = root2.Uint8Array;
  _Uint8Array = Uint8Array2;
  return _Uint8Array;
}
var _mapToArray;
var hasRequired_mapToArray;
function require_mapToArray() {
  if (hasRequired_mapToArray) return _mapToArray;
  hasRequired_mapToArray = 1;
  function mapToArray2(map) {
    var index2 = -1, result = Array(map.size);
    map.forEach(function(value, key) {
      result[++index2] = [key, value];
    });
    return result;
  }
  _mapToArray = mapToArray2;
  return _mapToArray;
}
var _setToArray;
var hasRequired_setToArray;
function require_setToArray() {
  if (hasRequired_setToArray) return _setToArray;
  hasRequired_setToArray = 1;
  function setToArray2(set3) {
    var index2 = -1, result = Array(set3.size);
    set3.forEach(function(value) {
      result[++index2] = value;
    });
    return result;
  }
  _setToArray = setToArray2;
  return _setToArray;
}
var _equalByTag;
var hasRequired_equalByTag;
function require_equalByTag() {
  if (hasRequired_equalByTag) return _equalByTag;
  hasRequired_equalByTag = 1;
  var Symbol2 = require_Symbol(), Uint8Array2 = require_Uint8Array(), eq2 = requireEq(), equalArrays2 = require_equalArrays(), mapToArray2 = require_mapToArray(), setToArray2 = require_setToArray();
  var COMPARE_PARTIAL_FLAG2 = 1, COMPARE_UNORDERED_FLAG2 = 2;
  var boolTag2 = "[object Boolean]", dateTag2 = "[object Date]", errorTag2 = "[object Error]", mapTag2 = "[object Map]", numberTag2 = "[object Number]", regexpTag2 = "[object RegExp]", setTag2 = "[object Set]", stringTag2 = "[object String]", symbolTag2 = "[object Symbol]";
  var arrayBufferTag2 = "[object ArrayBuffer]", dataViewTag2 = "[object DataView]";
  var symbolProto2 = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf2 = symbolProto2 ? symbolProto2.valueOf : void 0;
  function equalByTag2(object2, other, tag, bitmask, customizer4, equalFunc, stack) {
    switch (tag) {
      case dataViewTag2:
        if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
          return false;
        }
        object2 = object2.buffer;
        other = other.buffer;
      case arrayBufferTag2:
        if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object2), new Uint8Array2(other))) {
          return false;
        }
        return true;
      case boolTag2:
      case dateTag2:
      case numberTag2:
        return eq2(+object2, +other);
      case errorTag2:
        return object2.name == other.name && object2.message == other.message;
      case regexpTag2:
      case stringTag2:
        return object2 == other + "";
      case mapTag2:
        var convert = mapToArray2;
      case setTag2:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
        convert || (convert = setToArray2);
        if (object2.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object2);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG2;
        stack.set(object2, other);
        var result = equalArrays2(convert(object2), convert(other), bitmask, customizer4, equalFunc, stack);
        stack["delete"](object2);
        return result;
      case symbolTag2:
        if (symbolValueOf2) {
          return symbolValueOf2.call(object2) == symbolValueOf2.call(other);
        }
    }
    return false;
  }
  _equalByTag = equalByTag2;
  return _equalByTag;
}
var _arrayPush;
var hasRequired_arrayPush;
function require_arrayPush() {
  if (hasRequired_arrayPush) return _arrayPush;
  hasRequired_arrayPush = 1;
  function arrayPush3(array, values) {
    var index2 = -1, length = values.length, offset = array.length;
    while (++index2 < length) {
      array[offset + index2] = values[index2];
    }
    return array;
  }
  _arrayPush = arrayPush3;
  return _arrayPush;
}
var _baseGetAllKeys;
var hasRequired_baseGetAllKeys;
function require_baseGetAllKeys() {
  if (hasRequired_baseGetAllKeys) return _baseGetAllKeys;
  hasRequired_baseGetAllKeys = 1;
  var arrayPush3 = require_arrayPush(), isArray3 = requireIsArray();
  function baseGetAllKeys2(object2, keysFunc, symbolsFunc) {
    var result = keysFunc(object2);
    return isArray3(object2) ? result : arrayPush3(result, symbolsFunc(object2));
  }
  _baseGetAllKeys = baseGetAllKeys2;
  return _baseGetAllKeys;
}
var _arrayFilter;
var hasRequired_arrayFilter;
function require_arrayFilter() {
  if (hasRequired_arrayFilter) return _arrayFilter;
  hasRequired_arrayFilter = 1;
  function arrayFilter2(array, predicate) {
    var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while (++index2 < length) {
      var value = array[index2];
      if (predicate(value, index2, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
  _arrayFilter = arrayFilter2;
  return _arrayFilter;
}
var stubArray_1;
var hasRequiredStubArray;
function requireStubArray() {
  if (hasRequiredStubArray) return stubArray_1;
  hasRequiredStubArray = 1;
  function stubArray2() {
    return [];
  }
  stubArray_1 = stubArray2;
  return stubArray_1;
}
var _getSymbols;
var hasRequired_getSymbols;
function require_getSymbols() {
  if (hasRequired_getSymbols) return _getSymbols;
  hasRequired_getSymbols = 1;
  var arrayFilter2 = require_arrayFilter(), stubArray2 = requireStubArray();
  var objectProto2 = Object.prototype;
  var propertyIsEnumerable3 = objectProto2.propertyIsEnumerable;
  var nativeGetSymbols2 = Object.getOwnPropertySymbols;
  var getSymbols2 = !nativeGetSymbols2 ? stubArray2 : function(object2) {
    if (object2 == null) {
      return [];
    }
    object2 = Object(object2);
    return arrayFilter2(nativeGetSymbols2(object2), function(symbol) {
      return propertyIsEnumerable3.call(object2, symbol);
    });
  };
  _getSymbols = getSymbols2;
  return _getSymbols;
}
var _baseTimes;
var hasRequired_baseTimes;
function require_baseTimes() {
  if (hasRequired_baseTimes) return _baseTimes;
  hasRequired_baseTimes = 1;
  function baseTimes2(n, iteratee) {
    var index2 = -1, result = Array(n);
    while (++index2 < n) {
      result[index2] = iteratee(index2);
    }
    return result;
  }
  _baseTimes = baseTimes2;
  return _baseTimes;
}
var _isIndex;
var hasRequired_isIndex;
function require_isIndex() {
  if (hasRequired_isIndex) return _isIndex;
  hasRequired_isIndex = 1;
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  var reIsUint2 = /^(?:0|[1-9]\d*)$/;
  function isIndex2(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER2 : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint2.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  _isIndex = isIndex2;
  return _isIndex;
}
var _arrayLikeKeys;
var hasRequired_arrayLikeKeys;
function require_arrayLikeKeys() {
  if (hasRequired_arrayLikeKeys) return _arrayLikeKeys;
  hasRequired_arrayLikeKeys = 1;
  var baseTimes2 = require_baseTimes(), isArguments2 = requireIsArguments(), isArray3 = requireIsArray(), isBuffer2 = requireIsBuffer$1(), isIndex2 = require_isIndex(), isTypedArray2 = requireIsTypedArray();
  var objectProto2 = Object.prototype;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  function arrayLikeKeys2(value, inherited) {
    var isArr = isArray3(value), isArg = !isArr && isArguments2(value), isBuff = !isArr && !isArg && isBuffer2(value), isType = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes2(value.length, String) : [], length = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
      (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
      isIndex2(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  _arrayLikeKeys = arrayLikeKeys2;
  return _arrayLikeKeys;
}
var keys_1;
var hasRequiredKeys;
function requireKeys() {
  if (hasRequiredKeys) return keys_1;
  hasRequiredKeys = 1;
  var arrayLikeKeys2 = require_arrayLikeKeys(), baseKeys2 = require_baseKeys(), isArrayLike2 = requireIsArrayLike();
  function keys3(object2) {
    return isArrayLike2(object2) ? arrayLikeKeys2(object2) : baseKeys2(object2);
  }
  keys_1 = keys3;
  return keys_1;
}
var _getAllKeys;
var hasRequired_getAllKeys;
function require_getAllKeys() {
  if (hasRequired_getAllKeys) return _getAllKeys;
  hasRequired_getAllKeys = 1;
  var baseGetAllKeys2 = require_baseGetAllKeys(), getSymbols2 = require_getSymbols(), keys3 = requireKeys();
  function getAllKeys2(object2) {
    return baseGetAllKeys2(object2, keys3, getSymbols2);
  }
  _getAllKeys = getAllKeys2;
  return _getAllKeys;
}
var _equalObjects;
var hasRequired_equalObjects;
function require_equalObjects() {
  if (hasRequired_equalObjects) return _equalObjects;
  hasRequired_equalObjects = 1;
  var getAllKeys2 = require_getAllKeys();
  var COMPARE_PARTIAL_FLAG2 = 1;
  var objectProto2 = Object.prototype;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  function equalObjects2(object2, other, bitmask, customizer4, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, objProps = getAllKeys2(object2), objLength = objProps.length, othProps = getAllKeys2(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index2 = objLength;
    while (index2--) {
      var key = objProps[index2];
      if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
        return false;
      }
    }
    var objStacked = stack.get(object2);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) {
      return objStacked == other && othStacked == object2;
    }
    var result = true;
    stack.set(object2, other);
    stack.set(other, object2);
    var skipCtor = isPartial;
    while (++index2 < objLength) {
      key = objProps[index2];
      var objValue = object2[key], othValue = other[key];
      if (customizer4) {
        var compared = isPartial ? customizer4(othValue, objValue, key, other, object2, stack) : customizer4(objValue, othValue, key, object2, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer4, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object2.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack["delete"](object2);
    stack["delete"](other);
    return result;
  }
  _equalObjects = equalObjects2;
  return _equalObjects;
}
var _baseIsEqualDeep;
var hasRequired_baseIsEqualDeep;
function require_baseIsEqualDeep() {
  if (hasRequired_baseIsEqualDeep) return _baseIsEqualDeep;
  hasRequired_baseIsEqualDeep = 1;
  var Stack2 = require_Stack(), equalArrays2 = require_equalArrays(), equalByTag2 = require_equalByTag(), equalObjects2 = require_equalObjects(), getTag2 = require_getTag(), isArray3 = requireIsArray(), isBuffer2 = requireIsBuffer$1(), isTypedArray2 = requireIsTypedArray();
  var COMPARE_PARTIAL_FLAG2 = 1;
  var argsTag2 = "[object Arguments]", arrayTag2 = "[object Array]", objectTag2 = "[object Object]";
  var objectProto2 = Object.prototype;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  function baseIsEqualDeep2(object2, other, bitmask, customizer4, equalFunc, stack) {
    var objIsArr = isArray3(object2), othIsArr = isArray3(other), objTag = objIsArr ? arrayTag2 : getTag2(object2), othTag = othIsArr ? arrayTag2 : getTag2(other);
    objTag = objTag == argsTag2 ? objectTag2 : objTag;
    othTag = othTag == argsTag2 ? objectTag2 : othTag;
    var objIsObj = objTag == objectTag2, othIsObj = othTag == objectTag2, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer2(object2)) {
      if (!isBuffer2(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack2());
      return objIsArr || isTypedArray2(object2) ? equalArrays2(object2, other, bitmask, customizer4, equalFunc, stack) : equalByTag2(object2, other, objTag, bitmask, customizer4, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG2)) {
      var objIsWrapped = objIsObj && hasOwnProperty2.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack2());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer4, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack2());
    return equalObjects2(object2, other, bitmask, customizer4, equalFunc, stack);
  }
  _baseIsEqualDeep = baseIsEqualDeep2;
  return _baseIsEqualDeep;
}
var _baseIsEqual;
var hasRequired_baseIsEqual;
function require_baseIsEqual() {
  if (hasRequired_baseIsEqual) return _baseIsEqual;
  hasRequired_baseIsEqual = 1;
  var baseIsEqualDeep2 = require_baseIsEqualDeep(), isObjectLike2 = requireIsObjectLike();
  function baseIsEqual2(value, other, bitmask, customizer4, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike2(value) && !isObjectLike2(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep2(value, other, bitmask, customizer4, baseIsEqual2, stack);
  }
  _baseIsEqual = baseIsEqual2;
  return _baseIsEqual;
}
var isEqual_1;
var hasRequiredIsEqual;
function requireIsEqual() {
  if (hasRequiredIsEqual) return isEqual_1;
  hasRequiredIsEqual = 1;
  var baseIsEqual2 = require_baseIsEqual();
  function isEqual(value, other) {
    return baseIsEqual2(value, other);
  }
  isEqual_1 = isEqual;
  return isEqual_1;
}
var isEqualExports = requireIsEqual();
const _isEqual = /* @__PURE__ */ getDefaultExportFromCjs(isEqualExports);
var _arrayMap;
var hasRequired_arrayMap;
function require_arrayMap() {
  if (hasRequired_arrayMap) return _arrayMap;
  hasRequired_arrayMap = 1;
  function arrayMap2(array, iteratee) {
    var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
    while (++index2 < length) {
      result[index2] = iteratee(array[index2], index2, array);
    }
    return result;
  }
  _arrayMap = arrayMap2;
  return _arrayMap;
}
var isSymbol_1;
var hasRequiredIsSymbol;
function requireIsSymbol() {
  if (hasRequiredIsSymbol) return isSymbol_1;
  hasRequiredIsSymbol = 1;
  var baseGetTag2 = require_baseGetTag(), isObjectLike2 = requireIsObjectLike();
  var symbolTag2 = "[object Symbol]";
  function isSymbol2(value) {
    return typeof value == "symbol" || isObjectLike2(value) && baseGetTag2(value) == symbolTag2;
  }
  isSymbol_1 = isSymbol2;
  return isSymbol_1;
}
var _baseToString;
var hasRequired_baseToString;
function require_baseToString() {
  if (hasRequired_baseToString) return _baseToString;
  hasRequired_baseToString = 1;
  var Symbol2 = require_Symbol(), arrayMap2 = require_arrayMap(), isArray3 = requireIsArray(), isSymbol2 = requireIsSymbol();
  var symbolProto2 = Symbol2 ? Symbol2.prototype : void 0, symbolToString2 = symbolProto2 ? symbolProto2.toString : void 0;
  function baseToString2(value) {
    if (typeof value == "string") {
      return value;
    }
    if (isArray3(value)) {
      return arrayMap2(value, baseToString2) + "";
    }
    if (isSymbol2(value)) {
      return symbolToString2 ? symbolToString2.call(value) : "";
    }
    var result = value + "";
    return result == "0" && 1 / value == -Infinity ? "-0" : result;
  }
  _baseToString = baseToString2;
  return _baseToString;
}
var toString_1;
var hasRequiredToString;
function requireToString() {
  if (hasRequiredToString) return toString_1;
  hasRequiredToString = 1;
  var baseToString2 = require_baseToString();
  function toString3(value) {
    return value == null ? "" : baseToString2(value);
  }
  toString_1 = toString3;
  return toString_1;
}
var _baseSlice;
var hasRequired_baseSlice;
function require_baseSlice() {
  if (hasRequired_baseSlice) return _baseSlice;
  hasRequired_baseSlice = 1;
  function baseSlice(array, start, end) {
    var index2 = -1, length = array.length;
    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }
    end = end > length ? length : end;
    if (end < 0) {
      end += length;
    }
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while (++index2 < length) {
      result[index2] = array[index2 + start];
    }
    return result;
  }
  _baseSlice = baseSlice;
  return _baseSlice;
}
var _castSlice;
var hasRequired_castSlice;
function require_castSlice() {
  if (hasRequired_castSlice) return _castSlice;
  hasRequired_castSlice = 1;
  var baseSlice = require_baseSlice();
  function castSlice(array, start, end) {
    var length = array.length;
    end = end === void 0 ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
  }
  _castSlice = castSlice;
  return _castSlice;
}
var _hasUnicode;
var hasRequired_hasUnicode;
function require_hasUnicode() {
  if (hasRequired_hasUnicode) return _hasUnicode;
  hasRequired_hasUnicode = 1;
  var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
  var rsZWJ = "\\u200d";
  var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
  function hasUnicode(string2) {
    return reHasUnicode.test(string2);
  }
  _hasUnicode = hasUnicode;
  return _hasUnicode;
}
var _asciiToArray;
var hasRequired_asciiToArray;
function require_asciiToArray() {
  if (hasRequired_asciiToArray) return _asciiToArray;
  hasRequired_asciiToArray = 1;
  function asciiToArray(string2) {
    return string2.split("");
  }
  _asciiToArray = asciiToArray;
  return _asciiToArray;
}
var _unicodeToArray;
var hasRequired_unicodeToArray;
function require_unicodeToArray() {
  if (hasRequired_unicodeToArray) return _unicodeToArray;
  hasRequired_unicodeToArray = 1;
  var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
  var rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsZWJ = "\\u200d";
  var reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
  var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
  function unicodeToArray(string2) {
    return string2.match(reUnicode) || [];
  }
  _unicodeToArray = unicodeToArray;
  return _unicodeToArray;
}
var _stringToArray;
var hasRequired_stringToArray;
function require_stringToArray() {
  if (hasRequired_stringToArray) return _stringToArray;
  hasRequired_stringToArray = 1;
  var asciiToArray = require_asciiToArray(), hasUnicode = require_hasUnicode(), unicodeToArray = require_unicodeToArray();
  function stringToArray(string2) {
    return hasUnicode(string2) ? unicodeToArray(string2) : asciiToArray(string2);
  }
  _stringToArray = stringToArray;
  return _stringToArray;
}
var _createCaseFirst;
var hasRequired_createCaseFirst;
function require_createCaseFirst() {
  if (hasRequired_createCaseFirst) return _createCaseFirst;
  hasRequired_createCaseFirst = 1;
  var castSlice = require_castSlice(), hasUnicode = require_hasUnicode(), stringToArray = require_stringToArray(), toString3 = requireToString();
  function createCaseFirst(methodName) {
    return function(string2) {
      string2 = toString3(string2);
      var strSymbols = hasUnicode(string2) ? stringToArray(string2) : void 0;
      var chr = strSymbols ? strSymbols[0] : string2.charAt(0);
      var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string2.slice(1);
      return chr[methodName]() + trailing;
    };
  }
  _createCaseFirst = createCaseFirst;
  return _createCaseFirst;
}
var upperFirst_1;
var hasRequiredUpperFirst;
function requireUpperFirst() {
  if (hasRequiredUpperFirst) return upperFirst_1;
  hasRequiredUpperFirst = 1;
  var createCaseFirst = require_createCaseFirst();
  var upperFirst = createCaseFirst("toUpperCase");
  upperFirst_1 = upperFirst;
  return upperFirst_1;
}
var capitalize_1;
var hasRequiredCapitalize;
function requireCapitalize() {
  if (hasRequiredCapitalize) return capitalize_1;
  hasRequiredCapitalize = 1;
  var toString3 = requireToString(), upperFirst = requireUpperFirst();
  function capitalize2(string2) {
    return upperFirst(toString3(string2).toLowerCase());
  }
  capitalize_1 = capitalize2;
  return capitalize_1;
}
var capitalizeExports = requireCapitalize();
const capitalize = /* @__PURE__ */ getDefaultExportFromCjs(capitalizeExports);
function CalendarIcon() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16.8", height: "18.5", viewBox: "0 0 16.8 18.5", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { id: "Icon_feather-calendar", "data-name": "Icon feather-calendar", transform: "translate(-3.75 -2.25)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        id: "Trazado_25",
        "data-name": "Trazado 25",
        d: "M6.2,6H18.1a1.74,1.74,0,0,1,1.7,1.778V20.222A1.74,1.74,0,0,1,18.1,22H6.2a1.74,1.74,0,0,1-1.7-1.778V7.778A1.74,1.74,0,0,1,6.2,6Z",
        transform: "translate(0 -2)",
        fill: "none",
        stroke: "#707070",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        id: "Trazado_26",
        "data-name": "Trazado 26",
        d: "M24,3V5",
        transform: "translate(-8.45)",
        fill: "none",
        stroke: "#707070",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        id: "Trazado_27",
        "data-name": "Trazado 27",
        d: "M12,3V5",
        transform: "translate(-3.25)",
        fill: "none",
        stroke: "#707070",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        id: "Trazado_28",
        "data-name": "Trazado 28",
        d: "M4.5,15H19.8",
        transform: "translate(0 -5.2)",
        fill: "none",
        stroke: "#707070",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      }
    )
  ] }) });
}
function CustomCalendarIcon() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "button",
    {
      className: "SingleDatePickerInput_calendarIcon SingleDatePickerInput_calendarIcon_1",
      type: "button",
      "aria-label": "date-picker",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "svg",
        {
          className: "SingleDatePickerInput_calendarIcon_svg SingleDatePickerInput_calendarIcon_svg_1",
          focusable: "false",
          viewBox: "0 0 1393.1 1500",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M107.2 1392.9h241.1v-241.1H107.2v241.1zm294.7 0h267.9v-241.1H401.9v241.1zm-294.7-294.7h241.1V830.4H107.2v267.8zm294.7 0h267.9V830.4H401.9v267.8zM107.2 776.8h241.1V535.7H107.2v241.1zm616.2 616.1h267.9v-241.1H723.4v241.1zM401.9 776.8h267.9V535.7H401.9v241.1zm642.9 616.1H1286v-241.1h-241.1v241.1zm-321.4-294.7h267.9V830.4H723.4v267.8zM428.7 375V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.3-5.3 8-11.5 8-18.8zm616.1 723.2H1286V830.4h-241.1v267.8zM723.4 776.8h267.9V535.7H723.4v241.1zm321.4 0H1286V535.7h-241.1v241.1zm26.8-401.8V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.4-5.3 8-11.5 8-18.8zm321.5-53.6v1071.4c0 29-10.6 54.1-31.8 75.3-21.2 21.2-46.3 31.8-75.3 31.8H107.2c-29 0-54.1-10.6-75.3-31.8C10.6 1447 0 1421.9 0 1392.9V321.4c0-29 10.6-54.1 31.8-75.3s46.3-31.8 75.3-31.8h107.2v-80.4c0-36.8 13.1-68.4 39.3-94.6S311.4 0 348.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3 26.2 26.2 39.3 57.8 39.3 94.6v80.4h321.5v-80.4c0-36.8 13.1-68.4 39.3-94.6C922.9 13.1 954.4 0 991.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3s39.3 57.8 39.3 94.6v80.4H1286c29 0 54.1 10.6 75.3 31.8 21.2 21.2 31.8 46.3 31.8 75.3z" })
        }
      )
    }
  );
}
class FormattedPriceWithCurrency extends Component {
  shouldComponentUpdate({ currency, value }) {
    const { currency: currencyProp, value: valueProp } = this.props;
    return currency !== currencyProp || value !== valueProp;
  }
  render() {
    const { currency, value } = this.props;
    const locale = Cookie.get("languageCountryCode");
    return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: value > 0 ? value : 0, currency });
  }
}
function mapStateToProps$u(state) {
  const { clientList } = state.pointOfSales;
  const currency = clientList[0].currencyList[0].isoCode;
  return { currency };
}
const FormattedPriceWithCurrency$1 = connect(mapStateToProps$u)(FormattedPriceWithCurrency);
const formattedDateMessage = (key) => {
  const messages2 = {
    Hoy: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "button.calendar.today", defaultMessage: "Hoy" }),
    Tomorrow: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "button.calendar.tomorrow", defaultMessage: "Mañana" })
  };
  return messages2[String(key)];
};
function QuickDayButton({
  keyName,
  onClick,
  date,
  dayInfo,
  available,
  price,
  currency,
  isFetching,
  showPricing
}) {
  const hasInfo = dayInfo.length > 0;
  const isAvailable = available === "no-availability";
  const day = formattedDateMessage(keyName) || capitalize(date.format(DATE_FORMAT_DAY_FULL));
  const dateDisplay = capitalize(date.format(DATE_FORMAT_MD_LONG));
  const styleDisplayDate = { display: "flex", flexFlow: "column" };
  const locale = getIntlCountryLocale(getAppLocale());
  const { length } = formattedPriceString({
    locale,
    currency,
    value: price ?? 0
  });
  let priceClassname = "";
  if (price) {
    if (length > 8) {
      priceClassname = "price small";
    } else {
      priceClassname = "price";
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "button",
    {
      type: "button",
      className: `button quick-day-button ${hasInfo ? "with-info" : ""} ${priceClassname}`,
      onClick,
      disabled: isAvailable,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { marginTop: hasInfo ? "1px" : "0px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: isAvailable ? styleDisplayDate : void 0, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: day }),
          dateDisplay,
          isAvailable && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "red icon-own-remove" })
        ] }) }),
        hasInfo && dayInfo.map(({ id: id2, customClass = "", color }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          "span",
          {
            className: `calendar-day-bullet ${customClass}`,
            style: { backgroundColor: `#${color}` },
            children: " "
          },
          `calendar-day-${date.format("D")}-bullet-${id2}`
        )),
        isFetching && showPricing && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "price-skeleton small" }),
        !isFetching && showPricing && price && /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPriceWithCurrency$1, { value: price })
      ]
    }
  );
}
class SingleDatePickerCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false
    };
  }
  toggleFocus = () => {
    const { focused } = this.state;
    const { selectedDate, onChangeMonth } = this.props;
    if (focused) {
      onChangeMonth(moment(selectedDate).format(DATE_FORMAT_YMD));
    }
    this.setState((prevState) => ({
      focused: !prevState.focused
    }));
  };
  render() {
    const {
      datePickerProps,
      displayFormat,
      handleOnClickButton,
      daysInfo,
      disablePrevButton,
      disableNextButton,
      renderProductInfo,
      showCalendar,
      currency,
      isFetching,
      showPricing
    } = this.props;
    const { focused } = this.state;
    const dayPickerProps = {
      readOnly: true,
      withFullScreenPortal: true,
      showDefaultInputIcon: true,
      appendToBody: false,
      disableScroll: true,
      displayFormat,
      focused: focused || showCalendar,
      navPrev: disablePrevButton && null,
      navNext: disableNextButton && null,
      onFocusChange: this.toggleFocus,
      noBorder: true,
      daySize: 45,
      ...datePickerProps
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `containerSingleDatePicker ${focused || showCalendar ? "focused" : ""}`, children: [
        !focused && !showCalendar && daysInfo.map((element) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          QuickDayButton,
          {
            isFetching,
            currency,
            keyName: element.key,
            dayInfo: element.infoList,
            available: element.available,
            date: moment(element.date),
            price: element.price,
            onClick: () => handleOnClickButton(element.date),
            showPricing
          },
          element.key
        )),
        (focused || showCalendar) && /* @__PURE__ */ jsxRuntimeExports.jsx(DayPickerSingleDateController, { ...dayPickerProps }),
        !showCalendar && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: !focused ? "button quick-day-button more-dates" : "button focused",
            onClick: this.toggleFocus,
            onKeyDown: (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                this.toggleFocus();
              }
            },
            tabIndex: 0,
            role: "button",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: !focused ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "button.calendar.more.dates", defaultMessage: "Más fechas" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "button.calendar.go.back", defaultMessage: "Atrás" }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: !focused && /* @__PURE__ */ jsxRuntimeExports.jsx(CalendarIcon, {}) })
            ]
          }
        )
      ] }),
      !focused && !showCalendar && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "containerProductInfoQuickButtonCalendar", children: renderProductInfo() })
    ] });
  }
}
class SingleDatePicker extends Component {
  render() {
    const { disablePrevButton, disableNextButton } = this.props;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SingleDatePicker$1, { navPrev: disablePrevButton && void 0, navNext: disableNextButton && void 0, ...this.props });
  }
}
function fetchCalendarInfo({
  salesGroupId = throwIfMissing$1("salesGroupId"),
  productId = throwIfMissing$1("productId"),
  year = throwIfMissing$1("year"),
  month = throwIfMissing$1("month")
}) {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL()}/salesGroups/${salesGroupId}/product/${productId}/calendar-info`,
      types: [CALENDAR_INFO_REQUEST, CALENDAR_INFO_SUCCESS, CALENDAR_INFO_FAILURE],
      authenticated: true,
      params: { year, month }
    }
  };
}
function fetchEvents({
  salesGroupId = throwIfMissing$1("salesGroupId"),
  productId = throwIfMissing$1("productId"),
  startDateFrom = throwIfMissing$1("startDateFrom"),
  timeZone,
  ...params
}) {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL()}/events/available`,
      types: [EVENTS_REQUEST, EVENTS_SUCCESS, EVENTS_FAILURE],
      authenticated: true,
      timeZone,
      params: {
        salesGroupId,
        productId,
        startDateFrom,
        ...params
      }
    }
  };
}
function fetchEventsByVenue({
  salesGroupId = throwIfMissing$1("salesGroupId"),
  productId = throwIfMissing$1("productId"),
  startDateFrom = throwIfMissing$1("startDateFrom"),
  venueId = throwIfMissing$1("venueId"),
  timeZone,
  ...params
}) {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL()}/events/available`,
      types: [EVENTS_BY_VENUE_REQUEST, EVENTS_BY_VENUE_SUCCESS, EVENTS_BY_VENUE_FAILURE],
      authenticated: true,
      timeZone,
      venueId,
      params: {
        salesGroupId,
        productId,
        startDateFrom,
        venueId,
        ...params
      }
    }
  };
}
function fetchEvent(eventId, productId, salesGroupId, params) {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL()}/events/${eventId}/views/eventruleavailability`,
      authenticated: true,
      params: {
        productId,
        salesGroupId,
        ...params
      },
      types: [EVENT_REQUEST, EVENT_SUCCESS, EVENT_FAILURE]
    }
  };
}
function fetchEventsAvailability(salesGroupId = throwIfMissing$1("salesGroupId"), productId = throwIfMissing$1("productId"), params) {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL()}/salesGroups/${salesGroupId}/product/${productId}/availability`,
      params,
      authenticated: true,
      types: [CALENDAR_AVAILABILITY_REQUEST, CALENDAR_AVAILABILITY_SUCCESS, CALENDAR_AVAILABILITY_FAILURE]
    }
  };
}
function fetchCalendarPricing(salesGroupId = throwIfMissing$1("salesGroupId"), productId = throwIfMissing$1("productId"), startDate, endDate) {
  const params = {
    salesGroupId,
    productId,
    startDate,
    endDate
  };
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL()}/pricings/calendarPricing`,
      params,
      authenticated: true,
      types: [CALENDAR_PRICING_REQUEST, CALENDAR_PRICING_SUCCESS, CALENDAR_PRICING_FAILURE]
    }
  };
}
function cleanCalendarPricing() {
  return {
    type: CALENDAR_PRICING_CLEAN
  };
}
function fetchNextMonthDays(salesGroupId = throwIfMissing$1("salesGroupId"), productId = throwIfMissing$1("productId"), params) {
  const endpoint = `${CATALOG_SERVICE_URL()}/salesGroups/${salesGroupId}/product/${productId}/availability`;
  return fetchApiDirect(endpoint, true, {}, params);
}
function fetchCalendarInfoNextMonth(salesGroupId = throwIfMissing$1("salesGroupId"), productId = throwIfMissing$1("productId"), year, month) {
  return fetchApiDirect(
    `${CATALOG_SERVICE_URL()}/salesGroups/${salesGroupId}/product/${productId}/calendar-info`,
    true,
    {},
    { year, month }
  );
}
function getDatesAroundSelected(sortedDates, selectedIndex, count) {
  const dates = [sortedDates[selectedIndex]];
  let beforeIndex = selectedIndex - 1;
  let afterIndex = selectedIndex + 1;
  while (dates.length < count) {
    if (afterIndex < sortedDates.length) {
      dates.push(sortedDates[afterIndex]);
      afterIndex++;
    }
    if (beforeIndex >= 0 && dates.length < count && dates.length < count) {
      dates.unshift(sortedDates[beforeIndex]);
      beforeIndex--;
    }
    if (afterIndex >= sortedDates.length) {
      break;
    }
  }
  return dates;
}
async function getNextMonthDates(salesGroupId, productId, paramsAvailability, currentYearCompare, currentMonthCompare) {
  try {
    let nextMonthDays = {};
    if (salesGroupId && productId && paramsAvailability)
      nextMonthDays = await fetchNextMonthDays(salesGroupId, productId, paramsAvailability);
    const result = {};
    if (nextMonthDays && !isEmpty(nextMonthDays)) {
      const calendarInfo = await fetchCalendarInfoNextMonth(salesGroupId, productId, currentYearCompare, currentMonthCompare);
      Object.entries(nextMonthDays).forEach(([key, value]) => {
        if (value !== "no-availability") {
          result[key] = { available: value };
          const calendarInfoIndices = calendarInfo.dates[key];
          let calendarInfoResult = [];
          if (calendarInfo && !isEmpty(calendarInfo.dates) && calendarInfoIndices && calendarInfoIndices.length > 0) {
            calendarInfoResult = calendarInfoIndices.map((pos) => ({
              customClass: calendarInfo.calendarInfos[pos].customClass,
              color: calendarInfo.calendarInfos[pos].calendarColor
            }));
          }
          result[key] = { ...result[key], infoList: calendarInfoResult };
        }
      });
    }
    return result;
  } catch (error) {
    console.error("Error fetching next month dates: ", error);
    return {};
  }
}
function isDaysEmpty(days) {
  return Object.keys(days).length === 0;
}
const isTodayOrFutureDay = (momentDate) => compareAsc(momentDate.toDate(), startOfToday()) !== -1;
class Calendar extends Component {
  currentRequestId = 0;
  static defaultProps = {
    displayFormat: DATE_FORMAT_DMY,
    firstDayOfWeek: 1
  };
  constructor(props) {
    super(props);
    this.state = {
      matchingDates: [],
      focused: false
    };
    if (props.locale) {
      initMomentLocale(props.locale);
    }
    this.isOutOfRange = this.isOutOfRange.bind(this);
    this.isDayBlocked = this.isDayBlocked.bind(this);
    this.onPrevMonthClick = this.onPrevMonthClick.bind(this);
    this.onNextMonthClick = this.onNextMonthClick.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleRenderDay = this.handleRenderDay.bind(this);
    this.handleOnClickButton = this.handleOnClickButton.bind(this);
    this.loadDates = this.loadDates.bind(this);
    this.onFocusMobileChange = this.onFocusMobileChange.bind(this);
  }
  async componentDidMount() {
    const { days = {}, allowFrontendCalendarWithImprovements, onChangeMonth, selectedDate } = this.props;
    if (typeof onChangeMonth === "function") {
      const initialDate = selectedDate || /* @__PURE__ */ new Date();
      onChangeMonth(typeof initialDate === "string" ? initialDate : moment(initialDate).format(DATE_FORMAT_YMD));
    }
    if (!isEmpty(days) && allowFrontendCalendarWithImprovements) {
      await this.handleCalendarMobileWithImprovementLoad();
    }
  }
  async componentDidUpdate(prevProps) {
    const { days = {}, allowFrontendCalendarWithImprovements = false } = this.props;
    const shouldReload = allowFrontendCalendarWithImprovements && !isEmpty(days) && !_isEqual(prevProps.days, days);
    if (shouldReload) {
      await this.handleCalendarMobileWithImprovementLoad();
    }
  }
  async handleCalendarMobileWithImprovementLoad() {
    const { days, timeZone, selectedDate = /* @__PURE__ */ new Date(), salesGroupId, productId, venueId, minTickets } = this.props;
    const date = new Date(selectedDate);
    let month = date.getMonth();
    let year = date.getFullYear();
    month += 1;
    if (month === 12) {
      month = 1;
      year += 1;
    } else {
      month++;
    }
    const paramsAvailability = {
      month,
      year,
      venueId,
      minAvailability: minTickets
    };
    await this.loadDates(days ?? {}, timeZone, selectedDate, salesGroupId, productId, paramsAvailability);
  }
  handleSelect(momentDate) {
    const { timeZone, handleSelect } = this.props;
    handleSelect(moment.tz(momentDate.format(DATETIME_FORMAT_YMDHM), DATETIME_FORMAT_YMDHM, timeZone).format());
  }
  handleOnClickButton(selectedDay) {
    const { timeZone, handleSelect } = this.props;
    handleSelect(
      moment.tz(moment(selectedDay).format(DATETIME_FORMAT_YMDHM), DATETIME_FORMAT_YMDHM, timeZone).format()
    );
  }
  handleRenderDay({
    day,
    available,
    infoList = [],
    price
  }) {
    let dayClass = "";
    const { disabledDates, currency, showPricing, isFetching } = this.props;
    const dateNotIncluded = disabledDates && disabledDates.split(",").includes(moment(day).format(DATE_FORMAT_DMY_COMPACT));
    const locale = Cookie.get("languageCountryCode");
    const priceLength = price ? formattedPriceString({
      locale,
      currency,
      value: price
    }).length : 0;
    const isDisabled = this.isDayBlocked(day);
    let showPrice = showPricing;
    if (!isTodayOrFutureDay(day)) {
      dayClass += " disabled";
      showPrice = false;
    } else if ((available === "no-availability" || !available) && !dateNotIncluded) {
      showPrice = false;
      if (!available) {
        dayClass += " disabled";
      } else {
        dayClass += ` ${available}`;
      }
    } else if (available === "availability" && !isDisabled) {
      dayClass += ` ${available}`;
    }
    if (isDisabled) showPrice = false;
    const formattedDateDayNumber = day.format("D");
    const calendarClassname = showPricing ? `CalendarPricingDay ${dayClass}` : "CalendarDay_button";
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `${calendarClassname}`, "data-date-id": format(day.toDate(), DATE_FORMAT_DMY), children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: dayClass, children: [
        formattedDateDayNumber,
        infoList.map(({ id: id2, customClass = "", color }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          "span",
          {
            className: `calendar-day-bullet ${customClass}`,
            style: { backgroundColor: `#${color}` },
            children: " "
          },
          `calendar-day-${formattedDateDayNumber}-bullet-${id2}`
        ))
      ] }),
      isFetching && showPrice && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "price-skeleton" }),
      !isFetching && price && showPrice && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: `price ${priceLength > 8 ? "small" : ""}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPriceWithCurrency$1, { value: price }) })
    ] });
  }
  onFocusMobileChange(value) {
    this.setState({ focused: value });
  }
  onPrevMonthClick(momentDate) {
    const { onChangeMonth } = this.props;
    onChangeMonth(momentDate.format(DATE_FORMAT_YMD));
  }
  onNextMonthClick(momentDate) {
    const { onChangeMonth } = this.props;
    onChangeMonth(momentDate.format(DATE_FORMAT_YMD));
  }
  async getMatchingDates(timeZone, days, selectedDate, count = 3, salesGroupId, productId, paramsAvailability) {
    const currentDateMoment = moment.tz(timeZone);
    const currentDate = currentDateMoment.format(DATE_FORMAT_YMD);
    const selectedDateMoment = moment(selectedDate).tz(timeZone);
    const selectedDateCompare = selectedDateMoment.format(DATE_FORMAT_YMD);
    let matchingDates = [];
    const sortedDates = this.filterAndSortDates(days, timeZone, currentDate);
    const selectedIndex = sortedDates.indexOf(selectedDateCompare);
    let daysResult = days;
    const nextMonthCompare = selectedDateMoment.clone().add(1, "months");
    const currentMonthCompare = nextMonthCompare.month() + 1;
    const currentYearCompare = nextMonthCompare.year();
    if (selectedIndex !== -1) {
      matchingDates = getDatesAroundSelected(sortedDates, selectedIndex, count);
    } else {
      matchingDates = sortedDates.slice(0, count);
    }
    const keys3 = [];
    if (matchingDates && matchingDates.length > 0 && matchingDates[0] === currentDate) {
      keys3.push("Hoy");
    }
    const nextDay = moment.tz(timeZone).add(1, "days").format(DATE_FORMAT_YMD);
    if (matchingDates[1] === nextDay || matchingDates[0] === nextDay) {
      keys3.push("Tomorrow");
    }
    for (let i = keys3.length; i <= count; i++) {
      keys3.push(i);
    }
    let dateToCompare;
    if (matchingDates.length < 2) {
      dateToCompare = moment(matchingDates[0]);
    } else if (matchingDates.length < 3) {
      dateToCompare = moment(matchingDates[1]);
    } else {
      dateToCompare = selectedDateMoment;
    }
    const currentDateCompare = dateToCompare.date();
    const lastDayOfMonth = selectedDateMoment.endOf("month").date();
    if (lastDayOfMonth - currentDateCompare <= 4 || matchingDates.length < count) {
      let nextMonthDates = {};
      if (salesGroupId && productId && paramsAvailability && currentYearCompare && currentMonthCompare) {
        nextMonthDates = await getNextMonthDates(
          salesGroupId,
          productId,
          paramsAvailability,
          currentYearCompare,
          currentMonthCompare
        );
      }
      if (!isEmpty(nextMonthDates)) {
        daysResult = { ...daysResult, ...nextMonthDates };
        const sortedDatesNextMonth = this.filterAndSortDates(nextMonthDates, timeZone, currentDate);
        for (let i = 0; i < sortedDatesNextMonth.length && matchingDates.length < count; i++) {
          matchingDates.push(sortedDatesNextMonth[i]);
        }
      }
    }
    if (matchingDates.length < count && sortedDates.length > matchingDates.length) {
      for (let i = sortedDates.length - 1; i >= 0 && matchingDates.length < count; i--) {
        if (!matchingDates.includes(sortedDates[i])) {
          matchingDates.unshift(sortedDates[i]);
        }
      }
    }
    return matchingDates.map((date, index2) => this.generateDateObject(date, daysResult, keys3[index2]));
  }
  isDayBlocked(momentDate) {
    const { weekDays, disabledDates, days, blockNoAvailability = false } = this.props;
    const date = moment(momentDate).format(DATE_FORMAT_YMD);
    const parsedDate = date;
    const weekDayIsAllowed = isProductWeekDayInRange({
      date,
      weekDay: weekDays ? Array.isArray(weekDays) ? weekDays.join(",") : String(weekDays) : ""
    });
    const dateIsDisabled = disabledDates && disabledDates.split(",").includes(moment(date).format(DATE_FORMAT_DMY_COMPACT));
    let blockedByAvailability = false;
    if (days && days[parsedDate]) {
      const dayData = days[parsedDate];
      if (blockNoAvailability) {
        blockedByAvailability = dayData.available !== "availability";
      } else {
        blockedByAvailability = dayData.available === "no-availability" || !dayData.available;
      }
    } else if (days) {
      blockedByAvailability = true;
    }
    return !weekDayIsAllowed || !!dateIsDisabled || blockedByAvailability;
  }
  hasNoAvailability(momentDate) {
    const { days } = this.props;
    const date = moment(momentDate).format(DATE_FORMAT_YMD);
    return !!(days && days[date] && days[date].available === "no-availability");
  }
  isOutOfRange(momentDate) {
    const {
      endDate,
      isOutOfRange,
      allowSellAndEditPastEvents,
      timeZone,
      startDate = moment.tz(timeZone).startOf("day")
    } = this.props;
    const date = moment.tz(momentDate, timeZone).format(DATE_FORMAT_YMD);
    const conditionalValidation = (dateParams) => isOutOfRange && isOutOfRange(dateParams);
    const isBefore = moment(startDate).isBefore(moment(endDate));
    if (!isBefore) return true;
    if (allowSellAndEditPastEvents) {
      return !!conditionalValidation(date);
    }
    try {
      return !isDateInRange$1({
        date,
        startDatetime: startDate,
        endDatetime: endDate
      }) || !!conditionalValidation(date);
    } catch {
      return !isDateInRange$1({
        date,
        startDatetime: startDate,
        endDatetime: startDate
      }) || !!conditionalValidation(date);
    }
  }
  generateDateObject(date, days, key) {
    const { datesPricing } = this.props;
    const price = datesPricing ? datesPricing[date] : null;
    return {
      ...days[date],
      date,
      key,
      infoList: days[date]?.infoList ?? [],
      available: days[date]?.available ?? "",
      price: price ?? null
    };
  }
  filterAndSortDates(days, timeZone, currentDate) {
    return Object.keys(days).filter(
      (date) => days[date].available !== "no-availability" && !this.isDayBlocked(date) && isTodayOrFutureDay(moment(date).tz(timeZone)) && !this.isOutOfRange(date) && moment(date).isSameOrAfter(moment(currentDate))
    ).sort((a, b) => moment(a).diff(moment(b)));
  }
  async loadDates(days, timeZone, selectedDate, salesGroupId, productId, paramsAvailability) {
    const requestId = ++this.currentRequestId;
    try {
      const matchingDates = await this.getMatchingDates(
        timeZone,
        days,
        selectedDate,
        3,
        salesGroupId,
        productId,
        paramsAvailability
      );
      if (requestId === this.currentRequestId) {
        this.setState({ matchingDates });
      }
    } catch (error) {
      console.error("Error loading dates: ", error);
    }
  }
  render() {
    const {
      days = {},
      datesPricing = {},
      displayFormat,
      firstDayOfWeek,
      id: id2,
      productInfo,
      initialVisibleMonth,
      onChangeMonth,
      selectedDate,
      disablePrevButton,
      disableNextButton,
      showSecondCalendar,
      allowFrontendCalendarWithImprovements,
      currency,
      isFetching,
      showPricing,
      locale
    } = this.props;
    const { matchingDates, focused } = this.state;
    const isUSEnglishLocale = locale === "us";
    const hasAvailability = Object.entries(days).some(([date]) => this.hasNoAvailability(date));
    const renderProductInfo = () => productInfo && productInfo.legend && productInfo.legend.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "legend legend-bullets", children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "list-unstyled list-inline", children: productInfo.legend }) });
    const legendAvailability = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      hasAvailability ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "legend", children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "list-unstyled list-inline", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "red icon-own-remove" }),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Sin disponibilidad", id: "legend.text.notavailable" })
      ] }) }) }) : "",
      renderProductInfo()
    ] });
    const datePickerProps = {
      key: `date-picker-${id2}`,
      date: moment(selectedDate),
      onDateChange: this.handleSelect,
      isOutsideRange: this.isOutOfRange,
      isDayBlocked: (day) => this.isDayBlocked(day),
      firstDayOfWeek: isUSEnglishLocale ? 0 : firstDayOfWeek,
      hideKeyboardShortcutsPanel: true,
      onNextMonthClick: this.onNextMonthClick,
      onPrevMonthClick: this.onPrevMonthClick,
      numberOfMonths: 1,
      initialVisibleMonth,
      renderCalendarInfo: legendAvailability,
      renderDayContents: (day) => this.handleRenderDay({
        day,
        ...days[day.format(DATE_FORMAT_YMD)],
        price: datesPricing[format(day.toDate(), DATE_FORMAT_YMD)]
      })
    };
    const desktopPickerProps = {
      keepOpenOnDateSelect: true,
      focused: true,
      daySize: 65,
      noBorder: true,
      ...datePickerProps
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(MediaQuery, { query: "(min-width: 610px)", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DayPickerSingleDateController, { ...desktopPickerProps }) }, "media-query-610"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(MediaQuery, { query: "(max-width: 610px)", children: allowFrontendCalendarWithImprovements ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        SingleDatePickerCustom,
        {
          isDaysEmpty: isDaysEmpty(days),
          daysInfo: matchingDates,
          datePickerProps,
          displayFormat: displayFormat ?? "DD/MM/YYYY",
          handleOnClickButton: this.handleOnClickButton,
          selectedDate: String(selectedDate ?? ""),
          onChangeMonth,
          disablePrevButton,
          disableNextButton,
          renderProductInfo: legendAvailability,
          showCalendar: showSecondCalendar ?? false,
          currency,
          isFetching,
          showPricing: showPricing ?? false
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        SingleDatePicker,
        {
          ...{
            disablePrevButton,
            disableNextButton,
            readOnly: true,
            withFullScreenPortal: true,
            showDefaultInputIcon: true,
            appendToBody: false,
            disableScroll: true,
            displayFormat,
            focused,
            onFocusChange: ({ focused: focusedParam }) => this.onFocusMobileChange(focusedParam),
            customInputIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(CustomCalendarIcon, {}),
            daySize: 45,
            ...datePickerProps
          }
        }
      ) }, "media-query-0")
    ] });
  }
}
function mapStateToProps$t(state) {
  const pos = state.pointOfSales;
  const { clientList, configurations } = pos;
  const { isFetching, isFetchingPrice = false } = state.events;
  return {
    allowFrontendCalendarWithImprovements: configurations?.frontendCalendarWithImprovements,
    allowSellAndEditPastEvents: pos.pointOfSale?.allowSellAndEditPastEvents,
    timeZone: clientList[0].timeZone,
    currency: clientList[0].currencyList?.[0]?.isoCode ?? "",
    isFetching: isFetching || isFetchingPrice
  };
}
const Calendar$1 = connect(mapStateToProps$t)(Calendar);
var get_monthExports = requireGet_month();
const getMonth = /* @__PURE__ */ getDefaultExportFromCjs(get_monthExports);
var get_yearExports = requireGet_year();
const getYear = /* @__PURE__ */ getDefaultExportFromCjs(get_yearExports);
function setSelectedDateForVenue({
  venueId = throwIfMissing$1("venueId"),
  date = throwIfMissing$1("date")
}) {
  return {
    type: SET_SELECTED_DATE_FOR_VENUE,
    payload: {
      venueId,
      date
    }
  };
}
function setSelectedEventForVenue({
  venueId = throwIfMissing$1("venueId"),
  event = throwIfMissing$1("event")
}) {
  return {
    type: SET_SELECTED_EVENT_FOR_VENUE,
    payload: {
      venueId,
      event
    }
  };
}
function setSelectedBuyerTypes(ticketsSelected) {
  return {
    type: SET_SELECTED_BUYER_TYPES,
    payload: ticketsSelected
  };
}
function setSelectedServices(servicesSelected) {
  return {
    type: SET_SELECTED_SERVICES,
    payload: servicesSelected
  };
}
function removeSelectedService(serviceId) {
  return {
    type: REMOVE_SELECTED_SERVICES,
    payload: serviceId
  };
}
var NOT_FOUND = "NOT_FOUND";
function createSingletonCache(equals) {
  var entry;
  return {
    get: function get3(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }
      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key,
        value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = void 0;
    }
  };
}
function createLruCache(maxSize, equals) {
  var entries = [];
  function get3(key) {
    var cacheIndex = entries.findIndex(function(entry2) {
      return equals(key, entry2.key);
    });
    if (cacheIndex > -1) {
      var entry = entries[cacheIndex];
      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }
      return entry.value;
    }
    return NOT_FOUND;
  }
  function put(key, value) {
    if (get3(key) === NOT_FOUND) {
      entries.unshift({
        key,
        value
      });
      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }
  function getEntries() {
    return entries;
  }
  function clear() {
    entries = [];
  }
  return {
    get: get3,
    put,
    getEntries,
    clear
  };
}
var defaultEqualityCheck = function defaultEqualityCheck2(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    }
    var length = prev.length;
    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }
    return true;
  };
}
function defaultMemoize(func2, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
  function memoized() {
    var value = cache.get(arguments);
    if (value === NOT_FOUND) {
      value = func2.apply(null, arguments);
      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function(entry) {
          return resultEqualityCheck(entry.value, value);
        });
        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }
      cache.put(arguments, value);
    }
    return value;
  }
  memoized.clearCache = function() {
    return cache.clear();
  };
  return memoized;
}
function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
  if (!dependencies.every(function(dep) {
    return typeof dep === "function";
  })) {
    var dependencyTypes = dependencies.map(function(dep) {
      return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
    }).join(", ");
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }
  return dependencies;
}
function createSelectorCreator(memoize2) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }
  var createSelector2 = function createSelector3() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }
    var _recomputations = 0;
    var _lastResult;
    var directlyPassedOptions = {
      memoizeOptions: void 0
    };
    var resultFunc = funcs.pop();
    if (typeof resultFunc === "object") {
      directlyPassedOptions = resultFunc;
      resultFunc = funcs.pop();
    }
    if (typeof resultFunc !== "function") {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    }
    var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2;
    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize2.apply(void 0, [function recomputationWrapper() {
      _recomputations++;
      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions));
    var selector = memoize2(function dependenciesChecker() {
      var params = [];
      var length = dependencies.length;
      for (var i = 0; i < length; i++) {
        params.push(dependencies[i].apply(null, arguments));
      }
      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc,
      memoizedResultFunc,
      dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  };
  return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(defaultMemoize);
var prefix = "@@redux-form/";
var ARRAY_INSERT = prefix + "ARRAY_INSERT";
var ARRAY_MOVE = prefix + "ARRAY_MOVE";
var ARRAY_POP = prefix + "ARRAY_POP";
var ARRAY_PUSH = prefix + "ARRAY_PUSH";
var ARRAY_REMOVE = prefix + "ARRAY_REMOVE";
var ARRAY_REMOVE_ALL = prefix + "ARRAY_REMOVE_ALL";
var ARRAY_SHIFT = prefix + "ARRAY_SHIFT";
var ARRAY_SPLICE = prefix + "ARRAY_SPLICE";
var ARRAY_UNSHIFT = prefix + "ARRAY_UNSHIFT";
var ARRAY_SWAP = prefix + "ARRAY_SWAP";
var AUTOFILL = prefix + "AUTOFILL";
var BLUR = prefix + "BLUR";
var CHANGE = prefix + "CHANGE";
var CLEAR_FIELDS = prefix + "CLEAR_FIELDS";
var CLEAR_SUBMIT = prefix + "CLEAR_SUBMIT";
var CLEAR_SUBMIT_ERRORS = prefix + "CLEAR_SUBMIT_ERRORS";
var CLEAR_ASYNC_ERROR = prefix + "CLEAR_ASYNC_ERROR";
var DESTROY = prefix + "DESTROY";
var FOCUS = prefix + "FOCUS";
var INITIALIZE = prefix + "INITIALIZE";
var REGISTER_FIELD = prefix + "REGISTER_FIELD";
var RESET = prefix + "RESET";
var RESET_SECTION = prefix + "RESET_SECTION";
var SET_SUBMIT_FAILED = prefix + "SET_SUBMIT_FAILED";
var SET_SUBMIT_SUCCEEDED = prefix + "SET_SUBMIT_SUCCEEDED";
var START_ASYNC_VALIDATION = prefix + "START_ASYNC_VALIDATION";
var START_SUBMIT = prefix + "START_SUBMIT";
var STOP_ASYNC_VALIDATION = prefix + "STOP_ASYNC_VALIDATION";
var STOP_SUBMIT = prefix + "STOP_SUBMIT";
var SUBMIT = prefix + "SUBMIT";
var TOUCH = prefix + "TOUCH";
var UNREGISTER_FIELD = prefix + "UNREGISTER_FIELD";
var UNTOUCH = prefix + "UNTOUCH";
var UPDATE_SYNC_ERRORS = prefix + "UPDATE_SYNC_ERRORS";
var UPDATE_SYNC_WARNINGS = prefix + "UPDATE_SYNC_WARNINGS";
var _extends$a = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var arrayInsert$1 = function arrayInsert(form2, field, index2, value) {
  return {
    type: ARRAY_INSERT,
    meta: { form: form2, field, index: index2 },
    payload: value
  };
};
var arrayMove$1 = function arrayMove(form2, field, from, to) {
  return {
    type: ARRAY_MOVE,
    meta: { form: form2, field, from, to }
  };
};
var arrayPop$1 = function arrayPop(form2, field) {
  return {
    type: ARRAY_POP,
    meta: { form: form2, field }
  };
};
var arrayPush$2 = function arrayPush(form2, field, value) {
  return {
    type: ARRAY_PUSH,
    meta: { form: form2, field },
    payload: value
  };
};
var arrayRemove$1 = function arrayRemove(form2, field, index2) {
  return {
    type: ARRAY_REMOVE,
    meta: { form: form2, field, index: index2 }
  };
};
var arrayRemoveAll$1 = function arrayRemoveAll(form2, field) {
  return {
    type: ARRAY_REMOVE_ALL,
    meta: { form: form2, field }
  };
};
var arrayShift$1 = function arrayShift(form2, field) {
  return {
    type: ARRAY_SHIFT,
    meta: { form: form2, field }
  };
};
var arraySplice$1 = function arraySplice(form2, field, index2, removeNum, value) {
  var action = {
    type: ARRAY_SPLICE,
    meta: { form: form2, field, index: index2, removeNum }
  };
  if (value !== void 0) {
    action.payload = value;
  }
  return action;
};
var arraySwap$1 = function arraySwap(form2, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error("Swap indices cannot be equal");
  }
  if (indexA < 0 || indexB < 0) {
    throw new Error("Swap indices cannot be negative");
  }
  return { type: ARRAY_SWAP, meta: { form: form2, field, indexA, indexB } };
};
var arrayUnshift$1 = function arrayUnshift(form2, field, value) {
  return {
    type: ARRAY_UNSHIFT,
    meta: { form: form2, field },
    payload: value
  };
};
var autofill = function autofill2(form2, field, value) {
  return {
    type: AUTOFILL,
    meta: { form: form2, field },
    payload: value
  };
};
var blur$1 = function blur(form2, field, value, touch3) {
  return {
    type: BLUR,
    meta: { form: form2, field, touch: touch3 },
    payload: value
  };
};
var change$2 = function change(form2, field, value, touch3, persistentSubmitErrors) {
  return {
    type: CHANGE,
    meta: { form: form2, field, touch: touch3, persistentSubmitErrors },
    payload: value
  };
};
var clearSubmit = function clearSubmit2(form2) {
  return {
    type: CLEAR_SUBMIT,
    meta: { form: form2 }
  };
};
var clearSubmitErrors = function clearSubmitErrors2(form2) {
  return {
    type: CLEAR_SUBMIT_ERRORS,
    meta: { form: form2 }
  };
};
var clearAsyncError = function clearAsyncError2(form2, field) {
  return {
    type: CLEAR_ASYNC_ERROR,
    meta: { form: form2, field }
  };
};
var clearFields = function clearFields2(form2, keepTouched, persistentSubmitErrors) {
  for (var _len = arguments.length, fields = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    fields[_key - 3] = arguments[_key];
  }
  return {
    type: CLEAR_FIELDS,
    meta: { form: form2, keepTouched, persistentSubmitErrors, fields }
  };
};
var destroy = function destroy2() {
  for (var _len2 = arguments.length, form2 = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    form2[_key2] = arguments[_key2];
  }
  return {
    type: DESTROY,
    meta: { form: form2 }
  };
};
var focus$1 = function focus(form2, field) {
  return {
    type: FOCUS,
    meta: { form: form2, field }
  };
};
var initialize$1 = function initialize(form2, values, keepDirty) {
  var otherMeta = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }
  return {
    type: INITIALIZE,
    meta: _extends$a({ form: form2, keepDirty }, otherMeta),
    payload: values
  };
};
var registerField = function registerField2(form2, name, type) {
  return {
    type: REGISTER_FIELD,
    meta: { form: form2 },
    payload: { name, type }
  };
};
var reset$1 = function reset(form2) {
  return {
    type: RESET,
    meta: { form: form2 }
  };
};
var resetSection = function resetSection2(form2) {
  for (var _len3 = arguments.length, sections = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    sections[_key3 - 1] = arguments[_key3];
  }
  return {
    type: RESET_SECTION,
    meta: { form: form2, sections }
  };
};
var startAsyncValidation = function startAsyncValidation2(form2, field) {
  return {
    type: START_ASYNC_VALIDATION,
    meta: { form: form2, field }
  };
};
var startSubmit = function startSubmit2(form2) {
  return {
    type: START_SUBMIT,
    meta: { form: form2 }
  };
};
var stopAsyncValidation = function stopAsyncValidation2(form2, errors) {
  return {
    type: STOP_ASYNC_VALIDATION,
    meta: { form: form2 },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};
var stopSubmit = function stopSubmit2(form2, errors) {
  return {
    type: STOP_SUBMIT,
    meta: { form: form2 },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};
var submit = function submit2(form2) {
  return {
    type: SUBMIT,
    meta: { form: form2 }
  };
};
var setSubmitFailed = function setSubmitFailed2(form2) {
  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }
  return {
    type: SET_SUBMIT_FAILED,
    meta: { form: form2, fields },
    error: true
  };
};
var setSubmitSucceeded = function setSubmitSucceeded2(form2) {
  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }
  return {
    type: SET_SUBMIT_SUCCEEDED,
    meta: { form: form2, fields },
    error: false
  };
};
var touch = function touch2(form2) {
  for (var _len6 = arguments.length, fields = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    fields[_key6 - 1] = arguments[_key6];
  }
  return {
    type: TOUCH,
    meta: { form: form2, fields }
  };
};
var unregisterField = function unregisterField2(form2, name) {
  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  return {
    type: UNREGISTER_FIELD,
    meta: { form: form2 },
    payload: { name, destroyOnUnmount }
  };
};
var untouch = function untouch2(form2) {
  for (var _len7 = arguments.length, fields = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    fields[_key7 - 1] = arguments[_key7];
  }
  return {
    type: UNTOUCH,
    meta: { form: form2, fields }
  };
};
var updateSyncErrors = function updateSyncErrors2(form2) {
  var syncErrors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var error = arguments[2];
  return {
    type: UPDATE_SYNC_ERRORS,
    meta: { form: form2 },
    payload: { syncErrors, error }
  };
};
var updateSyncWarnings = function updateSyncWarnings2(form2) {
  var syncWarnings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var warning2 = arguments[2];
  return {
    type: UPDATE_SYNC_WARNINGS,
    meta: { form: form2 },
    payload: { syncWarnings, warning: warning2 }
  };
};
var actions = {
  arrayInsert: arrayInsert$1,
  arrayMove: arrayMove$1,
  arrayPop: arrayPop$1,
  arrayPush: arrayPush$2,
  arrayRemove: arrayRemove$1,
  arrayRemoveAll: arrayRemoveAll$1,
  arrayShift: arrayShift$1,
  arraySplice: arraySplice$1,
  arraySwap: arraySwap$1,
  arrayUnshift: arrayUnshift$1,
  autofill,
  blur: blur$1,
  change: change$2,
  clearFields,
  clearSubmit,
  clearSubmitErrors,
  clearAsyncError,
  destroy,
  focus: focus$1,
  initialize: initialize$1,
  registerField,
  reset: reset$1,
  resetSection,
  startAsyncValidation,
  startSubmit,
  stopAsyncValidation,
  stopSubmit,
  submit,
  setSubmitFailed,
  setSubmitSucceeded,
  touch,
  unregisterField,
  untouch,
  updateSyncErrors,
  updateSyncWarnings
};
var defaultShouldAsyncValidate = function defaultShouldAsyncValidate2(_ref) {
  var initialized = _ref.initialized, trigger = _ref.trigger, pristine = _ref.pristine, syncValidationPasses = _ref.syncValidationPasses;
  if (!syncValidationPasses) {
    return false;
  }
  switch (trigger) {
    case "blur":
    case "change":
      return true;
    case "submit":
      return !pristine || !initialized;
    default:
      return false;
  }
};
var defaultShouldValidate = function defaultShouldValidate2(_ref) {
  var values = _ref.values, nextProps = _ref.nextProps, initialRender = _ref.initialRender, lastFieldValidatorKeys = _ref.lastFieldValidatorKeys, fieldValidatorKeys = _ref.fieldValidatorKeys, structure2 = _ref.structure;
  if (initialRender) {
    return true;
  }
  return !structure2.deepEqual(values, nextProps && nextProps.values) || !structure2.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};
var defaultShouldError = function defaultShouldError2(_ref) {
  var values = _ref.values, nextProps = _ref.nextProps, initialRender = _ref.initialRender, lastFieldValidatorKeys = _ref.lastFieldValidatorKeys, fieldValidatorKeys = _ref.fieldValidatorKeys, structure2 = _ref.structure;
  if (initialRender) {
    return true;
  }
  return !structure2.deepEqual(values, nextProps && nextProps.values) || !structure2.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};
var defaultShouldWarn = function defaultShouldWarn2(_ref) {
  var values = _ref.values, nextProps = _ref.nextProps, initialRender = _ref.initialRender, lastFieldValidatorKeys = _ref.lastFieldValidatorKeys, fieldValidatorKeys = _ref.fieldValidatorKeys, structure2 = _ref.structure;
  if (initialRender) {
    return true;
  }
  return !structure2.deepEqual(values, nextProps && nextProps.values) || !structure2.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};
function componentWillMount() {
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== void 0) {
    this.setState(state);
  }
}
function componentWillReceiveProps(nextProps) {
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== void 0 ? state : null;
  }
  this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component2) {
  var prototype = Component2.prototype;
  if (!prototype || !prototype.isReactComponent) {
    throw new Error("Can only polyfill class components");
  }
  if (typeof Component2.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") {
    return Component2;
  }
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === "function") {
    foundWillMountName = "componentWillMount";
  } else if (typeof prototype.UNSAFE_componentWillMount === "function") {
    foundWillMountName = "UNSAFE_componentWillMount";
  }
  if (typeof prototype.componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "componentWillReceiveProps";
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
  }
  if (typeof prototype.componentWillUpdate === "function") {
    foundWillUpdateName = "componentWillUpdate";
  } else if (typeof prototype.UNSAFE_componentWillUpdate === "function") {
    foundWillUpdateName = "UNSAFE_componentWillUpdate";
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component2.displayName || Component2.name;
    var newApiName = typeof Component2.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      "Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks"
    );
  }
  if (typeof Component2.getDerivedStateFromProps === "function") {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }
  if (typeof prototype.getSnapshotBeforeUpdate === "function") {
    if (typeof prototype.componentDidUpdate !== "function") {
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    }
    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;
    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }
  return Component2;
}
var formatName = function formatName2(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + "." + name : name;
};
var _extends$9 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass$5 = /* @__PURE__ */ (function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties2(Constructor.prototype, protoProps);
    if (staticProps) defineProperties2(Constructor, staticProps);
    return Constructor;
  };
})();
function _objectWithoutProperties$6(obj, keys3) {
  var target = {};
  for (var i in obj) {
    if (keys3.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$7(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var FormSection = (function(_Component) {
  _inherits$7(FormSection2, _Component);
  function FormSection2(props, context) {
    _classCallCheck$7(this, FormSection2);
    var _this = _possibleConstructorReturn$7(this, (FormSection2.__proto__ || Object.getPrototypeOf(FormSection2)).call(this, props, context));
    if (!context._reduxForm) {
      throw new Error("FormSection must be inside a component decorated with reduxForm()");
    }
    return _this;
  }
  _createClass$5(FormSection2, [{
    key: "getChildContext",
    value: function getChildContext() {
      var context = this.context, name = this.props.name;
      return {
        _reduxForm: _extends$9({}, context._reduxForm, {
          sectionPrefix: formatName(context, name)
        })
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props, children = _props.children;
      _props.name;
      var component = _props.component, rest = _objectWithoutProperties$6(_props, ["children", "name", "component"]);
      if (React__default.isValidElement(children)) {
        return children;
      }
      return createElement$2(component, _extends$9({}, rest, {
        children
      }));
    }
  }]);
  return FormSection2;
})(Component);
FormSection.propTypes = {
  name: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.node])
};
FormSection.defaultProps = {
  component: "div"
};
FormSection.childContextTypes = {
  _reduxForm: PropTypes.object.isRequired
};
FormSection.contextTypes = {
  _reduxForm: PropTypes.object
};
function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$6(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }
  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }
  return ExtendableBuiltin;
}
var ExtendableError = (function(_extendableBuiltin2) {
  _inherits$6(ExtendableError2, _extendableBuiltin2);
  function ExtendableError2() {
    var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    _classCallCheck$6(this, ExtendableError2);
    var _this = _possibleConstructorReturn$6(this, (ExtendableError2.__proto__ || Object.getPrototypeOf(ExtendableError2)).call(this, message));
    Object.defineProperty(_this, "message", {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });
    Object.defineProperty(_this, "name", {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });
    if (Error.hasOwnProperty("captureStackTrace")) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn$6(_this);
    }
    Object.defineProperty(_this, "stack", {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }
  return ExtendableError2;
})(_extendableBuiltin(Error));
function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$5(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var SubmissionError = (function(_ExtendableError) {
  _inherits$5(SubmissionError2, _ExtendableError);
  function SubmissionError2(errors) {
    _classCallCheck$5(this, SubmissionError2);
    var _this = _possibleConstructorReturn$5(this, (SubmissionError2.__proto__ || Object.getPrototypeOf(SubmissionError2)).call(this, "Submit Validation Failed"));
    _this.errors = errors;
    return _this;
  }
  return SubmissionError2;
})(ExtendableError);
var _extends$8 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties$5(obj, keys3) {
  var target = {};
  for (var i in obj) {
    if (keys3.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var processProps = function processProps2(type, props, _value, deepEqual3) {
  var value = props.value;
  if (type === "checkbox") {
    return _extends$8({}, props, {
      checked: !!value
    });
  }
  if (type === "radio") {
    return _extends$8({}, props, {
      checked: deepEqual3(value, _value),
      value: _value
    });
  }
  if (type === "select-multiple") {
    return _extends$8({}, props, {
      value: value || []
    });
  }
  if (type === "file") {
    return _extends$8({}, props, {
      value: value || void 0
    });
  }
  return props;
};
var createFieldProps = function createFieldProps2(_ref2, name, _ref) {
  var getIn3 = _ref2.getIn, toJS2 = _ref2.toJS, deepEqual3 = _ref2.deepEqual;
  var asyncError = _ref.asyncError, asyncValidating = _ref.asyncValidating, onBlur = _ref.onBlur, onChange = _ref.onChange, onDrop = _ref.onDrop, onDragStart = _ref.onDragStart, dirty = _ref.dirty, dispatch = _ref.dispatch, onFocus = _ref.onFocus, form2 = _ref.form, format2 = _ref.format, initial = _ref.initial;
  _ref.parse;
  var pristine = _ref.pristine, props = _ref.props, state = _ref.state, submitError = _ref.submitError, submitFailed = _ref.submitFailed, submitting = _ref.submitting, syncError = _ref.syncError, syncWarning = _ref.syncWarning;
  _ref.validate;
  var value = _ref.value, _value = _ref._value;
  _ref.warn;
  var custom = _objectWithoutProperties$5(_ref, ["asyncError", "asyncValidating", "onBlur", "onChange", "onDrop", "onDragStart", "dirty", "dispatch", "onFocus", "form", "format", "initial", "parse", "pristine", "props", "state", "submitError", "submitFailed", "submitting", "syncError", "syncWarning", "validate", "value", "_value", "warn"]);
  var error = syncError || asyncError || submitError;
  var warning2 = syncWarning;
  var formatFieldValue = function formatFieldValue2(value2, format3) {
    if (format3 === null) {
      return value2;
    }
    var defaultFormattedValue = value2 == null ? "" : value2;
    return format3 ? format3(value2, name) : defaultFormattedValue;
  };
  var formattedFieldValue = formatFieldValue(value, format2);
  return {
    input: processProps(custom.type, {
      name,
      onBlur,
      onChange,
      onDragStart,
      onDrop,
      onFocus,
      value: formattedFieldValue
    }, _value, deepEqual3),
    meta: _extends$8({}, toJS2(state), {
      active: !!(state && getIn3(state, "active")),
      asyncValidating,
      autofilled: !!(state && getIn3(state, "autofilled")),
      dirty,
      dispatch,
      error,
      form: form2,
      initial,
      warning: warning2,
      invalid: !!error,
      pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn3(state, "touched")),
      valid: !error,
      visited: !!(state && getIn3(state, "visited"))
    }),
    custom: _extends$8({}, custom, props)
  };
};
var isEvent = function isEvent2(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};
var getSelectedValues = function getSelectedValues2(options) {
  var result = [];
  if (options) {
    for (var index2 = 0; index2 < options.length; index2++) {
      var option = options[index2];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};
var getValue$1 = function getValue(event, isReactNative2) {
  if (isEvent(event)) {
    if (!isReactNative2 && event.nativeEvent && event.nativeEvent.text !== void 0) {
      return event.nativeEvent.text;
    }
    if (isReactNative2 && event.nativeEvent !== void 0) {
      return event.nativeEvent.text;
    }
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target, type = _detypedEvent$target.type, value = _detypedEvent$target.value, checked = _detypedEvent$target.checked, files = _detypedEvent$target.files, dataTransfer = detypedEvent.dataTransfer;
    if (type === "checkbox") {
      return !!checked;
    }
    if (type === "file") {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === "select-multiple") {
      return getSelectedValues(event.target.options);
    }
    return value;
  }
  return event;
};
var isReactNative = typeof window !== "undefined" && window.navigator && window.navigator.product && window.navigator.product === "ReactNative";
var onChangeValue = function onChangeValue2(event, _ref) {
  var name = _ref.name, parse2 = _ref.parse, normalize2 = _ref.normalize;
  var value = getValue$1(event, isReactNative);
  if (parse2) {
    value = parse2(value, name);
  }
  if (normalize2) {
    value = normalize2(name, value);
  }
  return value;
};
var dataKey = "text";
function _toConsumableArray$3(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
var splice$1 = function splice(array, index2, removeNum, value) {
  array = array || [];
  if (index2 < array.length) {
    if (value === void 0 && !removeNum) {
      var _copy2 = [].concat(_toConsumableArray$3(array));
      _copy2.splice(index2, 0, true);
      _copy2[index2] = void 0;
      return _copy2;
    }
    if (value != null) {
      var _copy3 = [].concat(_toConsumableArray$3(array));
      _copy3.splice(index2, removeNum, value);
      return _copy3;
    }
    var _copy = [].concat(_toConsumableArray$3(array));
    _copy.splice(index2, removeNum);
    return _copy;
  }
  if (removeNum) {
    return array;
  }
  var copy = [].concat(_toConsumableArray$3(array));
  copy[index2] = value;
  return copy;
};
function arrayMap(array, iteratee) {
  var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
  while (++index2 < length) {
    result[index2] = iteratee(array[index2], index2, array);
  }
  return result;
}
function copyArray(source, array) {
  var index2 = -1, length = source.length;
  array || (array = Array(length));
  while (++index2 < length) {
    array[index2] = source[index2];
  }
  return array;
}
var isArray2 = Array.isArray;
var symbolTag$1 = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag$1;
}
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$1(value) {
  if (!isObject$1(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root$1["__core-js_shared__"];
var maskSrcKey = (function() {
  var uid2 = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid2 ? "Symbol(src)_1." + uid2 : "";
})();
function isMasked(func2) {
  return !!maskSrcKey && maskSrcKey in func2;
}
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource(func2) {
  if (func2 != null) {
    try {
      return funcToString$1.call(func2);
    } catch (e) {
    }
    try {
      return func2 + "";
    } catch (e) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$b = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$9).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function getValue2(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
function getNative(object2, key) {
  var value = getValue2(object2, key);
  return baseIsNative(value) ? value : void 0;
}
var nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$a = Object.prototype;
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
function hashGet(key) {
  var data2 = this.__data__;
  if (nativeCreate) {
    var result = data2[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$8.call(data2, key) ? data2[key] : void 0;
}
var objectProto$9 = Object.prototype;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
function hashHas(key) {
  var data2 = this.__data__;
  return nativeCreate ? data2[key] !== void 0 : hasOwnProperty$7.call(data2, key);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(key, value) {
  var data2 = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data2[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
function Hash(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var arrayProto = Array.prototype;
var splice2 = arrayProto.splice;
function listCacheDelete(key) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data2.length - 1;
  if (index2 == lastIndex) {
    data2.pop();
  } else {
    splice2.call(data2, index2, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  return index2 < 0 ? void 0 : data2[index2][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  if (index2 < 0) {
    ++this.size;
    data2.push([key, value]);
  } else {
    data2[index2][1] = value;
  }
  return this;
}
function ListCache(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$1 = getNative(root$1, "Map");
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$1 || ListCache)(),
    "string": new Hash()
  };
}
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function getMapData(map, key) {
  var data2 = map.__data__;
  return isKeyable(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
}
function mapCacheDelete(key) {
  var result = getMapData(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  var data2 = getMapData(this, key), size2 = data2.size;
  data2.set(key, value);
  this.size += data2.size == size2 ? 0 : 1;
  return this;
}
function MapCache(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var FUNC_ERROR_TEXT = "Expected a function";
function memoize(func2, resolver) {
  if (typeof func2 != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func2.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func2) {
  var result = memoize(func2, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped(function(string2) {
  var result = [];
  if (string2.charCodeAt(0) === 46) {
    result.push("");
  }
  string2.replace(rePropName, function(match2, number2, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match2);
  });
  return result;
});
function toKey(value) {
  if (typeof value == "string" || isSymbol(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray2(value)) {
    return arrayMap(value, baseToString) + "";
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function toString$1(value) {
  return value == null ? "" : baseToString(value);
}
function toPath(value) {
  if (isArray2(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString$1(value)));
}
var getIn = function getIn2(state, field) {
  if (!state) {
    return state;
  }
  var path = toPath(field);
  var length = path.length;
  if (!length) {
    return void 0;
  }
  var result = state;
  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }
  return result;
};
var _extends$7 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var setInWithPath = function setInWithPath2(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }
  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath2(firstState, value, path, pathIndex + 1);
  if (!state) {
    if (isNaN(first)) {
      return _defineProperty$4({}, first, next);
    }
    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }
  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }
  return _extends$7({}, state, _defineProperty$4({}, first, next));
};
var setIn = function setIn2(state, field, value) {
  return setInWithPath(state, value, toPath(field), 0);
};
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
function stackDelete(key) {
  var data2 = this.__data__, result = data2["delete"](key);
  this.size = data2.size;
  return result;
}
function stackGet(key) {
  return this.__data__.get(key);
}
function stackHas(key) {
  return this.__data__.has(key);
}
var LARGE_ARRAY_SIZE = 200;
function stackSet(key, value) {
  var data2 = this.__data__;
  if (data2 instanceof ListCache) {
    var pairs = data2.__data__;
    if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data2.size;
      return this;
    }
    data2 = this.__data__ = new MapCache(pairs);
  }
  data2.set(key, value);
  this.size = data2.size;
  return this;
}
function Stack(entries) {
  var data2 = this.__data__ = new ListCache(entries);
  this.size = data2.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value) {
  return this.__data__.has(value);
}
function SetCache(values) {
  var index2 = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index2 < length) {
    this.add(values[index2]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (predicate(array[index2], index2, array)) {
      return true;
    }
  }
  return false;
}
function cacheHas(cache, key) {
  return cache.has(key);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(array, other, bitmask, customizer4, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index2 < arrLength) {
    var arrValue = array[index2], othValue = other[index2];
    if (customizer4) {
      var compared = isPartial ? customizer4(othValue, arrValue, index2, other, array, stack) : customizer4(arrValue, othValue, index2, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer4, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer4, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result;
}
var Uint8Array$1 = root$1.Uint8Array;
function mapToArray(map) {
  var index2 = -1, result = Array(map.size);
  map.forEach(function(value, key) {
    result[++index2] = [key, value];
  });
  return result;
}
function setToArray(set3) {
  var index2 = -1, result = Array(set3.size);
  set3.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]";
var symbolProto = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(object2, other, tag, bitmask, customizer4, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
        return false;
      }
      object2 = object2.buffer;
      other = other.buffer;
    case arrayBufferTag$1:
      if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object2), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      return eq(+object2, +other);
    case errorTag$1:
      return object2.name == other.name && object2.message == other.message;
    case regexpTag$1:
    case stringTag$1:
      return object2 == other + "";
    case mapTag$2:
      var convert = mapToArray;
    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object2.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object2);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object2, other);
      var result = equalArrays(convert(object2), convert(other), bitmask, customizer4, equalFunc, stack);
      stack["delete"](object2);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object2) == symbolValueOf.call(other);
      }
  }
  return false;
}
function arrayPush$1(array, values) {
  var index2 = -1, length = values.length, offset = array.length;
  while (++index2 < length) {
    array[offset + index2] = values[index2];
  }
  return array;
}
function baseGetAllKeys(object2, keysFunc, symbolsFunc) {
  var result = keysFunc(object2);
  return isArray2(object2) ? result : arrayPush$1(result, symbolsFunc(object2));
}
function arrayFilter(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
  while (++index2 < length) {
    var value = array[index2];
    if (predicate(value, index2, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
function stubArray() {
  return [];
}
var objectProto$8 = Object.prototype;
var propertyIsEnumerable$1 = objectProto$8.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols ? stubArray : function(object2) {
  if (object2 == null) {
    return [];
  }
  object2 = Object(object2);
  return arrayFilter(nativeGetSymbols(object2), function(symbol) {
    return propertyIsEnumerable$1.call(object2, symbol);
  });
};
function baseTimes(n, iteratee) {
  var index2 = -1, result = Array(n);
  while (++index2 < n) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var argsTag$2 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}
var objectProto$7 = Object.prototype;
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
var propertyIsEnumerable2 = objectProto$7.propertyIsEnumerable;
var isArguments = baseIsArguments(/* @__PURE__ */ (function() {
  return arguments;
})()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$6.call(value, "callee") && !propertyIsEnumerable2.call(value, "callee");
};
function stubFalse() {
  return false;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$1 = moduleExports$2 ? root$1.Buffer : void 0;
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag$2 = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func2) {
  return function(value) {
    return func2(value);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal.process;
var nodeUtil = (function() {
  try {
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    if (types) {
      return types;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e) {
  }
})();
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$5.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var objectProto$5 = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$5;
  return value === proto;
}
var nativeKeys = overArg(Object.keys, Object);
var objectProto$4 = Object.prototype;
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
function baseKeys(object2) {
  if (!isPrototype(object2)) {
    return nativeKeys(object2);
  }
  var result = [];
  for (var key in Object(object2)) {
    if (hasOwnProperty$4.call(object2, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}
function keys$1(object2) {
  return isArrayLike(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
}
function getAllKeys(object2) {
  return baseGetAllKeys(object2, keys$1, getSymbols);
}
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$3 = Object.prototype;
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function equalObjects(object2, other, bitmask, customizer4, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$3.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object2);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object2;
  }
  var result = true;
  stack.set(object2, other);
  stack.set(other, object2);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object2[key], othValue = other[key];
    if (customizer4) {
      var compared = isPartial ? customizer4(othValue, objValue, key, other, object2, stack) : customizer4(objValue, othValue, key, object2, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer4, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object2.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object2);
  stack["delete"](other);
  return result;
}
var DataView = getNative(root$1, "DataView");
var Promise$1 = getNative(root$1, "Promise");
var Set$1 = getNative(root$1, "Set");
var WeakMap = getNative(root$1, "WeakMap");
var mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap);
var getTag = baseGetTag;
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag(new Map$1()) != mapTag || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
  getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function baseIsEqualDeep(object2, other, bitmask, customizer4, equalFunc, stack) {
  var objIsArr = isArray2(object2), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object2), othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object2)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object2) ? equalArrays(object2, other, bitmask, customizer4, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer4, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$2.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$2.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer4, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object2, other, bitmask, customizer4, equalFunc, stack);
}
function baseIsEqual(value, other, bitmask, customizer4, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer4, baseIsEqual, stack);
}
function isEqualWith(value, other, customizer4) {
  customizer4 = typeof customizer4 == "function" ? customizer4 : void 0;
  var result = customizer4 ? customizer4(value, other) : void 0;
  return result === void 0 ? baseIsEqual(value, other, void 0, customizer4) : !!result;
}
var customizer$1 = function customizer(obj, other) {
  if (obj === other) return true;
  if (!obj && !other) {
    var objIsEmpty = obj === null || obj === void 0 || obj === "";
    var otherIsEmpty = other === null || other === void 0 || other === "";
    return objIsEmpty === otherIsEmpty;
  }
  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
  if (React__default.isValidElement(obj) || React__default.isValidElement(other)) return false;
};
var deepEqual = function deepEqual2(a, b) {
  return isEqualWith(a, b, customizer$1);
};
var _extends$6 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray$2(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function deleteInWithPath(state, first) {
  if (state === void 0 || state === null || first === void 0 || first === null) {
    return state;
  }
  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }
  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
      }
      var firstIndex = Number(first);
      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(void 0, [state && state[firstIndex]].concat(_toConsumableArray$2(rest)));
        if (result !== state[firstIndex]) {
          var copy = [].concat(_toConsumableArray$2(state));
          copy[firstIndex] = result;
          return copy;
        }
      }
      return state;
    }
    if (first in state) {
      var _result = deleteInWithPath.apply(void 0, [state && state[first]].concat(_toConsumableArray$2(rest)));
      return state[first] === _result ? state : _extends$6({}, state, _defineProperty$3({}, first, _result));
    }
    return state;
  }
  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
    }
    var _firstIndex = Number(first);
    if (_firstIndex < state.length) {
      var _copy = [].concat(_toConsumableArray$2(state));
      _copy.splice(_firstIndex, 1);
      return _copy;
    }
    return state;
  }
  if (first in state) {
    var _copy2 = _extends$6({}, state);
    delete _copy2[first];
    return _copy2;
  }
  return state;
}
var deleteIn = function deleteIn2(state, field) {
  return deleteInWithPath.apply(void 0, [state].concat(_toConsumableArray$2(toPath(field))));
};
function keys2(value) {
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value.map(function(i) {
      return i.name;
    });
  }
  return Object.keys(value);
}
var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn,
  setIn,
  deepEqual,
  deleteIn,
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: keys2,
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: splice$1,
  toJS: function toJS(value) {
    return value;
  }
};
var _extends$5 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass$4 = /* @__PURE__ */ (function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties2(Constructor.prototype, protoProps);
    if (staticProps) defineProperties2(Constructor, staticProps);
    return Constructor;
  };
})();
var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function _objectWithoutProperties$4(obj, keys3) {
  var target = {};
  for (var i in obj) {
    if (keys3.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$4(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var propsToNotUpdateFor$2 = ["_reduxForm"];
var isObject = function isObject2(entity) {
  return entity && (typeof entity === "undefined" ? "undefined" : _typeof$1(entity)) === "object";
};
var isFunction = function isFunction2(entity) {
  return entity && typeof entity === "function";
};
var eventPreventDefault = function eventPreventDefault2(event) {
  if (isObject(event) && isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};
var eventDataTransferGetData = function eventDataTransferGetData2(event, key) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};
var eventDataTransferSetData = function eventDataTransferSetData2(event, key, value) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};
var createConnectedField = function createConnectedField2(structure$1) {
  var deepEqual3 = structure$1.deepEqual, getIn3 = structure$1.getIn;
  var getSyncError = function getSyncError2(syncErrors, name) {
    var error = structure.getIn(syncErrors, name);
    return error && error._error ? error._error : error;
  };
  var getSyncWarning = function getSyncWarning2(syncWarnings, name) {
    var warning2 = getIn3(syncWarnings, name);
    return warning2 && warning2._warning ? warning2._warning : warning2;
  };
  var ConnectedField = (function(_Component) {
    _inherits$4(ConnectedField2, _Component);
    function ConnectedField2() {
      var _ref;
      var _temp, _this, _ret;
      _classCallCheck$4(this, ConnectedField2);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn$4(this, (_ref = ConnectedField2.__proto__ || Object.getPrototypeOf(ConnectedField2)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function(ref) {
        return _this.ref = ref;
      }, _this.isPristine = function() {
        return _this.props.pristine;
      }, _this.getValue = function() {
        return _this.props.value;
      }, _this.handleChange = function(event) {
        var _this$props = _this.props, name = _this$props.name, dispatch = _this$props.dispatch, parse2 = _this$props.parse, normalize2 = _this$props.normalize, onChange = _this$props.onChange, _reduxForm = _this$props._reduxForm, previousValue = _this$props.value;
        var newValue = onChangeValue(event, { name, parse: parse2, normalize: normalize2 });
        var defaultPrevented = false;
        if (onChange) {
          if (!isReactNative) {
            onChange(_extends$5({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onChange(event, newValue, previousValue, name);
          }
        }
        if (!defaultPrevented) {
          dispatch(_reduxForm.change(name, newValue));
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, "change");
          }
        }
      }, _this.handleFocus = function(event) {
        var _this$props2 = _this.props, name = _this$props2.name, dispatch = _this$props2.dispatch, onFocus = _this$props2.onFocus, _reduxForm = _this$props2._reduxForm;
        var defaultPrevented = false;
        if (onFocus) {
          if (!isReactNative) {
            onFocus(_extends$5({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), name);
          } else {
            onFocus(event, name);
          }
        }
        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      }, _this.handleBlur = function(event) {
        var _this$props3 = _this.props, name = _this$props3.name, dispatch = _this$props3.dispatch, parse2 = _this$props3.parse, normalize2 = _this$props3.normalize, onBlur = _this$props3.onBlur, _reduxForm = _this$props3._reduxForm, _value = _this$props3._value, previousValue = _this$props3.value;
        var newValue = onChangeValue(event, { name, parse: parse2, normalize: normalize2 });
        if (newValue === _value && _value !== void 0) {
          newValue = previousValue;
        }
        var defaultPrevented = false;
        if (onBlur) {
          if (!isReactNative) {
            onBlur(_extends$5({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onBlur(event, newValue, previousValue, name);
          }
        }
        if (!defaultPrevented) {
          dispatch(_reduxForm.blur(name, newValue));
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, "blur");
          }
        }
      }, _this.handleDragStart = function(event) {
        var _this$props4 = _this.props, name = _this$props4.name, onDragStart = _this$props4.onDragStart, value = _this$props4.value;
        eventDataTransferSetData(event, dataKey, value == null ? "" : value);
        if (onDragStart) {
          onDragStart(event, name);
        }
      }, _this.handleDrop = function(event) {
        var _this$props5 = _this.props, name = _this$props5.name, dispatch = _this$props5.dispatch, onDrop = _this$props5.onDrop, _reduxForm = _this$props5._reduxForm, previousValue = _this$props5.value;
        var newValue = eventDataTransferGetData(event, dataKey);
        var defaultPrevented = false;
        if (onDrop) {
          onDrop(_extends$5({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue, name);
        }
        if (!defaultPrevented) {
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      }, _temp), _possibleConstructorReturn$4(_this, _ret);
    }
    _createClass$4(ConnectedField2, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;
        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function(prop) {
          if (~(nextProps.immutableProps || []).indexOf(prop)) {
            return _this2.props[prop] !== nextProps[prop];
          }
          return !~propsToNotUpdateFor$2.indexOf(prop) && !deepEqual3(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: "getRenderedComponent",
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: "render",
      value: function render() {
        var _props = this.props, component = _props.component, withRef = _props.withRef, name = _props.name, _reduxForm = _props._reduxForm;
        _props.normalize;
        _props.onBlur;
        _props.onChange;
        _props.onFocus;
        _props.onDragStart;
        _props.onDrop;
        _props.immutableProps;
        var rest = _objectWithoutProperties$4(_props, ["component", "withRef", "name", "_reduxForm", "normalize", "onBlur", "onChange", "onFocus", "onDragStart", "onDrop", "immutableProps"]);
        var _createFieldProps = createFieldProps(structure$1, name, _extends$5({}, rest, {
          form: _reduxForm.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })), custom = _createFieldProps.custom, props = _objectWithoutProperties$4(_createFieldProps, ["custom"]);
        if (withRef) {
          custom.ref = this.saveRef;
        }
        if (typeof component === "string") {
          var input = props.input;
          props.meta;
          return createElement$2(component, _extends$5({}, input, custom));
        } else {
          return createElement$2(component, _extends$5({}, props, custom));
        }
      }
    }]);
    return ConnectedField2;
  })(Component);
  ConnectedField.propTypes = {
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.node]).isRequired,
    props: PropTypes.object
  };
  var connector = connect(function(state, ownProps) {
    var name = ownProps.name, _ownProps$_reduxForm = ownProps._reduxForm, initialValues = _ownProps$_reduxForm.initialValues, getFormState = _ownProps$_reduxForm.getFormState;
    var formState = getFormState(state);
    var initialState2 = getIn3(formState, "initial." + name);
    var initial = initialState2 !== void 0 ? initialState2 : initialValues && getIn3(initialValues, name);
    var value = getIn3(formState, "values." + name);
    var submitting = getIn3(formState, "submitting");
    var syncError = getSyncError(getIn3(formState, "syncErrors"), name);
    var syncWarning = getSyncWarning(getIn3(formState, "syncWarnings"), name);
    var pristine = deepEqual3(value, initial);
    return {
      asyncError: getIn3(formState, "asyncErrors." + name),
      asyncValidating: getIn3(formState, "asyncValidating") === name,
      dirty: !pristine,
      pristine,
      state: getIn3(formState, "fields." + name),
      submitError: getIn3(formState, "submitErrors." + name),
      submitFailed: getIn3(formState, "submitFailed"),
      submitting,
      syncError,
      syncWarning,
      initial,
      value,
      _value: ownProps.value
      // save value passed in (for checkboxes)
    };
  }, void 0, void 0, { withRef: true });
  return connector(ConnectedField);
};
var customizer2 = function customizer3(objectValue, otherValue, indexOrkey, object2, other, stack) {
  if (stack) {
    return objectValue === otherValue;
  }
};
var shallowCompare = function shallowCompare2(instance, nextProps, nextState) {
  var propsEqual = isEqualWith(instance.props, nextProps, customizer2);
  var stateEqual = isEqualWith(instance.state, nextState, customizer2);
  return !propsEqual || !stateEqual;
};
var _extends$4 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass$3 = /* @__PURE__ */ (function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties2(Constructor.prototype, protoProps);
    if (staticProps) defineProperties2(Constructor, staticProps);
    return Constructor;
  };
})();
function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$3(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var createField = function createField2(structure$1) {
  var ConnectedField = createConnectedField(structure$1);
  var setIn3 = structure$1.setIn;
  var Field2 = (function(_Component) {
    _inherits$3(Field3, _Component);
    function Field3(props, context) {
      _classCallCheck$3(this, Field3);
      var _this = _possibleConstructorReturn$3(this, (Field3.__proto__ || Object.getPrototypeOf(Field3)).call(this, props, context));
      _this.saveRef = function(ref) {
        return _this.ref = ref;
      };
      _this.normalize = function(name, value) {
        var normalize2 = _this.props.normalize;
        if (!normalize2) {
          return value;
        }
        var previousValues = _this.context._reduxForm.getValues();
        var previousValue = _this.value;
        var nextValues = setIn3(previousValues, name, value);
        return normalize2(value, previousValue, nextValues, previousValues);
      };
      if (!context._reduxForm) {
        throw new Error("Field must be inside a component decorated with reduxForm()");
      }
      return _this;
    }
    _createClass$3(Field3, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;
        this.context._reduxForm.register(this.name, "Field", function() {
          return _this2.props.validate;
        }, function() {
          return _this2.props.warn;
        });
      }
    }, {
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState) {
        return shallowCompare(this, nextProps, nextState);
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps2(nextProps, nextContext) {
        var oldName = formatName(this.context, this.props.name);
        var newName = formatName(nextContext, nextProps.name);
        if (oldName !== newName || // use deepEqual here because they could be a function or an array of functions
        !structure.deepEqual(this.props.validate, nextProps.validate) || !structure.deepEqual(this.props.warn, nextProps.warn)) {
          this.context._reduxForm.unregister(oldName);
          this.context._reduxForm.register(newName, "Field", function() {
            return nextProps.validate;
          }, function() {
            return nextProps.warn;
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: "getRenderedComponent",
      value: function getRenderedComponent() {
        invariant(this.props.withRef, "If you want to access getRenderedComponent(), you must specify a withRef prop to Field");
        return this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : void 0;
      }
    }, {
      key: "render",
      value: function render() {
        return createElement$2(ConnectedField, _extends$4({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: "name",
      get: function get3() {
        return formatName(this.context, this.props.name);
      }
    }, {
      key: "dirty",
      get: function get3() {
        return !this.pristine;
      }
    }, {
      key: "pristine",
      get: function get3() {
        return !!(this.ref && this.ref.getWrappedInstance().isPristine());
      }
    }, {
      key: "value",
      get: function get3() {
        return this.ref && this.ref.getWrappedInstance().getValue();
      }
    }]);
    return Field3;
  })(Component);
  Field2.propTypes = {
    name: PropTypes.string.isRequired,
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.node]).isRequired,
    format: PropTypes.func,
    normalize: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onDragStart: PropTypes.func,
    onDrop: PropTypes.func,
    parse: PropTypes.func,
    props: PropTypes.object,
    validate: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
    warn: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
    withRef: PropTypes.bool,
    immutableProps: PropTypes.arrayOf(PropTypes.string)
  };
  Field2.contextTypes = {
    _reduxForm: PropTypes.object
  };
  polyfill(Field2);
  return Field2;
};
const Field = createField(structure);
var defineProperty3 = (function() {
  try {
    var func2 = getNative(Object, "defineProperty");
    func2({}, "", {});
    return func2;
  } catch (e) {
  }
})();
function baseAssignValue(object2, key, value) {
  if (key == "__proto__" && defineProperty3) {
    defineProperty3(object2, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object2[key] = value;
  }
}
function createBaseFor(fromRight) {
  return function(object2, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object2), props = keysFunc(object2), length = props.length;
    while (length--) {
      var key = props[++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object2;
  };
}
var baseFor = createBaseFor();
function baseForOwn(object2, iteratee) {
  return object2 && baseFor(object2, iteratee, keys$1);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(object2, source, matchData, customizer4) {
  var index2 = matchData.length, length = index2;
  if (object2 == null) {
    return !length;
  }
  object2 = Object(object2);
  while (index2--) {
    var data2 = matchData[index2];
    if (data2[2] ? data2[1] !== object2[data2[0]] : !(data2[0] in object2)) {
      return false;
    }
  }
  while (++index2 < length) {
    data2 = matchData[index2];
    var key = data2[0], objValue = object2[key], srcValue = data2[1];
    if (data2[2]) {
      if (objValue === void 0 && !(key in object2)) {
        return false;
      }
    } else {
      var stack = new Stack();
      var result;
      if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer4, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
function isStrictComparable(value) {
  return value === value && !isObject$1(value);
}
function getMatchData(object2) {
  var result = keys$1(object2), length = result.length;
  while (length--) {
    var key = result[length], value = object2[key];
    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}
function matchesStrictComparable(key, srcValue) {
  return function(object2) {
    if (object2 == null) {
      return false;
    }
    return object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
  };
}
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object2) {
    return object2 === source || baseIsMatch(object2, source, matchData);
  };
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(value, object2) {
  if (isArray2(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object2 != null && value in Object(object2);
}
function castPath(value, object2) {
  if (isArray2(value)) {
    return value;
  }
  return isKey(value, object2) ? [value] : stringToPath(toString$1(value));
}
function baseGet(object2, path) {
  path = castPath(path, object2);
  var index2 = 0, length = path.length;
  while (object2 != null && index2 < length) {
    object2 = object2[toKey(path[index2++])];
  }
  return index2 && index2 == length ? object2 : void 0;
}
function get2(object2, path, defaultValue) {
  var result = object2 == null ? void 0 : baseGet(object2, path);
  return result === void 0 ? defaultValue : result;
}
function baseHasIn(object2, key) {
  return object2 != null && key in Object(object2);
}
function hasPath(object2, path, hasFunc) {
  path = castPath(path, object2);
  var index2 = -1, length = path.length, result = false;
  while (++index2 < length) {
    var key = toKey(path[index2]);
    if (!(result = object2 != null && hasFunc(object2, key))) {
      break;
    }
    object2 = object2[key];
  }
  if (result || ++index2 != length) {
    return result;
  }
  length = object2 == null ? 0 : object2.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray2(object2) || isArguments(object2));
}
function hasIn(object2, path) {
  return object2 != null && hasPath(object2, path, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object2) {
    var objValue = get2(object2, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object2, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function identity$1(value) {
  return value;
}
function baseProperty(key) {
  return function(object2) {
    return object2 == null ? void 0 : object2[key];
  };
}
function basePropertyDeep(path) {
  return function(object2) {
    return baseGet(object2, path);
  };
}
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
function baseIteratee(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity$1;
  }
  if (typeof value == "object") {
    return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
function mapValues(object2, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee);
  baseForOwn(object2, function(value, key, object3) {
    baseAssignValue(result, key, iteratee(value, key, object3));
  });
  return result;
}
var _extends$3 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties$3(obj, keys3) {
  var target = {};
  for (var i in obj) {
    if (keys3.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var createFieldArrayProps = function createFieldArrayProps2(_ref2, name, form2, sectionPrefix, getValue3, _ref) {
  var getIn3 = _ref2.getIn;
  var arrayInsert3 = _ref.arrayInsert, arrayMove3 = _ref.arrayMove, arrayPop3 = _ref.arrayPop, arrayPush3 = _ref.arrayPush, arrayRemove3 = _ref.arrayRemove, arrayRemoveAll3 = _ref.arrayRemoveAll, arrayShift3 = _ref.arrayShift, arraySplice3 = _ref.arraySplice, arraySwap3 = _ref.arraySwap, arrayUnshift3 = _ref.arrayUnshift, asyncError = _ref.asyncError, dirty = _ref.dirty, length = _ref.length, pristine = _ref.pristine, submitError = _ref.submitError;
  _ref.state;
  var submitFailed = _ref.submitFailed, submitting = _ref.submitting, syncError = _ref.syncError, syncWarning = _ref.syncWarning, value = _ref.value, props = _ref.props, rest = _objectWithoutProperties$3(_ref, ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncError", "dirty", "length", "pristine", "submitError", "state", "submitFailed", "submitting", "syncError", "syncWarning", "value", "props"]);
  var error = syncError || asyncError || submitError;
  var warning2 = syncWarning;
  var fieldName = sectionPrefix ? name.replace(sectionPrefix + ".", "") : name;
  var finalProps = _extends$3({
    fields: {
      _isFieldArray: true,
      forEach: function forEach2(callback) {
        return (value || []).forEach(function(item, index2) {
          return callback(fieldName + "[" + index2 + "]", index2, finalProps.fields);
        });
      },
      get: getValue3,
      getAll: function getAll() {
        return value;
      },
      insert: arrayInsert3,
      length,
      map: function map(callback) {
        return (value || []).map(function(item, index2) {
          return callback(fieldName + "[" + index2 + "]", index2, finalProps.fields);
        });
      },
      move: arrayMove3,
      name,
      pop: function pop() {
        arrayPop3();
        return getIn3(value, String(length - 1));
      },
      push: arrayPush3,
      reduce: function reduce(callback, initial) {
        return (value || []).reduce(function(accumulator, item, index2) {
          return callback(accumulator, fieldName + "[" + index2 + "]", index2, finalProps.fields);
        }, initial);
      },
      remove: arrayRemove3,
      removeAll: arrayRemoveAll3,
      shift: function shift() {
        arrayShift3();
        return getIn3(value, "0");
      },
      splice: arraySplice3,
      swap: arraySwap3,
      unshift: arrayUnshift3
    },
    meta: {
      dirty,
      error,
      form: form2,
      warning: warning2,
      invalid: !!error,
      pristine,
      submitting,
      submitFailed,
      valid: !error
    }
  }, props, rest);
  return finalProps;
};
var _createClass$2 = /* @__PURE__ */ (function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties2(Constructor.prototype, protoProps);
    if (staticProps) defineProperties2(Constructor, staticProps);
    return Constructor;
  };
})();
function _objectWithoutProperties$2(obj, keys3) {
  var target = {};
  for (var i in obj) {
    if (keys3.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$2(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var propsToNotUpdateFor$1 = ["_reduxForm", "value"];
var createConnectedFieldArray = function createConnectedFieldArray2(structure$1) {
  var deepEqual3 = structure$1.deepEqual, getIn3 = structure$1.getIn, size2 = structure$1.size;
  var getSyncError = function getSyncError2(syncErrors, name) {
    return structure.getIn(syncErrors, name + "._error");
  };
  var getSyncWarning = function getSyncWarning2(syncWarnings, name) {
    return getIn3(syncWarnings, name + "._warning");
  };
  var ConnectedFieldArray = (function(_React$Component) {
    _inherits$2(ConnectedFieldArray2, _React$Component);
    function ConnectedFieldArray2() {
      var _ref;
      var _temp, _this, _ret;
      _classCallCheck$2(this, ConnectedFieldArray2);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn$2(this, (_ref = ConnectedFieldArray2.__proto__ || Object.getPrototypeOf(ConnectedFieldArray2)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function(ref) {
        _this.ref = ref;
      }, _this.getValue = function(index2) {
        return _this.props.value && getIn3(_this.props.value, String(index2));
      }, _temp), _possibleConstructorReturn$2(_this, _ret);
    }
    _createClass$2(ConnectedFieldArray2, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;
        var thisValue = this.props.value;
        var nextValue = nextProps.value;
        if (thisValue && nextValue) {
          var nextValueItemsSame = nextValue.every(function(val) {
            return ~thisValue.indexOf(val);
          });
          var nextValueItemsOrderChanged = nextValue.some(function(val, index2) {
            return val !== thisValue[index2];
          });
          if (thisValue.length !== nextValue.length || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function(val, index2) {
            return !deepEqual3(val, nextValue[index2]);
          })) {
            return true;
          }
        }
        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function(prop) {
          return !~propsToNotUpdateFor$1.indexOf(prop) && !deepEqual3(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: "getRenderedComponent",
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: "render",
      value: function render() {
        var _props = this.props, component = _props.component, withRef = _props.withRef, name = _props.name, _reduxForm = _props._reduxForm;
        _props.validate;
        _props.warn;
        _props.rerenderOnEveryChange;
        var rest = _objectWithoutProperties$2(_props, ["component", "withRef", "name", "_reduxForm", "validate", "warn", "rerenderOnEveryChange"]);
        var props = createFieldArrayProps(structure$1, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
        if (withRef) {
          props.ref = this.saveRef;
        }
        return React.createElement(component, props);
      }
    }, {
      key: "dirty",
      get: function get3() {
        return this.props.dirty;
      }
    }, {
      key: "pristine",
      get: function get3() {
        return this.props.pristine;
      }
    }, {
      key: "value",
      get: function get3() {
        return this.props.value;
      }
    }]);
    return ConnectedFieldArray2;
  })(React.Component);
  ConnectedFieldArray.propTypes = {
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.node]).isRequired,
    props: PropTypes.object,
    rerenderOnEveryChange: PropTypes.bool
  };
  ConnectedFieldArray.defaultProps = {
    rerenderOnEveryChange: false
  };
  ConnectedFieldArray.contextTypes = {
    _reduxForm: PropTypes.object
  };
  var connector = connect(function(state, ownProps) {
    var name = ownProps.name, _ownProps$_reduxForm = ownProps._reduxForm, initialValues = _ownProps$_reduxForm.initialValues, getFormState = _ownProps$_reduxForm.getFormState;
    var formState = getFormState(state);
    var initial = getIn3(formState, "initial." + name) || initialValues && getIn3(initialValues, name);
    var value = getIn3(formState, "values." + name);
    var submitting = getIn3(formState, "submitting");
    var syncError = getSyncError(getIn3(formState, "syncErrors"), name);
    var syncWarning = getSyncWarning(getIn3(formState, "syncWarnings"), name);
    var pristine = deepEqual3(value, initial);
    return {
      asyncError: getIn3(formState, "asyncErrors." + name + "._error"),
      dirty: !pristine,
      pristine,
      state: getIn3(formState, "fields." + name),
      submitError: getIn3(formState, "submitErrors." + name + "._error"),
      submitFailed: getIn3(formState, "submitFailed"),
      submitting,
      syncError,
      syncWarning,
      value,
      length: size2(value)
    };
  }, function(dispatch, ownProps) {
    var name = ownProps.name, _reduxForm = ownProps._reduxForm;
    var arrayInsert3 = _reduxForm.arrayInsert, arrayMove3 = _reduxForm.arrayMove, arrayPop3 = _reduxForm.arrayPop, arrayPush3 = _reduxForm.arrayPush, arrayRemove3 = _reduxForm.arrayRemove, arrayRemoveAll3 = _reduxForm.arrayRemoveAll, arrayShift3 = _reduxForm.arrayShift, arraySplice3 = _reduxForm.arraySplice, arraySwap3 = _reduxForm.arraySwap, arrayUnshift3 = _reduxForm.arrayUnshift;
    return mapValues({
      arrayInsert: arrayInsert3,
      arrayMove: arrayMove3,
      arrayPop: arrayPop3,
      arrayPush: arrayPush3,
      arrayRemove: arrayRemove3,
      arrayRemoveAll: arrayRemoveAll3,
      arrayShift: arrayShift3,
      arraySplice: arraySplice3,
      arraySwap: arraySwap3,
      arrayUnshift: arrayUnshift3
    }, function(actionCreator) {
      return bindActionCreators(actionCreator.bind(null, name), dispatch);
    });
  }, void 0, { withRef: true });
  return connector(ConnectedFieldArray);
};
var _extends$2 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass$1 = /* @__PURE__ */ (function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties2(Constructor.prototype, protoProps);
    if (staticProps) defineProperties2(Constructor, staticProps);
    return Constructor;
  };
})();
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var toArray$1 = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};
var wrapError = function wrapError2(fn, key) {
  return fn && function() {
    var validators = toArray$1(fn);
    for (var i = 0; i < validators.length; i++) {
      var result = validators[i].apply(validators, arguments);
      if (result) {
        return _defineProperty$2({}, key, result);
      }
    }
  };
};
var createFieldArray = function createFieldArray2(structure2) {
  var ConnectedFieldArray = createConnectedFieldArray(structure2);
  var FieldArray2 = (function(_Component) {
    _inherits$1(FieldArray3, _Component);
    function FieldArray3(props, context) {
      _classCallCheck$1(this, FieldArray3);
      var _this = _possibleConstructorReturn$1(this, (FieldArray3.__proto__ || Object.getPrototypeOf(FieldArray3)).call(this, props, context));
      _this.saveRef = function(ref) {
        _this.ref = ref;
      };
      if (!context._reduxForm) {
        throw new Error("FieldArray must be inside a component decorated with reduxForm()");
      }
      return _this;
    }
    _createClass$1(FieldArray3, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;
        this.context._reduxForm.register(this.name, "FieldArray", function() {
          return wrapError(_this2.props.validate, "_error");
        }, function() {
          return wrapError(_this2.props.warn, "_warning");
        });
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps2(nextProps, nextContext) {
        var oldName = formatName(this.context, this.props.name);
        var newName = formatName(nextContext, nextProps.name);
        if (oldName !== newName) {
          this.context._reduxForm.unregister(oldName);
          this.context._reduxForm.register(newName, "FieldArray");
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: "getRenderedComponent",
      value: function getRenderedComponent() {
        invariant(this.props.withRef, "If you want to access getRenderedComponent(), you must specify a withRef prop to FieldArray");
        return this.ref && this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: "render",
      value: function render() {
        return createElement$2(ConnectedFieldArray, _extends$2({}, this.props, {
          name: this.name,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: "name",
      get: function get3() {
        return formatName(this.context, this.props.name);
      }
    }, {
      key: "dirty",
      get: function get3() {
        return !this.ref || this.ref.getWrappedInstance().dirty;
      }
    }, {
      key: "pristine",
      get: function get3() {
        return !!(this.ref && this.ref.getWrappedInstance().pristine);
      }
    }, {
      key: "value",
      get: function get3() {
        return this.ref ? this.ref.getWrappedInstance().value : void 0;
      }
    }]);
    return FieldArray3;
  })(Component);
  FieldArray2.propTypes = {
    name: PropTypes.string.isRequired,
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.node]).isRequired,
    props: PropTypes.object,
    validate: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
    warn: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
    withRef: PropTypes.bool
  };
  FieldArray2.contextTypes = {
    _reduxForm: PropTypes.object
  };
  polyfill(FieldArray2);
  return FieldArray2;
};
const FieldArray = createFieldArray(structure);
var createGetFormValues = function createGetFormValues2(_ref) {
  var getIn3 = _ref.getIn;
  return function(form2, getFormState) {
    return function(state) {
      var nonNullGetFormState = getFormState || function(state2) {
        return getIn3(state2, "form");
      };
      return getIn3(nonNullGetFormState(state), form2 + ".values");
    };
  };
};
const getFormValues = createGetFormValues(structure);
var createGetFormSyncErrors = function createGetFormSyncErrors2(_ref) {
  var getIn3 = _ref.getIn, empty2 = _ref.empty;
  return function(form2, getFormState) {
    return function(state) {
      var nonNullGetFormState = getFormState || function(state2) {
        return getIn3(state2, "form");
      };
      return getIn3(nonNullGetFormState(state), form2 + ".syncErrors") || empty2;
    };
  };
};
const getFormSyncErrors = createGetFormSyncErrors(structure);
var getErrorKeys = function getErrorKeys2(name, type) {
  switch (type) {
    case "Field":
      return [name, name + "._error"];
    case "FieldArray":
      return [name + "._error"];
    default:
      throw new Error("Unknown field type");
  }
};
var createHasError = function createHasError2(_ref) {
  var getIn3 = _ref.getIn;
  var hasError = function hasError2(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }
    var name = getIn3(field, "name");
    var type = getIn3(field, "type");
    return getErrorKeys(name, type).some(function(key) {
      return getIn3(syncErrors, key) || getIn3(asyncErrors, key) || getIn3(submitErrors, key);
    });
  };
  return hasError;
};
var createIsValid = function createIsValid2(structure2) {
  var getIn3 = structure2.getIn, keys3 = structure2.keys;
  var hasError = createHasError(structure2);
  return function(form2, getFormState) {
    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return function(state) {
      var nonNullGetFormState = getFormState || function(state2) {
        return getIn3(state2, "form");
      };
      var formState = nonNullGetFormState(state);
      var syncError = getIn3(formState, form2 + ".syncError");
      if (syncError) {
        return false;
      }
      if (!ignoreSubmitErrors) {
        var error = getIn3(formState, form2 + ".error");
        if (error) {
          return false;
        }
      }
      var syncErrors = getIn3(formState, form2 + ".syncErrors");
      var asyncErrors = getIn3(formState, form2 + ".asyncErrors");
      var submitErrors = ignoreSubmitErrors ? void 0 : getIn3(formState, form2 + ".submitErrors");
      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }
      var registeredFields = getIn3(formState, form2 + ".registeredFields");
      if (!registeredFields) {
        return true;
      }
      return !keys3(registeredFields).filter(function(name) {
        return getIn3(registeredFields, "['" + name + "'].count") > 0;
      }).some(function(name) {
        return hasError(getIn3(registeredFields, "['" + name + "']"), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};
const isValid = createIsValid(structure);
function assignMergeValue(object2, key, value) {
  if (value !== void 0 && !eq(object2[key], value) || value === void 0 && !(key in object2)) {
    baseAssignValue(object2, key, value);
  }
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer = moduleExports ? root$1.Buffer : void 0;
Buffer ? Buffer.allocUnsafe : void 0;
function cloneBuffer(buffer2, isDeep) {
  {
    return buffer2.slice();
  }
}
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}
function cloneTypedArray(typedArray, isDeep) {
  var buffer2 = cloneArrayBuffer(typedArray.buffer);
  return new typedArray.constructor(buffer2, typedArray.byteOffset, typedArray.length);
}
var objectCreate = Object.create;
var baseCreate = /* @__PURE__ */ (function() {
  function object2() {
  }
  return function(proto) {
    if (!isObject$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object2.prototype = proto;
    var result = new object2();
    object2.prototype = void 0;
    return result;
  };
})();
function initCloneObject(object2) {
  return typeof object2.constructor == "function" && !isPrototype(object2) ? baseCreate(getPrototype(object2)) : {};
}
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}
function safeGet(object2, key) {
  if (key === "constructor" && typeof object2[key] === "function") {
    return;
  }
  if (key == "__proto__") {
    return;
  }
  return object2[key];
}
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function assignValue(object2, key, value) {
  var objValue = object2[key];
  if (!(hasOwnProperty$1.call(object2, key) && eq(objValue, value)) || value === void 0 && !(key in object2)) {
    baseAssignValue(object2, key, value);
  }
}
function copyObject(source, props, object2, customizer4) {
  var isNew = !object2;
  object2 || (object2 = {});
  var index2 = -1, length = props.length;
  while (++index2 < length) {
    var key = props[index2];
    var newValue = void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object2, key, newValue);
    } else {
      assignValue(object2, key, newValue);
    }
  }
  return object2;
}
function nativeKeysIn(object2) {
  var result = [];
  if (object2 != null) {
    for (var key in Object(object2)) {
      result.push(key);
    }
  }
  return result;
}
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function baseKeysIn(object2) {
  if (!isObject$1(object2)) {
    return nativeKeysIn(object2);
  }
  var isProto = isPrototype(object2), result = [];
  for (var key in object2) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object2, key)))) {
      result.push(key);
    }
  }
  return result;
}
function keysIn(object2) {
  return isArrayLike(object2) ? arrayLikeKeys(object2, true) : baseKeysIn(object2);
}
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}
function baseMergeDeep(object2, source, key, srcIndex, mergeFunc, customizer4, stack) {
  var objValue = safeGet(object2, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
  if (stacked) {
    assignMergeValue(object2, key, stacked);
    return;
  }
  var newValue = customizer4 ? customizer4(objValue, srcValue, key + "", object2, source, stack) : void 0;
  var isCommon = newValue === void 0;
  if (isCommon) {
    var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray2(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue);
      } else {
        newValue = [];
      }
    } else if (isPlainObject$1(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject$1(objValue) || isFunction$1(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer4, stack);
    stack["delete"](srcValue);
  }
  assignMergeValue(object2, key, newValue);
}
function baseMerge(object2, source, srcIndex, customizer4, stack) {
  if (object2 === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack());
    if (isObject$1(srcValue)) {
      baseMergeDeep(object2, source, key, srcIndex, baseMerge, customizer4, stack);
    } else {
      var newValue = customizer4 ? customizer4(safeGet(object2, key), srcValue, key + "", object2, source, stack) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object2, key, newValue);
    }
  }, keysIn);
}
function apply(func2, thisArg, args) {
  switch (args.length) {
    case 0:
      return func2.call(thisArg);
    case 1:
      return func2.call(thisArg, args[0]);
    case 2:
      return func2.call(thisArg, args[0], args[1]);
    case 3:
      return func2.call(thisArg, args[0], args[1], args[2]);
  }
  return func2.apply(thisArg, args);
}
var nativeMax = Math.max;
function overRest(func2, start, transform) {
  start = nativeMax(start === void 0 ? func2.length - 1 : start, 0);
  return function() {
    var args = arguments, index2 = -1, length = nativeMax(args.length - start, 0), array = Array(length);
    while (++index2 < length) {
      array[index2] = args[start + index2];
    }
    index2 = -1;
    var otherArgs = Array(start + 1);
    while (++index2 < start) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start] = transform(array);
    return apply(func2, this, otherArgs);
  };
}
function constant(value) {
  return function() {
    return value;
  };
}
var baseSetToString = !defineProperty3 ? identity$1 : function(func2, string2) {
  return defineProperty3(func2, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string2),
    "writable": true
  });
};
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut(func2) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func2.apply(void 0, arguments);
  };
}
var setToString = shortOut(baseSetToString);
function baseRest(func2, start) {
  return setToString(overRest(func2, start, identity$1), func2 + "");
}
function isIterateeCall(value, index2, object2) {
  if (!isObject$1(object2)) {
    return false;
  }
  var type = typeof index2;
  if (type == "number" ? isArrayLike(object2) && isIndex(index2, object2.length) : type == "string" && index2 in object2) {
    return eq(object2[index2], value);
  }
  return false;
}
function createAssigner(assigner) {
  return baseRest(function(object2, sources) {
    var index2 = -1, length = sources.length, customizer4 = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
    customizer4 = assigner.length > 3 && typeof customizer4 == "function" ? (length--, customizer4) : void 0;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer4 = length < 3 ? void 0 : customizer4;
      length = 1;
    }
    object2 = Object(object2);
    while (++index2 < length) {
      var source = sources[index2];
      if (source) {
        assigner(object2, source, index2, customizer4);
      }
    }
    return object2;
  });
}
var merge = createAssigner(function(object2, source, srcIndex) {
  baseMerge(object2, source, srcIndex);
});
var hoistNonReactStatics_cjs;
var hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  };
  var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  };
  var defineProperty4 = Object.defineProperty;
  var getOwnPropertyNames2 = Object.getOwnPropertyNames;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var getOwnPropertyDescriptor3 = Object.getOwnPropertyDescriptor;
  var getPrototypeOf = Object.getPrototypeOf;
  var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
  function hoistNonReactStatics2(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
      if (objectPrototype) {
        var inheritedComponent = getPrototypeOf(sourceComponent);
        if (inheritedComponent && inheritedComponent !== objectPrototype) {
          hoistNonReactStatics2(targetComponent, inheritedComponent, blacklist);
        }
      }
      var keys3 = getOwnPropertyNames2(sourceComponent);
      if (getOwnPropertySymbols) {
        keys3 = keys3.concat(getOwnPropertySymbols(sourceComponent));
      }
      for (var i = 0; i < keys3.length; ++i) {
        var key = keys3[i];
        if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
          var descriptor = getOwnPropertyDescriptor3(sourceComponent, key);
          try {
            defineProperty4(targetComponent, key, descriptor);
          } catch (e) {
          }
        }
      }
      return targetComponent;
    }
    return targetComponent;
  }
  hoistNonReactStatics_cjs = hoistNonReactStatics2;
  return hoistNonReactStatics_cjs;
}
var hoistNonReactStatics_cjsExports = requireHoistNonReactStatics_cjs();
const hoistStatics = /* @__PURE__ */ getDefaultExportFromCjs(hoistNonReactStatics_cjsExports);
var isPromise$1 = { exports: {} };
var hasRequiredIsPromise;
function requireIsPromise() {
  if (hasRequiredIsPromise) return isPromise$1.exports;
  hasRequiredIsPromise = 1;
  isPromise$1.exports = isPromise2;
  isPromise$1.exports.default = isPromise2;
  function isPromise2(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
  }
  return isPromise$1.exports;
}
var isPromiseExports = requireIsPromise();
const isPromise = /* @__PURE__ */ getDefaultExportFromCjs(isPromiseExports);
var asyncValidation = function asyncValidation2(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!isPromise(promise)) {
    throw new Error("asyncValidate function passed to reduxForm must return a promise");
  }
  var handleErrors = function handleErrors2(rejected) {
    return function(errors) {
      if (rejected) {
        if (errors && Object.keys(errors).length) {
          stop(errors);
          return errors;
        } else {
          stop();
          throw new Error("Asynchronous validation promise was rejected without errors.");
        }
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};
var silenceEvent = function silenceEvent2(event) {
  var is2 = isEvent(event);
  if (is2) {
    event.preventDefault();
  }
  return is2;
};
var silenceEvents = function silenceEvents2(fn) {
  return function(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return silenceEvent(event) ? fn.apply(void 0, args) : fn.apply(void 0, [event].concat(args));
  };
};
var toArray2 = function toArray3(value) {
  return Array.isArray(value) ? value : [value];
};
var getError = function getError2(value, values, props, validators, name) {
  var array = toArray2(validators);
  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props, name);
    if (error) {
      return error;
    }
  }
};
var generateValidator = function generateValidator2(validators, _ref) {
  var getIn3 = _ref.getIn;
  return function(values, props) {
    var errors = {};
    Object.keys(validators).forEach(function(name) {
      var value = getIn3(values, name);
      var error = getError(value, values, props, validators[name], name);
      if (error) {
        errors = structure.setIn(errors, name, error);
      }
    });
    return errors;
  };
};
var _extends$1 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _toConsumableArray$1(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
var handleSubmit = function handleSubmit2(submit3, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch, onSubmitFail = props.onSubmitFail, onSubmitSuccess = props.onSubmitSuccess, startSubmit3 = props.startSubmit, stopSubmit3 = props.stopSubmit, setSubmitFailed3 = props.setSubmitFailed, setSubmitSucceeded3 = props.setSubmitSucceeded, syncErrors = props.syncErrors, asyncErrors = props.asyncErrors, touch3 = props.touch, values = props.values, persistentSubmitErrors = props.persistentSubmitErrors;
  touch3.apply(void 0, _toConsumableArray$1(fields));
  if (valid || persistentSubmitErrors) {
    var doSubmit = function doSubmit2() {
      var result = void 0;
      try {
        result = submit3(values, dispatch, props);
      } catch (submitError) {
        var error = submitError instanceof SubmissionError ? submitError.errors : void 0;
        stopSubmit3(error);
        setSubmitFailed3.apply(void 0, _toConsumableArray$1(fields));
        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }
        if (error || onSubmitFail) {
          return error;
        } else {
          throw submitError;
        }
      }
      if (isPromise(result)) {
        startSubmit3();
        return result.then(function(submitResult) {
          stopSubmit3();
          setSubmitSucceeded3();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult, dispatch, props);
          }
          return submitResult;
        }, function(submitError) {
          var error2 = submitError instanceof SubmissionError ? submitError.errors : void 0;
          stopSubmit3(error2);
          setSubmitFailed3.apply(void 0, _toConsumableArray$1(fields));
          if (onSubmitFail) {
            onSubmitFail(error2, dispatch, submitError, props);
          }
          if (error2 || onSubmitFail) {
            return error2;
          } else {
            throw submitError;
          }
        });
      } else {
        setSubmitSucceeded3();
        if (onSubmitSuccess) {
          onSubmitSuccess(result, dispatch, props);
        }
      }
      return result;
    };
    var asyncValidateResult = asyncValidate && asyncValidate();
    if (asyncValidateResult) {
      return asyncValidateResult.then(function(asyncErrors2) {
        if (asyncErrors2) {
          throw asyncErrors2;
        }
        return doSubmit();
      }).catch(function(asyncErrors2) {
        setSubmitFailed3.apply(void 0, _toConsumableArray$1(fields));
        if (onSubmitFail) {
          onSubmitFail(asyncErrors2, dispatch, null, props);
        }
        return Promise.reject(asyncErrors2);
      });
    } else {
      return doSubmit();
    }
  } else {
    setSubmitFailed3.apply(void 0, _toConsumableArray$1(fields));
    var errors = _extends$1({}, asyncErrors, syncErrors);
    if (onSubmitFail) {
      onSubmitFail(errors, dispatch, null, props);
    }
    return errors;
  }
};
var getDisplayName = function getDisplayName2(Comp) {
  return Comp.displayName || Comp.name || "Component";
};
var isHotReloading = function isHotReloading2() {
  return !!(typeof module !== "undefined" && module.hot && typeof module.hot.status === "function" && module.hot.status() === "apply");
};
var _createClass = /* @__PURE__ */ (function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties2(Constructor.prototype, protoProps);
    if (staticProps) defineProperties2(Constructor, staticProps);
    return Constructor;
  };
})();
var _extends = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _objectWithoutProperties$1(obj, keys3) {
  var target = {};
  for (var i in obj) {
    if (keys3.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var isClassComponent = function isClassComponent2(Component2) {
  return Boolean(Component2 && Component2.prototype && _typeof(Component2.prototype.isReactComponent) === "object");
};
var arrayInsert2 = actions.arrayInsert, arrayMove2 = actions.arrayMove, arrayPop2 = actions.arrayPop, arrayPush2 = actions.arrayPush, arrayRemove2 = actions.arrayRemove, arrayRemoveAll2 = actions.arrayRemoveAll, arrayShift2 = actions.arrayShift, arraySplice2 = actions.arraySplice, arraySwap2 = actions.arraySwap, arrayUnshift2 = actions.arrayUnshift, blur2 = actions.blur, change$1 = actions.change, focus2 = actions.focus, formActions = _objectWithoutProperties$1(actions, ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "blur", "change", "focus"]);
var arrayActions = {
  arrayInsert: arrayInsert2,
  arrayMove: arrayMove2,
  arrayPop: arrayPop2,
  arrayPush: arrayPush2,
  arrayRemove: arrayRemove2,
  arrayRemoveAll: arrayRemoveAll2,
  arrayShift: arrayShift2,
  arraySplice: arraySplice2,
  arraySwap: arraySwap2,
  arrayUnshift: arrayUnshift2
};
var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(actions)), ["array", "asyncErrors", "initialValues", "syncErrors", "syncWarnings", "values", "registeredFields"]);
var checkSubmit = function checkSubmit2(submit3) {
  if (!submit3 || typeof submit3 !== "function") {
    throw new Error("You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop");
  }
  return submit3;
};
var createReduxForm = function createReduxForm2(structure$1) {
  var deepEqual3 = structure$1.deepEqual, empty2 = structure$1.empty, getIn3 = structure$1.getIn, setIn3 = structure$1.setIn, keys3 = structure$1.keys, fromJS2 = structure$1.fromJS;
  var isValid2 = createIsValid(structure$1);
  return function(initialConfig) {
    var config = _extends({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: defaultShouldAsyncValidate,
      shouldValidate: defaultShouldValidate,
      shouldError: defaultShouldError,
      shouldWarn: defaultShouldWarn,
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      updateUnregisteredFields: false,
      getFormState: function getFormState(state) {
        return getIn3(state, "form");
      },
      pure: true,
      forceUnregisterOnUnmount: false
    }, initialConfig);
    return function(WrappedComponent) {
      var Form2 = (function(_Component) {
        _inherits(Form3, _Component);
        function Form3() {
          var _ref;
          var _temp, _this, _ret;
          _classCallCheck(this, Form3);
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form3.__proto__ || Object.getPrototypeOf(Form3)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldCounts = {}, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = void 0, _this.submitPromise = void 0, _this.getValues = function() {
            return _this.props.values;
          }, _this.isValid = function() {
            return _this.props.valid;
          }, _this.isPristine = function() {
            return _this.props.pristine;
          }, _this.register = function(name, type, getValidator, getWarner) {
            var lastCount = _this.fieldCounts[name];
            var nextCount = (lastCount || 0) + 1;
            _this.fieldCounts[name] = nextCount;
            _this.props.registerField(name, type);
            if (getValidator) {
              _this.fieldValidators[name] = getValidator;
            }
            if (getWarner) {
              _this.fieldWarners[name] = getWarner;
            }
          }, _this.unregister = function(name) {
            var lastCount = _this.fieldCounts[name];
            if (lastCount === 1) delete _this.fieldCounts[name];
            else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;
            if (!_this.destroyed) {
              var _this$props = _this.props, _destroyOnUnmount = _this$props.destroyOnUnmount, _forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount, _unregisterField = _this$props.unregisterField;
              if (_destroyOnUnmount || _forceUnregisterOnUnmount) {
                _unregisterField(name, _destroyOnUnmount);
                if (!_this.fieldCounts[name]) {
                  delete _this.fieldValidators[name];
                  delete _this.fieldWarners[name];
                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function(key) {
                    return key !== name;
                  });
                }
              } else {
                _unregisterField(name, false);
              }
            }
          }, _this.getFieldList = function(options) {
            var registeredFields = _this.props.registeredFields;
            var list = [];
            if (!registeredFields) {
              return list;
            }
            var keySeq = keys3(registeredFields);
            if (options && options.excludeFieldArray) {
              keySeq = keySeq.filter(function(name) {
                return getIn3(registeredFields, "['" + name + "'].type") !== "FieldArray";
              });
            }
            return fromJS2(keySeq.reduce(function(acc, key) {
              acc.push(key);
              return acc;
            }, list));
          }, _this.getValidators = function() {
            var validators = {};
            Object.keys(_this.fieldValidators).forEach(function(name) {
              var validator = _this.fieldValidators[name]();
              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          }, _this.generateValidator = function() {
            var validators = _this.getValidators();
            return Object.keys(validators).length ? generateValidator(validators, structure$1) : void 0;
          }, _this.getWarners = function() {
            var warners = {};
            Object.keys(_this.fieldWarners).forEach(function(name) {
              var warner = _this.fieldWarners[name]();
              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          }, _this.generateWarner = function() {
            var warners = _this.getWarners();
            return Object.keys(warners).length ? generateValidator(warners, structure$1) : void 0;
          }, _this.asyncValidate = function(name, value, trigger) {
            var _this$props2 = _this.props, asyncBlurFields = _this$props2.asyncBlurFields, asyncChangeFields = _this$props2.asyncChangeFields, asyncErrors = _this$props2.asyncErrors, asyncValidate = _this$props2.asyncValidate, dispatch = _this$props2.dispatch, initialized = _this$props2.initialized, pristine = _this$props2.pristine, shouldAsyncValidate = _this$props2.shouldAsyncValidate, startAsyncValidation3 = _this$props2.startAsyncValidation, stopAsyncValidation3 = _this$props2.stopAsyncValidation, syncErrors = _this$props2.syncErrors, values = _this$props2.values;
            var submitting = !name;
            var fieldNeedsValidation = function fieldNeedsValidation2() {
              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, "[]"));
              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+\]/g, "[]"));
              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);
              return submitting || asyncValidateByDefault || (trigger === "blur" ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
            };
            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn3(values, name, value);
              var syncValidationPasses = submitting || !getIn3(syncErrors, name);
              if (fieldNeedsValidation() && shouldAsyncValidate({
                asyncErrors,
                initialized,
                trigger: submitting ? "submit" : trigger,
                blurredField: name,
                pristine,
                syncValidationPasses
              })) {
                return asyncValidation(function() {
                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                }, startAsyncValidation3, stopAsyncValidation3, name);
              }
            }
          }, _this.submitCompleted = function(result) {
            delete _this.submitPromise;
            return result;
          }, _this.submitFailed = function(error) {
            delete _this.submitPromise;
            throw error;
          }, _this.listenToSubmit = function(promise) {
            if (!isPromise(promise)) {
              return promise;
            }
            _this.submitPromise = promise;
            return promise.then(_this.submitCompleted, _this.submitFailed);
          }, _this.submit = function(submitOrEvent) {
            var _this$props3 = _this.props, onSubmit = _this$props3.onSubmit, blur3 = _this$props3.blur, change3 = _this$props3.change, dispatch = _this$props3.dispatch;
            if (!submitOrEvent || silenceEvent(submitOrEvent)) {
              if (!_this.submitPromise) {
                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
                  return _this.innerOnSubmit();
                } else {
                  return _this.listenToSubmit(handleSubmit(checkSubmit(onSubmit), _extends({}, _this.props, bindActionCreators({ blur: blur3, change: change3 }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
                }
              }
            } else {
              return silenceEvents(function() {
                return !_this.submitPromise && _this.listenToSubmit(handleSubmit(checkSubmit(submitOrEvent), _extends({}, _this.props, bindActionCreators({ blur: blur3, change: change3 }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
              });
            }
          }, _this.reset = function() {
            return _this.props.reset();
          }, _this.saveRef = function(ref) {
            _this.wrapped = ref;
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Form3, [{
          key: "getChildContext",
          value: function getChildContext() {
            var _this2 = this;
            return {
              _reduxForm: _extends({}, this.props, {
                getFormState: function getFormState(state) {
                  return getIn3(_this2.props.getFormState(state), _this2.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: void 0,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                  return _this2.innerOnSubmit = innerOnSubmit;
                }
              })
            };
          }
        }, {
          key: "initIfNeeded",
          value: function initIfNeeded(nextProps) {
            var enableReinitialize = this.props.enableReinitialize;
            if (nextProps) {
              if ((enableReinitialize || !nextProps.initialized) && !deepEqual3(this.props.initialValues, nextProps.initialValues)) {
                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(nextProps.initialValues, _keepDirty, {
                  keepValues: nextProps.keepValues,
                  lastInitialValues: this.props.initialValues,
                  updateUnregisteredFields: nextProps.updateUnregisteredFields
                });
              }
            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
                keepValues: this.props.keepValues,
                updateUnregisteredFields: this.props.updateUnregisteredFields
              });
            }
          }
        }, {
          key: "updateSyncErrorsIfNeeded",
          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
            var _props = this.props, error = _props.error, updateSyncErrors3 = _props.updateSyncErrors;
            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
            if (!(noErrors && nextNoErrors) && (!structure.deepEqual(lastSyncErrors, nextSyncErrors) || !structure.deepEqual(error, nextError))) {
              updateSyncErrors3(nextSyncErrors, nextError);
            }
          }
        }, {
          key: "clearSubmitPromiseIfNeeded",
          value: function clearSubmitPromiseIfNeeded(nextProps) {
            var submitting = this.props.submitting;
            if (this.submitPromise && submitting && !nextProps.submitting) {
              delete this.submitPromise;
            }
          }
        }, {
          key: "submitIfNeeded",
          value: function submitIfNeeded(nextProps) {
            var _props2 = this.props, clearSubmit3 = _props2.clearSubmit, triggerSubmit = _props2.triggerSubmit;
            if (!triggerSubmit && nextProps.triggerSubmit) {
              clearSubmit3();
              this.submit();
            }
          }
        }, {
          key: "shouldErrorFunction",
          value: function shouldErrorFunction() {
            var _props3 = this.props, shouldValidate = _props3.shouldValidate, shouldError = _props3.shouldError;
            var shouldValidateOverridden = shouldValidate !== defaultShouldValidate;
            var shouldErrorOverridden = shouldError !== defaultShouldError;
            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
          }
        }, {
          key: "validateIfNeeded",
          value: function validateIfNeeded(nextProps) {
            var _props4 = this.props, validate = _props4.validate, values = _props4.values;
            var shouldError = this.shouldErrorFunction();
            var fieldLevelValidate = this.generateValidator();
            if (validate || fieldLevelValidate) {
              var initialRender = nextProps === void 0;
              var fieldValidatorKeys = Object.keys(this.getValidators());
              var validateParams = {
                values,
                nextProps,
                props: this.props,
                initialRender,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys,
                structure: structure$1
              };
              if (shouldError(validateParams)) {
                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;
                var _merge2 = merge(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}), _error = _merge2._error, nextSyncErrors = _objectWithoutProperties$1(_merge2, ["_error"]);
                this.lastFieldValidatorKeys = fieldValidatorKeys;
                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
              }
            } else {
              this.lastFieldValidatorKeys = [];
            }
          }
        }, {
          key: "updateSyncWarningsIfNeeded",
          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
            var _props5 = this.props, warning2 = _props5.warning, syncWarnings = _props5.syncWarnings, updateSyncWarnings3 = _props5.updateSyncWarnings;
            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning2;
            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
            if (!(noWarnings && nextNoWarnings) && (!structure.deepEqual(lastSyncWarnings, nextSyncWarnings) || !structure.deepEqual(warning2, nextWarning))) {
              updateSyncWarnings3(nextSyncWarnings, nextWarning);
            }
          }
        }, {
          key: "shouldWarnFunction",
          value: function shouldWarnFunction() {
            var _props6 = this.props, shouldValidate = _props6.shouldValidate, shouldWarn = _props6.shouldWarn;
            var shouldValidateOverridden = shouldValidate !== defaultShouldValidate;
            var shouldWarnOverridden = shouldWarn !== defaultShouldWarn;
            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
          }
        }, {
          key: "warnIfNeeded",
          value: function warnIfNeeded(nextProps) {
            var _props7 = this.props, warn = _props7.warn, values = _props7.values;
            var shouldWarn = this.shouldWarnFunction();
            var fieldLevelWarn = this.generateWarner();
            if (warn || fieldLevelWarn) {
              var initialRender = nextProps === void 0;
              var fieldWarnerKeys = Object.keys(this.getWarners());
              var validateParams = {
                values,
                nextProps,
                props: this.props,
                initialRender,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: fieldWarnerKeys,
                structure: structure$1
              };
              if (shouldWarn(validateParams)) {
                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;
                var _merge3 = merge(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}), _warning = _merge3._warning, nextSyncWarnings = _objectWithoutProperties$1(_merge3, ["_warning"]);
                this.lastFieldWarnerKeys = fieldWarnerKeys;
                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
              }
            }
          }
        }, {
          key: "componentWillMount",
          value: function componentWillMount2() {
            if (!isHotReloading()) {
              this.initIfNeeded();
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            invariant(this.props.shouldValidate, "shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.");
          }
        }, {
          key: "componentWillReceiveProps",
          value: function componentWillReceiveProps2(nextProps) {
            this.initIfNeeded(nextProps);
            this.validateIfNeeded(nextProps);
            this.warnIfNeeded(nextProps);
            this.clearSubmitPromiseIfNeeded(nextProps);
            this.submitIfNeeded(nextProps);
            var onChange = nextProps.onChange, values = nextProps.values, dispatch = nextProps.dispatch;
            if (onChange && !deepEqual3(values, this.props.values)) {
              onChange(values, dispatch, nextProps, this.props.values);
            }
          }
        }, {
          key: "shouldComponentUpdate",
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;
            if (!this.props.pure) return true;
            var _config$immutableProp = config.immutableProps, immutableProps = _config$immutableProp === void 0 ? [] : _config$immutableProp;
            return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function(prop) {
              if (~immutableProps.indexOf(prop)) {
                return _this3.props[prop] !== nextProps[prop];
              }
              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual3(_this3.props[prop], nextProps[prop]);
            }));
          }
        }, {
          key: "componentDidMount",
          value: function componentDidMount() {
            if (!isHotReloading()) {
              this.initIfNeeded(this.props);
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            invariant(this.props.shouldValidate, "shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.");
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            var _props8 = this.props, destroyOnUnmount = _props8.destroyOnUnmount, destroy3 = _props8.destroy;
            if (destroyOnUnmount && !isHotReloading()) {
              this.destroyed = true;
              destroy3();
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _props9 = this.props, anyTouched = _props9.anyTouched, array = _props9.array;
            _props9.arrayInsert;
            _props9.arrayMove;
            _props9.arrayPop;
            _props9.arrayPush;
            _props9.arrayRemove;
            _props9.arrayRemoveAll;
            _props9.arrayShift;
            _props9.arraySplice;
            _props9.arraySwap;
            _props9.arrayUnshift;
            _props9.asyncErrors;
            _props9.asyncValidate;
            var asyncValidating = _props9.asyncValidating, blur3 = _props9.blur, change3 = _props9.change, clearSubmit3 = _props9.clearSubmit, destroy3 = _props9.destroy;
            _props9.destroyOnUnmount;
            _props9.forceUnregisterOnUnmount;
            var dirty = _props9.dirty, dispatch = _props9.dispatch;
            _props9.enableReinitialize;
            var error = _props9.error;
            _props9.focus;
            var form2 = _props9.form;
            _props9.getFormState;
            _props9.immutableProps;
            var initialize3 = _props9.initialize, initialized = _props9.initialized, initialValues = _props9.initialValues, invalid = _props9.invalid;
            _props9.keepDirtyOnReinitialize;
            _props9.keepValues;
            _props9.updateUnregisteredFields;
            var pristine = _props9.pristine, propNamespace = _props9.propNamespace;
            _props9.registeredFields;
            _props9.registerField;
            var reset3 = _props9.reset, resetSection3 = _props9.resetSection;
            _props9.setSubmitFailed;
            _props9.setSubmitSucceeded;
            _props9.shouldAsyncValidate;
            _props9.shouldValidate;
            _props9.shouldError;
            _props9.shouldWarn;
            _props9.startAsyncValidation;
            _props9.startSubmit;
            _props9.stopAsyncValidation;
            _props9.stopSubmit;
            var submitting = _props9.submitting, submitFailed = _props9.submitFailed, submitSucceeded = _props9.submitSucceeded, touch3 = _props9.touch;
            _props9.touchOnBlur;
            _props9.touchOnChange;
            _props9.persistentSubmitErrors;
            _props9.syncErrors;
            _props9.syncWarnings;
            _props9.unregisterField;
            var untouch3 = _props9.untouch;
            _props9.updateSyncErrors;
            _props9.updateSyncWarnings;
            var valid = _props9.valid;
            _props9.validExceptSubmit;
            _props9.values;
            var warning2 = _props9.warning, rest = _objectWithoutProperties$1(_props9, ["anyTouched", "array", "arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncErrors", "asyncValidate", "asyncValidating", "blur", "change", "clearSubmit", "destroy", "destroyOnUnmount", "forceUnregisterOnUnmount", "dirty", "dispatch", "enableReinitialize", "error", "focus", "form", "getFormState", "immutableProps", "initialize", "initialized", "initialValues", "invalid", "keepDirtyOnReinitialize", "keepValues", "updateUnregisteredFields", "pristine", "propNamespace", "registeredFields", "registerField", "reset", "resetSection", "setSubmitFailed", "setSubmitSucceeded", "shouldAsyncValidate", "shouldValidate", "shouldError", "shouldWarn", "startAsyncValidation", "startSubmit", "stopAsyncValidation", "stopSubmit", "submitting", "submitFailed", "submitSucceeded", "touch", "touchOnBlur", "touchOnChange", "persistentSubmitErrors", "syncErrors", "syncWarnings", "unregisterField", "untouch", "updateSyncErrors", "updateSyncWarnings", "valid", "validExceptSubmit", "values", "warning"]);
            var reduxFormProps = _extends({
              array,
              anyTouched,
              asyncValidate: this.asyncValidate,
              asyncValidating
            }, bindActionCreators({ blur: blur3, change: change3 }, dispatch), {
              clearSubmit: clearSubmit3,
              destroy: destroy3,
              dirty,
              dispatch,
              error,
              form: form2,
              handleSubmit: this.submit,
              initialize: initialize3,
              initialized,
              initialValues,
              invalid,
              pristine,
              reset: reset3,
              resetSection: resetSection3,
              submitting,
              submitFailed,
              submitSucceeded,
              touch: touch3,
              untouch: untouch3,
              valid,
              warning: warning2
            });
            var propsToPass = _extends({}, propNamespace ? _defineProperty$1({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
            if (isClassComponent(WrappedComponent)) {
              propsToPass.ref = this.saveRef;
            }
            return createElement$2(WrappedComponent, propsToPass);
          }
        }]);
        return Form3;
      })(Component);
      Form2.displayName = "Form(" + getDisplayName(WrappedComponent) + ")";
      Form2.WrappedComponent = WrappedComponent;
      Form2.childContextTypes = {
        _reduxForm: PropTypes.object.isRequired
      };
      Form2.propTypes = {
        destroyOnUnmount: PropTypes.bool,
        forceUnregisterOnUnmount: PropTypes.bool,
        form: PropTypes.string.isRequired,
        immutableProps: PropTypes.arrayOf(PropTypes.string),
        initialValues: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        getFormState: PropTypes.func,
        onSubmitFail: PropTypes.func,
        onSubmitSuccess: PropTypes.func,
        propNamespace: PropTypes.string,
        validate: PropTypes.func,
        warn: PropTypes.func,
        touchOnBlur: PropTypes.bool,
        touchOnChange: PropTypes.bool,
        triggerSubmit: PropTypes.bool,
        persistentSubmitErrors: PropTypes.bool,
        registeredFields: PropTypes.any
      };
      var connector = connect(function(state, props) {
        var form2 = props.form, getFormState = props.getFormState, initialValues = props.initialValues, enableReinitialize = props.enableReinitialize, keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
        var formState = getIn3(getFormState(state) || empty2, form2) || empty2;
        var stateInitial = getIn3(formState, "initial");
        var initialized = !!stateInitial;
        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual3(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
        var initial = initialValues || stateInitial || empty2;
        if (shouldUpdateInitialValues) {
          initial = stateInitial || empty2;
        }
        var values = getIn3(formState, "values") || initial;
        if (shouldResetValues) {
          values = initial;
        }
        var pristine = shouldResetValues || deepEqual3(initial, values);
        var asyncErrors = getIn3(formState, "asyncErrors");
        var syncErrors = getIn3(formState, "syncErrors") || structure.empty;
        var syncWarnings = getIn3(formState, "syncWarnings") || structure.empty;
        var registeredFields = getIn3(formState, "registeredFields");
        var valid = isValid2(form2, getFormState, false)(state);
        var validExceptSubmit = isValid2(form2, getFormState, true)(state);
        var anyTouched = !!getIn3(formState, "anyTouched");
        var submitting = !!getIn3(formState, "submitting");
        var submitFailed = !!getIn3(formState, "submitFailed");
        var submitSucceeded = !!getIn3(formState, "submitSucceeded");
        var error = getIn3(formState, "error");
        var warning2 = getIn3(formState, "warning");
        var triggerSubmit = getIn3(formState, "triggerSubmit");
        return {
          anyTouched,
          asyncErrors,
          asyncValidating: getIn3(formState, "asyncValidating") || false,
          dirty: !pristine,
          error,
          initialized,
          invalid: !valid,
          pristine,
          registeredFields,
          submitting,
          submitFailed,
          submitSucceeded,
          syncErrors,
          syncWarnings,
          triggerSubmit,
          values,
          valid,
          validExceptSubmit,
          warning: warning2
        };
      }, function(dispatch, initialProps) {
        var bindForm = function bindForm2(actionCreator) {
          return actionCreator.bind(null, initialProps.form);
        };
        var boundFormACs = mapValues(formActions, bindForm);
        var boundArrayACs = mapValues(arrayActions, bindForm);
        var boundBlur = function boundBlur2(field, value) {
          return blur2(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };
        var boundChange = function boundChange2(field, value) {
          return change$1(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };
        var boundFocus = bindForm(focus2);
        var connectedFormACs = bindActionCreators(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: bindActionCreators(boundArrayACs.arrayInsert, dispatch),
          move: bindActionCreators(boundArrayACs.arrayMove, dispatch),
          pop: bindActionCreators(boundArrayACs.arrayPop, dispatch),
          push: bindActionCreators(boundArrayACs.arrayPush, dispatch),
          remove: bindActionCreators(boundArrayACs.arrayRemove, dispatch),
          removeAll: bindActionCreators(boundArrayACs.arrayRemoveAll, dispatch),
          shift: bindActionCreators(boundArrayACs.arrayShift, dispatch),
          splice: bindActionCreators(boundArrayACs.arraySplice, dispatch),
          swap: bindActionCreators(boundArrayACs.arraySwap, dispatch),
          unshift: bindActionCreators(boundArrayACs.arrayUnshift, dispatch)
        };
        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch
        });
        return function() {
          return computedActions;
        };
      }, void 0, { withRef: true });
      var ConnectedForm = hoistStatics(connector(Form2), WrappedComponent);
      ConnectedForm.defaultProps = config;
      var ReduxForm = (function(_Component2) {
        _inherits(ReduxForm2, _Component2);
        function ReduxForm2() {
          _classCallCheck(this, ReduxForm2);
          return _possibleConstructorReturn(this, (ReduxForm2.__proto__ || Object.getPrototypeOf(ReduxForm2)).apply(this, arguments));
        }
        _createClass(ReduxForm2, [{
          key: "submit",
          value: function submit3() {
            return this.ref && this.ref.getWrappedInstance().submit();
          }
        }, {
          key: "reset",
          value: function reset3() {
            if (this.ref) {
              this.ref.getWrappedInstance().reset();
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _this5 = this;
            var _props10 = this.props, initialValues = _props10.initialValues, rest = _objectWithoutProperties$1(_props10, ["initialValues"]);
            return createElement$2(ConnectedForm, _extends({}, rest, {
              ref: function ref(_ref3) {
                _this5.ref = _ref3;
              },
              // convert initialValues if need to
              initialValues: fromJS2(initialValues)
            }));
          }
        }, {
          key: "valid",
          get: function get3() {
            return !!(this.ref && this.ref.getWrappedInstance().isValid());
          }
        }, {
          key: "invalid",
          get: function get3() {
            return !this.valid;
          }
        }, {
          key: "pristine",
          get: function get3() {
            return !!(this.ref && this.ref.getWrappedInstance().isPristine());
          }
        }, {
          key: "dirty",
          get: function get3() {
            return !this.pristine;
          }
        }, {
          key: "values",
          get: function get3() {
            return this.ref ? this.ref.getWrappedInstance().getValues() : empty2;
          }
        }, {
          key: "fieldList",
          get: function get3() {
            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
          }
        }, {
          key: "wrappedInstance",
          get: function get3() {
            return this.ref && this.ref.getWrappedInstance().wrapped;
          }
        }]);
        return ReduxForm2;
      })(Component);
      polyfill(ReduxForm);
      return hoistStatics(ReduxForm, WrappedComponent);
    };
  };
};
const reduxForm = createReduxForm(structure);
function createDeleteInWithCleanUp(structure2) {
  var shouldDeleteDefault = function shouldDeleteDefault2(structure3) {
    return function(state, path) {
      return structure3.getIn(state, path) !== void 0;
    };
  };
  var deepEqual3 = structure2.deepEqual, empty2 = structure2.empty, getIn3 = structure2.getIn, deleteIn3 = structure2.deleteIn, setIn3 = structure2.setIn;
  return function() {
    var shouldDelete3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : shouldDeleteDefault;
    var deleteInWithCleanUp = function deleteInWithCleanUp2(state, path) {
      if (path[path.length - 1] === "]") {
        var pathTokens = toPath(path);
        pathTokens.pop();
        var parent = getIn3(state, pathTokens.join("."));
        return parent ? setIn3(state, path) : state;
      }
      var result = state;
      if (shouldDelete3(structure2)(state, path)) {
        result = deleteIn3(state, path);
      }
      var dotIndex = path.lastIndexOf(".");
      if (dotIndex > 0) {
        var parentPath = path.substring(0, dotIndex);
        if (parentPath[parentPath.length - 1] !== "]") {
          var _parent = getIn3(result, parentPath);
          if (deepEqual3(_parent, empty2)) {
            return deleteInWithCleanUp2(result, parentPath);
          }
        }
      }
      return result;
    };
    return deleteInWithCleanUp;
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(obj, keys3) {
  var target = {};
  for (var i in obj) {
    if (keys3.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var shouldDelete = function shouldDelete2(_ref) {
  var getIn3 = _ref.getIn;
  return function(state, path) {
    var initialValuesPath = null;
    if (path.startsWith("values")) {
      initialValuesPath = path.replace("values", "initial");
    }
    var initialValueComparison = initialValuesPath ? getIn3(state, initialValuesPath) === void 0 : true;
    return getIn3(state, path) !== void 0 && initialValueComparison;
  };
};
var isReduxFormAction = function isReduxFormAction2(action) {
  return action && action.type && action.type.length > prefix.length && action.type.substring(0, prefix.length) === prefix;
};
function createReducer(structure$1) {
  var _behaviors;
  var deepEqual3 = structure$1.deepEqual, empty2 = structure$1.empty, forEach2 = structure$1.forEach, getIn3 = structure$1.getIn, setIn3 = structure$1.setIn, deleteIn3 = structure$1.deleteIn, fromJS2 = structure$1.fromJS, keys3 = structure$1.keys, size2 = structure$1.size, some2 = structure$1.some, splice3 = structure$1.splice;
  var deleteInWithCleanUp = createDeleteInWithCleanUp(structure$1)(shouldDelete);
  var plainDeleteInWithCleanUp = createDeleteInWithCleanUp(structure)(shouldDelete);
  var doSplice = function doSplice2(state, key, field, index2, removeNum, value, force) {
    var existing = getIn3(state, key + "." + field);
    return existing || force ? setIn3(state, key + "." + field, splice3(existing, index2, removeNum, value)) : state;
  };
  var doPlainSplice = function doPlainSplice2(state, key, field, index2, removeNum, value, force) {
    var slice = getIn3(state, key);
    var existing = structure.getIn(slice, field);
    return existing || force ? setIn3(state, key, structure.setIn(slice, field, structure.splice(existing, index2, removeNum, value))) : state;
  };
  var rootKeys = ["values", "fields", "submitErrors", "asyncErrors"];
  var arraySplice3 = function arraySplice4(state, field, index2, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty2 : void 0;
    result = doSplice(result, "values", field, index2, removeNum, value, true);
    result = doSplice(result, "fields", field, index2, removeNum, nonValuesValue);
    result = doPlainSplice(result, "syncErrors", field, index2, removeNum, void 0);
    result = doPlainSplice(result, "syncWarnings", field, index2, removeNum, void 0);
    result = doSplice(result, "submitErrors", field, index2, removeNum, void 0);
    result = doSplice(result, "asyncErrors", field, index2, removeNum, void 0);
    return result;
  };
  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, ARRAY_INSERT, function(state, _ref2) {
    var _ref2$meta = _ref2.meta, field = _ref2$meta.field, index2 = _ref2$meta.index, payload = _ref2.payload;
    return arraySplice3(state, field, index2, 0, payload);
  }), _defineProperty(_behaviors, ARRAY_MOVE, function(state, _ref3) {
    var _ref3$meta = _ref3.meta, field = _ref3$meta.field, from = _ref3$meta.from, to = _ref3$meta.to;
    var array = getIn3(state, "values." + field);
    var length = array ? size2(array) : 0;
    var result = state;
    if (length) {
      rootKeys.forEach(function(key) {
        var path = key + "." + field;
        if (getIn3(result, path)) {
          var value = getIn3(result, path + "[" + from + "]");
          result = setIn3(result, path, splice3(getIn3(result, path), from, 1));
          result = setIn3(result, path, splice3(getIn3(result, path), to, 0, value));
        }
      });
    }
    return result;
  }), _defineProperty(_behaviors, ARRAY_POP, function(state, _ref4) {
    var field = _ref4.meta.field;
    var array = getIn3(state, "values." + field);
    var length = array ? size2(array) : 0;
    return length ? arraySplice3(state, field, length - 1, 1) : state;
  }), _defineProperty(_behaviors, ARRAY_PUSH, function(state, _ref5) {
    var field = _ref5.meta.field, payload = _ref5.payload;
    var array = getIn3(state, "values." + field);
    var length = array ? size2(array) : 0;
    return arraySplice3(state, field, length, 0, payload);
  }), _defineProperty(_behaviors, ARRAY_REMOVE, function(state, _ref6) {
    var _ref6$meta = _ref6.meta, field = _ref6$meta.field, index2 = _ref6$meta.index;
    return arraySplice3(state, field, index2, 1);
  }), _defineProperty(_behaviors, ARRAY_REMOVE_ALL, function(state, _ref7) {
    var field = _ref7.meta.field;
    var array = getIn3(state, "values." + field);
    var length = array ? size2(array) : 0;
    return length ? arraySplice3(state, field, 0, length) : state;
  }), _defineProperty(_behaviors, ARRAY_SHIFT, function(state, _ref8) {
    var field = _ref8.meta.field;
    return arraySplice3(state, field, 0, 1);
  }), _defineProperty(_behaviors, ARRAY_SPLICE, function(state, _ref9) {
    var _ref9$meta = _ref9.meta, field = _ref9$meta.field, index2 = _ref9$meta.index, removeNum = _ref9$meta.removeNum, payload = _ref9.payload;
    return arraySplice3(state, field, index2, removeNum, payload);
  }), _defineProperty(_behaviors, ARRAY_SWAP, function(state, _ref10) {
    var _ref10$meta = _ref10.meta, field = _ref10$meta.field, indexA = _ref10$meta.indexA, indexB = _ref10$meta.indexB;
    var result = state;
    rootKeys.forEach(function(key) {
      var valueA = getIn3(result, key + "." + field + "[" + indexA + "]");
      var valueB = getIn3(result, key + "." + field + "[" + indexB + "]");
      if (valueA !== void 0 || valueB !== void 0) {
        result = setIn3(result, key + "." + field + "[" + indexA + "]", valueB);
        result = setIn3(result, key + "." + field + "[" + indexB + "]", valueA);
      }
    });
    return result;
  }), _defineProperty(_behaviors, ARRAY_UNSHIFT, function(state, _ref11) {
    var field = _ref11.meta.field, payload = _ref11.payload;
    return arraySplice3(state, field, 0, 0, payload);
  }), _defineProperty(_behaviors, AUTOFILL, function(state, _ref12) {
    var field = _ref12.meta.field, payload = _ref12.payload;
    var result = state;
    result = deleteInWithCleanUp(result, "asyncErrors." + field);
    result = deleteInWithCleanUp(result, "submitErrors." + field);
    result = setIn3(result, "fields." + field + ".autofilled", true);
    result = setIn3(result, "values." + field, payload);
    return result;
  }), _defineProperty(_behaviors, BLUR, function(state, _ref13) {
    var _ref13$meta = _ref13.meta, field = _ref13$meta.field, touch3 = _ref13$meta.touch, payload = _ref13.payload;
    var result = state;
    var initial = getIn3(result, "initial." + field);
    if (initial === void 0 && payload === "") {
      result = deleteInWithCleanUp(result, "values." + field);
    } else if (payload !== void 0) {
      result = setIn3(result, "values." + field, payload);
    }
    if (field === getIn3(result, "active")) {
      result = deleteIn3(result, "active");
    }
    result = deleteIn3(result, "fields." + field + ".active");
    if (touch3) {
      result = setIn3(result, "fields." + field + ".touched", true);
      result = setIn3(result, "anyTouched", true);
    }
    return result;
  }), _defineProperty(_behaviors, CHANGE, function(state, _ref14) {
    var _ref14$meta = _ref14.meta, field = _ref14$meta.field, touch3 = _ref14$meta.touch, persistentSubmitErrors = _ref14$meta.persistentSubmitErrors, payload = _ref14.payload;
    var result = state;
    var initial = getIn3(result, "initial." + field);
    if (initial === void 0 && payload === "") {
      result = deleteInWithCleanUp(result, "values." + field);
    } else if (payload !== void 0) {
      result = setIn3(result, "values." + field, payload);
    }
    result = deleteInWithCleanUp(result, "asyncErrors." + field);
    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, "submitErrors." + field);
    }
    result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");
    if (touch3) {
      result = setIn3(result, "fields." + field + ".touched", true);
      result = setIn3(result, "anyTouched", true);
    }
    return result;
  }), _defineProperty(_behaviors, CLEAR_SUBMIT, function(state) {
    return deleteIn3(state, "triggerSubmit");
  }), _defineProperty(_behaviors, CLEAR_SUBMIT_ERRORS, function(state) {
    var result = state;
    result = deleteInWithCleanUp(result, "submitErrors");
    result = deleteIn3(result, "error");
    return result;
  }), _defineProperty(_behaviors, CLEAR_ASYNC_ERROR, function(state, _ref15) {
    var field = _ref15.meta.field;
    return deleteIn3(state, "asyncErrors." + field);
  }), _defineProperty(_behaviors, CLEAR_FIELDS, function(state, _ref16) {
    var _ref16$meta = _ref16.meta, keepTouched = _ref16$meta.keepTouched, persistentSubmitErrors = _ref16$meta.persistentSubmitErrors, fields = _ref16$meta.fields;
    var result = state;
    fields.forEach(function(field) {
      result = deleteInWithCleanUp(result, "values." + field);
      result = deleteInWithCleanUp(result, "asyncErrors." + field);
      if (!persistentSubmitErrors) {
        result = deleteInWithCleanUp(result, "submitErrors." + field);
      }
      result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");
      if (!keepTouched) {
        result = deleteIn3(result, "fields." + field + ".touched");
      }
    });
    var anyTouched = some2(keys3(getIn3(result, "registeredFields")), function(key) {
      return getIn3(result, "fields." + key + ".touched");
    });
    result = anyTouched ? setIn3(result, "anyTouched", true) : deleteIn3(result, "anyTouched");
    return result;
  }), _defineProperty(_behaviors, FOCUS, function(state, _ref17) {
    var field = _ref17.meta.field;
    var result = state;
    var previouslyActive = getIn3(state, "active");
    result = deleteIn3(result, "fields." + previouslyActive + ".active");
    result = setIn3(result, "fields." + field + ".visited", true);
    result = setIn3(result, "fields." + field + ".active", true);
    result = setIn3(result, "active", field);
    return result;
  }), _defineProperty(_behaviors, INITIALIZE, function(state, _ref18) {
    var payload = _ref18.payload, _ref18$meta = _ref18.meta, keepDirty = _ref18$meta.keepDirty, keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded, updateUnregisteredFields = _ref18$meta.updateUnregisteredFields, keepValues = _ref18$meta.keepValues;
    var mapData = fromJS2(payload);
    var result = empty2;
    var warning2 = getIn3(state, "warning");
    if (warning2) {
      result = setIn3(result, "warning", warning2);
    }
    var syncWarnings = getIn3(state, "syncWarnings");
    if (syncWarnings) {
      result = setIn3(result, "syncWarnings", syncWarnings);
    }
    var error = getIn3(state, "error");
    if (error) {
      result = setIn3(result, "error", error);
    }
    var syncErrors = getIn3(state, "syncErrors");
    if (syncErrors) {
      result = setIn3(result, "syncErrors", syncErrors);
    }
    var registeredFields = getIn3(state, "registeredFields");
    if (registeredFields) {
      result = setIn3(result, "registeredFields", registeredFields);
    }
    var previousValues = getIn3(state, "values");
    var previousInitialValues = getIn3(state, "initial");
    var newInitialValues = mapData;
    var newValues = previousValues;
    if (keepDirty && registeredFields) {
      if (!deepEqual3(newInitialValues, previousInitialValues)) {
        var overwritePristineValue = function overwritePristineValue2(name) {
          var previousInitialValue = getIn3(previousInitialValues, name);
          var previousValue = getIn3(previousValues, name);
          if (deepEqual3(previousValue, previousInitialValue)) {
            var newInitialValue = getIn3(newInitialValues, name);
            if (getIn3(newValues, name) !== newInitialValue) {
              newValues = setIn3(newValues, name, newInitialValue);
            }
          }
        };
        if (!updateUnregisteredFields) {
          forEach2(keys3(registeredFields), function(name) {
            return overwritePristineValue(name);
          });
        }
        forEach2(keys3(newInitialValues), function(name) {
          var previousInitialValue = getIn3(previousInitialValues, name);
          if (typeof previousInitialValue === "undefined") {
            var newInitialValue = getIn3(newInitialValues, name);
            newValues = setIn3(newValues, name, newInitialValue);
          }
          if (updateUnregisteredFields) {
            overwritePristineValue(name);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }
    if (keepValues) {
      forEach2(keys3(previousValues), function(name) {
        var previousValue = getIn3(previousValues, name);
        newValues = setIn3(newValues, name, previousValue);
      });
      forEach2(keys3(previousInitialValues), function(name) {
        var previousInitialValue = getIn3(previousInitialValues, name);
        newInitialValues = setIn3(newInitialValues, name, previousInitialValue);
      });
    }
    if (keepSubmitSucceeded && getIn3(state, "submitSucceeded")) {
      result = setIn3(result, "submitSucceeded", true);
    }
    result = setIn3(result, "values", newValues);
    result = setIn3(result, "initial", newInitialValues);
    return result;
  }), _defineProperty(_behaviors, REGISTER_FIELD, function(state, _ref19) {
    var _ref19$payload = _ref19.payload, name = _ref19$payload.name, type = _ref19$payload.type;
    var key = "registeredFields['" + name + "']";
    var field = getIn3(state, key);
    if (field) {
      var count = getIn3(field, "count") + 1;
      field = setIn3(field, "count", count);
    } else {
      field = fromJS2({ name, type, count: 1 });
    }
    return setIn3(state, key, field);
  }), _defineProperty(_behaviors, RESET, function(state) {
    var result = empty2;
    var registeredFields = getIn3(state, "registeredFields");
    if (registeredFields) {
      result = setIn3(result, "registeredFields", registeredFields);
    }
    var values = getIn3(state, "initial");
    if (values) {
      result = setIn3(result, "values", values);
      result = setIn3(result, "initial", values);
    }
    return result;
  }), _defineProperty(_behaviors, RESET_SECTION, function(state, _ref20) {
    var sections = _ref20.meta.sections;
    var result = state;
    sections.forEach(function(section) {
      result = deleteInWithCleanUp(result, "asyncErrors." + section);
      result = deleteInWithCleanUp(result, "submitErrors." + section);
      result = deleteInWithCleanUp(result, "fields." + section);
      var values = getIn3(state, "initial." + section);
      result = values ? setIn3(result, "values." + section, values) : deleteInWithCleanUp(result, "values." + section);
    });
    var anyTouched = some2(keys3(getIn3(result, "registeredFields")), function(key) {
      return getIn3(result, "fields." + key + ".touched");
    });
    result = anyTouched ? setIn3(result, "anyTouched", true) : deleteIn3(result, "anyTouched");
    return result;
  }), _defineProperty(_behaviors, SUBMIT, function(state) {
    return setIn3(state, "triggerSubmit", true);
  }), _defineProperty(_behaviors, START_ASYNC_VALIDATION, function(state, _ref21) {
    var field = _ref21.meta.field;
    return setIn3(state, "asyncValidating", field || true);
  }), _defineProperty(_behaviors, START_SUBMIT, function(state) {
    return setIn3(state, "submitting", true);
  }), _defineProperty(_behaviors, STOP_ASYNC_VALIDATION, function(state, _ref22) {
    var payload = _ref22.payload;
    var result = state;
    result = deleteIn3(result, "asyncValidating");
    if (payload && Object.keys(payload).length) {
      var _error = payload._error, fieldErrors = _objectWithoutProperties(payload, ["_error"]);
      if (_error) {
        result = setIn3(result, "error", _error);
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn3(result, "asyncErrors", fromJS2(fieldErrors));
      }
    } else {
      result = deleteIn3(result, "error");
      result = deleteIn3(result, "asyncErrors");
    }
    return result;
  }), _defineProperty(_behaviors, STOP_SUBMIT, function(state, _ref23) {
    var payload = _ref23.payload;
    var result = state;
    result = deleteIn3(result, "submitting");
    result = deleteIn3(result, "submitFailed");
    result = deleteIn3(result, "submitSucceeded");
    if (payload && Object.keys(payload).length) {
      var _error = payload._error, fieldErrors = _objectWithoutProperties(payload, ["_error"]);
      if (_error) {
        result = setIn3(result, "error", _error);
      } else {
        result = deleteIn3(result, "error");
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn3(result, "submitErrors", fromJS2(fieldErrors));
      } else {
        result = deleteIn3(result, "submitErrors");
      }
      result = setIn3(result, "submitFailed", true);
    } else {
      result = deleteIn3(result, "error");
      result = deleteIn3(result, "submitErrors");
    }
    return result;
  }), _defineProperty(_behaviors, SET_SUBMIT_FAILED, function(state, _ref24) {
    var fields = _ref24.meta.fields;
    var result = state;
    result = setIn3(result, "submitFailed", true);
    result = deleteIn3(result, "submitSucceeded");
    result = deleteIn3(result, "submitting");
    fields.forEach(function(field) {
      return result = setIn3(result, "fields." + field + ".touched", true);
    });
    if (fields.length) {
      result = setIn3(result, "anyTouched", true);
    }
    return result;
  }), _defineProperty(_behaviors, SET_SUBMIT_SUCCEEDED, function(state) {
    var result = state;
    result = deleteIn3(result, "submitFailed");
    result = setIn3(result, "submitSucceeded", true);
    return result;
  }), _defineProperty(_behaviors, TOUCH, function(state, _ref25) {
    var fields = _ref25.meta.fields;
    var result = state;
    fields.forEach(function(field) {
      return result = setIn3(result, "fields." + field + ".touched", true);
    });
    result = setIn3(result, "anyTouched", true);
    return result;
  }), _defineProperty(_behaviors, UNREGISTER_FIELD, function(state, _ref26) {
    var _ref26$payload = _ref26.payload, name = _ref26$payload.name, destroyOnUnmount = _ref26$payload.destroyOnUnmount;
    var result = state;
    var key = "registeredFields['" + name + "']";
    var field = getIn3(result, key);
    if (!field) {
      return result;
    }
    var count = getIn3(field, "count") - 1;
    if (count <= 0 && destroyOnUnmount) {
      result = deleteIn3(result, key);
      if (deepEqual3(getIn3(result, "registeredFields"), empty2)) {
        result = deleteIn3(result, "registeredFields");
      }
      var syncErrors = getIn3(result, "syncErrors");
      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
        if (structure.deepEqual(syncErrors, structure.empty)) {
          result = deleteIn3(result, "syncErrors");
        } else {
          result = setIn3(result, "syncErrors", syncErrors);
        }
      }
      var syncWarnings = getIn3(result, "syncWarnings");
      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
        if (structure.deepEqual(syncWarnings, structure.empty)) {
          result = deleteIn3(result, "syncWarnings");
        } else {
          result = setIn3(result, "syncWarnings", syncWarnings);
        }
      }
      result = deleteInWithCleanUp(result, "submitErrors." + name);
      result = deleteInWithCleanUp(result, "asyncErrors." + name);
    } else {
      field = setIn3(field, "count", count);
      result = setIn3(result, key, field);
    }
    return result;
  }), _defineProperty(_behaviors, UNTOUCH, function(state, _ref27) {
    var fields = _ref27.meta.fields;
    var result = state;
    fields.forEach(function(field) {
      return result = deleteIn3(result, "fields." + field + ".touched");
    });
    var anyTouched = some2(keys3(getIn3(result, "registeredFields")), function(key) {
      return getIn3(result, "fields." + key + ".touched");
    });
    result = anyTouched ? setIn3(result, "anyTouched", true) : deleteIn3(result, "anyTouched");
    return result;
  }), _defineProperty(_behaviors, UPDATE_SYNC_ERRORS, function(state, _ref28) {
    var _ref28$payload = _ref28.payload, syncErrors = _ref28$payload.syncErrors, error = _ref28$payload.error;
    var result = state;
    if (error) {
      result = setIn3(result, "error", error);
      result = setIn3(result, "syncError", true);
    } else {
      result = deleteIn3(result, "error");
      result = deleteIn3(result, "syncError");
    }
    if (Object.keys(syncErrors).length) {
      result = setIn3(result, "syncErrors", syncErrors);
    } else {
      result = deleteIn3(result, "syncErrors");
    }
    return result;
  }), _defineProperty(_behaviors, UPDATE_SYNC_WARNINGS, function(state, _ref29) {
    var _ref29$payload = _ref29.payload, syncWarnings = _ref29$payload.syncWarnings, warning2 = _ref29$payload.warning;
    var result = state;
    if (warning2) {
      result = setIn3(result, "warning", warning2);
    } else {
      result = deleteIn3(result, "warning");
    }
    if (Object.keys(syncWarnings).length) {
      result = setIn3(result, "syncWarnings", syncWarnings);
    } else {
      result = deleteIn3(result, "syncWarnings");
    }
    return result;
  }), _behaviors);
  var reducer2 = function reducer3() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : empty2;
    var action = arguments[1];
    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };
  var byForm = function byForm2(reducer3) {
    return function() {
      var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : empty2;
      var action = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { type: "NONE" };
      var form2 = action && action.meta && action.meta.form;
      if (!form2 || !isReduxFormAction(action)) {
        return state;
      }
      if (action.type === DESTROY && action.meta && action.meta.form) {
        return action.meta.form.reduce(function(result2, form3) {
          return deleteInWithCleanUp(result2, form3);
        }, state);
      }
      var formState = getIn3(state, form2);
      var result = reducer3(formState, action);
      return result === formState ? state : setIn3(state, form2, result);
    };
  };
  function decorate(target) {
    target.plugin = function(reducers) {
      var _this = this;
      return decorate(function() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : empty2;
        var action = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { type: "NONE" };
        var callPlugin = function callPlugin2(processed2, key) {
          var previousState = getIn3(processed2, key);
          var nextState = reducers[key](previousState, action, getIn3(state, key));
          return nextState !== previousState ? setIn3(processed2, key, nextState) : processed2;
        };
        var processed = _this(state, action);
        var form2 = action && action.meta && action.meta.form;
        if (form2) {
          return reducers[form2] ? callPlugin(processed, form2) : processed;
        } else {
          return Object.keys(reducers).reduce(callPlugin, processed);
        }
      });
    };
    return target;
  }
  return decorate(byForm(reducer2));
}
const form = createReducer(structure);
actions.arrayInsert;
actions.arrayMove;
actions.arrayPop;
actions.arrayPush;
actions.arrayRemove;
actions.arrayRemoveAll;
actions.arrayShift;
actions.arraySplice;
actions.arraySwap;
actions.arrayUnshift;
actions.autofill;
actions.blur;
var change2 = actions.change;
actions.clearAsyncError;
actions.clearFields;
actions.clearSubmitErrors;
actions.destroy;
actions.focus;
var initialize2 = actions.initialize;
actions.registerField;
var reset2 = actions.reset;
actions.resetSection;
actions.setSubmitFailed;
actions.setSubmitSucceeded;
actions.startAsyncValidation;
actions.startSubmit;
actions.stopAsyncValidation;
actions.stopSubmit;
actions.submit;
actions.touch;
actions.unregisterField;
actions.untouch;
actions.updateSyncWarnings;
const createNotification = ({
  title,
  message,
  position,
  type = "bc",
  autoDismiss = 5,
  action = null
}) => ({
  title,
  message,
  level: type,
  position,
  autoDismiss,
  action,
  style: false
});
function createNotificationError(data2) {
  return createNotification({
    position: "bc",
    type: "error",
    autoDismiss: 5,
    ...data2
  });
}
function createNotificationInfo(data2) {
  return createNotification({
    position: "bc",
    type: "info",
    autoDismiss: null,
    ...data2
  });
}
const createReservationErrorNotys = () => createNotificationError({
  title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Error creating the reservation", id: "notification.error.title.reservation" }),
  message: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Please, try again", id: "notification.error.text.reservation" })
});
const createTicketsOutOfRangeNoty = ({ min: min2, max: max2 }) => createNotificationError({
  title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Wrong amount of tickets", id: "notification.error.title.tickets" }),
  message: /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormattedMessage,
    {
      defaultMessage: "The amount of tickets is not allowed. It must be between {min} and {max}",
      id: "notification.error.text.tickets",
      values: { min: min2, max: max2 }
    }
  )
});
const createOneTicketAtLeastNoty = () => createNotificationInfo({
  title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Pick a ticket", id: "notification.error.title.select.tickets" }),
  message: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "There were not tickets selected", id: "notification.error.text.select.tickets" })
});
const createAmountNotAllowedNoty = (total) => createNotificationInfo({
  title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Not allowed", id: "notification.error.title.amount-not-allowed" }),
  message: /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormattedMessage,
    {
      defaultMessage: "No esta permitida la compra a precio {total}",
      id: "notification.error.text.amount-not-allowed",
      values: { total }
    }
  )
});
const createOneEventPerVenueNoty = () => createNotificationInfo({
  title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Error picking the event", id: "notification.error.title.events" }),
  message: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Still remain events to select", id: "notification.error.text.events" })
});
const createPreventMultiReservationNoty = () => createNotificationInfo({
  title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Error creating the reservation", id: "notification.error.title.reservation" }),
  message: /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormattedMessage,
    {
      defaultMessage: "This product only can be purchased once",
      id: "notification.error.text.preventMultiReservation"
    }
  )
});
const createVerifyLoyaltyNoty = () => createNotificationInfo({
  title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Error verifying Loyalty User", id: "notification.error.title.verifyLoyaltyUser" }),
  message: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Error verifying loyalty user", id: "notification.error.text.verifyLoyaltyUser" })
});
const createAddLoyaltyNoty = () => createNotificationInfo({
  title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Error verifying Loyalty User", id: "notification.error.title.verifyLoyaltyUser" }),
  message: /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormattedMessage,
    {
      defaultMessage: "The current reservation has buyer types that must be assigned to a loyalty user",
      id: "notification.error.text.mustAddLoyalty"
    }
  )
});
const createUncompleteForm = () => createNotificationError({
  title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Error at form", id: "notification.error.title.form" }),
  message: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "There are required fields to fill", id: "notification.error.text.form" })
});
function getMinMaxTickets(salesGroup = {}, product = {}, eventList = []) {
  let { minTickets, maxTickets = Number.MAX_VALUE } = salesGroup;
  const { minTickets: minTicketsProduct = 0, maxTickets: maxTicketsProduct = Number.MAX_VALUE } = product;
  const { maxTickets: maxTicketsEvents } = eventList.reduce(
    (acc, event) => {
      if (acc.maxTickets < event.totalAvailability) {
        return acc;
      }
      return {
        maxTickets: event.totalAvailability || Number.MAX_VALUE
      };
    },
    {
      maxTickets: Number.MAX_VALUE
    }
  );
  if (minTicketsProduct) {
    minTickets = minTicketsProduct;
  }
  if (maxTicketsProduct && maxTicketsProduct !== Number.MAX_VALUE) {
    maxTickets = maxTicketsProduct;
  }
  return {
    minTickets,
    maxTickets: Math.min(maxTickets, maxTicketsEvents),
    maxTicketsBySalesGroup: maxTickets
  };
}
function isNumInRange({ n, min: min2 = 0, max: max2 = Number.MAX_VALUE }) {
  return !!n && min2 <= n && n <= max2;
}
const haveOneEventPerVenue = (events2, product) => {
  if (product && product.onlyExtras) return true;
  if (!events2 || !product || !product.productVenueSet || !product.productVenueSet.length) {
    return false;
  }
  const nVenueNeedsEvent = product.productVenueSet.filter(
    (pv) => !(pv.openDate && ["event", "periodic"].indexOf(pv.validType || "") === -1)
  ).length;
  return Object.keys(events2).length === nVenueNeedsEvent;
};
const verifyLoyaltyUserRenewal = (loyaltyUser, product) => {
  if (product && !product.renewal) return true;
  if (loyaltyUser == null) return false;
  return true;
};
const verifyLoyaltyBuyerTypes = (tickets, loyaltyUser) => {
  if (Object.keys(tickets).length === 0 && tickets.constructor === Object) return true;
  if (sessionStorage.getItem("benefitRuleBuyerTypeIdList")) {
    const btArray = JSON.parse(sessionStorage.getItem("benefitRuleBuyerTypeIdList"));
    const ticketBts = Object.keys(tickets);
    const mustHaveLoyalty = !ticketBts.some(
      (ticketBt) => btArray.includes(parseInt(ticketBt, 10)) && loyaltyUser == null
    );
    return mustHaveLoyalty;
  }
  return true;
};
const haveOneTicketAtLeast = (tickets) => !!tickets && Object.keys(tickets).length > 0;
const hasServiceAnswerRequired = (services, events2) => !!services && !!events2 && Object.values(services).filter((service) => {
  const { disabledDates } = service;
  if (!disabledDates) return true;
  return !events2.some(
    (event) => disabledDates && disabledDates.split(",").includes(moment(event.startDatetime).format(DATE_FORMAT_DMY_COMPACT))
  );
}).filter((service) => service.answerRequired && service.quantity === -1).length > 0;
const checkPreventMultiReservation = (product, purchase) => {
  let moreThanOneReservation = false;
  if (!!product.preventMultiReservation && purchase && purchase.reservationList) {
    purchase.reservationList.forEach((reservation) => {
      moreThanOneReservation = reservation.product.productId === product.productId;
    });
  }
  return moreThanOneReservation;
};
const productNoNeedsEvents = (product) => !!(product && product.productVenueSet && product.productVenueSet.length && !!product.productVenueSet[0].openDate && ["event", "periodic"].indexOf(product.productVenueSet[0].validType || "") === -1 || product && product.onlyExtras);
const getNowDate = (timeZone) => getNowInTimeZone(timeZone);
const checkBookingReservation = ({
  salesGroup = {},
  product = {},
  events: events2,
  tickets,
  total,
  services,
  subtotalServices
}, purchase, loyaltyUser) => {
  if (!Object.keys(salesGroup).length || !Object.keys(product).length) {
    return {
      valid: false
    };
  }
  let status;
  const { minTickets, maxTickets } = getMinMaxTickets(salesGroup, product);
  const AMOUNT_ALLOWED = (total || 0) + (subtotalServices || 0) === 0 && salesGroup.salesChannel && salesGroup.salesChannel.salesChannelId !== 4 ? product.allowFreeOnline : true;
  const HAS_ONE_TICKET_AT_LEAST = haveOneTicketAtLeast(tickets);
  const RESPECT_PREVENT_MULTI_RESERVATION = !checkPreventMultiReservation(product, purchase);
  const ANSWER_REQUIRED_SERVICES_WITHOUT_ANSWER = hasServiceAnswerRequired(services, events2);
  let TICKETS_OUT_OF_RANGE = true;
  if (HAS_ONE_TICKET_AT_LEAST) {
    TICKETS_OUT_OF_RANGE = !isNumInRange({
      n: Object.values(tickets).reduce((acc, { n = 0 }) => acc + n, 0),
      min: minTickets,
      max: maxTickets
    });
  }
  const HAVE_ONE_EVENT_PER_VENUE = haveOneEventPerVenue(events2, product);
  const LOYALTY_RENEWAL_USER_VERIFIED = verifyLoyaltyUserRenewal(loyaltyUser, product);
  const LOYALTY_BENEFIT_RULE_BUYER_TYPE_VERIFIED = verifyLoyaltyBuyerTypes(tickets || {}, loyaltyUser);
  if (AMOUNT_ALLOWED && !TICKETS_OUT_OF_RANGE && HAS_ONE_TICKET_AT_LEAST && RESPECT_PREVENT_MULTI_RESERVATION && HAVE_ONE_EVENT_PER_VENUE && !ANSWER_REQUIRED_SERVICES_WITHOUT_ANSWER && LOYALTY_RENEWAL_USER_VERIFIED && LOYALTY_BENEFIT_RULE_BUYER_TYPE_VERIFIED) {
    status = { valid: true };
  } else {
    const notifications2 = [];
    if (!AMOUNT_ALLOWED) {
      notifications2.push(createAmountNotAllowedNoty(total ?? 0));
    }
    if (!HAS_ONE_TICKET_AT_LEAST) {
      notifications2.push(createOneTicketAtLeastNoty());
    } else if (TICKETS_OUT_OF_RANGE) {
      notifications2.push(createTicketsOutOfRangeNoty({ min: minTickets ?? 0, max: maxTickets ?? 0 }));
    }
    if (!HAVE_ONE_EVENT_PER_VENUE) {
      notifications2.push(createOneEventPerVenueNoty());
    }
    if (!RESPECT_PREVENT_MULTI_RESERVATION) {
      notifications2.push(createPreventMultiReservationNoty());
    }
    if (!LOYALTY_RENEWAL_USER_VERIFIED) {
      notifications2.push(createVerifyLoyaltyNoty());
    }
    if (!LOYALTY_BENEFIT_RULE_BUYER_TYPE_VERIFIED) {
      notifications2.push(createAddLoyaltyNoty());
    }
    status = {
      valid: false,
      notifications: notifications2
    };
  }
  return status;
};
const getRenderableServices = (serviceList = [], events2, edit) => serviceList.filter(({ qty, disabledDates, extra }) => {
  if (!qty) return false;
  const disabledOnSelectedEvent = !!disabledDates && !!events2 && events2.events.some(
    (event) => disabledDates.split(",").includes(moment(event.startDatetime).format(DATE_FORMAT_DMY_COMPACT))
  );
  if (disabledOnSelectedEvent) return false;
  const { manageStock, manageStockType, stock } = extra ?? {};
  return !(manageStock && manageStockType === "optional" && stock !== void 0 && qty > stock && !edit);
});
const OWNER_KEY = "bt";
const getOwnerBuyerTypeId = (formType, ownerId) => {
  if (formType !== "TicketNominal" && formType !== "Ticket") return void 0;
  const buyerTypeId = Number(String(ownerId).split("-")[1]);
  return Number.isNaN(buyerTypeId) ? void 0 : buyerTypeId;
};
const isFieldVisibleForBuyerType = (field, ownerBuyerTypeId) => {
  if (!field.supportsBuyerTypes || ownerBuyerTypeId === void 0) return true;
  const allowedBuyerTypeIds = field.supportsBuyerTypes.split(",").map((id2) => Number(id2.trim()));
  return allowedBuyerTypeIds.includes(ownerBuyerTypeId);
};
const formHasVisibleFieldsForOwner = (form2, ownerId) => {
  const ownerBuyerTypeId = getOwnerBuyerTypeId(form2.type, ownerId);
  if (ownerBuyerTypeId === void 0) return true;
  return (form2.formFieldsetSet ?? []).some(
    (fieldset) => (fieldset.genericFieldSet ?? []).some((field) => isFieldVisibleForBuyerType(field, ownerBuyerTypeId))
  );
};
const formHasFields = (form2) => (form2.formFieldsetSet ?? []).some((fieldset) => !!(fieldset.genericFieldSet ?? []).length);
const formHasVisibleFieldsForAnyOwner = (form2, ownerList = []) => formHasFields(form2) && ownerList.some((owner) => owner.qty > 0 && formHasVisibleFieldsForOwner(form2, `${owner.id}-0`));
const getCart = (state) => state.cart;
const getCartEvents = (state) => state.cart.events;
const getCartSalesGroup = (state) => state.cart.salesGroup;
const getCartProduct = (state) => state.cart.product;
const getCartTickets = (state) => state.cart.tickets;
const getCurrentPurchase = (state) => state.reservations.purchase;
const getLoyaltyUser = (state) => state.loyalty && state.loyalty.loyaltyUser;
const getEventList = (state) => state.events.eventList;
const getAvailableDatesMap = (state) => state.events.availableDates;
const getCalendarInfoMap = (state) => state.events.calendarInfoMap;
const getAvailablePricingDatesMap = (state) => state.events.datesPricing;
const getProductList = (state) => state.products.productList;
const getServiceList = (state) => state.products.serviceList;
const getVenueCapacityList = (state) => state.products.venueCapacityList;
const getVenueList = (state) => state.products.venueList;
const getProductFormList = (state) => state.products.productFormList;
const getBuyerTypeList = (state) => state.buyerTypes.buyerTypeList;
const getBuyerTypeInfoList = (state) => state.buyerTypes.buyerTypeInfoList;
const getPromotionList = (state) => state.promotions.promotionList;
const getAddonPromotionList = (state) => state.products.addons?.promotionsAddonsList ?? [];
const getPromotionCodeList = (state) => state.promotions.promotionCodeList;
const getSellerSalesGroupList = (state) => state.salesGroup?.salesGroup ?? [];
const getSellerBuyerTypes = (state) => state.editReservation?.selectedBuyerTypes ?? {};
const getSellerEvents = (state) => state.editReservation?.selectedEventPerVenue ?? {};
const getInitialSellerEvents = (state) => state.editReservation?.initialReservationState?.selectedEventPerVenue ?? {};
const getSellerDates = (state) => state.editReservation?.selectedDatesPerVenue ?? {};
const getSellerIdSelected = (state) => state.cart.sellerId || sessionStorage.getItem("sellerId") || null;
const getTimeZone = (state) => state.pointOfSales.clientList[0].timeZone;
const isReservationProductFormValid = (state) => isValid("reservationForm")(state);
const isTicketProductFormValid = (state) => isValid("ticketForm")(state);
const getModDays = createSelector(
  [getAvailableDatesMap, getCalendarInfoMap, getAvailablePricingDatesMap],
  (availableDates = {}, calendarInfoMap, datesPricing = {}) => {
    const { dates = {}, calendarInfos = {} } = calendarInfoMap ?? {};
    const daysModed = [...Object.keys(availableDates), ...Object.keys(dates)];
    const modDaysMap = daysModed.reduce((acc, day) => {
      const pricingDay = datesPricing[day] ?? null;
      return {
        ...acc,
        [day]: {
          available: availableDates[day],
          price: pricingDay,
          infoList: (dates[day] || []).map((infoId) => {
            const info = calendarInfos[infoId];
            return {
              id: infoId,
              color: info?.calendarColor ?? "",
              customClass: info?.customClass ?? ""
            };
          })
        }
      };
    }, {});
    return modDaysMap;
  }
);
const getTicketsQty = createSelector(
  [getCartTickets],
  (tickets = {}) => Object.values(tickets).reduce(
    (acc, { n = 0, noHandleAvailability }) => noHandleAvailability === false ? acc + n : acc,
    0
  )
);
const getTicketFormList = createSelector(
  [getProductFormList],
  (productFormList = []) => productFormList.filter((form2) => ["Ticket", "TicketNominal"].indexOf(form2.type) !== -1)
);
const getReservationFormList = createSelector(
  [getProductFormList],
  (productFormList = []) => productFormList.filter((form2) => ["Reservation"].indexOf(form2.type) !== -1)
);
const getTicketFormOwnerList = createSelector(
  [getCartTickets],
  (tickets = {}) => Object.values(tickets).map((ticket) => ({
    id: `${OWNER_KEY}-${ticket.buyerTypeId}`,
    label: ticket.name ?? "",
    qty: ticket.n ?? 0
  }))
);
const getRenderableTicketFormList = createSelector(
  [getTicketFormList, getTicketFormOwnerList],
  (ticketFormList = [], ownerList) => ticketFormList.filter((form2) => formHasVisibleFieldsForAnyOwner(form2, ownerList))
);
const getRenderableReservationFormList = createSelector(
  [getReservationFormList],
  (reservationFormList = []) => reservationFormList.filter(formHasFields)
);
const getPromotionListWithCodeIfApply = createSelector(
  [getPromotionList, getPromotionCodeList],
  (promotionList = [], promotionCodeList = []) => [
    ...promotionList.filter((promotion) => promotion.promotionType !== "promotional_code"),
    ...promotionCodeList
  ]
);
const getBuyerTypeMap = createSelector(
  [getBuyerTypeList],
  (buyerTypeList = []) => buyerTypeList.reduce(
    (acc, buyerType) => ({
      ...acc,
      [buyerType.buyerTypeId]: buyerType
    }),
    {}
  )
);
const getVenueCapacityMap = createSelector(
  [getVenueCapacityList],
  (venueCapacityList = []) => venueCapacityList.reduce(
    (acc, vc) => ({
      ...acc,
      [vc.venueCapacityId]: vc
    }),
    {}
  )
);
const getVenueMap = createSelector(
  [getVenueList],
  (venueList = []) => venueList.reduce(
    (acc, venue) => ({
      ...acc,
      [venue.venueId]: venue
    }),
    {}
  )
);
const getVisibleServiceList = createSelector(
  [getCartTickets, getServiceList],
  (tickets = {}, serviceList = []) => serviceList.map((s) => ({
    ...s,
    qty: s.buyerTypeIds.reduce((acc, btId) => acc + (tickets[btId] && tickets[btId].n || 0), 0)
  }))
);
const getRenderableServiceList = createSelector(
  [getVisibleServiceList, getCartEvents],
  (serviceList = [], events2 = []) => getRenderableServices(serviceList, { events: events2 })
);
const getVisibleServiceListSorted = createSelector(
  [getVisibleServiceList],
  (serviceList = []) => [...serviceList].sort(
    (a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
  )
);
const getEditServicesEventDatetime = createSelector(
  [getSellerEvents, getVenueMap, getSellerDates, getInitialSellerEvents],
  (selectedEventPerVenue = {}, venuesMap, selectedDatesPerVenue, initialSelectedEventPerVenue) => {
    const venueEntries = Object.values(venuesMap);
    const mainVenue = !isEmpty(venuesMap) && venueEntries.find((venue) => !venue.mainVenueId);
    if (!mainVenue || isEmpty(mainVenue)) return void 0;
    let event = !isEmpty(selectedEventPerVenue) && selectedEventPerVenue[mainVenue.venueId];
    if (!event) {
      const startDatetime = !isEmpty(selectedDatesPerVenue) && selectedDatesPerVenue[mainVenue.venueId];
      if (startDatetime) {
        event = { startDatetime };
      }
    }
    if (!event) {
      event = !isEmpty(initialSelectedEventPerVenue) && initialSelectedEventPerVenue[mainVenue.venueId];
    }
    return event ? new Date(event.startDatetime).toISOString() : void 0;
  }
);
const getVisibleServiceListEdit = createSelector(
  [getSellerBuyerTypes, getServiceList],
  (tickets = {}, serviceList = []) => {
    const ticketMap = tickets;
    return serviceList.map((s) => ({
      ...s,
      qty: s.buyerTypeIds.reduce((acc, btId) => acc + (ticketMap[btId] && ticketMap[btId].n || 0), 0)
    }));
  }
);
const getPromotionEventList = createSelector(
  [getPromotionList, getSellerIdSelected],
  (promotionList = [], sellerId) => {
    if (sellerId && promotionList.some(
      (p) => p.promotionType === "seller_agreement" && !isEmpty(p.sellerIds) && p.sellerIds.includes(Number(sellerId))
    )) {
      return [];
    }
    return promotionList.filter((p) => p.promotionType === "event");
  }
);
const getTicketsRange = createSelector(
  [getCartSalesGroup, getCartProduct, getCartEvents],
  (salesGroup = {}, product = {}, eventList = []) => getMinMaxTickets(salesGroup, product, eventList)
);
const getTicketsRangeEdit = createSelector(
  [getSellerSalesGroupList, getProductList, getSellerEvents],
  (salesGroups = [], products2 = [], sellerEvents = {}) => {
    const product = products2[0];
    const salesGroup = salesGroups[0];
    const eventList = Object.values(sellerEvents);
    return getMinMaxTickets(salesGroup, product, eventList);
  }
);
const getVenueCapacityVenueMap = createSelector(
  [getCartProduct],
  (product = {}) => product.productVenueSet && product.productVenueSet.reduce(
    (accV, pv) => ({
      ...accV,
      ...pv.venue.venueCapacityList.reduce(
        (accVC, vc) => ({
          ...accVC,
          [vc.venueCapacityId]: pv.venueId
        }),
        {}
      )
    }),
    {}
  )
);
const getEventsWithVenue = createSelector(
  [getEventList, getVenueCapacityVenueMap],
  (eventList = [], venueCapacityVenueMap = {}) => eventList.map((e) => ({
    ...e,
    venueId: venueCapacityVenueMap[e.venueCapacityId]
  }))
);
const getEventsAvailable = createSelector(
  [getEventsWithVenue, getTicketsQty, getTicketsRange],
  (eventList = [], nTickets = 0, {
    minTickets = 0
    /* , maxTickets */
  }) => (
    // this is for show disabled events
    eventList.map(({ totalAvailability, ...event }) => ({
      ...event,
      totalAvailability: totalAvailability >= nTickets && totalAvailability >= minTickets ? totalAvailability : 0
    }))
  )
);
const hasPromotion = (promotionEventList, event, venueList, timeZone) => promotionEventList.some(
  (promotion) => generalValidations({
    checkBuyerTypes: false,
    promotion,
    event,
    venueList,
    timeZone
  })
);
const getEventsWithPromotionFlag = createSelector(
  [getEventsAvailable, getPromotionEventList, getVenueMap, getTimeZone],
  (eventList = [], promotionEventList = [], venueList = [], timeZone) => eventList.map((event) => ({
    ...event,
    hasPromotion: hasPromotion(
      promotionEventList,
      event,
      Object.values(venueList),
      timeZone
    )
  }))
);
const getBuyerTypeInfoListForCartProduct = createSelector(
  [getBuyerTypeInfoList, getCartProduct],
  (buyerTypeInfoList = [], product = {}) => product.productId && buyerTypeInfoList.filter(({ productId }) => productId === product.productId)
);
const getVisibleComponentNameList = createSelector(
  [
    getCartProduct,
    getRenderableServiceList,
    getPromotionList,
    getTicketsQty,
    getRenderableTicketFormList,
    getRenderableReservationFormList,
    getProductFormList
  ],
  (product, serviceList = [], promotionList = [], _ticketsQty, ticketFormList = [], reservationFormList = [], _productFormList = []) => {
    const typedProduct = product;
    const orderComponents = window.pos?.orderComponents || ["numbered", "date-event", "buyerTypes", "membership", "services", "promotions", "forms"];
    return orderComponents.filter((name) => {
      switch (name) {
        case "date-event":
          if (typedProduct.onlyExtras || !!typedProduct.numbered) {
            return false;
          }
          break;
        case "buyerTypes":
          if (typedProduct.numbered) {
            return false;
          }
          break;
        case "membership":
          if (!typedProduct.membership) {
            return false;
          }
          break;
        case "services":
          if (!serviceList.length) {
            return false;
          }
          break;
        case "promotions": {
          const filteredPromotionList = Object.values(promotionList).filter(
            (promotion) => promotion.promotionType === "promotional_code" || promotion.promotionType === "agreement"
          );
          if (!filteredPromotionList.length) {
            return false;
          }
          break;
        }
        case "forms":
          if (!ticketFormList.length && !reservationFormList.length) {
            return false;
          }
          break;
        case "numbered":
          if (!typedProduct.numbered) {
            return false;
          }
          break;
        default:
          return true;
      }
      return true;
    });
  }
);
const getCartStatus = createSelector(
  [getCart, getCurrentPurchase, getLoyaltyUser],
  (cart2 = {}, purchase = {}, loyaltyUser = {}) => !!Object.keys(cart2).length && checkBookingReservation(
    cart2,
    purchase,
    loyaltyUser
  )
);
const getCartWithStatus = createSelector([getCart, getCartStatus], (cart2 = {}, status) => ({
  ...cart2,
  status
}));
const getVisiblePromoList = createSelector(
  [getPromotionList, getCartEvents, getVenueMap, getTimeZone],
  (promotionList = [], eventsSelected = [], venueList = [], timeZone) => {
    let eventSelected = eventsSelected && eventsSelected[0];
    if (!eventSelected) {
      const startDatetime = moment.tz(timeZone);
      eventSelected = {
        eventId: startDatetime.format(),
        startDatetime: startDatetime.format()
      };
    }
    const sellerPromos = eventsSelected && promotionList.filter(
      (promo) => (promo.promotionType === "seller_agreement" || promo.promotionType === "event" || promo.promotionType === "volume") && hasPromotion(
        [promo],
        eventSelected,
        Object.values(venueList),
        timeZone
      )
    );
    return sellerPromos || [];
  }
);
const getSellerPromoListEdit = createSelector(
  [getPromotionList, getSellerEvents, getVenueMap, getInitialSellerEvents, getTimeZone],
  (promotionList = [], eventsSelected = {}, venueList = [], initialEvents, timeZone) => {
    let eventSelected = Object.values(eventsSelected) && Object.values(eventsSelected)[0];
    if (!eventSelected) {
      eventSelected = Object.values(initialEvents) && Object.values(initialEvents)[0];
    }
    const sellerPromos = eventSelected && promotionList.filter(
      (promo) => promo.promotionType === "seller_agreement" && hasPromotion(
        [promo],
        eventSelected,
        Object.values(venueList),
        timeZone
      )
    );
    return sellerPromos || [];
  }
);
const getAddonPromoList = createSelector([getAddonPromotionList], (promotionList = []) => {
  const filteredPromotions = promotionList.filter(
    (promotion) => promotion.promotionType === "promotional_code" || promotion.promotionType === "agreement"
  );
  if (!filteredPromotions.length) {
    return false;
  }
  return true;
});
class DateContainer extends Component {
  static defaultProps = {
    displayFormat: DATE_FORMAT_DMY,
    firstDayOfWeek: 1
  };
  componentDidMount() {
    const { selectedDate, initialDate } = this.props;
    this.onChangeMonth(selectedDate);
    if (initialDate && !selectedDate) {
      this.onChangeMonth(initialDate);
      this.onChangeDay(initialDate);
    } else {
      this.onChangeMonth(selectedDate);
    }
  }
  componentDidUpdate(prevProps) {
    const { salesGroup, product, event, handleFetchBuyerTypesWithPrice, editReservation: editReservation2 } = this.props;
    const { initialReservationState } = editReservation2;
    if (salesGroup !== prevProps.salesGroup || product !== prevProps.product || event !== prevProps.event) {
      handleFetchBuyerTypesWithPrice({
        salesGroupId: salesGroup.salesGroupId,
        productId: product.productId,
        eventId: event?.eventId,
        date: initialReservationState.eventStartDatetime
      });
    }
  }
  onChangeDay = (day) => {
    const { handleSetSelectedDateForVenue, venue } = this.props;
    handleSetSelectedDateForVenue({ date: day, venueId: venue.venueId });
  };
  onChangeMonth = (date = /* @__PURE__ */ new Date()) => {
    const { handleFetchEventsAvailability, salesGroup, product, venue, minTickets } = this.props;
    const paramsAvailability = {
      month: getMonth(date instanceof Date ? date : new Date(date)) + 1,
      // +1 to convert zero case month on one case. Jan will be 1 and not 0.
      year: getYear(date instanceof Date ? date : new Date(date)),
      venueId: venue.venueId,
      minAvailability: minTickets
    };
    handleFetchEventsAvailability({
      salesGroupId: salesGroup.salesGroupId,
      productId: product.productId,
      params: paramsAvailability
    });
  };
  isOutOfRange = (date) => {
    const momentDate = moment(date);
    const { product, editReservation: editReservation2, venue } = this.props;
    const { selectedEventPerVenue, selectedDatesPerVenue } = editReservation2;
    const productVenueSet = product.productVenueSet;
    const productVenue = productVenueSet.find((pv) => pv.venueId === venue.venueId);
    const mainProductVenue = productVenueSet.find((pv) => pv.displayOrder === 0);
    if (productVenue && productVenue.displayOrder !== 0 && mainProductVenue) {
      const { minSeparation, maxSeparation } = productVenue;
      let mainEventSelected = selectedEventPerVenue[mainProductVenue.venueId];
      if (isEmpty(mainEventSelected) && !isEmpty(selectedDatesPerVenue)) {
        mainEventSelected = {
          startDatetime: selectedDatesPerVenue[mainProductVenue.venueId]
        };
      }
      return !momentDate.isBetween(
        moment(mainEventSelected.startDatetime).add(minSeparation, "minutes"),
        moment(mainEventSelected.startDatetime).add(maxSeparation, "minutes"),
        "day",
        "[]"
      );
    }
    return false;
  };
  render() {
    const {
      showCalendar,
      headerText,
      productInfo = {},
      days,
      displayFormat,
      startDate,
      endDate,
      locale: localeProp,
      product,
      userInfoCalendar,
      selectedDate,
      store,
      initialVisibleMonth,
      minTickets,
      timeZone
    } = this.props;
    const locale = localeProp || (typeof window !== "undefined" ? getAppLocale() : void 0);
    const calendarProps = {
      locale,
      weekDays: product.weekDays,
      handleSelect: (day) => {
        this.onChangeDay(day);
      },
      isOutOfRange: this.isOutOfRange,
      onChangeMonth: this.onChangeMonth,
      selectedDate,
      startDate: startDate ? moment.tz(startDate, timeZone ?? "").startOf("day") : void 0,
      endDate,
      days,
      displayFormat,
      disabledDates: product.disabledDates,
      productInfo,
      initialVisibleMonth,
      minTickets
    };
    return showCalendar ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      /* @__PURE__ */ jsxRuntimeExports.jsx(Provider, { store, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        headerText && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel-body-header", children: userInfoCalendar ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: userInfoCalendar } }) : /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: headerText }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "panel-body-content", children: [
          productInfo && productInfo.top && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: productInfo.top }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "calendar", children: endDate ? /* @__PURE__ */ jsxRuntimeExports.jsx(Calendar$1, { ...calendarProps }) : null }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: productInfo && productInfo.bottom })
        ] })
      ] }) })
    ) : null;
  }
}
function mapStateToProps$s(state, ownProps) {
  const { editReservation: editReservation2, pointOfSales, events: events2 } = state;
  const { initialReservationState, selectedDatesPerVenue } = editReservation2;
  const { minTickets, maxTickets } = getTicketsRangeEdit(state);
  const { clientList } = pointOfSales;
  return {
    initialReservationState,
    selectedDate: selectedDatesPerVenue[ownProps.venue.venueId],
    days: getModDays(state),
    editReservation: editReservation2,
    minTickets,
    maxTickets,
    timeZone: clientList[0].timeZone,
    event: events2.event
  };
}
function mapDispatchToProps$i(dispatch) {
  return {
    handleFetchEventsAvailability: ({ salesGroupId, productId, params }) => {
      Promise.all([
        dispatch(fetchEventsAvailability(salesGroupId, productId, params)),
        dispatch(fetchCalendarInfo({ salesGroupId, productId, ...params }))
      ]);
    },
    handleSetSelectedDateForVenue: ({ date, venueId }) => {
      dispatch(setSelectedDateForVenue({ date, venueId }));
    },
    handleFetchBuyerTypesWithPrice: ({ salesGroupId, productId, date, eventId }) => {
      dispatch(
        fetchBuyerTypesWithPrice({ salesGroupId, productId, date, eventId })
      );
    }
  };
}
const DateContainer_default = connect(mapStateToProps$s, mapDispatchToProps$i)(DateContainer);
class VenueCapacityProvider extends Component {
  render() {
    const { venueCapacityList, venueCapacityId, onChangeVenueCapacity, eventListTotal, children } = this.props;
    const disabledVenue = index(
      (venueCapacityIdmap) => !eventListTotal.some((event) => event.venueCapacityId === venueCapacityIdmap && event.totalAvailability > 0)
    );
    const options = [];
    const selectedVenueCapacity = venueCapacityId;
    venueCapacityList.forEach((v) => {
      options.push({
        id: v.venueCapacityId,
        label: v.name,
        displayOrder: v.displayOrder,
        disabled: disabledVenue(v.venueCapacityId)
      });
    });
    return options.length ? children({
      options,
      selected: selectedVenueCapacity,
      handleSelect: onChangeVenueCapacity
    }) : null;
  }
}
function ButtonSelector({ options, selected, handleSelect }) {
  return options ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: options.map((i) => {
    const { id: id2, label, disabled } = i;
    let itemClass = "event";
    if (selected === id2) {
      itemClass += " selected";
    }
    if (disabled) {
      itemClass += " disabled";
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "event-selector",
        onClick: () => handleSelect(id2),
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleSelect(id2);
          }
        },
        tabIndex: 0,
        role: "button",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: itemClass, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "date", children: label }) })
      },
      `btn-${id2}`
    );
  }) }) : null;
}
function VenueCapacitySelector({ selected, options = [], handleSelect }) {
  const orderedList = options.sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0));
  if (orderedList.length > 1) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-12", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "venuesCapacity-tabs", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonSelector, { handleSelect, options: orderedList, selected }, "btn-vc") }) }) });
  }
  return null;
}
function FormattedTime({ intl: _intl, value, ...props }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedTime$2, { hour12: false, value, ...props });
}
const FormattedTime$1 = injectIntl(FormattedTime);
function Event({
  label,
  capacity,
  handleClickEvent,
  selected,
  disabled,
  availability,
  thresholdHighAvailability,
  thresholdMediumAvailability,
  maxDisplayAvailability,
  showRealAvailability,
  hasPromotion: hasPromotion2 = false,
  startDatetime,
  currentReservations,
  maxReservations,
  ignoreSold,
  onlyAccessTime,
  eventBasePrice,
  currency,
  eventId
}) {
  const locale = Cookie.get("languageCountryCode");
  let eventClass = "";
  if (selected) {
    eventClass += " selected";
  }
  if (disabled) {
    eventClass += " disabled";
  }
  let groupsAvailables;
  if ((currentReservations || maxReservations) && !ignoreSold) {
    groupsAvailables = (maxReservations ?? 0) - (currentReservations ?? 0);
  }
  let availabilityClass = "";
  if ((availability ?? 0) >= (thresholdHighAvailability ?? 0) * (capacity ?? 0)) {
    availabilityClass = "high";
  } else if ((availability ?? 0) < (thresholdHighAvailability ?? 0) * (capacity ?? 0) && (availability ?? 0) >= (thresholdMediumAvailability ?? 0) * (capacity ?? 0)) {
    availabilityClass = "medium";
  } else {
    availabilityClass = "low";
  }
  let availabilityToShow;
  if (maxDisplayAvailability && (availability ?? 0) > maxDisplayAvailability) {
    availabilityToShow = "";
  } else {
    availabilityToShow = availability;
  }
  if (!thresholdHighAvailability && !thresholdMediumAvailability) {
    availabilityClass = "";
  }
  let availabilityLabelToShow = "";
  if (!disabled) {
    if (availabilityToShow && availabilityToShow > 0 && !groupsAvailables || showRealAvailability) {
      availabilityLabelToShow = /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: showRealAvailability ? "real-availability" : "low-availability", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "Quedan {ticketAvailability} entradas",
          id: "availability.text",
          values: {
            ticketAvailability: showRealAvailability ? availability : availabilityToShow
          }
        }
      ) });
    }
    if (groupsAvailables && (!showRealAvailability || showRealAvailability && !ignoreSold)) {
      availabilityLabelToShow = /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "low-availability", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          defaultMessage: "{groupsAvailables, plural, =0 {No quedan grupos disponibles} one {Queda 1 grupo disponible} other {Quedan {groupsAvailables} grupos disponibles}}",
          id: "availability.groups.text",
          values: {
            groupsAvailables
          }
        }
      ) });
    }
  }
  if (availability === 0) {
    availabilityLabelToShow = /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "zero-availability", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "AGOTADAS", id: "availability.soldOut" }) });
  }
  const shouldShowPrice = typeof eventBasePrice === "number";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "event-selector", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        type: "button",
        className: `event ${eventClass}`,
        onClick: disabled ? () => {
        } : handleClickEvent,
        "data-event-id": startDatetime,
        "test-event-id": eventId,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `date ${!disabled ? availabilityClass : ""} ${!onlyAccessTime ? "accessTime" : ""} `, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: `${shouldShowPrice ? "hasPrice" : ""}`, children: label }),
            shouldShowPrice && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "event-price", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { value: eventBasePrice, locale, currency }) })
          ] }),
          hasPromotion2 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "hasPromotion icon-own-discount_label" })
        ]
      }
    ),
    availabilityLabelToShow
  ] });
}
function EventLabel({
  showName,
  showNowText,
  isSpecial,
  name,
  startDatetime,
  endDatetime,
  finalDate,
  timeZone,
  text
}) {
  if (showNowText) return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: text });
  if (showName && !isSpecial && name) return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: name });
  if (startDatetime) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedTime$1, { value: new Date(startDatetime), timeZone }),
      finalDate && endDatetime && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "spacer", children: " - " }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedTime$1, { value: new Date(endDatetime), timeZone })
      ] })
    ] });
  }
  return null;
}
class EventSelector extends Component {
  componentDidUpdate(prevProps) {
    const { index: index2 = 0, eventList, cartEvents, venueCapacityList, handleSelect } = this.props;
    if (venueCapacityList && venueCapacityList.length === 1 && !!cartEvents && !!cartEvents[index2] && !!eventList && eventList.length > 0 && prevProps.eventList.length > 0 && eventList !== prevProps.eventList) {
      if (eventList.filter((event) => event.eventId === cartEvents[index2].eventId).length > 0) {
        handleSelect(cartEvents[index2].eventId);
      }
    }
  }
  render() {
    const {
      selected,
      eventList,
      handleSelect,
      checkDisabled,
      thresholdHighAvailability,
      thresholdMediumAvailability,
      maxDisplayAvailability = Number.MAX_VALUE,
      showEventName = false,
      text,
      initialEvent,
      ignoreSold,
      showRealAvailability = false,
      onlyAccessTime,
      currency
    } = this.props;
    const hasPromotion2 = () => !!eventList.find((event) => event.hasPromotion === true);
    return eventList && eventList.length ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "events-tabs", children: eventList.map((event) => {
        const {
          eventId,
          totalAvailability,
          capacity,
          hasPromotion: eventHasPromotion,
          startDatetime,
          currentReservations = 0,
          maxReservations = 0,
          appliedDeny,
          eventBasePrice
        } = event;
        const isSelected = eventId === selected;
        const isDisabled = eventId === initialEvent ? false : checkDisabled(event);
        return !appliedDeny && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Event,
          {
            label: /* @__PURE__ */ jsxRuntimeExports.jsx(
              EventLabel,
              {
                name: event.name,
                isSpecial: event.isSpecial,
                startDatetime,
                endDatetime: event.endDatetime,
                timeZone: event.timeZone,
                text,
                showName: showEventName,
                finalDate: !onlyAccessTime
              }
            ),
            availability: totalAvailability,
            capacity,
            thresholdHighAvailability,
            thresholdMediumAvailability,
            maxDisplayAvailability,
            showRealAvailability,
            selected: isSelected,
            disabled: isDisabled,
            startDatetime,
            handleClickEvent: () => {
              if (!isDisabled) {
                handleSelect(eventId);
              }
            },
            hasPromotion: eventHasPromotion,
            currentReservations,
            maxReservations,
            ignoreSold,
            eventId,
            onlyAccessTime,
            eventBasePrice,
            currency
          },
          `event-${eventId}`
        );
      }) }),
      thresholdMediumAvailability && thresholdHighAvailability && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "legend", "aria-hidden": true, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { className: "list-unstyled list-inline", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "legend-availability", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "red icon-own-remove" }),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Baja disponibilidad", id: "legend.text.lowavailability" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "legend-availability", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "yellow icon-own-remove" }),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Media disponibilidad", id: "legend.text.mediumavailability" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "legend-availability", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "green icon-own-remove" }),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Alta disponibilidad", id: "legend.text.highavailability" })
        ] }),
        hasPromotion2() ? /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-own-discount_label" }),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Promotion", id: "legend.text.promotion" })
        ] }) : ""
      ] }) })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "no-availability-text", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "No availability", id: "text.no.availability" }) });
  }
}
function SelectMode({ handleSelect, options, selected = 0 }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-select", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "select",
      {
        value: selected,
        onChange: (e) => {
          handleSelect(Number(e.target.value || 0));
        },
        children: options && options.length > 0 && options.map((option, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: option.id, children: option.textLabel }, index2))
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-own-arrow_drop_down" })
  ] });
}
function EventGroupLabel({ startDateTime, endDateTime, timeZone }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedTime$1, { value: new Date(startDateTime), timeZone, children: (txt) => txt }),
    " ",
    "- ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedTime$1, { value: new Date(endDateTime), timeZone, children: (txt) => txt })
  ] });
}
function ButtonMode({
  handleSelect,
  options,
  selected = options && options.length ? options[0].id : void 0
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonSelector, { handleSelect, options, selected }, "btn-eg");
}
function EventGroupSelector({ selected, eventGroupList = [], handleSelect }) {
  const options = eventGroupList.map((eg) => {
    const startGroup = eg.startDateTime && eg.timeZone && moment(eg.startDateTime).tz(eg.timeZone).format(TIME_FORMAT_24H).toString();
    const endGroup = eg.endDateTime && eg.timeZone && moment(eg.endDateTime).tz(eg.timeZone).format(TIME_FORMAT_24H).toString();
    const textLabel = `${startGroup} - ${endGroup}`;
    return {
      id: eg.eventGroupId,
      disabled: eg.totalAvailability <= 0,
      label: /* @__PURE__ */ jsxRuntimeExports.jsx(EventGroupLabel, { startDateTime: eg.startDateTime, endDateTime: eg.endDateTime, timeZone: eg.timeZone }),
      textLabel
    };
  });
  if (options.length > 1) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-12", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "event-group-tabs", children: /* @__PURE__ */ jsxRuntimeExports.jsx(MediaQuery, { query: "(max-width: 480px)", children: (matches) => matches ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      SelectMode,
      {
        handleSelect,
        options,
        selected
      },
      "btn-eg"
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonMode, { handleSelect, options, selected }, "btn-eg") }) }) }) });
  }
  return null;
}
var end_of_dayExports = requireEnd_of_day();
const endOfDay = /* @__PURE__ */ getDefaultExportFromCjs(end_of_dayExports);
var add_weeksExports = requireAdd_weeks();
const addWeeks = /* @__PURE__ */ getDefaultExportFromCjs(add_weeksExports);
var add_monthsExports = requireAdd_months();
const addMonths = /* @__PURE__ */ getDefaultExportFromCjs(add_monthsExports);
var difference_in_daysExports = requireDifference_in_days();
const differenceInDays = /* @__PURE__ */ getDefaultExportFromCjs(difference_in_daysExports);
var sub_minutesExports = requireSub_minutes();
const subMinutes = /* @__PURE__ */ getDefaultExportFromCjs(sub_minutesExports);
var minExports = requireMin();
const min = /* @__PURE__ */ getDefaultExportFromCjs(minExports);
var maxExports = requireMax();
const max = /* @__PURE__ */ getDefaultExportFromCjs(maxExports);
const throwIfMissing = (name) => {
  throw new Error(`Missing parameter: ${name}`);
};
const CalendarType = {
  CALENDAR: "calendar",
  PERIODIC: "periodic",
  EVENT: "event"
};
const PeriodType = {
  DAY: "day",
  MONTH: "month",
  WEEK: "week"
};
const Period = {
  START: "start",
  END: "end"
};
const PeriodTypeFn = {
  [PeriodType.DAY]: addDays,
  [PeriodType.WEEK]: addWeeks,
  [PeriodType.MONTH]: addMonths
};
const START_DATE = "start";
const END_DATE = "end";
const applyPeriod = (date, periodType, periodValue) => {
  if (periodType && periodValue !== 0) {
    const fn = PeriodTypeFn[periodType];
    if (fn) {
      return fn(date, periodValue);
    }
    throw new Error(`Unknown PeriodType: ${periodType}`);
  }
  return date;
};
function getDateToPeriodicValues({
  periodType,
  // PeriodType
  periodValue = 0,
  // int
  period,
  // Period
  defaultStartDate,
  // Date
  timeZone
}) {
  let responseDate;
  if (defaultStartDate) {
    responseDate = defaultStartDate;
  } else {
    responseDate = /* @__PURE__ */ new Date();
  }
  responseDate = applyPeriod(responseDate, periodType, periodValue);
  if (period === Period.START && periodValue !== 0 && !defaultStartDate) {
    responseDate = moment.tz(responseDate, timeZone).startOf("day").format(DATE_FORMAT_YMD);
  } else if (period === Period.END) {
    responseDate = moment(responseDate).endOf("day").format(DATE_FORMAT_YMD);
  }
  return responseDate;
}
function setCalendarValidDate({
  calendarDate,
  // Date
  startDate = /* @__PURE__ */ new Date(),
  // Date
  ...rest
}) {
  return {
    [START_DATE]: startDate,
    [END_DATE]: calendarDate,
    ...rest
  };
}
function setPeriodicValidDate({
  periodStartType,
  // PeriodType
  periodStartValue,
  // int
  periodEndType,
  // PeriodType
  periodEndValue
  // int
}) {
  return {
    [START_DATE]: getDateToPeriodicValues({
      periodType: periodStartType,
      periodValue: periodStartValue,
      period: Period.START
    }),
    periodStartType,
    periodStartValue,
    [END_DATE]: getDateToPeriodicValues({
      periodType: periodEndType,
      periodValue: periodEndValue,
      period: Period.END
    }),
    periodEndType,
    periodEndValue
  };
}
function setEndValidDateFromEventStart({
  defaultStartDate,
  // Date
  periodEndType,
  // PeriodType
  periodEndValue,
  // int
  calendarDate,
  // Date
  timeZone
}) {
  return {
    [START_DATE]: defaultStartDate,
    [END_DATE]: calendarDate || getDateToPeriodicValues({
      periodType: periodEndType,
      periodValue: periodEndValue,
      period: Period.END,
      defaultStartDate,
      timeZone
    }),
    periodEndType,
    periodEndValue
  };
}
const getEventGroupList = (eventList = [], threshold = eventList.length) => {
  const eventGroupList = [];
  if (!eventList.length) return eventGroupList;
  const eventListTmp = [...eventList];
  let nGroups = 1;
  while (eventListTmp.length > 0) {
    const eventGroup = eventListTmp.splice(0, threshold !== 0 ? threshold : eventList.length);
    eventGroupList.push({
      eventGroupId: nGroups,
      totalAvailability: eventGroup.reduce(
        (sumAvailability, e) => sumAvailability + e.totalAvailability,
        0
      ),
      timeZone: eventGroup[0].timeZone,
      startDateTime: eventGroup[0].startDatetime,
      endDateTime: eventGroup[eventGroup.length - 1].startDatetime,
      events: eventGroup
    });
    nGroups++;
  }
  return eventGroupList;
};
const getAvailableRanges = (v1 = {
  selectedDate: throwIfMissing("selectedDate"),
  duration: 0,
  minSeparation: 0,
  maxSeparation: 0
}, v2 = {
  duration: 0,
  maxSeparation: 0,
  minSeparation: 0
}, rangeList = []) => {
  let updatedRangeList = [...rangeList];
  if (!v2.mainVenueId) {
    const prevDate = subMinutes(v1.selectedDate, v2.duration);
    const prevStartDate = v2.maxBeforeSeparation ? subMinutes(prevDate, v2.maxBeforeSeparation) : subMinutes(prevDate, v2.maxSeparation);
    const prevEndDate = v2.minBeforeSeparation ? subMinutes(prevDate, v2.minBeforeSeparation) : subMinutes(prevDate, v2.minSeparation);
    const prevDiffDays = Math.abs(differenceInDays(v1.selectedDate, prevStartDate));
    const backwardRange = {
      startDate: prevStartDate,
      endDate: prevEndDate,
      diffDays: prevDiffDays,
      showDaySelector: prevDiffDays > 0,
      tag: "backward"
      // Helper
    };
    updatedRangeList = [...rangeList, backwardRange];
  }
  let nextDate;
  let nextStartDate;
  let nextEndDate;
  let nextDiffDays;
  if (v2.mainVenueId && v2.mainVenueId === v1.venueId) {
    nextDate = v1.selectedDate;
    nextStartDate = addMinutes(nextDate, v2.minSeparation);
    nextEndDate = addMinutes(nextDate, v2.maxSeparation);
    nextDiffDays = Math.abs(differenceInDays(v1.selectedDate, nextEndDate));
  } else if (v1.mainVenueId && v1.mainVenueId === v2.venueId) {
    nextDate = v1.selectedDate;
    nextStartDate = subMinutes(nextDate, v1.maxSeparation);
    nextEndDate = subMinutes(nextDate, v1.minSeparation);
    nextDiffDays = Math.abs(differenceInDays(v1.selectedDate, nextStartDate));
  } else {
    nextDate = v1.duration ? addMinutes(v1.selectedDate, v1.duration) : v1.selectedDate;
    nextStartDate = addMinutes(nextDate, v2.minSeparation);
    nextEndDate = addMinutes(nextDate, v2.maxSeparation);
    nextDiffDays = Math.abs(differenceInDays(v1.selectedDate, nextEndDate));
  }
  const forwardRange = {
    startDate: nextStartDate,
    endDate: nextEndDate,
    diffDays: nextDiffDays,
    showDaySelector: nextDiffDays > 0,
    tag: "forward"
    // Helper
  };
  updatedRangeList = [...updatedRangeList, forwardRange];
  return updatedRangeList;
};
const getRanges = (v2Index, v2, previousSelectedList) => (vc2) => {
  let rangeList = [];
  if (v2Index <= 0 || !previousSelectedList || !Object.keys(previousSelectedList).length) {
    const initialRange = {
      diffDays: 0,
      showDaySelector: true
    };
    rangeList = [...rangeList, initialRange];
  } else {
    let currentIndex = v2Index;
    while (currentIndex > 0) {
      const selected1 = previousSelectedList[currentIndex - 1];
      const { venue: v1, venueCapacity: vc1, event: e1 } = selected1;
      const vc2Duration = vc2 && vc2.duration || Math.min(...v2.venueCapacityList.map((vc) => vc.duration || 0));
      const e1StartDateTime = new Date(e1.startDatetime);
      const v1Conditionals = {
        selectedDate: e1StartDateTime,
        venueId: v1.venueId,
        name: v1.name,
        mainVenueId: v1.mainVenueId,
        minSeparation: v1.minSeparation,
        maxSeparation: v1.maxSeparation,
        minBeforeSeparation: v1.minBeforeSeparation,
        maxBeforeSeparation: v1.maxBeforeSeparation,
        duration: vc1.duration || 0
      };
      const v2Conditionals = {
        venueId: v2.venueId,
        name: v2.name,
        mainVenueId: v2.mainVenueId,
        minSeparation: v2.minSeparation,
        maxSeparation: v2.maxSeparation,
        minBeforeSeparation: v2.minBeforeSeparation,
        maxBeforeSeparation: v2.maxBeforeSeparation,
        duration: vc2Duration
      };
      rangeList = [...rangeList, ...getAvailableRanges(v1Conditionals, v2Conditionals)];
      currentIndex--;
    }
  }
  return rangeList;
};
const filterEventWithRanges = (vc2EventList = [], rangeList = []) => {
  let filteredEvents;
  if (rangeList && rangeList.length) {
    filteredEvents = vc2EventList.map((e) => {
      if (rangeList.some(
        (range) => isDateInRange$1({
          date: e.startDatetime,
          startDatetime: range.startDate,
          endDatetime: range.endDate
        })
      )) {
        return e;
      }
      return { ...e, status: "disabled" };
    });
  } else {
    filteredEvents = vc2EventList;
  }
  return filteredEvents;
};
const getStartDate = ({ now, calendarStart, minNumDays }) => {
  let startDate = calendarStart ? max(calendarStart, now) : now;
  let newMinNumDays = minNumDays;
  if (newMinNumDays) {
    newMinNumDays -= differenceInDays(startDate, now);
    startDate = newMinNumDays > 0 ? addDays(startDate, newMinNumDays) : startDate;
  }
  return startDate;
};
const getEndDate = ({
  calendarType,
  openingDate,
  numPeriods,
  periodType,
  calendarEnd,
  now
}) => {
  if (calendarType === CalendarType.CALENDAR) {
    return endOfDay(openingDate);
  }
  if (calendarEnd) {
    return min(applyPeriod(now, periodType, Number(numPeriods)), endOfDay(calendarEnd));
  }
  return applyPeriod(now, periodType, Number(numPeriods));
};
function addOrUpdateEvent(event, state) {
  const { events: events2 } = state.cart;
  if (state.cart && event) {
    const foundEventIndex = events2.findIndex((e) => event.venueId === e.venueId);
    const newEvents = [...events2];
    if (foundEventIndex === -1) {
      newEvents.push(event);
    } else {
      newEvents[foundEventIndex] = event;
    }
    return newEvents;
  }
  return void 0;
}
function hasPricingForMonth(datesPricing, year, month) {
  return Object.keys(datesPricing || {}).some((dateKey) => {
    const dateObj = new Date(dateKey);
    return dateObj.getFullYear() === year && dateObj.getMonth() + 1 === month;
  });
}
function getAvailableDateRange(dateStatusMap) {
  const today = moment().startOf("day");
  const availableDates = Object.keys(dateStatusMap).filter((date) => dateStatusMap[date] === "availability").sort();
  const startDate = availableDates.find((date) => moment(date).isSameOrAfter(today));
  const endDate = availableDates[availableDates.length - 1];
  return { startDate, endDate };
}
function getValidDates({
  isOpenDate = false,
  // boolean
  isOpenTime = false,
  // boolean
  calendarType,
  // CalendarType
  calendarDate,
  // Date
  periodStartType,
  // PeriodType
  periodStartValue,
  // int
  periodEndType,
  // PeriodType
  periodEndValue,
  // int
  defaultStartDate,
  // Date
  defaultEndDate,
  // Date
  timeZone
}) {
  if (isOpenDate) {
    switch (calendarType) {
      case CalendarType.CALENDAR:
        return setCalendarValidDate({
          calendarDate,
          startDate: periodStartType ? getDateToPeriodicValues({
            periodType: periodStartType,
            periodValue: periodStartValue,
            period: Period.START
          }) : /* @__PURE__ */ new Date(),
          periodStartType,
          periodStartValue
        });
      case CalendarType.PERIODIC:
        return setPeriodicValidDate({
          periodStartType,
          periodStartValue,
          periodEndType,
          periodEndValue
        });
      case CalendarType.EVENT:
        return setEndValidDateFromEventStart({
          defaultStartDate: moment.tz(defaultStartDate, timeZone).format(DATE_FORMAT_YMD),
          periodEndType,
          periodEndValue,
          calendarDate,
          timeZone
        });
      default:
        throw new Error(`Unknown CalendarType: ${calendarType}`);
    }
  } else if (isOpenTime) {
    return {
      [START_DATE]: defaultStartDate,
      [END_DATE]: defaultEndDate
    };
  } else {
    return {
      [START_DATE]: defaultStartDate,
      [END_DATE]: defaultEndDate
    };
  }
}
const EventUtils = {
  CalendarType,
  PeriodType,
  Period,
  PeriodTypeFn,
  START_DATE,
  END_DATE,
  applyPeriod,
  getValidDates,
  getEndDate,
  getStartDate,
  getDateToPeriodicValues,
  setCalendarValidDate,
  setPeriodicValidDate,
  setEndValidDateFromEventStart,
  getEventGroupList,
  getAvailableRanges,
  getRanges,
  filterEventWithRanges,
  getAvailableDateRange,
  hasPricingForMonth
};
class EventsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventList: [],
      eventGroupList: [],
      eventGroupId: null
    };
  }
  componentDidMount() {
    const { initialEvent, initialVenueCapacity } = this.props;
    if (initialEvent) {
      this.setState({
        selectedEvent: initialEvent,
        selectedVenueCapacity: initialVenueCapacity ?? void 0
      });
      this.handleSelect(initialEvent);
    }
    this.handleGetEvents();
  }
  componentDidUpdate(prevProps) {
    const { selectedDate: selectedDatePrev, eventList: eventListPrev } = prevProps;
    const { eventList, selectedDate } = this.props;
    const { selectedVenueCapacity } = this.state;
    const newEventList = eventList;
    const eventsHasChanged = !_isEqual(newEventList, eventListPrev);
    const selectedDateHasChanged = selectedDatePrev !== selectedDate;
    if (selectedDateHasChanged) {
      this.handleGetEvents();
    }
    if (eventsHasChanged && newEventList) {
      const filteredEvents = newEventList.filter((event) => event.venueCapacityId === selectedVenueCapacity);
      const eventGroupList = getEventGroupList(
        filteredEvents,
        12
      );
      const selectedEventGroupId = eventGroupList[0] && eventGroupList[0].eventGroupId ? eventGroupList[0].eventGroupId : null;
      this.setState({
        eventList: filteredEvents,
        eventGroupList,
        eventGroupId: selectedEventGroupId
      });
    }
  }
  handleSelect = (eventId) => {
    const { venue, handleOnChangeEvent, eventMap, product, salesGroup } = this.props;
    handleOnChangeEvent({
      venueId: venue.venueId,
      event: eventMap[eventId] || eventId,
      productId: product.productId,
      salesGroupId: salesGroup.salesGroupId
    });
  };
  onChangeEventGroup = (eventGroupIdProp) => {
    const { eventGroupId } = this.state;
    if (eventGroupIdProp === eventGroupId) return;
    this.setState({
      eventGroupId: eventGroupIdProp
    });
  };
  onChangeVenueCapacity = (venueCapacityIdProp) => {
    const { venueCapacityId, eventsThreshold, maxDisplayAvailability } = this.state;
    if (venueCapacityIdProp === venueCapacityId && eventsThreshold && maxDisplayAvailability) {
      return;
    }
    const { eventList } = this.props;
    const filteredEvents = (eventList ?? []).filter((event) => event.venueCapacityId === venueCapacityIdProp);
    const venueCapacity = this.getSelectedVenueCapacity(venueCapacityIdProp);
    const { eventsThreshold: vnEventsThreshold, maxDisplayAvailability: vnMaxDisplayAvailability } = venueCapacity ?? {};
    const eventGroupList = getEventGroupList(
      filteredEvents,
      vnEventsThreshold ?? 12
    );
    this.setState({
      eventList: filteredEvents,
      eventGroupList: eventGroupList || [],
      selectedVenueCapacity: venueCapacityIdProp,
      eventsThreshold: vnEventsThreshold,
      maxDisplayAvailability: vnMaxDisplayAvailability
    });
  };
  /** check if event is disabled */
  checkDisabled = ({ totalAvailability, status }) => {
    const { totalTickets, selectedDate } = this.props;
    const { selectedEvent } = this.state;
    const initialEvent = selectedEvent;
    return totalAvailability <= 0 || status === "disabled" || !_isEqual(selectedDate, initialEvent?.startDatetime) && totalAvailability < (totalTickets ?? 0);
  };
  handleGetEvents = () => {
    const {
      selectedDate,
      handleFetchEventsByVenue,
      venue,
      product,
      salesGroup,
      mapVenueEvent,
      timeZone,
      enableCaptcha,
      pointOfSale
    } = this.props;
    let mapVenueEventObject = {};
    const venueWithData = product.productVenueSet.find((pv) => pv.venueId === venue.venueId);
    if (venueWithData && venueWithData.displayOrder !== 0) {
      mapVenueEventObject = Object.entries(mapVenueEvent ?? {}).reduce(
        (acc, [venueId, event]) => {
          return {
            ...acc,
            [venueId]: event.eventId
          };
        },
        {}
      );
    }
    if (enableCaptcha) {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(window.serviceUrls.reCaptchaKey, {
          action: "getAvailability"
        }).then((token2) => {
          handleFetchEventsByVenue({
            productId: product.productId,
            salesGroupId: salesGroup.salesGroupId,
            startDateFrom: moment.tz(selectedDate, timeZone ?? "").format(DATE_FORMAT_YMD),
            startDateTo: moment.tz(selectedDate, timeZone ?? "").format(DATE_FORMAT_YMD),
            venueId: venue.venueId,
            selectedEvents: JSON.stringify(mapVenueEventObject),
            action: pointOfSale?.allowSellAndEditPastEvents ? "edit" : "",
            timeZone,
            recaptcha: token2
          });
        });
      });
    } else {
      handleFetchEventsByVenue({
        productId: product.productId,
        salesGroupId: salesGroup.salesGroupId,
        startDateFrom: moment.tz(selectedDate, timeZone ?? "").format(DATE_FORMAT_YMD),
        startDateTo: moment.tz(selectedDate, timeZone ?? "").format(DATE_FORMAT_YMD),
        venueId: venue.venueId,
        action: pointOfSale?.allowSellAndEditPastEvents ? "edit" : "",
        selectedEvents: JSON.stringify(mapVenueEventObject),
        timeZone
      });
    }
  };
  getSelectedEventGroup = () => {
    const { eventGroupId, eventGroupList } = this.state;
    let selectedEventGroup;
    if (eventGroupList && eventGroupList.length) {
      if (eventGroupId) {
        selectedEventGroup = eventGroupList.find((eg) => eg.eventGroupId === eventGroupId);
      }
    }
    return selectedEventGroup;
  };
  getSelectedVenueCapacity = (venueCapacityId) => {
    const { venueCapacityMap } = this.props;
    return venueCapacityMap && venueCapacityMap[venueCapacityId];
  };
  render() {
    const {
      eventProductInfo,
      venue,
      selectedEvent,
      venueCapacityMap,
      initialVenueCapacity,
      product,
      store,
      showRealAvailability = false,
      currency,
      eventList: eventListProps
    } = this.props;
    const { eventGroupList, eventList, initialEvent, eventGroupId, selectedVenueCapacity } = this.state;
    const { venueCapacityList } = venue;
    const currentVenueCapacity = selectedVenueCapacity || initialVenueCapacity;
    const currentVC = venueCapacityMap[currentVenueCapacity] ?? {};
    const { maxDisplayAvailability, thresholdHighAvailability, thresholdMediumAvailability, onlyAccessTime } = currentVC;
    const selectedEventGroup = this.getSelectedEventGroup();
    const selectedEventId = selectedEvent ? selectedEvent && selectedEvent.eventId : initialEvent && initialEvent.initialEvent;
    return (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      /* @__PURE__ */ jsxRuntimeExports.jsx(Provider, { store, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        eventProductInfo && eventProductInfo.top,
        eventList && venueCapacityList && /* @__PURE__ */ jsxRuntimeExports.jsx(
          VenueCapacityProvider,
          {
            venueCapacityList,
            venueCapacityId: selectedVenueCapacity,
            onChangeVenueCapacity: this.onChangeVenueCapacity,
            eventListTotal: eventListProps || [],
            children: ({ options, selected, handleSelect: vcHandleSelect }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              VenueCapacitySelector,
              {
                options,
                selected,
                handleSelect: vcHandleSelect
              }
            )
          }
        ),
        eventGroupList && eventGroupList.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
          EventGroupSelector,
          {
            eventGroupList,
            handleSelect: this.onChangeEventGroup,
            selected: eventGroupId ?? void 0
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          EventSelector,
          {
            showRealAvailability,
            ignoreSold: product.ignoreSold,
            eventList: selectedEventGroup && selectedEventGroup.events,
            initialEvent,
            selected: selectedEventId,
            handleSelect: this.handleSelect,
            thresholdHighAvailability,
            thresholdMediumAvailability,
            maxDisplayAvailability,
            checkDisabled: (event) => this.checkDisabled({ totalAvailability: event.totalAvailability, status: event.status ?? "" }),
            onlyAccessTime,
            currency
          }
        ),
        eventProductInfo && eventProductInfo.bottom
      ] }) })
    );
  }
}
function mapStateToProps$r(state, ownProps) {
  const { venue, timeZone } = ownProps;
  const { events: events2, editReservation: editReservation2, promotions: promotions2, pointOfSales } = state;
  const { promotionList } = promotions2;
  const { selectedDatesPerVenue, selectedEventPerVenue } = editReservation2;
  const selectedDateForVenue = selectedDatesPerVenue[venue.venueId];
  const selectedEventForVenue = selectedEventPerVenue[venue.venueId];
  const eventsByVenue = events2.eventsByVenue ?? {};
  const eventMap = {};
  const venueCapacityMap = {};
  const { clientList } = pointOfSales;
  const eventPromos = promotionList.filter((p) => p.promotionType === "event");
  const newEventByVenue = eventsByVenue[venue.venueId] && eventsByVenue[venue.venueId].map((event) => ({
    ...event,
    hasPromotion: hasPromotion(
      eventPromos,
      event,
      [venue],
      timeZone ?? ""
    )
  }));
  const venueEvents = eventsByVenue[venue.venueId];
  if (venueEvents) {
    venueEvents.forEach((event) => {
      eventMap[event.eventId] = event;
    });
  }
  venue.venueCapacityList.forEach((venueCapacity) => {
    const vc = venueCapacity;
    venueCapacityMap[vc.venueCapacityId] = vc;
  });
  const selectedEvents = Object.entries(selectedEventPerVenue).reduce(
    (prev, [key, value]) => {
      return {
        ...prev,
        [key]: value.eventId
      };
    },
    {}
  );
  return {
    eventList: newEventByVenue,
    currency: clientList[0].currencyList[0].isoCode,
    eventMap,
    venueCapacityMap,
    selectedEvents,
    selectedDate: selectedDateForVenue,
    selectedEvent: selectedEventForVenue,
    pointOfSale: pointOfSales.pointOfSale
  };
}
function mapDispatchToProps$h(dispatch) {
  return {
    handleFetchEventsByVenue: ({
      productId,
      salesGroupId,
      startDateFrom,
      startDateTo,
      venueId,
      selectedEvents,
      timeZone,
      recaptcha,
      action
    }) => {
      dispatch(
        fetchEventsByVenue({
          productId,
          salesGroupId,
          startDateFrom,
          startDateTo,
          venueId,
          selectedEvents,
          timeZone,
          recaptcha,
          action
        })
      );
    },
    handleOnChangeEvent: ({ venueId, event, productId, salesGroupId }) => {
      const eventObj = event;
      if (!eventObj.totalAvailability) {
        dispatch(
          fetchEvent(eventObj.eventId, productId, salesGroupId, {
            hideSold: false,
            action: "list",
            includeDisabled: true
          })
        ).then(({ response }) => {
          dispatch(setSelectedEventForVenue({ venueId, event: response }));
        });
      } else {
        dispatch(setSelectedEventForVenue({ venueId, event: eventObj }));
      }
    }
  };
}
const EventsContainer_default = connect(mapStateToProps$r, mapDispatchToProps$h)(EventsContainer);
function InfoType({ infoType }) {
  let infoTypeIcon;
  switch (infoType.messageClass) {
    case "cl_info":
      infoTypeIcon = "icon-own-info_outline";
      break;
    case "cl_warning":
      infoTypeIcon = "icon-own-error_outline";
      break;
    case "cl_danger":
      infoTypeIcon = "icon-own-error_outline";
      break;
    case "cl_error":
      infoTypeIcon = "icon-own-highlight_off";
      break;
    default:
      infoTypeIcon = "";
  }
  if (infoType.icon && infoType.icon !== "noIcon") {
    infoTypeIcon = infoType.icon;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `special-info ${infoType.messageClass}`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "desc", children: [
    !infoType.hideTitle && /* @__PURE__ */ jsxRuntimeExports.jsxs("h4", { children: [
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: infoTypeIcon }),
      " ",
      infoType.name,
      " "
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: infoType.description } })
  ] }) });
}
const getProductInfos = (productInfo, infoType) => productInfo?.filter((element) => element.infoType === infoType);
const getProductInfoMap = (productInfoList = [], key) => {
  const topInfo = productInfoList.filter(({ infoType }) => infoType.startsWith(key) && infoType.endsWith("top"));
  const bottomInfo = productInfoList.filter(({ infoType }) => infoType.startsWith(key) && infoType.endsWith("bottom"));
  return {
    top: topInfo && topInfo.sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)).map((info, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(InfoType, { infoType: info }, index2)),
    bottom: bottomInfo && bottomInfo.sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)).map((info, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(InfoType, { infoType: info }, index2))
  };
};
const getProductConfigurationMap = (productConfigurations = [], key) => productConfigurations.filter((productConfiguration) => productConfiguration.configKey.includes(key));
class BuyerTypesContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketsSelected: null
    };
    this.handleSelection = this.handleSelection.bind(this);
  }
  componentDidMount() {
    const { ticketList, getBuyerTypeName } = this.props;
    const initialTickets = ticketList.reduce(
      (all, nextValue) => {
        const count = all[String(nextValue.buyerTypeId)] ? all[String(nextValue.buyerTypeId)].n + 1 : 1;
        return {
          ...all,
          [nextValue.buyerTypeId]: {
            buyerTypeId: nextValue.buyerTypeId,
            name: getBuyerTypeName ? getBuyerTypeName(nextValue.buyerTypeId) : "",
            n: count
          }
        };
      },
      {}
    );
    this.getPrices();
    this.setState(
      {
        ticketsSelected: initialTickets
      },
      () => this.handleSelection({ selected: initialTickets })
    );
  }
  componentDidUpdate(prevProps) {
    const { selectedEventPerVenue, dispatch, salesGroupId, productId, selectedDatesPerVenue, mainVenue, event } = this.props;
    const {
      selectedEventPerVenue: prevSelected,
      selectedDatesPerVenue: prevSelectedDates,
      mainVenue: prevMainVenue
    } = prevProps;
    const venueId = mainVenue ? mainVenue.venueId : void 0;
    if (selectedEventPerVenue && !isEmpty(prevSelected) && !isEmpty(prevMainVenue) && venueId !== void 0 && !isEmpty(prevSelected[venueId]) && prevSelected[venueId]?.eventId !== selectedEventPerVenue[venueId]?.eventId) {
      dispatch(
        fetchBuyerTypesWithPrice({
          salesGroupId,
          productId,
          date: selectedEventPerVenue[venueId].startDatetime,
          eventId: event ? event.eventId : void 0
        })
      );
    }
    if (isEmpty(selectedEventPerVenue) && !isEmpty(selectedDatesPerVenue) && !_isEqual(prevSelectedDates, selectedDatesPerVenue)) {
      dispatch(
        fetchBuyerTypesWithPrice({
          salesGroupId,
          productId,
          date: venueId !== void 0 ? moment(selectedDatesPerVenue[venueId]).toISOString() : "",
          eventId: event ? event.eventId : void 0
        })
      );
    }
  }
  handleSelection(newSelection) {
    const { dispatch } = this.props;
    dispatch(setSelectedBuyerTypes(newSelection.selected));
  }
  getPrices() {
    const { dispatch, salesGroupId, productId, eventStartDatetime, event } = this.props;
    dispatch(
      fetchBuyerTypesWithPrice({
        salesGroupId,
        productId,
        date: eventStartDatetime,
        eventId: event ? event.eventId : void 0
      })
    );
  }
  render() {
    const {
      buyerTypesMap,
      productInfo,
      promotionList,
      minTickets,
      maxTickets,
      store,
      event,
      sellerIdSelected,
      app,
      product,
      showBuyerTypesAsSelect,
      maxTicketsBySalesGroup,
      currency
    } = this.props;
    const { ticketsSelected } = this.state;
    const headerText = /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormattedMessage,
      {
        id: "buyerTypes.helpMessage",
        description: "Help to select buyer types",
        defaultMessage: `Selecciona el número de personas e indica el tipo de entrada. El
        número máximo de entradas debe estar comprendido entre {minTickets} y {maxTickets}.`,
        values: {
          minTickets,
          maxTickets
        },
        tagName: "p"
      }
    );
    return (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      /* @__PURE__ */ jsxRuntimeExports.jsx(Provider, { store, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: ticketsSelected && Object.keys(buyerTypesMap).length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
        BuyerTypeSelector$1,
        {
          headerText,
          buyerTypesMap,
          productInfo,
          handleSelection: this.handleSelection,
          promotionList,
          ticketsSelected,
          minTickets,
          maxTickets,
          maxTicketsBySalesGroup,
          isEditMode: true,
          event: event || void 0,
          sellerIdSelected,
          hidePrice: product.priceByPackage,
          showBuyerTypesAsSelect,
          currency,
          app
        }
      ) }) })
    );
  }
}
function mapStateToProps$q(state, ownProps) {
  const { editReservation: editReservation2, products: products2, pointOfSales } = state;
  const { app } = ownProps;
  const { productInfoList, productList = [] } = products2;
  const { clientList } = pointOfSales;
  const currency = clientList[0].currencyList[0].isoCode;
  const { initialReservationState, selectedEventPerVenue, selectedDatesPerVenue } = editReservation2;
  const initialState2 = initialReservationState;
  const { salesGroupId, productId, eventStartDatetime, ticketList, eventId, currentTicketNum } = initialState2;
  const initialSelectedEvent = initialState2.selectedEventPerVenue;
  const ticketsRange = getTicketsRangeEdit(state);
  const { minTickets, maxTicketsBySalesGroup } = ticketsRange;
  let { maxTickets } = ticketsRange;
  const venuesMap = getVenueMap(state);
  const mainVenue = !isEmpty(venuesMap) && Object.values(venuesMap).find((venue) => !venue?.mainVenueId) || false;
  const venueId = mainVenue ? mainVenue.venueId : void 0;
  let event = !isEmpty(selectedEventPerVenue) && !isEmpty(mainVenue) && venueId !== void 0 && selectedEventPerVenue[venueId];
  if (!event) {
    event = !isEmpty(initialSelectedEvent) && !isEmpty(mainVenue) && venueId !== void 0 && initialSelectedEvent[venueId];
  }
  const initialEventsIds = Object.values(initialSelectedEvent).map((item) => item.eventId).sort();
  const eventsIds = Object.values(selectedEventPerVenue ?? {}).map((item) => item.eventId).sort();
  if (_isEqual(initialEventsIds, eventsIds)) {
    maxTickets = (maxTickets ?? 0) + currentTicketNum;
  } else {
    let ticketsToSum = 0;
    Object.values(selectedEventPerVenue ?? {}).some((selectedEvent) => {
      const isInInitialEvents = initialEventsIds.find((initial) => initial === selectedEvent.eventId);
      if (isInInitialEvents) {
        ticketsToSum = currentTicketNum;
        return true;
      }
      return false;
    });
    maxTickets = (maxTickets ?? 0) + ticketsToSum;
  }
  return {
    salesGroupId,
    productId,
    eventStartDatetime,
    ticketList,
    minTickets,
    maxTickets: (maxTickets ?? 0) < currentTicketNum ? currentTicketNum : maxTickets ?? 0,
    maxTicketsBySalesGroup,
    buyerTypesMap: getBuyerTypeMap(state),
    productInfo: getProductInfoMap(
      productInfoList,
      "buyer_types"
    ),
    promotionList: app === "seller" ? getSellerPromoListEdit(state) : getPromotionListWithCodeIfApply(state),
    selectedEventPerVenue: selectedEventPerVenue ?? {},
    selectedDatesPerVenue: selectedDatesPerVenue ?? {},
    eventId,
    event,
    mainVenue,
    product: productList[0],
    currency
  };
}
const BuyerTypesContainer_default = connect(mapStateToProps$q)(BuyerTypesContainer);
function FormField({
  input,
  label,
  type,
  placeholder,
  className,
  required,
  maxLength: maxLength2,
  meta: { touched, error, valid },
  ...rest
}) {
  const [focused, setFocused] = useState(false);
  const labelIsUp = focused || touched || !!input.value;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: validationControl(valid, touched, type ?? "", input.value), children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-custom", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        ...input,
        className,
        type,
        id: `contact-${input.name}`,
        required,
        maxLength: maxLength2,
        placeholder: labelIsUp ? placeholder : void 0,
        "aria-invalid": touched && required,
        onFocus: (e) => {
          setFocused(true);
          input.onFocus(e);
        },
        onBlur: (e) => {
          setFocused(false);
          input.onBlur(e);
        },
        ...rest
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { htmlFor: `contact-${input.name}`, children: [
      label,
      " ",
      required ? /* @__PURE__ */ jsxRuntimeExports.jsx("em", { children: "*" }) : null
    ] }),
    touched && error ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block error", children: error }) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block" })
  ] }) });
}
function FormSelectBasicField({
  input,
  label,
  type,
  placeholder,
  className,
  required,
  options,
  meta: { touched, error, warning: warning2, valid },
  ...rest
}) {
  const [focused, setFocused] = useState(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: validationControl(valid, touched, type ?? "", input.value), children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-custom select", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "select",
      {
        ...input,
        className,
        id: `contact-${input.name}`,
        required,
        "aria-invalid": touched && required,
        onFocus: (e) => {
          setFocused(true);
          input.onFocus(e);
        },
        onBlur: (e) => {
          setFocused(false);
          input.onBlur(e);
        },
        ...rest,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "", disabled: true, hidden: true, children: (focused || touched) && !input.value && placeholder ? placeholder : "" }),
          options.map((option, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: option.value, children: option.label }, index2))
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { htmlFor: `contact-${input.name}`, children: [
      label,
      " ",
      required ? /* @__PURE__ */ jsxRuntimeExports.jsx("em", { children: "*" }) : null
    ] }),
    touched && (required ? error && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block error", children: error }) : (
      // TODO: refine — original logic: <span> is always truthy so warning branch is unreachable
      /* @ts-expect-error TS2872: preserved from original JS — span is always truthy */
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block" }) || warning2 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block", children: warning2 })
    ))
  ] }) });
}
function scrollToStartAndFocus(sectionRef) {
  const el = sectionRef.current;
  if (!el) return;
  const fixedElements = document.querySelectorAll('header, nav, [style*="position: fixed"]');
  let totalFixedHeight = 0;
  fixedElements.forEach((element) => {
    const rect = element.getBoundingClientRect();
    if (rect.top === 0) {
      totalFixedHeight += rect.height;
    }
  });
  const elementPosition = el.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - totalFixedHeight - 20;
  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
}
function isMobileDevice() {
  return window.matchMedia("(max-width: 768px)").matches;
}
const requiredErrorMessage = (value) => value ? void 0 : /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Required", id: "error.helper.required" });
const maxLength = (number2) => function maxLengthValidator(value) {
  const str = typeof value === "string" ? value : "";
  return !str || str.length <= number2 ? void 0 : /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormattedMessage,
    {
      defaultMessage: "Maximum {limit} characters",
      id: "error.helper.maxLength",
      values: { limit: number2 }
    }
  );
};
const maxLengthMessage128 = maxLength(128);
const identity = (value) => value;
const buildRegexValidator = (pattern, transform = identity) => function regexValidatorFn(value) {
  if (!value) return void 0;
  let regex;
  try {
    regex = new RegExp(pattern, "i");
  } catch (e) {
    console.error("Invalid regexValidation pattern:", pattern, e);
    return void 0;
  }
  return regex.test(transform(String(value))) ? void 0 : /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Invalid format", id: "error.helper.valid.format" });
};
const regexValidatorCache = /* @__PURE__ */ new Map();
const regexValidator$1 = (pattern) => {
  const cached = regexValidatorCache.get(pattern);
  if (cached) return cached;
  const validator = buildRegexValidator(pattern);
  regexValidatorCache.set(pattern, validator);
  return validator;
};
const dateRegexValidatorCache = /* @__PURE__ */ new Map();
const dateRegexValidator = (pattern) => {
  const cached = dateRegexValidatorCache.get(pattern);
  if (cached) return cached;
  const validator = buildRegexValidator(pattern, (value) => {
    const parsed = moment(value, DATE_FORMAT_YMD, true);
    return parsed.isValid() ? parsed.format("DD/MM/YYYY") : value;
  });
  dateRegexValidatorCache.set(pattern, validator);
  return validator;
};
const byDisplayOrder = (a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0);
function ErrorBlock({ error }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block error", children: error });
}
function getOptions(n) {
  const options = [];
  let index2 = n;
  while (index2) {
    options.push({ label: n, value: n });
    index2--;
  }
  return options;
}
function SelectFields({
  fields,
  meta: { error },
  label,
  required,
  options,
  maxQty,
  idx,
  placeholder,
  regexValidation
}) {
  const values = fields.getAll();
  const optionsValue = options.toString().split(",").map((option) => {
    const [
      name,
      id2
      /* value = name */
    ] = option.split("::");
    return {
      label: name,
      value: id2 || option
    };
  });
  let nDiff = maxQty;
  if (values && values.length) {
    nDiff = values.reduce((acc, { qty = 0 }) => acc - Number(qty), maxQty);
  }
  const optionsQty = getOptions(nDiff);
  if (!fields.length && optionsQty[0] && optionsValue[0]) {
    fields.push({
      value: "",
      qty: optionsQty[optionsQty.length - 1].value
      // Min value by default
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    error && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-custom", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBlock, { error }) }),
    fields.map((member, index2) => {
      const fValue = values[index2];
      const memberOptionsValue = optionsValue.filter(
        (option) => values.filter((v) => v.value !== fValue.value).map((v) => v.value).indexOf(option.value) === -1
      );
      const blocks = Math.round(label.length / 16);
      const lengthElement = blocks > 4 ? blocks : 4;
      const validationArray = [];
      if (required) validationArray.push(requiredErrorMessage);
      if (regexValidation) validationArray.push(regexValidator$1(regexValidation));
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `form-group form-custom col-md-${lengthElement} field-order-${idx}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Field,
        {
          name: `${member}.value`,
          component: FormSelectBasicField,
          className: "form-control",
          label,
          required,
          options: memberOptionsValue,
          placeholder,
          validate: validationArray.length ? validationArray : void 0,
          clearable: "false"
        }
      ) }, member);
    })
  ] });
}
function TextFields({
  fields,
  label,
  required,
  type,
  maxQty,
  idx,
  placeholder,
  regexValidation
}) {
  if (!fields.length) {
    for (let i = 0; i <= maxQty; i++) {
      fields.push({});
    }
  } else if (maxQty > fields.length) {
    for (let i = 0; i <= maxQty - fields.length; i++) {
      fields.push({});
    }
  } else if (maxQty < fields.length) {
    for (let i = 0; i <= fields.length - maxQty; i++) {
      fields.remove(fields.length - 1);
    }
  }
  const validationArray = [maxLengthMessage128];
  if (required) validationArray.push(requiredErrorMessage);
  if (regexValidation) validationArray.push(regexValidator$1(regexValidation));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: fields.map((member, index2) => {
    const blocks = Math.round(label.length / 16);
    const lengthElement = blocks > 4 ? blocks : 4;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: `form-group form-custom col-md-${lengthElement} field-order-${idx}`,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Field,
          {
            name: `${member}.value`,
            type,
            component: FormField,
            label,
            required,
            className: "form-control",
            placeholder,
            validate: validationArray
          }
        )
      },
      `form-group-${index2}`
    );
  }) });
}
function DatePickerField({
  input,
  label,
  required,
  dataValidation,
  placeholder,
  regexValidation,
  meta: { touched, error, valid }
}) {
  const [focused, setFocused] = useState(false);
  const [hasInvalidRawInput, setHasInvalidRawInput] = useState(false);
  const wrapperRef = useRef(null);
  const dateValue = input.value ? moment(input.value) : null;
  const isMobile = typeof window !== "undefined" && isMobileDevice();
  const locale = typeof window !== "undefined" ? getAppLocale() : "en";
  initMomentLocale(locale);
  const { displayFormat, firstDayOfWeek } = getCalendarLocaleConfig(locale);
  const currentYear = moment().year();
  const years = Array.from({ length: 120 }, (_, i) => currentYear - i);
  const showInvalidRawInputError = !!regexValidation && hasInvalidRawInput && !input.value;
  const validClass = () => {
    if (!valid && touched || showInvalidRawInputError) return "has-error";
    if (valid && touched) return "has-success";
    if (input.value) return "has-value";
    return "";
  };
  const labelIsUp = focused || touched || !!input.value;
  const isBirthDateValidation = dataValidation === "birth_date";
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: validClass(), children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-custom date-picker-form-field", ref: wrapperRef, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SingleDatePicker$1,
      {
        id: `contact-${input.name}`,
        date: dateValue,
        onDateChange: (date) => {
          const formatted = date ? date.format(DATE_FORMAT_YMD) : null;
          input.onChange(formatted);
          setTimeout(() => input.onBlur(formatted), 0);
        },
        focused,
        onFocusChange: ({ focused: isFocused }) => {
          setFocused(isFocused);
          if (isFocused) {
            setHasInvalidRawInput(false);
            return;
          }
          const rawValue = wrapperRef.current?.querySelector("input")?.value ?? "";
          setHasInvalidRawInput(!!rawValue.trim() && !input.value);
        },
        numberOfMonths: 1,
        initialVisibleMonth: () => dateValue || moment(),
        isOutsideRange: isBirthDateValidation ? (day) => day.isAfter(moment().endOf("day")) : () => false,
        withPortal: isMobile,
        withFullScreenPortal: false,
        hideKeyboardShortcutsPanel: true,
        displayFormat,
        firstDayOfWeek,
        placeholder: labelIsUp ? placeholder : " ",
        readOnly: isMobile,
        noBorder: true,
        block: true,
        renderMonthElement: ({ month, onMonthSelect, onYearSelect }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "date-picker-month-year-selectors", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("select", { value: month.month(), onChange: (e) => onMonthSelect(month, e.target.value), children: moment.months().map((monthLabel, value) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value, children: monthLabel }, value)) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("select", { value: month.year(), onChange: (e) => onYearSelect(month, e.target.value), children: years.map((yr) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: yr, children: yr }, yr)) })
        ] })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { htmlFor: `contact-${input.name}`, children: [
      label,
      " ",
      required ? /* @__PURE__ */ jsxRuntimeExports.jsx("em", { children: "*" }) : null
    ] }),
    touched && error || showInvalidRawInputError ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block error", children: error ?? /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Invalid format", id: "error.helper.valid.format" }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block" })
  ] }) });
}
function DateFields({
  fields,
  label,
  required,
  maxQty,
  idx,
  dataValidation,
  placeholder,
  regexValidation
}) {
  const diff2 = maxQty - fields.length;
  if (diff2 > 0) {
    for (let i = 0; i < diff2; i++) fields.push({});
  } else if (diff2 < 0) {
    for (let i = 0; i < Math.abs(diff2); i++) fields.remove(fields.length - 1);
  }
  const validationArray = required ? [requiredErrorMessage] : [];
  if (regexValidation) validationArray.push(dateRegexValidator(regexValidation));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: fields.map((member, index2) => {
    const blocks = Math.round(label.length / 16);
    const lengthElement = blocks > 4 ? blocks : 4;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: `form-group form-custom col-md-${lengthElement} field-order-${idx}`,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Field,
          {
            name: `${member}.value`,
            component: DatePickerField,
            label,
            required,
            dataValidation,
            placeholder,
            regexValidation,
            validate: validationArray
          }
        )
      },
      `form-group-date-${index2}`
    );
  }) });
}
const fieldArrayTypeMap = {
  Purchase: {
    select: { component: (props) => SelectFields(props) },
    text: { component: (props) => TextFields(props) },
    date: { component: (props) => DateFields(props) }
  },
  Reservation: {
    select: { component: (props) => SelectFields(props) },
    text: { component: (props) => TextFields(props) },
    date: { component: (props) => DateFields(props) }
  },
  TicketNominal: {
    select: { component: (props) => SelectFields(props) },
    text: { component: (props) => TextFields(props) },
    date: { component: (props) => DateFields(props) }
  }
};
const renderFieldArray = ({
  id: id2,
  label,
  required,
  type,
  maxQty,
  options,
  component,
  ...props
}) => {
  const FA = FieldArray;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FA,
    {
      name: `field-${id2}`,
      component,
      label,
      required,
      type,
      maxQty,
      options,
      ...props
    },
    `fieldarray-${type}-${id2}`
  );
};
function FieldSet({ fieldset, formType, qty, ownerId, answersMap, dispatch, formName }) {
  const key = `form[fs-${fieldset.formFieldsetId}]_owner[${ownerId}]`;
  const realFormType = formType === "Ticket" ? "TicketNominal" : formType;
  const ownerBuyerTypeId = getOwnerBuyerTypeId(formType, ownerId);
  const visibleFields = fieldset.genericFieldSet.filter((field) => isFieldVisibleForBuyerType(field, ownerBuyerTypeId));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormSection, { name: `formsection-${fieldset.formFieldsetId}`, component: Fragment, children: visibleFields.sort(byDisplayOrder).map((field, idx) => {
    const {
      genericFieldId,
      name,
      fieldType,
      required,
      fieldOptions,
      parentFieldOptionsValue,
      parentGenericField,
      dataValidationOptions,
      dataValidation,
      placeholder,
      regexValidation
    } = field;
    if (parentFieldOptionsValue && parentGenericField?.genericFieldId) {
      const sectionAnswers = answersMap?.[`formsection-${fieldset.formFieldsetId}`];
      const parentFieldKey = realFormType === "TicketNominal" ? `field-${parentGenericField.genericFieldId}-${ownerId}` : `field-${parentGenericField.genericFieldId}-0`;
      const parentValue = sectionAnswers?.[parentFieldKey]?.[0]?.value;
      const allowedValues = parentFieldOptionsValue.split(",").map((v) => v.trim());
      const matches = !!parentValue && allowedValues.includes(parentValue);
      if (!matches) {
        const sectionKey = `formsection-${fieldset.formFieldsetId}`;
        const arrayKey = `field-${genericFieldId}-${ownerId}`;
        const sectionBefore = answersMap?.[sectionKey] || {};
        const arrayValues = sectionBefore[arrayKey];
        if (Array.isArray(arrayValues) && arrayValues.length > 0 && typeof dispatch === "function" && formName) {
          const { [arrayKey]: _omit, ...sectionAfter } = sectionBefore;
          dispatch(change2(formName, sectionKey, sectionAfter));
        }
        return null;
      }
    }
    return renderFieldArray({
      id: `${genericFieldId}-${ownerId}`,
      label: name,
      required,
      type: fieldType,
      options: fieldOptions,
      maxQty: qty,
      dataValidation,
      dataValidationOptions,
      placeholder,
      regexValidation,
      component: fieldArrayTypeMap[realFormType][fieldType].component,
      idx
    });
  }) }) }, `fragment_${key}`);
}
class Title extends Component {
  render() {
    const { title, children } = this.props;
    const formTitle = title.trim() ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row TitleRow", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: title }) }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row ChildrenRow", children })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row ChildrenRow", children });
    return formTitle;
  }
}
const renderFieldList = ({ form: form2, ownerId, selectQty, answersMap, dispatch, formName }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldSetList,
  {
    ownerId,
    fieldSetList: form2.formFieldsetSet,
    formType: form2.type,
    qty: selectQty,
    answersMap,
    dispatch,
    formName
  }
);
function Form({ form: form2, ownerList, answersMap, productInfo, dispatch, formName }) {
  const keyForm = `form[${form2.productFormId}]`;
  const formTitle = form2.description;
  if (form2.type === "TicketNominal" || form2.type === "Ticket") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel-body-content", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Title, { title: formTitle, children: [
      productInfo && productInfo.top,
      ownerList.map(
        (owner) => Array.from(new Array(owner.qty).keys()).map((n) => {
          const ownerId = `${owner.id}-${n}`;
          if (!formHasVisibleFieldsForOwner(form2, ownerId)) return null;
          const keyOwner = `owner[${ownerId}]`;
          return /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { title: `${owner.label} ${n > 0 ? n + 1 : ""}`, children: renderFieldList({
            form: form2,
            ownerId,
            selectQty: 1,
            answersMap,
            dispatch,
            formName
          }) }, `title-${keyOwner}`);
        })
      ),
      productInfo && productInfo.bottom
    ] }, `title-${keyForm}`) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel-body-content", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Title, { title: formTitle, children: [
    productInfo && productInfo.top,
    renderFieldList({
      form: form2,
      ownerId: 0,
      selectQty: 1,
      answersMap,
      dispatch,
      formName
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "clearfix" }),
    productInfo && productInfo.bottom
  ] }, `title-${keyForm}`) });
}
const Forms = ({ formlist, ownerList = [], answersMap, productInfo, dispatch, form: formName }) => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: formlist.sort(byDisplayOrder).map((form2, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Form,
  {
    form: form2,
    ownerList,
    answersMap,
    productInfo,
    dispatch,
    formName
  },
  `form-${index2}`
)) });
function FieldSetList({ ownerId, fieldSetList, formType, qty, answersMap, dispatch, formName }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `form-section-list ${formType}`, children: fieldSetList.sort(byDisplayOrder).map((fieldset) => {
    const key = `fieldset-${fieldset.formFieldsetId}_fieldset_${ownerId}`;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FieldSet,
      {
        fieldset,
        formType,
        qty,
        ownerId,
        answersMap,
        dispatch,
        formName
      },
      key
    );
  }) });
}
class FormsContainer extends Component {
  componentDidMount() {
    const { getAnswers } = this.props;
    getAnswers();
  }
  componentDidUpdate(prevProps) {
    const { initialAnswers, reservationFormList, ticketFormList, dispatch, initialTickets, mode } = this.props;
    if (!_isEqual(prevProps.initialAnswers, initialAnswers) && !isEmpty(initialAnswers)) {
      let initialValuesReservationForm = {};
      let initialValuesTicketForm = {};
      if (!isEmpty(initialAnswers) && !isEmpty(reservationFormList)) {
        initialAnswers.forEach((values) => {
          const { field, answer, formSection } = getFormDetails(
            reservationFormList,
            values
          );
          if (!field) return;
          initialValuesReservationForm = {
            ...initialValuesReservationForm,
            [`formsection-${formSection.formFieldsetId}`]: {
              ...initialValuesReservationForm[`formsection-${formSection.formFieldsetId}`],
              [`field-${values.genericFieldId}-0`]: [{ value: answer, qty: 1 }]
            }
          };
        });
        dispatch(initialize2("reservationForm", initialValuesReservationForm));
      }
      if (!isEmpty(initialAnswers) && !isEmpty(ticketFormList)) {
        let count = 0;
        initialAnswers.forEach((values) => {
          const currentTicketId = values.ticketId;
          const buyerTypeIdFromTickets = initialTickets?.find((ticket) => ticket.ticketId === values.ticketId);
          const { field, answer, formSection } = getFormDetails(
            ticketFormList,
            values
          );
          if (!field) return;
          if (buyerTypeIdFromTickets) {
            const sectionKey = `formsection-${formSection.formFieldsetId}`;
            const fieldKey = `field-${values.genericFieldId}-bt-${buyerTypeIdFromTickets.buyerTypeId}-${mode === "edit" ? currentTicketId : count}`;
            if (initialValuesTicketForm && initialValuesTicketForm[sectionKey]?.[fieldKey]) {
              count += 1;
            }
            initialValuesTicketForm = {
              ...initialValuesTicketForm,
              [sectionKey]: {
                ...initialValuesTicketForm[sectionKey],
                [`field-${values.genericFieldId}-bt-${buyerTypeIdFromTickets.buyerTypeId}-${mode === "edit" ? currentTicketId : count}`]: [{ value: answer, ticketId: currentTicketId }]
              }
            };
          }
        });
        dispatch(initialize2("ticketForm", initialValuesTicketForm));
      }
    }
  }
  render() {
    const {
      reservationFormList = [],
      ticketFormList = [],
      ownerList = [],
      initialAnswers,
      initialTickets,
      answersMap,
      store
    } = this.props;
    return (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      /* @__PURE__ */ jsxRuntimeExports.jsx(Provider, { store, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        !isEmpty(reservationFormList) && /* @__PURE__ */ jsxRuntimeExports.jsx(
          ReservationForm$1,
          {
            ...{ formlist: reservationFormList, initialAnswers, answersMap }
          }
        ),
        !isEmpty(ticketFormList) && /* @__PURE__ */ jsxRuntimeExports.jsx(
          TicketForm$1,
          {
            ...{ formlist: ticketFormList, initialTickets, initialAnswers, ownerList }
          }
        )
      ] }) })
    );
  }
}
const TicketForm$1 = connect()(reduxForm({ form: "ticketForm" })(Forms));
const ReservationForm$1 = connect()(reduxForm({ form: "reservationForm" })(Forms));
function mapStateToProps$p(state) {
  const { products: products2, editReservation: editReservation2 } = state;
  const { productFormList } = products2;
  const { selectedBuyerTypes } = editReservation2;
  const ownerList = Object.values(
    selectedBuyerTypes
  ).map((bt) => ({
    id: `bt-${bt.buyerTypeId}`,
    label: bt.name ?? "",
    qty: bt.n ?? 0
  }));
  return {
    answersMap: getFormValues("reservationForm")(state),
    reservationFormList: productFormList.filter(
      (form2) => "Reservation".includes(form2.type),
      []
    ),
    ticketFormList: productFormList.filter(
      (form2) => ["Ticket", "TicketNominal"].includes(form2.type),
      []
    ),
    ownerList
  };
}
const FormsContainer_default = connect(mapStateToProps$p)(FormsContainer);
function CheckboxOneInput({
  id: id2,
  price,
  onChange,
  required,
  valuesFromState,
  hidePrice,
  currency
}) {
  const locale = Cookie.get("languageCountryCode");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-checkbox", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        id: `i${id2}`,
        type: "checkbox",
        value: "false",
        onChange,
        checked: valuesFromState && valuesFromState.quantity === 1 || required
      },
      `i${id2}`
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "checkbox-inline", htmlFor: `i${id2}`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: " " }),
      !hidePrice && /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: price, currency })
    ] })
  ] }, `l${id2}`);
}
function CheckboxAllInput({
  id: id2,
  price,
  onChange,
  required,
  valuesFromState,
  qty,
  hidePrice,
  currency,
  hasBuyerTypeRows,
  totalPrice = 0,
  isBoxOpen,
  onToggleBox
}) {
  const locale = Cookie.get("languageCountryCode");
  const renderLabel = () => {
    if (hidePrice) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "{qty} tickets", id: "services.label.quantity", values: { qty } });
    }
    if (hasBuyerTypeRows) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: totalPrice, currency }),
        " (",
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "{qty} tickets", id: "services.label.quantity", values: { qty } }),
        ")"
      ] });
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: price * qty, currency }),
      " (",
      qty,
      " x",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: price, currency }),
      ")"
    ] });
  };
  const checkbox = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-checkbox", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        name: "communicationCheck",
        id: `i${id2}`,
        type: "checkbox",
        value: "false",
        onChange,
        checked: valuesFromState && valuesFromState.quantity === 1 || required
      },
      `i${id2}`
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "checkbox-inline", htmlFor: `i${id2}`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: " " }),
      renderLabel()
    ] })
  ] }, `l${id2}`);
  if (!hasBuyerTypeRows) return checkbox;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "service-element-selector-all", children: [
    checkbox,
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        type: "button",
        className: "btn btn-link service-see-details",
        onClick: onToggleBox,
        "aria-expanded": !!isBoxOpen,
        "aria-controls": `service-buyertype-box-${id2}`,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "services.button.seeDetails", defaultMessage: "Ver detalles" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "span",
            {
              className: `${isBoxOpen ? "icon-own-keyboard_arrow_up" : "icon-own-keyboard_arrow_down"} service-btn-icon`,
              "aria-hidden": "true"
            }
          )
        ]
      }
    )
  ] });
}
class IncrementalSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.valuesFromState?.quantity ?? 0
    };
  }
  componentDidUpdate(prevProps) {
    const { valuesFromState } = this.props;
    if (!prevProps.valuesFromState && valuesFromState) {
      const { quantity } = valuesFromState;
      this.setState({
        value: quantity
      });
    }
  }
  incrementItem = () => {
    const { value } = this.state;
    const { handleSelection, price, min: min2 } = this.props;
    const next = value === 0 && min2 > 1 ? min2 : value + 1;
    this.setState({ value: next });
    handleSelection(next, price, false);
  };
  decreaseItem = () => {
    const { value } = this.state;
    const { handleSelection, price, min: min2 } = this.props;
    const next = min2 > 1 && value === min2 ? 0 : value - 1;
    this.setState({ value: next });
    handleSelection(next, price, false);
  };
  render() {
    const { id: id2, min: min2, max: max2 } = this.props;
    const { value } = this.state;
    const unreachable = min2 > max2;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-group", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-group-btn", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          className: "btn btn-default",
          type: "button",
          onClick: this.decreaseItem.bind(this),
          disabled: value === 0,
          children: "-"
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { id: `l${id2}`, type: "text", className: "form-control", value, onChange: () => {
      } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-group-btn", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          className: "btn btn-default",
          type: "button",
          onClick: this.incrementItem.bind(this),
          disabled: max2 === value || unreachable,
          children: "+"
        }
      ) })
    ] });
  }
}
function SelectInput({
  id: id2,
  qty = 0,
  minSelection = 0,
  maxSelection = Number.MAX_VALUE,
  handleSelection,
  price,
  hidePrice,
  valuesFromState,
  currency,
  isBoxOpen,
  onToggleBox,
  selectedQuantity = 0,
  hasBuyerTypePricing = false
}) {
  const locale = Cookie.get("languageCountryCode");
  if (!hasBuyerTypePricing) {
    const maxValue = Math.min(qty, maxSelection);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "service-element-selector", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: `l${id2}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "services.label.select.quantity", defaultMessage: "Selecciona cantidad" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          IncrementalSelector,
          {
            handleSelection,
            id: `l${id2}`,
            price,
            hidePrice,
            min: minSelection,
            max: maxValue,
            valuesFromState
          }
        ),
        !hidePrice && /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: price, currency })
      ] })
    ] }, `l${id2}`);
  }
  if (selectedQuantity > 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "service-element-selector-buyertypes service-element-selector-added", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "service-added-label", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-own-check service-added-icon", "aria-hidden": "true" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormattedMessage,
          {
            id: "services.label.added",
            defaultMessage: "Añadido (x{qty})",
            values: { qty: selectedQuantity }
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          type: "button",
          className: "btn btn-link service-see-details",
          onClick: onToggleBox,
          "aria-expanded": !!isBoxOpen,
          "aria-controls": `service-buyertype-box-${id2}`,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "services.button.seeDetails", defaultMessage: "Ver detalles" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "span",
              {
                className: `${isBoxOpen ? "icon-own-keyboard_arrow_up" : "icon-own-keyboard_arrow_down"} service-btn-icon`,
                "aria-hidden": "true"
              }
            )
          ]
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "service-element-selector-buyertypes", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "button",
    {
      type: "button",
      className: "btn btn-link service-add-button",
      onClick: onToggleBox,
      "aria-expanded": !!isBoxOpen,
      "aria-controls": `service-buyertype-box-${id2}`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-own-add service-btn-icon", "aria-hidden": "true" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "services.button.add", defaultMessage: "Añadir" })
      ]
    }
  ) });
}
function AnswerRequired({ id: id2, onChange, valuesFromState }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-checkbox", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          id: `i${id2}`,
          type: "radio",
          value: "true",
          name: `option_${id2}`,
          onChange,
          checked: valuesFromState && valuesFromState.quantity === 1
        },
        `i${id2}`
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "checkbox-inline", htmlFor: `i${id2}`, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: " " }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Si", id: "button.yes" })
      ] })
    ] }, `l${id2}`),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-checkbox", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          id: `i${id2}false`,
          type: "radio",
          name: `option_${id2}`,
          value: "false",
          onChange,
          checked: valuesFromState && valuesFromState.quantity === 0
        },
        `i${id2}false`
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "checkbox-inline", htmlFor: `i${id2}false`, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: " " }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "No", id: "button.no" })
      ] })
    ] }, `l${id2}false`)
  ] });
}
const getTicketName = (ticket, buyerTypeId) => ticket.name ?? ticket.shortName ?? String(buyerTypeId);
const getEligibleBuyerTypeRows = (priceRows = [], tickets = {}, buyerTypeIds = []) => priceRows.filter((row) => !buyerTypeIds.length || buyerTypeIds.includes(row.buyerTypeId)).filter((row) => (tickets[row.buyerTypeId]?.n ?? 0) > 0).map((row) => ({
  buyerTypeId: row.buyerTypeId,
  name: getTicketName(tickets[row.buyerTypeId], row.buyerTypeId),
  price: row.price,
  max: tickets[row.buyerTypeId].n
}));
const getFlatBuyerTypeRows = (buyerTypeIds = [], tickets = {}, price = 0) => buyerTypeIds.filter((buyerTypeId) => (tickets[buyerTypeId]?.n ?? 0) > 0).map((buyerTypeId) => ({
  buyerTypeId,
  name: getTicketName(tickets[buyerTypeId], buyerTypeId),
  price,
  max: tickets[buyerTypeId].n
}));
const sumCounts = (counts = {}) => Object.values(counts).reduce((total, count) => total + count, 0);
const getCountsTotal = (counts = {}, rows = []) => rows.reduce((total, row) => total + row.price * (counts[row.buyerTypeId] ?? 0), 0);
const getSingleUnitPrice = (eligibleRows = [], priceRows = [], flatPrice = 0) => eligibleRows[0]?.price ?? priceRows[0]?.price ?? flatPrice;
const getCheapestPrice = (rows = []) => rows.length ? Math.min(...rows.map((row) => row.price)) : void 0;
const getFullCounts = (rows = []) => rows.reduce((counts, row) => ({ ...counts, [row.buyerTypeId]: row.max }), {});
const applyBuyerTypeCount = (counts = {}, rows = [], buyerTypeId, value, minSelection = 0) => {
  const previous = counts[buyerTypeId] ?? 0;
  const next = { ...counts, [buyerTypeId]: value };
  const total = sumCounts(next);
  if (total > 0 && total < minSelection) {
    if (value < previous) return {};
    const row = rows.find((candidate) => candidate.buyerTypeId === buyerTypeId);
    next[buyerTypeId] = Math.min(value + (minSelection - total), row?.max ?? value);
    if (sumCounts(next) < minSelection) return counts;
  }
  return Object.entries(next).reduce((res, [id2, count]) => {
    if (count > 0) return { ...res, [id2]: count };
    return res;
  }, {});
};
const repriceServiceEntry = (entry, service, priceRows = [], tickets = {}, fallbackCounts) => {
  const { selectionType, answerRequired, price = 0, qty = 0, buyerTypeIds } = service;
  if (answerRequired || entry.quantity <= 0) return entry;
  const rows = getEligibleBuyerTypeRows(priceRows, tickets, buyerTypeIds);
  if (selectionType === "select") {
    const previous = entry.buyerTypeCounts;
    if (!rows.length) return { ...entry, buyerTypeCounts: void 0, totalPrice: void 0 };
    const source = previous ?? fallbackCounts ?? {};
    const counts = rows.reduce((res, row) => {
      const count = Math.min(source[row.buyerTypeId] ?? 0, row.max);
      return count > 0 ? { ...res, [row.buyerTypeId]: count } : res;
    }, {});
    return { ...entry, quantity: sumCounts(counts), buyerTypeCounts: counts, totalPrice: getCountsTotal(counts, rows) };
  }
  if (selectionType === "checkbox_all") {
    return {
      ...entry,
      price: price * qty,
      totalPrice: rows.length ? getCountsTotal(getFullCounts(rows), rows) : price * qty,
      count: qty
    };
  }
  if (selectionType === "checkbox_one") {
    return { ...entry, price: getSingleUnitPrice(rows, priceRows, price) };
  }
  return entry;
};
function BuyerTypePriceBox({
  serviceId,
  rows,
  counts,
  editable = true,
  currency,
  hidePrice,
  minSelection = 0,
  maxSelection = Number.MAX_VALUE,
  onChange
}) {
  const locale = Cookie.get("languageCountryCode");
  const total = sumCounts(counts);
  const hasMaxLimit = Number.isFinite(maxSelection) && maxSelection < Number.MAX_VALUE;
  const availableUnits = rows.reduce((units, row) => units + row.max, 0);
  const maxUnits = hasMaxLimit ? Math.min(maxSelection, availableUnits) : availableUnits;
  const hasBounds = minSelection > 1 || hasMaxLimit;
  const renderDetail = (row, value) => {
    const price = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: row.price, currency });
    if (!editable) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "services.label.priceTimesTickets",
          defaultMessage: "{price} x {count} {count, plural, one {entrada} other {entradas}}",
          values: { price, count: value }
        }
      );
    }
    return price;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "service-buyertype-box", id: `service-buyertype-box-${serviceId}`, children: [
    editable && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "service-buyertype-title", id: `service-buyertype-title-${serviceId}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "services.label.howMany", defaultMessage: "¿Qué cantidad necesitas?" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "service-buyertype-rows",
        role: "group",
        "aria-labelledby": editable ? `service-buyertype-title-${serviceId}` : void 0,
        children: rows.map((row) => {
          const value = counts[row.buyerTypeId] ?? 0;
          const optionMax = Math.max(Math.min(row.max, maxSelection - (total - value)), value);
          const selectId = `service-${serviceId}-bt-${row.buyerTypeId}`;
          return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "service-buyertype-row", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "service-buyertype-info", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("label", { className: "service-buyertype-name", htmlFor: editable ? selectId : void 0, children: row.name }),
              !hidePrice && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "service-buyertype-detail", children: renderDetail(row, value) })
            ] }),
            editable ? /* @__PURE__ */ jsxRuntimeExports.jsx(
              "select",
              {
                id: selectId,
                className: "form-control service-buyertype-select",
                value,
                onChange: (event) => onChange?.(row.buyerTypeId, Number(event.target.value)),
                children: Array.from({ length: optionMax + 1 }, (_, option) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: option, children: option }, option))
              }
            ) : (
              // With prices hidden the row would otherwise be just a name, so it falls back to
              // the plain count — the breakdown still has to say how many of each buyer type.
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "service-buyertype-amount", children: hidePrice ? value : /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: row.price * value, currency }) })
            )
          ] }, `service-${serviceId}-bt-${row.buyerTypeId}`);
        })
      }
    ),
    !editable && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "service-buyertype-note", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormattedMessage,
      {
        id: "services.label.addedToAllTickets",
        defaultMessage: "El servicio se añade a todas las entradas"
      }
    ) }),
    editable && hasBounds && maxUnits > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "service-buyertype-note", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormattedMessage,
      {
        id: "services.label.selectionRange",
        description: "Help to select service units",
        defaultMessage: "El número de unidades debe estar comprendido entre {minUnits} y {maxUnits}.",
        values: { minUnits: minSelection, maxUnits }
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "service-buyertype-footer", children: !hidePrice && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "service-buyertype-subtotal", "aria-live": "polite", "aria-atomic": "true", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "service-buyertype-subtotal-label", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "services.label.serviceSubtotal", defaultMessage: "Subtotal servicio" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "service-buyertype-subtotal-value", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: getCountsTotal(counts, rows), currency }) })
    ] }) })
  ] });
}
const ComponentByType = {
  checkbox_one: CheckboxOneInput,
  checkbox_all: CheckboxAllInput,
  select: SelectInput,
  answerRequired: AnswerRequired
};
const renderInputByType = ({
  selectionType,
  answerRequired,
  ...props
}) => {
  let Component2;
  if (answerRequired === true) {
    Component2 = ComponentByType.answerRequired;
  } else {
    Component2 = ComponentByType[selectionType];
  }
  return Component2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, { ...props }) : null;
};
function ServiceSelectorItem({
  serviceId,
  name,
  description,
  selectionType,
  // Services configured only through `extra` come back without a top-level price; without the
  // default every derived amount becomes NaN and poisons the cart total.
  price = 0,
  image,
  required,
  answerRequired,
  minSelection,
  maxSelection,
  qty = 0,
  classService,
  showInfo,
  handleSelection,
  htmlToEmbed,
  valuesFromState,
  hidePrice,
  currency,
  extra,
  buyerTypeIds,
  priceRows,
  tickets
}) {
  const [isBoxOpen, setIsBoxOpen] = useState(false);
  const isPricedSelect = selectionType === "select" && !answerRequired;
  const isCheckboxAll = selectionType === "checkbox_all" && !answerRequired;
  const isCheckboxOne = selectionType === "checkbox_one" && !answerRequired;
  const eligibleRows = getEligibleBuyerTypeRows(priceRows, tickets, buyerTypeIds);
  const hasPriceRows = eligibleRows.length > 0;
  const buyerTypeRows = hasPriceRows ? eligibleRows : getFlatBuyerTypeRows(buyerTypeIds, tickets, price);
  const effectivePrice = isCheckboxOne ? getSingleUnitPrice(eligibleRows, priceRows, price) : price;
  const hasBuyerTypePricing = isPricedSelect && hasPriceRows;
  const showPriceFrom = hasBuyerTypePricing && !hidePrice;
  const priceFrom = getCheapestPrice(buyerTypeRows) ?? price;
  const fixedTotal = getCountsTotal(getFullCounts(buyerTypeRows), buyerTypeRows);
  const committedCounts = valuesFromState?.buyerTypeCounts ?? {};
  const selectedQuantity = sumCounts(committedCounts);
  const handleOnChange = (event) => {
    const { target } = event;
    let value;
    value = target.type === "checkbox" ? target.checked : target.value;
    if (required && !answerRequired || value === true || value === "true") {
      value = 1;
    } else if (value === false || value === "false") {
      value = 0;
    }
    if (!isCheckboxAll) {
      handleSelection(value, selectionType === "checkbox_all" ? price * qty : effectivePrice, answerRequired);
      return;
    }
    handleSelection(value, price * qty, answerRequired, void 0, {
      totalPrice: value === 1 ? hasPriceRows ? fixedTotal : price * qty : 0,
      count: value === 1 ? qty : 0
    });
  };
  const boxCounts = hasBuyerTypePricing ? committedCounts : getFullCounts(buyerTypeRows);
  const changeBuyerTypeCount = (buyerTypeId, value) => {
    const counts = applyBuyerTypeCount(committedCounts, buyerTypeRows, buyerTypeId, value, minSelection);
    handleSelection(sumCounts(counts), price, false, void 0, {
      totalPrice: getCountsTotal(counts, buyerTypeRows),
      buyerTypeCounts: counts
    });
  };
  const hasBox = hasPriceRows && (hasBuyerTypePricing || isCheckboxAll);
  const { manageStock, stock, manageStockType } = extra;
  const locale = Cookie.get("languageCountryCode");
  const isSelected = valuesFromState && valuesFromState.quantity > 0 || isBoxOpen;
  const card = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `service-element ${classService} ${hasBox && isSelected ? "selected" : ""}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "service-element-left", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "cover", src: image, alt: name }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "service-element-right", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { children: [
        name,
        " ",
        required || answerRequired ? "*" : ""
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: description }),
      showPriceFrom && selectedQuantity === 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "service-price-from", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormattedMessage,
        {
          id: "services.label.priceFrom",
          defaultMessage: "desde {price}",
          values: {
            price: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "service-price-from-value", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: priceFrom, currency }) })
          }
        }
      ) }),
      answerRequired && !hidePrice ? (
        // don't want to break the current design
        /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: selectionType !== "checkbox_all" ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: price, currency }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: price * qty, currency }),
          " (",
          qty,
          " x",
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: price, currency }),
          ")"
        ] }) })
      ) : "",
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "service-element-input", children: manageStock && manageStockType === "mandatory" && (stock ?? 0) < qty ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "services.label.mandatory.sold", defaultMessage: "Agotado" }) : renderInputByType({
        selectionType,
        id: serviceId,
        price: effectivePrice,
        minSelection,
        maxSelection,
        qty,
        required,
        answerRequired,
        valuesFromState,
        hidePrice,
        onChange: (event) => handleOnChange(event),
        handleSelection,
        currency,
        buyerTypeRows,
        hasBuyerTypePricing,
        isBoxOpen,
        selectedQuantity,
        hasBuyerTypeRows: hasPriceRows,
        totalPrice: fixedTotal,
        onToggleBox: () => setIsBoxOpen((open) => !open)
      }) })
    ] }),
    htmlToEmbed && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "service-element-info", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        role: "button",
        tabIndex: 0,
        className: "icon-own-info_outline",
        title: "Info",
        onClick: () => {
          showInfo({ name, htmlToEmbed });
        }
      }
    ) })
  ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `service-element-group ${classService}-group ${isBoxOpen ? "open" : ""}`, children: [
    card,
    hasBox && isBoxOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
      BuyerTypePriceBox,
      {
        serviceId,
        rows: buyerTypeRows,
        counts: boxCounts,
        editable: hasBuyerTypePricing,
        currency,
        hidePrice,
        minSelection,
        maxSelection,
        onChange: changeBuyerTypeCount
      }
    )
  ] });
}
function CustomModal({
  show: show2,
  onClose,
  title,
  body,
  footerContent = null,
  onAccept = null,
  onCancel = null,
  size: size2,
  customClass = "",
  showFooter = true,
  dangerouslySetInnerHTMLTitle = false,
  dangerouslySetInnerHTMLBody = false,
  closeButton = true,
  bodyClassName = "",
  footerClassName = "",
  id: id2 = "modal",
  backdrop = true
}) {
  const modalProps = {
    ...customClass && { dialogClassName: customClass },
    ...id2 && { id: id2 },
    ...backdrop && { backdrop }
  };
  const bodyProps = {
    ...bodyClassName && { bsClass: bodyClassName }
  };
  const footerProps = {
    ...footerClassName && { bsClass: footerClassName }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { show: show2, onHide: onClose, bsSize: size2, ...modalProps, children: [
    (closeButton || title) && /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Header, { closeButton, children: title && /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Title, { children: dangerouslySetInnerHTMLTitle ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: title } }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: title }) }) }),
    body && /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Body, { ...bodyProps, children: dangerouslySetInnerHTMLBody ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: body } }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: body }) }),
    showFooter && /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Footer, { ...footerProps, children: footerContent || /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      onCancel && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "btn btn-default", onClick: onCancel, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "modal.cancel", defaultMessage: "Cancelar" }) }),
      onAccept && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "btn btn-custom btn-custom-buy", onClick: onAccept, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "modal.accept", defaultMessage: "Aceptar" }) })
    ] }) })
  ] });
}
const hasValidSeats = (seatList) => !!seatList && seatList.length > 0;
const getTicketsCount = () => {
  const sessionData = sessionStorage.getItem("cartSelectedAndCount");
  return sessionData ? JSON.parse(sessionData).count || 0 : 0;
};
const isEmptyCart = (seatList, ticketsCount) => !hasValidSeats(seatList) && !ticketsCount;
const calculateSeatsTotal = (seatList) => seatList.reduce((accumulator, seat) => {
  if (seat && typeof seat.price === "number") {
    return accumulator + seat.price;
  }
  return accumulator;
}, 0);
const calculateTicketsTotal = (tickets, product) => Object.values(tickets).reduce((prev, next) => {
  if (product.priceByPackage) {
    return next.price - (next.discount || 0);
  }
  return prev + (next.price - (next.discount || 0)) * next.n;
}, 0);
const findPromotionById = (promotionList, promotionId) => promotionList.find((promo) => promo.promotionId === promotionId);
const getCommissionRate = (ticket, product) => {
  if (product.numbered) {
    return ticket.commissionNumbered || 0;
  }
  return ticket.commission || 0;
};
const calculateCommissionsForPackage = (tickets) => {
  const ticketValues = Object.values(tickets || {});
  const ticketWithCommission = ticketValues.find(
    (ticket) => ticket && typeof ticket.commission === "number" && !Number.isNaN(ticket.commission) && ticket.commission !== 0
  );
  return ticketWithCommission ? ticketWithCommission.commission : 0;
};
const calculateCommissionsForIndividualTickets = (tickets, product) => Object.values(tickets).reduce((total, ticket) => {
  const commissionRate = getCommissionRate(ticket, product);
  return total + commissionRate * ticket.n;
}, 0);
const calculateTotalCommissions = (tickets, product) => {
  if (product.priceByPackage) {
    return calculateCommissionsForPackage(tickets);
  }
  return calculateCommissionsForIndividualTickets(tickets, product);
};
const calculateAmountTaxesForPackage = (tickets) => {
  const ticketValues = Object.values(tickets || {});
  const ticketWithAmountTax = ticketValues.find(
    (ticket) => ticket && getAmountTaxTotal(ticket.amountTaxList) !== 0
  );
  return ticketWithAmountTax ? getAmountTaxTotal(ticketWithAmountTax.amountTaxList) : 0;
};
const calculateAmountTaxesForIndividualTickets = (tickets) => Object.values(tickets).reduce((total, ticket) => {
  const amountTax = getAmountTaxTotal(ticket.amountTaxList);
  return total + amountTax * ticket.n;
}, 0);
const calculateTotalAmountTaxes = (tickets, product) => {
  if (product.priceByPackage) {
    return calculateAmountTaxesForPackage(tickets);
  }
  return calculateAmountTaxesForIndividualTickets(tickets);
};
const isAgreementTypePromotion = (promotionType) => [
  PROMOTION_TYPES.AGREEMENT,
  PROMOTION_TYPES.EVENT,
  PROMOTION_TYPES.SELLER_AGREEMENT,
  PROMOTION_TYPES.PROMOTIONAL_CODE
].includes(promotionType);
const roundToTwoDecimals$1 = (value) => Math.round(value * 100) / 100;
const calculateVolumePromotionDiscount = (current, matchingPromo, tickets) => {
  if (!matchingPromo?.leftPurchased || !matchingPromo?.rightPaid) {
    return 0;
  }
  const { leftPurchased, rightPaid } = matchingPromo;
  const ticketInfo = tickets[current.buyerTypeId];
  if (!ticketInfo || ticketInfo.n < leftPurchased) {
    return 0;
  }
  const completeSets = Math.floor(ticketInfo.n / leftPurchased);
  const freeTickets = completeSets * (leftPurchased - rightPaid);
  return freeTickets * current.price;
};
const findPromotionPrice = (promotionPrices, buyerTypeId) => (promotionPrices || []).find((promo) => promo.buyerTypeId === buyerTypeId);
const calculateAgreementDiscount = (current, matchingPromo) => {
  if (matchingPromo.percentage) {
    const promotionPrice2 = findPromotionPrice(current.promotionPrices, current.buyerTypeId);
    const percentage = promotionPrice2?.percentage || matchingPromo.percentage;
    return roundHalfDownToTwoDecimals(current.price * percentage);
  }
  const promotionPrice = findPromotionPrice(current.promotionPrices, current.buyerTypeId);
  return promotionPrice?.amount || matchingPromo.amount || 0;
};
const calculateDefaultDiscount = (previous, current) => roundToTwoDecimals$1(previous + roundHalfDownToTwoDecimals(current.discount * current.amount));
const shouldSkipPromotion = (current) => current.price === 0 || current.discount > current.price;
const handleFreeTicketCommission = (current, tickets, totalOfCommissions) => {
  if (current.price - current.discount === 0 && tickets[current.buyerTypeId]?.commission) {
    return totalOfCommissions - tickets[current.buyerTypeId].commission;
  }
  return totalOfCommissions;
};
const calculatePromotionDiscount = (promotionData, product, tickets, promotionList, processedVolumeBuyerTypes) => Object.values(promotionData).reduce((totalDiscount, currentPromotion) => {
  if (product.priceByPackage) {
    return totalDiscount === 0 ? totalDiscount + currentPromotion.discount : totalDiscount;
  }
  if (shouldSkipPromotion(currentPromotion)) {
    return currentPromotion.discount > currentPromotion.price ? totalDiscount + currentPromotion.price : totalDiscount;
  }
  if (currentPromotion.promotionType === PROMOTION_TYPES.VOLUME) {
    if (processedVolumeBuyerTypes.has(currentPromotion.buyerTypeId)) {
      return totalDiscount;
    }
    processedVolumeBuyerTypes.add(currentPromotion.buyerTypeId);
    const matchingPromo = findPromotionById(promotionList, currentPromotion.promotionId);
    const volumeDiscount = calculateVolumePromotionDiscount(currentPromotion, matchingPromo, tickets);
    return totalDiscount + volumeDiscount;
  }
  if (isAgreementTypePromotion(currentPromotion.promotionType)) {
    const matchingPromo = findPromotionById(promotionList, currentPromotion.promotionId);
    if (matchingPromo) {
      const agreementDiscount = calculateAgreementDiscount(currentPromotion, matchingPromo);
      return totalDiscount + agreementDiscount;
    }
  }
  return calculateDefaultDiscount(totalDiscount, currentPromotion);
}, 0);
const calculateTotalWithoutCommission = (cart2) => {
  const { seatList, tickets, product } = cart2;
  if (hasValidSeats(seatList)) {
    return calculateSeatsTotal(seatList);
  }
  return calculateTicketsTotal(tickets || {}, product || {});
};
const calculateFinalTotal = (totalWithoutCommission, discount, subtotalServices, totalOfCommissions, totalOfAmountTaxes) => {
  const netTotal = totalWithoutCommission - discount;
  if (netTotal === 0) {
    return subtotalServices + totalOfCommissions + totalOfAmountTaxes;
  }
  return netTotal + subtotalServices + totalOfCommissions + totalOfAmountTaxes;
};
const getTotalWithPromosAndServices = (cart2, promotionList) => {
  const { tickets = {}, subtotalServices = 0, product = {}, seatList, promotionDataList } = cart2;
  const ticketsCount = getTicketsCount();
  if (isEmptyCart(seatList, ticketsCount)) {
    return { totalToShow: 0, totalOfCommissions: 0 };
  }
  const totalWithoutCommission = calculateTotalWithoutCommission(cart2);
  let totalOfCommissions = calculateTotalCommissions(tickets, product);
  const totalOfAmountTaxes = calculateTotalAmountTaxes(tickets, product);
  let discount = 0;
  if (promotionDataList) {
    const processedVolumeBuyerTypes = /* @__PURE__ */ new Set();
    discount = calculatePromotionDiscount(
      promotionDataList,
      product,
      tickets,
      promotionList,
      processedVolumeBuyerTypes
    );
    Object.values(promotionDataList).forEach((currentPromotion) => {
      totalOfCommissions = handleFreeTicketCommission(currentPromotion, tickets, totalOfCommissions);
    });
  }
  const totalToShow = calculateFinalTotal(
    totalWithoutCommission,
    discount,
    subtotalServices,
    totalOfCommissions,
    totalOfAmountTaxes
  );
  return {
    totalToShow,
    totalOfCommissions
  };
};
const ensurePromotionDataList = (cart2, promotionList, buyerTypeListSorted) => {
  if (cart2.promotionDataList && Object.keys(cart2.promotionDataList).length > 0) {
    return;
  }
  const promotionDataList = {};
  const ticketsSelected = cart2.ticketsSelected || {};
  buyerTypeListSorted.forEach((buyerType, index2) => {
    const { buyerTypeId } = buyerType;
    const selectedTicket = ticketsSelected[buyerTypeId];
    if (!selectedTicket || !selectedTicket.n) {
      return;
    }
    const applicablePromotion = promotionList.find((promo) => {
      if (promo.promotionType === PROMOTION_TYPES.PROMOTIONAL_CODE && !cart2.appliedPromotionalCodes?.includes(promo.promotionId)) {
        return false;
      }
      return promo.buyerTypeIds.includes(buyerTypeId) && promo.productIds.includes(buyerType.productId);
    });
    if (!applicablePromotion) {
      return;
    }
    const promotionPrice = (applicablePromotion.promotionPrices || []).find(
      (p) => p.buyerTypeId === buyerTypeId
    );
    let discount = 0;
    if (promotionPrice && promotionPrice.amount) {
      discount = promotionPrice.amount;
    } else if (applicablePromotion.percentage) {
      discount = Math.round(buyerType.price * applicablePromotion.percentage * 100) / 100;
    }
    if (!discount) {
      return;
    }
    for (let i = 0; i < selectedTicket.n; i++) {
      const key = `buyerTypePromo-${buyerTypeId}-${index2}-${i}`;
      promotionDataList[key] = {
        promotionId: applicablePromotion.promotionId,
        name: applicablePromotion.name,
        promotionType: applicablePromotion.promotionType,
        isGrouped: false,
        discount,
        amount: 1,
        price: buyerType.price,
        applied: true,
        buyerTypeId: String(buyerTypeId),
        productId: buyerType.productId,
        salesGroupId: promotionPrice ? promotionPrice.salesGroupId : void 0,
        promotionPrices: applicablePromotion.promotionPrices
      };
    }
  });
  Object.assign(cart2, { promotionDataList });
};
const PAYMENT_METHODS_ORIGINS = Object.freeze({
  ADYEN_ALIPAY: "adyen-alipay",
  ADYEN_APPLE: "adyen-apple",
  ADYEN_GOOGLE: "adyen-google",
  ADYEN_IDEAL: "adyen-ideal",
  ADYEN_KLARNA: "adyen-klarna",
  ADYEN_PAYPAL: "adyen-paypal",
  ADYEN_POS: "adyen-pos",
  ADYEN_POS_V: "adyen-pos-v",
  ADYEN_WECHAT: "adyen-wechat",
  ALIPAY: "alipay",
  ALIPAYPC: "alipaypc",
  ALIPAY_STRIPE_V2: "alipay-stripe-v2",
  API: "API-POSV",
  BIZUM: "bizum",
  CASH: "cash",
  CHEQUE: "cheque",
  CLORIAN_PAYMENTS_APPLE: "clorian-payments-apple",
  CLORIAN_PAYMENTS_GOOGLE: "clorian-payments-google",
  CLORIAN_PAYMENTS_IDEAL: "clorian-payments-ideal",
  CLORIAN_PAYMENTS_KLARNA: "clorian-payments-klarna",
  CLORIAN_PAYMENTS_TPV: "clorian-payments-tpv",
  CVCO: "cvco",
  DEFERRED: "deferred",
  FREE: "free",
  PAYBOX: "paybox",
  PAYPAL_EXPRESS: "paypal-e",
  PINPAD_GPRS: "pinpad-gprs",
  POS: "POS",
  POS2: "POS2",
  POS_V: "POS-V",
  PREPAYMENT: "prepayment",
  PROSA: "prosa",
  SIBS: "sibs",
  TRANSFER: "transfer",
  VOUCHER: "voucher",
  WECHAT: "wechat",
  WECHAT_STRIPE_V2: "wechat-stripe-v2",
  BALANCE: "balance",
  YUNO: "yuno",
  IVR: "ivr"
});
const ADYEN_CHANNEL = Object.freeze({
  WEB: "Web"
});
function hasTrackingConsent() {
  return allowSendCookie(window?.pos?.gtmEventsStrictMode) === "true";
}
function resolveProviders() {
  const pos = window?.pos;
  const configured = pos?.analytics?.providers;
  if (configured && configured.length > 0) return configured;
  if (pos?.name === "CasaBatllo") return ["casaBatllo"];
  if (pos?.GAVersion === "GA4") return ["ga4"];
  return ["ua"];
}
function isProviderEnabled(provider) {
  return resolveProviders().includes(provider);
}
const adapters = /* @__PURE__ */ new Map();
function registerAdapter(adapter) {
  adapters.set(adapter.id, adapter);
}
function resetAdapters() {
  adapters.clear();
}
function track(name, payload = {}) {
  if (!hasTrackingConsent()) return;
  const event = { name, payload };
  resolveProviders().forEach((provider) => {
    const adapter = adapters.get(provider);
    if (!adapter) return;
    try {
      adapter.handle(event);
    } catch (error) {
      console.error(`[analytics] adapter "${provider}" failed on "${name}"`, error);
    }
  });
}
function toStr(value) {
  if (value === null || value === void 0 || value === "") return void 0;
  return String(value);
}
function toNum(value) {
  if (value === null || value === void 0 || value === "") return void 0;
  const parsed = typeof value === "number" ? value : Number.parseFloat(String(value));
  return Number.isNaN(parsed) ? void 0 : parsed;
}
function compact(obj) {
  Object.keys(obj).forEach((key) => obj[key] === void 0 && delete obj[key]);
  return obj;
}
function toAnalyticsItem(product, position = 0) {
  return compact({
    id: toStr(product.id ?? product.item_id),
    name: product.name ?? product.item_name ?? void 0,
    bookingId: toStr(product.reservationId),
    category: product.category ?? product.item_category,
    variant: product.variant ?? product.item_variant ?? void 0,
    variantId: toStr(product.item_variant_id),
    brand: product.item_brand,
    price: toNum(product.price),
    quantity: toNum(product.quantity) ?? 1,
    discount: toNum(product.discount ?? product.productMetrics?.ecProductDiscount),
    coupon: product.coupon ?? void 0,
    index: typeof product.index === "number" ? product.index : position + 1,
    listName: product.item_list_name,
    date: product.productDimensions?.ecProductDate ?? product.item_product_date,
    time: product.productDimensions?.ecProductTime ?? product.item_product_time
  });
}
function toAnalyticsItems(products2 = []) {
  return products2.map((product, index2) => toAnalyticsItem(product, index2));
}
function catalogueToItem(product, options = {}) {
  return compact({
    id: toStr(product.productId),
    name: product.name,
    // No variant here: `shortName` is the PRODUCT's short name, not a buyer type
    // (general/niño/adulto...). Call-sites that know the selected buyer type set
    // `variant` themselves (see mapBookingStep); everywhere else it stays unset —
    // there's no buyer type to report yet.
    category: "tickets",
    brand: options.posName,
    price: toNum(options.price ?? product.basePrice),
    index: options.index !== void 0 ? options.index + 1 : product.displayOrder,
    listName: options.listName
  });
}
function attachReservationInfo(items, reservations2) {
  if (reservations2.length === 0) return items;
  const byProductId = /* @__PURE__ */ new Map();
  reservations2.forEach((reservation) => {
    const key = String(reservation.product?.productId);
    if (!byProductId.has(key)) byProductId.set(key, reservation);
  });
  return items.map((item) => {
    const reservation = item.id !== void 0 ? byProductId.get(String(item.id)) : void 0;
    if (!reservation) return item;
    return compact({
      ...item,
      bookingId: item.bookingId ?? toStr(reservation.reservationId),
      name: reservation.product?.name ?? item.name
    });
  });
}
function mapTransaction(products2 = [], meta = {}, reservations2 = []) {
  return compact({
    items: attachReservationInfo(toAnalyticsItems(products2), reservations2),
    total: toNum(meta.total),
    tax: toNum(meta.tax),
    currency: meta.currency,
    transactionId: toStr(meta.transactionId),
    buyerCountry: meta.country,
    declaredSource: meta.declaredSource,
    attribution: meta.attribution,
    paymentType: meta.paymentType,
    paymentDetail: meta.paymentDetail,
    step: meta.step,
    stepName: meta.stepName,
    processName: meta.processName,
    processCategory: meta.processCategory
  });
}
function mapProductList(products2 = [], options = {}) {
  return {
    items: products2.map(
      (product, index2) => catalogueToItem(product, { posName: options.posName, index: index2, listName: options.listName })
    )
  };
}
function mapProduct(product, options = {}) {
  return compact({
    items: [catalogueToItem(product, options)],
    currency: options.currency
  });
}
function mapBookingStep(options) {
  const item = options.product ? {
    ...compact({
      ...catalogueToItem(options.product, { posName: options.posName }),
      date: options.date,
      time: options.time
    }),
    variant: options.buyerType
  } : void 0;
  return compact({
    items: item ? [item] : [],
    stepName: options.section,
    step: options.section,
    processCategory: "booking",
    processName: "booking-process"
  });
}
function mapPageView(page = {}) {
  return { page: compact({ ...page }) };
}
function mapPromotions(promoArray = [], options = {}) {
  const promotions2 = promoArray.map(
    (promo) => compact({
      id: toStr(promo.promotion_id ?? promo.id),
      name: toStr(promo.promotion_name ?? promo.name),
      creative: toStr(promo.creative ?? promo.promotion_creative),
      position: toStr(promo.position ?? promo.promotion_position)
    })
  );
  return compact({
    promotions: promotions2,
    page: options.pageName ? { name: options.pageName } : void 0
  });
}
const query$2 = queryString.parse(window.location.search);
window.dataLayer = window.dataLayer || [];
const isCasaBatllo = () => window.pos && window.pos.name === "CasaBatllo";
const gtmEventsStrictMode = window.pos && window.pos.gtmEventsStrictMode ? "true" : void 0;
const comesFromCB = document.referrer.indexOf("casabatllo.es") !== -1;
const isGA4 = () => isProviderEnabled("ga4");
function formatString(text) {
  if (text) {
    let formattedText = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    formattedText = formattedText.replace(/([a-zñ])([A-ZÑ])/g, "$1 $2");
    formattedText = formattedText.toLowerCase();
    formattedText = formattedText.replace(/\s+/g, "-");
    formattedText = formattedText.replace(/[^\p{L}\p{N}-]/gu, "");
    formattedText = formattedText.replace(/-+/g, "-");
    formattedText = formattedText.replace(/-+$/, "");
    return formattedText;
  }
  return text;
}
function getCategory(product) {
  if (product && product.openDate) return "open-date";
  if (product && product.showCalendar && product.showEvents) return "with-day-and-hour";
  if (product && product.showCalendar && !product.showEvents) return "without-hour";
  if (product && !product.showCalendar && product.showEvents) return "without-day";
  if (product && !product.showCalendar && !product.showEvents) return "without-day-and-hour-selection";
  return void 0;
}
const PAYMENT_MAPPINGS = Object.freeze({
  [PAYMENT_METHODS_ORIGINS.POS_V]: "card",
  // Adyen's card form is always embedded in the checkout, never a redirect.
  [PAYMENT_METHODS_ORIGINS.ADYEN_POS_V]: "card_inline",
  [PAYMENT_METHODS_ORIGINS.ALIPAY_STRIPE_V2]: "alipay",
  [PAYMENT_METHODS_ORIGINS.ADYEN_ALIPAY]: "alipay",
  [PAYMENT_METHODS_ORIGINS.WECHAT_STRIPE_V2]: "wechat",
  [PAYMENT_METHODS_ORIGINS.ADYEN_WECHAT]: "wechat",
  [PAYMENT_METHODS_ORIGINS.PAYPAL_EXPRESS]: "paypal",
  [PAYMENT_METHODS_ORIGINS.ADYEN_PAYPAL]: "paypal",
  [PAYMENT_METHODS_ORIGINS.CLORIAN_PAYMENTS_APPLE]: "apple_pay",
  [PAYMENT_METHODS_ORIGINS.ADYEN_APPLE]: "apple_pay",
  [PAYMENT_METHODS_ORIGINS.CLORIAN_PAYMENTS_GOOGLE]: "google_pay",
  [PAYMENT_METHODS_ORIGINS.ADYEN_GOOGLE]: "google_pay"
});
const toSnakeCase = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, "_");
function getPaymentType(purchase, paymentMethod, { redsysInline = false } = {}) {
  const origin = paymentMethod || purchase?.frontendPaymentVo?.origin || "";
  if (redsysInline && origin === PAYMENT_METHODS_ORIGINS.POS_V) return "card_inline";
  return PAYMENT_MAPPINGS[origin] ?? toSnakeCase(origin);
}
function getPaymentDetail(purchase) {
  const cardBrand = purchase?.frontendPaymentVo?.cardBrand;
  return cardBrand ? toSnakeCase(cardBrand) : void 0;
}
function getProductAnalyticsConfigValue(item, configKey, type = "PRODUCT", extra, buyerTypeId, promotionId) {
  const productAnalyticsConfig = JSON.parse(sessionStorage.getItem("productAnalyticsConfig") ?? "null") || {};
  if (!item || !item.productId || Object.keys(productAnalyticsConfig).length === 0) {
    return null;
  }
  return productAnalyticsConfig[item.productId]?.find((config) => {
    if (config.configKey !== configKey || config.type !== type) return false;
    if (type === "BUYER_TYPE") return config.genericId === buyerTypeId;
    if (type === "SERVICE") return config.genericId === extra?.service?.serviceId;
    if (type === "PROMOTION") return config.genericId === promotionId;
    return config.genericId === item?.productId;
  })?.configValue || null;
}
function promotionView(promoArray, posName) {
  track("promotion.viewed", mapPromotions(promoArray));
  if (allowSendCookie(gtmEventsStrictMode)) {
    if (isGA4()) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "view_promotion",
        event_type: "booking-process-2",
        event_detail: formatString(posName),
        ecommerce: {
          items: promoArray
        }
      });
    } else {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "promotionView",
        ecommerce: {
          items: {
            products: promoArray
          }
        }
      });
    }
  }
}
function promotionClick(promoArray, posName) {
  sessionStorage.setItem("promotionSelected", JSON.stringify(promoArray[0]));
  track("promotion.clicked", mapPromotions(promoArray));
  const objEcommerce = isGA4() ? {
    event: "select_promotion",
    event_type: "booking-process-2",
    event_detail: formatString(posName),
    ecommerce: {
      items: promoArray
    }
  } : {
    event: "promotionClick",
    ecommerce: {
      promoClick: {
        promotions: promoArray
      }
    }
  };
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(objEcommerce);
}
function viewProduct({
  serviceList,
  posName,
  productPrice,
  product,
  currency,
  events: events2,
  timeZone
}) {
  if (product) {
    track("product.viewed", mapProduct(product, { posName, price: productPrice, currency }));
  }
  if (allowSendCookie(gtmEventsStrictMode) && !isCasaBatllo()) {
    let productsArray = [];
    if (product) {
      productsArray = [
        {
          item_name: formatString(product.name),
          item_id: product.productId?.toString(),
          item_list_name: "ticket-selection",
          item_category: "tickets",
          price: Number.parseFloat(String(productPrice || product.basePrice || 0)),
          index: product.displayOrder ?? 0,
          ...getCategory(product) ? { item_category2: getCategory(product) } : {},
          item_brand: formatString(posName),
          item_variant: formatString(product.shortName)
        }
      ];
    } else {
      productsArray = serviceList.map((service, index2) => ({
        item_name: formatString(service.name),
        item_id: service.serviceId.toString(),
        item_list_name: "ticket-selection",
        item_category: "extra",
        price: Number.parseFloat(String(productPrice || service.price || 0)),
        index: index2 + 1,
        ...getCategory(product) ? { item_category2: getCategory(product) } : {},
        item_brand: formatString(posName)
      }));
    }
    if (isGA4()) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "view_item",
        ecommerce: {
          event_type: "booking-process-2",
          event_detail: formatString(posName),
          currency,
          items: productsArray
        }
      });
    }
  } else {
    let productsArray = [];
    if (serviceList) {
      productsArray = serviceList.map((service, index2) => ({
        item_name: getItemNameCB({ productId: events2?.events[0]?.productId }, "SERVICE", {
          service: { serviceId: Number(service?.serviceId) }
        }) || formatString(service.name),
        item_id: service.serviceId.toString(),
        price: Number.parseFloat(String(productPrice || service.price || 0)),
        quantity: 1,
        item_category: "extra",
        item_list_name: "extras",
        index: index2 + 1,
        item_product_date: events2?.events[0]?.startDatetime ? moment(events2.events[0].startDatetime).tz(timeZone).format(DATE_FORMAT_YMD_COMPACT) : "",
        item_product_time: events2?.events[0]?.startDatetime ? moment(events2.events[0].startDatetime).tz(timeZone).format(TIME_FORMAT_24H) : "",
        item_dinamic_price: "false"
      }));
    }
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "view_item_list",
      ecommerce: {
        items: productsArray
      }
    });
  }
}
function getItemCategoryCB(item, buyerTypeId, type = "BUYER_TYPE") {
  return getProductAnalyticsConfigValue(item, "item_category", type, void 0, buyerTypeId);
}
function getItemCategory2CB(item, type = "PRODUCT", extra) {
  return getProductAnalyticsConfigValue(item, "item_category2", type, extra);
}
function getItemVariantCB(item, type = "PRODUCT", extra) {
  return getProductAnalyticsConfigValue(item, "item_variant", type, extra);
}
function getItemNameCB(item, type = "PRODUCT", extra) {
  return getProductAnalyticsConfigValue(item, "item_name", type, extra);
}
function getPromotionCB(item, type = "PROMOTION", promotionId) {
  return getProductAnalyticsConfigValue(item, "coupon", type, void 0, void 0, promotionId);
}
function getTicketsByBuyerTypeAndPromotion(reservationList, pos, timeZone) {
  const productsArray = [];
  reservationList.forEach((reservation) => {
    reservation.ticketSet.forEach((ticket) => {
      let defaultValue = "";
      if (isCasaBatllo()) {
        defaultValue = void 0;
      }
      const ticketWithDefaults = {
        ...ticket,
        reservationId: reservation.reservationId,
        promotion: {
          ...ticket.promotion,
          name: ticket.promotion ? ticket.promotion.name : defaultValue
        }
      };
      let discount = 0;
      let extrasTotal = 0;
      let complementTotal = 0;
      if (ticket.priceOriginal) {
        if (ticket.ticketExtraSet && ticket.ticketExtraSet.length > 0) {
          extrasTotal = ticket.ticketExtraSet.reduce(
            (accum, extra) => accum + (extra.priceOriginal || extra.price || 0),
            0
          );
        }
        if (ticket.ticketComplementSet && ticket.ticketComplementSet.length > 0) {
          complementTotal = ticket.ticketComplementSet.reduce(
            (accum, complement) => accum + (complement.priceOriginal || complement.price || 0),
            0
          );
        }
        discount = Number.parseFloat(
          String((ticket.priceOriginal || 0) + extrasTotal + complementTotal - ticket.total)
        ).toFixed(2);
      }
      const price = reservation.product.priceByPackage ? ticketWithDefaults.total / reservation.ticketSet.length : ticketWithDefaults.total;
      const isUpsellingOrGeneral = query$2.upselling === "1" ? "upselling" : "entradas-general";
      if (isCasaBatllo()) {
        const priceTotalService = (ticket.ticketExtraSet || []).filter((item) => item.service).reduce((total, item) => total + (item.price || 0), 0);
        const promotionSelectedCB = getPromotionCB(
          reservation.product,
          "PROMOTION",
          ticketWithDefaults.promotion?.promotionId
        );
        productsArray.push({
          item_name: reservation.product.name,
          item_id: reservation.product.productId,
          price: Number(Number.parseFloat(String(price - priceTotalService)).toFixed(2)),
          discount: Number(discount),
          coupon: promotionSelectedCB || ticketWithDefaults.promotion.name,
          quantity: 1,
          item_variant_id: reservation.product.productId,
          item_variant: reservation.product.name || "",
          item_category: ticketWithDefaults.buyerType.shortName.toLowerCase() || `${reservation.product.shortName}`,
          buyer_type_id: ticketWithDefaults.buyerType.buyerTypeId,
          item_list_name: comesFromCB ? isUpsellingOrGeneral : "entradas-tickets",
          index: "1",
          item_product_date: ticket.event?.startDatetime ? moment(ticket.event.startDatetime).tz(timeZone).format(DATE_FORMAT_YMD_COMPACT) : "",
          item_product_time: ticket.event?.startDatetime ? moment(ticket.event.startDatetime).tz(timeZone).format(TIME_FORMAT_24H) : "",
          item_dinamic_price: "false"
        });
      } else if (productsArray.filter(
        (e) => e.reservationId === ticketWithDefaults.reservationId && (e.variant || "").toLowerCase() === ticketWithDefaults.buyerType.shortName.toLowerCase() && e.coupon === ticketWithDefaults.promotion.name
      ).length > 0) {
        productsArray.forEach((product, index2) => {
          if (product.reservationId === ticketWithDefaults.reservationId && (product.variant || "").toLowerCase() === ticketWithDefaults.buyerType.shortName.toLowerCase() && product.coupon === ticketWithDefaults.promotion.name) {
            productsArray[index2] = {
              ...product,
              quantity: (product.quantity || 0) + 1,
              productMetrics: {
                ...product.productMetrics,
                ecProductDiscount: Number.parseFloat(String(Number(discount) * ((product.quantity || 0) + 1))).toFixed(
                  2
                )
              }
            };
          }
        });
      } else {
        productsArray.push({
          //  adding a product to a shopping cart.
          reservationId: reservation.reservationId,
          name: `${pos.posName} - ${reservation.product.shortName}`,
          id: reservation.product.productId,
          price: Number(Number.parseFloat(String(price)).toFixed(2)),
          quantity: 1,
          coupon: ticketWithDefaults.promotion.name,
          variant: ticketWithDefaults.buyerType.shortName.toLowerCase(),
          item_variant_id: ticketWithDefaults.buyerType.buyerTypeId,
          category: pos.posName,
          productDimensions: {
            ecProductDate: moment(ticket.event?.startDatetime || "").tz(timeZone).format(DATE_FORMAT_YMD_COMPACT),
            ecProductTime: moment(ticket.event?.startDatetime || "").tz(timeZone).format(TIME_FORMAT_24H)
          },
          productMetrics: {
            ecProductDiscount: discount
          }
        });
      }
    });
  });
  const productsCBArray = productsArray.reduce((acc, ticket) => {
    const index2 = acc.findIndex((el) => el.item_category === ticket.item_category && el.item_id === ticket.item_id);
    if (index2 === -1) {
      acc.push({ ...ticket, quantity: 1 });
    } else {
      acc[index2].quantity = (acc[index2].quantity || 0) + 1;
    }
    return acc;
  }, []);
  return isCasaBatllo() ? productsCBArray : productsArray;
}
function getTicketsWithExtrasAndPromotion(reservationList, pos, timeZone) {
  const productsArray = [];
  reservationList.forEach((reservation) => {
    reservation.ticketSet.forEach((ticket) => {
      const defaultValue = "";
      const ticketWithDefaults = {
        ...ticket,
        reservationId: reservation.reservationId,
        promotion: {
          ...ticket.promotion,
          name: ticket.promotion ? ticket.promotion.name : defaultValue
        }
      };
      let discount = 0;
      let extrasTotal = 0;
      let complementTotal = 0;
      if (ticket.priceOriginal) {
        if (ticket.ticketExtraSet && ticket.ticketExtraSet.length > 0) {
          extrasTotal = ticket.ticketExtraSet.reduce(
            (accum, extra) => accum + (extra.priceOriginal || extra.price || 0),
            0
          );
        }
        if (ticket.ticketComplementSet && ticket.ticketComplementSet.length > 0) {
          complementTotal = ticket.ticketComplementSet.reduce(
            (accum, complement) => accum + (complement.priceOriginal || complement.price || 0),
            0
          );
        }
        discount = Number.parseFloat(
          String((ticket.priceOriginal || 0) + extrasTotal + complementTotal - ticket.total)
        ).toFixed(2);
      }
      const price = reservation.product.priceByPackage ? ticketWithDefaults.total / reservation.ticketSet.length : ticket.price || 0;
      if (productsArray.filter(
        (e) => e.reservationId === ticketWithDefaults.reservationId && (e.variant || "").toLowerCase() === ticketWithDefaults.buyerType.shortName.toLowerCase() && e.coupon === ticketWithDefaults.promotion.name
      ).length > 0) {
        productsArray.forEach((product, index2) => {
          if ((product.itemCategory === "tickets" || product.itemCategory === "addons") && product.reservationId === ticketWithDefaults.reservationId && (product.variant || "").toLowerCase() === ticketWithDefaults.buyerType.shortName.toLowerCase() && product.coupon === ticketWithDefaults.promotion.name) {
            productsArray[index2] = {
              ...product,
              quantity: (product.quantity || 0) + 1,
              productMetrics: {
                ...product.productMetrics,
                ecProductDiscount: Number.parseFloat(String(Number(discount) * ((product.quantity || 0) + 1))).toFixed(
                  2
                )
              }
            };
          }
        });
      } else {
        productsArray.push({
          reservationId: reservation.reservationId,
          name: reservation.product.name,
          id: reservation.product.productId,
          price: Number(Number.parseFloat(String(price)).toFixed(2)),
          total: Number(Number.parseFloat(String(ticket.total)).toFixed(2)),
          quantity: 1,
          coupon: ticketWithDefaults.promotion.name,
          variant: ticketWithDefaults.buyerType.shortName.toLowerCase(),
          category: pos,
          itemCategory: "tickets",
          productDimensions: {
            ecProductDate: moment(ticket.event?.startDatetime || "").tz(timeZone).format(DATE_FORMAT_YMD_COMPACT),
            ecProductTime: moment(ticket.event?.startDatetime || "").tz(timeZone).format(TIME_FORMAT_24H)
          },
          productMetrics: {
            ecProductDiscount: discount
          }
        });
      }
    });
  });
  return productsArray;
}
function getTicketExtrasServices(reservationsList) {
  const servicesMap = [];
  reservationsList.forEach((reservation) => {
    if (reservation)
      reservation.ticketSet.forEach((ticket) => {
        if (ticket)
          (ticket.ticketExtraSet || []).forEach((extra) => {
            if (extra && extra.service) {
              const { serviceId } = extra.service;
              const { price } = extra;
              const existingService = servicesMap.find((service) => service.item_id === serviceId);
              if (existingService) {
                existingService.quantity = (existingService.quantity || 0) + 1;
              } else {
                servicesMap.push({
                  item_name: getItemNameCB(reservation?.product, "SERVICE", extra) || formatString(extra.service.name),
                  item_id: serviceId,
                  price: Number(Number((price || 0).toFixed(2))),
                  discount: 0,
                  quantity: 1,
                  item_category: "extra"
                });
              }
            }
          });
      });
  });
  return servicesMap;
}
function viewSection({
  section,
  productInfo,
  timeZone,
  dateCart,
  hourCart,
  dateCartSecond,
  buyerType
}) {
  let obj = {};
  let event = "";
  track(
    "booking.stepViewed",
    mapBookingStep({
      product: productInfo,
      posName: window?.pos?.name,
      section,
      date: dateCart ? moment.tz(dateCart, timeZone).format(DATE_FORMAT_YMD_COMPACT) : void 0,
      time: hourCart || (dateCart ? moment.tz(dateCart, timeZone).format(TIME_FORMAT_24H) : void 0),
      buyerType
    })
  );
  if (allowSendCookie(gtmEventsStrictMode)) {
    if (isCasaBatllo() && (section === "select-hour" || section === "select-day" || section === "select-tickets")) {
      const itemVariantCB = getItemVariantCB(productInfo);
      const isUpsellingOrGeneral = query$2.upselling === "1" ? "upselling" : "entradas-general";
      obj = {
        item_name: getItemNameCB(productInfo) || "(not set)",
        item_id: productInfo.productId,
        coupon: void 0,
        quantity: 1,
        item_list_name: comesFromCB ? isUpsellingOrGeneral : "entradas-tickets",
        item_category2: getItemCategory2CB(productInfo),
        index: "1",
        price: productInfo.basePrice
      };
      if (section === "select-tickets") {
        event = "view_paxs";
        obj.item_product_date = moment.tz(dateCart, timeZone).format(DATE_FORMAT_YMD_COMPACT);
        obj.item_product_time = hourCart;
        obj.item_dinamic_price = "false";
        obj.item_variant_id = productInfo.productId;
        if (itemVariantCB) obj.item_variant = itemVariantCB;
      } else if (section === "select-hour") {
        event = "view_hour";
        obj.item_product_date = moment.tz(dateCart, timeZone).format(DATE_FORMAT_YMD_COMPACT);
        obj.item_variant_id = productInfo.productId;
        if (itemVariantCB) obj.item_variant = itemVariantCB;
        obj.item_dinamic_price = "false";
      } else if (section === "select-day") {
        event = "view_day";
        if (itemVariantCB) obj.item_variant = itemVariantCB;
      }
      obj.item_list_name = comesFromCB ? isUpsellingOrGeneral : "entradas-tickets";
      if (event !== "") {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event,
          ecommerce: {
            items: obj
          }
        });
      }
    } else {
      const promotionSelected = JSON.parse(sessionStorage.getItem("promotionSelected") ?? "null");
      const isWithPromotion = promotionSelected && !!promotionSelected.promotion_id;
      switch (section) {
        case "select-hour":
          obj.event_product_hour = moment.tz(dateCart, timeZone).format(TIME_FORMAT_24H);
          break;
        case "select_second_hour":
          obj.event_product_hour = `${moment.tz(dateCart, timeZone).format(TIME_FORMAT_24H)}/${moment.tz(dateCartSecond, timeZone).format(TIME_FORMAT_24H)}`;
          break;
        case "select-day":
          obj.event_product_day = moment.tz(dateCart, timeZone).format(DATE_FORMAT_YMD_COMPACT);
          break;
        case "select_second_day":
          obj.event_product_day = `${moment.tz(dateCart, timeZone).format(DATE_FORMAT_YMD_COMPACT)}/${moment.tz(dateCartSecond, timeZone).format(DATE_FORMAT_YMD_COMPACT)}`;
          break;
        default:
          obj = {};
          break;
      }
      if (isGA4()) {
        let sectionEvent;
        if (section === "select-hour") {
          sectionEvent = "select_hour";
        } else if (section === "select-day") {
          sectionEvent = "select_day";
        } else if (section === "select-tickets") {
          sectionEvent = "select_tickets";
        } else {
          sectionEvent = section;
        }
        if (sectionEvent) {
          window.dataLayer.push({
            event: sectionEvent,
            event_type: isWithPromotion ? "booking-process-2/upgrade" : "booking-process-2",
            event_detail: productInfo ? formatString(productInfo?.name) : "",
            ...obj
          });
        }
      } else {
        let sectionEvent;
        if (section === "select_second_hour") {
          sectionEvent = "select-hour";
        } else if (section === "select_second_day") {
          sectionEvent = "select-day";
        } else {
          sectionEvent = section;
        }
        if (!isCasaBatllo()) {
          window.dataLayer.push({
            event: "jsStepsCheckout",
            addToUrl: sectionEvent
          });
        }
      }
    }
  }
}
function addToCart$1(cart2, posName, timeZone, reservationList, currency) {
  localStorage.setItem("notShowViewSection", "true");
  const promotionSelected = JSON.parse(
    sessionStorage.getItem("promotionSelected") ?? "null"
  );
  const isWithPromotion = promotionSelected && !!promotionSelected.promotion_id;
  const product = cart2.product;
  const productsArray = [];
  const productDimensions = {
    ecProductDate: "nn",
    ecProductTime: "nn"
  };
  if (!isCasaBatllo()) {
    if (cart2.events && cart2.events.length > 0) {
      productDimensions.ecProductDate = moment.tz(cart2.events[0].startDatetime, timeZone).format(DATE_FORMAT_YMD_COMPACT);
      productDimensions.ecProductTime = moment.tz(cart2.events[0].startDatetime, timeZone).format(TIME_FORMAT_24H);
      productDimensions.ecAvailability = cart2.events[0].totalAvailability;
    }
  }
  const servicesList = getTicketExtrasServices(reservationList);
  if (isCasaBatllo()) {
    Object.entries(cart2.tickets).forEach(([, value]) => {
      const itemVariantCB = getItemVariantCB(product);
      const isUpsellingOrGeneral = query$2.upselling === "1" ? "upselling" : "entradas-general";
      const ticketEntry = value;
      const itemCategoryCB = getItemCategoryCB(product, ticketEntry?.buyerTypeId);
      const findPromotion = reservationList[0]?.ticketSet?.find((ticket) => ticket.buyerType?.buyerTypeId === value?.buyerTypeId)?.promotion || null;
      const promotionSelectedCB = getPromotionCB(product, "PROMOTION", findPromotion?.promotionId);
      if (ticketEntry.n > 0) {
        productsArray.push({
          item_name: getItemNameCB(product),
          item_id: product.productId,
          price: Number(Number(ticketEntry.price.toFixed(2))),
          discount: 0,
          coupon: promotionSelectedCB || findPromotion?.name,
          quantity: ticketEntry.n,
          ...itemVariantCB ? { item_variant: itemVariantCB } : {},
          item_variant_id: product.productId,
          item_category: itemCategoryCB || String(ticketEntry.name || "").toLowerCase(),
          item_category2: getItemCategory2CB(product),
          item_list_name: comesFromCB ? isUpsellingOrGeneral : "entradas-tickets",
          index: "1",
          item_product_date: cart2.events[0] ? moment.tz(cart2.events[0].startDatetime, timeZone).format(DATE_FORMAT_YMD_COMPACT) : "",
          item_product_time: cart2.events[0] ? moment.tz(cart2.events[0].startDatetime, timeZone).format(TIME_FORMAT_24H) : "",
          item_dinamic_price: "false"
        });
      }
    });
    if (servicesList.length) {
      servicesList.forEach((item) => {
        productsArray.push({
          item_name: item.item_name,
          item_id: item.item_id,
          price: item.price,
          discount: 0,
          quantity: item.quantity,
          item_category: "extra"
        });
      });
    }
  } else {
    const productsInfo = getTicketsWithExtrasAndPromotion(reservationList, posName, timeZone);
    if (!isGA4()) {
      Object.entries(cart2.tickets).forEach(([, value]) => {
        const ticketEntry = value;
        productsArray.push({
          //  adding a product to a shopping cart.
          name: `${posName} - ${product.shortName || ""}`,
          id: product.productId,
          price: Number(ticketEntry.price.toFixed(2)),
          quantity: ticketEntry.n,
          category: posName,
          variant: String(ticketEntry.name || "").toLowerCase(),
          item_variant_id: ticketEntry.buyerTypeId,
          productDimensions,
          ...isWithPromotion && product.productId === promotionSelected?.item_id ? {
            promotion_id: promotionSelected.promotion_id,
            promotion_name: promotionSelected.promotion_name
          } : {}
        });
      });
    } else {
      productsInfo.forEach((item, index2) => {
        if (item.itemCategory === "tickets") {
          productsArray.push({
            item_name: formatString(item.name),
            item_id: item.id?.toString(),
            item_brand: formatString(posName),
            item_list_name: "product-detail",
            index: index2 + 1,
            quantity: item.quantity,
            item_category: formatString(item.itemCategory),
            item_category2: getCategory(product),
            item_variant: formatString(item.variant),
            item_product_day: cart2.events[1] ? `${moment.tz(cart2.events[0].startDatetime, timeZone).format(DATE_FORMAT_YMD_COMPACT)}/${moment.tz(cart2.events[1].startDatetime, timeZone).format(DATE_FORMAT_YMD_COMPACT)}` : moment.tz(item.productDimensions?.ecProductDate, timeZone).format(DATE_FORMAT_YMD_COMPACT),
            item_product_hour: cart2.events[1] ? `${moment.tz(cart2.events[0].startDatetime, timeZone).format(TIME_FORMAT_24H)}/${moment.tz(cart2.events[1].startDatetime, timeZone).format(TIME_FORMAT_24H)}` : item.productDimensions?.ecProductTime,
            price: servicesList.length ? item.price : item.total,
            ...item.coupon ? { coupon: item.coupon } : {},
            ...item.productMetrics?.ecProductDiscount ? { discount: Number.parseFloat(String(item.productMetrics.ecProductDiscount)) } : {},
            ...isWithPromotion && product.productId === promotionSelected?.item_id ? {
              promotion_id: promotionSelected.promotion_id,
              promotion_name: promotionSelected.promotion_name
            } : {}
          });
        } else {
          productsArray.push({
            item_name: formatString(item.name),
            item_id: item.id?.toString(),
            item_brand: formatString(posName),
            price: item.price,
            index: index2 + 1,
            item_list_name: "product-detail",
            quantity: item.quantity,
            item_category: formatString(item.itemCategory),
            ...item.itemCategory === "addons" ? { item_variant: formatString(item.variant) } : {},
            ...item.productMetrics?.ecProductDiscount ? { discount: Number.parseFloat(String(item.productMetrics.ecProductDiscount)) } : {},
            ...item.coupon ? { coupon: item.coupon } : {}
          });
        }
      });
      if (getTicketExtrasServices(reservationList).length) {
        getTicketExtrasServices(reservationList).forEach((item, index2) => {
          productsArray.push({
            item_name: item.item_name,
            item_id: item.item_id,
            price: item.price,
            discount: 0,
            quantity: item.quantity,
            item_category: "extra",
            item_brand: formatString(posName),
            index: index2 + 1,
            item_list_name: "product-detail"
          });
        });
      }
    }
  }
  const totalSum = reservationList.reduce((sum, r) => sum + r.total, 0);
  track(
    "cart.itemAdded",
    mapTransaction(
      getTicketsByBuyerTypeAndPromotion(reservationList, { posName }, timeZone),
      {
        total: totalSum,
        currency,
        processCategory: "booking",
        processName: "booking-process",
        stepName: "select tickets added"
      },
      reservationList
    )
  );
  if (allowSendCookie(gtmEventsStrictMode)) {
    if (isCasaBatllo()) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          items: productsArray
        }
      });
    } else if (isGA4()) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          event_type: isWithPromotion ? "booking-process-2/upgrade" : "booking-process-2",
          event_detail: formatString(posName),
          value: totalSum,
          currency,
          items: productsArray
        }
      });
    } else {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "addToCart",
        ecommerce: {
          currencyCode: "EUR",
          add: {
            products: productsArray
          }
        }
      });
    }
  }
}
let hasBeenCalled = false;
class ServiceSelector extends Component {
  constructor(props) {
    super(props);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      show: false,
      modalInfo: {}
    };
  }
  componentDidMount() {
    const { initialServices } = this.props;
    if (initialServices)
      Object.entries(initialServices).forEach(([key, value]) => {
        this.handleSelection({
          serviceId: key,
          result: value.quantity,
          price: value.price,
          answerRequired: value.answerRequired,
          totalPrice: value.totalPrice,
          buyerTypeCounts: value.buyerTypeCounts,
          count: value.count
        });
      });
  }
  componentDidUpdate(prevProps) {
    const {
      serviceList,
      initialServices,
      edit,
      activeStep,
      step,
      clientList,
      currency,
      events: events2,
      servicePriceMap,
      tickets
    } = this.props;
    const { serviceList: prevServiceList } = prevProps;
    if (prevServiceList && serviceList && prevServiceList.length > 0 && serviceList.length > 0 && serviceList !== prevServiceList) {
      serviceList.filter(
        (service) => service && service.selectionType !== "select" && (service.required || service.answerRequired) && !!service.qty && (!initialServices || !initialServices[service.serviceId])
      ).forEach((service) => {
        const {
          serviceId,
          selectionType,
          price = 0,
          qty = 0,
          answerRequired,
          disabledDates,
          extra,
          buyerTypeIds
        } = service;
        let result = service.answerRequired ? -1 : 1;
        if (extra.manageStock && service.answerRequired && extra.stock !== void 0 && extra.stock < qty && !edit) {
          result = 0;
        }
        const priceRows = servicePriceMap?.[String(serviceId)];
        const rows = getEligibleBuyerTypeRows(priceRows, tickets, buyerTypeIds);
        let totalPrice;
        let count;
        if (selectionType === "checkbox_all" && !answerRequired) {
          totalPrice = result === 1 ? getCountsTotal(getFullCounts(rows), rows) || price * qty : 0;
          count = result === 1 ? qty : 0;
        }
        const unitPrice = selectionType === "checkbox_one" && !answerRequired ? getSingleUnitPrice(rows, priceRows, price) : price;
        this.handleSelection({
          serviceId,
          result,
          price: selectionType === "checkbox_all" ? price * qty : unitPrice,
          answerRequired,
          disabledDates,
          totalPrice,
          count
        });
      });
    }
    if (!hasBeenCalled && activeStep === step && serviceList?.length && clientList?.length) {
      viewProduct({
        serviceList,
        posName: clientList[0].name,
        currency,
        events: events2,
        timeZone: clientList[0].timeZone
      });
      hasBeenCalled = true;
    }
  }
  handleClose() {
    this.setState({ show: false });
  }
  handleShow(service) {
    this.setState({
      show: true,
      modalInfo: service
    });
  }
  handleSelection({
    serviceId,
    result,
    price,
    answerRequired,
    disabledDates,
    totalPrice,
    buyerTypeCounts,
    count
  }) {
    const { handleSelection } = this.props;
    let newResult = result;
    if (newResult === true || newResult === "true") {
      newResult = 1;
    } else if (newResult === false && newResult === "false") {
      newResult = 0;
    }
    const entry = {
      quantity: newResult,
      price,
      answerRequired,
      disabledDates,
      totalPrice,
      buyerTypeCounts,
      count
    };
    this.setState(
      { [serviceId]: entry },
      () => handleSelection?.({
        [serviceId]: entry
      })
    );
  }
  render() {
    let { serviceList = [] } = this.props;
    const { headerText, currency, productInfo, edit, events: events2, servicePriceMap, tickets, selectedServices } = this.props;
    const show2 = this.state.show;
    const modalInfo = this.state.modalInfo;
    serviceList = getRenderableServices(serviceList, events2, edit);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CustomModal,
        {
          show: show2,
          onClose: this.handleClose,
          size: "large",
          title: modalInfo.name,
          dangerouslySetInnerHTMLBody: true,
          body: modalInfo.htmlToEmbed,
          showFooter: false
        }
      ),
      headerText && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel-body-header", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: headerText }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "panel-body-content", children: [
        productInfo && productInfo.top,
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "serviceList", className: "services", children: serviceList && serviceList.length > 0 ? serviceList.map((service) => {
          const { serviceId } = service;
          const valuesFromState = selectedServices?.[String(serviceId)] ?? this.state[serviceId];
          const classService = `service-id-${serviceId}`;
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            ServiceSelectorItem,
            {
              ...service,
              currency: currency ?? "",
              priceRows: servicePriceMap?.[String(serviceId)],
              tickets,
              classService,
              valuesFromState,
              handleSelection: ((result, price, answerRequired, disabledDates, extra) => {
                this.handleSelection({
                  serviceId,
                  result,
                  price,
                  answerRequired,
                  disabledDates,
                  totalPrice: extra?.totalPrice,
                  buyerTypeCounts: extra?.buyerTypeCounts,
                  count: extra?.count
                });
              }),
              showInfo: this.handleShow
            },
            `service-item-${serviceId}`
          );
        }) : /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormattedMessage,
          {
            id: "text.services.not.available",
            defaultMessage: "No hay servicios extras disponibles para tu selección de tickets"
          }
        ) }) })
      ] }),
      productInfo && productInfo.bottom
    ] });
  }
}
function fetchServicePrices({
  serviceId = throwIfMissing$1("serviceId"),
  date = throwIfMissing$1("date")
}) {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL()}/services/${serviceId}/prices`,
      types: [SERVICE_PRICES_REQUEST, SERVICE_PRICES_SUCCESS, SERVICE_PRICES_FAILURE],
      authenticated: true,
      // A service without configured pricing is a normal outcome, not something to notify about.
      showError: false,
      params: { date },
      // Forwarded to the SUCCESS action so the reducer can key the rows by service.
      serviceId,
      date
    }
  };
}
function fetchAllServicePrices({
  serviceList = [],
  date = throwIfMissing$1("date")
}) {
  return (dispatch) => {
    if (!serviceList.length) return Promise.resolve();
    return Promise.all(
      serviceList.map(
        (service) => dispatch(fetchServicePrices({ serviceId: service.serviceId, date }))
      )
    );
  };
}
function cleanServicePrices() {
  return { type: SERVICE_PRICES_CLEAN };
}
class ServicesContainer extends Component {
  /** Units of each select service per buyer type, as the reservation was loaded. */
  initialCounts = {};
  /**
   * Prices already requested, by date and services. Tracked here rather than from the store's
   * fetch state so that a failing request does not re-arm the fetch.
   */
  requestedPricesKey = null;
  constructor(props) {
    super(props);
    this.state = {
      initialServices: null
    };
    this.handleSelection = this.handleSelection.bind(this);
  }
  componentDidMount() {
    const { initialTickets, serviceList } = this.props;
    const initialServices = initialTickets.map((ticket) => ticket.ticketExtraSet.filter((extra) => extra.serviceId)).flat();
    this.initialCounts = initialTickets.reduce((counts, ticket) => {
      if (ticket.buyerTypeId === void 0) return counts;
      ticket.ticketExtraSet.forEach(({ serviceId }) => {
        if (!serviceId) return;
        const serviceCounts = counts[String(serviceId)] ?? {};
        serviceCounts[ticket.buyerTypeId] = (serviceCounts[ticket.buyerTypeId] ?? 0) + 1;
        counts[String(serviceId)] = serviceCounts;
      });
      return counts;
    }, {});
    const initialServicesIds = initialServices.map((s) => s.serviceId);
    const servicesWithAnswerRequired = serviceList.filter(
      (service) => service.answerRequired && !initialServicesIds.includes(service.serviceId)
    );
    const initialServicesMap = initialServices.reduce(
      (totalServices, service) => {
        const initialQuantity = initialServices.filter((s) => s.serviceId === service.serviceId).length;
        const masterService = serviceList.find((serviceListItem) => serviceListItem.serviceId === service.serviceId);
        const prevQuantity = totalServices[service.serviceId] ? totalServices[service.serviceId].quantity : 0;
        const quantity = prevQuantity + 1;
        return {
          ...totalServices,
          [service.serviceId]: {
            quantity: masterService?.selectionType !== "select" ? 1 : quantity,
            price: masterService?.selectionType === "checkbox_all" ? service.price * initialQuantity : service.price,
            answerRequired: masterService?.answerRequired
          }
        };
      },
      {}
    );
    const servicesWithAnswerRequiredMap = servicesWithAnswerRequired.reduce(
      (totalServices, service) => ({
        ...totalServices,
        [service.serviceId]: {
          quantity: 0,
          price: service.selectionType === "checkbox_all" ? 0 : service.price ?? 0,
          answerRequired: service.answerRequired
        }
      }),
      {}
    );
    const merged = this.reprice({ ...initialServicesMap, ...servicesWithAnswerRequiredMap });
    this.setState(
      {
        initialServices: merged
      },
      () => this.handleSelection(merged)
    );
    this.fetchPrices();
  }
  componentDidUpdate(prevProps) {
    const { serviceList, selectedServices, dispatch, servicePriceMap, eventDate } = this.props;
    if (eventDate !== prevProps.eventDate || serviceList !== prevProps.serviceList) {
      this.fetchPrices();
    }
    if (_isEqual(prevProps.serviceList, serviceList) && servicePriceMap !== prevProps.servicePriceMap) {
      this.handleSelection(this.reprice(selectedServices));
    }
    if (!_isEqual(prevProps.serviceList, serviceList)) {
      serviceList.forEach((service) => {
        const { serviceId, price, qty, answerRequired, required } = service;
        if (selectedServices[serviceId] || required) {
          let quantity;
          if (required) {
            if (service.selectionType === "checkbox_one") {
              quantity = 1;
            } else {
              quantity = qty ?? 0;
            }
          } else if (selectedServices[serviceId].quantity === -1) {
            quantity = 0;
          } else {
            quantity = selectedServices[serviceId].quantity;
          }
          this.handleSelection(
            this.reprice({
              [serviceId]: {
                ...selectedServices[serviceId],
                quantity,
                price: service.selectionType === "checkbox_all" ? (price ?? 0) * (qty ?? 0) : price ?? 0,
                answerRequired
              }
            })
          );
        }
      });
      const originalServiceIdMap = prevProps.serviceList.map((s) => s.serviceId);
      const newServiceIdMap = serviceList.map((s) => s.serviceId);
      const deletedServiceId = originalServiceIdMap.find((serviceId) => !newServiceIdMap.includes(serviceId));
      if (deletedServiceId) {
        dispatch(removeSelectedService(deletedServiceId));
      }
    }
  }
  /** Brings the given entries in line with the current per-buyer-type prices and tickets. */
  reprice(entries) {
    const { serviceList, servicePriceMap, tickets } = this.props;
    return Object.entries(entries).reduce((res, [serviceId, entry]) => {
      const service = serviceList.find((item) => String(item.serviceId) === serviceId);
      if (!service) return { ...res, [serviceId]: entry };
      return {
        ...res,
        [serviceId]: repriceServiceEntry(
          entry,
          service,
          servicePriceMap[serviceId],
          tickets,
          this.initialCounts[serviceId]
        )
      };
    }, {});
  }
  fetchPrices() {
    const { serviceList, eventDate, pricesEnabled, dispatch } = this.props;
    if (!pricesEnabled || !eventDate || !serviceList.length) return;
    const key = `${eventDate}|${serviceList.map((service) => service.serviceId).join(",")}`;
    if (this.requestedPricesKey === key) return;
    this.requestedPricesKey = key;
    dispatch(fetchAllServicePrices({ serviceList, date: eventDate }));
  }
  handleSelection(serviceSelected) {
    const { dispatch } = this.props;
    dispatch(setSelectedServices(serviceSelected));
  }
  render() {
    const { serviceList, productInfo, currency, store, servicePriceMap, tickets, selectedServices } = this.props;
    const { initialServices } = this.state;
    return (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      /* @__PURE__ */ jsxRuntimeExports.jsx(Provider, { store, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: initialServices && /* @__PURE__ */ jsxRuntimeExports.jsx(
        ServiceSelector,
        {
          serviceList,
          productInfo,
          handleSelection: this.handleSelection,
          initialServices,
          edit: true,
          currency,
          servicePriceMap,
          tickets,
          selectedServices
        }
      ) }) })
    );
  }
}
function mapStateToProps$o(state) {
  const { products: products2, editReservation: editReservation2, pointOfSales, servicePrices: servicePrices2 } = state;
  const { productInfoList } = products2;
  const { clientList } = pointOfSales;
  return {
    serviceList: getVisibleServiceListEdit(state).sort(
      (a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
    ),
    productInfo: getProductInfoMap(productInfoList, "services"),
    selectedServices: editReservation2.selectedServices,
    currency: clientList[0].currencyList[0].isoCode,
    servicePriceMap: servicePrices2?.byServiceId ?? {},
    tickets: editReservation2.selectedBuyerTypes ?? {},
    eventDate: getEditServicesEventDatetime(state),
    pricesEnabled: !!servicePrices2
  };
}
const ServicesContainer_default = connect(mapStateToProps$o)(ServicesContainer);
const roundToTwoDecimals = (value) => Number(Number(value || 0).toFixed(2));
const messages$3 = defineMessages({
  placeholderCode: {
    id: "placeholder.promotionalCode",
    defaultMessage: "Code"
  },
  placeholderDNI: {
    id: "promotions.placeholder.dni.text",
    defaultMessage: "DNI"
  },
  placeholderPassword: {
    id: "promotions.placeholder.password.text",
    defaultMessage: "Password"
  },
  placeholderTarjeta: {
    id: "promotions.placeholder.tarjeta.text",
    defaultMessage: "Tarjeta"
  },
  tooltipRemove: {
    id: "tooltip.remove.promotion",
    defaultMessage: "Remove promotion"
  }
});
function PromotionAgreementForm({ inputs, onChange, onClick }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "col-md-12", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
    inputs.map((input, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "col-md-offset-4 col-md-4",
        style: {
          marginBottom: inputs.length > 1 && index2 === 0 ? "4px" : void 0
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            className: "form-control",
            placeholder: input.placeholder,
            onChange: (e) => onChange(input.stateKey, e.target.value)
          }
        )
      },
      index2
    )),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "submit", className: "btn btn-custom", onClick, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "button.validate", defaultMessage: "Validar" }) }) })
  ] });
}
class PromotionValidation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: "",
      promotionCode: "",
      promotionKey: ""
    };
  }
  get isChillidaleku() {
    const { buyerType } = this.props;
    return buyerType.clientId === 154;
  }
  get isAzkunazentroa() {
    const { buyerType } = this.props;
    return buyerType.clientId === 191;
  }
  get isCustomPromotion() {
    return this.isChillidaleku || this.isAzkunazentroa;
  }
  get customFormInput() {
    const customFormInput = [
      { stateKey: "promotionCode", placeholder: this.placeholderPromotionCode },
      { stateKey: "promotionKey", placeholder: this.placeholderPromotionKey }
    ];
    if (this.isAzkunazentroa) return customFormInput.reverse();
    return customFormInput;
  }
  get placeholderPromotionCode() {
    const { intl } = this.props;
    if (!this.isCustomPromotion) return intl.formatMessage(messages$3.placeholderCode);
    return intl.formatMessage(messages$3.placeholderDNI);
  }
  get placeholderPromotionKey() {
    const { intl } = this.props;
    return this.isChillidaleku ? intl.formatMessage(messages$3.placeholderPassword) : intl.formatMessage(messages$3.placeholderTarjeta);
  }
  get onClickHandler() {
    if (this.isCustomPromotion) return this.handleAgreementCredentialsValidation;
    return this.handleAgreementValidation;
  }
  get formInputs() {
    const placeholderCode = this.placeholderPromotionCode;
    if (this.isCustomPromotion) return this.customFormInput;
    return [{ stateKey: "code", placeholder: placeholderCode }];
  }
  handleAgreementValidation = () => {
    const { handleCodeValidation, promotion } = this.props;
    const { code } = this.state;
    handleCodeValidation(code, "agreement", promotion.promotionId);
  };
  handleAgreementCredentialsValidation = () => {
    const { handleCodeValidation, promotion } = this.props;
    const { promotionCode, promotionKey } = this.state;
    handleCodeValidation({ promotionCode, promotionKey }, "agreement", promotion.promotionId);
  };
  handleInputChange = (key, value) => {
    this.setState({ [key]: value });
  };
  render() {
    const {
      promotion,
      intl,
      buyerType,
      currency,
      showCommissionSummary,
      ticketMap,
      seat,
      seatPromo,
      unSelectPromotion
    } = this.props;
    const tooltipRemove = intl.formatMessage(messages$3.tooltipRemove);
    const locale = Cookie.get("languageCountryCode");
    let priceToShow = promotion.amount ?? 0;
    if (buyerType && buyerType.commission && priceToShow > 0) {
      priceToShow += buyerType.commission;
    }
    if (showCommissionSummary) {
      priceToShow = promotion.amount ?? 0;
    }
    const percentage = Number(seatPromo && seatPromo.percentage);
    const hasPercentagePromotion = Number.isFinite(percentage);
    const promotionBasePrice = Number(promotion && promotion.price);
    if (hasPercentagePromotion && Number.isFinite(promotionBasePrice)) {
      const basePrice = roundToTwoDecimals(promotionBasePrice);
      const seatDiscount = roundToTwoDecimals(basePrice * percentage);
      priceToShow = roundToTwoDecimals(basePrice - seatDiscount);
      promotion.amount = priceToShow;
      promotion.price = basePrice;
      promotion.discount = seatDiscount;
    } else if (seat) {
      const seatPromoEntry = seatPromo || void 0;
      priceToShow = seat.price - getDiscountForBuyerType(
        seatPromoEntry,
        buyerType,
        ticketMap,
        seat
      );
      promotion.amount = priceToShow;
      promotion.price = seat.price;
      promotion.discount = getDiscountForBuyerType(
        seatPromoEntry,
        buyerType,
        ticketMap,
        seat
      );
    }
    const isAgreementPromotion = promotion.promotionType === "agreement" && promotion.externalProviderId;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      promotion.applied && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "col-md-2 promo promo-notapplied", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: priceToShow, currency }),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "span",
          {
            role: "button",
            tabIndex: 0,
            className: "glyphicon glyphicon-remove clickable",
            title: tooltipRemove,
            onClick: unSelectPromotion
          }
        )
      ] }),
      isAgreementPromotion && /* @__PURE__ */ jsxRuntimeExports.jsx(
        PromotionAgreementForm,
        {
          inputs: this.formInputs,
          onChange: this.handleInputChange,
          onClick: this.onClickHandler
        }
      )
    ] });
  }
}
const mapStateToProps$n = (state) => {
  const { pointOfSales, cart: cart2 } = state;
  const { configurations } = pointOfSales;
  const { tickets } = cart2;
  const ticketMap = {};
  Object.entries(tickets).forEach(([key, value]) => {
    ticketMap[key] = value.n;
  });
  return {
    showCommissionSummary: configurations?.showCommissionSummary,
    ticketMap
  };
};
const PromotionValidation$1 = connect(mapStateToProps$n)(injectIntl(PromotionValidation));
class BuyerTypePromotion extends Component {
  constructor(props) {
    super(props);
    const { promotions: promotions2 } = props;
    this.state = {
      promotions: promotions2
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleCodeValidation = this.handleCodeValidation.bind(this);
    this.unSelectPromotion = this.unSelectPromotion.bind(this);
    this.setAndSendPromotion = this.setAndSendPromotion.bind(this);
  }
  componentDidUpdate(prevProps) {
    const { promotions: promotions2 } = this.props;
    if (prevProps.promotions !== promotions2) {
      this.setState({ promotions: promotions2 });
    }
  }
  componentWillUnmount() {
    const { handleChange, ticketIndex } = this.props;
    handleChange(void 0, ticketIndex);
  }
  handleChange(event) {
    const { promotions: promotions2, buyerType } = this.props;
    const promotionSelected = promotions2[event.target.value];
    const selectedPromotion = promotionSelected && {
      ...promotionSelected,
      buyerTypeId: buyerType.buyerTypeId,
      quantity: promotionSelected.promotionType === "promotional_code" ? 1 : 0
    };
    if (selectedPromotion) {
      this.setAndSendPromotion(selectedPromotion);
    } else {
      this.unSelectPromotion();
    }
  }
  handleCodeValidation(code, type, promotionId) {
    const { checkPromotionCode, ticketIndex } = this.props;
    checkPromotionCode(code, type, promotionId, ticketIndex);
  }
  setAndSendPromotion(promotion) {
    const { handleChange, showError, ticketIndex } = this.props;
    if (promotion && promotion.applied) {
      const promoWithoutExternalProvider = promotion.promotionType !== "agreement" || promotion.promotionType === "agreement" && !promotion.externalProviderId;
      handleChange({ ...promotion, applied: promoWithoutExternalProvider }, ticketIndex);
    } else {
      showError();
    }
  }
  unSelectPromotion() {
    const { handleChange, ticketIndex } = this.props;
    handleChange(
      {
        promotionId: -1
      },
      ticketIndex
    );
  }
  render() {
    const { buyerType, promotionData, currency, showCommissionSummary, seat, seatPromo } = this.props;
    const { promotions: promotions2 } = this.state;
    const HAS_PROMOTION = !!promotionData;
    const HAS_PROMOTION_APPLIED = HAS_PROMOTION && promotionData.applied;
    const locale = Cookie.get("languageCountryCode");
    const selectOptions = [
      {
        promotionId: -1,
        name: "--",
        applied: void 0
      },
      ...Object.values(promotions2)
    ].map(({ promotionId, name, applied }) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: promotionId, style: { color: applied ? "black" : "gray" }, children: name }, `promotion-${promotionId}`));
    let priceToShow = buyerType.price;
    if (seat) {
      priceToShow = seat.price;
    }
    if (buyerType.price && buyerType.commission && priceToShow > 0) priceToShow += buyerType.commission;
    if (showCommissionSummary) {
      priceToShow = buyerType.price;
    }
    const promoBySeat = promotionData && seatPromo && seatPromo.find((promo) => promo.promotionId === promotionData.promotionId);
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-12 promotions-item", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "form-group form-custom", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { htmlFor: `select-promotion-${buyerType.buyerTypeId}`, className: "col-md-4 text-right", children: [
        buyerType.name,
        " "
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-4", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "select-form-control", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "select",
          {
            className: "form-control",
            value: promotionData && promotionData.promotionId ? promotionData.promotionId : -1,
            onChange: this.handleChange,
            children: selectOptions
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-own-arrow_drop_down" })
      ] }) }),
      promotionData && promotionData.promotionType !== "volume" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `col-md-2 promo ${HAS_PROMOTION_APPLIED ? "promo-applied" : "promo-notapplied"}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedPrice, { locale, value: priceToShow, currency }) }),
        HAS_PROMOTION ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          PromotionValidation$1,
          {
            promotion: promotionData,
            seatPromo: promoBySeat,
            buyerType,
            seat,
            currency,
            unSelectPromotion: this.unSelectPromotion,
            handleCodeValidation: this.handleCodeValidation
          }
        ) : null
      ] }) : null
    ] }) });
  }
}
const mapStateToProps$m = (state) => {
  const { pointOfSales } = state;
  const { configurations } = pointOfSales;
  return {
    showCommissionSummary: configurations?.showCommissionSummary
  };
};
const BuyerTypePromotion$1 = connect(mapStateToProps$m)(BuyerTypePromotion);
function PromotionalCodeCode({
  onChange,
  onClick,
  placeholderCode,
  buttonTextValidate,
  promotionCodeValid,
  code,
  selectedBuyerTypes
}) {
  const disableButton = !code || code.length < 1 || selectedBuyerTypes.length === 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-horizontal form-custom", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "form-group", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { htmlFor: "promo-code-input", className: "col-md-2 col-md-offset-2 text-right", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-own-discount_label" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: "Código promocional" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-4", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-custom", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { className: "form-control", type: "text", placeholder: placeholderCode, onChange }),
      (() => {
        if (selectedBuyerTypes.length === 0) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block error", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            FormattedMessage,
            {
              id: "notification.error.field.selectBuyerType",
              defaultMessage: "Antes debes selecccionar tus entradas"
            }
          ) });
        }
        if (promotionCodeValid === false) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block error", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "notification.error.field.promotion", defaultMessage: "Código inválido" }) });
        }
        return null;
      })()
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        type: "button",
        className: `btn btn-custom btn-custom-promo ${disableButton ? "disabled" : ""}`,
        onClick: () => onClick("promotional_code"),
        disabled: disableButton,
        children: buttonTextValidate
      }
    ) })
  ] }) });
}
class PromotionSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketIndexPromotionMap: {},
      buyerTypesPromotions: []
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleCodeValidation = this.handleCodeValidation.bind(this);
    this.handleCode = this.handleCode.bind(this);
    this.applyPromotionToState = this.applyPromotionToState.bind(this);
    this.applyMultiplePromotions = this.applyMultiplePromotions.bind(this);
  }
  componentDidMount() {
    const { promotions: promotions2, buyerTypes: buyerTypes2, ticketMap, event, sellerIdSelected, timeZone, seats } = this.props;
    const promotionsByBuyerType = getPromotionsByBuyerType({
      ticketMap,
      buyerTypesMap: buyerTypes2,
      promotions: promotions2,
      event,
      timeZone,
      seats
    });
    let defaultEventPromotion = {};
    if (promotions2) {
      const promoListAvailable = promotions2.filter(
        (promo) => generalValidations({
          promotion: promo,
          event,
          checkBuyerTypes: false,
          timeZone
        })
      );
      defaultEventPromotion = getDefaultEventPromotionMemo(
        promoListAvailable,
        sellerIdSelected ?? void 0,
        ticketMap
      ) ?? {};
    }
    this.getBuyerTypePromotion(ticketMap, promotionsByBuyerType, defaultEventPromotion);
  }
  componentDidUpdate(prevProps) {
    const { ticketMap, buyerTypes: buyerTypes2, promotions: promotions2, event, sellerIdSelected, timeZone, seats } = this.props;
    const {
      promotions: promotionsProp,
      event: eventProp,
      ticketMap: ticketMapProp,
      buyerTypes: buyerTypesProp,
      showNotification: showNotificationProp,
      showNotFound: showNotFoundProp
    } = prevProps;
    const { ticketIndexPromotionMap } = this.state;
    const nextPropsPromoCode = getPromotionsWithPromotionalCode(
      promotions2
    )[0];
    const isSamePromo = checkIfPromoCodeChanges(
      promotionsProp,
      promotions2
    );
    const promotionsByBuyerType = getPromotionsByBuyerType({
      ticketMap,
      buyerTypesMap: buyerTypes2,
      promotions: promotions2,
      event,
      isSamePromo,
      ticketIndexPromotionMap,
      timeZone,
      seats
    });
    const EVENT_CHANGES = event && eventProp && event.eventId !== eventProp.eventId;
    const PROMOTIONS_CHANGES = !_isEqual(promotions2, promotionsProp);
    const TICKET_CHANGES = !_isEqual(ticketMapProp, ticketMap) || !_isEqual(buyerTypesProp, buyerTypes2);
    if (promotions2) {
      const promoListAvailable = promotions2.filter(
        (promo) => generalValidations({
          promotion: promo,
          event: eventProp,
          checkBuyerTypes: false,
          timeZone
        })
      );
      const defaultEventPromotion = getDefaultEventPromotionMemo(
        promoListAvailable,
        sellerIdSelected ?? void 0,
        ticketMap
      );
      if (!isEmpty(defaultEventPromotion)) {
        if (nextPropsPromoCode && !isSamePromo) {
          getTicketIndexToApplyPromo(
            nextPropsPromoCode,
            promotionsByBuyerType,
            ticketMap,
            this.applyPromotionToState,
            showNotificationProp,
            event?.eventId
          );
        }
      } else if (nextPropsPromoCode && !isSamePromo) {
        getTicketIndexToApplyPromo(
          nextPropsPromoCode,
          promotionsByBuyerType,
          ticketMap,
          this.applyPromotionToState,
          showNotificationProp,
          event?.eventId
        );
      }
      if ((EVENT_CHANGES || PROMOTIONS_CHANGES || TICKET_CHANGES) && !nextPropsPromoCode) {
        this.getBuyerTypePromotion(
          ticketMap,
          promotionsByBuyerType,
          defaultEventPromotion
        );
      }
      if ((EVENT_CHANGES || PROMOTIONS_CHANGES || TICKET_CHANGES) && nextPropsPromoCode) {
        const buyerTypesPromotions = this.buyerTypePromoObject(ticketMap, promotionsByBuyerType);
        this.setState({ buyerTypesPromotions });
      }
      if (nextPropsPromoCode && !isSamePromo) {
        const buyerTypesWithPromoCode = Object.entries(ticketIndexPromotionMap).filter(
          ([, promotion]) => promotion.promotionId === nextPropsPromoCode.promotionId
        );
        if (!buyerTypesWithPromoCode || buyerTypesWithPromoCode.length < 1) {
          showNotFoundProp?.();
        }
      }
    }
  }
  handleChange(btPromotion, ticketIndex) {
    const { promotions: promotions2, event, salesGroupId, productId, productIsOpenDate, showError, applyPromotions } = this.props;
    const { ticketIndexPromotionMap: ticketIndexPromotionMapState } = this.state;
    let ticketIndexPromotionMap = { ...ticketIndexPromotionMapState };
    if (btPromotion) {
      let promotionIsValid = true;
      const promotionsHasTheSelectedPromo = promotions2.filter(
        (promotion) => promotion.promotionId === btPromotion.promotionId
      )[0];
      if (!!promotionsHasTheSelectedPromo && promotionsHasTheSelectedPromo.promotionType === "promotional_code") {
        const usedTimesPromotionCode = getUsedTimesByPromotionId(
          ticketIndexPromotionMap,
          btPromotion.promotionId
        );
        promotionIsValid = redeemedTimes(
          promotionsHasTheSelectedPromo,
          usedTimesPromotionCode,
          event?.eventId
        );
        if (!promotionIsValid) {
          showError(btPromotion.promotionCode ?? "");
        }
      }
      if (promotionIsValid) {
        ticketIndexPromotionMap = {
          ...ticketIndexPromotionMap,
          [ticketIndex]: {
            ...btPromotion,
            eventId: productIsOpenDate ? void 0 : event?.eventId,
            productId,
            salesGroupId
          }
        };
      }
    } else {
      delete ticketIndexPromotionMap[ticketIndex];
    }
    this.setState({ ticketIndexPromotionMap }, () => applyPromotions(ticketIndexPromotionMap));
  }
  handleCodeValidation() {
    const { checkPromotionCode } = this.props;
    let { code } = this.state;
    code = code ? code.trim() : code;
    if (code && code.length > 0) {
      checkPromotionCode(code);
    }
  }
  handleCode(event) {
    this.setState({ code: event.target.value });
  }
  getBuyerTypePromotion = (ticketMap, promotionsByBuyerType, defaultEventPromotion) => {
    const { event, productId, salesGroupId, productIsOpenDate, buyerTypePromotions, applyPromotions } = this.props;
    const buyerTypesPromotions = this.buyerTypePromoObject(ticketMap, promotionsByBuyerType);
    let promos = buyerTypesPromotions.reduce(
      (defaultPromos, btpromotion) => {
        if (!defaultPromos[btpromotion.ticketIndex] && !isEmpty(defaultEventPromotion)) {
          const validDefaultEventPromotion = !isEmpty(defaultEventPromotion[btpromotion.buyerTypeId]) && Object.keys(btpromotion.promotionsByBuyerType).find(
            (promotion) => promotion === defaultEventPromotion[btpromotion.buyerTypeId]?.promotionId?.toString()
          );
          if (!isEmpty(validDefaultEventPromotion)) {
            return {
              ...defaultPromos,
              [btpromotion.ticketIndex]: {
                ...btpromotion.promotionsByBuyerType[defaultEventPromotion[btpromotion.buyerTypeId]?.promotionId],
                buyerTypeId: btpromotion.buyerTypeId,
                eventId: productIsOpenDate ? void 0 : event?.eventId,
                productId,
                salesGroupId
              }
            };
          }
          return defaultPromos;
        }
        return defaultPromos;
      },
      {}
    );
    const volumePromosArray = Object.entries(promos).filter(([, value]) => value.promotionType === "volume").reduce((acc, next) => {
      const [key, value] = next;
      return [...acc, { ticketIndex: key, ...value }];
    }, []);
    const volumePromosById = volumePromosArray.reduce(
      (acc, promo) => ({
        ...acc,
        [promo.promotionId]: acc[promo.promotionId] ? acc[promo.promotionId].concat(promo) : [promo]
      }),
      {}
    );
    let promosWithDiscount = [];
    Object.values(volumePromosById).forEach((promosById) => {
      const numberPromos = promosById.length;
      const newVolumeKeysArray = promosById.reduce((acc, promo) => {
        const discardPromosByDiscount = acc.filter(
          (promoCheaper) => promoCheaper.discount > promo.discount
        );
        const maxPromos = Math.trunc(numberPromos / promo.leftPurchased) * (promo.leftPurchased - promo.rightPaid);
        if (acc.length < maxPromos) {
          return acc.concat(promo);
        }
        if (!isEmpty(discardPromosByDiscount)) {
          const validPromos = acc.filter(
            (validPromosFilter) => validPromosFilter.ticketIndex !== discardPromosByDiscount[0].ticketIndex
          );
          return validPromos.concat(promo);
        }
        return acc;
      }, []).map((promo) => promo.ticketIndex);
      promosWithDiscount = promosWithDiscount.concat(newVolumeKeysArray);
    });
    Object.entries(promos).filter(([, value]) => value.promotionType === "volume").forEach(([key]) => {
      if (!promosWithDiscount.includes(key)) {
        promos[key].discount = 0;
      }
    });
    if (isEmpty(promos) && buyerTypePromotions) {
      promos = buyerTypePromotions;
    }
    this.setState({ ticketIndexPromotionMap: promos, buyerTypesPromotions }, () => applyPromotions(promos));
  };
  buyerTypePromoObject = (ticketMap, promotionsByBuyerType) => {
    const { seats = [] } = this.props;
    const buyerTypesPromotions = [];
    Object.entries(ticketMap).filter(
      ([buyerTypeId]) => promotionsByBuyerType[buyerTypeId] && Object.keys(promotionsByBuyerType[buyerTypeId]).length > 0
    ).forEach(([buyerTypeId, ticketQuantity]) => {
      for (let quantity = 0; quantity < ticketQuantity; quantity++) {
        const promotion = {
          buyerTypeId: Number(buyerTypeId),
          promotionsByBuyerType: promotionsByBuyerType[buyerTypeId],
          ticketIndex: `buyerTypePromo-${buyerTypeId}-${quantity}`
        };
        const seatListCopy = [...seats];
        if (seatListCopy && seatListCopy.length > 0) {
          promotion.seat = seatListCopy.shift();
        }
        buyerTypesPromotions.push(promotion);
      }
    });
    return buyerTypesPromotions;
  };
  applyMultiplePromotions(event) {
    const promotionId = event.target.value;
    const { ticketIndexPromotionMap, buyerTypesPromotions } = this.state;
    const { promotions: promotions2, salesGroupId, productId, productIsOpenDate, applyPromotions } = this.props;
    let selectedPromos = {};
    const promotionSelected = promotionId && promotions2.find((promo) => promo.promotionId === Number(promotionId));
    buyerTypesPromotions.forEach((buyerType) => {
      if (promotionSelected && promotionSelected.buyerTypeIds.includes(Number(buyerType.buyerTypeId))) {
        const promotionToApply = Object.values(buyerType.promotionsByBuyerType).find(
          (promo) => promo.promotionId === Number(promotionId)
        );
        selectedPromos = {
          ...ticketIndexPromotionMap,
          ...selectedPromos,
          [buyerType.ticketIndex]: {
            ...promotionToApply,
            applied: true,
            buyerTypeId: Number(buyerType.buyerTypeId),
            quantity: 0,
            eventId: productIsOpenDate ? void 0 : event?.eventId,
            productId,
            salesGroupId
          }
        };
      }
    });
    this.setState({ ticketIndexPromotionMap: selectedPromos }, () => applyPromotions(selectedPromos));
  }
  applyPromotionToState(promotion, ticketIndexArray) {
    const { ticketIndexPromotionMap } = this.state;
    const { event, productId, salesGroupId, productIsOpenDate, applyPromotions } = this.props;
    ticketIndexArray.forEach((ticketIndex) => {
      ticketIndexPromotionMap[ticketIndex] = {
        ...promotion,
        eventId: productIsOpenDate ? void 0 : event?.eventId,
        productId,
        salesGroupId
      };
    });
    this.setState({ ticketIndexPromotionMap }, () => applyPromotions(ticketIndexPromotionMap));
  }
  render() {
    const {
      placeholderCode,
      buttonTextValidate,
      productInfo,
      productConfiguration = [],
      promotionCodeValid,
      promotions: promotions2,
      ticketMap,
      isSeller,
      timeZone,
      currency,
      event,
      buyerTypes: buyerTypes2,
      seats = [],
      showError,
      checkPromotionCode
    } = this.props;
    const { ticketIndexPromotionMap } = this.state;
    const selectedBuyerTypes = Object.keys(ticketMap).map((btId) => Number(btId));
    const availableAgreements = promotions2.filter(
      (promo) => promo.promotionType === "agreement" && promo.buyerTypeIds.some((buyerTypeId) => selectedBuyerTypes.includes(buyerTypeId)) && generalValidationsMemo({
        promotion: promo,
        event,
        checkBuyerTypes: false,
        timeZone
      })
    );
    const { buyerTypesPromotions = [] } = this.state;
    let { code } = this.state;
    code = code ? code.trim() : code;
    const typedProductConfiguration = productConfiguration;
    const promotionCommonDescription = typedProductConfiguration.filter(
      (configuration) => configuration.configKey === "promotions_common_description"
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "promotions", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "panel-body-header", children: [
        promotionCommonDescription && promotionCommonDescription.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
          InfoType,
          {
            infoType: {
              description: promotionCommonDescription[0].configValue,
              messageClass: "cl_info",
              hideTitle: true
            }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormattedMessage,
          {
            defaultMessage: "Introduce el código promocional o selecciona una promoción para\n          obtener el descuento",
            id: "text.promotions",
            tagName: "p"
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "panel-body-content", children: [
        productInfo && productInfo.top,
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          PromotionalCodeCode,
          {
            onChange: this.handleCode,
            onClick: this.handleCodeValidation,
            placeholderCode,
            buttonTextValidate,
            promotionCodeValid,
            code,
            selectedBuyerTypes
          }
        ),
        !isEmpty(availableAgreements) && isSeller && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "form-horizontal form-custom", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-12 promotions-item", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "form-group form-custom", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "available-agreements-select", className: "col-md-4 text-right", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "text.agreement.promotions", defaultMessage: "Agreements" }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-4", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "select-form-control", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                "select",
                {
                  id: "available-agreements-select",
                  className: "form-control",
                  onChange: this.applyMultiplePromotions,
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "" }),
                    availableAgreements.map((promoAgreement, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: promoAgreement.promotionId, children: promoAgreement.name }, index2))
                  ]
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-own-arrow_drop_down" })
            ] }) })
          ] }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", {})
        ] }),
        buyerTypesPromotions.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Otras promociones", id: "title.other.promotions" }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-horizontal form-custom", children: buyerTypesPromotions.map((btpromotion, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            BuyerTypePromotion$1,
            {
              buyerType: buyerTypes2[btpromotion.buyerTypeId],
              ticketIndex: btpromotion.ticketIndex,
              seat: seats[index2],
              seatPromo: promotions2,
              showError,
              promotions: btpromotion.promotionsByBuyerType,
              checkPromotionCode,
              promotionData: ticketIndexPromotionMap[btpromotion.ticketIndex],
              handleChange: this.handleChange,
              currency: currency ?? ""
            },
            btpromotion.ticketIndex
          )) })
        ] }),
        productInfo && productInfo.bottom
      ] })
    ] });
  }
}
function cleanPromotionalCode() {
  return {
    type: PROMOTION_CODE_CLEAN
  };
}
function fetchPromotionCode({
  salesGroupId = throwIfMissing$1("salesGroupId"),
  productId = throwIfMissing$1("productId"),
  eventId,
  code,
  type = "promotional_code",
  promotionId,
  ...params
}) {
  const REQUEST = type === "promotional_code" ? PROMOTION_CODE_REQUEST : PROMOTION_EXTERNAL_REQUEST;
  const SUCCESS = type === "promotional_code" ? PROMOTION_CODE_SUCCESS : PROMOTION_EXTERNAL_SUCCESS;
  const FAILURE = type === "promotional_code" ? PROMOTION_CODE_FAILURE : PROMOTION_EXTERNAL_FAILURE;
  let requestParams = {
    salesGroupId,
    productId,
    eventId,
    promotionId,
    promotionType: type,
    ...params
  };
  if (typeof code === "object" && code.promotionKey) {
    requestParams = {
      ...requestParams,
      promotionKey: code.promotionKey,
      promotionCode: code.promotionCode
    };
  } else {
    requestParams = {
      ...requestParams,
      promotionCode: code
    };
  }
  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL()}/promotion/validate`,
      types: [REQUEST, SUCCESS, FAILURE],
      authenticated: true,
      params: requestParams
    }
  };
}
function fetchRecommendation(body) {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL()}/recommendations`,
      config: {
        method: "POST",
        body: JSON.stringify(body)
      },
      authenticated: true,
      types: [
        PRODUCT_RECOMMENDATION_REQUEST,
        PRODUCT_RECOMMENDATION_SUCCESS,
        PRODUCT_RECOMMENDATION_FAILURE
      ]
    }
  };
}
function cleanRecommendations() {
  return {
    type: PRODUCT_RECOMMENDATION_CLEAN
  };
}
function fetchProductServices({
  salesGroupId,
  productId,
  purchaseDatetime,
  eventDatetime
}) {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL()}/services/views/relationids`,
      params: {
        salesGroupId,
        productId,
        purchaseDatetime,
        eventDatetime
      },
      config: {
        headers: {
          "Internal-Cache-Control": "no-cache"
        }
      },
      authenticated: true,
      types: [PRODUCT_SERVICES_REQUEST, PRODUCT_SERVICES_SUCCESS, PRODUCT_SERVICES_FAILURE]
    }
  };
}
function setPromotionSelected({
  productId,
  promotionId,
  promotionName
}) {
  return {
    type: SET_PROMOTION_SELECTED,
    payload: {
      productId,
      promotionId,
      promotionName
    }
  };
}
function show(showMessage, message) {
  return {
    type: LOADER_SHOW,
    data: { showMessage, message }
  };
}
function hide() {
  return {
    type: LOADER_HIDE
  };
}
const query$1 = queryString.parse(window.location.search);
function addToCart({
  productId = throwIfMissing$1("productId"),
  salesGroupId = throwIfMissing$1("salesGroupId"),
  ...values
}) {
  let body = {
    productId,
    salesGroupId,
    ...values
  };
  const hasDynamicPricing = window.pos?.hasDynamicPricing === true;
  if (hasDynamicPricing) {
    const dynamicPricingMapObj = {
      pricingWebCookie: Cookie.get("UUID_CB") || null,
      ...query$1.ta && { ta: query$1.ta },
      ...query$1.ap && { ap: query$1.ap }
    };
    if (Object.keys(dynamicPricingMapObj).length > 0) {
      const dynamicPricingMap = JSON.stringify(dynamicPricingMapObj);
      body = { ...body, dynamicPricingMap };
    }
  }
  const config = {
    method: "POST",
    body: JSON.stringify(body)
  };
  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL()}/reservations`,
      config,
      authenticated: true,
      types: [RESERVATION_REQUEST, RESERVATION_SUCCESS, RESERVATION_FAILURE]
    }
  };
}
function addToCartLoyalty({
  productId = throwIfMissing$1("productId"),
  salesGroupId = throwIfMissing$1("salesGroupId"),
  ...values
}) {
  const body = {
    productId,
    salesGroupId,
    ...values
  };
  const config = {
    method: "POST",
    body: JSON.stringify(body)
  };
  return {
    [CALL_API]: {
      endpoint: `${LOYALTY_SERVICE_URL()}/reservations`,
      config,
      authenticated: true,
      types: [RESERVATION_REQUEST, RESERVATION_SUCCESS, RESERVATION_FAILURE]
    }
  };
}
function setCookieLifeTime(time) {
  return {
    cookieLifeTime: time,
    type: SET_COOKIE_LIFETIME
  };
}
const getServiceSelectionMap = (services = {}) => Object.entries(services).reduce((res, [serviceId, value]) => {
  const { buyerTypeCounts } = value;
  if (buyerTypeCounts && Object.keys(buyerTypeCounts).length) {
    return { ...res, [serviceId]: { buyerTypeCounts } };
  }
  if (value.quantity > 0) {
    return { ...res, [serviceId]: { count: value.count ?? value.quantity } };
  }
  return res;
}, {});
function clean() {
  return {
    type: CART_CLEAN
  };
}
function update(cart2) {
  return {
    type: CART_UPDATE,
    cart: cart2
  };
}
function updateDate(date) {
  return {
    type: CART_UPDATE_DATE,
    date
  };
}
function updateHour(hour) {
  return {
    type: CART_UPDATE_HOUR,
    hour
  };
}
function updateEvents(events2) {
  return {
    type: CART_UPDATE_EVENTS,
    events: events2
  };
}
function addMembershipForms(forms) {
  return {
    type: CART_ADD_MEMBERS,
    membershipForms: forms
  };
}
function cleanEvents() {
  return updateEvents([]);
}
function addEvent(event) {
  return {
    type: CART_ADD_EVENT,
    event
  };
}
function setFirstEventSelected() {
  return (dispatch, getState) => {
    const eventList = getEventsWithPromotionFlag(getState());
    if (eventList.length) {
      dispatch(addEvent(eventList[0]));
    }
  };
}
function updateBt({
  tickets,
  ticketsQuantity,
  total
}) {
  return {
    type: CART_UPDATE_BT,
    tickets,
    ticketsQuantity,
    total
  };
}
function cleanServices() {
  return {
    type: CART_CLEAN_SERVICES
  };
}
function cleanPromotions() {
  return {
    type: CART_CLEAN_PROMOTIONS
  };
}
function updatePromotionTickets(promotionDataList) {
  return {
    type: CART_UPDATE_PROMOTIONS,
    promotionDataList
  };
}
function updateServices(serviceSelectedMap) {
  return {
    type: CART_UPDATE_SERVICES,
    services: serviceSelectedMap
  };
}
function addSeats({ seat: seatList, buyerType }) {
  return {
    type: CART_ADD_SEATS,
    seatList,
    buyerType
  };
}
function removeSeats(seatIdList) {
  return {
    type: CART_REMOVE_SEATS,
    seatIdList
  };
}
function setRecommendationAsked() {
  return {
    type: CART_RECOMMENDATION_ASKED
  };
}
function setRecommendationNotAsked() {
  return {
    type: CART_RECOMMENDATION_NOT_ASKED
  };
}
function setAnswerList(answers, productFormList) {
  return {
    type: CART_ADD_ANSWERS,
    answers,
    productFormList
  };
}
function updateAll(cart2) {
  return (dispatch) => {
    dispatch(update(cart2));
  };
}
function checkRecommendation({
  productId,
  salesGroupId,
  ticketTypeNumberMap,
  serviceQuantityMap,
  eventsFilteredForRecommendations
}) {
  return (dispatch) => {
    if (eventsFilteredForRecommendations && eventsFilteredForRecommendations.length === 1) {
      return dispatch(
        fetchRecommendation({
          offeringType: "online",
          // private String offeringType; // ['online', 'email', 'email_batch']
          salesGroupId,
          // private Integer salesGroupId;
          productId,
          // private Integer productId;
          buyerTypeMap: ticketTypeNumberMap,
          // private Map<Integer, Integer> buyerTypeMap;
          eventId: eventsFilteredForRecommendations[0].eventId,
          // TODO: solo uno // private Integer eventId;
          serviceMap: serviceQuantityMap
          // private Map<Integer, String> extrasSelectedMap;
        })
      ).then(({ response }) => {
        if (!response || !response.recommendationRuleId) {
          return Promise.reject();
        }
        return Promise.resolve();
      });
    }
    return Promise.reject();
  };
}
function setEventsFetching() {
  return {
    type: EVENTS_REQUEST
  };
}
function getEventsAvailability({
  salesGroupId,
  productId,
  venueId,
  date,
  timeZone,
  product,
  isOpenDateWithoutCalendar
}) {
  return async (dispatch, getState) => {
    dispatch(cleanPromotions());
    dispatch(setEventsFetching());
    let recaptcha;
    if (Cookie.get("captcha") === "true") {
      recaptcha = await new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(window.serviceUrls.reCaptchaKey, { action: "getAvailability" }).then((token2) => {
            resolve(token2);
          }).catch(reject);
        });
      });
    }
    const dateIfOpen = moment.tz(timeZone).format(DATE_FORMAT_YMD);
    const params = {
      salesGroupId,
      productId,
      venueId,
      startDateFrom: isOpenDateWithoutCalendar ? dateIfOpen : moment(date).format(DATE_FORMAT_YMD),
      startDateTo: isOpenDateWithoutCalendar ? dateIfOpen : moment(date).format(DATE_FORMAT_YMD),
      timeZone,
      recaptcha
    };
    dispatch(fetchEvents(params)).then((e) => {
      if (isOpenTimeAndMultiVenue(product)) {
        const events2 = addOrUpdateEvent(
          e.response[0],
          getState()
        );
        if (events2) dispatch(updateEvents(events2));
      }
    });
  };
}
function onChangeDate({
  date = /* @__PURE__ */ new Date(),
  salesGroupId,
  productId,
  venueId,
  timeZone,
  product
}) {
  return (dispatch) => {
    dispatch(updateDate(date));
    if (!isOpenTimeAndMultiVenue(product)) dispatch(cleanEvents());
    if (date && salesGroupId && productId) {
      dispatch(
        getEventsAvailability({
          salesGroupId,
          productId,
          venueId,
          date,
          timeZone,
          product: isOpenTimeAndMultiVenue(product) ? product : null,
          isOpenDateWithoutCalendar: !!(product && product.openDate && !product.showCalendar)
        })
      );
    }
  };
}
function onChangeEvents({ eventList = [] }) {
  return (dispatch) => {
    dispatch(
      updateEvents(
        eventList.map(({ startDatetime, endDatetime, ...e }) => ({
          ...e,
          startDatetime: new Date(startDatetime).toISOString(),
          endDatetime: endDatetime ? new Date(endDatetime).toISOString() : void 0
        }))
      )
    );
    const date = eventList[0] && eventList[0].startDatetime;
    dispatch(updateHour(`${new Date(date).getHours()}:${new Date(date).getMinutes()}`));
  };
}
function addRecaptcha(recaptcha) {
  return {
    type: CART_ADD_RECAPTCHA,
    recaptcha
  };
}
function handleAddToCart({
  cart: cart2,
  pos,
  cookieLifeTime,
  timeZone,
  recommendationEngineEnabled,
  loyalty,
  productFormList,
  hasAddons,
  isSeller,
  currency,
  eventList
}, callback) {
  return (dispatch) => {
    if (!cart2.status.valid) {
      if (cart2.status.notifications && cart2.status.notifications.length) {
        cart2.status.notifications.forEach((notification) => {
          dispatch(notificationsExports.error(notification));
        });
      }
      return Promise.resolve();
    }
    const {
      events: events2,
      eventCode,
      distributorReference,
      date,
      reservationObservationText,
      ticketGroupType,
      tickets,
      seatList,
      salesGroup,
      product,
      askForRecommendation,
      parentReservationId,
      answers,
      services,
      promotionDataList,
      recaptcha,
      code,
      refererProductId,
      recommendationRuleId,
      sellerId,
      customerId,
      externalCustomerId,
      membershipForms
    } = cart2;
    const { salesGroupId } = salesGroup;
    const { productId } = product;
    const typedProduct = product;
    let mustSendVenueDateMap = false;
    const venueDateMap = {};
    let eventsFiltered = events2;
    let eventsFilteredForRecommendations = events2;
    const servicesFiltered = { ...services };
    const ticketTypeNumberMap = {};
    Object.entries(tickets).forEach(([key, value]) => {
      ticketTypeNumberMap[key] = value.n || 0;
    });
    let seatBuyerTypeMap;
    if (seatList && seatList.length) {
      seatBuyerTypeMap = seatList.reduce(
        (res, s) => ({ ...res, [s.seatId]: s.buyerTypeId }),
        {}
      );
    }
    const noNeedsEvent = productNoNeedsEvents(typedProduct);
    if (typedProduct.openTime || typedProduct.openDate || typedProduct.onlyExtras) {
      mustSendVenueDateMap = true;
      if (typedProduct.productVenueSet) {
        typedProduct.productVenueSet.filter((pv) => pv.openDate || pv.openTime || typedProduct.onlyExtras).forEach((productVenue) => {
          if (typedProduct.openTime && events2 && events2.length > 0) {
            const eventForVenue = events2.find((e) => e.venueId === productVenue.venueId);
            if (eventForVenue) {
              venueDateMap[productVenue.venueId] = eventForVenue.startDatetime;
            } else if (eventList && eventList.length > 0) {
              venueDateMap[productVenue.venueId] = eventList[0].startDatetime;
            }
          } else {
            events2.filter((e) => e.venueId === productVenue.venueId).forEach((openEvent) => {
              venueDateMap[openEvent.venueId] = openEvent.startDatetime;
              eventsFiltered = events2.filter((eventInCart) => eventInCart.eventId !== openEvent.eventId);
            });
            if (productVenue.validType === "calendar") {
              const openCalendarDate = moment.tz(timeZone).startOf("day").format();
              venueDateMap[productVenue.venueId] = openCalendarDate;
            }
          }
        });
        if (typedProduct.onlyExtras) {
          venueDateMap[typedProduct.productVenueSet[0].venueId] = date;
        }
      }
    }
    let eventIdList;
    if (eventsFiltered && !noNeedsEvent) {
      eventIdList = eventsFiltered.map((e) => e.eventId);
    } else {
      eventIdList = [];
    }
    let promoCode = code;
    if (!promoCode && promotionDataList && Object.entries(promotionDataList).length > 0) {
      Object.entries(promotionDataList).forEach(([, promotionData]) => {
        const pd = promotionData;
        if (pd.promotionCode) {
          promoCode = pd.promotionCode;
        }
      });
    }
    const promoObject = promotionDataList && Object.entries(promotionDataList).length > 0 && Object.values(promotionDataList).map((values, index2) => ({
      ...values,
      ticketNumber: index2
    }));
    const getAnswers = (answersList) => {
      const scopeKey = (genericFieldId, groupIndex, buyerTypeId) => {
        let key = String(genericFieldId);
        if (groupIndex) key = `${key}-${groupIndex}`;
        if (buyerTypeId) key = `${key}-${buyerTypeId}`;
        return key;
      };
      const answersMap = {};
      answersList.forEach((answer) => {
        answersMap[scopeKey(answer.genericFieldId, answer.groupIndex, answer.buyerTypeId)] = answer;
      });
      const dependentFields = (productFormList ?? []).flatMap((form2) => form2.formFieldsetSet ?? []).flatMap((fieldset) => fieldset.genericFieldSet ?? []).filter(
        (field) => field.parentGenericField?.genericFieldId !== void 0 && field.parentFieldOptionsValue !== void 0
      );
      dependentFields.forEach((field) => {
        const parentFieldId = field.parentGenericField.genericFieldId;
        const allowedValues = (field.parentFieldOptionsValue ?? "").split(",").map((v) => v.trim());
        answersList.filter((answer) => answer.genericFieldId === field.genericFieldId).forEach((answer) => {
          const parentAnswer = answersMap[scopeKey(parentFieldId, answer.groupIndex, answer.buyerTypeId)];
          const parentValue = parentAnswer?.answerValue ?? parentAnswer?.answer;
          if (!parentValue || !allowedValues.includes(parentValue)) {
            delete answersMap[scopeKey(field.genericFieldId, answer.groupIndex, answer.buyerTypeId)];
          }
        });
      });
      return Object.values(answersMap);
    };
    const reservationData = {
      recaptcha,
      eventCode,
      productId,
      salesGroupId,
      distributorReference,
      reservationObservationText,
      ticketGroupType,
      upgradeReservationId: parentReservationId,
      eventIdList,
      ticketTypeNumberMap,
      seatBuyerTypeMap,
      refererProductId,
      recommendationRuleId,
      promotionDataSet: promoObject && promoObject.length ? promoObject : void 0,
      genericFieldAnswers: getAnswers(answers),
      promotionCode: promoCode || void 0,
      sellerId,
      customerId,
      externalCustomerId,
      loyaltyCode: loyalty && loyalty.loyaltyUser && loyalty.loyaltyUser.loyaltyCode ? loyalty.loyaltyUser.loyaltyCode : void 0,
      loyaltyType: loyalty && loyalty.loyaltyType,
      venueDateMap: mustSendVenueDateMap ? venueDateMap : void 0,
      loyaltyUserList: membershipForms && Object.values(membershipForms)
    };
    let serviceQuantityMap = {};
    if (servicesFiltered && Object.keys(servicesFiltered).length) {
      Object.keys(servicesFiltered).forEach((serviceId) => {
        if (!servicesFiltered[serviceId]) {
          delete servicesFiltered[serviceId];
          return;
        }
        const { disabledDates } = servicesFiltered[serviceId];
        if (events2.some(
          (event) => disabledDates && disabledDates.split(",").includes(moment(event.startDatetime).format(DATE_FORMAT_DMY_COMPACT))
        )) {
          delete servicesFiltered[serviceId];
        }
      });
      serviceQuantityMap = Object.entries(servicesFiltered).reduce(
        (res, [serviceId, value]) => {
          if (value.quantity > 0) {
            return {
              ...res,
              [serviceId]: value.quantity
            };
          }
          return { ...res };
        },
        {}
      );
      reservationData.serviceSelectionMap = getServiceSelectionMap(servicesFiltered);
    }
    dispatch(show(true));
    if (noNeedsEvent) eventsFilteredForRecommendations = eventList;
    const checkRecommendationPromise = !askForRecommendation || !recommendationEngineEnabled ? Promise.reject() : dispatch(
      checkRecommendation({
        ...reservationData,
        serviceQuantityMap,
        eventsFilteredForRecommendations
      })
    ).then(() => {
      dispatch(hide());
    });
    return checkRecommendationPromise.catch(() => {
      const webCookie = typedProduct.numbered && Cookie.get("tiqueteoSessionNumbered") ? Cookie.get("tiqueteoSessionNumbered") : Cookie.get("tiqueteoSession");
      const body = {
        webCookie,
        ...reservationData
      };
      const handleReservationResponse = (response, dispatchParam, cookieLifeTimeParam, callbackParam) => {
        if (response && response.purchaseId) {
          if (response.webCookie) {
            setCookie("tiqueteoSession", response.webCookie, {
              path: "/",
              expires: addMinutes(/* @__PURE__ */ new Date(), cookieLifeTimeParam)
            });
            const expirationDate = addMinutes(/* @__PURE__ */ new Date(), cookieLifeTimeParam);
            localStorage.setItem("cookieLifeTime", String(expirationDate));
            dispatchParam(setCookieLifeTime(expirationDate));
          }
          if (!hasAddons || isSeller) {
            dispatchParam(hide());
            dispatchParam(clean());
            dispatchParam(cleanPromotionalCode());
          }
          callbackParam();
        } else {
          dispatchParam(notificationsExports.error(createReservationErrorNotys()));
          dispatchParam(hide());
        }
      };
      const posName = pos.posName ? pos.posName : pos.clients[0].clientUrlName;
      if (typedProduct.membership && !typedProduct.renewal) {
        dispatch(addToCartLoyalty(body)).then(({ response }) => {
          addToCart$1(cart2, posName, timeZone, response.reservationList, currency);
          handleReservationResponse(response, dispatch, cookieLifeTime, callback);
        }).catch(() => {
          dispatch(notificationsExports.error(createReservationErrorNotys()));
          dispatch(hide());
        });
      } else {
        dispatch(addToCart(body)).then(({ response }) => {
          addToCart$1(cart2, posName, timeZone, response.reservationList, currency);
          handleReservationResponse(response, dispatch, cookieLifeTime, callback);
        }).catch(() => {
          dispatch(hide());
        });
      }
    });
  };
}
const messages$2 = defineMessages({
  placeholderCode: {
    id: "placeholder.promotionalCode",
    defaultMessage: "Promotional code"
  },
  buttonTextValidate: {
    id: "button.validate.promotionalCode",
    defaultMessage: "Validate"
  }
});
class PromotionsEditContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPromos: false,
      promotionDataList: {},
      appliedEditPromos: {}
    };
    this.applyPromotion = this.applyPromotion.bind(this);
    this.checkPromotionCode = this.checkPromotionCode.bind(this);
    this.showPromotionCodeNotification = this.showPromotionCodeNotification.bind(this);
    this.showPromotionCodeError = this.showPromotionCodeError.bind(this);
    this.showPromotionCodeNotFound = this.showPromotionCodeNotFound.bind(this);
    this.handleShowPromos = this.handleShowPromos.bind(this);
  }
  componentDidMount() {
    const { dispatch, initialTickets, productId, salesGroupId } = this.props;
    let ticketIndex = 0;
    const promotionDataList = initialTickets.filter((ticket) => ticket.promotionId).sort((a, b) => Number(a.buyerTypeId) - Number(b.buyerTypeId)).reduce((acc, ticket, index2) => {
      if (acc[`buyerTypePromo-${ticket.buyerTypeId}-${ticketIndex}`]) {
        ticketIndex++;
      } else {
        ticketIndex = 0;
      }
      const { commissionAmount = 0 } = ticket;
      return {
        ...acc,
        [`buyerTypePromo-${ticket.buyerTypeId}-${ticketIndex}`]: {
          promotionId: ticket.promotionId,
          name: ticket.promotionName,
          promotionType: ticket.promotionType,
          isGrouped: false,
          discount: Math.round((ticket.amountOriginal + commissionAmount - ticket.amount) * 100) / 100,
          amount: ticket.amount - commissionAmount,
          price: ticket.amountOriginal,
          applied: true,
          buyerTypeId: ticket.buyerTypeId,
          eventId: ticket.eventId,
          productId,
          salesGroupId,
          ticketNumber: index2
        }
      };
    }, {});
    dispatch(
      updatePromotionTickets(promotionDataList)
    );
    this.setState({ appliedEditPromos: promotionDataList });
  }
  handleShowPromos(showPromos) {
    this.setState({ showPromos });
  }
  showPromotionCodeNotification(type, _promotion, number2) {
    const { dispatch } = this.props;
    if (number2 > 0) {
      dispatch(
        notificationsExports.success(
          createNotification({
            title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Promotion", id: "notification.ok.title.promotion" }),
            message: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Promotion applied to tickets", id: "notification.ok.text.promotion" }),
            position: "bc",
            type,
            autoDismiss: 5
          })
        )
      );
    }
  }
  showPromotionCodeError() {
    const { dispatch } = this.props;
    dispatch(
      notificationsExports.error(
        createNotification({
          title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Error", id: "notification.ko.title.promotion" }),
          message: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Promotion uses exceeded", id: "notification.ko.text.promotion" }),
          position: "bc",
          type: "error",
          autoDismiss: 5
        })
      )
    );
  }
  checkPromotionCode(code, type, promotionId, ticketIndex) {
    const { dispatch, event, productId, salesGroupId, reservationId } = this.props;
    const eventId = event?.eventId;
    const { promotionDataList } = this.state;
    let isValid2 = true;
    if (Object.values(promotionDataList).some(
      (promo) => promo.promotionCode === code && promo.promotionType === "agreement"
    )) {
      this.showPromotionCodeError();
      isValid2 = false;
    }
    if (isValid2) {
      dispatch(
        fetchPromotionCode({
          code,
          eventId,
          salesGroupId,
          productId,
          type,
          promotionId,
          ticketIndex,
          reservationId
        })
      ).then((action) => {
        if (action.response && action.response.externalProviderId) {
          const idx = ticketIndex;
          if (promotionDataList[idx] && promotionDataList[idx].promotionId === promotionId) {
            promotionDataList[idx] = {
              ...promotionDataList[idx],
              applied: true,
              promotionCode: code
            };
            this.applyPromotion(promotionDataList);
          }
        }
      });
    }
  }
  applyPromotion(promotionDataList) {
    const { dispatch } = this.props;
    const dataListFiltered = {};
    Object.entries(promotionDataList).forEach(([key, data2]) => {
      if (!(data2.externalProviderId && !data2.promotionCode) && data2.promotionId !== -1) {
        dataListFiltered[key] = data2;
      }
    });
    this.setState(
      { promotionDataList },
      () => dispatch(
        updatePromotionTickets(dataListFiltered)
      )
    );
  }
  showPromotionCodeNotFound() {
    const { dispatch } = this.props;
    dispatch(
      notificationsExports.error(
        createNotification({
          title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Error", id: "notification.ko.title.promotion" }),
          message: /* @__PURE__ */ jsxRuntimeExports.jsx(
            FormattedMessage,
            {
              defaultMessage: "The resource was not found",
              id: "notification.error.text.promotioncode.notFound",
              tagName: "n"
            }
          ),
          position: "bc",
          type: "error",
          autoDismiss: 5
        })
      )
    );
  }
  render() {
    const {
      productId,
      salesGroupId,
      buyerTypeMap,
      promotionList = [],
      event,
      intl,
      productInfo,
      promotionDataList,
      seatList,
      store,
      tickets,
      timeZone,
      currency,
      initialReservationTicketLength,
      currentReservationTicketLength,
      isOpenDateCalendar
    } = this.props;
    const { showPromos, appliedEditPromos } = this.state;
    const placeholderCode = intl.formatMessage(messages$2.placeholderCode);
    const buttonTextValidate = intl.formatMessage(messages$2.buttonTextValidate);
    const showPromosAgreement = appliedEditPromos && Object.values(appliedEditPromos).some((promo) => Object.values(promo).includes("agreement"));
    const showPromoAgreementOnSelectBuyerType = !_isEqual(initialReservationTicketLength, currentReservationTicketLength) && showPromosAgreement;
    return !isEmpty(tickets) && !isEmpty(buyerTypeMap) && !isEmpty(event) && !isEmpty(promotionList) && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /* @__PURE__ */ jsxRuntimeExports.jsx(Provider, { store, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pull-right", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          type: "button",
          tabIndex: 0,
          className: "clickable",
          onClick: () => this.handleShowPromos(!showPromos),
          onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.handleShowPromos(!showPromos);
            }
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-own-discount_label" }),
            " ",
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              FormattedHTMLMessage,
              {
                id: "title.text.promotions",
                defaultMessage: "Do you have a promotional code? Click <strong>here</strong> to apply it"
              }
            )
          ]
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "clearfix" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("section", { className: "section-promotion", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `main-panel ${showPromos || showPromoAgreementOnSelectBuyerType ? "" : "hidden"}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        PromotionSelector,
        {
          productId,
          salesGroupId,
          buyerTypes: buyerTypeMap,
          promotions: promotionList,
          seats: seatList,
          ticketMap: tickets,
          event: event || void 0,
          placeholderCode,
          buttonTextValidate,
          buyerTypePromotions: promotionDataList,
          showNotification: this.showPromotionCodeNotification,
          showError: this.showPromotionCodeError,
          showNotFound: this.showPromotionCodeNotFound,
          checkPromotionCode: this.checkPromotionCode,
          applyPromotions: this.applyPromotion,
          productInfo,
          isSeller: true,
          timeZone,
          currency,
          productIsOpenDate: isOpenDateCalendar
        }
      ) }) })
    ] }) });
  }
}
const mapStateToProps$l = (state) => {
  const { cart: cart2, promotions: promotions2, products: products2, editReservation: editReservation2, pointOfSales } = state;
  const { promotionDataList, seatList } = cart2;
  const { selectedEventPerVenue, selectedBuyerTypes, initialReservationState } = editReservation2;
  const { selectedEventPerVenue: initialSelectedEventPerVenue = {} } = initialReservationState;
  const { promotionCode, promotionCodeValid } = promotions2;
  const { productInfoList, productList = [] } = products2;
  const { clientList } = pointOfSales;
  const venuesMap = getVenueMap(state);
  const mainVenue = !isEmpty(venuesMap) && Object.values(venuesMap).find((venue) => !venue?.mainVenueId);
  let event = !isEmpty(selectedEventPerVenue) && !isEmpty(mainVenue) && mainVenue && selectedEventPerVenue[mainVenue.venueId] || false;
  const tickets = Object.entries(selectedBuyerTypes).reduce((acc, [key, values]) => {
    return {
      ...acc,
      [key]: values.n
    };
  }, {});
  const initialReservationTicketLength = tickets && Object.values(tickets).reduce((total, num) => total + num, 0);
  const currentReservationTicketLength = initialReservationState.ticketList?.length ?? 0;
  if (!event) {
    event = !isEmpty(initialSelectedEventPerVenue) && !isEmpty(mainVenue) && mainVenue && initialSelectedEventPerVenue[mainVenue.venueId] || false;
  }
  return {
    venuesList: Object.values(venuesMap),
    isOpenDateCalendar: productList[0].openDate && productList[0].productVenueSet[0].validType === "calendar" || !!productList[0].openTime,
    event,
    tickets,
    promotionList: getPromotionListWithCodeIfApply(state),
    promotionCode,
    promotionCodeValid,
    promotionDataList: promotionDataList ?? {},
    buyerTypeMap: getBuyerTypeMap(state),
    productInfo: getProductInfoMap(productInfoList, "promotions"),
    currency: clientList[0].currencyList[0].isoCode,
    initialReservationTicketLength,
    currentReservationTicketLength,
    seatList
  };
};
const PromotionsEditContainer_default = connect(mapStateToProps$l)(injectIntl(PromotionsEditContainer));
const messages$1 = defineMessages({
  placeholderCode: {
    id: "placeholder.promotionalCode",
    defaultMessage: "Promotional code"
  },
  buttonTextValidate: {
    id: "button.validate.promotionalCode",
    defaultMessage: "Validate"
  }
});
class LinkedPromotionSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allPromos: {}
    };
    this.applyPromotion = this.applyPromotion.bind(this);
    this.checkPromotionCode = this.checkPromotionCode.bind(this);
    this.showPromotionCodeNotification = this.showPromotionCodeNotification.bind(this);
    this.showPromotionCodeError = this.showPromotionCodeError.bind(this);
    this.showPromotionCodeNotFound = this.showPromotionCodeNotFound.bind(this);
  }
  checkPromotionCode(code, type, promotionId, ticketIndex) {
    const { dispatch, event, productId, salesGroupId, isOpenDateCalendar } = this.props;
    const { allPromos } = this.state;
    const eventId = isOpenDateCalendar ? void 0 : event && event.eventId;
    let isValid2 = true;
    if (Object.values(allPromos).some(
      (promo) => promo.promotionCode === (typeof code === "string" ? code : code.promotionCode) && promo.promotionType === "agreement"
    )) {
      this.showPromotionCodeError();
      isValid2 = false;
    }
    let promotionValidation = {};
    if (typeof code === "object" && code.promotionCode && code.promotionKey) {
      promotionValidation = {
        promotionKey: code.promotionKey,
        promotionCode: code.promotionCode
      };
    } else if (typeof code === "string") {
      promotionValidation = {
        promotionCode: code
      };
    }
    if (isValid2) {
      dispatch(
        fetchPromotionCode({
          code,
          eventId,
          salesGroupId,
          productId,
          type,
          promotionId,
          ticketIndex
        })
      ).then((action) => {
        if (action.response && action.response.externalProviderId) {
          if (allPromos[ticketIndex] && allPromos[ticketIndex].promotionId === promotionId) {
            allPromos[ticketIndex] = {
              ...allPromos[ticketIndex],
              applied: true,
              ...promotionValidation
            };
            this.applyPromotion(allPromos);
          }
        }
      });
    }
  }
  applyPromotion(promotionDataList) {
    const { dispatch } = this.props;
    const dataListFiltered = {};
    Object.entries(promotionDataList).forEach(([key, data2]) => {
      if (!(data2.externalProviderId && !data2.promotionCode) && data2.promotionId !== -1) {
        dataListFiltered[key] = data2;
      }
    });
    this.setState(
      { allPromos: promotionDataList },
      () => dispatch(updatePromotionTickets(dataListFiltered))
    );
  }
  showPromotionCodeNotification(type, promotion, number2) {
    const { dispatch } = this.props;
    if (number2 > 0) {
      dispatch(
        notificationsExports.success(
          createNotification({
            title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Promotion", id: "notification.ok.title.promotion" }),
            message: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Promotion applied to tickets", id: "notification.ok.text.promotion" }),
            position: "bc",
            type,
            autoDismiss: 5
          })
        )
      );
    }
  }
  showPromotionCodeError() {
    const { dispatch } = this.props;
    dispatch(
      notificationsExports.error(
        createNotification({
          title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Error", id: "notification.ko.title.promotion" }),
          message: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Promotion uses exceeded", id: "notification.ko.text.promotion" }),
          position: "bc",
          type: "error",
          autoDismiss: 5
        })
      )
    );
  }
  showPromotionCodeNotFound() {
    const { dispatch } = this.props;
    dispatch(
      notificationsExports.error(
        createNotification({
          title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Error", id: "notification.ko.title.promotion" }),
          message: /* @__PURE__ */ jsxRuntimeExports.jsx(
            FormattedMessage,
            {
              defaultMessage: "The resource was not found",
              id: "notification.error.text.promotioncode.notFound",
              tagName: "n"
            }
          ),
          position: "bc",
          type: "error",
          autoDismiss: 5
        })
      )
    );
  }
  render() {
    const {
      productId,
      isOpenDateCalendar,
      salesGroupId,
      buyerTypeMap,
      promotionList = [],
      event,
      intl,
      productInfo,
      productConfiguration,
      promotionDataList,
      sellerIdSelected,
      tickets,
      timeZone,
      currency,
      seatList,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      dispatch,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      addonsEvent,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      productAddonId,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      addonsBuyerTypes,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      addonBuyerTypeSelected,
      ...props
    } = this.props;
    const placeholderCode = intl.formatMessage(messages$1.placeholderCode);
    const buttonTextValidate = intl.formatMessage(messages$1.buttonTextValidate);
    const ticketMap = {};
    Object.entries(tickets).forEach(([key, value]) => {
      ticketMap[key] = value.n;
    });
    return salesGroupId && productId && (event || isOpenDateCalendar) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      PromotionSelector,
      {
        productId,
        salesGroupId,
        buyerTypes: buyerTypeMap,
        promotions: promotionList,
        seats: seatList,
        ticketMap,
        sellerIdSelected,
        productIsOpenDate: isOpenDateCalendar,
        event,
        placeholderCode,
        buttonTextValidate,
        buyerTypePromotions: promotionDataList && promotionDataList.length ? promotionDataList.length : void 0,
        showNotification: this.showPromotionCodeNotification,
        showError: this.showPromotionCodeError,
        showNotFound: this.showPromotionCodeNotFound,
        checkPromotionCode: this.checkPromotionCode,
        applyPromotions: this.applyPromotion,
        productInfo,
        productConfiguration,
        timeZone,
        currency,
        ...props
      }
    ) : null;
  }
}
const getAddonBuyerTypeMap = (buyerTypes2 = []) => buyerTypes2.reduce(
  (acc, buyerType) => ({
    ...acc,
    [buyerType.buyerTypeId]: buyerType
  }),
  {}
);
const mapStateToProps$k = (state, ownProps) => {
  const { cart: cart2, promotions: promotions2, products: products2, events: events2, pointOfSales } = state;
  const { addonsEvent, productAddonId, addonsBuyerTypes, addonBuyerTypeSelected } = ownProps;
  const { salesGroup, product, tickets, events: eventsCart, promotionDataList, sellerId, seatList } = cart2;
  const { clientList } = pointOfSales;
  const { promotionCode, promotionCodeValid } = promotions2;
  const { productInfoList, productConfigurations, productList } = products2;
  let ticketsMap = tickets;
  let { productId } = product;
  let promotionList = getPromotionListWithCodeIfApply(state);
  const buyerTypeMap = addonsEvent ? getAddonBuyerTypeMap(addonsBuyerTypes) : getBuyerTypeMap(state);
  const venuesMap = getVenueMap(state);
  const sellerIdSelected = sellerId ? Number(sellerId) : Number(sessionStorage.getItem("sellerId")) || null;
  if (sellerIdSelected) {
    promotionList = promotionList.filter(
      (promo) => promo.sellerIds && promo.sellerIds.includes(sellerIdSelected) || !promo.sellerIds
    );
  }
  let event;
  if (Array.isArray(eventsCart) && eventsCart.length > 0) {
    const [filteredEvent] = eventsCart.filter(
      (eventItem) => venuesMap[eventItem.venueId] && (!venuesMap[eventItem.venueId]?.mainVenueId || venuesMap[eventItem.venueId]?.mainVenueId)
    );
    event = filteredEvent;
  } else if (addonsEvent) {
    const addonsTicketsMap = {};
    if (addonBuyerTypeSelected) {
      addonBuyerTypeSelected.forEach((buyerType) => {
        addonsTicketsMap[buyerType.buyerTypeId] = {
          ...buyerType,
          n: buyerType.qty,
          price: 0
        };
      });
      ticketsMap = addonsTicketsMap;
    }
    event = addonsEvent;
    productId = productAddonId;
  } else {
    event = events2.eventList[events2.eventList.length - 1];
  }
  return {
    productId,
    isOpenDateCalendar: product.openDate && product.productVenueSet?.[0]?.validType === "calendar",
    salesGroupId: salesGroup.salesGroupId ? salesGroup.salesGroupId : productList[0].salesGroupId,
    event,
    tickets: ticketsMap,
    sellerIdSelected,
    promotionList,
    productConfiguration: getProductConfigurationMap(
      productConfigurations,
      "promotions"
    ),
    promotionCode,
    promotionCodeValid,
    promotionDataList,
    buyerTypeMap,
    productInfo: getProductInfoMap(productInfoList, "promotions"),
    timeZone: clientList[0].timeZone,
    currency: clientList[0].currencyList[0].isoCode,
    seatList
  };
};
const LinkedPromotionSelector$1 = connect(mapStateToProps$k)(injectIntl(LinkedPromotionSelector));
class PromotionsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPromos: false
    };
  }
  componentDidUpdate(prevProps) {
    const { tickets } = this.props;
    if (!_isEqual(tickets, prevProps.tickets)) {
      this.setState({
        showPromos: false
      });
    }
  }
  handleShowPromos = (showPromos) => {
    if (showPromos) viewSection("promotion");
    this.setState({
      showPromos
    });
  };
  render() {
    const { showPromos } = this.state;
    const {
      visiblePromos,
      showAddToCart,
      isSeller,
      addonsEvent,
      productAddonId,
      addonsBuyerTypes,
      addonBuyerTypeSelected
    } = this.props;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: showAddToCart && visiblePromos ? "" : "hidden", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cart-promos-text", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "clickable", onClick: () => this.handleShowPromos(!showPromos), children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-own-discount_label" }),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormattedHTMLMessage,
          {
            id: "title.text.promotions",
            defaultMessage: "Do you have a promotional code? Click <strong>here</strong> to apply it"
          }
        )
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "clearfix" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("section", { className: "section-promotion", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `main-panel ${showPromos ? "" : "hidden"}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        LinkedPromotionSelector$1,
        {
          isSeller,
          addonsEvent,
          productAddonId,
          addonsBuyerTypes,
          addonBuyerTypeSelected
        }
      ) }) })
    ] });
  }
}
function mapStateToProps$j(state, ownProps) {
  const cart2 = getCartWithStatus(state);
  const { tickets } = cart2;
  return {
    tickets,
    visiblePromos: ownProps.isAddons ? Boolean(getAddonPromoList(state)) : getVisibleComponentNameList(state).some((order) => order === "promotions")
  };
}
const PromotionsContainer$1 = connect(mapStateToProps$j)(PromotionsContainer);
function setAutoSelectEvent(value) {
  return {
    type: SET_AUTO_SELECT_EVENT,
    payload: value
  };
}
const messages = defineMessages({
  changeTooltip: {
    id: "tootip.edit",
    defaultMessage: "Cambiar"
  }
});
class FrontendMainPanel extends Component {
  sectionRef;
  constructor(props) {
    super(props);
    this.sectionRef = React__default.createRef();
  }
  componentDidMount() {
    const { activeStep, stepEcommerce, step, productInfo, cart: cart2, timeZone, productConfigurations } = this.props;
    const isCasaBatllo2 = () => window.pos && window.pos.name === "CasaBatllo";
    if ((isCasaBatllo2() || !isProviderEnabled("ga4")) && activeStep === 0 && stepEcommerce && step === activeStep && productInfo?.productId) {
      const dateCart = cart2.date || void 0;
      const hourCart = cart2.hour || void 0;
      viewSection({
        section: stepEcommerce,
        productInfo,
        timeZone,
        dateCart,
        hourCart
      });
    }
  }
  componentDidUpdate(prevProps) {
    const {
      visible = true,
      activeStep,
      step,
      stepEcommerce,
      productInfo,
      cart: cart2,
      timeZone,
      productConfigurations
    } = this.props;
    const isCasaBatllo2 = () => window.pos && window.pos.name === "CasaBatllo";
    const hasProduct = Boolean(productInfo?.productId);
    const stepJustBecameActive = Boolean(activeStep) && activeStep !== prevProps.activeStep;
    const productJustArrived = hasProduct && !prevProps.productInfo?.productId;
    if ((isCasaBatllo2() || !isProviderEnabled("ga4")) && step === activeStep && stepEcommerce && visible && hasProduct && (stepJustBecameActive || productJustArrived) && stepEcommerce !== "select-hour") {
      const dateCart = cart2.date || void 0;
      const hourCart = cart2.events?.[0]?.startDatetime && moment.tz(cart2.events[0].startDatetime, timeZone).format(TIME_FORMAT_24H) || void 0;
      viewSection({
        section: stepEcommerce,
        productInfo,
        timeZone,
        dateCart,
        hourCart
      });
    }
  }
  handleDisableAutoSelectEvent = () => {
    const { setAutoSelectEvent: handleSetAutoSelectevent } = this.props;
    handleSetAutoSelectevent(false);
  };
  handleScrollAfterExpand = () => {
    const { canCenter } = this.props;
    if (canCenter && isMobileDevice()) {
      scrollToStartAndFocus(this.sectionRef);
    }
  };
  handleOnClickEdit = () => {
    const { goToStep, step } = this.props;
    goToStep(step);
    this.handleDisableAutoSelectEvent();
  };
  render() {
    const {
      selected,
      icon,
      title,
      mainTitle,
      visible = true,
      totalSteps = 0,
      activeStep,
      goToStep,
      step,
      titleEditable,
      showNext = false,
      intl,
      renderRequired,
      className,
      stepEcommerce,
      children
    } = this.props;
    const display = visible ? "block" : "none";
    let active = "";
    let editable = "";
    if (step === activeStep) active = "active";
    if (activeStep > step && !active) editable = "editable";
    let configuredMsg = false;
    if (title?.props?.defaultMessage === void 0) configuredMsg = true;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("section", { style: { display }, className, ref: this.sectionRef, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `main-panel ${active} ${editable}`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "panel-color", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { role: "presentation", className: `${icon} icon-panel` }),
        " ",
        editable && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "arrow" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "panel-color-box", children: [
          mainTitle && !configuredMsg && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "span",
            {
              dangerouslySetInnerHTML: {
                __html: mainTitle
              }
            }
          ),
          editable && titleEditable || title,
          !!selected && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "selected", children: selected })
        ] }),
        editable && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            onClick: this.handleOnClickEdit,
            onKeyDown: (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                this.handleOnClickEdit();
              }
            },
            tabIndex: 0,
            className: "edit clickable border-round",
            title: intl.formatMessage(messages.changeTooltip),
            "aria-expanded": false,
            role: "button",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { role: "presentation", className: "icon-own-mode_edit", children: " " })
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Panel,
        {
          expanded: step === activeStep,
          onToggle: () => {
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(Panel.Collapse, { onEntered: this.handleScrollAfterExpand, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Panel.Body, { children: [
            step === activeStep || renderRequired ? children : null,
            totalSteps - 1 !== activeStep && showNext ? /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                type: "button",
                className: `btn btn-custom btn-custom-next ${stepEcommerce}`,
                onClick: () => goToStep(step + 1),
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Next", id: "button.next" })
              }
            ) : ""
          ] }) })
        }
      )
    ] }) });
  }
}
function mapStateToProps$i(state) {
  const { products: products2, cart: cart2, pointOfSales } = state;
  const { productList, productConfigurations } = products2;
  const { clientList } = pointOfSales;
  return {
    productInfo: productList[0],
    cart: cart2,
    timeZone: clientList[0].timeZone,
    shouldAutoSelectEvent: state.autoSelect?.shouldAutoSelectEvent,
    productConfigurations
  };
}
const mapDispatchToProps$g = {
  setAutoSelectEvent
};
const FrontendMainPanel$1 = connect(mapStateToProps$i, mapDispatchToProps$g)(injectIntl(FrontendMainPanel));
function KeepFormDataCheckbox({ checked, onChange, id: id2 }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-group form-custom form-custom-seller col-xs-12 col-sm-12 col-md-12", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-checkbox", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("input", { id: id2, type: "checkbox", checked, onChange }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "checkbox-inline", htmlFor: id2, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "button.keep.otherData", defaultMessage: "Mantener los datos del formulario" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", {})
    ] })
  ] }) });
}
const TicketForm = reduxForm({ form: "ticketForm" })(Forms);
let scrolledY$1 = false;
class TicketFormContainer extends Component {
  static isKeepingOtherData = () => sessionStorage.getItem("keepTicketOtherData") === "true";
  constructor(props) {
    super(props);
    this.state = {
      keepDataChecked: hasCallCenterRole() ? TicketFormContainer.isKeepingOtherData() : false
    };
    this.onToggleKeepTicket = this.onToggleKeepTicket.bind(this);
    this.updateAnswerList = this.updateAnswerList.bind(this);
  }
  componentDidMount() {
    const { ticketFormList, isValid: isValidProp, setAnswerList: setAnswerList2, answersMap } = this.props;
    if (isValidProp && answersMap) {
      this.updateAnswerList(setAnswerList2, answersMap, ticketFormList);
    }
  }
  componentDidUpdate(prevProps) {
    const { ticketFormList, isValid: isValidProp, setAnswerList: setAnswerList2, answersMap } = this.props;
    const { keepDataChecked } = this.state;
    if (ticketFormList && ticketFormList.length > 0) {
      const formElement = document.getElementsByClassName("form-section-list")[0];
      if (formElement) {
        const mainPanelServiceElement = formElement.closest(".main-panel");
        if (!scrolledY$1 && formElement && mainPanelServiceElement?.classList.contains("active")) {
          let scrollValue = 850;
          if (window.innerWidth >= 1200) {
            scrollValue = 775;
          } else if (window.innerWidth > 480) {
            scrollValue = 750;
          }
          window.scrollTo({ top: scrollValue, left: 0 });
          scrolledY$1 = true;
        }
      }
    }
    if (isValidProp && prevProps.answersMap !== answersMap) {
      this.updateAnswerList(setAnswerList2, answersMap, ticketFormList);
      if (keepDataChecked && answersMap) {
        try {
          sessionStorage.setItem("ticketFormOtherData", JSON.stringify(answersMap));
        } catch (e) {
          console.error(e);
        }
      }
    }
  }
  onToggleKeepTicket = () => {
    this.setState(
      (prevState) => ({ keepDataChecked: !prevState.keepDataChecked }),
      () => {
        const { keepDataChecked } = this.state;
        const newChecked = keepDataChecked;
        const { answersMap } = this.props;
        if (newChecked) {
          if (answersMap) {
            try {
              sessionStorage.setItem("ticketFormOtherData", JSON.stringify(answersMap));
            } catch (e) {
              console.error(e);
            }
          }
        } else {
          sessionStorage.removeItem("ticketFormOtherData");
        }
        try {
          sessionStorage.setItem("keepTicketOtherData", newChecked.toString());
        } catch (e) {
          console.error(e);
        }
      }
    );
  };
  updateAnswerList(setAnswerList2, answersMap, ticketFormList) {
    const { productFormList } = this.props;
    setAnswerList2(
      answersMap ? generateAnswerList(
        answersMap,
        ticketFormList
      ) : [],
      productFormList
    );
  }
  render() {
    const {
      step,
      ticketFormList,
      ownerList = [],
      activeStep,
      totalSteps,
      handleSelect,
      answersMap,
      productInfo,
      formName,
      withCheckoutStepper = false
    } = this.props;
    const { keepDataChecked } = this.state;
    let initialValues = {};
    if (hasCallCenterRole() && sessionStorage.getItem("keepTicketOtherData") === "true" && sessionStorage.getItem("ticketFormOtherData")) {
      initialValues = JSON.parse(sessionStorage.getItem("ticketFormOtherData"));
    }
    if (!ticketFormList || !ticketFormList.length) return null;
    const [primaryForm] = [...ticketFormList].sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0));
    const panelTitle = primaryForm?.titleDisplayName?.trim() ? primaryForm.titleDisplayName : /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "title.forms", defaultMessage: "Otros datos" });
    const content = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TicketForm,
        {
          ...{
            form: formName,
            formlist: ticketFormList,
            ownerList,
            answersMap,
            productInfo,
            initialValues
          }
        }
      ),
      hasCallCenterRole() && /* @__PURE__ */ jsxRuntimeExports.jsx(
        KeepFormDataCheckbox,
        {
          id: "keepTicketFormCheckbox",
          checked: keepDataChecked,
          onChange: this.onToggleKeepTicket
        }
      )
    ] });
    return withCheckoutStepper ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      FrontendMainPanel$1,
      {
        title: panelTitle,
        icon: "icon-own-icon_venues",
        showNext: true,
        activeStep,
        totalSteps,
        goToStep: handleSelect,
        step,
        visible: true,
        renderRequired: true,
        children: content
      },
      `main-panel-${step}`
    ) : content;
  }
}
function mapStateToProps$h(state, ownProps) {
  const { products: products2, cart: cart2 } = state;
  const { productFormList, productInfoList } = products2;
  const { tickets } = cart2;
  const formName = ownProps.formName || "ticketForm";
  const formList = ownProps.formList ? ownProps.formList : productFormList;
  const defaultOwnerList = Object.values(tickets).map((bt) => ({
    id: `${OWNER_KEY}-${bt.buyerTypeId}`,
    label: bt.name ?? "",
    qty: bt.n ?? 0
  }));
  const ownerList = ownProps.ownerList ?? defaultOwnerList;
  return {
    ownerList,
    // Only the forms that will paint something: a form whose fields are all
    // restricted to buyer types nobody picked would render an empty panel.
    ticketFormList: formList.filter(
      (form2) => ["Ticket", "TicketNominal"].includes(form2.type) && formHasVisibleFieldsForAnyOwner(form2, ownerList)
    ),
    productInfo: getProductInfoMap(
      productInfoList,
      "ticket_form"
    ),
    answersMap: getFormValues(formName)(state),
    isValid: isValid(formName)(state),
    productFormList: formList,
    formName
  };
}
const mapDispatchToProps$f = (dispatch) => ({
  setAnswerList: (answerList, productFormList) => {
    dispatch(
      setAnswerList(
        answerList,
        productFormList
      )
    );
  }
});
const TicketFormContainer$1 = connect(mapStateToProps$h, mapDispatchToProps$f)(TicketFormContainer);
const ReservationForm = reduxForm({ form: "reservationForm" })(Forms);
let scrolledY = false;
class ReservationFormContainer extends Component {
  static isKeepingOtherData = () => sessionStorage.getItem("keepReservationOtherData") === "true";
  constructor(props) {
    super(props);
    this.state = {
      keepDataChecked: hasCallCenterRole() ? ReservationFormContainer.isKeepingOtherData() : false
    };
    this.onToggleKeepReservation = this.onToggleKeepReservation.bind(this);
  }
  componentDidUpdate(prevProps) {
    const { reservationFormList, isValid: isValidProp, setAnswerList: setAnswerList2, answersMap, productFormList } = this.props;
    if (reservationFormList && reservationFormList.length > 0) {
      const formElement = document.getElementsByClassName("form-section-list")[0];
      const mainPanelServiceElement = formElement?.closest(".main-panel");
      if (!scrolledY && formElement && mainPanelServiceElement?.classList.contains("active")) {
        let scrollValue = 850;
        if (window.innerWidth >= 1200) {
          scrollValue = 775;
        } else if (window.innerWidth > 480) {
          scrollValue = 750;
        }
        window.scrollTo({ top: scrollValue, left: 0 });
        scrolledY = true;
      }
    }
    if (isValidProp && prevProps.answersMap !== answersMap) {
      setAnswerList2(
        answersMap ? generateAnswerList(
          answersMap,
          reservationFormList
        ) : [],
        productFormList
      );
    }
  }
  onToggleKeepReservation = () => {
    this.setState(
      (prevState) => ({ keepDataChecked: !prevState.keepDataChecked }),
      () => {
        const { keepDataChecked } = this.state;
        if (!keepDataChecked) {
          sessionStorage.removeItem("reservationFormOtherData");
        }
        sessionStorage.setItem("keepReservationOtherData", String(keepDataChecked));
      }
    );
  };
  render() {
    const {
      step,
      reservationFormList = [],
      ownerList = [],
      activeStep,
      totalSteps,
      handleSelect,
      genericFieldAnswerList,
      answersMap,
      productInfo,
      formName,
      withCheckoutStepper = false
    } = this.props;
    const { keepDataChecked } = this.state;
    let initialValuesParsed = getFormInitialValuesFromUrl(
      genericFieldAnswerList
    );
    if (hasCallCenterRole() && ReservationFormContainer.isKeepingOtherData() && sessionStorage.getItem("reservationFormOtherData")) {
      initialValuesParsed = JSON.parse(sessionStorage.getItem("reservationFormOtherData"));
    }
    if (!reservationFormList || !reservationFormList.length) return null;
    const [primaryForm] = [...reservationFormList].sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0));
    const panelTitle = primaryForm?.titleDisplayName?.trim() ? primaryForm.titleDisplayName : /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "title.forms", defaultMessage: "Otros datos" });
    const content = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ReservationForm,
        {
          ...{
            form: formName,
            key: `reservation-form-${step}`,
            formlist: reservationFormList,
            genericFieldAnswerList,
            initialValues: initialValuesParsed,
            ownerList,
            answersMap,
            productInfo,
            id: "reservation-form"
          }
        }
      ),
      hasCallCenterRole() && /* @__PURE__ */ jsxRuntimeExports.jsx(
        KeepFormDataCheckbox,
        {
          id: "keepReservationFormCheckbox",
          checked: keepDataChecked,
          onChange: this.onToggleKeepReservation
        }
      )
    ] });
    return withCheckoutStepper ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      FrontendMainPanel$1,
      {
        title: panelTitle,
        icon: "icon-own-icon_venues",
        showNext: false,
        activeStep,
        totalSteps,
        goToStep: handleSelect,
        step,
        visible: true,
        renderRequired: true,
        children: content
      },
      `main-panel-${step}`
    ) : content;
  }
}
function mapStateToProps$g(state, ownProps) {
  const { products: products2 } = state;
  const { productFormList, productInfoList } = products2;
  const formName = ownProps.formName || "reservationForm";
  const formList = ownProps.formList ? ownProps.formList : productFormList;
  return {
    reservationFormList: formList.filter(
      (form2) => "Reservation".includes(form2.type) && formHasFields(form2)
    ),
    productInfo: getProductInfoMap(
      productInfoList,
      "reservation_form"
    ),
    answersMap: getFormValues(formName)(state),
    isValid: isValid(formName)(state),
    productFormList: formList,
    formName
  };
}
const mapDispatchToProps$e = (dispatch) => ({
  setAnswerList: (answerList, productFormList) => {
    dispatch(
      setAnswerList(
        answerList,
        productFormList
      )
    );
  }
});
const ReservationFormContainer$1 = connect(mapStateToProps$g, mapDispatchToProps$e)(ReservationFormContainer);
function LoginForm({
  inputChange,
  handlerSubmitLogin,
  resetPassword,
  messages: messages2,
  hasResetPassword,
  externalResetPassword,
  allowAuthenticator,
  materialIcons,
  hidePassword = true,
  toggleHidePassword,
  module: module2
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { onSubmit: handlerSubmitLogin, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-group", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-group", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-group-addon", id: "username", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "glyphicon glyphicon-user", children: materialIcons && "person" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            className: "form-control",
            name: "user",
            maxLength: 100,
            id: "user",
            "aria-describedby": "username",
            required: true,
            onChange: inputChange
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "username", children: messages2.emailLabel })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-group", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-group", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-group-addon", id: "password", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "glyphicon glyphicon-asterisk", children: materialIcons && "lock" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            autoComplete: "off",
            maxLength: 100,
            type: hidePassword ? "password" : "text",
            className: "form-control",
            name: "password",
            id: "password",
            "aria-describedby": "password",
            required: true,
            onChange: inputChange
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "password", children: messages2.passwordLabel }),
        (module2 === "cgr" || module2 === "seller") && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-group-addon cgr-show-password", id: "password", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "span",
          {
            role: "button",
            className: `glyphicon glyphicon-eye-${hidePassword ? "open" : "close"}`,
            tabIndex: 0,
            onClick: toggleHidePassword,
            onKeyDown: (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                if (toggleHidePassword) toggleHidePassword();
              }
            },
            "aria-label": hidePassword ? "Show password" : "Hide password"
          }
        ) })
      ] }) }),
      allowAuthenticator && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-group", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-group", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-group-addon", id: "authenticator", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "glyphicon glyphicon-asterisk", children: materialIcons && "lock" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            autoComplete: "off",
            maxLength: 100,
            type: "password",
            className: "form-control",
            name: "authenticator",
            id: "authenticator",
            "aria-describedby": "authenticator",
            onChange: inputChange
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "authenticator", children: messages2.authenticatorLabel })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "submit", value: "Entrar", className: "btn btn-login", children: messages2.buttonLabel }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      hasResetPassword && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "btn btn-link", onClick: resetPassword, children: messages2.resetLabel })
    ] }),
    externalResetPassword && /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: externalResetPassword, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "btn btn-link", children: messages2.resetLabel }) })
  ] });
}
function ResetPassword({ inputChange, handlerResetPassword, messages: messages2, module: module2, materialIcons }) {
  const inputType = module2 && module2 === "cgr" ? "text" : "email";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { onSubmit: handlerResetPassword, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-group", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-group", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-group-addon", id: "username", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "glyphicon glyphicon-user", children: materialIcons && "lock" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: inputType,
          className: "form-control",
          name: "userEmail",
          maxLength: 100,
          id: "userEmail",
          "aria-describedby": "userEmail",
          required: true,
          onChange: (e) => inputChange(e)
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "username", children: messages2.emailLabel })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "submit", value: "Entrar", className: "btn btn-login", children: messages2.sendResetLabel })
  ] });
}
const validatePassword = (newPassword, repeatNewPassword, touched, messages2) => {
  const errors = {};
  const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^*\-.])([A-Za-z0-9#?!@$%^*\-.]{8,16})$/;
  if (touched.newPassword) {
    if (!newPassword || !passwordRegex.test(newPassword)) {
      errors.newPassword = true;
      errors.message = messages2.validationErrorFormat;
    }
  }
  if (touched.repeatNewPassword) {
    if (repeatNewPassword && newPassword !== repeatNewPassword) {
      errors.repeatNewPassword = true;
      errors.message = messages2.validationErrorMatch;
    }
  }
  return errors;
};
const validatePasswordSize = (password, min2, max2) => {
  let error = false;
  if (password && (password.length < min2 || password.length > max2)) error = true;
  return error;
};
class NewPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      touched: {
        newPassword: false,
        repeatNewPassword: false
      },
      showPassword: false,
      showRepeatedPassword: false
    };
  }
  componentDidMount() {
    const { hideText } = this.props;
    hideText();
  }
  handleBlur = (field) => () => {
    const { touched } = this.state;
    this.setState({
      touched: { ...touched, [field]: true }
    });
  };
  handleShowPassword = () => {
    const { showPassword } = this.state;
    this.setState({ showPassword: !showPassword });
  };
  handleShowRepeatedPassword = () => {
    const { showRepeatedPassword } = this.state;
    this.setState({ showRepeatedPassword: !showRepeatedPassword });
  };
  render() {
    const {
      inputChange,
      handlerChangePassword,
      newPassword,
      repeatNewPassword,
      success,
      messages: messages2,
      materialIcons,
      type
    } = this.props;
    const { touched, showPassword, showRepeatedPassword } = this.state;
    const errors = validatePassword(newPassword ?? "", repeatNewPassword ?? "", touched, messages2);
    const isEnabled = !Object.keys(errors).some((x) => errors[x]);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      errors && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-danger", children: errors.message }),
      !success ? /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { onSubmit: isEnabled ? handlerChangePassword : () => {
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `form-group ${errors.newPassword && touched.newPassword ? "has-error" : ""}`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-group", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-group-addon", id: "password", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "glyphicon glyphicon-asterisk", children: materialIcons && "lock" }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              autoComplete: "off",
              maxLength: 18,
              type: showPassword ? "text" : "password",
              className: `form-control ${errors.newPassword && touched.newPassword ? "has-error" : ""}`,
              name: "newPassword",
              id: "newPassword",
              onBlur: this.handleBlur("newPassword"),
              "aria-describedby": "newPassword",
              required: true,
              onChange: (e) => inputChange(e)
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "password", children: messages2.newPasswordLabel }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-group-addon", id: "password", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "span",
            {
              role: "button",
              tabIndex: 0,
              className: `glyphicon glyphicon-eye-${showPassword ? "open" : "close"}`,
              onClick: this.handleShowPassword,
              onKeyDown: this.handleShowPassword,
              "aria-label": showPassword ? "Hide password" : "Show password"
            }
          ) })
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `form-group ${errors.repeatNewPassword && touched.repeatNewPassword ? "has-error" : ""}`, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-group", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-group-addon", id: "password", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "glyphicon glyphicon-asterisk", children: materialIcons && "lock" }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "input",
              {
                autoComplete: "off",
                maxLength: 18,
                type: showRepeatedPassword ? "text" : "password",
                className: `form-control ${errors.repeatNewPassword && touched.repeatNewPassword ? "has-error" : ""}`,
                name: "repeatNewPassword",
                id: "repeatNewPassword",
                "aria-describedby": "repeatNewPassword",
                onBlur: this.handleBlur("repeatNewPassword"),
                required: true,
                onChange: (e) => inputChange(e)
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "password", children: messages2.repeatPasswordLabel }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "input-group-addon", id: "password", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "span",
              {
                role: "button",
                tabIndex: 0,
                className: `glyphicon glyphicon-eye-${showRepeatedPassword ? "open" : "close"}`,
                onClick: this.handleShowRepeatedPassword,
                onKeyDown: this.handleShowRepeatedPassword,
                "aria-label": showPassword ? "Hide repeated password" : "Show repeated password"
              }
            ) })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              type: "submit",
              className: isEnabled ? "btn btn-login" : "btn btn-login disabled",
              disabled: !isEnabled,
              value: "Entrar",
              children: messages2.changePasswordLabel
            }
          )
        ] })
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            className: "btn btn-login",
            href: `${window.location.protocol}//${window.location.hostname}${window.location.pathname}`,
            children: messages2.backLoginLabel
          }
        ),
        type === "newPassword" && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-welcome-bottom", children: messages2.registerFinished })
      ] })
    ] });
  }
}
function Overlay({ loading, showMessage, message, noClorian }) {
  const divStyle = {
    display: loading ? "block" : "none"
  };
  const getMessage = () => {
    if (showMessage && !message) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "text.loading", defaultMessage: "Se están procesando tus entradas...", tagName: "p" });
    }
    if (showMessage && message) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: message });
    }
    return null;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${noClorian === true ? "overlay-noClorian" : "overlay"}`, style: divStyle, children: getMessage() });
}
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resetPasswordPage: false,
      loading: false,
      errorInternal: "",
      success: "",
      hidePassword: true,
      newPassword: void 0,
      repeatNewPassword: void 0
    };
    this.handlerSubmitLogin = this.handlerSubmitLogin.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handlerChangePassword = this.handlerChangePassword.bind(this);
    this.handlerResetPassword = this.handlerResetPassword.bind(this);
    this.toggleResetPassword = this.toggleResetPassword.bind(this);
    this.getLoginElement = this.getLoginElement.bind(this);
    this.toggleHidePassword = this.toggleHidePassword.bind(this);
  }
  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }
  handlerSubmitLogin(e) {
    e.preventDefault();
    const { onSubmit, onValidateLogin, passwordValidation } = this.props;
    const { user: user2, password, authenticator } = this.state;
    const creds = {
      username: user2,
      password,
      authenticator
    };
    if (passwordValidation && passwordValidation.enabled) {
      const error = validatePasswordSize(
        password ?? "",
        passwordValidation.minPasswordLength,
        passwordValidation.maxPasswordLength
      );
      if (passwordValidation && error) onValidateLogin?.();
      else onSubmit(creds);
    } else onSubmit(creds);
  }
  handlerResetPassword(e) {
    e.preventDefault();
    const { handlerResetPassword, module: module2, userService } = this.props;
    const { userEmail } = this.state;
    this.setState({
      loading: true,
      success: "",
      errorInternal: ""
    });
    if (userEmail) {
      if (handlerResetPassword) {
        handlerResetPassword(userEmail);
      } else {
        const config = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Referer: window.location.hostname
          },
          body: JSON.stringify({
            username: userEmail,
            application: module2
          })
        };
        fetch(`${userService}/users/resetPasswordEmail`, config).then((response) => {
          if (response.ok) {
            this.setState({
              success: {
                message: this.props.textMessages && this.props.textMessages.notifications?.emailSent || "You will receive an email"
              }
            });
            return null;
          }
          return response.json();
        }).then((myJson) => {
          if (myJson && myJson.errorCode) {
            this.setState({
              errorInternal: { message: myJson.message || "System error" }
            });
          }
        }).finally(() => {
          this.setState({
            loading: false
          });
        });
      }
    }
  }
  handlerChangePassword(e) {
    e.preventDefault();
    const { newPassword } = this.state;
    const { userService } = this.props;
    this.setState({
      loading: true,
      success: "",
      errorInternal: ""
    });
    const query2 = queryString.parse(window.location.search);
    const { token: token2, type } = query2;
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        newPassword,
        token: token2
      })
    };
    fetch(`${userService}/users/resetPassword`, config).then((response) => {
      if (response.ok) {
        const notificationMessage = type === "resetPassword" ? this.props.textMessages && this.props.textMessages.notifications?.passwordChanged : this.props.textMessages && this.props.textMessages.notifications?.passwordCreated;
        this.setState({
          success: {
            message: notificationMessage || "Your password has been changed. "
          }
        });
        return null;
      }
      return response.json();
    }).then((myJson) => {
      if (myJson && myJson.errorCode) {
        this.setState({
          errorInternal: { message: myJson.message || "System error" }
        });
      }
    });
    this.setState({
      loading: false
    });
  }
  getLoginElement() {
    const {
      emailLabel = "Username",
      passwordLabel = "Password",
      authenticatorLabel = "Authenticator",
      buttonLabel = "Login",
      resetLabel = "Reset password",
      hasResetPassword = true,
      externalResetPassword,
      module: module2,
      textMessages,
      materialIcons,
      hideText
    } = this.props;
    const messages2 = {
      loginForm: {
        emailLabel,
        passwordLabel,
        authenticatorLabel,
        resetLabel,
        buttonLabel,
        ...textMessages?.loginForm ?? {}
      },
      resetPassword: {
        emailLabel,
        sendResetLabel: "Send",
        ...textMessages?.resetPassword ?? {}
      },
      newPassword: {
        newPasswordLabel: "New password",
        repeatPasswordLabel: "Repeat new password",
        changePasswordLabel: "Change Password",
        backLoginLabel: "Back to login",
        validationErrorFormat: "Length between 8 and 16,presence of at least one capital letter, one digit and one special character.",
        validationErrorMatch: "Passwords do not match",
        ...textMessages?.newPassword ?? {}
      }
    };
    const query2 = queryString.parse(window.location.search);
    const { token: token2, type } = query2;
    const allowAuthenticator = module2 && module2 === "cgr";
    const { resetPasswordPage, newPassword, repeatNewPassword, success, hidePassword } = this.state;
    if (!resetPasswordPage && !token2) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        LoginForm,
        {
          handlerSubmitLogin: this.handlerSubmitLogin,
          inputChange: this.handleInputChange,
          module: module2,
          hasResetPassword,
          resetPassword: this.toggleResetPassword,
          externalResetPassword,
          allowAuthenticator: !!allowAuthenticator,
          messages: messages2.loginForm,
          materialIcons,
          hidePassword,
          toggleHidePassword: this.toggleHidePassword
        }
      );
    }
    if (resetPasswordPage && !token2) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        ResetPassword,
        {
          inputChange: this.handleInputChange,
          handlerResetPassword: this.handlerResetPassword,
          messages: messages2.resetPassword,
          module: module2,
          materialIcons
        }
      );
    }
    if (token2 && type) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        NewPassword,
        {
          inputChange: this.handleInputChange,
          newPassword,
          repeatNewPassword,
          handlerChangePassword: this.handlerChangePassword,
          success,
          messages: type === "resetPassword" ? messages2.resetPassword : messages2.newPassword,
          materialIcons,
          hideText: hideText ?? (() => {
          }),
          type
        }
      );
    }
    return null;
  }
  toggleResetPassword() {
    const { resetPasswordPage } = this.state;
    this.setState({ resetPasswordPage: !resetPasswordPage });
  }
  toggleHidePassword() {
    const { hidePassword } = this.state;
    this.setState({ hidePassword: !hidePassword });
  }
  render() {
    const { logo, disabled, error, noClorian, passwordValidation } = this.props;
    const { success, loading, errorInternal } = this.state;
    const query2 = queryString.parse(window.location.search);
    const { type } = query2;
    const mappedError = error?.errorCode ? errorCodeMessageId(error.errorCode, error.message) : null;
    const elementToRender = this.getLoginElement();
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "root", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Overlay, { noClorian, loading: disabled || loading }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id: "login", className: "login-box ", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "header-login", children: logo && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: logo, alt: "logo Clorian" }) }),
        success && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: type === "newPassword" ? "text-welcome-top" : "text-success", children: success.message }),
        mappedError && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-danger", children: mappedError }),
        !mappedError && error && passwordValidation && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-danger", dangerouslySetInnerHTML: { __html: error.message } }),
        !mappedError && error && !passwordValidation && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-danger", children: error.message }),
        errorInternal && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-danger", children: errorInternal.message }),
        elementToRender
      ] })
    ] });
  }
}
const isScriptLoaded = (url) => {
  const scripts = Array.from(document.getElementsByTagName("script"));
  return scripts.some((script) => script.src === url);
};
function Reports({ dashboardUrl, height = "750px" }) {
  const scriptUrl = "https://metabase.clorian.com/app/iframeResizer.js";
  if (!isScriptLoaded(scriptUrl)) {
    const script = document.createElement("script");
    script.src = scriptUrl;
    script.async = false;
    document.body.appendChild(script);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("iframe", { title: "iframe metabase", src: dashboardUrl, width: "100%", height, frameBorder: 0 });
}
class TermsAndConditionsItem extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      acceptTerms: false,
      showModal: false
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.generateHtml = this.generateHtml.bind(this);
    this.handlerCheck = this.handlerCheck.bind(this);
  }
  handlerCheck(event) {
    const { termsAndConditionsId, handlerMethod } = this.props;
    const { acceptTerms } = this.state;
    if (event.type === "keydown") {
      const keyEvent = event;
      if (keyEvent.key !== "Enter" && keyEvent.key !== " ") {
        return;
      }
    }
    handlerMethod(!acceptTerms, termsAndConditionsId);
    this.setState({ acceptTerms: !acceptTerms });
  }
  generateHtml() {
    const { index: index2, externalLink, name, termsAndConditionsId, termRequired, isInvalid } = this.props;
    const { acceptTerms } = this.state;
    const termName = name || "";
    if (externalLink) {
      let html22 = name;
      html22 = html22.replace("<p>", "").replace("</p>", "");
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "span",
          {
            role: "checkbox",
            "aria-checked": acceptTerms,
            tabIndex: index2,
            onKeyDown: (e) => this.handlerCheck(e),
            "aria-labelledby": `termsLabel${termsAndConditionsId}`
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: html22 } }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: termRequired ? "*" : "" } })
      ] });
    }
    const hasAnchor = termName.indexOf("<a") !== -1 && termName.indexOf("</a") !== -1 && termName.indexOf('">') !== -1;
    if (hasAnchor) {
      const namePartOne = termName.substring(termName.indexOf(`<p>`) + 3, termName.indexOf("<a"));
      const namePartTwoLink = termName.substring(termName.indexOf('">') + 2, termName.indexOf("</a"));
      let namePartThree = termName.substring(termName.indexOf("/a>") + 3, termName.lastIndexOf("</p>"));
      if (termRequired) namePartThree += " *";
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "span",
          {
            role: "checkbox",
            className: `${isInvalid ? "error-terms-checkbox" : void 0}`,
            "aria-checked": acceptTerms,
            tabIndex: index2,
            onKeyDown: (e) => this.handlerCheck(e),
            "aria-labelledby": `termsLabel${termsAndConditionsId}`
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: namePartOne } }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "span",
          {
            role: "button",
            tabIndex: 0,
            className: "btn-link link",
            dangerouslySetInnerHTML: { __html: namePartTwoLink },
            onClick: this.openModal
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: namePartThree } })
      ] });
    }
    let html2 = termName;
    if (html2.startsWith("<p>") && html2.endsWith("</p>")) {
      html2 = html2.replace(/^<p>/, "").replace(/<\/p>$/, "");
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "span",
        {
          role: "checkbox",
          className: `${isInvalid ? "error-terms-checkbox" : void 0}`,
          "aria-checked": acceptTerms,
          tabIndex: index2,
          onKeyDown: (e) => this.handlerCheck(e),
          "aria-labelledby": `termsLabel${termsAndConditionsId}`
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: html2 } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: termRequired ? " *" : "" } })
    ] });
  }
  closeModal() {
    this.setState({ showModal: false });
  }
  openModal(e) {
    e.preventDefault();
    this.setState({ showModal: true });
  }
  render() {
    const { showModal, acceptTerms } = this.state;
    const { index: index2, termsAndConditionsId, disabled, name, termsContent } = this.props;
    const termHtml = this.generateHtml();
    const modalTitle = name.substring(name.indexOf('">') + 2, name.indexOf("</a")).replace(/^\w/, (c) => c.toUpperCase());
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "individualTerm", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-checkbox", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            id: `termsInput${termsAndConditionsId}`,
            type: "checkbox",
            name: `termsInput${termsAndConditionsId}`,
            disabled,
            checked: acceptTerms,
            onChange: (e) => {
              this.handlerCheck(e);
            }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "label",
          {
            className: "checkbox-inline",
            id: `termsLabel${termsAndConditionsId}`,
            htmlFor: `termsInput${termsAndConditionsId}`,
            children: termHtml
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CustomModal,
        {
          show: showModal,
          onClose: this.closeModal,
          onCancel: this.closeModal,
          dangerouslySetInnerHTMLTitle: true,
          dangerouslySetInnerHTMLBody: true,
          title: modalTitle,
          body: termsContent,
          showFooter: false
        }
      )
    ] }, index2);
  }
}
function TermsAndConditionsList({
  termsList,
  handlerMethod,
  disabled,
  clientId,
  hideRequired,
  invalidTerms,
  isExpressCheckout
}) {
  const oneRequiredTermAtLeast = termsList.some((term) => term.termRequired);
  const isInvalid = (term) => invalidTerms && invalidTerms.includes(term);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    termsList.sort((a, b) => a.displayOrder - b.displayOrder).map((term, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      TermsAndConditionsItem,
      {
        handlerMethod,
        index: index2,
        disabled,
        isInvalid: !!isInvalid(term),
        termsAndConditionsId: term.termsAndConditionsId,
        name: term.name,
        termRequired: term.termRequired,
        ...term
      },
      `terms-and-conditions-item-${term.termsAndConditionsId}-${clientId}`
    )),
    oneRequiredTermAtLeast && !hideRequired ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${isExpressCheckout ? " express-checkout-terms-required" : void 0}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "(*) Required", id: "error.termsAndConditions.required" }) }) : null
  ] });
}
class PayBoxForm extends Component {
  payform;
  constructor(props) {
    super(props);
    this.payform = React__default.createRef();
  }
  componentDidMount() {
    this.payform.current.submit();
  }
  render() {
    const {
      url,
      PBX_SITE,
      PBX_RANG,
      PBX_IDENTIFIANT,
      PBX_TOTAL,
      PBX_DEVISE,
      PBX_CMD,
      PBX_PORTEUR,
      PBX_RETOUR,
      PBX_RUF1,
      PBX_SOURCE,
      PBX_LANGUE,
      PBX_EFFECTUE,
      PBX_REFUSE,
      PBX_ANNULE,
      PBX_ATTENTE,
      PBX_REPONDRE_A,
      PBX_HASH,
      PBX_TIME,
      PBX_BILLING,
      PBX_SHOPPINGCART,
      PBX_HMAC
    } = this.props;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { method: "POST", action: url, ref: this.payform, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_SITE", value: PBX_SITE }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_RANG", value: PBX_RANG }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_IDENTIFIANT", value: PBX_IDENTIFIANT }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_TOTAL", value: PBX_TOTAL }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_DEVISE", value: PBX_DEVISE }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_CMD", value: PBX_CMD }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_PORTEUR", value: PBX_PORTEUR }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_RETOUR", value: PBX_RETOUR }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_RUF1", value: PBX_RUF1 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_SOURCE", value: PBX_SOURCE }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_LANGUE", value: PBX_LANGUE }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_EFFECTUE", value: PBX_EFFECTUE }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_REFUSE", value: PBX_REFUSE }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_ANNULE", value: PBX_ANNULE }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_ATTENTE", value: PBX_ATTENTE }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_REPONDRE_A", value: PBX_REPONDRE_A }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_BILLING", value: PBX_BILLING }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_SHOPPINGCART", value: PBX_SHOPPINGCART }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_HASH", value: PBX_HASH }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_TIME", value: PBX_TIME }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "PBX_HMAC", value: PBX_HMAC })
    ] });
  }
}
class RedsysForm extends Component {
  payform;
  constructor(props) {
    super(props);
    this.payform = React__default.createRef();
  }
  componentDidMount() {
    this.payform.current.submit();
  }
  render() {
    const { SubmitUrl, Ds_SignatureVersion, Ds_MerchantParameters, Ds_Signature } = this.props;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { action: SubmitUrl, method: "POST", ref: this.payform, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "Ds_SignatureVersion", value: Ds_SignatureVersion }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "Ds_MerchantParameters", value: Ds_MerchantParameters }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "Ds_Signature", value: Ds_Signature })
    ] });
  }
}
function postRedsysInit(reference, initialRequest, browserInfo) {
  const config = {
    method: "POST",
    body: JSON.stringify({
      initialRequest,
      ...browserInfo
    })
  };
  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL()}/payments/redsys/init/${reference}`,
      config,
      authenticated: true,
      types: [REDSYS_INIT_REQUEST, REDSYS_INIT_SUCCESS, REDSYS_INIT_FAILURE]
    }
  };
}
function postRedsysAuthentication(body) {
  const config = {
    method: "POST",
    body: JSON.stringify(body)
  };
  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL()}/payments/redsys/authentication`,
      config,
      authenticated: true,
      types: [
        REDSYS_AUTHENTICATION_REQUEST,
        REDSYS_AUTHENTICATION_SUCCESS,
        REDSYS_AUTHENTICATION_FAILURE
      ]
    }
  };
}
const REDSYS_SCRIPT = Object.freeze({
  PRODUCTION: "https://sis.redsys.es/sis/NC/redsysV3.js",
  TEST: "https://sis-t.redsys.es:25443/sis/NC/sandbox/redsysV3.js"
});
class RedsysInlinePayment extends Component {
  cardFormRef;
  threeDSIframeRef;
  threeDSFormRef;
  challengeIframeRef;
  challengeFormRef;
  methodTimeoutId;
  isInitCalled;
  messageHandlerRef;
  methodMessageHandlerRef;
  challengeMessageHandlerRef;
  static extractOrder = (merchantParams) => {
    try {
      const decoded = atob(merchantParams);
      const params = JSON.parse(decoded);
      return params.DS_MERCHANT_ORDER || "";
    } catch {
      return "";
    }
  };
  static getBrowserInfo = () => ({
    browserAcceptHeader: navigator.userAgent || "",
    browserUserAgent: navigator.userAgent || "",
    browserJavaEnable: navigator.javaEnabled() ? "true" : "false",
    browserJavaScriptEnabled: "true",
    browserLanguage: navigator.language || "",
    browserColorDepth: String(screen.colorDepth || ""),
    browserScreenHeight: String(screen.height || ""),
    browserScreenWidth: String(screen.width || ""),
    browserTZ: String((/* @__PURE__ */ new Date()).getTimezoneOffset() || ""),
    challengeWindowSize: "05"
  });
  static cleanupScript = () => {
    const script = document.getElementById("redsys-script");
    if (script) {
      script.onload = null;
      script.onerror = null;
    }
  };
  static getRedsysLanguageCode = (locale) => {
    const languageMap = {
      es: "1",
      en: "2",
      ca: "3",
      fr: "4",
      de: "5",
      nl: "6",
      it: "7",
      pt: "9",
      val: "10",
      gl: "12",
      eu: "13",
      ja: "392",
      zh: "156",
      ko: "410",
      ru: "643",
      mx: "1"
    };
    const lang = locale.split("-")[0].toLowerCase();
    return languageMap[lang] || "2";
  };
  constructor(props) {
    super(props);
    this.cardFormRef = React__default.createRef();
    this.threeDSIframeRef = React__default.createRef();
    this.threeDSFormRef = React__default.createRef();
    this.challengeIframeRef = React__default.createRef();
    this.challengeFormRef = React__default.createRef();
    this.state = {
      order: null,
      idOper: null,
      scriptLoaded: false,
      scriptError: null,
      hideCardForm: false
    };
    this.methodTimeoutId = null;
    this.isInitCalled = false;
    this.messageHandlerRef = null;
    this.methodMessageHandlerRef = null;
    this.challengeMessageHandlerRef = null;
  }
  componentDidMount() {
    this.loadRedsysScript();
  }
  componentDidUpdate(prevProps, prevState) {
    const { scriptLoaded, scriptError } = this.state;
    if (scriptLoaded && !prevState.scriptLoaded && this.cardFormRef.current && window.getInSiteFormJSON) {
      this.initializeForm();
    }
    if (scriptError && !prevState.scriptError) {
      const { onError } = this.props;
      if (onError) {
        onError(scriptError);
      }
    }
  }
  componentWillUnmount() {
    this.cleanupMessageListeners();
    this.cleanupTimeout();
    this.cleanup3DSElements();
    this.cleanupChallengeElements();
    RedsysInlinePayment.cleanupScript();
  }
  cleanupMessageListeners = () => {
    if (this.messageHandlerRef) {
      window.removeEventListener("message", this.messageHandlerRef);
      this.messageHandlerRef = null;
    }
    if (this.methodMessageHandlerRef) {
      window.removeEventListener("message", this.methodMessageHandlerRef);
      this.methodMessageHandlerRef = null;
    }
    if (this.challengeMessageHandlerRef) {
      window.removeEventListener("message", this.challengeMessageHandlerRef);
      this.challengeMessageHandlerRef = null;
    }
  };
  cleanupTimeout = () => {
    if (this.methodTimeoutId) {
      clearTimeout(this.methodTimeoutId);
      this.methodTimeoutId = null;
    }
  };
  cleanup3DSElements = () => {
    const iframe = this.threeDSIframeRef.current;
    if (iframe?.parentNode) {
      iframe.parentNode.removeChild(iframe);
    }
    const form2 = this.threeDSFormRef.current;
    if (form2?.parentNode) {
      form2.parentNode.removeChild(form2);
    }
  };
  cleanupChallengeElements = () => {
    const iframe = this.challengeIframeRef.current;
    if (iframe?.parentNode) {
      iframe.parentNode.removeChild(iframe);
    }
    const form2 = this.challengeFormRef.current;
    if (form2?.parentNode) {
      form2.parentNode.removeChild(form2);
    }
  };
  loadRedsysScript = () => {
    const { isProd } = this.props;
    const existingScript = document.getElementById("redsys-script");
    if (existingScript) {
      if (window.getInSiteFormJSON) {
        this.setState({ scriptLoaded: true });
      }
      return;
    }
    const script = document.createElement("script");
    script.id = "redsys-script";
    script.src = isProd ? REDSYS_SCRIPT.PRODUCTION : REDSYS_SCRIPT.TEST;
    script.async = true;
    script.onload = () => {
      this.setState({ scriptLoaded: true });
    };
    script.onerror = () => {
      this.setState({
        scriptError: "No se pudo cargar el script de Redsys. Por favor, recarga la página."
      });
    };
    document.body.appendChild(script);
  };
  initializeForm = () => {
    const { paymentData, locale } = this.props;
    if (!paymentData || !paymentData.paymentProperties) {
      const { onError } = this.props;
      if (onError) {
        onError("Missing payment data");
      }
      return;
    }
    this.messageHandlerRef = this.handleReceiveMessage;
    window.addEventListener("message", this.messageHandlerRef);
    const order = RedsysInlinePayment.extractOrder(paymentData.paymentProperties.Ds_MerchantParameters);
    if (!order) {
      return;
    }
    this.setState({ order });
    const cardFormEl = document.getElementById("card-form");
    let styleButton;
    if (cardFormEl) {
      const cs = getComputedStyle(cardFormEl);
      const bg = cs.getPropertyValue("--redsys-btn-bg").trim();
      const color = cs.getPropertyValue("--redsys-btn-color").trim();
      if (bg) {
        styleButton = `background-color: ${bg}; color: ${color || "white"}; border-color: ${bg};`;
      }
    }
    const config = {
      id: "card-form",
      fuc: paymentData.paymentProperties.fuc,
      terminal: paymentData.paymentProperties.terminal,
      order,
      estiloInsite: "twoRows",
      idioma: RedsysInlinePayment.getRedsysLanguageCode(locale),
      ...styleButton ? { styleButton } : {}
    };
    window.getInSiteFormJSON?.(config);
  };
  handleReceiveMessage = (event) => {
    window.storeIdOper?.(event, "token", "errorCode");
    const tokenElement = document.getElementById("token");
    const errorElement = document.getElementById("errorCode");
    if (errorElement?.value) {
      if (this.messageHandlerRef) {
        window.removeEventListener("message", this.messageHandlerRef);
        this.messageHandlerRef = null;
      }
      const { onError } = this.props;
      if (onError) {
        onError(errorElement.value);
      }
      return;
    }
    if (tokenElement?.value) {
      const idOper = tokenElement.value;
      if (this.messageHandlerRef) {
        window.removeEventListener("message", this.messageHandlerRef);
        this.messageHandlerRef = null;
      }
      this.setState({ idOper, hideCardForm: true }, () => {
        this.callRedsysInit(idOper);
      });
    }
  };
  callRedsysInit = async (operID) => {
    const { order } = this.state;
    const { paymentData, dispatch } = this.props;
    if (!order || !operID) {
      return;
    }
    if (this.isInitCalled) {
      return;
    }
    this.isInitCalled = true;
    const reference = paymentData?.reference || paymentData?.paymentProperties?.reference;
    try {
      if (!reference) {
        return;
      }
      dispatch(
        show(
          true,
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "payments.redsys.processing", defaultMessage: "Procesando pago..." })
        )
      );
      const browserInfo = RedsysInlinePayment.getBrowserInfo();
      const initialRequest = {
        operID,
        order
      };
      const res = await dispatch(
        postRedsysInit(reference, initialRequest, browserInfo)
      );
      const response = res?.response;
      if (!response) {
        throw new Error("Empty response from init");
      }
      switch (response.result) {
        case "OK":
          dispatch(hide());
          this.redirectToSuccess(reference);
          break;
        case "AUT":
          dispatch(hide());
          if (response?.threeDSMethodURL) {
            this.execute3DSMethod(response, browserInfo);
          } else if (response.acsURL && (response.creq || response.pAReq)) {
            this.handleChallenge(response);
          } else if (response.acsURL && response.pAReq) {
            this.callAuthentication("N", response, browserInfo);
          } else if (response.protocolVersion && response.protocolVersion.startsWith("2.")) {
            this.callAuthentication("N", response, browserInfo);
          } else {
            this.callAuthentication("N", response, browserInfo);
          }
          break;
        default:
          dispatch(hide());
          this.redirectToError(reference);
          break;
      }
    } catch (error) {
      const { onError } = this.props;
      const reference2 = paymentData?.reference || paymentData?.paymentProperties?.reference;
      this.redirectToError(reference2);
      if (onError) {
        onError(error.message || "Error on init");
      }
    }
  };
  execute3DSMethod = (initResponse, browserInfo) => {
    const { threeDSMethodURL, threeDSServerTransID, threeDSMethodNotificationURL } = initResponse;
    const { dispatch, paymentData } = this.props;
    const reference = paymentData?.reference || paymentData?.paymentProperties?.reference;
    dispatch(
      show(
        true,
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "payments.redsys.verifying3DS", defaultMessage: "Verificando seguridad..." })
      )
    );
    const iframe = document.createElement("iframe");
    iframe.name = "threeDSMethodIframe";
    iframe.style.display = "none";
    this.threeDSIframeRef.current = iframe;
    document.body.appendChild(iframe);
    const form2 = document.createElement("form");
    form2.method = "POST";
    form2.action = threeDSMethodURL || "";
    form2.target = "threeDSMethodIframe";
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "threeDSMethodData";
    input.value = btoa(JSON.stringify({ threeDSMethodNotificationURL, threeDSServerTransID }));
    form2.appendChild(input);
    this.threeDSFormRef.current = form2;
    document.body.appendChild(form2);
    form2.submit();
    this.methodTimeoutId = setTimeout(() => {
      this.cleanup3DSElements();
      this.cleanupTimeout();
      this.callAuthentication("N", initResponse, browserInfo);
    }, 1e4);
    this.methodMessageHandlerRef = (event) => {
      if (event.data?.result === "OK") {
        this.cleanupTimeout();
        this.cleanup3DSElements();
        if (this.methodMessageHandlerRef) {
          window.removeEventListener("message", this.methodMessageHandlerRef);
          this.methodMessageHandlerRef = null;
        }
        this.callAuthentication("Y", initResponse, browserInfo);
      } else if (event.data?.result === "KO") {
        if (this.methodMessageHandlerRef) {
          window.removeEventListener("message", this.methodMessageHandlerRef);
          this.methodMessageHandlerRef = null;
        }
        this.redirectToError(reference);
      }
    };
    window.addEventListener("message", this.methodMessageHandlerRef);
  };
  callAuthentication = async (threeDSCompInd, initResponse, browserInfo) => {
    const { order, idOper } = this.state;
    const { paymentData, dispatch } = this.props;
    try {
      const reference = paymentData?.reference || paymentData?.paymentProperties?.reference;
      const authBody = {
        operID: idOper,
        order,
        threeDSCompInd,
        reference,
        threeDSInfo: "AuthenticationData",
        protocolVersion: initResponse?.protocolVersion || "2.1.0",
        threeDSServerTransID: initResponse?.threeDSServerTransID,
        threeDSMethodURL: initResponse?.threeDSMethodURL,
        threeDSRequestorAuthenticationInd: "01",
        ...browserInfo
      };
      dispatch(
        show(
          true,
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            FormattedMessage,
            {
              id: "payments.redsys.verifyingAuthentication",
              defaultMessage: "Verificando autenticación..."
            }
          )
        )
      );
      const res = await dispatch(postRedsysAuthentication(authBody));
      const { response } = res;
      if (response?.acsURL) {
        dispatch(hide());
        this.handleChallenge(response);
      } else {
        dispatch(hide());
        this.handleAuthenticationResult(response, reference);
      }
    } catch (error) {
      dispatch(hide());
      const { onError } = this.props;
      const reference = paymentData?.reference || paymentData?.paymentProperties?.reference;
      this.redirectToError(reference);
      if (onError) {
        onError(error.message || "Error in authentication");
      }
    }
  };
  handleChallenge = (authResponse) => {
    const { paymentData } = this.props;
    const reference = paymentData?.reference || paymentData?.paymentProperties?.reference;
    const is3DS2 = authResponse.protocolVersion && authResponse.protocolVersion.startsWith("2.");
    const iframe = document.createElement("iframe");
    iframe.name = "challengeIframe";
    iframe.style.width = "100%";
    iframe.style.height = "700px";
    iframe.style.border = "none";
    iframe.setAttribute("sandbox", "allow-forms allow-scripts allow-same-origin allow-top-navigation");
    this.challengeIframeRef.current = iframe;
    const container = document.getElementById("challenge-container") || this.cardFormRef.current;
    if (container) {
      container.appendChild(iframe);
    }
    const form2 = document.createElement("form");
    form2.method = "POST";
    form2.action = authResponse.acsURL || "";
    form2.target = "challengeIframe";
    if (is3DS2 && authResponse.creq) {
      const creqInput = document.createElement("input");
      creqInput.type = "hidden";
      creqInput.name = "creq";
      creqInput.value = authResponse.creq;
      form2.appendChild(creqInput);
    } else if (authResponse.pAReq) {
      if (!authResponse.md || !authResponse.termUrl) {
        this.redirectToError(reference);
      }
      const paReqInput = document.createElement("input");
      paReqInput.type = "hidden";
      paReqInput.name = "PaReq";
      paReqInput.value = authResponse.pAReq;
      form2.appendChild(paReqInput);
      const mdInput = document.createElement("input");
      mdInput.type = "hidden";
      mdInput.name = "MD";
      mdInput.value = authResponse.md || "";
      form2.appendChild(mdInput);
      const termUrlInput = document.createElement("input");
      termUrlInput.type = "hidden";
      termUrlInput.name = "TermUrl";
      termUrlInput.value = authResponse.termUrl || "";
      form2.appendChild(termUrlInput);
    }
    this.challengeFormRef.current = form2;
    document.body.appendChild(form2);
    form2.submit();
    this.challengeMessageHandlerRef = (event) => {
      const { data: data2 } = event;
      if (!data2 || typeof data2 !== "object" || !data2.result) {
        return;
      }
      this.cleanupChallengeElements();
      if (this.challengeMessageHandlerRef) {
        window.removeEventListener("message", this.challengeMessageHandlerRef);
        this.challengeMessageHandlerRef = null;
      }
      if (data2.result === "OK") {
        this.redirectToSuccess(reference);
      } else {
        this.redirectToError(reference);
      }
    };
    window.addEventListener("message", this.challengeMessageHandlerRef);
  };
  redirectToSuccess = (reference) => {
    if (!reference) return;
    const { locale, salesGroupId, paymentData } = this.props;
    window.location.href = `/${locale}/payment/success/${reference}/${paymentData.paymentProperties?.webCookie}/${salesGroupId}`;
  };
  redirectToError = (reference) => {
    if (!reference) return;
    const { locale, salesGroupId, paymentData } = this.props;
    window.location.href = `/${locale}/payment/error/${reference}/${paymentData.paymentProperties?.webCookie}/${salesGroupId}`;
  };
  handleAuthenticationResult = (response, reference) => {
    const { onSuccess } = this.props;
    if (response.result === "OK") {
      this.redirectToSuccess(reference);
    } else {
      this.redirectToError(reference);
    }
    if (onSuccess) {
      onSuccess(response);
    }
  };
  render() {
    const { hideCardForm } = this.state;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", id: "token" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", id: "errorCode" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          id: "card-form",
          className: "express-checkout-redsys-inline",
          ref: this.cardFormRef,
          style: { display: hideCardForm ? "none" : "block" }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "challenge-container" })
    ] });
  }
}
const RedsysInlinePayment_default = connect()(RedsysInlinePayment);
const YUNO_SDK_SRC = "https://sdk-web.y.uno/v1.10/main.js";
let sdkLoadPromise = null;
const loadYunoSdk = () => {
  if (typeof window === "undefined") return Promise.reject(new Error("window unavailable"));
  if (window.Yuno) return Promise.resolve(window.Yuno);
  if (sdkLoadPromise) return sdkLoadPromise;
  sdkLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = YUNO_SDK_SRC;
    script.async = true;
    script.onload = () => {
      if (window.Yuno) {
        resolve(window.Yuno);
      } else {
        sdkLoadPromise = null;
        reject(new Error("Yuno SDK missing on window after load"));
      }
    };
    script.onerror = () => {
      sdkLoadPromise = null;
      reject(new Error("Failed to load Yuno SDK"));
    };
    document.head.appendChild(script);
  });
  return sdkLoadPromise;
};
const EXTERNAL_BUTTON_TYPES = /* @__PURE__ */ new Set(["GOOGLE_PAY", "APPLE_PAY", "PAYPAL"]);
const isExternalButtonType = (type) => EXTERNAL_BUTTON_TYPES.has(type);
function YunoCheckoutLite({
  publicKey,
  checkoutId,
  paymentMethodType,
  countryCode,
  language = "es",
  externalButtonSelector,
  vaultedToken,
  onTokenReceived,
  onError,
  onPaymentResult,
  renderLoading,
  renderError,
  className
}) {
  const [errorMsg, setErrorMsg] = useState(null);
  const [isReady, setIsReady] = useState(false);
  const instanceRef = useRef(null);
  const initialisedRef = useRef(false);
  const containerRef = useRef(null);
  const mountElRef = useRef(null);
  const callbacksRef = useRef({ onTokenReceived, onError, onPaymentResult });
  useEffect(() => {
    callbacksRef.current.onTokenReceived = onTokenReceived;
    callbacksRef.current.onError = onError;
    callbacksRef.current.onPaymentResult = onPaymentResult;
  });
  useEffect(() => {
    if (!checkoutId || !publicKey || !paymentMethodType) return void 0;
    if (initialisedRef.current) return void 0;
    let cancelled = false;
    let phase = "setup";
    const reportError = (err) => {
      if (cancelled) return;
      setErrorMsg(err.message || "Yuno error");
      callbacksRef.current.onError?.(err, phase);
    };
    if (!containerRef.current) {
      reportError(new Error("Yuno mount container not available"));
      return void 0;
    }
    const baseId = `yuno-${paymentMethodType.toLowerCase()}-${Date.now()}`;
    const wrapperEl = document.createElement("div");
    mountElRef.current = wrapperEl;
    const cardEl = document.createElement("div");
    cardEl.id = `${baseId}-card`;
    const apmEl = document.createElement("div");
    apmEl.id = `${baseId}-apm`;
    const actionEl = document.createElement("div");
    actionEl.id = `${baseId}-action`;
    wrapperEl.append(cardEl, apmEl, actionEl);
    containerRef.current.appendChild(wrapperEl);
    const dynamicSelector = `#${cardEl.id}`;
    const apmSelector = `#${apmEl.id}`;
    const actionSelector = `#${actionEl.id}`;
    (async () => {
      try {
        const Yuno = await loadYunoSdk();
        if (cancelled) return;
        const yuno = await Yuno.initialize(publicKey);
        if (cancelled) return;
        instanceRef.current = yuno;
        const isExternal = isExternalButtonType(paymentMethodType);
        await yuno.startCheckout({
          checkoutSession: checkoutId,
          elementSelector: dynamicSelector,
          countryCode,
          language,
          showLoading: false,
          renderMode: { type: "element", elementSelector: { apmForm: apmSelector, actionForm: actionSelector } },
          showPayButton: paymentMethodType.toUpperCase() === "CARD",
          async yunoCreatePayment(oneTimeToken, tokenWithInformation) {
            try {
              await callbacksRef.current.onTokenReceived?.(oneTimeToken, tokenWithInformation);
              await yuno.continuePayment({ showPaymentStatus: false });
            } catch (cbErr) {
              const err = cbErr instanceof Error ? cbErr : new Error(String(cbErr));
              reportError(err);
              await yuno.notifyError();
              return;
            }
          },
          yunoPaymentResult: (status, subStatus) => {
            yuno.hideLoader().catch(() => void 0);
            callbacksRef.current.onPaymentResult?.(status, subStatus);
          },
          yunoError: (err) => {
            yuno.hideLoader().catch(() => void 0);
            const wrapped = err instanceof Error ? err : new Error(err?.message || "Yuno SDK error");
            reportError(wrapped);
          },
          yunoPaymentMethodSelected: () => void 0
        });
        if (cancelled) return;
        if (isExternal) {
          const buttonSelector = externalButtonSelector || dynamicSelector;
          try {
            await yuno.mountExternalButtons([
              {
                paymentMethodType,
                elementSelector: buttonSelector
              }
            ]);
          } catch (err) {
            const wrapped = err instanceof Error ? err : new Error(String(err));
            reportError(wrapped);
            return;
          }
        } else {
          await yuno.mountCheckoutLite({
            paymentMethodType,
            ...vaultedToken ? { vaultedToken } : {}
          });
        }
        if (cancelled) return;
        if (!isExternal) {
          await yuno.startPayment();
        }
        if (cancelled) return;
        initialisedRef.current = true;
        phase = "runtime";
        setIsReady(true);
      } catch (err) {
        reportError(err instanceof Error ? err : new Error(String(err)));
      }
    })();
    return () => {
      cancelled = true;
      const yuno = instanceRef.current;
      instanceRef.current = null;
      initialisedRef.current = false;
      if (isExternalButtonType(paymentMethodType)) {
        yuno?.unmountExternalButton(paymentMethodType).catch(() => void 0);
      } else {
        yuno?.unmountSdk?.().catch(() => void 0);
      }
      if (mountElRef.current && mountElRef.current.parentNode) {
        mountElRef.current.parentNode.removeChild(mountElRef.current);
      }
      mountElRef.current = null;
    };
  }, [checkoutId, publicKey, paymentMethodType, countryCode, language, externalButtonSelector, vaultedToken]);
  if (errorMsg) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: renderError ? renderError(errorMsg) : null });
  }
  const wrapperClassName = className ? `yuno-checkout-wrapper ${className}` : "yuno-checkout-wrapper";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    !isReady && renderLoading ? renderLoading() : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: containerRef, className: wrapperClassName })
  ] });
}
const WALLET_VARIANTS = /* @__PURE__ */ new Set(["googlepay", "applepay"]);
const createElement = (core, variant, options) => {
  switch (variant) {
    case "dropin":
      return new Dropin(core, options);
    case "card":
      return new Card(core, options);
    case "googlepay":
      return new GooglePay(core, options);
    case "applepay":
      return new ApplePay(core, options);
    case "redirect":
      return new Redirect(core, options);
    case "klarna":
      return new Klarna(core, options);
    default: {
      const unreachable = variant;
      throw new Error(`Unsupported Adyen variant: ${String(unreachable)}`);
    }
  }
};
const buildSignature = (variant, configuration, reinitKey) => [
  variant,
  configuration.clientKey,
  configuration.locale,
  configuration.countryCode,
  configuration.environment,
  configuration.amount?.value,
  configuration.amount?.currency,
  reinitKey
].join("|");
function AdyenPaymentElement({
  configuration,
  variant,
  variantOptions,
  reinitKey,
  id: id2,
  className,
  onReady,
  onUnavailable,
  onInitError,
  renderLoading
}) {
  const [mountedSignature, setMountedSignature] = useState(null);
  const containerRef = useRef(null);
  const elementRef = useRef(null);
  const latestRef = useRef({ onReady, onUnavailable, onInitError, variantOptions });
  useEffect(() => {
    latestRef.current = { onReady, onUnavailable, onInitError, variantOptions };
  });
  const signature = configuration && buildSignature(variant, configuration, reinitKey);
  const isMounted = signature !== null && mountedSignature === signature;
  useEffect(() => {
    if (!configuration || !signature) return void 0;
    const container = containerRef.current;
    if (!container) {
      latestRef.current.onInitError?.(new Error("Adyen mount container not available"));
      return void 0;
    }
    let cancelled = false;
    (async () => {
      try {
        const core = await AdyenCheckout(configuration);
        if (cancelled) return;
        const element = createElement(core, variant, latestRef.current.variantOptions);
        if (WALLET_VARIANTS.has(variant)) {
          try {
            await element.isAvailable();
          } catch (availabilityError) {
            if (cancelled) return;
            latestRef.current.onUnavailable?.(availabilityError);
            return;
          }
          if (cancelled) return;
        }
        element.mount(container);
        elementRef.current = element;
        setMountedSignature(signature);
        latestRef.current.onReady?.(element);
      } catch (initError) {
        if (cancelled) return;
        if (WALLET_VARIANTS.has(variant)) {
          latestRef.current.onUnavailable?.(initError);
        }
        latestRef.current.onInitError(initError);
      }
    })();
    return () => {
      cancelled = true;
      const element = elementRef.current;
      elementRef.current = null;
      try {
        element?.unmount();
      } catch {
      }
      container.replaceChildren();
    };
  }, [signature]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    !isMounted && renderLoading ? renderLoading() : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: containerRef, id: id2, className })
  ] });
}
const describeAmount = (amount) => {
  if (!amount || typeof amount !== "object") return "amount (missing)";
  const { value, currency } = amount;
  if (typeof value !== "number" || Number.isNaN(value)) {
    return `amount.value (must be a number, got ${Number.isNaN(value) ? "NaN" : typeof value})`;
  }
  if (value <= 0) return `amount.value (must be greater than 0, got ${value})`;
  if (typeof currency !== "string" || !currency.length) return "amount.currency (missing)";
  return null;
};
const describeEnvironment = (clientKey, environment) => {
  if (!clientKey || !environment) return null;
  const prefix2 = clientKey.substring(0, 4);
  if (prefix2 === "test" && environment !== "test") {
    return `environment ("${environment}" with a test clientKey)`;
  }
  if (prefix2 === "live" && !environment.startsWith("live")) {
    return `environment ("${environment}" with a live clientKey)`;
  }
  return null;
};
const validateAdyenCheckoutInputs = ({
  clientKey,
  countryCode,
  amount,
  environment
}) => [
  !clientKey && "clientKey (missing)",
  !countryCode && "countryCode (required by v6, even though the SDK types it optional)",
  // Adyen wants an ISO two-character code. It does not check the shape itself, so a
  // country name — which some order records hold instead of a code — would reach its
  // API and fail there rather than here.
  countryCode && !/^[A-Za-z]{2}$/.test(countryCode) && `countryCode ("${countryCode}" is not an ISO 2-letter code)`,
  describeAmount(amount),
  describeEnvironment(clientKey, environment)
].filter((problem) => Boolean(problem));
function getAdyenPaymentMethods(body) {
  const config = {
    method: "POST",
    body: JSON.stringify(body)
  };
  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL()}/payments/adyen/paymentMethods`,
      config,
      authenticated: true,
      types: [ADYEN_REQUEST, ADYEN_SUCCESS, ADYEN_FAILURE]
    }
  };
}
function postAdyenPayment(body) {
  const config = {
    method: "POST",
    body: JSON.stringify(body)
  };
  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL()}/payments/adyen/payment`,
      config,
      authenticated: true,
      types: [ADYEN_PAYMENT_REQUEST, ADYEN_PAYMENT_SUCCESS, ADYEN_PAYMENT_FAILURE]
    }
  };
}
function postAdyenPaymentDetails(body) {
  const config = {
    method: "POST",
    body: JSON.stringify(body)
  };
  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL()}/payments/adyen/paymentDetails`,
      config,
      authenticated: true,
      types: [
        ADYEN_PAYMENT_DETAILS_REQUEST,
        ADYEN_PAYMENT_DETAILS_SUCCESS,
        ADYEN_PAYMENT_DETAILS_FAILURE
      ]
    }
  };
}
var md5$1 = { exports: {} };
var crypt = { exports: {} };
var hasRequiredCrypt;
function requireCrypt() {
  if (hasRequiredCrypt) return crypt.exports;
  hasRequiredCrypt = 1;
  (function() {
    var base64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", crypt$1 = {
      // Bit-wise rotation left
      rotl: function(n, b) {
        return n << b | n >>> 32 - b;
      },
      // Bit-wise rotation right
      rotr: function(n, b) {
        return n << 32 - b | n >>> b;
      },
      // Swap big-endian to little-endian and vice versa
      endian: function(n) {
        if (n.constructor == Number) {
          return crypt$1.rotl(n, 8) & 16711935 | crypt$1.rotl(n, 24) & 4278255360;
        }
        for (var i = 0; i < n.length; i++)
          n[i] = crypt$1.endian(n[i]);
        return n;
      },
      // Generate an array of any length of random bytes
      randomBytes: function(n) {
        for (var bytes = []; n > 0; n--)
          bytes.push(Math.floor(Math.random() * 256));
        return bytes;
      },
      // Convert a byte array to big-endian 32-bit words
      bytesToWords: function(bytes) {
        for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
          words[b >>> 5] |= bytes[i] << 24 - b % 32;
        return words;
      },
      // Convert big-endian 32-bit words to a byte array
      wordsToBytes: function(words) {
        for (var bytes = [], b = 0; b < words.length * 32; b += 8)
          bytes.push(words[b >>> 5] >>> 24 - b % 32 & 255);
        return bytes;
      },
      // Convert a byte array to a hex string
      bytesToHex: function(bytes) {
        for (var hex = [], i = 0; i < bytes.length; i++) {
          hex.push((bytes[i] >>> 4).toString(16));
          hex.push((bytes[i] & 15).toString(16));
        }
        return hex.join("");
      },
      // Convert a hex string to a byte array
      hexToBytes: function(hex) {
        for (var bytes = [], c = 0; c < hex.length; c += 2)
          bytes.push(parseInt(hex.substr(c, 2), 16));
        return bytes;
      },
      // Convert a byte array to a base-64 string
      bytesToBase64: function(bytes) {
        for (var base64 = [], i = 0; i < bytes.length; i += 3) {
          var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
          for (var j = 0; j < 4; j++)
            if (i * 8 + j * 6 <= bytes.length * 8)
              base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 63));
            else
              base64.push("=");
        }
        return base64.join("");
      },
      // Convert a base-64 string to a byte array
      base64ToBytes: function(base64) {
        base64 = base64.replace(/[^A-Z0-9+\/]/ig, "");
        for (var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4) {
          if (imod4 == 0) continue;
          bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
        }
        return bytes;
      }
    };
    crypt.exports = crypt$1;
  })();
  return crypt.exports;
}
var charenc_1;
var hasRequiredCharenc;
function requireCharenc() {
  if (hasRequiredCharenc) return charenc_1;
  hasRequiredCharenc = 1;
  var charenc = {
    // UTF-8 encoding
    utf8: {
      // Convert a string to a byte array
      stringToBytes: function(str) {
        return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
      },
      // Convert a byte array to a string
      bytesToString: function(bytes) {
        return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
      }
    },
    // Binary encoding
    bin: {
      // Convert a string to a byte array
      stringToBytes: function(str) {
        for (var bytes = [], i = 0; i < str.length; i++)
          bytes.push(str.charCodeAt(i) & 255);
        return bytes;
      },
      // Convert a byte array to a string
      bytesToString: function(bytes) {
        for (var str = [], i = 0; i < bytes.length; i++)
          str.push(String.fromCharCode(bytes[i]));
        return str.join("");
      }
    }
  };
  charenc_1 = charenc;
  return charenc_1;
}
var isBuffer_1;
var hasRequiredIsBuffer;
function requireIsBuffer() {
  if (hasRequiredIsBuffer) return isBuffer_1;
  hasRequiredIsBuffer = 1;
  isBuffer_1 = function(obj) {
    return obj != null && (isBuffer2(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
  };
  function isBuffer2(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
  }
  function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer2(obj.slice(0, 0));
  }
  return isBuffer_1;
}
var hasRequiredMd5;
function requireMd5() {
  if (hasRequiredMd5) return md5$1.exports;
  hasRequiredMd5 = 1;
  (function() {
    var crypt2 = requireCrypt(), utf8 = requireCharenc().utf8, isBuffer2 = requireIsBuffer(), bin = requireCharenc().bin, md52 = function(message, options) {
      if (message.constructor == String)
        if (options && options.encoding === "binary")
          message = bin.stringToBytes(message);
        else
          message = utf8.stringToBytes(message);
      else if (isBuffer2(message))
        message = Array.prototype.slice.call(message, 0);
      else if (!Array.isArray(message) && message.constructor !== Uint8Array)
        message = message.toString();
      var m = crypt2.bytesToWords(message), l = message.length * 8, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
      for (var i = 0; i < m.length; i++) {
        m[i] = (m[i] << 8 | m[i] >>> 24) & 16711935 | (m[i] << 24 | m[i] >>> 8) & 4278255360;
      }
      m[l >>> 5] |= 128 << l % 32;
      m[(l + 64 >>> 9 << 4) + 14] = l;
      var FF = md52._ff, GG = md52._gg, HH = md52._hh, II = md52._ii;
      for (var i = 0; i < m.length; i += 16) {
        var aa = a, bb = b, cc = c, dd = d;
        a = FF(a, b, c, d, m[i + 0], 7, -680876936);
        d = FF(d, a, b, c, m[i + 1], 12, -389564586);
        c = FF(c, d, a, b, m[i + 2], 17, 606105819);
        b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
        a = FF(a, b, c, d, m[i + 4], 7, -176418897);
        d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
        c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
        b = FF(b, c, d, a, m[i + 7], 22, -45705983);
        a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
        d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
        c = FF(c, d, a, b, m[i + 10], 17, -42063);
        b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
        a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
        d = FF(d, a, b, c, m[i + 13], 12, -40341101);
        c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
        b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
        a = GG(a, b, c, d, m[i + 1], 5, -165796510);
        d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
        c = GG(c, d, a, b, m[i + 11], 14, 643717713);
        b = GG(b, c, d, a, m[i + 0], 20, -373897302);
        a = GG(a, b, c, d, m[i + 5], 5, -701558691);
        d = GG(d, a, b, c, m[i + 10], 9, 38016083);
        c = GG(c, d, a, b, m[i + 15], 14, -660478335);
        b = GG(b, c, d, a, m[i + 4], 20, -405537848);
        a = GG(a, b, c, d, m[i + 9], 5, 568446438);
        d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
        c = GG(c, d, a, b, m[i + 3], 14, -187363961);
        b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
        a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
        d = GG(d, a, b, c, m[i + 2], 9, -51403784);
        c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
        b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
        a = HH(a, b, c, d, m[i + 5], 4, -378558);
        d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
        c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
        b = HH(b, c, d, a, m[i + 14], 23, -35309556);
        a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
        d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
        c = HH(c, d, a, b, m[i + 7], 16, -155497632);
        b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
        a = HH(a, b, c, d, m[i + 13], 4, 681279174);
        d = HH(d, a, b, c, m[i + 0], 11, -358537222);
        c = HH(c, d, a, b, m[i + 3], 16, -722521979);
        b = HH(b, c, d, a, m[i + 6], 23, 76029189);
        a = HH(a, b, c, d, m[i + 9], 4, -640364487);
        d = HH(d, a, b, c, m[i + 12], 11, -421815835);
        c = HH(c, d, a, b, m[i + 15], 16, 530742520);
        b = HH(b, c, d, a, m[i + 2], 23, -995338651);
        a = II(a, b, c, d, m[i + 0], 6, -198630844);
        d = II(d, a, b, c, m[i + 7], 10, 1126891415);
        c = II(c, d, a, b, m[i + 14], 15, -1416354905);
        b = II(b, c, d, a, m[i + 5], 21, -57434055);
        a = II(a, b, c, d, m[i + 12], 6, 1700485571);
        d = II(d, a, b, c, m[i + 3], 10, -1894986606);
        c = II(c, d, a, b, m[i + 10], 15, -1051523);
        b = II(b, c, d, a, m[i + 1], 21, -2054922799);
        a = II(a, b, c, d, m[i + 8], 6, 1873313359);
        d = II(d, a, b, c, m[i + 15], 10, -30611744);
        c = II(c, d, a, b, m[i + 6], 15, -1560198380);
        b = II(b, c, d, a, m[i + 13], 21, 1309151649);
        a = II(a, b, c, d, m[i + 4], 6, -145523070);
        d = II(d, a, b, c, m[i + 11], 10, -1120210379);
        c = II(c, d, a, b, m[i + 2], 15, 718787259);
        b = II(b, c, d, a, m[i + 9], 21, -343485551);
        a = a + aa >>> 0;
        b = b + bb >>> 0;
        c = c + cc >>> 0;
        d = d + dd >>> 0;
      }
      return crypt2.endian([a, b, c, d]);
    };
    md52._ff = function(a, b, c, d, x, s, t) {
      var n = a + (b & c | ~b & d) + (x >>> 0) + t;
      return (n << s | n >>> 32 - s) + b;
    };
    md52._gg = function(a, b, c, d, x, s, t) {
      var n = a + (b & d | c & ~d) + (x >>> 0) + t;
      return (n << s | n >>> 32 - s) + b;
    };
    md52._hh = function(a, b, c, d, x, s, t) {
      var n = a + (b ^ c ^ d) + (x >>> 0) + t;
      return (n << s | n >>> 32 - s) + b;
    };
    md52._ii = function(a, b, c, d, x, s, t) {
      var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
      return (n << s | n >>> 32 - s) + b;
    };
    md52._blocksize = 16;
    md52._digestsize = 16;
    md5$1.exports = function(message, options) {
      if (message === void 0 || message === null)
        throw new Error("Illegal argument " + message);
      var digestbytes = crypt2.wordsToBytes(md52(message, options));
      return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt2.bytesToHex(digestbytes);
    };
  })();
  return md5$1.exports;
}
var md5Exports = requireMd5();
const md5 = /* @__PURE__ */ getDefaultExportFromCjs(md5Exports);
function base64ToBytes(base64) {
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
}
function bytesToBase64(bytes) {
  return btoa(String.fromCharCode(...new Uint8Array(bytes)));
}
async function encryptWebCookie(key, plaintext, initVector) {
  const md5Hex = await md5(key);
  const aesKeyHex = md5Hex.substring(0, 16);
  const aesKeyBytes = new TextEncoder().encode(aesKeyHex);
  const ivBytes = new TextEncoder().encode(initVector);
  const cryptoKey = await crypto.subtle.importKey("raw", aesKeyBytes, { name: "AES-CBC" }, false, ["encrypt"]);
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv: ivBytes },
    cryptoKey,
    new TextEncoder().encode(plaintext)
  );
  return bytesToBase64(new Uint8Array(encrypted));
}
async function decryptClientKey(encryptedBase64, key, initVector) {
  const md5Hex = await md5(key);
  const aesKeyHex = md5Hex.substring(0, 16);
  const aesKeyBytes = new TextEncoder().encode(aesKeyHex);
  const ivBytes = new TextEncoder().encode(initVector);
  const cryptoKey = await crypto.subtle.importKey("raw", aesKeyBytes, { name: "AES-CBC" }, false, ["decrypt"]);
  const encryptedBytes = base64ToBytes(encryptedBase64);
  const decrypted = await crypto.subtle.decrypt(
    { name: "AES-CBC", iv: ivBytes },
    cryptoKey,
    encryptedBytes.buffer
  );
  return new TextDecoder().decode(decrypted);
}
const ADYEN_ID_KEY = "adyen_id";
const PAYMENT_DATA_KEY = "paymentData";
const INIT_VECTOR = "9526309321898757";
const ensureAdyenIdempotencyKey = () => {
  const existing = localStorage.getItem(ADYEN_ID_KEY);
  if (existing) return existing;
  const created = crypto.randomUUID();
  localStorage.setItem(ADYEN_ID_KEY, created);
  return created;
};
const clearAdyenPaymentStorage = () => {
  localStorage.removeItem(ADYEN_ID_KEY);
  localStorage.removeItem(PAYMENT_DATA_KEY);
};
const responseCache = /* @__PURE__ */ new Map();
const inflight = /* @__PURE__ */ new Map();
const cacheKey = ({ clientId, salesGroupId, amount, countryCode, shopperLocale }) => [clientId, salesGroupId, amount.value, amount.currency, countryCode, shopperLocale, ADYEN_CHANNEL.WEB].join("|");
const resetAdyenPaymentMethodsCache = () => {
  responseCache.clear();
  inflight.clear();
};
const fetchAdyenPaymentMethods = (dispatch, query2) => {
  const key = cacheKey(query2);
  const cached = responseCache.get(key);
  if (cached) return Promise.resolve(cached);
  const pending = inflight.get(key);
  if (pending) return pending;
  const { clientId, salesGroupId, amount, countryCode, shopperLocale } = query2;
  const promise = dispatch(
    getAdyenPaymentMethods({
      paymentMethodsRequest: { amount, channel: ADYEN_CHANNEL.WEB, shopperLocale, countryCode },
      clientId,
      salesGroupId
    })
  ).then((result) => {
    const response = result?.response;
    if (response) responseCache.set(key, response);
    return response;
  }).finally(() => {
    inflight.delete(key);
  });
  inflight.set(key, promise);
  return promise;
};
const toAllowedPaymentMethods = (externalId) => {
  if (!externalId) return void 0;
  const allowed = externalId.split(",").map((value) => value.trim()).filter(Boolean);
  return allowed.length ? allowed : void 0;
};
const withoutIncompleteDeliveryAddress = (data2) => {
  const { deliveryAddress } = data2;
  const payload = { ...data2 };
  if (!deliveryAddress) return payload;
  const isComplete = deliveryAddress.street && deliveryAddress.city && deliveryAddress.postalCode && deliveryAddress.country;
  if (isComplete) return payload;
  delete payload.deliveryAddress;
  return payload;
};
const toOutcome = (resultCode) => {
  switch (resultCode) {
    case "Authorised":
      return "success";
    case "Pending":
    case "Received":
      return "pending";
    default:
      return "error";
  }
};
const readResultCode = (data2) => data2?.resultCode;
const releaseFailedElement = (element) => {
  if (!element || element instanceof Dropin) return;
  element.setStatus("ready");
};
const submitAdyenPaymentDetails = ({
  dispatch,
  clientId,
  reference,
  salesGroupId,
  details,
  threeDSAuthenticationOnly = true
}) => dispatch(
  postAdyenPaymentDetails({
    clientId,
    reference,
    salesGroupId,
    paymentDetailsRequest: {
      details,
      paymentData: localStorage.getItem(PAYMENT_DATA_KEY),
      threeDSAuthenticationOnly
    }
  })
);
const runAdyenSubmit = async (ctx, state, actions2) => {
  if (ctx.canSubmit && !ctx.canSubmit()) {
    actions2.reject();
    return;
  }
  try {
    const result = await ctx.dispatch(
      postAdyenPayment({
        paymentsRequest: {
          ...withoutIncompleteDeliveryAddress(state.data),
          reference: ctx.reference,
          amount: ctx.amount,
          ...ctx.metadata ? { metadata: ctx.metadata } : {},
          clientId: ctx.clientId,
          channel: ADYEN_CHANNEL.WEB,
          returnUrl: ctx.returnUrl
        },
        idempotency: ensureAdyenIdempotencyKey()
      })
    );
    const response = result?.response;
    if (!response) {
      ctx.onResult("error");
      actions2.reject();
      return;
    }
    if (response.action?.paymentData) {
      localStorage.setItem(PAYMENT_DATA_KEY, response.action.paymentData);
    }
    ctx.onPaymentSubmitted?.();
    actions2.resolve(response);
  } catch (submitError) {
    ctx.onError?.(submitError);
    ctx.onResult("error");
    actions2.reject();
  }
};
const runAdyenAdditionalDetails = async (ctx, state, actions2) => {
  try {
    const result = await submitAdyenPaymentDetails({
      dispatch: ctx.dispatch,
      clientId: ctx.clientId,
      reference: ctx.reference,
      salesGroupId: ctx.salesGroupId,
      details: state.data.details
    });
    const response = result?.response;
    if (!response) {
      ctx.onResult("error");
      actions2.reject();
      return;
    }
    actions2.resolve(response);
  } catch (detailsError) {
    ctx.onError?.(detailsError);
    ctx.onResult("error");
    actions2.reject();
  }
};
const useAdyenAdvancedFlow = ({
  dispatch,
  adyenDetails,
  clientId,
  salesGroupId,
  reference,
  amount,
  locale,
  countryCode,
  environment,
  returnUrl,
  metadata,
  onResult,
  onPaymentSubmitted,
  onError,
  onSetupError,
  canSubmit,
  enabled = true
}) => {
  const [settled, setSettled] = useState(null);
  const latestRef = useRef({
    dispatch,
    clientId,
    salesGroupId,
    reference,
    amount,
    returnUrl,
    metadata,
    onResult,
    onPaymentSubmitted,
    onError,
    canSubmit
  });
  useEffect(() => {
    latestRef.current = {
      dispatch,
      clientId,
      salesGroupId,
      reference,
      amount,
      returnUrl,
      metadata,
      onResult,
      onPaymentSubmitted,
      onError,
      canSubmit
    };
  });
  const handleSubmit3 = (state, _component, actions2) => runAdyenSubmit(latestRef.current, state, actions2);
  const handleAdditionalDetails = (state, _component, actions2) => runAdyenAdditionalDetails(latestRef.current, state, actions2);
  const handleFinalState = (data2, element) => {
    const resultCode = readResultCode(data2);
    const outcome = toOutcome(resultCode);
    if (outcome === "error") releaseFailedElement(element);
    latestRef.current.onResult(outcome, resultCode);
  };
  const handleError = (checkoutError) => {
    if (checkoutError?.name === "CANCEL") return;
    latestRef.current.onError?.(checkoutError);
    latestRef.current.onResult("error");
  };
  const clientKey = adyenDetails?.clientKey;
  const amountValue = amount?.value;
  const amountCurrency = amount?.currency;
  const problems = validateAdyenCheckoutInputs({ clientKey, countryCode, amount, environment });
  const isReady = enabled && problems.length === 0;
  const signature = isReady ? [
    clientKey,
    adyenDetails?.clientId,
    adyenDetails?.merchantAccount,
    adyenDetails?.externalId,
    clientId,
    salesGroupId,
    amountValue,
    amountCurrency,
    locale,
    countryCode,
    environment
  ].join("|") : null;
  const configuration = settled && settled.signature === signature ? settled.configuration : null;
  const isLoading = signature !== null && settled?.signature !== signature;
  useEffect(() => {
    if (!signature || !amount || !clientKey) return void 0;
    let cancelled = false;
    (async () => {
      try {
        const composedKey = `CLORIAN_${adyenDetails?.clientId}_${adyenDetails?.merchantAccount}`;
        const decryptedClientKey = await decryptClientKey(clientKey, composedKey, INIT_VECTOR);
        if (cancelled) return;
        if (!decryptedClientKey?.trim()) {
          throw new Error("Adyen client key could not be decrypted");
        }
        const paymentMethodsResponse = await fetchAdyenPaymentMethods(latestRef.current.dispatch, {
          clientId,
          salesGroupId,
          amount,
          countryCode,
          shopperLocale: locale
        });
        if (cancelled) return;
        if (!paymentMethodsResponse) {
          throw new Error("Adyen payment methods unavailable");
        }
        ensureAdyenIdempotencyKey();
        const built = {
          paymentMethodsResponse,
          allowPaymentMethods: toAllowedPaymentMethods(adyenDetails?.externalId),
          clientKey: decryptedClientKey,
          locale,
          countryCode,
          environment,
          amount,
          onSubmit: handleSubmit3,
          onAdditionalDetails: handleAdditionalDetails,
          onPaymentCompleted: handleFinalState,
          onPaymentFailed: handleFinalState,
          onError: handleError,
          analytics: { enabled: false }
        };
        setSettled({ signature, configuration: built });
      } catch (setupError) {
        if (cancelled) return;
        setSettled({ signature, configuration: null });
        onSetupError?.(setupError);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [signature]);
  return { configuration, isLoading, problems };
};
function MainContainerLayout({ children }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "container", children });
}
function Step({ step, isLastStep, history }) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      history.push(step.linkValue);
    }
  };
  return !isLastStep ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    "span",
    {
      onClick: () => history.push(step.linkValue),
      onKeyDown: handleKeyDown,
      tabIndex: 0,
      role: "link",
      className: "breadcrumb-step clickable",
      children: step.name
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "breadcrumb-step active", children: step.name });
}
function BreadCrumbs({ steps, history }) {
  const stepsToShow = [];
  if (!steps || steps.length === 0) {
    stepsToShow.push(/* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "active", children: "Inicio" }));
  } else {
    steps.forEach((step, index2, stepList) => {
      const isLastStep = index2 === stepList.length - 1;
      stepsToShow.push(/* @__PURE__ */ jsxRuntimeExports.jsx(Step, { step, isLastStep, history }, `breadcrumb-step-${index2}`));
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "container", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-12", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "breadcrumb-container", children: stepsToShow }) }) }) });
}
const initialState$c = {
  isFetching: false,
  isAuthenticated: !!sessionStorage.getItem("id_token")
};
function auth(state = initialState$c, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return { ...state, isFetching: true, isAuthenticated: false, user: action.creds };
    case LOGIN_SUCCESS:
      return { ...state, isFetching: false, isAuthenticated: true, user: action.user, errorMessage: "" };
    case LOGIN_FAILURE:
      return { ...state, isFetching: false, isAuthenticated: false, errorMessage: action.message };
    case LOGOUT_SUCCESS:
      return { ...state, isFetching: true, isAuthenticated: false };
    default:
      return state;
  }
}
const initialState$b = {
  authenticated: false,
  isFetching: false,
  isSubProductFetching: false,
  isServicesFetching: false,
  isProductInfoFetching: false,
  isFormsFetching: false,
  productList: [],
  specialEvents: [],
  specialEventsPerEvent: {},
  timeSlots: [],
  productInfoList: [],
  productConfigurations: [],
  productFormList: [],
  venueList: [],
  venueCapacityList: [],
  serviceList: [],
  recommendation: {},
  promotionSelected: {},
  isAnalyticsConfigFetching: false,
  productAnalyticsConfig: null,
  parentProduct: {},
  specialEventsByProductId: {}
};
function products(state = initialState$b, action) {
  switch (action.type) {
    case PRODUCT_REQUEST:
    case PARENT_PRODUCT_REQUEST:
      return { ...state, isParentFetching: true };
    case PRODUCT_LIST_REQUEST:
      return { ...state, isFetching: true };
    case PRODUCT_LIST_SUCCESS: {
      let specialEvents = [];
      const specialEventsByProductId = {};
      action.response.forEach((product) => {
        if (product.eventList) {
          specialEvents = [...specialEvents, ...product.eventList];
          specialEventsByProductId[product.productId] = product.eventList;
        }
      });
      return {
        ...state,
        isFetching: false,
        productList: action.response,
        specialEvents,
        specialEventsByProductId,
        authenticated: !!action.authenticated
      };
    }
    case PARENT_PRODUCT_SUCCESS:
      return {
        ...state,
        isParentFetching: false,
        parentProduct: action.response,
        authenticated: !!action.authenticated
      };
    case SUB_PRODUCT_LIST_REQUEST:
      return { ...state, isSubProductFetching: true };
    case SUB_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        isSubProductFetching: false,
        subProductList: action.response,
        authenticated: !!action.authenticated
      };
    case PRODUCT_SUCCESS: {
      let venueList = [];
      let venueCapacityList = [];
      const product = action.response;
      if (product) {
        if (product.productVenueSet) {
          product.productVenueSet.forEach(({ venue, ...rest }) => {
            venueList = [
              ...venueList,
              {
                ...venue,
                ...rest
              }
            ];
            venueCapacityList = [
              ...venueCapacityList,
              ...venue.venueCapacityList.map((vc) => ({
                ...vc,
                venueId: venue.venueId
              }))
            ];
          });
        }
      }
      return {
        ...state,
        isFetching: false,
        productList: !product ? [] : [product],
        parentProduct: {},
        venueList,
        venueCapacityList,
        authenticated: !!action.authenticated
      };
    }
    case SUB_PRODUCT_LIST_FAILURE:
      return { ...state, isSubProductFetching: true };
    case PARENT_PRODUCT_FAILURE:
      return { ...state, isParentFetching: true };
    case PRODUCT_LIST_FAILURE:
    case PRODUCT_FAILURE:
      return { ...state, isFetching: false, isSubProductFetching: false };
    case PRODUCT_SERVICES_REQUEST:
      return { ...state, isServicesFetching: true };
    case PRODUCT_SERVICES_SUCCESS:
      return {
        ...state,
        isServicesFetching: false,
        serviceList: action.response,
        authenticated: !!action.authenticated
      };
    case PRODUCT_SERVICES_FAILURE:
      return { ...state, isServicesFetching: false };
    case PRODUCT_INFO_REQUEST:
      return { ...state, isProductInfoFetching: true };
    case PRODUCT_INFO_SUCCESS:
      return {
        ...state,
        isProductInfoFetching: false,
        productInfoList: action.response,
        authenticated: !!action.authenticated
      };
    case PRODUCT_INFO_FAILURE:
      return { ...state, isProductInfoFetching: false };
    case PRODUCT_FORMS_REQUEST:
      return { ...state, isFormsFetching: true };
    case PRODUCT_FORMS_SUCCESS:
      return {
        ...state,
        isFormsFetching: false,
        productFormList: action.response,
        authenticated: !!action.authenticated
      };
    case PRODUCT_FORMS_FAILURE:
      return { ...state, isFormsFetching: false };
    case PRODUCT_CATEGORIES_REQUEST:
      return { ...state, isFetching: true };
    case PRODUCT_CATEGORIES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        productCategories: action.response,
        authenticated: !!action.authenticated
      };
    case PRODUCT_CATEGORIES_FAILURE:
      return { ...state, isFetching: false };
    case PRODUCT_CONFIGURATIONS_REQUEST:
      return { ...state, isProductConfigFetching: true };
    case PRODUCT_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        isProductConfigFetching: false,
        productConfigurations: action.response,
        authenticated: !!action.authenticated
      };
    case PRODUCT_CONFIGURATIONS_FAILURE:
      return { ...state, isProductConfigFetching: false };
    case PRODUCT_RECOMMENDATION_REQUEST:
      return { ...state, isFetchingRecommendation: true };
    case PRODUCT_RECOMMENDATION_SUCCESS:
      return {
        ...state,
        isFetchingRecommendation: false,
        recommendation: action.response,
        authenticated: !!action.authenticated
      };
    case PRODUCT_RECOMMENDATION_FAILURE:
      return {
        ...state,
        isFetchingRecommendation: false,
        error: action.error
      };
    case TIME_SLOTS_REQUEST:
      return { ...state, isFetching: true };
    case TIME_SLOTS_SUCCESS:
      return { ...state, isFetching: false, timeSlots: action.response };
    case TIME_SLOTS_FAILURE:
      return { ...state, isFetching: false };
    case PRODUCT_RECOMMENDATION_CLEAN:
      return { ...state, recommendation: {} };
    case SET_SPECIAL_PRODUCTS_FILTERS:
      return { ...state, filters: action.payload };
    case ADDONS_REQUEST:
      return { ...state, isAddonsFetching: true };
    case ADDONS_SUCCESS:
      return {
        ...state,
        isAddonsFetching: false,
        addons: {
          ...state.addons,
          list: action.response
        }
      };
    case ADDONS_FAILURE:
      return {
        ...state,
        isAddonsFetching: false,
        addons: {
          ...state.addons,
          error: true
        }
      };
    case SET_PROMOTION_SELECTED:
      return { ...state, promotionSelected: action.payload };
    case CLEAN_PROMOTION_SELECTED:
      return { ...state, promotionSelected: {} };
    case PRODUCT_ANALYTICS_CONFIG_REQUEST:
      return { ...state, isAnalyticsConfigFetching: true };
    case PRODUCT_ANALYTICS_CONFIG_SUCCESS:
      sessionStorage.setItem("productAnalyticsConfig", JSON.stringify(action.response));
      return {
        ...state,
        isAnalyticsConfigFetching: false,
        productAnalyticsConfig: action.response
      };
    case PRODUCT_ANALYTICS_CONFIG_FAILURE:
      return { ...state, isAnalyticsConfigFetching: false };
    default:
      return state;
  }
}
const initialState$a = {
  isFetching: false,
  buyerTypeList: [],
  buyerTypeInfoList: [],
  authenticated: false
};
function buyerTypes(state = initialState$a, action) {
  switch (action.type) {
    case BUYER_TYPES_REQUEST:
      return { ...state, isFetching: true };
    case BUYER_TYPES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        buyerTypeList: action.response,
        authenticated: !!action.authenticated
      };
    case BUYER_TYPES_FAILURE:
      return { ...state, isFetching: false };
    case BUYER_TYPES_CLEAN:
      return { ...state, isFetching: false, buyerTypeList: [] };
    case BUYER_TYPES_INFO_REQUEST:
      return { ...state, isFetching: true };
    case BUYER_TYPES_INFO_SUCCESS:
      return {
        ...state,
        isFetching: false,
        buyerTypeInfoList: action.response,
        authenticated: !!action.authenticated
      };
    case BUYER_TYPES_INFO_FAILURE:
      return { ...state, isFetching: false };
    default:
      return state;
  }
}
var start_of_dayExports = requireStart_of_day();
const startOfDay = /* @__PURE__ */ getDefaultExportFromCjs(start_of_dayExports);
const initialState$9 = {
  salesGroup: {},
  product: {},
  date: moment().startOf("day").toDate(),
  events: [],
  tickets: {},
  membershipForms: {},
  total: 0,
  subtotalServices: 0,
  ticketsQuantity: 0,
  services: {},
  seatList: [],
  askForRecommendation: true,
  answers: [],
  promotionDataList: {},
  code: null,
  sellerId: null,
  customerId: null,
  externalCustomerId: null
};
function cart(state = initialState$9, action) {
  const {
    salesGroup = {},
    product = {},
    date = moment().startOf("day").toDate(),
    membershipForms = {},
    buyerType = {},
    recaptcha
  } = action;
  let {
    events: events2 = [],
    seatList = [],
    seatIdList = [],
    answers = []
  } = action;
  answers = answers instanceof Array ? answers : [answers];
  seatIdList = seatIdList instanceof Array ? seatIdList : [seatIdList];
  seatList = seatList instanceof Array ? seatList : [seatList];
  events2 = events2 instanceof Array ? events2 : [events2];
  switch (action.type) {
    case CART_CLEAN:
      return initialState$9;
    case CART_UPDATE:
      return { ...state, ...action.cart };
    case CART_UPDATE_SALES_GROUP:
      return { ...state, salesGroup };
    case CART_UPDATE_DISTRIBUTOR_REFERENCE:
      return { ...state, distributorReference: action.distributorReference };
    case CART_UPDATE_RESERVATION_OBSERVATION:
      return { ...state, reservationObservationText: action.reservationObservationText };
    case CART_UPDATE_TICKET_GROUPING_TYPE:
      return { ...state, ticketGroupType: action.ticketGroupType };
    case CART_UPDATE_TYPE_OF_CUSTOMER:
      return { ...state, typeOfCustomer: action.typeOfCustomer };
    case CART_UPDATE_PRODUCT:
      return { ...state, product };
    case CART_UPDATE_DATE: {
      const newDate = moment.tz(date, action.timeZone).format(DATETIME_FORMAT_YMDHM);
      return { ...state, date: date && startOfDay(newDate) };
    }
    case CART_UPDATE_HOUR: {
      const hour = moment.tz(action.hour, action.timeZone).format(TIME_FORMAT_24H);
      return { ...state, hour };
    }
    case CART_ADD_MEMBERS:
      return { ...state, membershipForms };
    case CART_UPDATE_EVENTS:
      return { ...state, events: events2 };
    case CART_ADD_EVENT:
      return { ...state, events: [action.event] };
    case CART_UPDATE_BT: {
      const { tickets, ticketsQuantity, total } = action;
      return { ...state, tickets, total, ticketsQuantity };
    }
    case CART_UPDATE_PROMOTIONS: {
      const { promotionDataList } = action;
      let code = null;
      if (promotionDataList && Object.entries(promotionDataList).length > 0) {
        Object.values(promotionDataList).forEach((promotionData) => {
          if (promotionData && promotionData.promotionCode) {
            code = promotionData.promotionCode;
          }
        });
      }
      return { ...state, promotionDataList, code };
    }
    case CART_UPDATE_SERVICES: {
      const { services } = action;
      let subtotal = 0;
      Object.values({ ...state.services, ...services }).forEach((value) => {
        subtotal += value.totalPrice ?? value.price * (value.quantity > 0 ? value.quantity : 0);
      });
      return {
        ...state,
        services: {
          ...state.services,
          ...services
        },
        subtotalServices: subtotal
      };
    }
    case CART_CLEAN_SERVICES:
      return { ...state, services: {}, subtotalServices: 0 };
    case CART_CLEAN_PROMOTIONS:
      return { ...state, promotionDataList: {} };
    case CART_UPDATE_SEATS:
      return { ...state, seatList };
    case CART_ADD_SEATS: {
      const ticketsTmp = [...state.seatList, ...seatList].reduce(
        (acc, seat) => ({
          ...acc,
          [seat.buyerTypeId]: {
            ...buyerType,
            price: seat.price,
            n: (acc[seat.buyerTypeId] && acc[seat.buyerTypeId].n || 0) + 1
          }
        }),
        {}
      );
      return {
        ...state,
        seatList: [...state.seatList, ...seatList],
        tickets: ticketsTmp,
        ticketsQuantity: Object.values(ticketsTmp).reduce((acc, t) => acc + t.n, 0),
        total: Object.values(ticketsTmp).reduce((acc, t) => acc + t.price * t.n, 0)
      };
    }
    case CART_REMOVE_SEATS: {
      const seatToRemove = state.seatList.filter((seats) => seats.seatId === seatIdList[0].seatId);
      const ticketsTmpremove = {
        ...state.tickets,
        [seatToRemove[0].buyerTypeId]: {
          ...state.tickets[seatToRemove[0].buyerTypeId],
          n: state.tickets[seatToRemove[0].buyerTypeId].n - 1
        }
      };
      return {
        ...state,
        seatList: state.seatList.filter((s) => s !== seatToRemove[0]),
        tickets: ticketsTmpremove,
        ticketsQuantity: Object.values(ticketsTmpremove).reduce((acc, t) => acc + t.n, 0),
        total: Object.values(ticketsTmpremove).reduce((acc, t) => acc + t.price * t.n, 0)
      };
    }
    case CART_RECOMMENDATION_ASKED:
      return { ...state, askForRecommendation: false };
    case CART_RECOMMENDATION_NOT_ASKED:
      return { ...state, askForRecommendation: true };
    case CART_ADD_ANSWERS: {
      const typedAnswers = answers;
      const scopeKey = (genericFieldId, groupIndex, buyerTypeId) => {
        let key = String(genericFieldId);
        if (groupIndex) key = `${key}-${groupIndex}`;
        if (buyerTypeId) key = `${key}-${buyerTypeId}`;
        return key;
      };
      const answersMap = {};
      if (state.answers.length > 0) {
        state.answers.forEach((answer) => {
          const a = answer;
          answersMap[scopeKey(a.genericFieldId, a.groupIndex, a.buyerTypeId)] = answer;
        });
      }
      typedAnswers.forEach((answer) => {
        answersMap[scopeKey(answer.genericFieldId, answer.groupIndex, answer.buyerTypeId)] = answer;
      });
      const productFormList = action.productFormList;
      const dependentFields = (productFormList ?? []).flatMap((form2) => form2.formFieldsetSet ?? []).flatMap((fieldset) => fieldset.genericFieldSet ?? []).filter(
        (field) => field.parentGenericField?.genericFieldId !== void 0 && field.parentFieldOptionsValue !== void 0
      );
      dependentFields.forEach((field) => {
        const parentFieldId = field.parentGenericField.genericFieldId;
        const allowedValues = (field.parentFieldOptionsValue ?? "").split(",").map((v) => v.trim());
        typedAnswers.filter((answer) => answer.genericFieldId === field.genericFieldId).forEach((answer) => {
          const parentAnswer = answersMap[scopeKey(parentFieldId, answer.groupIndex, answer.buyerTypeId)];
          const parentValue = parentAnswer?.answerValue ?? parentAnswer?.answer;
          if (!parentValue || !allowedValues.includes(parentValue)) {
            delete answersMap[scopeKey(field.genericFieldId, answer.groupIndex, answer.buyerTypeId)];
          }
        });
      });
      return { ...state, answers: Object.values(answersMap) };
    }
    case CART_ADD_RECAPTCHA:
      return { ...state, recaptcha };
    case CART_SET_CUSTOMER_ID:
      if (action.payload.type === "seller") {
        return { ...state, sellerId: action.payload.value, customerId: null, externalCustomerId: null };
      }
      if (action.payload.type === "customer") {
        return {
          ...state,
          customerId: action.payload.value,
          externalCustomerId: action.payload.externalCustomerId || null,
          sellerId: null
        };
      }
      return state;
    case CART_CLEAR_CUSTOMER_ID: {
      return { ...state, sellerId: null, customerId: null, externalCustomerId: null };
    }
    default:
      return state;
  }
}
const initialState$8 = {
  shouldAutoSelectEvent: true
};
function autoSelectEvent(state = initialState$8, action) {
  switch (action.type) {
    case SET_AUTO_SELECT_EVENT:
      return {
        ...state,
        shouldAutoSelectEvent: action.payload
      };
    default:
      return state;
  }
}
const addTimeZone = (eventList, timeZone) => {
  if (timeZone) {
    return eventList.map((event) => ({
      ...event,
      timeZone
    }));
  }
  return [...eventList];
};
const initialState$7 = {
  isFetching: false,
  eventList: [],
  eventsByVenue: {},
  firstSpecialEventDate: null,
  eventsByProductId: {},
  availableDates: {},
  authenticated: false,
  isCGRAutoSelectEvent: true
};
function events(state = initialState$7, action) {
  const {
    response,
    timeZone,
    authenticated = false,
    productId
  } = action;
  switch (action.type) {
    case EVENTS_REQUEST:
      return { ...state, isFetching: true, isCGRAutoSelectEvent: true, eventList: [] };
    case EVENTS_SUCCESS: {
      const orderedEventList = response.sort(
        (a, b) => new Date(a.startDatetime).getTime() - new Date(b.startDatetime).getTime()
      );
      return {
        ...state,
        isFetching: false,
        isCGRAutoSelectEvent: false,
        eventList: addTimeZone(orderedEventList, timeZone),
        authenticated
      };
    }
    case EVENTS_FAILURE:
      return { ...state, isFetching: false, isCGRAutoSelectEvent: false };
    case EVENTS_BY_VENUE_REQUEST:
      return { ...state, isFetching: true, eventList: [] };
    case EVENTS_BY_VENUE_SUCCESS: {
      const orderedEventList = response.sort(
        (a, b) => new Date(a.startDatetime).getTime() - new Date(b.startDatetime).getTime()
      );
      const eventsByVenue = { ...state.eventsByVenue };
      eventsByVenue[action.venueId] = addTimeZone(orderedEventList, timeZone);
      return { ...state, isFetching: false, eventsByVenue, authenticated };
    }
    case EVENTS_BY_VENUE_FAILURE:
      return { ...state, isFetching: false };
    case EVENT_REQUEST:
      return { ...state, isFetching: true, event: void 0 };
    case EVENT_SUCCESS:
      return { ...state, isFetching: false, event: { ...response, timeZone }, authenticated };
    case EVENT_CODE_FAILURE:
      return { ...state, isFetching: false };
    case EVENT_CODE_REQUEST:
      return { ...state, isFetching: true, eventCode: {} };
    case EVENT_CODE_SUCCESS:
      return { ...state, isFetching: false, eventCode: response, authenticated };
    case EVENT_FAILURE:
      return { ...state, isFetching: false };
    case CALENDAR_INFO_REQUEST:
      return { ...state, isFetching: true };
    case CALENDAR_INFO_SUCCESS:
      return { ...state, isFetching: false, calendarInfoMap: response, authenticated };
    case CALENDAR_INFO_FAILURE:
      return { ...state, isFetching: false };
    case PRODUCT_RECENT_EVENTS_WITH_AVAILABILITY_REQUEST:
      return { ...state, isFetching: true };
    case PRODUCT_RECENT_EVENTS_WITH_AVAILABILITY_SUCCESS: {
      const eventList = addTimeZone(response, timeZone);
      return {
        ...state,
        isFetching: false,
        eventsByProductId: {
          ...state.eventsByProductId,
          [productId]: eventList
        },
        eventList,
        authenticated
      };
    }
    case PRODUCT_RECENT_EVENTS_WITH_AVAILABILITY_FAILURE:
      return { ...state, isFetching: false };
    case GET_EVENT_BY_ID_WITH_AVAILABILITY_REQUEST:
      return { ...state, isFetching: true };
    case GET_EVENT_BY_ID_WITH_AVAILABILITY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        eventsByProductId: {
          ...state.eventsByProductId,
          [productId]: [addTimeZone(response, timeZone)]
        },
        authenticated
      };
    case GET_EVENT_BY_ID_WITH_AVAILABILITY_FAILURE:
      return { ...state, isFetching: false };
    case CALENDAR_AVAILABILITY_REQUEST:
      return { ...state, isFetching: true };
    case CALENDAR_AVAILABILITY_SUCCESS: {
      const sortedDates = Object.keys(action.response).sort();
      const sortedAvailableDates = sortedDates.reduce(
        (acc, date) => ({
          ...acc,
          [date]: action.response[date]
        }),
        {}
      );
      return { ...state, isFetching: false, availableDates: sortedAvailableDates, authenticated };
    }
    case CALENDAR_AVAILABILITY_FAILURE:
      return { ...state, isFetching: false };
    default:
      return state;
  }
}
const initialState$6 = {
  loading: false
};
function loader(state = initialState$6, action) {
  switch (action.type) {
    case LOADER_SHOW:
      return { ...state, loading: true, showMessage: action.data.showMessage, message: action.data.message };
    case LOADER_HIDE:
      return { ...state, loading: false };
    default:
      return state;
  }
}
const initialState$5 = {
  isFetching: false,
  promotionList: [],
  promotionCodeList: [],
  promotionAgreementWithCodeList: [],
  promotionCode: {},
  promotionCodeValid: null,
  authenticated: false
};
function promotions(state = initialState$5, action) {
  switch (action.type) {
    case PROMOTIONS_REQUEST:
      return { ...state, isFetching: true };
    case PROMOTIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        promotionList: action.response,
        authenticated: !!action.authenticated
      };
    case PROMOTIONS_FAILURE:
      return { ...state, isFetching: false };
    case PROMOTION_CODE_REQUEST:
      return { ...state, promotionCodeValid: null };
    case PROMOTION_CODE_SUCCESS: {
      const promotionCode = action.response;
      let newState = {
        promotionCode,
        authenticated: !!action.authenticated
      };
      if (promotionCode && state.promotionCodeList) {
        const promotionCodeExists = !!state.promotionCodeList.some(
          (promotion) => promotion.promotionId === promotionCode.promotionId
        );
        if (!promotionCodeExists) {
          newState = {
            ...newState,
            promotionCodeValid: true,
            promotionCodeList: [promotionCode]
          };
        }
      }
      return { ...state, ...newState };
    }
    case PROMOTION_CODE_FAILURE:
      return { ...state, promotionCodeValid: false };
    case PROMOTION_EXTERNAL_REQUEST:
      return { ...state, promotionCodeValid: null };
    case PROMOTION_EXTERNAL_SUCCESS: {
      const promotionCode = action.response;
      let newState = {
        promotionCode,
        authenticated: !!action.authenticated
      };
      const { promotionAgreementWithCodeList } = state;
      promotionAgreementWithCodeList.push(promotionCode);
      newState = {
        ...newState,
        promotionAgreementWithCodeList
      };
      return { ...state, ...newState };
    }
    case PROMOTION_EXTERNAL_FAILURE:
      return { ...state, promotionCodeValid: false };
    case PROMOTION_CODE_CLEAN:
      return { ...state, promotionCodeList: [], promotionCode: {} };
    default:
      return state;
  }
}
const initialState$4 = {
  isFetching: false,
  reservation: [],
  purchase: {},
  productSubscription: {},
  authenticated: false,
  paymentDetails: {},
  termsAndConditionsList: [],
  paymentList: [],
  selectedDatesPerVenue: {},
  errorGettingRecommendation: false,
  cookieLifeTime: localStorage.getItem("cookieLifeTime") || null,
  errorInReservation: false
};
function reservations(state = initialState$4, action) {
  switch (action.type) {
    case RESERVATION_REQUEST:
      return { ...state, isFetching: true, errorInReservation: false };
    case RESERVATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        purchase: action.response,
        onPayment: false,
        authenticated: !!action.authenticated,
        errorInReservation: false
      };
    case RESERVATION_FAILURE:
      return { ...state, isFetching: false, errorInReservation: true };
    case GET_PAYMENT_REQUEST:
      return { ...state, isFetching: true, errorInPayment: false };
    case GET_PAYMENT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        paymentList: action.response,
        authenticated: !!action.authenticated
      };
    case GET_PAYMENT_FAILURE:
      return { ...state, isFetching: false, errorInPayment: true };
    case GET_PROSA_PAYMENT_STATUS_REQUEST:
      return { ...state, isFetching: true };
    case GET_PROSA_PAYMENT_STATUS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        paymentStatus: action.response,
        errorInPayment: false
      };
    case GET_PROSA_PAYMENT_STATUS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.response,
        errorInPayment: true
      };
    case PUT_PURCHASE_REQUEST:
      return { ...state, isFetching: true };
    case PUT_PURCHASE_SUCCESS:
      Cookie.remove("externalAffiliateId");
      return {
        ...state,
        isFetching: false,
        paymentDetails: action.response,
        onPayment: true,
        authenticated: !!action.authenticated
      };
    case POST_RETRYPAYMENT_FAILURE:
      return { ...state, isFetching: false, gettingPurchase: false };
    case POST_RETRYPAYMENT_REQUEST:
      return { ...state, isFetching: true };
    case POST_RETRYPAYMENT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        paymentDetails: action.response,
        onPayment: true,
        authenticated: !!action.authenticated
      };
    case PUT_PURCHASE_FAILURE:
      return { ...state, isFetching: false };
    case GET_PURCHASE_REQUEST:
      return { ...state, isFetching: true, gettingPurchase: true };
    case GET_PURCHASE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        purchase: action.response,
        gettingPurchase: false
      };
    case GET_PURCHASE_FAILURE:
      return { ...state, isFetching: false };
    case DELETE_RESERVATION_FAILURE:
      return { ...state, isFetching: false };
    case DELETE_RESERVATION_REQUEST:
      return { ...state, isFetching: true };
    case DELETE_RESERVATION_SUCCESS: {
      const purchase = state.purchase;
      let { reservationList: reservationListTmp = [] } = purchase;
      reservationListTmp = reservationListTmp.filter((r) => r.reservationId !== action.reservationId);
      const updatedPurchase = {
        ...purchase,
        total: reservationListTmp.reduce((acc, { total = 0 }) => acc + total, 0),
        reservationList: reservationListTmp
      };
      if (!reservationListTmp.length && Cookie.get("tiqueteoSession")) {
        Cookie.remove("tiqueteoSession", { path: "/" });
        delete updatedPurchase.sellerId;
      }
      return { ...state, purchase: updatedPurchase, isFetching: false };
    }
    case DELETE_PURCHASE_SUCCESS:
      return { ...state, purchase: {}, isFetching: false };
    case DELETE_PURCHASE_FAILURE:
      return { ...state, purchase: {}, isFetching: false };
    case DELETE_PURCHASE_REQUEST:
      return { ...state, isFetching: true };
    case DELETE_PURCHASE:
      return { ...state, purchase: {}, paymentDetails: {}, isFetching: false };
    case DELETE_PAYMENT_DETAILS:
      return { ...state, paymentDetails: {}, isFetching: false };
    case POST_PAYMENT_SUCCESS:
      return {
        ...state,
        purchaseConfirmed: true,
        isFetching: false
      };
    case POST_PAYMENT_FAILURE:
      return {
        ...state,
        purchaseConfirmed: false,
        isFetching: false
      };
    case POST_PAYMENT_REQUEST:
      return {
        ...state,
        purchaseConfirmed: false,
        isFetching: true
      };
    case POST_STRIPE_PAYMENT_SUCCESS:
      return {
        ...state,
        summaryDetails: action.response,
        isFetching: false
      };
    case POST_STRIPE_PAYMENT_FAILURE:
      return { ...state, isFetching: false };
    case POST_STRIPE_PAYMENT_REQUEST:
      return { ...state, isFetching: true };
    case GET_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        termsAndConditionsList: action.response,
        authenticated: !!action.authenticated
      };
    case GET_TERMS_AND_CONDITIONS_FAILURE:
      return { ...state, isFetching: false };
    case GET_TERMS_AND_CONDITIONS_REQUEST:
      return { ...state, isFetching: true };
    case GET_PAYMENT_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        termsAndConditionsList: [...state.termsAndConditionsList, ...action.response],
        authenticated: !!action.authenticated
      };
    case GET_PAYMENT_TERMS_AND_CONDITIONS_FAILURE:
      return { ...state, isFetching: false };
    case GET_PAYMENT_TERMS_AND_CONDITIONS_REQUEST:
      return { ...state, isFetching: true };
    case ACCEPT_TERM:
      return {
        ...state,
        termsAndConditionsList: state.termsAndConditionsList.map((term) => ({
          ...term,
          termAccepted: action.termId === term.termsAndConditionsId ? action.value : !!term.termAccepted
        }))
      };
    case ACCEPT_SUBSCRIPTION:
      return {
        ...state,
        productSubscription: {
          [action.productId]: action.value
        }
      };
    case GET_PARENT_RESERVATION_SUCCESS:
      return {
        ...state,
        parentReservation: action.response[0]
      };
    case GET_RECOMMENDATION_RULE_SUCCESS:
      return {
        ...state,
        recommendationRule: action.response,
        fetchingRecommendation: false
      };
    case GET_RECOMMENDATION_RULE_FAILURE:
      return {
        ...state,
        fetchingRecommendation: false,
        errorGettingRecommendation: true
      };
    case GET_RECOMMENDATION_RULE_REQUEST:
      return {
        ...state,
        fetchingRecommendation: true,
        errorGettingRecommendation: false
      };
    case SET_COOKIE_LIFETIME:
      return { ...state, cookieLifeTime: action.cookieLifeTime };
    default:
      return state;
  }
}
function getInitialReservationStateFromReservation(reservation) {
  const selectedEventPerVenue = {};
  const selectedVenueCapacityPerVenue = {};
  const selectedDatePerVenue = {};
  const ticket = reservation.ticketList[0];
  selectedEventPerVenue[ticket.venueId] = {
    eventId: ticket.eventId,
    startDatetime: ticket.startDatetime
  };
  selectedVenueCapacityPerVenue[ticket.venueId] = ticket.venueCapacityId;
  selectedDatePerVenue[ticket.venueId] = ticket.startDatetime;
  if (ticket.ticketComplementSet && ticket.ticketComplementSet.length > 0) {
    ticket.ticketComplementSet.forEach((ticketComplement) => {
      selectedEventPerVenue[ticketComplement.venueId] = {
        eventId: ticketComplement.eventId,
        startDatetime: ticketComplement.startDatetime
      };
      selectedVenueCapacityPerVenue[ticketComplement.venueId] = ticketComplement.venueCapacityId;
      selectedDatePerVenue[ticketComplement.venueId] = ticketComplement.startDatetime;
    });
  }
  return {
    ...reservation,
    selectedVenueCapacityPerVenue,
    selectedEventPerVenue,
    selectedDatePerVenue
  };
}
const initialState$3 = {
  selectedDatesPerVenue: {},
  // object with key venueId, value selected date
  selectedEventPerVenue: {},
  // object with key venueId, value selected event
  selectedVenueCapacityPerVenue: {},
  // object with key venueId, value selected venue capacity
  selectedBuyerTypes: {},
  selectedServices: {}
};
function editReservation(state = initialState$3, action) {
  switch (action.type) {
    /* get reservation and create an other object to fill easyli the initial state of components */
    case SET_INITIAL_RESERVATION_STATE: {
      const { reservation } = action.payload;
      const newInitialReservationState = getInitialReservationStateFromReservation(reservation);
      return {
        ...state,
        initialReservationState: newInitialReservationState,
        selectedDatesPerVenue: newInitialReservationState.selectedDatePerVenue
      };
    }
    /* One reservaion can have more than one venue, and we need a date for each one, ordered by venue displayOrder
     * For example: Sagrada Familia + Gaudi's Museum will need -> {venue 1 date 12-01-2019, venue
     */
    case SET_SELECTED_DATE_FOR_VENUE: {
      const { date, venueId } = action.payload;
      const newSelectedDates = { ...state.selectedDatesPerVenue };
      newSelectedDates[venueId] = date;
      return { ...state, selectedDatesPerVenue: newSelectedDates };
    }
    /* The same for events, we need at least one event per venue, except open date products and other special cases */
    case SET_SELECTED_EVENT_FOR_VENUE: {
      const { event, venueId } = action.payload;
      const newSelectedEvents = { ...state.selectedEventPerVenue };
      newSelectedEvents[venueId] = event;
      return { ...state, selectedEventPerVenue: newSelectedEvents };
    }
    case SET_SELECTED_BUYER_TYPES: {
      return { ...state, selectedBuyerTypes: action.payload };
    }
    case SET_SELECTED_SERVICES: {
      return {
        ...state,
        selectedServices: { ...state.selectedServices, ...action.payload }
      };
    }
    case REMOVE_SELECTED_SERVICES: {
      const newSelectedServices = { ...state.selectedServices };
      delete newSelectedServices[action.payload];
      return { ...state, selectedServices: newSelectedServices };
    }
    case SET_INITIAL_ANSWERS: {
      return {
        ...state,
        initialReservationState: {
          ...state.initialReservationState,
          ...action.payload
        }
      };
    }
    case CLEAN_RESERVATION: {
      return {
        ...state,
        selectedDatesPerVenue: {},
        selectedEventPerVenue: {},
        selectedVenueCapacityPerVenue: {},
        selectedBuyerTypes: {},
        selectedServices: {}
      };
    }
    default:
      return state;
  }
}
const initialState$2 = {
  isFetching: false,
  byServiceId: {},
  lastFetchedDate: null
};
const dedupeByBuyerType = (rows) => {
  const seen = /* @__PURE__ */ new Set();
  return rows.filter((row) => {
    if (seen.has(row.buyerTypeId)) return false;
    seen.add(row.buyerTypeId);
    return true;
  });
};
function servicePrices(state = initialState$2, action) {
  switch (action.type) {
    case SERVICE_PRICES_REQUEST:
      return { ...state, isFetching: true };
    case SERVICE_PRICES_SUCCESS: {
      const rows = Array.isArray(action.response) ? action.response : [];
      return {
        ...state,
        isFetching: false,
        lastFetchedDate: action.date ?? state.lastFetchedDate,
        byServiceId: {
          ...state.byServiceId,
          [String(action.serviceId)]: dedupeByBuyerType(rows)
        }
      };
    }
    case SERVICE_PRICES_FAILURE:
      return { ...state, isFetching: false };
    case SERVICE_PRICES_CLEAN:
      return initialState$2;
    default:
      return state;
  }
}
function updateObject(oldObject, newValues) {
  return { ...oldObject, ...newValues };
}
const initialState$1 = {
  isFetching: false,
  authenticated: false
};
function loginRequest(state) {
  return updateObject(state, {
    isFetching: true
  });
}
function loginSuccess(state) {
  return updateObject(state, {
    isFetching: false,
    authenticated: true
  });
}
function loginFailure(state) {
  return updateObject(state, {
    isFetching: false,
    authenticated: false
  });
}
function user(state = initialState$1, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return loginRequest(state);
    case LOGIN_SUCCESS:
      return loginSuccess(state);
    case LOGIN_FAILURE:
      return loginFailure(state);
    default:
      return state;
  }
}
function FormattedDate({ value, timeZone = "UTC", intl: _intl, ...props }) {
  if (Object.keys(props).length > 1) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedDate$1, { value, timeZone, ...props });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: moment(value).tz(timeZone).format(DATE_FORMAT_DMY) });
}
const FormattedDate_default = injectIntl(FormattedDate);
const dateTimeRx = /^(\d{4})-0?(\d+)-0?(\d+)[ ]0?(\d+):0?(\d+):0?(\d+)( \+0000)?$/;
const dateTimeUnixRx = /^(\d+)( \+0000)?$/;
function parseDate(value) {
  if (value === void 0 || value === null || value === "") {
    return moment.invalid();
  }
  if (moment.isMoment(value)) {
    return value;
  }
  if (Object.prototype.toString.call(value) === "[object Date]") {
    return moment(value);
  }
  const strValue = String(value);
  if (dateTimeRx.test(strValue)) {
    if (strValue.endsWith("+0000")) {
      return moment(strValue, DATETIME_FORMAT_ISO_YMDHMS_SPACE);
    }
    return moment(strValue, DATETIME_FORMAT_YMDHMS);
  }
  if (dateTimeUnixRx.test(strValue)) {
    return moment(strValue, "x");
  }
  if (moment(strValue, moment.ISO_8601).isValid()) {
    return moment(strValue);
  }
  return moment.invalid();
}
function FormattedDateTime({
  value,
  timeZone,
  partToShow,
  year = "numeric",
  month = "2-digit",
  day = "2-digit"
}) {
  if (!value) return null;
  const date = parseDate(value).toDate();
  const optional = {};
  if (timeZone) optional.timeZone = timeZone;
  const FormattedDateTimeRender = {
    [DATETIME_PART_TO_SHOW.DATE_ONLY]: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedDate$1, { year, month, day, value: date, ...optional }),
    [DATETIME_PART_TO_SHOW.TIME_ONLY]: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedTime$2, { hour12: false, value: date, ...optional }),
    [DATETIME_PART_TO_SHOW.DATE_AND_TIME]: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedTime$2, { year, month, day, hour12: false, value: date, ...optional }),
    default: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedTime$2, { year, month, day, hour12: false, value: date, ...optional })
  };
  return FormattedDateTimeRender[partToShow ?? "default"] ?? null;
}
const FormattedDateTime_default = injectIntl(FormattedDateTime);
function decodeJwt(token2) {
  if (!token2) {
    console.warn("Invalid token");
    return null;
  }
  const parts = token2.split(".");
  if (parts.length !== 3) {
    console.warn("Invalid format");
    return null;
  }
  try {
    const payloadBase64Url = parts[1];
    const payloadJson = atob(payloadBase64Url.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(payloadJson);
  } catch (error) {
    console.error("Error when decoding token:", error);
    return null;
  }
}
class LinkedBuyerTypeSelector extends Component {
  constructor(props) {
    super(props);
    this.handleBuyerTypeSelection = this.handleBuyerTypeSelection.bind(this);
  }
  componentDidUpdate(prevProps) {
    const { tickets, buyerTypesMap, update: update2 } = this.props;
    const prevTickets = prevProps.tickets;
    const prevBuyerTypesMap = prevProps.buyerTypesMap;
    const currentTicketsSelected = !isEmpty(prevTickets) ? Object.values(prevTickets).reduce((prev, next) => prev + next.n, 0) : 0;
    const nextTicketsSelected = !isEmpty(tickets) ? Object.values(tickets).reduce((prev, next) => prev + next.n, 0) : 0;
    const hasNumberOfTicketsChanged = currentTicketsSelected !== nextTicketsSelected;
    if (isEmpty(prevTickets) && !isEmpty(tickets) || hasNumberOfTicketsChanged || !isEmpty(buyerTypesMap) && !isEmpty(tickets) && isEmpty(prevBuyerTypesMap)) {
      let total = 0;
      const updatedTickets = { ...tickets };
      Object.entries(updatedTickets).forEach(([key, val]) => {
        if (buyerTypesMap[Number(key)]) {
          total += buyerTypesMap[Number(key)].price * val.n;
          updatedTickets[key] = { ...buyerTypesMap[Number(key)], n: val.n };
        } else {
          delete updatedTickets[key];
        }
      });
      const updatedCart = {
        total,
        ticketsSelected: updatedTickets
      };
      if (!isEmpty(updatedTickets)) {
        updatedCart.tickets = updatedTickets;
      }
      update2(updatedCart);
    }
  }
  handleBuyerTypeSelection({
    selected: tickets,
    count: ticketsQuantity,
    price: total
  }) {
    const { onChange } = this.props;
    onChange({
      tickets,
      ticketsQuantity,
      total
    });
  }
  render() {
    const {
      minTickets,
      maxTickets,
      maxTicketsBySalesGroup,
      currentTicketQuantity,
      currency,
      buyerTypesMap,
      productInfo,
      tickets,
      promotionList,
      event,
      sellerIdSelected,
      showBuyerTypesAsSelect,
      app,
      product,
      hasLogin
    } = this.props;
    const headerText = /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormattedMessage,
      {
        id: "buyerTypes.helpMessage",
        description: "Help to select buyer types",
        defaultMessage: `Selecciona el número de personas e indica el tipo de entrada. El
        número máximo de entradas debe estar comprendido entre {minTickets} y {maxTickets}.`,
        values: {
          minTickets,
          maxTickets
        },
        tagName: "p"
      }
    );
    const decodedToken = decodeJwt(sessionStorage.getItem("access_token"));
    let loginUrl = "";
    if (window.pos && hasLogin && !Cookie.get("loyalty") && !decodedToken?.loyalty) {
      loginUrl = "/login";
    }
    if (window.pos && window.pos.externalLogin && !Cookie.get("loyalty") && !decodedToken?.loyalty) {
      loginUrl = window.pos.externalLogin;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      BuyerTypeSelector$1,
      {
        showBuyerTypesAsSelect,
        handleSelection: this.handleBuyerTypeSelection,
        headerText,
        minTickets,
        maxTickets,
        hidePrice: product.priceByPackage,
        maxTicketsBySalesGroup,
        currentTicketQuantity,
        buyerTypesMap,
        productInfo,
        currency,
        ticketsSelected: tickets,
        loginUrl,
        promotionList,
        event,
        sellerIdSelected: sellerIdSelected ?? void 0,
        app
      }
    );
  }
}
const mapStateToProps$f = (state) => {
  const { cart: cart2, products: products2, reservations: reservations2, events: events2, pointOfSales } = state;
  const { productInfoList } = products2;
  const { tickets, events: eventsCart, sellerId, ticketsQuantity, product } = cart2;
  const { clientList, configurations } = pointOfSales;
  const hasLogin = configurations && configurations.hasLogin;
  const currency = clientList[0].currencyList[0].isoCode;
  const { minTickets, maxTickets, maxTicketsBySalesGroup } = getTicketsRange(state);
  const { parentReservation } = reservations2;
  const venuesMap = getVenueMap(state);
  let promotionList = getVisiblePromoList(state);
  const sellerIdSelected = sellerId ? Number(sellerId) : Number(sessionStorage.getItem("sellerId")) || null;
  if (sellerIdSelected) {
    promotionList = promotionList.filter(
      (promo) => promo.sellerIds && promo.sellerIds.includes(sellerIdSelected) || !promo.sellerIds
    );
  }
  const currentProductId = product?.productId;
  if (currentProductId) {
    promotionList = promotionList.filter(
      (promo) => Array.isArray(promo.productIds) && promo.productIds.includes(currentProductId)
    );
  }
  let event;
  if (Array.isArray(eventsCart) && eventsCart.length > 0) {
    const [filteredEvent] = eventsCart.filter(
      (eventItem) => venuesMap[eventItem.venueId] && (!venuesMap[eventItem.venueId]?.mainVenueId || venuesMap[eventItem.venueId]?.mainVenueId)
    );
    event = filteredEvent;
  } else {
    event = events2.eventList[events2.eventList.length - 1];
  }
  const limitTickets = parentReservation && parentReservation.status === "confirmed" ? parentReservation.currentTicketNum : maxTickets;
  return {
    minTickets: minTickets ?? 0,
    maxTickets: limitTickets ?? maxTickets,
    maxTicketsBySalesGroup,
    tickets,
    currentTicketQuantity: ticketsQuantity || 0,
    buyerTypesMap: getBuyerTypeMap(state),
    buyerTypeInfoList: getBuyerTypeInfoListForCartProduct(state),
    productInfo: getProductInfoMap(
      productInfoList,
      "buyer_types"
    ),
    promotionList,
    sellerIdSelected,
    event,
    product,
    currency,
    hasLogin
  };
};
const mapDispatchToProps$d = (dispatch, ownProps) => ({
  onChange: (tickets) => {
    dispatch(updateBt(tickets));
    dispatch(reset2("ticketForm"));
    if (ownProps.cart && ownProps.cart.services) {
      dispatch(cleanServices());
    }
    if (!tickets || !Object.values(tickets.tickets).length) {
      dispatch(cleanPromotions());
    }
  },
  update: (cart2) => {
    dispatch(updateAll(cart2));
  }
});
const LinkedBuyerTypeSelector$1 = connect(mapStateToProps$f, mapDispatchToProps$d)(LinkedBuyerTypeSelector);
let goToStepFired = false;
const markGoToStepFired = () => {
  goToStepFired = true;
};
const consumeGoToStepFlag = () => {
  const fired = goToStepFired;
  goToStepFired = false;
  return fired;
};
function BuyerTypeSelectorWrapper({
  step,
  ticketsQuantityToShow,
  handleSelect,
  activeStep,
  totalSteps,
  valid,
  currency,
  showBuyerTypesAsSelect,
  app,
  productInfo,
  timeZone
}) {
  const title = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "¿Cuántas personas seréis?", id: "title.buyerTypes" });
  const titleEditable = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedHTMLMessage, { defaultMessage: "Total de <strong>personas</strong>", id: "title.editable.buyerTypes" });
  const handleGoToStep = (targetStep) => {
    if (targetStep > step) {
      const isCasaBatllo2 = () => window.pos && window.pos.name === "CasaBatllo";
      if (!isCasaBatllo2() && isProviderEnabled("ga4")) {
        viewSection({
          section: "select-tickets",
          productInfo,
          timeZone
        });
        markGoToStepFired();
      }
    }
    handleSelect(targetStep);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FrontendMainPanel$1,
    {
      eventKey: step,
      title,
      icon: "icon-own-supervisor_account",
      selected: ticketsQuantityToShow,
      visible: true,
      titleEditable,
      activeStep,
      totalSteps,
      goToStep: handleGoToStep,
      step,
      showNext: valid,
      renderRequired: true,
      stepEcommerce: "select-tickets",
      canCenter: true,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        LinkedBuyerTypeSelector$1,
        {
          ...{ handleSelect: handleGoToStep, currency },
          showBuyerTypesAsSelect,
          app
        }
      )
    },
    `main-panel-${step}`
  );
}
const mapStateToProps$e = (state) => {
  const { cart: cart2, products: products2, pointOfSales } = state;
  const { clientList } = pointOfSales;
  const { tickets } = cart2;
  const { minTickets, maxTickets, maxTicketsBySalesGroup } = getTicketsRange(state);
  const { productList } = products2;
  const ticketsQuantityNoAvailability = Object.values(tickets).filter((ticket) => ticket.noHandleAvailability).reduce((res, { n = 0 }) => res + n, 0);
  const ticketsQuantity = Object.values(tickets).filter((ticket) => !ticket.noHandleAvailability).reduce((res, { n = 0 }) => res + n, 0);
  const ticketsQuantityToShow = Object.values(tickets).reduce((res, { n = 0 }) => res + n, 0);
  let valid = false;
  if (ticketsQuantity && ticketsQuantity >= (minTickets ?? 0) && ticketsQuantity <= (maxTickets ?? Infinity)) {
    valid = true;
  }
  if (ticketsQuantityNoAvailability && ticketsQuantityNoAvailability >= (minTickets ?? 0) && ticketsQuantityNoAvailability <= (maxTicketsBySalesGroup ?? Infinity)) {
    valid = true;
  }
  return {
    ticketsQuantity,
    ticketsQuantityToShow,
    valid,
    productInfo: productList[0],
    timeZone: clientList[0].timeZone
  };
};
const BuyerTypeSelectorWrapper$1 = connect(mapStateToProps$e)(BuyerTypeSelectorWrapper);
class SeatSelector extends Component {
  static defaultProps = {
    language: "en"
  };
  iframeSeatSelector = null;
  constructor(props) {
    super(props);
    this.onloadFrame = this.onloadFrame.bind(this);
    this.handleFrameTasks = this.handleFrameTasks.bind(this);
  }
  componentDidMount() {
    window.addEventListener("message", this.handleFrameTasks);
    if (this.iframeSeatSelector) {
      if (this.iframeSeatSelector.addEventListener) {
        this.iframeSeatSelector.addEventListener(
          "load",
          this.onloadFrame,
          false
          // https://stackoverflow.com/questions/7398290/unable-to-understand-usecapture-attribute-in-addeventlistener
        );
      } else {
        this.iframeSeatSelector.attachEvent("onload", this.onloadFrame);
      }
    }
  }
  shouldComponentUpdate(nextProps) {
    const { token: token2 } = this.props;
    return nextProps.token !== token2;
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handleFrameTasks);
  }
  handleFrameTasks(e) {
    const { logger, onUuidChange, handleEvent, handleSelection, handleUnSelection, refreshUser: refreshUser2, loginUser: loginUser2, showError } = this.props;
    logger(e);
    if (e.data.action) {
      if (e.data.action.indexOf("SEAT-ACTION") !== -1) {
        switch (e.data.action) {
          case "SEAT-ACTION-GET_EVENT":
            handleEvent(JSON.parse(e.data.data));
            break;
          case "SEAT-ACTION-RESERVE":
            handleSelection(JSON.parse(e.data.data));
            onUuidChange(JSON.parse(e.data.data).uuid);
            break;
          case "SEAT-ACTION-RELEASE":
            handleUnSelection(JSON.parse(e.data.data));
            onUuidChange(JSON.parse(e.data.data).uuid);
            break;
        }
      } else if (e.data.action.indexOf("SEAT-ERROR-HTTP") !== -1) {
        switch (e.data.action) {
          case "SEAT-ERROR-HTTP-401":
            refreshUser2(JSON.parse(e.data.data));
            break;
          case "SEAT-ERROR-HTTP-403":
            loginUser2(JSON.parse(e.data.data));
            break;
          default:
            showError(JSON.parse(e.data.data));
            break;
        }
      }
    }
  }
  onloadFrame() {
    console.log("loaded", this.iframeSeatSelector);
  }
  render() {
    const { token: token2, language, uuid, posId, salesGroupId, productId, eventId } = this.props;
    let src = `${NUMBERED_IFRAME_URL()}/#/numbered/product/${productId}/event/${eventId}/type/${salesGroupId}/pos/${posId}/token/${token2}`;
    const queryParams = {};
    if (uuid) queryParams.uuid = uuid;
    if (language) queryParams.lang = language;
    if (Object.keys(queryParams).length) {
      src += `?${queryString.stringify(queryParams)}`;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "iframe",
      {
        title: "iframe-seat-selector",
        src,
        width: "100%",
        height: "850px",
        scrolling: "no",
        frameBorder: 0,
        ref: (ifr) => {
          this.iframeSeatSelector = ifr;
        }
      },
      token2
    );
  }
}
class LinkedSeatSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      log: []
    };
    this.handleSeatUnSelection = this.handleSeatUnSelection.bind(this);
    this.logger = this.logger.bind(this);
  }
  handleSeatUnSelection(seat) {
    const { onRemoveSeat } = this.props;
    onRemoveSeat(seat);
  }
  logger(e) {
    const { log } = this.state;
    if (!e.data.type && e.data.action) {
      this.setState({
        log: [
          {
            action: e.data.action || e.data,
            data: JSON.parse(e.data.data || "{}")
          },
          ...log
        ]
      });
    }
  }
  render() {
    const {
      token: token2,
      salesGroupId,
      productId,
      productInfo,
      eventId,
      buyerTypeMap,
      onAddSeat,
      updateEvent,
      venueCapacityMap,
      handleRefreshUser,
      handleLoginUser,
      posId,
      showError,
      ...props
    } = this.props;
    const currentUuid = Cookie.get("tiqueteoSession");
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      productInfo && productInfo.top,
      eventId && /* @__PURE__ */ jsxRuntimeExports.jsx(
        SeatSelector,
        {
          language: Cookie.get("locale"),
          token: token2,
          uuid: currentUuid,
          onUuidChange: (uuid) => {
            if (currentUuid !== uuid) {
              setCookie("tiqueteoSessionNumbered", uuid);
            }
          },
          salesGroupId,
          productId,
          eventId,
          handleSelection: (seat) => {
            const seatObj = seat;
            onAddSeat({
              seat: seatObj,
              buyerType: buyerTypeMap[seatObj.buyerTypeId]
            });
          },
          handleUnSelection: this.handleSeatUnSelection,
          handleEvent: (event) => {
            const eventObj = event;
            updateEvent({
              ...eventObj,
              venueId: venueCapacityMap[eventObj.venueCapacityId].venueId
            });
          },
          logger: this.logger,
          refreshUser: handleRefreshUser,
          loginUser: handleLoginUser,
          showError,
          posId,
          ...props
        }
      ),
      productInfo && productInfo.bottom
    ] });
  }
}
const mapStateToProps$d = (state) => {
  const { cart: cart2, pointOfSales, products: products2 } = state;
  const { pointOfSale } = pointOfSales;
  const { pointOfSaleId } = pointOfSale;
  const { product, salesGroup, events: events2 } = cart2;
  const { productInfoList } = products2;
  const event = events2 && events2.length > 0 && events2[0];
  return {
    token: sessionStorage.getItem("access_token"),
    salesGroupId: salesGroup.salesGroupId,
    productId: product.productId,
    eventId: event && event.eventId,
    productInfo: getProductInfoMap(
      productInfoList,
      "numbered"
    ),
    buyerTypeMap: getBuyerTypeMap(state),
    venueCapacityMap: getVenueCapacityMap(state),
    posId: pointOfSaleId
  };
};
const mapDispatchToProps$c = (dispatch) => ({
  onAddSeat: ({ seat, buyerType }) => {
    dispatch(
      addSeats({ seat, buyerType })
    );
  },
  onRemoveSeat: (seatId) => {
    dispatch(removeSeats(seatId));
  },
  updateEvent: (event) => {
    dispatch(updateEvents(event));
  },
  showError: (err) => {
    try {
      const { message } = JSON.parse(err);
      dispatch(
        notificationsExports.error({
          title: "Numerado",
          message,
          level: "error",
          position: "bc"
        })
      );
    } catch {
    }
  },
  handleRefreshUser: () => {
    dispatch(refreshUser());
  },
  handleLoginUser: () => {
    dispatch(loginUser());
  }
});
const LinkedSeatSelector$1 = connect(mapStateToProps$d, mapDispatchToProps$c)(LinkedSeatSelector);
function SeatSelectorWrapper({
  step,
  ticketsQuantity,
  handleSelect,
  activeStep,
  totalSteps
}) {
  const title = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Escoge tus asientos", id: "title.numbered" });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FrontendMainPanel$1,
    {
      title,
      icon: "icon-own-event_seat",
      selected: !!ticketsQuantity && ticketsQuantity,
      visible: true,
      titleEditable: "",
      activeStep,
      totalSteps,
      goToStep: handleSelect,
      step,
      showNext: true,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(LinkedSeatSelector$1, {})
    },
    `main-panel-${step}`
  );
}
function ServiceSelectorWrapper({
  step,
  serviceList = [],
  onChange,
  productInfo,
  activeStep,
  handleSelect,
  totalSteps,
  currency,
  servicesCartInvalid,
  events: events2,
  clientList,
  servicePriceMap,
  tickets,
  eventDate,
  pricesEnabled,
  refetchPrices
}) {
  const requestedDateRef = useRef(null);
  useEffect(() => {
    if (!pricesEnabled || !eventDate || !serviceList.length) return;
    if (requestedDateRef.current === eventDate) return;
    requestedDateRef.current = eventDate;
    refetchPrices(serviceList, eventDate);
  }, [pricesEnabled, eventDate, serviceList, refetchPrices]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FrontendMainPanel$1,
    {
      title: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Completa tu visita", id: "title.services" }),
      icon: "icon-own-star",
      showNext: servicesCartInvalid,
      activeStep,
      totalSteps,
      goToStep: handleSelect,
      step,
      renderRequired: true,
      stepEcommerce: "select-upgrade",
      canCenter: true,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        ServiceSelector,
        {
          serviceList,
          productInfo,
          clientList,
          handleSelection: onChange,
          currency,
          events: { events: events2 },
          servicePriceMap,
          tickets,
          activeStep,
          step
        }
      )
    },
    `main-panel-${step}`
  );
}
const mapStateToProps$c = (state) => {
  const { cart: cart2, products: products2, pointOfSales, servicePrices: servicePrices2 } = state;
  const { productInfoList } = products2;
  const { clientList } = pointOfSales;
  const firstEvent = cart2.events?.[0];
  return {
    servicePriceMap: servicePrices2?.byServiceId ?? {},
    tickets: cart2.tickets ?? {},
    eventDate: firstEvent?.startDatetime,
    pricesEnabled: !!servicePrices2,
    serviceList: getVisibleServiceListSorted(state),
    productInfo: getProductInfoMap(productInfoList, "services"),
    servicesCartInvalid: !hasServiceAnswerRequired(
      cart2.services,
      cart2.events
    ),
    currency: clientList[0].currencyList[0].isoCode,
    events: cart2.events,
    clientList
  };
};
const mapDispatchToProps$b = (dispatch) => ({
  onChange: (serviceSelectedMap) => {
    dispatch(updateServices(serviceSelectedMap));
  },
  refetchPrices: (serviceList, date) => {
    dispatch(fetchAllServicePrices({ serviceList, date }));
  }
});
const ServiceSelectorWrapper$1 = connect(mapStateToProps$c, mapDispatchToProps$b)(ServiceSelectorWrapper);
var parseExports = requireParse();
const parse = /* @__PURE__ */ getDefaultExportFromCjs(parseExports);
class DateSelector extends Component {
  isMounted = false;
  processingInitialDate = false;
  previousSessionValue = null;
  hasLoadedDataLayer = false;
  static defaultProps = {
    displayFormat: DATE_FORMAT_DMY,
    firstDayOfWeek: 1,
    fromReschedule: false
  };
  static getCorrectDateSelection(selectedDate, cartDate) {
    if (cartDate) {
      return moment(cartDate);
    }
    if (selectedDate) {
      return moment(selectedDate);
    }
    return moment();
  }
  constructor(props) {
    super(props);
    this.state = {
      paramsAvailability: { minTickets: 0, month: 0, year: 0 },
      disablePrevButton: false,
      disableNextButton: false,
      initialDate: null,
      isLoading: true,
      nextMonthDays: {},
      currentMonthDays: {}
    };
    this.handleOnChangeMonth = this.handleOnChangeMonth.bind(this);
    this.handleChangeMinAvailability = this.handleChangeMinAvailability.bind(this);
    this.disabledPrevAction = this.disabledPrevAction.bind(this);
    this.updateCurrentAndNextMonthDays = this.updateCurrentAndNextMonthDays.bind(this);
  }
  async componentDidMount() {
    this.isMounted = true;
    const { selectedDate, selectedProduct, cart: cart2, timeZone, salesGroup, venueId, app } = this.props;
    const { salesGroupId } = salesGroup;
    const { productId } = selectedProduct;
    const dateCart = cart2.date;
    const isSellerOrCGR = app === "seller" || app === "cgr";
    const isCasaBatllo2 = window.pos && window.pos.name === "CasaBatllo";
    const correctDateSelection = DateSelector.getCorrectDateSelection(selectedDate, cart2.date);
    if (!this.isMounted) return;
    if (!isSellerOrCGR) {
      await this.updateCurrentAndNextMonthDays(salesGroupId, productId, venueId, correctDateSelection);
    } else {
      this.handleOnChangeMonth(selectedDate);
      this.setState({ isLoading: false, initialDate: selectedDate ?? null });
    }
    if (!isCasaBatllo2 && !this.hasLoadedDataLayer && !isProviderEnabled("ga4")) {
      viewSection({
        section: "select-day",
        productInfo: selectedProduct,
        timeZone,
        dateCart
      });
      this.hasLoadedDataLayer = true;
    }
  }
  async componentDidUpdate(prevProps, prevState) {
    if (!this.isMounted) return;
    const { selectedDate, app, cart: cart2, onChangeDay, fromReschedule, selectedProduct, timeZone } = this.props;
    const { nextMonthDays, currentMonthDays } = this.state;
    const isSellerOrCGR = app === "seller" || app === "cgr";
    const isCasaBatllo2 = window.pos && window.pos.name === "CasaBatllo";
    const currentSessionValue = sessionStorage.getItem("productItemConfigurations");
    const notSendViewSection = localStorage.getItem("notShowViewSection");
    const dateCart = cart2.date;
    if (isCasaBatllo2 && this.previousSessionValue !== currentSessionValue) {
      if (!this.hasLoadedDataLayer && !notSendViewSection && !isProviderEnabled("ga4")) {
        viewSection({
          section: "select-day",
          productInfo: selectedProduct,
          timeZone,
          dateCart
        });
      }
      this.previousSessionValue = currentSessionValue;
      this.hasLoadedDataLayer = true;
    }
    if (fromReschedule && prevProps.selectedDate && selectedDate) {
      const prevDateString = moment(prevProps.selectedDate).format(DATE_FORMAT_YMD);
      const currentDateString = moment(selectedDate).format(DATE_FORMAT_YMD);
      if (prevDateString !== currentDateString) {
        this.setState({
          initialDate: moment(selectedDate).toDate(),
          isLoading: false
        });
        return;
      }
    }
    if (cart2.date && prevProps.cart && prevProps.cart.date !== cart2.date) {
      onChangeDay(cart2.date);
    } else if (!isSellerOrCGR && (currentMonthDays !== prevState.currentMonthDays || nextMonthDays !== prevState.nextMonthDays) && !this.processingInitialDate) {
      this.processingInitialDate = true;
      const allDays = { ...currentMonthDays, ...nextMonthDays };
      const firstAvailableDate = this.findFirstAvailableDate(allDays);
      if (firstAvailableDate) {
        const [year, month, day] = firstAvailableDate.split("-").map(Number);
        const initialDateValue = new Date(year, month - 1, day);
        const setInitialDay = selectedDate > initialDateValue ? selectedDate : initialDateValue;
        this.setState({ initialDate: setInitialDay }, () => {
          this.handleOnChangeMonth(setInitialDay);
          this.processingInitialDate = false;
        });
      } else {
        this.setState({ isLoading: false, initialDate: selectedDate ?? null });
        this.processingInitialDate = false;
      }
    }
  }
  componentWillUnmount() {
    this.isMounted = false;
  }
  handleChangeMinAvailability(e) {
    const minAvailability = e.target.value;
    const { onChangeMonth } = this.props;
    this.setState((prevState) => {
      const newParamsAvailability = {
        ...prevState.paramsAvailability,
        minTickets: Number(minAvailability)
      };
      onChangeMonth(newParamsAvailability);
      return { paramsAvailability: newParamsAvailability };
    });
  }
  handleOnChangeMonth(date = /* @__PURE__ */ new Date()) {
    const { onChangeMonth, venueId, minTickets } = this.props;
    const { paramsAvailability: paramsAvailabilityState } = this.state;
    const paramsAvailability = {
      month: moment(date).month() + 1,
      year: moment(date).year(),
      venueId,
      minTickets: (paramsAvailabilityState.minTickets ?? 0) > (minTickets ?? 0) ? paramsAvailabilityState.minTickets : minTickets
    };
    this.disabledNextPrevCalendarBtns(date);
    this.setState({
      paramsAvailability
    });
    onChangeMonth(paramsAvailability);
  }
  async updateCurrentAndNextMonthDays(salesGroupId, productId, venueId, correctDateSelection) {
    const currentMonthParams = {
      month: correctDateSelection.month() + 1,
      year: correctDateSelection.year(),
      venueId
    };
    const nextMonthParams = {
      month: correctDateSelection.month() + 2,
      year: correctDateSelection.year(),
      venueId
    };
    if (currentMonthParams.month > 12) {
      currentMonthParams.month -= 12;
      currentMonthParams.year += 1;
    }
    if (nextMonthParams.month > 12) {
      nextMonthParams.month -= 12;
      nextMonthParams.year += 1;
    }
    try {
      const [getCurrentMonthDays, getNextMonthDays] = await Promise.all([
        fetchNextMonthDays(salesGroupId, productId, currentMonthParams),
        fetchNextMonthDays(salesGroupId, productId, nextMonthParams)
      ]);
      if (this.isMounted) {
        this.setState({
          nextMonthDays: getNextMonthDays,
          currentMonthDays: getCurrentMonthDays
        });
      }
    } catch (error) {
      console.error("Error fetching days data:", error);
      if (this.isMounted) {
        this.setState({ isLoading: false });
      }
    }
  }
  findFirstAvailableDate(availabilityObject) {
    const { disabledDates, timeZone, startDate, endDate } = this.props;
    const startTimestamp = moment.tz(new Date(startDate), timeZone).format(DATE_FORMAT_YMD);
    const endTimestamp = moment.tz(new Date(endDate), timeZone).format(DATE_FORMAT_YMD);
    const now = getNowDate(timeZone).format(DATE_FORMAT_YMD).toString();
    const disabledDatesArray = (disabledDates ?? "").split(",").map((date) => {
      const day = date.slice(0, 2);
      const month = date.slice(2, 4);
      const year = date.slice(4);
      return `${year}-${month}-${day}`;
    }).sort();
    const dates = Object.entries(availabilityObject).map(([date, status]) => {
      const cleanDate = date.replace(/^\d+\.\s\*\*|\*\*$/g, "");
      return { date: cleanDate, status };
    });
    dates.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
    const availableDates = dates.find((item) => {
      const dateTimestamp = moment.tz(item.date, timeZone).format(DATE_FORMAT_YMD);
      const nowTimestamp = moment.tz(now, timeZone).format(DATE_FORMAT_YMD);
      return dateTimestamp >= nowTimestamp && dateTimestamp >= startTimestamp && dateTimestamp <= endTimestamp && !disabledDatesArray.includes(item.date) && item.status?.available === "availability";
    });
    return availableDates && Object.keys(availableDates).length ? availableDates.date : null;
  }
  disabledNextPrevCalendarBtns(momentDate) {
    const { salesGroup, openingDate, calendarEnd, app, allowSellAndEditPastEvents } = this.props;
    const { calendarType, numPeriods = 0, periodType } = salesGroup;
    const periodMapping = {
      day: "days",
      week: "weeks",
      month: "months"
    };
    const period = periodMapping[periodType ?? ""] || "months";
    let momentFirstDayOfOpeningDate;
    if (calendarType === "periodic") {
      momentFirstDayOfOpeningDate = moment().add(numPeriods, period).startOf("month");
    } else {
      momentFirstDayOfOpeningDate = moment(openingDate).startOf("month");
    }
    const momentFirstDayOfCalendarEnd = moment(calendarEnd).startOf("month");
    const dateEndCalendar = !calendarEnd || momentFirstDayOfOpeningDate.isBefore(momentFirstDayOfCalendarEnd) ? momentFirstDayOfOpeningDate : momentFirstDayOfCalendarEnd;
    const currentDateCalendarUser = moment(momentDate);
    const nowDateCalendar = moment();
    const navPrevButton = document.getElementsByClassName("DayPickerNavigation_leftButton__horizontalDefault")[0];
    const navNextButton = document.getElementsByClassName("DayPickerNavigation_rightButton__horizontalDefault")[0];
    if (currentDateCalendarUser.isSameOrAfter(dateEndCalendar)) {
      navNextButton?.classList.add("disabled-next-prev-btn_calendar");
      this.setState(() => ({
        disableNextButton: true
      }));
    } else {
      navNextButton?.classList.remove("disabled-next-prev-btn_calendar");
      this.setState(() => ({
        disableNextButton: false
      }));
    }
    if (!app || app && !allowSellAndEditPastEvents) {
      this.disabledPrevAction(currentDateCalendarUser, nowDateCalendar, navPrevButton);
    }
  }
  disabledPrevAction(currentDateCalendarUser, nowDateCalendar, navPrevButton) {
    if (currentDateCalendarUser.format(DATE_FORMAT_YEAR_MONTH) === nowDateCalendar.format(DATE_FORMAT_YEAR_MONTH) || currentDateCalendarUser.startOf("month").isSameOrBefore(nowDateCalendar.startOf("month"))) {
      navPrevButton?.classList.add("disabled-next-prev-btn_calendar");
      this.setState(() => ({
        disablePrevButton: true
      }));
    } else {
      navPrevButton?.classList.remove("disabled-next-prev-btn_calendar");
      this.setState(() => ({
        disablePrevButton: false
      }));
    }
  }
  render() {
    const {
      showCalendar,
      isOutOfRange,
      headerText,
      productInfo = {},
      days,
      datesPricing = {},
      weekDays,
      onChangeDay,
      startDate,
      endDate,
      locale,
      disabledDates,
      userInfoCalendar,
      showAvailabilityFilter = false,
      minTickets,
      maxTickets = 90,
      selectedProduct,
      venueId,
      blockNoAvailability = false,
      salesGroup,
      showPricing
    } = this.props;
    const { isLoading, initialDate, disableNextButton, disablePrevButton } = this.state;
    const calendarProps = {
      locale,
      weekDays,
      handleSelect: (day) => {
        onChangeDay(day);
      },
      ...isOutOfRange && { isOutOfRange },
      onChangeMonth: this.handleOnChangeMonth,
      selectedDate: initialDate,
      startDate,
      endDate: endDate ?? null,
      days,
      datesPricing,
      showPricing,
      disabledDates,
      productInfo,
      disablePrevButton,
      disableNextButton,
      showSecondCalendar: selectedProduct && selectedProduct.productVenueSet && selectedProduct.productVenueSet.length > 1 && venueId === selectedProduct.productVenueSet[0].venueId,
      blockNoAvailability,
      salesGroupId: salesGroup.salesGroupId,
      productId: selectedProduct.productId,
      venueId,
      minTickets
    };
    const options = [];
    for (let i = minTickets ?? 0; i <= maxTickets; i++) {
      options.push(
        /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: i, children: i }, i)
      );
    }
    if (isLoading && !initialDate) return null;
    return showCalendar ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      headerText && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel-body-header", children: userInfoCalendar ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: userInfoCalendar } }) : /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: headerText }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "panel-body-content", children: [
        productInfo && productInfo.top && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-12", children: productInfo.top }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "row row-centered", children: [
          showAvailabilityFilter && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-2 col-centered", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { htmlFor: "minAvailability", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "label.calendar.availability", defaultMessage: "How many people?" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "select",
              {
                className: "form-control",
                name: "minAvailability",
                id: "minAvailability",
                onChange: this.handleChangeMinAvailability,
                children: options
              }
            )
          ] }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: "col-md-12 calendar",
              style: {
                marginTop: showAvailabilityFilter ? 25 : 0,
                marginBottom: showAvailabilityFilter || headerText ? 15 : 0
              },
              children: endDate ? /* @__PURE__ */ jsxRuntimeExports.jsx(Calendar$1, { ...calendarProps }) : null
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-12 calendar", children: productInfo && productInfo.bottom }) })
      ] })
    ] }) : null;
  }
}
function mapStateToProps$b(state, ownProps) {
  const { products: products2, cart: cart2, pointOfSales, events: events2 } = state;
  const { productList, productConfigurations } = products2;
  const { clientList, pointOfSale, configurations } = pointOfSales;
  const { salesGroup, product } = cart2;
  const { availableDates, datesPricing } = events2;
  const { app } = ownProps;
  let openingDate;
  if (salesGroup && salesGroup.openingDate) {
    openingDate = salesGroup.openingDate;
  } else if (ownProps.salesGroup) {
    openingDate = ownProps.salesGroup.openingDate;
  }
  const isSellerOrCGR = app === "seller" || app === "cgr";
  return {
    selectedProduct: productList[0],
    cart: cart2,
    timeZone: clientList[0].timeZone,
    calendarEnd: product?.calendarEnd ? product.calendarEnd : ownProps.calendarEnd,
    allowSellAndEditPastEvents: pointOfSale?.allowSellAndEditPastEvents,
    openingDate,
    salesGroup: salesGroup && Object.keys(salesGroup).length > 0 ? salesGroup : ownProps.salesGroup,
    availableDates,
    datesPricing,
    showPricing: !!(configurations?.pricesInCalendar && !isSellerOrCGR),
    app,
    productConfigurations
  };
}
const DateSelector$1 = connect(mapStateToProps$b)(DateSelector);
class StepperDayProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: void 0
    };
  }
  getFormattedSelectedDay = index((venue, day) => {
    const { timeZone } = this.props;
    if (!day || !venue) return void 0;
    return getValidDates({
      isOpenDate: venue.openDate,
      isOpenTime: venue.openTime,
      calendarType: venue.validType,
      calendarDate: venue.calendarDate ? parse(venue.calendarDate) : void 0,
      periodStartType: venue.typePeriodStart,
      periodStartValue: venue.periodStart,
      periodEndType: venue.typePeriodEnd,
      periodEndValue: venue.periodEnd,
      defaultStartDate: day,
      defaultEndDate: day,
      timeZone
    });
  });
  setSelected = ({ venue, day }) => {
    if (venue && day) {
      this.setState({
        selectedDate: this.getFormattedSelectedDay(venue, day)
      });
    }
  };
  render() {
    const { children } = this.props;
    const { selectedDate } = this.state;
    return children({
      selectedDate,
      setSelected: this.setSelected
    });
  }
}
var is_afterExports = requireIs_after();
const isAfter = /* @__PURE__ */ getDefaultExportFromCjs(is_afterExports);
const logAndReturn = (fnName, ...rest) => (response) => {
  return response;
};
function CalendarInfoLegend({ id: id2, name, customClass, calendarColor: color }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: `calendar-legend-bullet ${customClass}`, style: { backgroundColor: `#${color}` }, children: " " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: name })
  ] }, `calendar-legend-bullet-${id2}`);
}
const getCalendarInfos = (productInfoList, calendarInfoList) => {
  const calendarInfoMap = getProductInfoMap(productInfoList, "calendar");
  return {
    legend: calendarInfoList.map((calendarInfo, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(CalendarInfoLegend, { ...calendarInfo }, `infolegend-${index2}`)),
    top: calendarInfoMap.top,
    bottom: calendarInfoMap.bottom
  };
};
const isDateInRange = ({ date = /* @__PURE__ */ new Date(), startDatetime, endDatetime } = {}) => logAndReturn("isDateInRange", { date, startDatetime, endDatetime })(
  !!date && (!startDatetime || !endDatetime || isWithinRange(date, startDatetime, endDatetime))
);
class DaySelectorProvider extends Component {
  isOutOfRange = (date) => {
    const { rangeList } = this.props;
    return !rangeList.some(
      (range) => isDateInRange({
        date,
        startDatetime: range.startDate && startOfDay(range.startDate),
        endDatetime: range.endDate && endOfDay(range.endDate)
      })
    );
  };
  getDay = (day) => {
    if (day) return day;
    const { rangeList } = this.props;
    const availableDates = rangeList.map((range) => range.startDate).filter(Boolean).sort(compareAsc).filter((date) => isAfter(date, /* @__PURE__ */ new Date()));
    return availableDates && availableDates[0];
  };
  render() {
    const { isOutOfRange, getDay: getDay2 } = this;
    const { day, rangeList, children } = this.props;
    const showDaySelector = rangeList.some((r) => !!r.showDaySelector);
    return children({
      selectedDay: getDay2(day),
      isOutOfRange,
      showDaySelector
    });
  }
}
var is_same_dayExports = requireIs_same_day();
const isSameDay = /* @__PURE__ */ getDefaultExportFromCjs(is_same_dayExports);
var is_todayExports = requireIs_today();
const isToday = /* @__PURE__ */ getDefaultExportFromCjs(is_todayExports);
function SelectedDay({ selectedDate, timeZone }) {
  const tz = timeZone ?? "UTC";
  const startDate = parseDateWithTimeZone(selectedDate.start, tz);
  const endDate = parseDateWithTimeZone(selectedDate.end, tz);
  if (!startDate || !endDate) return null;
  if (isSameDay(startDate, endDate)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedDate$1, { value: startDate, timeZone: tz });
  }
  if (isToday(startDate)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Desde hoy hasta el", id: "title.selected.date.from-now-until" }),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedDate$1, { value: endDate, timeZone: tz })
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Desde el", id: "title.selected.date.from" }),
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedDate$1, { value: startDate, timeZone: tz }),
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "hasta el", id: "title.selected.date.until" }),
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedDate$1, { value: endDate, timeZone: tz })
  ] });
}
class StepperEventProvider extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      selectedName: void 0
    };
  }
  componentDidUpdate(prevProps, prevState) {
    const { event, intl, timeZone } = this.props;
    const { venueCapacity } = this.state;
    if (!isEmpty(event) && !prevState.selectedName) {
      let selectedName = intl.formatTime(event.startDatetime, {
        hour12: false,
        timeZone
      });
      if (venueCapacity && !venueCapacity.onlyAccessTime && event && event.startDatetime && event.endDatetime) {
        selectedName += ` - ${intl.formatTime(event.endDatetime, {
          hour12: false,
          timeZone
        })}`;
      }
      this.setState({ selectedName });
    }
  }
  setSelected = (selection, numberOfVenues) => {
    if (selection) {
      const { intl, timeZone } = this.props;
      const { venueCapacity, event } = selection;
      let selectedName = "";
      if (venueCapacity && numberOfVenues > 1) {
        selectedName += `${venueCapacity.name} - `;
      }
      if (venueCapacity && venueCapacity.onlyAccessTime && event && event.startDatetime) {
        selectedName += intl.formatTime(event.startDatetime, {
          hour12: false,
          timeZone
        });
      } else if (venueCapacity && !venueCapacity.onlyAccessTime && event && event.startDatetime && event.endDatetime) {
        selectedName += intl.formatTime(event.startDatetime, {
          hour12: false,
          timeZone
        });
        selectedName += ` - ${intl.formatTime(event.endDatetime, {
          hour12: false,
          timeZone
        })}`;
      }
      this.setState({ selectedName, venueCapacity });
    }
  };
  render() {
    const { children } = this.props;
    const { selectedName } = this.state;
    return children({
      selectedName,
      setSelected: this.setSelected
    });
  }
}
const StepperEventProvider$1 = injectIntl(StepperEventProvider);
class EventSelectorProvider extends Component {
  findVenueCapacityBy = index(
    (venueCapacityList, { venueCapacityId }) => venueCapacityList.find((vc) => vc.venueCapacityId === venueCapacityId)
  );
  findEventBy = index((eventList, { eventId }) => {
    if (!eventId) return void 0;
    return eventList.find((e) => e.eventId === eventId);
  });
  filterEventsBy = index((eventList, { venueCapacityId }) => {
    if (!venueCapacityId) return [];
    return eventList.filter((e) => e.venueCapacityId === venueCapacityId);
  });
  getEventList = index((eventList) => {
    const availableEvents = eventList.filter((item) => item?.totalAvailability > 0);
    return availableEvents.map((itemY) => itemY?.venueCapacityId);
  });
  getFirstAvailableVenueIndex = index(
    (venueCapacityList, yFilter) => venueCapacityList.filter((itemX) => yFilter.includes(itemX?.venueCapacityId))
  );
  constructor(props) {
    super(props);
    const { venueCapacityId, eventId } = props;
    this.state = {
      venueCapacityId,
      eventId,
      eventsThreshold: 0
    };
  }
  componentDidMount() {
    this.forceUpdate();
    const { venueCapacityList } = this.props;
    this.onChangeVenueCapacity(venueCapacityList[0].venueCapacityId);
  }
  componentDidUpdate() {
    this.setFirstVenueCapacityIfNotSelected();
  }
  onChangeVenueCapacity = (venueCapacityIdParam) => {
    const {
      venueCapacityId: venueCapacityIdState,
      eventsThreshold: eventsThresholdState,
      maxDisplayAvailability: maxDisplayAvailabilityState
    } = this.state;
    if (venueCapacityIdParam === venueCapacityIdState && eventsThresholdState && maxDisplayAvailabilityState) {
      return;
    }
    const { venueCapacityList: venueCapacityListProp } = this.props;
    const venueCapacity = this.findVenueCapacityBy(venueCapacityListProp, {
      venueCapacityId: venueCapacityIdParam
    });
    if (!venueCapacity) return;
    const {
      eventsThreshold,
      thresholdHighAvailability,
      thresholdMediumAvailability,
      maxDisplayAvailability,
      onlyAccessTime
    } = venueCapacity;
    this.setState({
      venueCapacityId: venueCapacityIdParam,
      eventsThreshold,
      thresholdHighAvailability,
      thresholdMediumAvailability,
      maxDisplayAvailability,
      onlyAccessTime
    });
  };
  autoSelectedEvent = () => {
    const { autoSelectEventList } = this.props;
    const autoSelectEventIndex = autoSelectEventList.findIndex((item) => item.autoSelectEvent === true);
    const allAutoSelectEvents = autoSelectEventList.filter((item) => item.autoSelectEvent === true);
    if (autoSelectEventIndex === 1 && allAutoSelectEvents.length >= 1) {
      setTimeout(() => {
        const firstEventSelectorDiv = document.querySelector(".events-tabs .event-selector");
        if (firstEventSelectorDiv) {
          const buttonInsideEventSelector = firstEventSelectorDiv.querySelector("button");
          if (buttonInsideEventSelector) {
            buttonInsideEventSelector.click();
          }
        }
      }, 1e3);
    }
  };
  onChangeEvent = (eventIdParam) => {
    const { venueCapacityList, eventList, fetchBuyerTypesPrice, salesGroupId, productId, date, onChangeEvent } = this.props;
    const { venueCapacityId, eventId } = this.state;
    venueCapacityList.sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0));
    const venueCapacity = this.findVenueCapacityBy(venueCapacityList, {
      venueCapacityId: venueCapacityId ?? 0
    });
    const event = this.findEventBy(eventList, { eventId: eventIdParam });
    onChangeEvent({ venueCapacity, event });
    if (eventIdParam === eventId) {
      return;
    }
    this.setState({
      eventId: eventIdParam
    });
    this.autoSelectedEvent();
    fetchBuyerTypesPrice({ salesGroupId, productId, date, eventId: eventIdParam });
  };
  setFirstVenueCapacityIfNotSelected = () => {
    const { venueCapacityList, eventList } = this.props;
    const { venueCapacityId, eventsThreshold, maxDisplayAvailability } = this.state;
    const yFilter = this.getEventList(eventList);
    const enabledVenues = this.getFirstAvailableVenueIndex(venueCapacityList, yFilter);
    enabledVenues.sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0));
    const hasSelectedAvailability = enabledVenues.some((venue) => venue.venueCapacityId === venueCapacityId);
    if (!eventList) {
      if (!venueCapacityId && venueCapacityList.length || venueCapacityList[0].eventsThreshold && !eventsThreshold || venueCapacityList[0].maxDisplayAvailability && !maxDisplayAvailability) {
        this.onChangeVenueCapacity(venueCapacityList[0].venueCapacityId);
      }
    } else if (enabledVenues.length > 0 && (!venueCapacityId || enabledVenues[0].eventsThreshold && !eventsThreshold || enabledVenues[0].maxDisplayAvailability && !maxDisplayAvailability)) {
      if (enabledVenues.findIndex((venue) => venue.venueCapacityId === venueCapacityId) > -1) {
        this.onChangeVenueCapacity(venueCapacityId ?? enabledVenues[0].venueCapacityId);
      } else {
        this.onChangeVenueCapacity(enabledVenues[0].venueCapacityId);
      }
    } else if (!hasSelectedAvailability && enabledVenues.length) {
      this.onChangeVenueCapacity(enabledVenues[0].venueCapacityId);
    }
  };
  filterByRanges = (eventList) => {
    const { getRanges: getRanges2, hideDisabledEvents } = this.props;
    const { venueCapacityId } = this.state;
    const rangeList = getRanges2(venueCapacityId);
    const events2 = filterEventWithRanges(eventList, rangeList);
    if (hideDisabledEvents) {
      return events2.filter((event) => event.status === "enabled" && event.totalAvailability > 0);
    }
    return events2;
  };
  render() {
    const { venueCapacityList, eventList, children } = this.props;
    const {
      venueCapacityId,
      eventId,
      eventsThreshold,
      thresholdHighAvailability,
      thresholdMediumAvailability,
      maxDisplayAvailability,
      onlyAccessTime
    } = this.state;
    return children({
      venueCapacityList,
      venueCapacityId,
      onChangeVenueCapacity: this.onChangeVenueCapacity,
      eventsThreshold,
      thresholdHighAvailability,
      thresholdMediumAvailability,
      maxDisplayAvailability,
      onlyAccessTime,
      eventList: this.filterByRanges(this.filterEventsBy(eventList, { venueCapacityId })),
      eventListTotal: eventList,
      eventId,
      onChangeEvent: this.onChangeEvent
    });
  }
}
const mapDispatchToProps$a = (dispatch) => ({
  fetchBuyerTypesPrice: ({ salesGroupId, productId, date, eventId }) => dispatch(
    fetchBuyerTypesWithPrice({ salesGroupId, productId, date, eventId, isNumbered: false })
  )
});
const mapStateToProps$a = (state) => {
  const { pointOfSales, products: products2, cart: cart2 } = state;
  const { configurations } = pointOfSales;
  const { salesGroup, product, date } = cart2;
  const { productList } = products2;
  const autoSelectEventList = productList[0]?.productVenueSet ?? [];
  return {
    hideDisabledEvents: configurations?.hideDisabledEvents,
    autoSelectEventList,
    salesGroupId: salesGroup.salesGroupId,
    productId: product.productId,
    date: dateFnsExports.format(date, DATETIME_FORMAT_YMDHMS)
  };
};
const EventSelectorProvider$1 = connect(mapStateToProps$a, mapDispatchToProps$a)(EventSelectorProvider);
class EventGroupProvider extends Component {
  constructor(props) {
    super(props);
    const { eventGroupId } = this.props;
    this.state = {
      eventGroupId
    };
  }
  componentDidUpdate() {
    const { eventList, threshold } = this.props;
    const { eventGroupId } = this.state;
    const eventGroupList = this.getEventGroupList(eventList, threshold);
    if (!eventGroupId && eventGroupList.length) {
      this.onChangeEventGroup(eventGroupList[0].eventGroupId);
    }
  }
  getEventGroupList = index(getEventGroupList);
  onChangeEventGroup = (eventGroupIdParam) => {
    const { eventGroupId } = this.state;
    if (eventGroupIdParam === eventGroupId) {
      return;
    }
    this.setState({
      eventGroupId: eventGroupIdParam
    });
  };
  render() {
    const { props, state, onChangeEventGroup, getEventGroupList: getEventGroupList2 } = this;
    const { eventList, eventId, onChangeEvent, threshold, children } = props;
    const eventGroupList = getEventGroupList2(eventList, threshold);
    const { eventGroupId } = state;
    let events2 = [];
    if (eventGroupId) {
      const eventGroup = eventGroupList.find((eg) => eg.eventGroupId === eventGroupId);
      if (eventGroup) {
        events2 = eventGroup.events;
      }
    }
    return children({
      eventGroupList,
      eventGroupId,
      onChangeEventGroup,
      eventListGrouped: events2,
      eventId,
      onChangeEvent
    });
  }
}
function HtmlMessage({ children }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "span",
    {
      dangerouslySetInnerHTML: {
        __html: children
      }
    }
  );
}
function PanelHeader({ children }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel-body-header", children });
}
function PanelContent({ children }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel-body-content", children });
}
class VenueBlockEventSelectorContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      day: void 0,
      venueCapacity: void 0,
      event: void 0,
      hourSelected: void 0,
      initAutoSelect: false
    };
  }
  componentDidUpdate(prevProps) {
    const {
      venue,
      showEvents,
      eventListFromState,
      handleFetchBuyerTypesWithPrice,
      product,
      salesGroupId,
      numberOfVenues,
      previousSelectedList,
      index: index2,
      app,
      availableDates,
      eventList,
      shouldAutoSelectEvent,
      isCgrAutoSelectEvent,
      isAutoSelectEvent
    } = this.props;
    const {
      eventListFromState: prevEventListFromState,
      isCgrAutoSelectEvent: prevIsCgr,
      isAutoSelectEvent: prevIsAutoSelect
    } = prevProps;
    const { event, initAutoSelect } = this.state;
    const showEventsTmp = venue.showEvents === false ? false : showEvents;
    const venueCapacityList = venue.venueCapacityList ?? [];
    if (eventListFromState && eventListFromState.length === 1 && eventListFromState !== prevEventListFromState && numberOfVenues > 1 && !!Object.keys(previousSelectedList).length && !showEventsTmp) {
      const { startDatetime } = eventListFromState[0];
      let hour;
      try {
        hour = Number(startDatetime.slice(startDatetime.search("T") + 1, startDatetime.search(":")));
      } catch {
        console.log("Error setting hour 0");
      }
      if (hour === 0) {
        this.onChangeEvent({
          venueCapacity: venueCapacityList[0],
          event: eventListFromState[0]
        });
      }
    }
    const query2 = queryString.parse(window.location.search);
    if (query2.autoEventId && query2.date) {
      if (!isEmpty(eventListFromState) && !_isEqual(prevEventListFromState, eventListFromState)) {
        const selectedEvent = eventListFromState.find((eventFind) => eventFind.eventId === Number(query2.autoEventId));
        if (!isEmpty(selectedEvent) && !_isEqual(selectedEvent, event) && isEmpty(event)) {
          this.onChangeEvent({
            venueCapacity: venueCapacityList[0],
            event: selectedEvent
          });
          handleFetchBuyerTypesWithPrice({
            salesGroupId,
            productId: product?.productId,
            date: query2.date,
            eventId: selectedEvent.eventId
          });
        }
      }
    }
    if (Object.keys(availableDates).length && eventList.length && shouldAutoSelectEvent && initAutoSelect) {
      if ((app === "cgr" || app === "seller") && prevIsCgr && !isCgrAutoSelectEvent) {
        this.autoSelectEvent();
      } else if (prevIsAutoSelect && !isAutoSelectEvent) {
        this.autoSelectEvent();
      }
    }
  }
  getRanges = index(
    (index2, venue, previousSelectedList, getRangesFn, disableEventsBeforeSelection) => getRangesFn(index2, venue, previousSelectedList, disableEventsBeforeSelection)
  );
  onChangeDay = (dayParam) => {
    const {
      onChangeDay,
      showEvents,
      goToNextStep,
      showCalendar,
      dispatch,
      venue,
      salesGroupId,
      product,
      handleFetchBuyerTypesWithPrice
    } = this.props;
    const { day } = this.state;
    if (dayParam) {
      this.setState({ initAutoSelect: true });
    }
    const { venueId } = venue;
    onChangeDay(dayParam, venue);
    if (dayParam !== day) {
      this.setState({ day: dayParam });
    }
    const showEventsTmp = venue.showEvents === false ? false : showEvents;
    const date = dayParam;
    if (!showEventsTmp && showCalendar) {
      dispatch(
        onChangeDate({
          date,
          salesGroupId,
          productId: product?.productId,
          venueId,
          product
        })
      );
      if (!product?.showEvents) {
        handleFetchBuyerTypesWithPrice({
          salesGroupId,
          productId: product?.productId,
          date
        });
      }
      goToNextStep();
    }
  };
  autoSelectEvent = () => {
    const { venue, eventList, autoSelectEventList } = this.props;
    const autoSelectEventIndex = autoSelectEventList.findIndex((item) => item.autoSelectEvent === true);
    const allAutoSelectEvents = autoSelectEventList.filter((item) => item.autoSelectEvent === true);
    const selectedEvent = venue && venue.venueCapacityList[0];
    const selection = {
      venueCapacity: selectedEvent,
      event: eventList[0]
    };
    if (autoSelectEventIndex !== -1) {
      if (autoSelectEventIndex === 0 && allAutoSelectEvents.length === 1) {
        this.onChangeEvent(selection);
      } else if (autoSelectEventIndex === 0 && allAutoSelectEvents.length === 2) {
        setTimeout(() => {
          const firstEventSelectorDiv = document.querySelector(".events-tabs .event-selector");
          if (firstEventSelectorDiv) {
            const buttonInsideEventSelector = firstEventSelectorDiv.querySelector("button");
            if (buttonInsideEventSelector) {
              buttonInsideEventSelector.click();
            }
          }
        }, 2500);
      }
    }
  };
  onChangeEvent = (selection) => {
    const { onChangeEvent } = this.props;
    const { venueCapacity: venueCapacityState, event: eventState } = this.state;
    onChangeEvent({ ...this.state, ...selection });
    const { venueCapacity, event } = selection;
    if (venueCapacity !== venueCapacityState || event !== eventState) {
      this.setState(selection);
    }
  };
  render() {
    const {
      mod = 0,
      index: index2,
      venue,
      previousSelectedList,
      DaySelectorStep: DaySelectorStep2,
      DateSelector: DateSelector2,
      EventSelectorStep: EventSelectorStep2,
      eventProps = {},
      stepProps = {},
      productConfigurations,
      venueCapacityId,
      EventListProvider: EventListProvider2,
      eventId,
      getRanges: getRanges2,
      showCalendar,
      showEvents,
      numberOfVenues,
      eventsFetching,
      days,
      cart: cart2,
      calendarInfos,
      productInfoList = [],
      ignoreSold,
      timeZone,
      showAvailabilityFilter = false,
      showRealAvailability = false,
      currency
    } = this.props;
    const { text, showEventName, infoMessage } = eventProps;
    const { venueId, venueCapacityList = [], dateHeader, timeHeader, userInfoCalendar } = venue;
    let { userInfo } = venue;
    const disableEventsBeforeSelection = getProductConfigurationMap(
      productConfigurations,
      "disableEventsBeforeSelection"
    );
    const disableEventsBeforeSelectionValue = disableEventsBeforeSelection && disableEventsBeforeSelection[0] ? disableEventsBeforeSelection[0].configValue === "true" : false;
    const productInfoByVenue = productInfoList && productInfoList.filter(
      (info) => info.venueIds && info.venueIds.includes(venueId)
    );
    const productInfo = productInfoByVenue && getCalendarInfos(
      productInfoByVenue,
      Object.values(calendarInfos)
    );
    const eventProductInfo = productInfoByVenue && getProductInfoMap(productInfoByVenue, "sessions");
    userInfo = userInfo || infoMessage;
    const getRangesByVenue = this.getRanges(
      index2,
      venue,
      previousSelectedList,
      getRanges2,
      disableEventsBeforeSelectionValue
    );
    const { day, event } = this.state;
    const showEventsTmp = venue.showEvents === false ? false : showEvents;
    const showDaySelector = getRangesByVenue().some((r) => !!r.showDaySelector);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DaySelectorProvider,
        {
          rangeList: getRangesByVenue(),
          day,
          children: (({
            isOutOfRange,
            showDaySelector: showDay
          }) => {
            if (showCalendar && showDay) {
              const stepDay = 0 + mod - (!showEvents && index2 !== 0 ? 1 : 0);
              const stepDayKey = `step-day-selector-venue-${venueId}-${stepDay}`;
              return /* @__PURE__ */ jsxRuntimeExports.jsx(StepperDayProvider, { timeZone, children: (({
                selectedDate,
                setSelected
              }) => /* @__PURE__ */ createElement$2(
                DaySelectorStep2,
                {
                  ...stepProps,
                  key: stepDayKey,
                  step: stepDay,
                  venueId,
                  selected: selectedDate && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    SelectedDay,
                    {
                      selectedDate,
                      timeZone
                    }
                  ),
                  dateHeader
                },
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  DateSelector2,
                  {
                    cart: cart2,
                    onChangeDay: ((dayParam) => {
                      setSelected({ venue, day: dayParam });
                      this.onChangeDay(moment.tz(dayParam, timeZone).format(DATE_FORMAT_YMD));
                    }),
                    days,
                    venueId,
                    productInfo,
                    isOutOfRange,
                    showCalendar,
                    userInfoCalendar,
                    showAvailabilityFilter,
                    timeZone,
                    blockNoAvailability: true
                  }
                )
              )) });
            }
            return null;
          })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StepperEventProvider$1, { event, timeZone, children: (({
        selectedName,
        setSelected
      }) => {
        if (showEventsTmp) {
          const stepEvent = 1 + mod - (!showCalendar || !showDaySelector ? 1 : 0);
          const stepEventKey = `step-event-selector-venue-${venueId}-${stepEvent}`;
          return /* @__PURE__ */ createElement$2(
            EventSelectorStep2,
            {
              ...stepProps,
              key: stepEventKey,
              step: stepEvent,
              venueId,
              selected: selectedName,
              timeHeader
            },
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              EventListProvider2,
              {
                venueId,
                day: showDaySelector ? day : previousSelectedList[index2 - 1]?.day,
                children: (({ eventList: evListParam = [] }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(PanelContent, { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(PanelHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlMessage, { children: userInfo ?? "" }) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    EventSelectorProvider$1,
                    {
                      getRanges: getRangesByVenue,
                      onChangeEvent: (selection) => {
                        setSelected(selection, numberOfVenues);
                        this.onChangeEvent(selection);
                      },
                      venueCapacityList,
                      venueCapacityId,
                      eventList: evListParam,
                      eventId,
                      children: (({
                        venueCapacityList: venueCapacityListParam,
                        venueCapacityId: venueCapacityIdParam,
                        onChangeVenueCapacity,
                        eventsThreshold,
                        thresholdHighAvailability,
                        thresholdMediumAvailability,
                        onlyAccessTime,
                        maxDisplayAvailability,
                        eventList: eventListParam,
                        eventListTotal,
                        eventId: eventIdParam,
                        onChangeEvent
                      }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                        eventProductInfo?.top,
                        /* @__PURE__ */ jsxRuntimeExports.jsx(
                          VenueCapacityProvider,
                          {
                            venueCapacityList: venueCapacityListParam,
                            venueCapacityId: venueCapacityIdParam,
                            onChangeVenueCapacity,
                            eventListTotal,
                            children: (({
                              options,
                              selected,
                              handleSelect
                            }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                              VenueCapacitySelector,
                              {
                                options,
                                selected,
                                handleSelect
                              }
                            ))
                          }
                        ),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(
                          EventGroupProvider,
                          {
                            onChangeEvent,
                            eventList: eventListParam,
                            eventId: eventIdParam,
                            threshold: eventsThreshold,
                            children: (({
                              eventGroupList,
                              eventGroupId,
                              onChangeEventGroup,
                              eventListGrouped,
                              eventId: eventIdSelected,
                              onChangeEvent: onChangeEventParam
                            }) => eventsFetching ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "loading" }) }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                              /* @__PURE__ */ jsxRuntimeExports.jsx(
                                EventGroupSelector,
                                {
                                  eventGroupList,
                                  handleSelect: onChangeEventGroup,
                                  selected: eventGroupId
                                }
                              ),
                              /* @__PURE__ */ jsxRuntimeExports.jsx(
                                EventSelector,
                                {
                                  cartEvents: cart2 && cart2.events,
                                  index: index2,
                                  ignoreSold,
                                  text,
                                  showEventName,
                                  eventList: eventListGrouped,
                                  handleSelect: onChangeEventParam,
                                  selected: eventIdSelected,
                                  onlyAccessTime,
                                  thresholdHighAvailability,
                                  thresholdMediumAvailability,
                                  maxDisplayAvailability,
                                  showRealAvailability,
                                  checkDisabled: ({
                                    totalAvailability,
                                    status
                                  }) => totalAvailability <= 0 || status === "disabled",
                                  currency
                                }
                              )
                            ] }))
                          }
                        ),
                        eventProductInfo?.bottom
                      ] }))
                    }
                  )
                ] }))
              }
            )
          );
        }
        return null;
      }) })
    ] });
  }
}
const mapDispatchToProps$9 = (dispatch) => ({
  handleFetchBuyerTypesWithPrice: ({ salesGroupId, productId, date, eventId }) => dispatch(
    fetchBuyerTypesWithPrice({ salesGroupId, productId, date, eventId, isNumbered: false })
  ),
  dispatch
});
const mapStateToProps$9 = (state) => {
  const { events: events2, products: products2, cart: cart2, pointOfSales } = state;
  const { productInfoList, productConfigurations, productList } = products2;
  const { calendarInfoMap = {}, eventList } = events2;
  const { calendarInfos = {} } = calendarInfoMap ?? {};
  const { clientList } = pointOfSales ?? { clientList: [] };
  const productVenueSet = productList && productList[0]?.productVenueSet;
  const autoSelectEvent2 = productVenueSet && productVenueSet[0]?.autoSelectEvent;
  const autoSelectEventList = productVenueSet ? [...productVenueSet].sort(
    (a, b) => (a.venue?.displayOrder ?? 0) - (b.venue?.displayOrder ?? 0)
  ) : [];
  return {
    timeZone: clientList[0]?.timeZone ?? "Europe/Madrid",
    currency: clientList[0]?.currencyList?.[0]?.isoCode ?? "",
    eventsFetching: events2.isFetching,
    productInfoList: productInfoList ?? [],
    productConfigurations: productConfigurations ?? [],
    eventListFromState: eventList,
    days: getModDays(state),
    calendarInfos,
    cart: cart2,
    autoSelectEvent: autoSelectEvent2 ?? void 0,
    autoSelectEventList,
    eventList,
    isAutoSelectEvent: events2.isCGRAutoSelectEvent,
    availableDates: events2.availableDates,
    shouldAutoSelectEvent: state.autoSelect?.shouldAutoSelectEvent,
    isCgrAutoSelectEvent: events2.isCGRAutoSelectEvent
  };
};
const VenueBlockEventSelectorContainer$1 = connect(mapStateToProps$9, mapDispatchToProps$9)(VenueBlockEventSelectorContainer);
function DaySelectorStep(props) {
  const { dateHeader, venueId, ...panelProps } = props;
  let titleCalendar;
  let titleEditableCalendar;
  if (!dateHeader) {
    titleCalendar = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "¿Cuándo quieres venir?", id: "title.date" });
    titleEditableCalendar = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedHTMLMessage, { defaultMessage: "Tu <strong>fecha</strong> seleccionada", id: "title.editable.date" });
  } else {
    const dateHeaderText = dateHeader.replace(/<.+?>/g, "");
    const calendarSpan = /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: dateHeaderText } });
    titleCalendar = calendarSpan;
    titleEditableCalendar = calendarSpan;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FrontendMainPanel$1,
    {
      icon: "icon-own-date_range",
      className: `calendar-${venueId}`,
      title: titleCalendar,
      titleEditable: titleEditableCalendar,
      ...panelProps
    }
  );
}
function EventSelectorStep(props) {
  const { timeHeader, venueId, ...panelProps } = props;
  let titleEvent;
  let titleEditableEvent;
  if (!timeHeader) {
    titleEvent = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "¿A qué hora?", id: "title.events" });
    titleEditableEvent = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedHTMLMessage, { defaultMessage: "Tu <strong>hora</strong> seleccionada", id: "title.editable.events" });
  } else {
    const timeHeaderText = timeHeader.replace(/<.+?>/g, "");
    const eventTitleSpan = /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: timeHeaderText } });
    titleEvent = eventTitleSpan;
    titleEditableEvent = eventTitleSpan;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FrontendMainPanel$1,
    {
      icon: "icon-own-schedule",
      className: `events-${venueId}`,
      title: titleEvent,
      titleEditable: titleEditableEvent,
      stepEcommerce: "select-hour",
      ...panelProps
    }
  );
}
class EventListProvider extends Component {
  memoizedGetEvents = index((props) => {
    const { salesGroupId, productId, timeZone, venueId, day, getEvents } = props;
    if (salesGroupId && productId && timeZone && venueId && day) {
      getEvents({ salesGroupId, productId, timeZone, venueId, day });
    }
  });
  componentDidMount() {
    this.memoizedGetEvents(this.props);
  }
  componentDidUpdate(prevProps) {
    const { salesGroupId, productId, timeZone, venueId, day } = this.props;
    if (prevProps.salesGroupId !== salesGroupId || prevProps.productId !== productId || prevProps.timeZone !== timeZone || prevProps.venueId !== venueId || prevProps.day !== day) {
      this.memoizedGetEvents(this.props);
    }
  }
  render() {
    const { children, eventList } = this.props;
    return children({
      eventList,
      getEvents: this.memoizedGetEvents
    });
  }
}
const mapStateToProps$8 = (state) => ({
  eventList: getEventsWithPromotionFlag(state)
});
const mapDispatchToProps$8 = (dispatch) => ({
  getEvents: ({ salesGroupId, productId, timeZone, venueId, day: date }) => {
    dispatch(
      onChangeDate({ date, salesGroupId, productId, venueId, timeZone })
    );
  }
});
const EventListProvider$1 = connect(mapStateToProps$8, mapDispatchToProps$8)(EventListProvider);
class EventListSelectorContainer extends Component {
  static getRanges = (index2, venue, previousSelectedList) => getRanges(
    index2,
    venue,
    previousSelectedList
  );
  sortByDisplayOrder = index(
    (venueList) => venueList.sort((a, b) => a.viewDisplayOrder - b.viewDisplayOrder)
  );
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    const { venueList } = this.props;
    const { activeStep } = this.state;
    return nextState.activeStep !== activeStep || nextProps.venueList !== venueList;
  }
  componentWillUnmount() {
    const { calendarPricesClean } = this.props;
    calendarPricesClean();
  }
  callViewSection = (section, params) => {
    const { productConfigurations } = this.props;
    viewSection({
      section,
      productInfo: params.productInfo,
      timeZone: params.timeZone || "",
      dateCart: params.dateCart,
      dateCartSecond: params.dateCartSecond
    });
  };
  sendHoursEvents = (selectEvent) => {
    const { venueList, product, timeZone } = this.props;
    const venuesId = this.sortByDisplayOrder(venueList).map((item) => item.venueId);
    const isCasaBatllo2 = () => window.pos && window.pos.name === "CasaBatllo";
    const stateWithoutActiveStep = { ...this.state };
    delete stateWithoutActiveStep.activeStep;
    const firstVenueHour = Object.values(stateWithoutActiveStep).find(
      (entry) => entry?.venue?.viewDisplayOrder === 0
    );
    const firstVenueStartDatetime = firstVenueHour?.event?.startDatetime;
    if (!selectEvent?.event?.venueId) return null;
    const { venueId, startDatetime } = selectEvent.event;
    if (!isCasaBatllo2() && isProviderEnabled("ga4")) {
      if (venueId === venuesId[0]) {
        this.callViewSection("select-hour", {
          productInfo: product,
          timeZone,
          dateCart: startDatetime
        });
      } else if (venueId === venuesId[1]) {
        this.callViewSection("select_second_hour", {
          productInfo: product,
          timeZone,
          dateCart: firstVenueStartDatetime,
          dateCartSecond: startDatetime
        });
      }
    }
    return null;
  };
  sendDaysEvents = (day, venue) => {
    const { venueList, product, timeZone } = this.props;
    const isCasaBatllo2 = () => window.pos && window.pos.name === "CasaBatllo";
    const venuesId = this.sortByDisplayOrder(venueList).map((item) => item.venueId);
    const stateWithoutActiveStep = { ...this.state };
    delete stateWithoutActiveStep.activeStep;
    const firstVenueHour = Object.values(stateWithoutActiveStep).find(
      (entry) => entry?.venue?.viewDisplayOrder === 0
    );
    const firstVenueStartDatetime = firstVenueHour?.event?.startDatetime;
    if (!venue?.venueId) return null;
    const { venueId } = venue;
    if (!isCasaBatllo2() && isProviderEnabled("ga4")) {
      if (venueId === venuesId[0]) {
        this.callViewSection("select-day", {
          productInfo: product,
          timeZone,
          dateCart: day
        });
      } else if (venueId === venuesId[1]) {
        this.callViewSection("select_second_day", {
          productInfo: product,
          timeZone,
          dateCart: firstVenueStartDatetime,
          dateCartSecond: day
        });
      }
    } else if (isCasaBatllo2()) {
      this.callViewSection("select-hour", {
        productInfo: product,
        timeZone,
        dateCart: day
      });
    }
    return null;
  };
  goToStep = (activeStep) => {
    const { step, handleSelect } = this.props;
    handleSelect(step);
    this.setState({ activeStep });
  };
  nextStep = () => {
    const { calendarPricesClean } = this.props;
    this.setState(
      (state) => ({ activeStep: state.activeStep + 1 }),
      () => calendarPricesClean()
    );
  };
  updateVenueSelection = (vIndex, selection = {}) => {
    const { handleSelection, venueList } = this.props;
    this.setState(
      (prevState) => ({
        [vIndex]: {
          ...prevState[vIndex] || {},
          ...selection
        }
      }),
      () => {
        if (vIndex === venueList.length - 1) {
          const stateWithoutActiveStep = { ...this.state };
          delete stateWithoutActiveStep.activeStep;
          handleSelection(Object.values(stateWithoutActiveStep).map((entry) => entry.event));
        }
      }
    );
  };
  WrappedDateSelector = (props) => {
    const { calendarProps, showAvailabilityFilter = false, app } = this.props;
    const DS = DateSelector$1;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DS, { ...calendarProps, ...props, showAvailabilityFilter, app });
  };
  WrappedEventListProvider = (props) => {
    const { product, salesGroupId, timeZone } = this.props;
    const { activeStep } = this.state;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      EventListProvider$1,
      {
        ...props,
        productId: product?.productId,
        salesGroupId,
        activeStep,
        venueId: props.venueId,
        timeZone
      }
    );
  };
  render() {
    const { goToStep, nextStep, updateVenueSelection, WrappedDateSelector, WrappedEventListProvider } = this;
    const {
      venueList,
      eventProps = {},
      goToNextStep,
      salesGroupId,
      product,
      showRealAvailability = false,
      app,
      fetchProductServices: fetchProductServices2,
      timeZone
    } = this.props;
    const fetchServices = (eventDatetime) => fetchProductServices2({
      salesGroupId,
      productId: product.productId,
      purchaseDatetime: (/* @__PURE__ */ new Date()).toISOString(),
      eventDatetime
    });
    const { productId, showCalendar, showEvents, ignoreSold } = product;
    const stateSlices = Object.values(this.state);
    const { activeStep, stepProvider, ...state } = this.state;
    const sortedVenueList = this.sortByDisplayOrder(venueList);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: sortedVenueList.map((venue, index2) => {
      const { venueId, name } = venue;
      const v2Selection = stateSlices[index2] || {};
      const venueShowsEvents = venue.showEvents === false ? false : showEvents;
      const stepProps = {
        mainTitle: venueList.length > 1 && `<strong>${name}: </strong>`,
        activeStep,
        goToStep
      };
      const venueBlockProps = {
        productId,
        salesGroupId,
        venueCapacityId: v2Selection.venueCapacity?.venueCapacityId,
        eventId: v2Selection.event?.eventId,
        index: index2,
        venue,
        venueId,
        showRealAvailability,
        previousSelectedList: Object.values(
          state
        ),
        stepProps,
        DaySelectorStep,
        DateSelector: WrappedDateSelector,
        onChangeDay: (day, venueParam) => {
          this.sendDaysEvents(day, venueParam);
          if (index2 === 0 && !venueShowsEvents && day) {
            fetchServices(toUtcIsoString(day, timeZone));
          }
          nextStep();
        },
        EventSelectorStep,
        eventProps,
        EventListProvider: WrappedEventListProvider,
        onChangeEvent: (selection) => {
          const venueWithoutVenueCapacityList = { ...venue };
          delete venueWithoutVenueCapacityList.venueCapacityList;
          updateVenueSelection(index2, {
            ...selection,
            venue: venueWithoutVenueCapacityList
          });
          this.sendHoursEvents(selection);
          if (index2 === 0 && selection.event?.startDatetime) {
            fetchServices(
              toUtcIsoString(String(selection.event.startDatetime), timeZone)
            );
          }
          nextStep();
        },
        getRanges: EventListSelectorContainer.getRanges,
        showCalendar,
        showEvents,
        numberOfVenues: venueList.length,
        goToNextStep,
        ignoreSold,
        product
      };
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        VenueBlockEventSelectorContainer$1,
        {
          mod: index2 % venueList.length + index2,
          app,
          ...venueBlockProps
        },
        `venue-block-selector-${index2}`
      );
    }) });
  }
}
function mapStateToProps$7(state) {
  const { productConfigurations } = state.products;
  return {
    productConfigurations
  };
}
function mapDispatchToProps$7(dispatch) {
  return {
    fetchProductServices: (args) => dispatch(fetchProductServices(args))
  };
}
const EventListSelectorContainer$1 = connect(mapStateToProps$7, mapDispatchToProps$7)(EventListSelectorContainer);
const selectMessages = defineMessages({
  messagePickADate: {
    id: "singledatepicker.select",
    defaultMessage: "Pick a date"
  },
  messageSchedule: {
    id: "event.header.text",
    defaultMessage: "Select a schedule"
  }
});
class LinkedEventListSelector extends Component {
  constructor(props) {
    super(props);
    this.onChangeMonth = this.onChangeMonth.bind(this);
    this.handleEventSelection = this.handleEventSelection.bind(this);
    this.goToNextStep = this.goToNextStep.bind(this);
    initMomentLocale(getAppLocale());
  }
  shouldComponentUpdate(nextProps) {
    const { eventList } = nextProps;
    const { eventList: prevEventList } = this.props;
    return !!(prevEventList && prevEventList.length !== eventList.length);
  }
  handleEventSelection(newEventSelectedList) {
    const { step, onChangeEvents: onChangeEvents2, venueList, handleSelect } = this.props;
    if (newEventSelectedList && newEventSelectedList.length === venueList.length) {
      onChangeEvents2({ eventList: newEventSelectedList });
      handleSelect(step + 1);
    }
  }
  onChangeMonth(paramsAvailability) {
    const { fetchEventsAvailability: fetchEventsAvailability2, salesGroupId, productId, showPricing, datesPricing } = this.props;
    fetchEventsAvailability2({
      salesGroupId,
      productId,
      params: paramsAvailability,
      showPricing,
      datesPricing
    });
  }
  goToNextStep() {
    const { step, handleSelect } = this.props;
    handleSelect(step + 1);
  }
  render() {
    const {
      intl,
      step,
      handleSelect,
      salesGroupId,
      productId,
      timeZone,
      calendarProps,
      venueList,
      showEventName,
      eventList,
      product,
      showAvailabilityFilter = false,
      showRealAvailability = false,
      app,
      promotionSelected,
      calendarPricesClean
    } = this.props;
    if (!salesGroupId || !productId) return null;
    const { weekDays, startDate, endDate, selectedDate, disabledDates, minTickets, maxTickets } = calendarProps;
    const locale = getAppLocale();
    const { displayFormat } = getCalendarLocaleConfig(locale);
    const selectMessage = intl.formatMessage(selectMessages.messagePickADate);
    const defaultMessage = intl.formatMessage(selectMessages.messageSchedule);
    const calendarPropsTmp = {
      locale,
      headerText: selectMessage,
      onChangeMonth: this.onChangeMonth,
      displayFormat,
      weekDays,
      startDate,
      endDate,
      selectedDate,
      disabledDates,
      minTickets,
      maxTickets
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      EventListSelectorContainer$1,
      {
        salesGroupId,
        product,
        step,
        handleSelect,
        calendarProps: calendarPropsTmp,
        calendarPricesClean,
        eventProps: {
          infoMessage: defaultMessage,
          showEventName,
          showSelector: true
        },
        eventList,
        venueList,
        timeZone,
        handleSelection: this.handleEventSelection,
        goToNextStep: this.goToNextStep,
        showAvailabilityFilter,
        showRealAvailability,
        promotionSelected,
        app
      }
    );
  }
}
const mapStateToProps$6 = (state, ownProps) => {
  const { cart: cart2, products: products2, pointOfSales, events: events2 } = state;
  const { venueList = [], productInfoList, promotionSelected } = products2;
  const { clientList, configurations } = pointOfSales;
  const { salesGroup, product, date } = cart2;
  const { salesGroupId, calendarType, openingDate, numPeriods, periodType } = salesGroup;
  const { productId, weekDays, calendarStart, calendarEnd, showCalendar, showEvents, disabledDates } = product;
  const { app } = ownProps;
  let { minNumDays } = product;
  const sgMinNumDays = salesGroup.minNumDays;
  if (sgMinNumDays && sgMinNumDays > (minNumDays || 0)) minNumDays = sgMinNumDays;
  const { calendarInfoMap = {}, eventList, datesPricing } = events2;
  const { calendarInfos = {} } = calendarInfoMap;
  const now = getNowDate(clientList[0].timeZone).format("MM/DD/YYYY").toString();
  const startDate = EventUtils.getStartDate({ calendarStart, now, minNumDays });
  const { minTickets, maxTickets } = getTicketsRange(state);
  const isSellerOrCGR = app === "seller" || app === "cgr";
  return {
    showCalendar,
    showEvents,
    showPricing: configurations?.pricesInCalendar && !isSellerOrCGR,
    calendarProps: {
      selectedDate: max(date, startDate),
      disabledDates,
      cart: cart2,
      productInfoList,
      weekDays,
      startDate: startOfDay(startDate),
      endDate: EventUtils.getEndDate({
        calendarType,
        openingDate: calendarEnd ? min(parse(calendarEnd), parse(openingDate)) : openingDate,
        numPeriods,
        periodType,
        calendarEnd,
        now
      }),
      calendarInfoList: Object.values(calendarInfos),
      minTickets: minTickets ?? 0,
      maxTickets: maxTickets ?? 0
    },
    datesPricing,
    productId,
    product,
    salesGroupId,
    timeZone: clientList[0].timeZone,
    eventSelectedList: cart2.events,
    venueList: venueList ?? [],
    eventList,
    showEventName: !!(configurations && configurations.showEventNameNotSpecial),
    promotionSelected
  };
};
const mapDispatchToProps$6 = (dispatch) => ({
  onChangeEvents: ({ eventList = [] }) => {
    dispatch(onChangeEvents({ eventList }));
  },
  calendarPricesClean: () => dispatch(cleanCalendarPricing()),
  fetchEventsAvailability: ({ salesGroupId, productId, params, showPricing = false, datesPricing = {} }) => {
    const promises = [
      dispatch(fetchCalendarInfo({ salesGroupId, productId, ...params }))
    ];
    return dispatch(
      fetchEventsAvailability(salesGroupId, productId, params)
    ).then(({ response: dateStatusMap }) => {
      const { year, month } = params;
      const isMonthPricingCached = EventUtils.hasPricingForMonth(
        datesPricing,
        year,
        month
      );
      if (dateStatusMap && showPricing && !isMonthPricingCached) {
        const { startDate, endDate } = EventUtils.getAvailableDateRange(
          dateStatusMap
        );
        if (startDate && endDate)
          promises.push(
            dispatch(fetchCalendarPricing(salesGroupId, productId, startDate, endDate))
          );
      }
      return Promise.all(promises);
    });
  }
});
const LinkedEventListSelector$1 = injectIntl(connect(mapStateToProps$6, mapDispatchToProps$6)(LinkedEventListSelector));
const NAME_REGEX = /^[A-Za-záéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛñÑçÇãÃõÕªº.\s,'-]+$/;
const COMPANY_REGEX = /^[0-9A-Za-záéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛñÑçÇãÃõÕªº^,]+((\s)?(('|&|-.|,|\^)?([0-9A-Za-záéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛñÑçÇãÃõÕªº])+((\s)?(\.)?)+))*$/;
const SPECIAL_CHARACTERS_REGEX = /^[A-Za-záéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛñÑçÇãÃõÕ0-9\s-]+$/;
const DOCUMENT_NUMBER_REGEX = /^[A-Za-záéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛñÑçÇãÃõÕ0-9\s]+$/;
const PROVINCE_REGEX = /^[A-Za-záéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛñÑçÇãÃõÕ'/0-9\s-^]+$/;
const ADDRESS_REGEX = /^[A-Za-záéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛñÑçÇãÃõÕ,.'ªº/0-9\s-^]+$/;
const CITY_REGEX = /^[A-Za-záéíóúÁÉÍÓÚäëïöüÄËÏÖÜÿŸàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛñÑçÇãÃõÕ'’0-9\s-]+$/;
const POSTAL_CODE_REGEX = /^[0-9]{5}$/i;
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*\d)(?=.*[@#$%_()&?¿+\-¡!*])(?=.*[A-Z]).{8,16}$/;
const FLOAT_REGEX = /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/;
const EMAIL_REGEX = /^[A-Za-z0-9_+-]+(?:\.[A-Za-z0-9_+-]+)*@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/;
const regexValidator = {
  FirstNameValidator: (value) => !!value && NAME_REGEX.test(value),
  CompanyValidator: (value) => !!value && COMPANY_REGEX.test(value),
  SpecialCharactersValidator: (value) => !!value && SPECIAL_CHARACTERS_REGEX.test(value),
  DocumentNumberValidator: (value) => !!value && DOCUMENT_NUMBER_REGEX.test(value),
  ProvinceValidator: (value) => !!value && PROVINCE_REGEX.test(value),
  AddressValidator: (value) => !!value && ADDRESS_REGEX.test(value),
  PostalCodeValidator: (value) => !!value && POSTAL_CODE_REGEX.test(value),
  CityValidator: (value) => !!value && CITY_REGEX.test(value),
  PasswordValidator: (value) => !!value && PASSWORD_REGEX.test(value),
  FloatValidator: (value) => !!value && FLOAT_REGEX.test(value),
  EmailValidator: (value) => !!value && EMAIL_REGEX.test(value)
};
const getFloatingLabelStyle = (hasValue) => hasValue ? {
  display: "block",
  position: "absolute",
  top: "-10px",
  left: "5px",
  zIndex: 4,
  backgroundColor: "#fff",
  padding: "0 10px",
  transition: "color 0.2s, top 0.2s, left 0.2s"
} : void 0;
const LOYALTY_FIELD_TO_STATE_KEY = {
  first_name: "firstName",
  last_name: "lastName",
  telephone: "telephone",
  email: "email",
  birth_date: "birthDate",
  vat_number: "vatNumber",
  postal_code: "postalCode",
  city: "city",
  gender: "gender"
};
class MembershipFormWrapper extends Component {
  dateRawInputs = {};
  constructor(props) {
    super(props);
    this.state = {
      formsData: {},
      dateFocused: {}
    };
  }
  componentDidUpdate(prevProps) {
    const { ticketsArray } = this.props;
    const prevLength = prevProps.ticketsArray.length;
    const currentLength = ticketsArray.length;
    if (prevLength === currentLength) return;
    if (currentLength === 1) {
      this.tryAutoSelectPrimaryUser();
    }
    if (currentLength > 1) {
      this.setState((prevState) => {
        const newFormsData = { ...prevState.formsData };
        Object.keys(newFormsData).forEach((key) => {
          const k = Number(key);
          if (newFormsData[k]?.primaryUser) {
            newFormsData[k] = {
              ...newFormsData[k],
              primaryUser: false
            };
          }
        });
        return { formsData: newFormsData };
      }, this.updateMembershipForms);
    }
  }
  tryAutoSelectPrimaryUser = () => {
    const { ticketsArray, loyaltyForms, loyaltyProgramId } = this.props;
    const { formsData } = this.state;
    if (!ticketsArray || ticketsArray.length !== 1) return;
    if (!loyaltyForms || !loyaltyProgramId) return;
    const loyaltyProgram = loyaltyForms[loyaltyProgramId];
    const holderRequired = loyaltyProgram?.holderRequired;
    if (!holderRequired) return;
    const alreadySelected = formsData?.[0]?.primaryUser;
    if (alreadySelected) return;
    this.setState(
      (prevState) => ({
        formsData: {
          ...prevState.formsData,
          0: {
            ...prevState.formsData?.[0],
            primaryUser: true
          }
        }
      }),
      this.updateMembershipForms
    );
  };
  shouldRenderField = (fieldConfig, buyerTypeId) => {
    if (!fieldConfig.requiredBuyerTypes) return true;
    const allowedTypes = fieldConfig.requiredBuyerTypes.split(",").map((id2) => id2.trim());
    return allowedTypes.includes(String(buyerTypeId));
  };
  validateField = (fieldConfig, value) => {
    const { required, dataValidation, dataValidationOptions } = fieldConfig;
    if (required && (!value || value.trim() === "")) {
      return false;
    }
    const stateKey = this.getStateKeyFromField(fieldConfig.field);
    if (stateKey === "email" && value) {
      return regexValidator.EmailValidator(value);
    }
    if (dataValidation === "regex" && dataValidationOptions && value) {
      try {
        const regex = new RegExp(dataValidationOptions);
        return regex.test(value);
      } catch {
        console.error("Invalid regex:", dataValidationOptions);
        return false;
      }
    }
    if (dataValidation === "birth_date" && value) {
      const parsed = moment(value, DATE_FORMAT_YMD, true);
      const minBirthDate = moment().subtract(130, "years").startOf("day");
      if (!parsed.isValid() || parsed.isAfter(moment().endOf("day")) || parsed.isBefore(minBirthDate)) {
        return false;
      }
    }
    return true;
  };
  getStateKeyFromField = (field) => LOYALTY_FIELD_TO_STATE_KEY[field] || field;
  parseFieldOptions = (fieldOptions) => {
    if (!fieldOptions) return [];
    return fieldOptions.split(",").map((option) => {
      const [value] = option.split("::");
      return { value: value.trim() };
    });
  };
  getPlaceholder = (field, intl) => {
    const isCGR = sessionStorage.getItem("isCGR") === "true";
    switch (field) {
      case "first_name":
        return intl.formatMessage({ defaultMessage: "First Name", id: "reservation.details.membership.firstName" });
      case "last_name":
        return intl.formatMessage({ defaultMessage: "Last Name", id: "reservation.details.membership.lastName" });
      case "telephone":
        return intl.formatMessage({ defaultMessage: "Telephone", id: "reservation.details.membership.phone" });
      case "email":
        return intl.formatMessage({ defaultMessage: "Email", id: "reservation.details.membership.email" });
      case "birth_date":
        return intl.formatMessage({
          defaultMessage: "Date of birth",
          id: "reservation.details.membership.birthDate"
        });
      case "vat_number":
        return intl.formatMessage({
          defaultMessage: "Vat Number",
          id: isCGR ? "data.form.vatNumber" : "contact.data.vatNumber"
        });
      case "postal_code":
        return intl.formatMessage({
          defaultMessage: "Postal code",
          id: isCGR ? "reservation.details.countrypostalCode" : "contact.postalcode"
        });
      case "city":
        return intl.formatMessage({
          defaultMessage: "City",
          id: isCGR ? "reservation.invoice.billingCity" : "bill.city"
        });
      case "gender":
        return intl.formatMessage({ defaultMessage: "Gender", id: "reservation.details.membership.gender" });
      default:
        return "";
    }
  };
  handleFieldBlur = (index2, fieldName, fieldConfig) => {
    this.setState((prevState) => {
      const newFormsData = { ...prevState.formsData };
      if (newFormsData[index2]) {
        newFormsData[index2] = {
          ...newFormsData[index2],
          touched: {
            ...newFormsData[index2].touched ?? {},
            [fieldName]: true
          }
        };
        const value = newFormsData[index2][fieldName];
        const isValid2 = this.validateField(fieldConfig, value);
        if (!isValid2) {
          newFormsData[index2][`${fieldName}Error`] = true;
        } else {
          delete newFormsData[index2][`${fieldName}Error`];
        }
      }
      return { formsData: newFormsData };
    });
  };
  handleChange = (e, index2) => {
    const { name, value } = e.target;
    const { ticketsArray } = this.props;
    this.setState((prevState) => {
      const newFormsData = { ...prevState.formsData };
      newFormsData[index2] = {
        ...newFormsData[index2],
        [name]: value,
        ticketId: ticketsArray[index2].id,
        buyerTypeId: ticketsArray[index2].buyerTypeId,
        subscription: false
      };
      return { formsData: newFormsData };
    }, this.updateMembershipForms);
  };
  handleCheckboxChange = (e, index2) => {
    const { name } = e.target;
    this.setState((prevState) => {
      const newFormsData = { ...prevState.formsData };
      if (!newFormsData[index2]) {
        newFormsData[index2] = {};
      }
      Object.keys(newFormsData).forEach((key) => {
        const k = Number(key);
        if (key !== String(index2)) {
          newFormsData[k] = { ...newFormsData[k], [name]: false };
        }
      });
      newFormsData[index2] = {
        ...newFormsData[index2],
        [name]: !newFormsData[index2]?.[name]
      };
      return { formsData: newFormsData };
    }, this.updateMembershipForms);
  };
  updateMembershipForms = () => {
    const { formsData } = this.state;
    const { onChange, update: update2, loyaltyForms, loyaltyProgramId, ticketsArray } = this.props;
    const loyaltyProgram = loyaltyForms && loyaltyProgramId ? loyaltyForms[loyaltyProgramId] : null;
    const holderRequired = loyaltyProgram?.holderRequired || false;
    const formFieldList = loyaltyProgram?.formFieldList || [];
    const updatedFormsData = { ...formsData };
    let allFormsValid = true;
    let primaryUserChecked = false;
    ticketsArray.forEach((ticket, index2) => {
      const formData = formsData[index2];
      if (!formData) {
        allFormsValid = false;
        return;
      }
      let formValid = true;
      formFieldList.forEach((fieldConfig) => {
        if (!this.shouldRenderField(fieldConfig, ticket.buyerTypeId ?? 0)) return;
        const stateKey = this.getStateKeyFromField(fieldConfig.field);
        const value = formData[stateKey];
        if (!this.validateField(fieldConfig, value)) {
          formValid = false;
        }
      });
      if (formData.primaryUser) {
        primaryUserChecked = true;
      }
      if (!formValid) {
        allFormsValid = false;
      }
    });
    if (holderRequired && !primaryUserChecked) {
      allFormsValid = false;
    }
    const dateStateKeys = formFieldList.filter((fieldConfig) => fieldConfig.fieldType === "date").map((fieldConfig) => this.getStateKeyFromField(fieldConfig.field));
    const updatedFormsDataServer = Object.values(updatedFormsData).map((formData) => {
      const { touched, ...rest } = formData;
      const normalizedDates = dateStateKeys.reduce((acc, key) => {
        acc[key] = formData[key] || null;
        return acc;
      }, {});
      return {
        ...rest,
        ...normalizedDates
      };
    });
    onChange({ membershipForms: updatedFormsData });
    update2({
      membershipForms: updatedFormsDataServer,
      membershipFormsValid: allFormsValid
    });
  };
  handleDateChange = (date, index2, stateKey) => {
    const { ticketsArray } = this.props;
    const formatted = date ? date.format(DATE_FORMAT_YMD) : "";
    this.setState(
      (prevState) => ({
        formsData: {
          ...prevState.formsData,
          [index2]: {
            ...prevState.formsData[index2],
            [stateKey]: formatted,
            ticketId: ticketsArray[index2].id,
            buyerTypeId: ticketsArray[index2].buyerTypeId,
            subscription: false
          }
        }
      }),
      this.updateMembershipForms
    );
  };
  renderDateField = (fieldConfig, form2, index2, intl) => {
    const { field, required, dataValidation } = fieldConfig;
    const stateKey = this.getStateKeyFromField(field);
    const focusKey = `${stateKey}-${index2}`;
    const { dateFocused } = this.state;
    const value = form2[stateKey] || "";
    const dateValue = value ? moment(value) : null;
    const touched = form2.touched?.[stateKey];
    const hasFieldError = form2[`${stateKey}Error`];
    const hasFormatError = !!form2[`${stateKey}FormatError`];
    const focused = dateFocused[focusKey] || false;
    const isMobile = typeof window !== "undefined" && isMobileDevice();
    const isBirthDateValidation = dataValidation === "birth_date";
    const minBirthDate = moment().subtract(130, "years").startOf("day");
    const parsedBirthDate = isBirthDateValidation && value ? moment(value, DATE_FORMAT_YMD, true) : null;
    const isFutureBirthDate = !!parsedBirthDate && parsedBirthDate.isAfter(moment().endOf("day"));
    const isTooOldBirthDate = !!parsedBirthDate && parsedBirthDate.isBefore(minBirthDate);
    const hasInvalidFormat = hasFormatError || isFutureBirthDate || isTooOldBirthDate;
    const isEmpty2 = !value && touched && required;
    const locale = typeof window !== "undefined" ? getAppLocale() : "en";
    initMomentLocale(locale);
    const { displayFormat, firstDayOfWeek } = getCalendarLocaleConfig(locale);
    const currentYear = moment().year();
    const years = Array.from({ length: 131 }, (_, i) => currentYear - i);
    const placeholder = this.getPlaceholder(field, intl);
    const isInvalid = !!isEmpty2 || !!hasFieldError || hasInvalidFormat;
    const stateClass = isInvalid ? "has-error" : "";
    const floatingLabelStyle = getFloatingLabelStyle(!!value);
    const applyFormControlClass = (el) => {
      if (!el) return;
      const input = el.querySelector(".DateInput_input");
      if (!input) return;
      if (!input.classList.contains("form-control")) {
        input.classList.add("form-control");
      }
      if (!input.dataset.rawListenerAttached) {
        input.dataset.rawListenerAttached = "true";
        input.addEventListener("input", (e) => {
          this.dateRawInputs[focusKey] = e.target.value;
        });
      }
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-group form-custom col-md-4", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: stateClass, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-custom date-picker-form-field", ref: applyFormControlClass, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          SingleDatePicker$1,
          {
            id: `membership-${stateKey}-${index2}`,
            date: dateValue,
            onDateChange: (date) => {
              if (date) {
                this.dateRawInputs[focusKey] = "";
              }
              this.handleDateChange(date, index2, stateKey);
            },
            focused,
            onFocusChange: ({ focused: isFocused }) => {
              this.setState((prev) => ({
                ...prev,
                dateFocused: { ...prev.dateFocused, [focusKey]: isFocused }
              }));
              if (!isFocused) {
                const raw = this.dateRawInputs[focusKey] || "";
                this.dateRawInputs[focusKey] = "";
                this.setState((prev) => {
                  const newFormsData = { ...prev.formsData };
                  const current = newFormsData[index2] || {};
                  const stored = current[stateKey];
                  const invalidFormat = !!raw && !stored;
                  newFormsData[index2] = {
                    ...current,
                    touched: { ...current.touched ?? {}, [stateKey]: true }
                  };
                  if (invalidFormat) {
                    newFormsData[index2][`${stateKey}FormatError`] = true;
                  } else {
                    delete newFormsData[index2][`${stateKey}FormatError`];
                  }
                  return { formsData: newFormsData };
                });
              }
            },
            numberOfMonths: 1,
            initialVisibleMonth: () => dateValue || moment(),
            isOutsideRange: isBirthDateValidation ? (day) => day.isAfter(moment().endOf("day")) || day.isBefore(minBirthDate) : () => false,
            withPortal: isMobile,
            withFullScreenPortal: false,
            hideKeyboardShortcutsPanel: true,
            displayFormat,
            firstDayOfWeek,
            placeholder: " ",
            readOnly: isMobile,
            noBorder: true,
            block: true,
            renderMonthElement: ({ month, onMonthSelect, onYearSelect }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "date-picker-month-year-selectors", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("select", { value: month.month(), onChange: (e) => onMonthSelect(month, e.target.value), children: moment.months().map((monthLabel, val) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: val, children: monthLabel }, val)) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("select", { value: month.year(), onChange: (e) => onYearSelect(month, e.target.value), children: years.map((yr) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: yr, children: yr }, yr)) })
            ] })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { htmlFor: `membership-${stateKey}-${index2}`, style: floatingLabelStyle, children: [
          placeholder,
          " ",
          required ? /* @__PURE__ */ jsxRuntimeExports.jsx("em", { children: "*" }) : null
        ] })
      ] }),
      hasInvalidFormat && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block error", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Invalid format", id: "error.helper.valid.format" }) }),
      isEmpty2 && !hasInvalidFormat && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block error", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Required", id: "error.helper.required" }) })
    ] }) }, fieldConfig.loyaltyProgramFormFieldId);
  };
  renderDynamicField = (fieldConfig, form2, index2, intl) => {
    const { field, fieldType, required, fieldOptions, dataValidation, dataValidationOptions } = fieldConfig;
    if (fieldType === "date") {
      return this.renderDateField(fieldConfig, form2, index2, intl);
    }
    const stateKey = this.getStateKeyFromField(field);
    const value = form2[stateKey] || "";
    const touched = form2.touched?.[stateKey];
    const isEmpty2 = !value && touched && required;
    const hasRegexValidation = dataValidation === "regex" && !!dataValidationOptions;
    const hasEmailValidation = stateKey === "email";
    const hasInvalidFormat = (hasEmailValidation || hasRegexValidation) && !!value && !!form2[`${stateKey}Error`];
    const hasFieldError = form2[`${stateKey}Error`];
    const baseClass = "form-group form-custom col-md-4";
    const isInvalid = !!isEmpty2 || !!hasFieldError || !!hasInvalidFormat;
    const stateClass = isInvalid ? "has-error" : "";
    const placeholder = this.getPlaceholder(field, intl);
    const inputId = `membership-${stateKey}-${index2}`;
    const floatingLabelStyle = getFloatingLabelStyle(!!value);
    const commonProps = {
      id: inputId,
      name: stateKey,
      className: "form-control",
      value,
      onChange: (e) => this.handleChange(e, index2),
      onBlur: () => this.handleFieldBlur(index2, stateKey, fieldConfig)
    };
    let inputNode = null;
    if (fieldType === "select") {
      const options = this.parseFieldOptions(fieldOptions);
      inputNode = /* @__PURE__ */ jsxRuntimeExports.jsxs("select", { ...commonProps, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "", disabled: true, children: placeholder }),
        options.map((option) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: option.value, children: option.value }, option.value.toLowerCase()))
      ] });
    } else {
      let type = "text";
      if (stateKey === "email") type = "email";
      if (stateKey === "telephone") type = "tel";
      inputNode = /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type, ...commonProps });
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: baseClass, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: stateClass, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "input-custom", children: [
        inputNode,
        /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { htmlFor: inputId, style: floatingLabelStyle, children: [
          placeholder,
          " ",
          required ? /* @__PURE__ */ jsxRuntimeExports.jsx("em", { children: "*" }) : null
        ] })
      ] }),
      hasInvalidFormat && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block error", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Invalid format", id: "error.helper.valid.format" }) }),
      isEmpty2 && !hasInvalidFormat && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "help-block error", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Required", id: "error.helper.required" }) })
    ] }) }, fieldConfig.loyaltyProgramFormFieldId);
  };
  render() {
    const { formsData } = this.state;
    const { step, handleSelect, activeStep, totalSteps, ticketsArray, cart: cart2, intl, loyaltyForms, loyaltyProgramId } = this.props;
    const loyaltyProgram = loyaltyForms && loyaltyProgramId ? loyaltyForms[loyaltyProgramId] : null;
    const formFieldList = loyaltyProgram?.formFieldList || [];
    const sortedFields = [...formFieldList].sort((a, b) => a.displayOrder - b.displayOrder);
    const defaultTitle = /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Membership", id: "reservation.details.membership" });
    const title = loyaltyProgram?.title ? loyaltyProgram.title : defaultTitle;
    const holderRequired = loyaltyProgram?.holderRequired;
    const isPrimaryUserChecked = Object.values(formsData).some((formData) => formData.primaryUser);
    const errorPrimaryUserChecked = holderRequired && !isPrimaryUserChecked ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "text-left error", style: { fontWeight: "bold", fontStyle: "italic", color: "#B32424" }, children: [
      "* ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Please select a membership holder.", id: "membership.error.primaryUser" })
    ] }) : null;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FrontendMainPanel$1,
      {
        title,
        icon: "icon-own-supervisor_account",
        showNext: cart2.membershipFormsValid,
        activeStep,
        totalSteps,
        goToStep: handleSelect,
        step,
        renderRequired: true,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "panel-body-content", children: [
          ticketsArray && ticketsArray.map((ticket, index2) => {
            const form2 = formsData[index2] || {};
            return /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "buyerTypeId", value: ticket.buyerTypeId }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", name: "subscription", value: "false" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row", style: { fontWeight: "bold", paddingBottom: ".2em" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: ticket.name }) }) }),
              holderRequired && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-group form-custom col-md-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-checkbox", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "input",
                  {
                    type: "checkbox",
                    name: "primaryUser",
                    id: `primaryUser-${index2}`,
                    checked: !!formsData[index2]?.primaryUser,
                    onChange: (e) => this.handleCheckboxChange(e, index2)
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { htmlFor: `primaryUser-${index2}`, className: "checkbox-inline", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { role: "checkbox", "aria-checked": "false", "aria-label": "Select option" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", {}),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Holder", id: "reservation.details.membership.holder" })
                ] })
              ] }) }) }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row form-loyalty-container", children: sortedFields.filter((fieldConfig) => this.shouldRenderField(fieldConfig, ticket.buyerTypeId ?? 0)).map((fieldConfig) => this.renderDynamicField(fieldConfig, form2, index2, intl)) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("hr", {})
            ] }, index2);
          }),
          errorPrimaryUserChecked
        ] })
      },
      `main-panel-${step}`
    );
  }
}
const mapStateToProps$5 = (state) => {
  const { cart: cart2, products: products2 } = state;
  let { loyaltyForms } = products2;
  const ticketsArray = [];
  const ticketsSelected = cart2.ticketsSelected || null;
  if ((!loyaltyForms || Object.keys(loyaltyForms).length === 0) && sessionStorage.getItem("loyaltyFormData")) {
    const formLoyaltyFromStorage = JSON.parse(sessionStorage.getItem("loyaltyFormData"));
    loyaltyForms = {
      [String(formLoyaltyFromStorage.loyaltyProgramId)]: formLoyaltyFromStorage
    };
  }
  if (ticketsSelected) {
    Object.values(ticketsSelected).forEach((ticket) => {
      for (let i = 0; i < ticket.n; i++) {
        ticketsArray.push(ticket);
      }
    });
  }
  let loyaltyProgramId = null;
  if (loyaltyForms && typeof loyaltyForms === "object") {
    const firstKey = Object.keys(loyaltyForms)[0];
    if (firstKey) loyaltyProgramId = firstKey;
  }
  return {
    cart: cart2,
    ticketsArray,
    loyaltyForms,
    loyaltyProgramId
  };
};
const mapDispatchToProps$5 = (dispatch) => ({
  onChange: (forms) => {
    dispatch(addMembershipForms(forms));
  },
  update: (cartData) => {
    dispatch(updateAll(cartData));
  }
});
const MembershipFormWrapper$1 = connect(mapStateToProps$5, mapDispatchToProps$5)(injectIntl(MembershipFormWrapper));
class SelectorsOrquestrator extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onChangeStep = this.onChangeStep.bind(this);
  }
  shouldComponentUpdate(nextProps, nextState) {
    const { activeStep } = this.state;
    const { product, orderComponents } = this.props;
    return activeStep !== nextState.activeStep || !!product && product !== nextProps.product || orderComponents !== nextProps.orderComponents;
  }
  componentDidUpdate(prevProps) {
    const { setFirstEventSelected: setFirstEventSelected2, events: events2, orderComponents, product, eventList, showAddToCart, cart: cart2 } = this.props;
    const { eventList: prevEventList } = prevProps;
    const prod = product;
    if ((!events2 || !events2.length) && orderComponents && product && prod.productVenueSet && prod.productVenueSet.length > 0 && CalendarType.CALENDAR !== prod.productVenueSet[0].validType && !prod.showEvents && eventList.length > 0 && prevEventList.length === 0) {
      setFirstEventSelected2();
    }
    const { activeStep = 0 } = this.state;
    const stepModification = !prod.showEvents && !prod.showCalendar ? -1 : 0;
    showAddToCart(orderComponents.length - 1 + stepModification === activeStep);
    if (orderComponents[activeStep + 1] === "membership") {
      if (cart2.membershipFormsValid) {
        showAddToCart(true);
      } else {
        showAddToCart(false);
      }
    }
    this.onChangeStep(activeStep);
  }
  onChangeStep(activeStepParam = 0) {
    const { showAddToCart, orderComponents, product, cart: cart2 } = this.props;
    const { activeStep } = this.state;
    const prod = product;
    const stepModification = !prod.showEvents && !prod.showCalendar ? -1 : 0;
    if (activeStep !== activeStepParam && !!(orderComponents.length + stepModification)) {
      showAddToCart(orderComponents.length - 1 + stepModification === activeStepParam);
      if (orderComponents[activeStepParam + 1] === "membership") {
        if (cart2.membershipFormsValid) {
          showAddToCart(true);
        } else {
          showAddToCart(false);
        }
      }
      this.setState({ activeStep: activeStepParam });
    }
  }
  render() {
    const {
      product,
      orderComponents,
      urlParams,
      currency,
      showBuyerTypesAsSelect,
      showRealAvailability,
      showAvailabilityFilter,
      app
    } = this.props;
    const { activeStep = 0 } = this.state;
    if (!product || !Object.keys(product).length) {
      return null;
    }
    const prod = product;
    const genericFieldAnswerList = urlParams && urlParams.gfa ? urlParams.gfa : void 0;
    const stepModification = !prod.showEvents && !prod.showCalendar && !prod.onlyExtras ? -1 : 0;
    const componentProps = {
      totalSteps: orderComponents.length + stepModification,
      activeStep,
      currency,
      handleSelect: this.onChangeStep
    };
    return orderComponents.map((order, step) => {
      switch (order) {
        case "numbered":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            SeatSelectorWrapper,
            {
              step: step + stepModification,
              totalSteps: componentProps.totalSteps,
              activeStep: componentProps.activeStep,
              handleSelect: componentProps.handleSelect
            },
            `numbered-wrapper-${step + stepModification}`
          );
        case "date-event":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            LinkedEventListSelector$1,
            {
              step: step + stepModification,
              handleSelect: componentProps.handleSelect,
              showRealAvailability,
              showAvailabilityFilter,
              app
            },
            `date-selector-wrapper-${step + stepModification}`
          );
        case "buyerTypes":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            BuyerTypeSelectorWrapper$1,
            {
              step: step + stepModification,
              showBuyerTypesAsSelect,
              app,
              ...componentProps
            },
            `bt-selector-wrapper-${step + stepModification}`
          );
        case "membership":
          if (prod.renewal) return null;
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            MembershipFormWrapper$1,
            {
              step: step + stepModification,
              ...componentProps
            },
            `membership-selector-wrapper-${step + stepModification}`
          );
        case "services":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            ServiceSelectorWrapper$1,
            {
              step: step + stepModification,
              ...componentProps
            },
            `service-selector-wrapper-${step + stepModification}`
          );
        case "forms":
          return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              TicketFormContainer$1,
              {
                step: step + stepModification,
                ...componentProps,
                genericFieldAnswerList,
                withCheckoutStepper: true
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              ReservationFormContainer$1,
              {
                step: step + stepModification,
                ...componentProps,
                genericFieldAnswerList,
                withCheckoutStepper: true
              }
            )
          ] }, `forms-selector-wrapper-${step + stepModification}`);
        default:
          return null;
      }
    });
  }
}
const mapStateToProps$4 = (state) => {
  const { cart: cart2, pointOfSales, events: events2 } = state;
  const { product } = cart2;
  const clientList = pointOfSales?.clientList ?? [];
  const currency = clientList[0]?.currencyList?.[0]?.isoCode ?? "";
  return {
    product,
    orderComponents: getVisibleComponentNameList(state).filter((order) => order !== "promotions"),
    currency,
    events: cart2.events,
    eventList: events2.eventList,
    cart: cart2
  };
};
const mapDispatchToProps$4 = (dispatch) => ({
  setFirstEventSelected: () => {
    dispatch(setFirstEventSelected());
  }
});
const SelectorsOrquestrator$1 = connect(mapStateToProps$4, mapDispatchToProps$4)(SelectorsOrquestrator);
class AddToCartButton extends Component {
  timeoutId;
  addToCartButton = createRef();
  constructor(props) {
    super(props);
    this.addToCart = this.addToCart.bind(this);
  }
  componentDidMount() {
    const { enableCaptcha = false, handleAddToCart: handleAddToCart2, dispatchAddToCart, valid } = this.props;
    if (dispatchAddToCart && valid) {
      if (enableCaptcha) {
        this.captchaAddToCart();
      } else {
        handleAddToCart2({ recaptcha: false });
      }
    }
  }
  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }
  captchaAddToCart() {
    const { handleAddToCart: handleAddToCart2, reCaptchaKey } = this.props;
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(reCaptchaKey, { action: "addToCart" }).then((token2) => {
        handleAddToCart2({ recaptcha: token2 });
      });
    });
  }
  createTimeOut() {
    this.timeoutId = setTimeout(() => {
      if (this.addToCartButton.current) {
        this.addToCartButton.current.removeAttribute("disabled");
      }
    }, 1e3);
  }
  addToCart() {
    const { enableCaptcha = false, handleAddToCart: handleAddToCart2 } = this.props;
    this.addToCartButton.current.setAttribute("disabled", "disabled");
    if (enableCaptcha) {
      this.captchaAddToCart();
    } else {
      handleAddToCart2({ recaptcha: false });
    }
    this.createTimeOut();
  }
  render() {
    const { id: id2, valid = true } = this.props;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        type: "button",
        className: `btn btn-custom btn-custom-addToCart ${!valid ? "disabled" : ""}`,
        ref: this.addToCartButton,
        onClick: this.addToCart,
        disabled: !valid,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Continuar", id: "button.add.to.cart" }),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-own-keyboard_arrow_right" })
        ]
      },
      `atc-fragment-${id2}`
    );
  }
}
class LinkedAddToCartButton extends Component {
  addToCartButtonId;
  constructor(props) {
    super(props);
    this.handleAddToCart = this.handleAddToCart.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleConfirmAddToCart = this.handleConfirmAddToCart.bind(this);
    this.state = {
      showModal: false
    };
    this.addToCartButtonId = "add-to-cart";
  }
  shouldComponentUpdate({ cart: cart2, showAddToCart, isAddonsFetching, hasAddons, productConfigurations }, { showModal }) {
    const {
      cart: cartProp,
      showAddToCart: showAddToCartProp,
      errorInReservation: errorInReservationProp,
      isAddonsFetching: isAddonsFetchingProp,
      productConfigurations: productConfigurationsProp
    } = this.props;
    const { showModal: showModalState } = this.state;
    return cart2.status.valid !== cartProp.status.valid || showAddToCart !== showAddToCartProp || showModal !== showModalState || errorInReservationProp || !!(hasAddons && !isAddonsFetching && isAddonsFetchingProp) || productConfigurations !== productConfigurationsProp;
  }
  componentDidUpdate(prevProps) {
    const { hasAddons, isAddonsFetching, addons, history, onFetchAddons, eventId } = this.props;
    if (hasAddons && prevProps.isAddonsFetching && !isAddonsFetching && history) {
      let nextLocation;
      if (addons && addons.list && addons.list.length) {
        const productPathname = eventId ? history.location.pathname.split("/").slice(0, -1).join("/") : history.location.pathname;
        nextLocation = `${productPathname}/addons`;
      } else {
        const locale = Cookie.get("locale");
        nextLocation = `/${locale}/summaryPurchase${history.location.search}`;
      }
      onFetchAddons();
      history.push(nextLocation);
    }
  }
  handleAddToCart({ recaptcha, buy }) {
    const {
      pos,
      tiempoSesion,
      cart: cart2,
      addToCart: addToCart2,
      recommendationEngineEnabled,
      recommendation,
      productInfoPopUp,
      loyalty,
      timeZone,
      productFormList,
      form: form2,
      currency,
      productInfo,
      eventList
    } = this.props;
    const isCasaBatllo2 = () => window.pos && window.pos.name === "CasaBatllo";
    if (!isCasaBatllo2() && isProviderEnabled("ga4") && !consumeGoToStepFlag()) {
      viewSection({
        section: "select-tickets",
        productInfo,
        timeZone
      });
    }
    if (hasCallCenterRole()) {
      const keepReservationOtherDataChecked = sessionStorage.getItem("keepReservationOtherData") === "true";
      const keepTicketOtherDataChecked = sessionStorage.getItem("keepTicketOtherData") === "true";
      const formState = form2;
      if (formState && formState.reservationForm && keepReservationOtherDataChecked) {
        sessionStorage.setItem("reservationFormOtherData", JSON.stringify(formState.reservationForm.values));
      }
      if (formState && formState.ticketForm && keepTicketOtherDataChecked) {
        sessionStorage.setItem("ticketFormOtherData", JSON.stringify(formState.ticketForm.values));
      }
    }
    const hasModal = productInfoPopUp;
    if (hasModal && !buy) {
      this.setState({ showModal: true });
    } else if (hasModal && buy) {
      this.setState({ showModal: false });
      addToCart2(
        cart2,
        pos,
        tiempoSesion,
        recommendationEngineEnabled && !recommendation,
        recaptcha,
        loyalty,
        timeZone,
        productFormList,
        currency,
        eventList
      );
    } else {
      addToCart2(
        cart2,
        pos,
        tiempoSesion,
        recommendationEngineEnabled && !recommendation,
        recaptcha,
        loyalty,
        timeZone,
        productFormList,
        currency,
        eventList
      );
    }
  }
  handleConfirmAddToCart() {
    const { enableCaptcha, reCaptchaKey } = this.props;
    if (enableCaptcha) {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(reCaptchaKey, { action: "addToCart" }).then((token2) => {
          this.handleAddToCart({ recaptcha: token2, buy: true });
        });
      });
    } else {
      this.handleAddToCart({ buy: true });
    }
  }
  handleClose() {
    this.setState({ showModal: false });
  }
  getModalDates() {
    const { cart: cart2, venueCapacityMap, eventList } = this.props;
    const { product } = cart2;
    return cart2.events.map((cartEvent, index2) => {
      const event = cartEvent.startDatetime ? cartEvent : eventList.find((eventToFind) => eventToFind.eventId === cartEvent.eventId);
      const startDatetime = new Date(event.startDatetime);
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "terms-addToCart-events", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
          startDatetime.getUTCHours() === 22 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            FormattedMessage,
            {
              id: "title.initial.date.venue",
              defaultMessage: "Inicio de {venueName}",
              values: {
                venueName: venueCapacityMap[event.venueCapacityId] && venueCapacityMap[event.venueCapacityId].name
              }
            }
          ) : venueCapacityMap[event.venueCapacityId] && venueCapacityMap[event.venueCapacityId].name,
          " :"
        ] }),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "terms-addToCart-events-date", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedDate$1, { value: startDatetime, year: "numeric", month: "long", day: "2-digit" }) }),
        " ",
        !product.openTime && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "terms-addToCart-events-time", children: startDatetime.getUTCHours() !== 22 ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedTime$2, { value: startDatetime }) : null })
      ] }, index2);
    });
  }
  render() {
    const { cart: cart2, showAddToCart, seatList, enableCaptcha, dispatchAddToCart, productInfoPopUp, reCaptchaKey } = this.props;
    const { status } = cart2;
    const { showModal } = this.state;
    const id2 = this.addToCartButtonId;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AddToCartButton,
        {
          valid: !!(status && status.valid && (showAddToCart || !!seatList.length)),
          reCaptchaKey,
          handleAddToCart: this.handleAddToCart,
          dispatchAddToCart,
          enableCaptcha,
          id: `${id2}`
        },
        `atc-button-${id2}`
      ),
      productInfoPopUp && showModal && /* @__PURE__ */ jsxRuntimeExports.jsx(
        CustomModal,
        {
          show: showModal,
          onClose: this.handleClose,
          body: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                dangerouslySetInnerHTML: {
                  __html: productInfoPopUp.description || ""
                }
              }
            ),
            this.getModalDates()
          ] }),
          title: productInfoPopUp.name,
          showFooter: true,
          footerContent: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              type: "button",
              className: "btn btn-custom btn-custom-buy pull-right",
              onClick: this.handleConfirmAddToCart,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Aceptar", id: "button.popup.add_to_cart.accept" })
            }
          )
        }
      )
    ] });
  }
}
function mapStateToProps$3(state) {
  const { pointOfSales, products: products2, loyalty, events: events2, form: form2 } = state;
  const { configurations, pointOfSale, clientList } = pointOfSales;
  const { productInfoList, addons, isAddonsFetching, promotionSelected, productConfigurations, productList } = products2;
  const { tiempoSesion, recommendationEngineEnabled } = configurations || {};
  const { eventList } = events2;
  let cart2 = getCartWithStatus(state);
  let { status } = cart2;
  const { seatList } = cart2;
  const productFormList = getReservationFormList(state);
  const venueCapacityMap = getVenueCapacityMap(state);
  const { errorInReservation } = state.reservations;
  if (productFormList && (!isReservationProductFormValid(state) || !isTicketProductFormValid(state))) {
    status = {
      valid: false,
      notifications: [createUncompleteForm()]
    };
  }
  cart2 = { ...cart2, status };
  const productInfoPopUp = productInfoList ? getProductInfos(productInfoList, "popup_terms_addtocart") : void 0;
  return {
    pos: pointOfSale,
    cart: cart2,
    productInfo: productList[0],
    venueCapacityMap,
    tiempoSesion,
    productInfoPopUp: productInfoPopUp ? productInfoPopUp[0] : void 0,
    recommendationEngineEnabled,
    seatList,
    loyalty,
    eventList,
    errorInReservation,
    timeZone: clientList[0].timeZone,
    currency: clientList[0].currencyList[0].isoCode,
    productFormList,
    form: form2,
    addons,
    isAddonsFetching: Boolean(isAddonsFetching),
    promotionSelected,
    productConfigurations
  };
}
const mapDispatchToProps$3 = (dispatch, ownProps) => {
  const locale = Cookie.get("locale");
  const { isSeller, sellerCallback, hasAddons = false } = ownProps;
  return {
    addToCart: (cart2, pos, tiempoSesion, recommendationEngineEnabled, recaptcha, loyalty, timeZone, productFormList, currency, eventList) => {
      if (recaptcha) {
        dispatch(addRecaptcha(recaptcha));
      }
      dispatch(
        handleAddToCart(
          {
            cart: { ...cart2, recaptcha },
            pos,
            cookieLifeTime: tiempoSesion,
            recommendationEngineEnabled: isSeller ? false : recommendationEngineEnabled,
            loyalty,
            timeZone,
            productFormList,
            hasAddons,
            isSeller,
            currency,
            eventList
          },
          () => {
            if (isSeller) {
              sellerCallback?.();
            } else if (hasAddons && !isSeller) {
              const mainEventId = cart2.events[0].eventId;
              const buyerTypeIdList = Object.keys(cart2.tickets).join();
              ownProps.fetchAddons?.(mainEventId, buyerTypeIdList);
            } else {
              ownProps.history?.push(`/${locale}/summaryPurchase${ownProps.history?.location.search}`);
            }
          }
        )
      );
    },
    onFetchAddons: () => {
      dispatch(hide());
      dispatch(clean());
      dispatch(cleanPromotionalCode());
    }
  };
};
const LinkedAddToCartButton$1 = connect(mapStateToProps$3, mapDispatchToProps$3)(LinkedAddToCartButton);
class RecommendationContainer extends Component {
  componentDidMount() {
    const { productList, recommendationRuleId, pos, productSelected, name } = this.props;
    const recommendationArray = [];
    if (productList && productList.length > 0 && Object.keys(productSelected).length > 0) {
      productList.forEach((product) => {
        if (!isProviderEnabled("ga4")) {
          recommendationArray.push({
            id: recommendationRuleId,
            name,
            position: product.displayOrder
          });
        } else {
          recommendationArray.push({
            item_id: product.productId,
            item_name: formatString(productSelected.name),
            item_list_name: "product-detail",
            index: productSelected.displayOrder,
            item_category: productSelected.productCategory && productSelected.productCategory.name,
            price: productSelected?.basePrice,
            promotion_name: formatString(name),
            promotion_id: recommendationRuleId,
            item_brand: formatString(pos.posName),
            item_category2: getCategory(
              productSelected
            ),
            item_variant: formatString(productSelected.shortName)
          });
        }
      });
    }
    if (recommendationArray.length > 0) promotionView(recommendationArray, pos.posName);
  }
  acceptRecommendation({ productId, slug, eventId, startDatetime }) {
    const { productList, recommendationRuleId, name, pos, handleSetPromotionSelected, handleSelect, productSelected } = this.props;
    const recommendationArray = [];
    if (productList && productList.length > 0) {
      productList.filter((product) => product.productId === productId).forEach((product) => {
        {
          recommendationArray.push({
            item_id: product.productId,
            item_name: formatString(productSelected.name),
            item_list_name: "product-detail",
            index: productSelected.displayOrder,
            item_category: productSelected.productCategory && productSelected.productCategory.name,
            price: productSelected?.basePrice,
            promotion_name: formatString(name),
            promotion_id: recommendationRuleId,
            item_brand: formatString(pos.posName),
            item_category2: getCategory(
              productSelected
            ),
            item_variant: formatString(productSelected.shortName)
          });
        }
      });
    }
    promotionClick(recommendationArray, pos.posName);
    handleSetPromotionSelected({
      productId,
      promotionId: recommendationRuleId,
      promotionName: name
    });
    handleSelect({ productId, slug, eventId, startDatetime });
  }
  render() {
    const { title, body, footer, productList, children, currency } = this.props;
    const productOfferedList = productList && productList.length > 0 && productList.sort((a, b) => a.displayOrder - b.displayOrder).map((product) => {
      const { productId, slug, name, image, price, event = {}, shortDescription } = product;
      const { eventId, startDatetime } = event;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        ProductItem,
        {
          name,
          image,
          basePrice: price,
          showPrice: true,
          displayClass: "product-standard recommendation",
          shortDescription,
          currency,
          buttons: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "product-buy", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "button",
            {
              type: "button",
              className: "btn btn-custom btn-custom-buy",
              onClick: () => this.acceptRecommendation({
                productId,
                slug,
                eventId,
                startDatetime
              }),
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "product.buy", defaultMessage: "Buy" }),
                " ",
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-own-keyboard_arrow_right" })
              ]
            }
          ) })
        },
        `recommended-product-item-${productId}`
      );
    });
    return React__default.cloneElement(
      children,
      {
        title,
        body,
        footer
      },
      productOfferedList
    );
  }
}
const mapDispatchToProps$2 = (dispatch) => ({
  handleSetPromotionSelected: ({ productId, promotionId, promotionName }) => {
    dispatch(
      setPromotionSelected({
        productId,
        promotionId,
        promotionName
      })
    );
  }
});
const RecommendationContainer$1 = connect(null, mapDispatchToProps$2)(RecommendationContainer);
class RecommendationModal extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
  }
  handleCancel() {
    const { handleCancel } = this.props;
    handleCancel();
  }
  render() {
    const { title, body, footer, children, recommendationId, opened } = this.props;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      CustomModal,
      {
        show: opened ?? false,
        onClose: this.handleCancel,
        title,
        bodyClassName: "modal-body modal-custom-recommendation",
        body: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          body && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modal-custom-recommendation-body", dangerouslySetInnerHTML: { __html: body } }),
          children,
          footer && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modal-custom-recommendation-footer", dangerouslySetInnerHTML: { __html: footer } })
        ] }),
        footerContent: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "btn btn-default", onClick: this.handleCancel, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "recommendationmodal.reject", defaultMessage: "No, Gracias" }) }),
        size: "large",
        customClass: `modal-recommendation recommendationModalId-${recommendationId}`,
        showFooter: true,
        onCancel: this.handleCancel
      }
    ) });
  }
}
class LinkedRecommendation extends Component {
  static hasSelectedTickets(tickets = {}) {
    return Object.values(tickets).some((bt) => bt.n > 0);
  }
  constructor(props) {
    super(props);
    this.state = {
      showModal: LinkedRecommendation.hasSelectedTickets(props.cart.tickets)
    };
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
  }
  componentDidUpdate(prevProps) {
    const { recommendation, askForRecommendation, cart: cart2 } = this.props;
    const { showModal } = this.state;
    const recommendationChanged = recommendation !== prevProps.recommendation;
    const hasRecommendation = recommendation && recommendation.recommendationRuleId;
    const modalClosed = !showModal;
    const shouldAsk = askForRecommendation;
    const ticketsSelected = LinkedRecommendation.hasSelectedTickets(cart2.tickets);
    if (recommendationChanged && hasRecommendation && modalClosed && shouldAsk && ticketsSelected) {
      this.setState({ showModal: true });
    }
  }
  handleSelection({ productId, slug, eventId, startDatetime }) {
    if (productId) {
      const { cart: cart2, history, handleSetRecommendationNotAsked, language, recommendation, cleanBuyerTypes } = this.props;
      const { salesGroup, tickets, services } = cart2;
      const url = `/${language}/${salesGroup.salesGroupId}${salesGroup.slug ? `-${salesGroup.slug}` : ""}/${productId}${slug ? `-${slug}` : ""}`;
      const eventIdList = eventId ? [eventId] : [];
      const dateObj = new Date(startDatetime || "");
      const isValidDate = !Number.isNaN(dateObj.getTime());
      const formattedDate = isValidDate ? format(startDatetime, DATE_FORMAT_YMD) : void 0;
      const params = {
        salesGroupId: salesGroup.salesGroupId,
        refererProductId: cart2.product.productId,
        eventIdList,
        date: formattedDate,
        recommendation: true,
        recommendationRuleId: recommendation.recommendationRuleId,
        ticketTypeNumberMap: JSON.stringify(
          Object.values(tickets).reduce(
            (res, bt) => ({
              ...res,
              [bt.buyerTypeId]: bt.n
            }),
            {}
          )
        ),
        ...Object.keys(services).reduce(
          (acc, serviceId) => ({
            ...acc,
            [`serviceId-${serviceId}`]: services[serviceId]
          }),
          {}
        )
      };
      handleSetRecommendationNotAsked();
      cleanBuyerTypes();
      history.push({
        pathname: url,
        search: `?${queryString.stringify(params)}`
      });
    } else {
      this.handleCancel();
    }
  }
  handleCancel() {
    this.setState({ showModal: false });
    const {
      pos,
      tiempoSesion,
      cart: cart2,
      onReject,
      recommendationEngineEnabled,
      timeZone,
      currency,
      cart: {
        product: { hasProductAddOn }
      }
    } = this.props;
    onReject(cart2, pos, tiempoSesion, recommendationEngineEnabled, timeZone, currency, hasProductAddOn);
  }
  render() {
    const { askForRecommendation, recommendation, currency, pos, cart: cart2 } = this.props;
    const { showModal } = this.state;
    return askForRecommendation && recommendation && Object.keys(recommendation).length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      RecommendationContainer$1,
      {
        ...recommendation,
        handleSelect: this.handleSelection,
        currency,
        pos,
        productSelected: cart2.product,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          RecommendationModal,
          {
            recommendationId: recommendation.recommendationRuleId,
            handleCancel: this.handleCancel,
            opened: showModal
          }
        )
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", {});
  }
}
const mapStateToProps$2 = (state) => {
  const { products: products2, pointOfSales } = state;
  const { pointOfSale, configurations, clientList } = pointOfSales;
  const { recommendation, addons, isAddonsFetching } = products2;
  const { tiempoSesion, recommendationEngineEnabled } = configurations || {};
  const cart2 = getCartWithStatus(state);
  const { askForRecommendation } = cart2;
  const language = Cookie.get("locale");
  return {
    pos: pointOfSale,
    cart: cart2,
    tiempoSesion,
    recommendationEngineEnabled,
    recommendation,
    askForRecommendation: Boolean(askForRecommendation),
    language,
    currency: clientList[0].currencyList[0].isoCode,
    timeZone: clientList[0].timeZone,
    addons,
    isAddonsFetching
  };
};
const mapDispatchToProps$1 = (dispatch, ownProps) => {
  const locale = Cookie.get("locale");
  return {
    handleSetRecommendationNotAsked: () => {
      dispatch(setRecommendationNotAsked());
    },
    onReject: (cart2, pos, tiempoSesion, recommendationEngineEnabled, timeZone, currency, hasAddons) => {
      if (cart2.status && cart2.status.valid) {
        dispatch(setRecommendationAsked());
        dispatch(cleanRecommendations());
        const newCart = {
          ...cart2,
          askForRecommendation: false
        };
        dispatch(
          handleAddToCart(
            {
              cart: newCart,
              pos,
              cookieLifeTime: tiempoSesion,
              recommendationEngineEnabled,
              timeZone,
              currency
            },
            () => {
              if (hasAddons) {
                const mainEventId = cart2.events[0].eventId;
                const buyerTypeIdList = Object.keys(cart2.tickets).join();
                ownProps.fetchAddons?.(mainEventId, buyerTypeIdList);
              } else {
                ownProps.history.push(`/${locale}/summaryPurchase`);
              }
            }
          )
        );
      }
    },
    cleanBuyerTypes: () => {
      dispatch(cleanBuyerTypesWithPrice());
    }
  };
};
const LinkedRecommendation$1 = connect(mapStateToProps$2, mapDispatchToProps$1)(LinkedRecommendation);
const parseDefaultValues = (defaultValueString) => {
  const parsed = {};
  defaultValueString.split(",").forEach((pair) => {
    const [key, value] = pair.split("::");
    parsed[key] = value;
  });
  return parsed;
};
const camelCase = (str) => str.replace(/^[_.\- ]+/, "").replace(/([a-z0-9])[_\-\s.]+([a-z0-9])/gi, (_, a, b) => a + b.toUpperCase()).replace(/^(.)/, (_, c) => c.toLowerCase());
const getFilteredConfigs = (configurations, filter) => configurations.filter(
  (item) => Object.keys(filter).every((key) => {
    if (key === "configKey") {
      return camelCase(item[key]) === filter[key];
    }
    return item[key] !== void 0 && item[key] === filter[key];
  })
);
const getConfigValue = (configurations, filter, filterLanguage = false) => {
  if (!configurations) return void 0;
  if (!filter) return configurations;
  let configValues;
  switch (filter.configKey) {
    case "purchaseFormDefaultValues": {
      const configValuesFiltered = getFilteredConfigs(configurations, filter);
      if (configValuesFiltered && configValuesFiltered.length > 0) {
        return parseDefaultValues(configValuesFiltered[0].configValue);
      }
      break;
    }
    case "showReserve": {
      const configValuesFiltered = getFilteredConfigs(configurations, filter);
      const showReserve = {
        client: false,
        salesGroupIds: null,
        productIds: null
      };
      if (configValuesFiltered) {
        const salesGroupIds = [];
        const productIds = [];
        let isGlobal = false;
        configValuesFiltered.forEach((config) => {
          if (config.configValue === "true") {
            if (config.clientId && !config.productId && !config.salesGroupId) {
              isGlobal = true;
            }
            if (config.productId) {
              productIds.push(config.productId);
            } else if (config.salesGroupId && !salesGroupIds.includes(config.salesGroupId)) {
              salesGroupIds.push(config.salesGroupId);
            }
          }
        });
        if (isGlobal) {
          showReserve.client = true;
          showReserve.salesGroupIds = null;
          showReserve.productIds = null;
        } else {
          showReserve.salesGroupIds = salesGroupIds.length > 0 ? salesGroupIds : null;
          showReserve.productIds = productIds.length > 0 ? productIds : null;
        }
      }
      return showReserve;
    }
    case "specialProductsByCategoryFrontend": {
      const configValuesFiltered = getFilteredConfigs(configurations, filter);
      if (configValuesFiltered && filter.salesGroupId) {
        configValues = configValuesFiltered.filter((c) => c.salesGroupId);
      }
      break;
    }
    case "hasGift": {
      const configValuesFiltered = getFilteredConfigs(configurations, filter);
      if (!filter.salesGroupId) {
        configValues = configValuesFiltered.filter((c) => !c.salesGroupId);
      } else if (!filter.productId) {
        configValues = configValuesFiltered.filter((c) => !c.productId);
      }
      break;
    }
    case "expressCheckout": {
      const configValuesFiltered = getFilteredConfigs(configurations, filter);
      if (configValuesFiltered && configValuesFiltered[0]) {
        const value = configValuesFiltered[0].configValue;
        return value === "1" || value === "true" || value === true || value === 1;
      }
      return false;
    }
    default: {
      configValues = getFilteredConfigs(configurations, filter);
      break;
    }
  }
  if (!configValues || !configValues[0] || configValues.length === 0) return void 0;
  if (filterLanguage) {
    const locale = Cookie.get("locale");
    const multilanguageValue = JSON.parse(configValues[0].configValue);
    return multilanguageValue[locale];
  }
  return configValues[0].configValue;
};
function getStepsList({
  isExpressCheckout,
  hasAddons
}) {
  const messageStep1 = !isExpressCheckout ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Select your tickets", id: "step1.title" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Tickets", id: "step1.express.title" });
  const messageStep2 = !isExpressCheckout ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Personal Data", id: "step2.title" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Information", id: "step2.express.title" });
  const steps = [
    {
      key: "step1",
      label: messageStep1,
      icon: "icon-own-ticket"
    }
  ];
  if (hasAddons) {
    steps.push({
      key: "addons",
      label: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Experiences", id: "step.addons.title" }),
      icon: "icon-own-star",
      isAddonStep: true
    });
  }
  steps.push({
    key: "step2",
    label: messageStep2,
    icon: "icon-own-dehaze"
  });
  if (!isExpressCheckout) {
    steps.push({
      key: "step3",
      label: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Payment", id: "step3.title" }),
      icon: "icon-own-payment"
    });
  }
  steps.push({
    key: "step4",
    label: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Confirmation", id: "step4.title" }),
    icon: "icon-own-check"
  });
  return steps;
}
function getStepClass({
  s,
  index: index2,
  step,
  hasAddons
}) {
  const stepIndex = index2 + 1;
  if (s.isAddonStep && hasAddons && step === void 0) {
    return "active";
  }
  if (typeof step === "number") {
    let adjustedStep = step;
    if (hasAddons && step > 1) {
      adjustedStep = step + 1;
    }
    if (adjustedStep === stepIndex) return "active";
    if (adjustedStep > stepIndex) return "visited";
    return "";
  }
  return "";
}
function Steps({ step, isExpressCheckout = false, hasAddons = false }) {
  const stepsList = getStepsList({ isExpressCheckout, hasAddons });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "steps", children: stepsList.map((s, index2) => {
    const className = getStepClass({ s, index: index2, step, hasAddons });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `step ${className}`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: `${s.icon} edit` }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "step-text", children: s.label })
    ] }, s.key);
  }) });
}
const mapStateToProps$1 = (state) => {
  const { pointOfSales } = state;
  const configurationsArray = pointOfSales?.configurationsArray;
  return {
    isExpressCheckout: !!(configurationsArray && getConfigValue(configurationsArray, { configKey: "expressCheckout" }))
  };
};
const Steps$1 = connect(mapStateToProps$1)(injectIntl(Steps));
const query = queryString.parse(window.location.search);
class ProductCheckoutContainer extends Component {
  static updateCartIfNeeded = (props, prevProps = null) => {
    const {
      salesGroup,
      product,
      events: events2,
      eventCode,
      tickets,
      parentReservationId,
      refererProductId,
      recommendationRuleId,
      date,
      cart: cart2 = {},
      update: update2,
      buyerTypeList
    } = props;
    let updatedCart = {};
    if (salesGroup && salesGroup.salesGroupId && (!cart2.salesGroup || cart2.salesGroup.salesGroupId !== salesGroup.salesGroupId)) {
      updatedCart = { ...updatedCart, salesGroup };
    }
    if (product && product.productId && (!cart2.product || cart2.product.productId !== product.productId)) {
      updatedCart = { ...updatedCart, product };
    }
    if (events2 && (!cart2.events || !cart2.events.length)) {
      updatedCart = { ...updatedCart, events: events2 };
    }
    if (eventCode && !cart2.eventCode) {
      updatedCart = { ...updatedCart, eventCode };
    }
    if (date && (!cart2.date || date !== cart2.date)) {
      updatedCart = { ...updatedCart, date };
    }
    if (parentReservationId && !cart2.parentReservationId) {
      updatedCart = { ...updatedCart, parentReservationId };
    }
    if (recommendationRuleId && !cart2.recommendationRuleId) {
      updatedCart = { ...updatedCart, recommendationRuleId };
    }
    if (refererProductId && !cart2.refererProductId) {
      updatedCart = { ...updatedCart, refererProductId };
    }
    if (buyerTypeList && prevProps && buyerTypeList !== prevProps.buyerTypeList) {
      const updatedTickets = cart2.tickets ? { ...cart2.tickets } : {};
      buyerTypeList.forEach((buyerType) => {
        if (buyerType.price !== prevProps.buyerTypeList.find((bt) => bt.buyerTypeId === buyerType.buyerTypeId)?.price && updatedTickets[buyerType.buyerTypeId]) {
          updatedTickets[buyerType.buyerTypeId].price = buyerType.price;
        }
      });
      updatedCart = { ...updatedCart, tickets: updatedTickets };
    }
    if (tickets && (!cart2.tickets || Object.keys(cart2.tickets).length < 1)) {
      updatedCart = { ...updatedCart, tickets };
    }
    if (Object.keys(updatedCart).length) {
      update2(updatedCart);
    }
  };
  constructor(props) {
    super(props);
    this.state = {
      showAddToCart: true,
      showModal: false
    };
    this.showAddToCart = this.showAddToCart.bind(this);
    this.handleClose = this.handleClose.bind(this);
    window.serviceUrls = props.serviceUrls;
  }
  componentDidMount() {
    const { onChangeDate: onChangeDate2, timeZone, eventId, getEvent, startDate, productInfoPopUp, cart: cart2 } = this.props;
    if (productInfoPopUp) {
      this.setState({ showModal: true });
    }
    if (eventId) {
      getEvent(eventId);
    } else {
      onChangeDate2(startDate, timeZone);
    }
    const { product, fetchServices } = this.props;
    const prod = product;
    const hasDateEventStep = !prod.onlyExtras && (prod.showCalendar || prod.showEvents);
    if (!hasDateEventStep) {
      const cartDate = cart2?.date;
      fetchServices(toUtcIsoString(cartDate, timeZone));
    }
    ProductCheckoutContainer.updateCartIfNeeded(this.props);
    const { history, promotionList, buyerTypesMap } = this.props;
    const buyerTypeListSorted = toListSorted(buyerTypesMap);
    const currTickets = cart2?.ticketsSelected || {};
    if (history && history.location.search.includes("recommendation=true") && currTickets) {
      ensurePromotionDataList(
        cart2,
        promotionList,
        buyerTypeListSorted
      );
    }
  }
  componentDidUpdate(prevProps) {
    ProductCheckoutContainer.updateCartIfNeeded(this.props, prevProps);
    const { cart: cart2, history, promotionList, buyerTypesMap } = this.props;
    const buyerTypeListSorted = toListSorted(buyerTypesMap);
    const prevTickets = prevProps.cart?.ticketsSelected || {};
    const currTickets = cart2?.ticketsSelected || {};
    if (history && history.location.search.includes("recommendation=true") && !_isEqual(prevTickets, currTickets)) {
      ensurePromotionDataList(
        cart2,
        promotionList,
        buyerTypeListSorted
      );
    }
  }
  componentWillUnmount() {
    const { clean: clean2 } = this.props;
    clean2();
  }
  handleClose() {
    this.setState({ showModal: false });
  }
  showAddToCart(showAddToCart = true) {
    this.setState({ showAddToCart });
  }
  render() {
    const {
      cart: cart2,
      recommendationEngineEnabled,
      location,
      recommendation,
      recommendationRule,
      history,
      productInfoPopUp,
      isSeller,
      enableCaptcha,
      reCaptchaKey,
      store,
      showAvailabilityFilter = false,
      showRealAvailability = false,
      sellerCallback,
      hidePromos,
      showBuyerTypesAsSelect,
      product,
      showCommissionSummary,
      app,
      productConfigurations,
      fetchAddons,
      promotionList,
      buyerTypesMap,
      eventId
    } = this.props;
    const { showModal, showAddToCart } = this.state;
    const urlParams = queryString.parse(location.search);
    const hasModal = productInfoPopUp;
    const dispatchAddToCart = urlParams.directAddToCart || recommendationRule && recommendationRule.directAddToCart ? JSON.parse(urlParams.directAddToCart) : false;
    const buyerTypeListSorted = toListSorted(buyerTypesMap);
    if (history && history.location.search.includes("recommendation=true")) {
      ensurePromotionDataList(
        cart2,
        promotionList,
        buyerTypeListSorted
      );
    }
    const totalWithPromosAndServices = getTotalWithPromosAndServices(
      cart2,
      promotionList
    );
    const availableToBuy = !(product.availableToBuyOnline === false && app !== "cgr" && app !== "seller");
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Provider, { store, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `container${isSeller ? "-fluid" : ""}`, children: [
      hasModal && /* @__PURE__ */ jsxRuntimeExports.jsx(
        CustomModal,
        {
          show: showModal,
          onClose: this.handleClose,
          title: productInfoPopUp.name,
          body: productInfoPopUp.description,
          dangerouslySetInnerHTMLBody: true,
          showFooter: true,
          footerContent: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "btn btn-custom btn-custom-buy pull-right", onClick: this.handleClose, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { defaultMessage: "Aceptar", id: "button.popup.add_to_cart.accept" }) })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "view-checkout", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-12 col-sm-12 col-xs-12", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Steps$1, { step: 1 }) }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "col-md-12 col-sm-12 col-xs-12 checkout-view-inner", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            SelectorsOrquestrator$1,
            {
              showAddToCart: this.showAddToCart,
              urlParams,
              showAvailabilityFilter,
              showRealAvailability,
              showBuyerTypesAsSelect,
              app
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: hidePromos ? "hidden" : "", children: /* @__PURE__ */ jsxRuntimeExports.jsx(PromotionsContainer$1, { isSeller, showAddToCart }) })
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "col-md-12 col-sm-12 col-xs-12", children: [
          showCommissionSummary && totalWithPromosAndServices.totalToShow > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cart-commission-table", children: /* @__PURE__ */ jsxRuntimeExports.jsx("table", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("tbody", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("td", { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "addtocart.text.base.price", defaultMessage: "Base price" }),
                ":"
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "text-right", children: /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                FormattedPriceWithCurrency$1,
                {
                  value: totalWithPromosAndServices.totalToShow - totalWithPromosAndServices.totalOfCommissions
                }
              ) }) })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { className: "disabled", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("td", { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormattedMessage, { id: "addtocart.text.booking.fees", defaultMessage: "Booking fees" }),
                ":"
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "text-right", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                FormattedPriceWithCurrency$1,
                {
                  value: totalWithPromosAndServices.totalOfCommissions
                }
              ) })
            ] })
          ] }) }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cart-addtoCart", children: [
            !needsToHidePriceField(
              productConfigurations
            ) && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "total", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                FormattedMessage,
                {
                  defaultMessage: "Total a pagar",
                  id: "button.text.pay",
                  tagName: "p"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                FormattedPriceWithCurrency$1,
                {
                  value: totalWithPromosAndServices.totalToShow
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              LinkedAddToCartButton$1,
              {
                reCaptchaKey,
                enableCaptcha,
                recommendation,
                dispatchAddToCart,
                showAddToCart: availableToBuy && showAddToCart,
                sellerCallback,
                history,
                isSeller,
                hasAddons: product.hasProductAddOn,
                fetchAddons: product.hasProductAddOn ? fetchAddons : void 0,
                eventId
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row" })
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row", children: enableCaptcha && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grecaptcha-message", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormattedHTMLMessage,
          {
            id: "recaptcha.policy.text",
            defaultMessage: "This site is protected by reCAPTCHA and the Google <a href='https://policies.google.com/privacy'>Privacy Policy</a> and\n                <a href='https://policies.google.com/terms'>Terms of Service</a> apply."
          }
        ) }) })
      ] }),
      recommendationEngineEnabled && !recommendation && /* @__PURE__ */ jsxRuntimeExports.jsx(
        LinkedRecommendation$1,
        {
          history,
          fetchAddons: product.hasProductAddOn ? fetchAddons : void 0
        }
      )
    ] }) });
  }
}
const mapStateToProps = (state, ownProps) => {
  const { cart: cart2, pointOfSales, events: events2, buyerTypes: buyerTypes2, products: products2, promotions: promotions2 } = state;
  const { productList, productInfoList, productConfigurations } = products2;
  const productsConfigurations = products2.productsConfigurations;
  const { promotionList } = promotions2;
  const { configurations } = pointOfSales ?? {};
  const { clientList = [] } = pointOfSales ?? {};
  const { buyerTypeList } = buyerTypes2;
  const { recommendationEngineEnabled } = configurations ?? {};
  const { product } = ownProps;
  const productInfoPopUp = productInfoList ? getProductInfos(productInfoList, "popup_terms_product") : void 0;
  const now = moment().format(DATE_FORMAT_YMD);
  let { calendarStart = now } = product;
  calendarStart = calendarStart || now;
  let startDate = calendarStart ? max(calendarStart, now) : now;
  if (query.date) {
    startDate = moment.tz(query.date, clientList[0]?.timeZone ?? "Europe/Madrid").toISOString();
  }
  if (productList && productList[0] && productList[0].needsCaptcha) {
    setCookie("captcha", "true", { expires: 1 });
  } else {
    setCookie("captcha", "false", { expires: 1 });
  }
  return {
    cart: cart2,
    buyerTypeList,
    enableCaptcha: !!(productList && productList[0] && productList[0].needsCaptcha),
    event: events2.event,
    productInfoPopUp: productInfoPopUp ? productInfoPopUp[0] : void 0,
    timeZone: clientList[0]?.timeZone ?? "Europe/Madrid",
    recommendationEngineEnabled,
    startDate,
    showCommissionSummary: !!(configurations && configurations.showCommissionSummary),
    productConfigurations: getProductConfig(
      productConfigurations,
      productsConfigurations,
      product.productId
    ),
    clientList,
    promotionList,
    buyerTypesMap: getBuyerTypeMap(state)
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  onChangeDate: (date, timeZone) => {
    const { salesGroup, product } = ownProps;
    dispatch(
      onChangeDate({
        date,
        salesGroupId: salesGroup.salesGroupId,
        productId: product.productId,
        venueId: product.productVenueSet.sort(
          (a, b) => (a.venue?.displayOrder ?? 0) - (b.venue?.displayOrder ?? 0)
        )[0].venueId,
        timeZone,
        product
      })
    );
  },
  getEvent: (eventId) => {
    const { salesGroup, product } = ownProps;
    dispatch(
      fetchEvent(eventId, product.productId, salesGroup.salesGroupId)
    ).then((event) => {
      dispatch(updateDate(event.response.startDatetime));
      dispatch(updateHour(event.response.startDatetime));
      const newEvent = event;
      newEvent.response.venueId = product.productVenueSet[0].venueId;
      dispatch(
        updateEvents([newEvent.response])
      );
      if (product.numbered || !product.productCategory?.general) {
        dispatch(
          fetchBuyerTypesWithPrice({
            date: event.response.startDatetime,
            salesGroupId: salesGroup.salesGroupId,
            productId: product.productId,
            isNumbered: product.numbered,
            eventId
          })
        );
      }
    });
  },
  clean: () => {
    dispatch(clean());
  },
  update: (cartUpdate) => {
    dispatch(updateAll(cartUpdate));
  },
  fetchServices: (eventDatetime) => {
    const { salesGroup, product } = ownProps;
    dispatch(
      fetchProductServices({
        salesGroupId: salesGroup.salesGroupId,
        productId: product.productId,
        purchaseDatetime: (/* @__PURE__ */ new Date()).toISOString(),
        eventDatetime
      })
    );
  }
});
const ProductCheckoutContainer_default = injectIntl(connect(mapStateToProps, mapDispatchToProps)(ProductCheckoutContainer));
function styleScript(locale, mail, emailLabel, phoneLabel) {
  return `var wpwlOptions = {locale: "${locale}", style: "plain", brandDetection: true,registrations: { requireCvv: true },maskCvv: true,allowEmptyCvv: false,billingAddress: {country: "",state: "",city: "",street1: "",street2: "",postcode: ""},forceCardHolderEqualsBillingName: false,onReady: function(){$(".wpwl-group-cardNumber").after($(".wpwl-group-brand").detach());$(".wpwl-group-cvv").after($(".wpwl-group-cardHolder").detach());var visa = $(".wpwl-brand:first").clone().removeAttr("class").attr("class", "wpwl-brand-card wpwl-brand-custom wpwl-brand-VISA");var master = $(visa).clone().removeClass("wpwl-brand-VISA").addClass("wpwl-brand-MASTER");$(".wpwl-brand:first").after($(master)).after($(visa));var customerEmail = '<div class="wpwl-wrapper wpwl-wrapper amex-inputs" style="display:inline; margin-top:5px"><input required type="email" class="wpwl-control cemail" name="customer.email" placeholder="${emailLabel}" value="${mail}"></input></div> <br>';var customerPhone = '<div class="wpwl-wrapper wpwl-wrapper amex-inputs" style="display:inline; margin-top:10px"><input required type="tel" class="wpwl-control cphone" name="customer.phone" placeholder="${phoneLabel}"></input></div> <br>';$('form.wpwl-form-card').find('.wpwl-button').before(customerEmail);$('form.wpwl-form-card').find('.wpwl-button').before(customerPhone);},onChangeBrand: function(e){$(".wpwl-brand-custom").css("opacity", "0.3");$(".wpwl-brand-" + e).css("opacity", "1");},onBeforeSubmit: function(){if ($(".wpwl-control.cemail").val() === "" || $(".wpwl-control.cphone").val() === "") {   alert("Please fill out all required fields.");   return false;}return true;}};`;
}
class ProsaPaymentForm extends Component {
  static getLanguageCountryCodeWithUpperCaseCountryCode(languageCountryCode) {
    const languageCountryCodeSplit = languageCountryCode.split("-");
    return `${languageCountryCodeSplit[0]}-${languageCountryCodeSplit[1].toUpperCase()}`;
  }
  static loadScript(payload, callback, itsUrl = true) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    const ieScript = script;
    if (ieScript.readyState) {
      ieScript.onreadystatechange = function() {
        if (ieScript.readyState === "loaded" || ieScript.readyState === "complete") {
          ieScript.onreadystatechange = null;
          if (callback) callback();
        }
      };
    } else {
      script.onload = function() {
        if (callback) callback();
      };
    }
    if (itsUrl) script.src = payload;
    else script.text = payload;
    document.getElementsByTagName("head")[0].appendChild(script);
    if (!itsUrl) callback();
  }
  constructor(props) {
    super(props);
    this.state = {
      scriptLoaded: false,
      isHideComponent: true
    };
    this.scriptWasLoaded = this.scriptWasLoaded.bind(this);
    this.showFormComponent = this.showFormComponent.bind(this);
  }
  scriptWasLoaded() {
    this.setState({
      scriptLoaded: true
    });
  }
  showFormComponent() {
    this.setState({
      isHideComponent: false
    });
  }
  render() {
    const { checkoutId, shopperResultUrl, environment, languageCountryCode, mail, intl } = this.props;
    const { scriptLoaded, isHideComponent } = this.state;
    const waitAndRender = () => {
      this.scriptWasLoaded();
      setTimeout(this.showFormComponent, 2e3);
    };
    const loadProsaLibrary = () => {
      ProsaPaymentForm.loadScript(
        `https://eu-${environment}.oppwa.com/v1/paymentWidgets.js?checkoutId=${checkoutId}`,
        waitAndRender
      );
    };
    const loadStyleScriptForProsa = () => {
      const emailLabel = intl.formatMessage({
        id: "contact.email",
        defaultMessage: "Email"
      });
      const phoneLabel = intl.formatMessage({
        id: "contact.phone",
        defaultMessage: "Phone"
      });
      const styleScriptString = styleScript(
        ProsaPaymentForm.getLanguageCountryCodeWithUpperCaseCountryCode(languageCountryCode),
        mail,
        emailLabel,
        phoneLabel
      );
      ProsaPaymentForm.loadScript(styleScriptString, loadProsaLibrary, false);
    };
    const loadJQueryAntThenOthers = () => {
      ProsaPaymentForm.loadScript(
        "https://ajax.googleapis.com/ajax/libs/jquery/3.6.1/jquery.min.js",
        loadStyleScriptForProsa
      );
    };
    if (!scriptLoaded) {
      loadJQueryAntThenOthers();
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      (!scriptLoaded || isHideComponent) && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { maxHeight: "350px" }, className: "spinner-validator-short", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "spinner-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "loading-spinner" }) }) }),
      scriptLoaded && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          style: {
            visibility: isHideComponent ? "hidden" : "visible",
            position: isHideComponent ? "absolute" : "relative"
          },
          className: "prosa-payment-form",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("form", { action: shopperResultUrl, className: "paymentWidgets", "data-brands": "VISA MASTER AMEX" })
        }
      ) })
    ] });
  }
}
const ProsaPaymentForm_default = injectIntl(ProsaPaymentForm);
function scriptSibsForm(locale) {
  return `
    var wpwlOptions = {
      locale: "${locale}",
      style: "plain",
      brandDetection: true,
      registrations: { requireCvv: true },
      maskCvv: true,
      allowEmptyCvv: false,
      billingAddress: {
        street1: "",
        street2: "",
        country: "",
        city: "",
        postcode: ""
      },
      onReady: function() {
        $(".wpwl-group-cardNumber").after($(".wpwl-group-brand").detach());
        $(".wpwl-group-cvv").after($(".wpwl-group-cardHolder").detach());
        var visa = $(".wpwl-brand:first").clone().removeAttr("class").attr("class", "wpwl-brand-card wpwl-brand-custom wpwl-brand-VISA");
        var master = $(visa).clone().removeClass("wpwl-brand-VISA").addClass("wpwl-brand-MASTER");
        $(".wpwl-brand:first").after($(master)).after($(visa));
      },
      onChangeBrand: function(e) {
        $(".wpwl-brand-custom").css("opacity", "0.3");
        $(".wpwl-brand-" + e).css("opacity", "1");
      }
    };
  `;
}
class SIBSPaymentForm extends Component {
  static loadScript(payload, callback, itsUrl = true) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    const ieScript = script;
    if (ieScript.readyState) {
      ieScript.onreadystatechange = function onReadyStateChange() {
        if (ieScript.readyState === "loaded" || ieScript.readyState === "complete") {
          ieScript.onreadystatechange = null;
          if (callback) callback();
        }
      };
    } else {
      script.onload = function onLoad() {
        if (callback) callback();
      };
    }
    if (itsUrl) script.src = payload;
    else script.text = payload;
    document.getElementsByTagName("head")[0].appendChild(script);
    if (!itsUrl) callback();
  }
  constructor(props) {
    super(props);
    this.state = {
      scriptLoaded: false,
      isHideComponent: true
    };
    this.scriptWasLoaded = this.scriptWasLoaded.bind(this);
    this.showFormComponent = this.showFormComponent.bind(this);
  }
  scriptWasLoaded() {
    this.setState({
      scriptLoaded: true
    });
  }
  showFormComponent() {
    this.setState({
      isHideComponent: false
    });
  }
  render() {
    const { formContext, formConfig, transactionID } = this.props;
    const { scriptLoaded, isHideComponent } = this.state;
    const formStyle = {
      transaction: {
        layout: "default",
        theme: "default",
        color: {
          primary: "",
          header: {
            text: "black"
          },
          body: {
            text: "black"
          }
        }
      }
    };
    const waitAndRender = () => {
      this.scriptWasLoaded();
      setTimeout(this.showFormComponent, 2e3);
    };
    const loadSIBSLibrary = () => {
      const loadScriptSibsUrl = JSON.parse(formConfig).loadScriptSibs;
      SIBSPaymentForm.loadScript(`${loadScriptSibsUrl}${transactionID}`, waitAndRender);
    };
    const loadStyleScriptForSIBS = () => {
      const styleScriptString = scriptSibsForm("en");
      SIBSPaymentForm.loadScript(styleScriptString, loadSIBSLibrary, false);
    };
    const loadJQueryAntThenOthers = () => {
      SIBSPaymentForm.loadScript(
        "https://ajax.googleapis.com/ajax/libs/jquery/3.6.1/jquery.min.js",
        loadStyleScriptForSIBS
      );
    };
    if (!scriptLoaded) {
      loadJQueryAntThenOthers();
    }
    const spgProps = {
      "spg-context": formContext,
      "spg-config": formConfig,
      "spg-style": JSON.stringify(formStyle.transaction)
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      (!scriptLoaded || isHideComponent) && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { maxHeight: "350px" }, className: "spinner-validator-short", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "spinner-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "loading-spinner" }) }) }),
      scriptLoaded && /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          style: {
            visibility: isHideComponent ? "hidden" : "visible",
            position: isHideComponent ? "absolute" : "relative"
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("form", { className: "paymentSPG", ...spgProps })
        }
      )
    ] });
  }
}
function SearchBar({ placeholder, onChange }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Form$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(InputGroup, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputGroup.Addon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Glyphicon, { glyph: "search" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl, { type: "text", placeholder: placeholder || "Search...", onChange })
  ] }) });
}
function initYunoCheckoutByWebcookie(webCookie, countryCode) {
  const config = {
    method: "POST",
    body: JSON.stringify({ web_cookie: webCookie, country_code: countryCode })
  };
  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL()}/payments/yuno/paymentMethods/byWebcookie`,
      config,
      authenticated: true,
      types: [YUNO_CHECKOUT_REQUEST, YUNO_CHECKOUT_SUCCESS, YUNO_CHECKOUT_FAILURE],
      scope: "discovery"
    }
  };
}
function initYunoCheckoutByReference(reference) {
  const config = {
    method: "POST",
    body: JSON.stringify({ reference })
  };
  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL()}/payments/yuno/paymentMethods/byReference`,
      config,
      authenticated: true,
      types: [YUNO_CHECKOUT_REQUEST, YUNO_CHECKOUT_SUCCESS, YUNO_CHECKOUT_FAILURE]
    }
  };
}
const resetYunoCheckout = () => ({ type: YUNO_CHECKOUT_RESET });
function createYunoPayment(reference, checkoutSession, oneTimeToken, options) {
  const config = {
    method: "POST",
    body: JSON.stringify({
      reference,
      checkoutSession,
      oneTimeToken,
      vaultOnSuccess: options?.vaultOnSuccess ?? false,
      paymentMethodType: options?.paymentMethodType
    })
  };
  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL()}/payments/yuno/createPayment`,
      config,
      authenticated: true,
      types: [YUNO_CREATE_PAYMENT_REQUEST, YUNO_CREATE_PAYMENT_SUCCESS, YUNO_CREATE_PAYMENT_FAILURE]
    }
  };
}
const initialState = {
  checkoutId: null,
  publicKey: null,
  paymentMethods: [],
  currency: null,
  country: null,
  isFetching: false,
  error: null
};
function yunoCheckout(state = initialState, action) {
  switch (action.type) {
    case YUNO_CHECKOUT_REQUEST:
      return { ...state, isFetching: true, error: null };
    case YUNO_CHECKOUT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        checkoutId: action.scope === "discovery" ? state.checkoutId : action.response?.checkoutId ?? null,
        publicKey: action.response?.publicKey ?? null,
        paymentMethods: action.response?.paymentMethods ?? [],
        currency: action.response?.currency ?? null,
        country: action.response?.country ?? null
      };
    case YUNO_CHECKOUT_FAILURE:
      return { ...state, isFetching: false, error: action.error ?? action.message ?? "YUNO_CHECKOUT_ERROR" };
    case YUNO_CHECKOUT_RESET:
      return initialState;
    default:
      return state;
  }
}
const DNI_REGEX = /^(([KLM]\d{7})|(\d{8}))([A-Z])$/;
const CIF_REGEX = /^([ABCDEFGHJNPQRSUVW])(\d{7})([0-9A-J])$/;
const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/;
const checkSpanishId = (toCheck, type) => {
  toCheck = toCheck.toUpperCase().replace(/\s/, "");
  let valid = false;
  if (type === "NIF") {
    if (toCheck.match(DNI_REGEX)) valid = checkDNI(toCheck);
  } else if (type === "NIE") {
    if (toCheck.match(NIE_REGEX)) valid = checkNIE(toCheck);
  } else if (type === "CIF") {
    if (toCheck.match(CIF_REGEX)) valid = checkCIF(toCheck);
  } else {
    valid = true;
  }
  return valid;
};
function checkDNI(dni) {
  const dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
  if (dni[0].match(/[KLM]/)) {
    dni = dni.substr(1);
  }
  return dni_letters.charAt(parseInt(dni, 10) % 23) === dni.charAt(dni.length - 1);
}
function checkNIE(nie) {
  let nie_prefix = nie.charAt(0);
  switch (nie_prefix) {
    case "X":
      nie_prefix = 0;
      break;
    case "Y":
      nie_prefix = 1;
      break;
    case "Z":
      nie_prefix = 2;
      break;
  }
  return checkDNI(nie_prefix + nie.substr(1));
}
function checkCIF(cif) {
  const match2 = cif.match(CIF_REGEX);
  if (!match2) return false;
  const letter = match2[1];
  const number2 = match2[2];
  const control = match2[3];
  let even_sum = 0;
  let odd_sum = 0;
  let n;
  for (let i = 0; i < number2.length; i++) {
    n = parseInt(number2.charAt(i), 10);
    if (i % 2 === 0) {
      n *= 2;
      odd_sum += n < 10 ? n : n - 9;
    } else {
      even_sum += n;
    }
  }
  const last_digit = parseInt((even_sum + odd_sum).toString().slice(-1), 10);
  const control_digit = last_digit !== 0 ? 10 - last_digit : last_digit;
  const control_letter = "JABCDEFGHI".substr(control_digit, 1);
  if (letter.match(/[ABEH]/)) {
    return control == String(control_digit);
  } else if (letter.match(/[PQSW]/)) {
    return control == control_letter;
  } else {
    return control == String(control_digit) || control == control_letter;
  }
}
const NIF_NIPC_REGEX = /^[12356789]\d{8}$/;
const validateNifNipc = (number2) => {
  if (!number2.match(NIF_NIPC_REGEX)) {
    return false;
  }
  const digits = number2.split("").map((d) => parseInt(d));
  const checkDigit = digits[8];
  const baseDigits = digits.slice(0, 8);
  let sum = 0;
  for (let i = 0; i < baseDigits.length; i++) {
    sum += baseDigits[i] * (9 - i);
  }
  const remainder = sum % 11;
  let expectedCheckDigit;
  if (remainder < 2) {
    expectedCheckDigit = 0;
  } else {
    expectedCheckDigit = 11 - remainder;
  }
  return checkDigit === expectedCheckDigit;
};
const checkPortugueseId = (input) => {
  const cleanNumber = input.toString().replace(/\s+/g, "").trim();
  if (!cleanNumber.match(NIF_NIPC_REGEX)) {
    return false;
  }
  const isValid2 = validateNifNipc(cleanNumber);
  return isValid2;
};
const checkVATNumber = (toCheck) => {
  var vatexp = new Array();
  var defCCode = "GB";
  vatexp.push(/^(AT)U(\d{8})$/);
  vatexp.push(/^(BE)(0\d{9})$/);
  vatexp.push(/^(BE)(\d{10})$/);
  vatexp.push(/^(BG)(\d{9,10})$/);
  vatexp.push(/^(CHE)(\d{9})(MWST|TVA|IVA)?$/);
  vatexp.push(/^(CY)([0-59]\d{7}[A-Z])$/);
  vatexp.push(/^(CZ)(\d{8,10})(\d{3})?$/);
  vatexp.push(/^(DE)([1-9]\d{8})$/);
  vatexp.push(/^(DK)(\d{8})$/);
  vatexp.push(/^(EE)(10\d{7})$/);
  vatexp.push(/^(EL)(\d{9})$/);
  vatexp.push(/^(ES)([A-Z]\d{8})$/);
  vatexp.push(/^(ES)([A-HN-SW]\d{7}[A-J])$/);
  vatexp.push(/^(ES)([0-9YZ]\d{7}[A-Z])$/);
  vatexp.push(/^(ES)([KLMX]\d{7}[A-Z])$/);
  vatexp.push(/^(EU)(\d{9})$/);
  vatexp.push(/^(FI)(\d{8})$/);
  vatexp.push(/^(FR)(\d{11})$/);
  vatexp.push(/^(FR)([A-HJ-NP-Z]\d{10})$/);
  vatexp.push(/^(FR)(\d[A-HJ-NP-Z]\d{9})$/);
  vatexp.push(/^(FR)([A-HJ-NP-Z]{2}\d{9})$/);
  vatexp.push(/^(GB)?(\d{9})$/);
  vatexp.push(/^(GB)?(\d{12})$/);
  vatexp.push(/^(GB)?(GD\d{3})$/);
  vatexp.push(/^(GB)?(HA\d{3})$/);
  vatexp.push(/^(HR)(\d{11})$/);
  vatexp.push(/^(HU)(\d{8})$/);
  vatexp.push(/^(IE)(\d{7}[A-W])$/);
  vatexp.push(/^(IE)([7-9][A-Z\*\+)]\d{5}[A-W])$/);
  vatexp.push(/^(IE)(\d{7}[A-W][AH])$/);
  vatexp.push(/^(IT)(\d{11})$/);
  vatexp.push(/^(LV)(\d{11})$/);
  vatexp.push(/^(LT)(\d{9}|\d{12})$/);
  vatexp.push(/^(LU)(\d{8})$/);
  vatexp.push(/^(MT)([1-9]\d{7})$/);
  vatexp.push(/^(NL)(\d{9})B\d{2}$/);
  vatexp.push(/^(NO)(\d{9})$/);
  vatexp.push(/^(PL)(\d{10})$/);
  vatexp.push(/^(PT)(\d{9})$/);
  vatexp.push(/^(RO)([1-9]\d{1,9})$/);
  vatexp.push(/^(RU)(\d{10}|\d{12})$/);
  vatexp.push(/^(RS)(\d{9})$/);
  vatexp.push(/^(SI)([1-9]\d{7})$/);
  vatexp.push(/^(SK)([1-9]\d[2346-9]\d{7})$/);
  vatexp.push(/^(SE)(\d{10}01)$/);
  var VATNumber = toCheck.toUpperCase();
  VATNumber = VATNumber.replace(/(\s|-|\.)+/g, "");
  var valid = false;
  for (let i = 0; i < vatexp.length; i++) {
    if (vatexp[i].test(VATNumber)) {
      var cCode = RegExp.$1;
      var cNumber = RegExp.$2;
      if (cCode.length == 0) cCode = defCCode;
      const checkFunction = VATCheckDigitFunctions[cCode + "VATCheckDigit"];
      if (checkFunction && checkFunction(cNumber)) valid = VATNumber;
      break;
    }
  }
  return valid;
};
const ATVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [1, 2, 1, 2, 1, 2, 1];
  var temp = 0;
  for (var i = 0; i < 7; i++) {
    temp = Number(vatnumber.charAt(i)) * multipliers[i];
    if (temp > 9) total += Math.floor(temp / 10) + temp % 10;
    else total += temp;
  }
  total = 10 - (total + 4) % 10;
  if (total == 10) total = 0;
  if (total == vatnumber.slice(7, 8)) return true;
  else return false;
};
const BEVATCheckDigit = (vatnumber) => {
  if (vatnumber.length === 9) {
    vatnumber = "0" + vatnumber;
  }
  if (vatnumber.length !== 10) {
    return false;
  }
  const first8 = parseInt(vatnumber.slice(0, 8));
  const last2 = parseInt(vatnumber.slice(8, 10));
  const remainder = first8 % 97;
  let checkValue;
  if (remainder === 0) {
    checkValue = 0;
  } else {
    checkValue = 97 - remainder;
  }
  if (vatnumber.startsWith("0") && checkValue !== last2) {
    const alternativeCheck = (97 - remainder) % 97;
    if (alternativeCheck === last2) {
      return true;
    }
    if (last2 === 97 - remainder || last2 === remainder) {
      return true;
    }
  }
  return checkValue === last2;
};
const BGVATCheckDigit = (vatnumber) => {
  if (vatnumber.length == 9) {
    var total = 0;
    var temp = 0;
    for (var i = 0; i < 8; i++) temp += Number(vatnumber.charAt(i)) * (i + 1);
    total = temp % 11;
    if (total != 10) {
      if (total == vatnumber.slice(8)) return true;
      else return false;
    }
    var temp = 0;
    for (var i = 0; i < 8; i++) temp += Number(vatnumber.charAt(i)) * (i + 3);
    total = temp % 11;
    if (total == 10) total = 0;
    if (total == vatnumber.slice(8)) return true;
    else return false;
  }
  if (/^\d\d[0-5]\d[0-3]\d\d{4}$/.test(vatnumber)) {
    var month = Number(vatnumber.slice(2, 4));
    if (month > 0 && month < 13 || month > 20 && month < 33 || month > 40 && month < 53) {
      var multipliers = [2, 4, 8, 5, 10, 9, 7, 3, 6];
      var total = 0;
      for (var i = 0; i < 9; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
      total = total % 11;
      if (total == 10) total = 0;
      if (total == vatnumber.substr(9, 1)) return true;
    }
  }
  var multipliers = [21, 19, 17, 13, 11, 9, 7, 3, 1];
  var total = 0;
  for (var i = 0; i < 9; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  if (total % 10 == vatnumber.substr(9, 1)) return true;
  var multipliers = [4, 3, 2, 7, 6, 5, 4, 3, 2];
  var total = 0;
  for (var i = 0; i < 9; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  total = 11 - total % 11;
  if (total == 10) return false;
  if (total == 11) total = 0;
  if (total == vatnumber.substr(9, 1)) return true;
  else return false;
};
const CHEVATCheckDigit = (vatnumber) => {
  var multipliers = [5, 4, 3, 2, 7, 6, 5, 4];
  var total = 0;
  for (var i = 0; i < 8; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  total = 11 - total % 11;
  if (total == 10) return false;
  if (total == 11) total = 0;
  if (total == vatnumber.substr(8, 1)) return true;
  else return false;
};
const CYVATCheckDigit = (vatnumber) => {
  if (Number(vatnumber.slice(0, 2) == 12)) return false;
  var total = 0;
  for (var i = 0; i < 8; i++) {
    var temp = Number(vatnumber.charAt(i));
    if (i % 2 == 0) {
      switch (temp) {
        case 0:
          temp = 1;
          break;
        case 1:
          temp = 0;
          break;
        case 2:
          temp = 5;
          break;
        case 3:
          temp = 7;
          break;
        case 4:
          temp = 9;
          break;
        default:
          temp = temp * 2 + 3;
      }
    }
    total += temp;
  }
  total = total % 26;
  var totalChar = String.fromCharCode(total + 65);
  if (totalChar == vatnumber.substr(8, 1)) return true;
  else return false;
};
const CZVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [8, 7, 6, 5, 4, 3, 2];
  var czexp = new Array();
  czexp[0] = /^\d{8}$/;
  czexp[1] = /^[0-5][0-9][0|1|5|6][0-9][0-3][0-9]\d{3}$/;
  czexp[2] = /^6\d{8}$/;
  czexp[3] = /^\d{2}[0-3|5-8][0-9][0-3][0-9]\d{4}$/;
  var i = 0;
  if (czexp[0].test(vatnumber)) {
    for (var i = 0; i < 7; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
    total = 11 - total % 11;
    if (total == 10) total = 0;
    if (total == 11) total = 1;
    if (total == vatnumber.slice(7, 8)) return true;
    else return false;
  } else if (czexp[1].test(vatnumber)) {
    if (Number(vatnumber.slice(0, 2)) > 62) return false;
    return true;
  } else if (czexp[2].test(vatnumber)) {
    for (var i = 0; i < 7; i++) total += Number(vatnumber.charAt(i + 1)) * multipliers[i];
    var a;
    if (total % 11 == 0) a = total + 11;
    else a = Math.ceil(total / 11) * 11;
    var pointer = a - total;
    var lookup = [8, 7, 6, 5, 4, 3, 2, 1, 0, 9, 8];
    if (lookup[pointer - 1] == vatnumber.slice(8, 9)) return true;
    else return false;
  } else if (czexp[3].test(vatnumber)) {
    var temp = Number(vatnumber.slice(0, 2)) + Number(vatnumber.slice(2, 4)) + Number(vatnumber.slice(4, 6)) + Number(vatnumber.slice(6, 8)) + Number(vatnumber.slice(8));
    if (temp % 11 == 0 && Number(vatnumber) % 11 == 0) return true;
    else return false;
  }
  return false;
};
const DEVATCheckDigit = (vatnumber) => {
  var product = 10;
  var sum = 0;
  var checkdigit = 0;
  for (var i = 0; i < 8; i++) {
    sum = (Number(vatnumber.charAt(i)) + product) % 10;
    if (sum == 0) {
      sum = 10;
    }
    product = 2 * sum % 11;
  }
  if (11 - product == 10) {
    checkdigit = 0;
  } else {
    checkdigit = 11 - product;
  }
  if (checkdigit == vatnumber.slice(8, 9)) return true;
  else return false;
};
const DKVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [2, 7, 6, 5, 4, 3, 2, 1];
  for (var i = 0; i < 8; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  total = total % 11;
  if (total == 0) return true;
  else return false;
};
const EEVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [3, 7, 1, 3, 7, 1, 3, 7];
  for (var i = 0; i < 8; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  total = 10 - total % 10;
  if (total == 10) total = 0;
  if (total == vatnumber.slice(8, 9)) return true;
  else return false;
};
const ELVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [256, 128, 64, 32, 16, 8, 4, 2];
  if (vatnumber.length == 8) {
    vatnumber = "0" + vatnumber;
  }
  for (var i = 0; i < 8; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  total = total % 11;
  if (total > 9) {
    total = 0;
  }
  if (total == vatnumber.slice(8, 9)) return true;
  else return false;
};
const ESVATCheckDigit = (vatnumber) => {
  var total = 0;
  var temp = 0;
  var multipliers = [2, 1, 2, 1, 2, 1, 2];
  var esexp = new Array();
  esexp[0] = /^[A-H|J|U|V]\d{8}$/;
  esexp[1] = /^[A-H|N-S|W]\d{7}[A-J]$/;
  esexp[2] = /^[0-9|Y|Z]\d{7}[A-Z]$/;
  esexp[3] = /^[K|L|M|X]\d{7}[A-Z]$/;
  var i = 0;
  if (esexp[0].test(vatnumber)) {
    for (i = 0; i < 7; i++) {
      temp = Number(vatnumber.charAt(i + 1)) * multipliers[i];
      if (temp > 9) total += Math.floor(temp / 10) + temp % 10;
      else total += temp;
    }
    total = 10 - total % 10;
    if (total == 10) {
      total = 0;
    }
    if (total == vatnumber.slice(8, 9)) return true;
    else return false;
  } else if (esexp[1].test(vatnumber)) {
    for (i = 0; i < 7; i++) {
      temp = Number(vatnumber.charAt(i + 1)) * multipliers[i];
      if (temp > 9) total += Math.floor(temp / 10) + temp % 10;
      else total += temp;
    }
    total = 10 - total % 10;
    var totalChar = String.fromCharCode(total + 64);
    if (totalChar == vatnumber.slice(8, 9)) return true;
    else return false;
  } else if (esexp[2].test(vatnumber)) {
    var tempnumber = vatnumber;
    if (tempnumber.substring(0, 1) == "Y") tempnumber = tempnumber.replace(/Y/, "1");
    if (tempnumber.substring(0, 1) == "Z") tempnumber = tempnumber.replace(/Z/, "2");
    return tempnumber.charAt(8) == "TRWAGMYFPDXBNJZSQVHLCKE".charAt(Number(tempnumber.substring(0, 8)) % 23);
  } else if (esexp[3].test(vatnumber)) {
    return vatnumber.charAt(8) == "TRWAGMYFPDXBNJZSQVHLCKE".charAt(Number(vatnumber.substring(1, 8)) % 23);
  } else return false;
};
const EUVATCheckDigit = (vatnumber) => {
  return true;
};
const FIVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [7, 9, 10, 5, 8, 4, 2];
  for (var i = 0; i < 7; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  total = 11 - total % 11;
  if (total > 9) {
    total = 0;
  }
  if (total == vatnumber.slice(7, 8)) return true;
  else return false;
};
const FRVATCheckDigit = (vatnumber) => {
  if (!/^\d{11}$/.test(vatnumber)) return true;
  var total = vatnumber.substring(2);
  total = (total * 100 + 12) % 97;
  if (total == vatnumber.slice(0, 2)) return true;
  else return false;
};
const GBVATCheckDigit = (vatnumber) => {
  var multipliers = [8, 7, 6, 5, 4, 3, 2];
  if (vatnumber.substr(0, 2) == "GD") {
    if (vatnumber.substr(2, 3) < 500) return true;
    else return false;
  }
  if (vatnumber.substr(0, 2) == "HA") {
    if (vatnumber.substr(2, 3) > 499) return true;
    else return false;
  }
  var total = 0;
  if (Number(vatnumber.slice(0)) == 0) return false;
  var no = Number(vatnumber.slice(0, 7));
  for (var i = 0; i < 7; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  var cd = total;
  while (cd > 0) {
    cd = cd - 97;
  }
  cd = Math.abs(cd);
  if (cd == vatnumber.slice(7, 9) && no < 9990001 && (no < 1e5 || no > 999999) && (no < 9490001 || no > 97e5))
    return true;
  if (cd >= 55) cd = cd - 55;
  else cd = cd + 42;
  if (cd == vatnumber.slice(7, 9) && no > 1e6) return true;
  else return false;
};
const HRVATCheckDigit = (vatnumber) => {
  var product = 10;
  var sum = 0;
  for (var i = 0; i < 10; i++) {
    sum = (Number(vatnumber.charAt(i)) + product) % 10;
    if (sum == 0) {
      sum = 10;
    }
    product = 2 * sum % 11;
  }
  if ((product + vatnumber.slice(10, 11) * 1) % 10 == 1) return true;
  else return false;
};
const HUVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [9, 7, 3, 1, 9, 7, 3];
  for (var i = 0; i < 7; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  total = 10 - total % 10;
  if (total == 10) total = 0;
  if (total == vatnumber.slice(7, 8)) return true;
  else return false;
};
const IEVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [8, 7, 6, 5, 4, 3, 2];
  if (/^\d[A-Z\*\+]/.test(vatnumber))
    vatnumber = "0" + vatnumber.substring(2, 7) + vatnumber.substring(0, 1) + vatnumber.substring(7, 8);
  for (var i = 0; i < 7; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  if (/^\d{7}[A-Z][AH]$/.test(vatnumber)) {
    if (vatnumber.charAt(8) == "H") total += 72;
    else total += 9;
  }
  total = total % 23;
  var totalChar;
  if (total == 0) totalChar = "W";
  else totalChar = String.fromCharCode(total + 64);
  if (totalChar == vatnumber.slice(7, 8)) return true;
  else return false;
};
const ITVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [1, 2, 1, 2, 1, 2, 1, 2, 1, 2];
  var temp;
  if (Number(vatnumber.slice(0, 7)) == 0) return false;
  temp = Number(vatnumber.slice(7, 10));
  if (temp < 1 || temp > 201 && temp != 999 && temp != 888) return false;
  for (var i = 0; i < 10; i++) {
    temp = Number(vatnumber.charAt(i)) * multipliers[i];
    if (temp > 9) total += Math.floor(temp / 10) + temp % 10;
    else total += temp;
  }
  total = 10 - total % 10;
  if (total > 9) {
    total = 0;
  }
  if (total == vatnumber.slice(10, 11)) return true;
  else return false;
};
const LTVATCheckDigit = (vatnumber) => {
  if (vatnumber.length == 9) {
    if (!/^\d{7}1/.test(vatnumber)) return false;
    var total = 0;
    for (var i = 0; i < 8; i++) total += Number(vatnumber.charAt(i)) * (i + 1);
    if (total % 11 == 10) {
      var multipliers = [3, 4, 5, 6, 7, 8, 9, 1];
      total = 0;
      for (i = 0; i < 8; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
    }
    total = total % 11;
    if (total == 10) {
      total = 0;
    }
    if (total == vatnumber.slice(8, 9)) return true;
    else return false;
  } else {
    if (!/^\d{10}1/.test(vatnumber)) return false;
    var total = 0;
    var multipliers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1, 2];
    for (var i = 0; i < 11; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
    if (total % 11 == 10) {
      var multipliers = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3, 4];
      total = 0;
      for (i = 0; i < 11; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
    }
    total = total % 11;
    if (total == 10) {
      total = 0;
    }
    if (total == vatnumber.slice(11, 12)) return true;
    else return false;
  }
};
const LUVATCheckDigit = (vatnumber) => {
  if (vatnumber.slice(0, 6) % 89 == vatnumber.slice(6, 8)) return true;
  else return false;
};
const LVVATCheckDigit = (vatnumber) => {
  if (/^[0-3]/.test(vatnumber)) {
    if (/^[0-3][0-9][0-1][0-9]/.test(vatnumber)) return true;
    else return false;
  } else {
    var total = 0;
    var multipliers = [9, 1, 4, 8, 3, 10, 2, 5, 7, 6];
    for (var i = 0; i < 10; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
    if (total % 11 == 4 && vatnumber[0] == "9") total = total - 45;
    if (total % 11 == 4) total = 4 - total % 11;
    else if (total % 11 > 4) total = 14 - total % 11;
    else if (total % 11 < 4) total = 3 - total % 11;
    if (total == vatnumber.slice(10, 11)) return true;
    else return false;
  }
};
const MTVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [3, 4, 6, 7, 8, 9];
  for (var i = 0; i < 6; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  total = 37 - total % 37;
  if (total == vatnumber.slice(6, 8) * 1) return true;
  else return false;
};
const NLVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [9, 8, 7, 6, 5, 4, 3, 2];
  for (var i = 0; i < 8; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  total = total % 11;
  if (total > 9) {
    total = 0;
  }
  if (total == vatnumber.slice(8, 9)) return true;
  else return false;
};
const NOVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [3, 2, 7, 6, 5, 4, 3, 2];
  for (var i = 0; i < 8; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  total = 11 - total % 11;
  if (total == 11) {
    total = 0;
  }
  if (total < 10) {
    if (total == vatnumber.slice(8, 9)) return true;
    else return false;
  }
  return false;
};
const PLVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  for (var i = 0; i < 9; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  total = total % 11;
  if (total > 9) {
    total = 0;
  }
  if (total == vatnumber.slice(9, 10)) return true;
  else return false;
};
const PTVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [9, 8, 7, 6, 5, 4, 3, 2];
  for (var i = 0; i < 8; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  total = 11 - total % 11;
  if (total > 9) {
    total = 0;
  }
  if (total == vatnumber.slice(8, 9)) return true;
  else return false;
};
const ROVATCheckDigit = (vatnumber) => {
  var multipliers = [7, 5, 3, 2, 1, 7, 5, 3, 2];
  var VATlen = vatnumber.length;
  multipliers = multipliers.slice(10 - VATlen);
  var total = 0;
  for (var i = 0; i < vatnumber.length - 1; i++) {
    total += Number(vatnumber.charAt(i)) * multipliers[i];
  }
  total = 10 * total % 11;
  if (total == 10) total = 0;
  if (total == vatnumber.slice(vatnumber.length - 1, vatnumber.length)) return true;
  else return false;
};
const RSVATCheckDigit = (vatnumber) => {
  var product = 10;
  var sum = 0;
  for (var i = 0; i < 8; i++) {
    sum = (Number(vatnumber.charAt(i)) + product) % 10;
    if (sum == 0) {
      sum = 10;
    }
    product = 2 * sum % 11;
  }
  if ((product + vatnumber.slice(8, 9) * 1) % 10 == 1) return true;
  else return false;
};
const RUVATCheckDigit = (vatnumber) => {
  if (vatnumber.length == 10) {
    var total = 0;
    var multipliers = [2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
    for (var i = 0; i < 10; i++) {
      total += Number(vatnumber.charAt(i)) * multipliers[i];
    }
    total = total % 11;
    if (total > 9) {
      total = total % 10;
    }
    if (total == vatnumber.slice(9, 10)) return true;
    else return false;
  } else if (vatnumber.length == 12) {
    var total1 = 0;
    var multipliers1 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
    var total2 = 0;
    var multipliers2 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
    for (var i = 0; i < 11; i++) total1 += Number(vatnumber.charAt(i)) * multipliers1[i];
    total1 = total1 % 11;
    if (total1 > 9) {
      total1 = total1 % 10;
    }
    for (var i = 0; i < 11; i++) total2 += Number(vatnumber.charAt(i)) * multipliers2[i];
    total2 = total2 % 11;
    if (total2 > 9) {
      total2 = total2 % 10;
    }
    if (total1 == vatnumber.slice(10, 11) && total2 == vatnumber.slice(11, 12))
      return true;
    else return false;
  }
  return false;
};
const SEVATCheckDigit = (vatnumber) => {
  var R = 0;
  var digit;
  for (var i = 0; i < 9; i = i + 2) {
    digit = Number(vatnumber.charAt(i));
    R += Math.floor(digit / 5) + digit * 2 % 10;
  }
  var S = 0;
  for (var i = 1; i < 9; i = i + 2) S += Number(vatnumber.charAt(i));
  var cd = (10 - (R + S) % 10) % 10;
  if (cd == vatnumber.slice(9, 10)) return true;
  else return false;
};
const SIVATCheckDigit = (vatnumber) => {
  var total = 0;
  var multipliers = [8, 7, 6, 5, 4, 3, 2];
  for (var i = 0; i < 7; i++) total += Number(vatnumber.charAt(i)) * multipliers[i];
  total = 11 - total % 11;
  if (total == 10) {
    total = 0;
  }
  if (total != 11 && total == vatnumber.slice(7, 8)) return true;
  else return false;
};
const SKVATCheckDigit = (vatnumber) => {
  if (Number(vatnumber) % 11 == 0) return true;
  else return false;
};
const VATCheckDigitFunctions = {
  ATVATCheckDigit,
  BEVATCheckDigit,
  BGVATCheckDigit,
  CHEVATCheckDigit,
  CYVATCheckDigit,
  CZVATCheckDigit,
  DEVATCheckDigit,
  DKVATCheckDigit,
  EEVATCheckDigit,
  ELVATCheckDigit,
  ESVATCheckDigit,
  EUVATCheckDigit,
  FIVATCheckDigit,
  FRVATCheckDigit,
  GBVATCheckDigit,
  HRVATCheckDigit,
  HUVATCheckDigit,
  IEVATCheckDigit,
  ITVATCheckDigit,
  LTVATCheckDigit,
  LUVATCheckDigit,
  LVVATCheckDigit,
  MTVATCheckDigit,
  NLVATCheckDigit,
  NOVATCheckDigit,
  PLVATCheckDigit,
  PTVATCheckDigit,
  ROVATCheckDigit,
  RSVATCheckDigit,
  RUVATCheckDigit,
  SEVATCheckDigit,
  SIVATCheckDigit,
  SKVATCheckDigit
};
function getReduxFormsStatus(state, formNames) {
  let isAllValid = true;
  const allValues = {};
  const allErrors = {};
  formNames.forEach((formName) => {
    const formValid = isValid(formName)(state);
    const formValues = getFormValues(formName)(state);
    const formErrors = getFormSyncErrors(formName)(state);
    if (!formValid) isAllValid = false;
    allValues[formName] = formValues || {};
    allErrors[formName] = formErrors || {};
  });
  return {
    isValid: isAllValid,
    values: allValues,
    errors: allErrors
  };
}
const EVENTS = {
  "page.viewed": "pageview",
  "product.viewed": "experience_view",
  "productList.viewed": "list_impression",
  "booking.stepViewed": "booking_step",
  "cart.itemAdded": "booking_step",
  "checkout.started": "booking_start",
  "checkout.stepViewed": "booking_step",
  "checkout.paymentInfoAdded": "add_payment_info",
  "cart.itemRemoved": "experience_remove",
  "cart.expired": "booking_expired",
  "checkout.completed": "purchase_experience",
  "checkout.paymentFailed": "payment_error",
  "promotion.viewed": "promo_view",
  "promotion.clicked": "promo_click",
  "cta.clicked": "click_cta",
  "link.clicked": "click_generic",
  "outbound.clicked": "click_outbound",
  "form.started": "form_start",
  "form.submitted": "form_submit",
  "form.errored": "form_error",
  "form.succeeded": "form_success"
};
function resolveAdobeEvent(name) {
  return EVENTS[name] ?? null;
}
function carriesProductList(event) {
  return event === "booking_start" || event === "booking_step" || event === "purchase_experience" || event === "booking_expired" || event === "add_payment_info";
}
const ADOBE_DATE_FORMAT = "MM-DD-YYYY";
const COMBINING_MARKS = /[\u0300-\u036f]/g;
function formatStringAdobe(text, separator = "") {
  if (!text) return "";
  const withoutAccents = text.normalize("NFD").replace(COMBINING_MARKS, "");
  const lowercased = withoutAccents.toLowerCase();
  const allowed = new RegExp(`[^a-z0-9 ${escapeForCharClass(separator)}]`, "g");
  return lowercased.replace(allowed, "").replace(/\s+/g, " ").trim();
}
function joinAdobe(parts, separator = ":") {
  return parts.map((part) => formatStringAdobe(part)).filter(Boolean).join(separator);
}
function formatNumberAdobe(value) {
  if (value === void 0 || value === null || value === "") return void 0;
  const numeric = typeof value === "number" ? value : Number(String(value).replace(",", "."));
  if (Number.isNaN(numeric)) return void 0;
  return numeric;
}
function formatDateAdobe(date, timeZone) {
  if (!date) return "";
  const parsed = timeZone ? moment.tz(date, timeZone) : moment(date);
  if (!parsed.isValid()) return "";
  return parsed.format(ADOBE_DATE_FORMAT);
}
function formatVisitDateAdobe(date) {
  if (!date) return void 0;
  const parsed = moment(date, ["YYYYMMDD", "YYYY-MM-DD"], true);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : void 0;
}
function omitEmpty(source) {
  return Object.fromEntries(
    Object.entries(source).filter(([, value]) => value !== "" && value !== void 0 && value !== null)
  );
}
function escapeForCharClass(separator) {
  return separator.replace(/[\\\]^-]/g, "\\$&");
}
function buildAdobePushes(event) {
  const adobeEvent = resolveAdobeEvent(event.name);
  if (!adobeEvent) return [];
  if (adobeEvent === "pageview") return [buildPageView(event)];
  if (adobeEvent === "promo_view" || adobeEvent === "promo_click") return [buildPromotion(adobeEvent, event)];
  if (adobeEvent === "payment_error") return [buildPaymentError(event)];
  if (adobeEvent === "experience_view") return [buildExperienceView(event)];
  if (adobeEvent === "experience_remove") return [buildExperienceRemove(event)];
  if (adobeEvent === "list_impression") return [buildListImpression(event)];
  if (isClickEvent(adobeEvent)) return [buildClick(adobeEvent, event)];
  if (isFormEvent(adobeEvent)) return [buildForm(adobeEvent, event)];
  return [buildProductListPush(adobeEvent, event)];
}
function formatPaymentAdobe(value) {
  return formatStringAdobe(value, "_");
}
function isClickEvent(event) {
  return event === "click_generic" || event === "click_cta" || event === "click_outbound";
}
function isFormEvent(event) {
  return event === "form_start" || event === "form_submit" || event === "form_error" || event === "form_success";
}
function buildClick(adobeEvent, event) {
  const interaction = event.payload.interaction ?? {};
  const push2 = { event: adobeEvent };
  const eventinfo = omitEmpty({
    event_category: formatStringAdobe(interaction.category),
    event_action: formatStringAdobe(interaction.action),
    event_label: formatStringAdobe(interaction.label)
  });
  if (Object.keys(eventinfo).length > 0) push2.eventinfo = eventinfo;
  if (adobeEvent === "click_cta" || adobeEvent === "click_outbound") {
    const componentes = omitEmpty({
      cta_name: formatStringAdobe(interaction.ctaName),
      cta_location: formatStringAdobe(interaction.ctaLocation),
      outbound_dest: adobeEvent === "click_outbound" ? interaction.outboundDest ?? "" : ""
    });
    if (Object.keys(componentes).length > 0) push2.componentes = componentes;
  }
  return push2;
}
function buildForm(adobeEvent, event) {
  const form2 = event.payload.form ?? {};
  const push2 = { event: adobeEvent };
  const eventinfo = omitEmpty({ event_category: formatStringAdobe(form2.category) });
  if (Object.keys(eventinfo).length > 0) push2.eventinfo = eventinfo;
  const componentes = omitEmpty({
    form_id: formatStringAdobe(form2.id),
    error_type: adobeEvent === "form_error" ? formatStringAdobe(form2.errorType) : "",
    form_success: adobeEvent === "form_success" ? formatStringAdobe(form2.success) : "",
    form_detail: formatStringAdobe(form2.detail)
  });
  if (Object.keys(componentes).length > 0) push2.componentes = componentes;
  return push2;
}
const SITE_BRAND = "MEGA";
function buildPageView(event) {
  const { page = {} } = event.payload;
  const [sub1, sub2, sub3, sub4, sub5] = page.subcategories ?? [];
  return {
    event: "pageview",
    page: omitEmpty({
      page_name: page.name ? formatStringAdobe(page.name, ":") : joinAdobe([SITE_BRAND, page.category, sub1, sub2], ":"),
      page_category: formatStringAdobe(page.category),
      page_subcategory1: formatStringAdobe(sub1),
      page_subcategory2: formatStringAdobe(sub2),
      page_subcategory3: formatStringAdobe(sub3),
      page_subcategory4: formatStringAdobe(sub4),
      page_subcategory5: formatStringAdobe(sub5),
      page_category_agg: formatStringAdobe(page.categoryAgg),
      content_section: formatStringAdobe(page.section),
      site_brand: SITE_BRAND,
      language: formatStringAdobe(page.language)
    }),
    // Always sent empty: the client maps this to their own CMP's consent state.
    // Not run through omitEmpty — the key must stay present even when empty.
    user: {
      consent_state: ""
    },
    // previous_page is a URL, same as url_page/url_referrer above: it must NOT go
    // through formatStringAdobe (strips ':', '/', '.' — turns
    // "https://foo.com/" into "httpsfoocom").
    navegacion: omitEmpty({
      url_page: page.url ?? "",
      url_page_sp: page.url ? page.url.split("?")[0] : "",
      url_referrer: page.referrer ?? "",
      previous_page: page.previous ?? ""
    })
  };
}
function buildPromotion(adobeEvent, event) {
  const promotion = event.payload.promotions?.[0];
  return omitEmpty({
    event: adobeEvent,
    page: omitEmpty({ page_name: formatStringAdobe(event.payload.page?.name, ":") }),
    eventinfo: omitEmpty({ internal_promo: formatStringAdobe(promotion?.name ?? promotion?.id) }),
    componentes: adobeEvent === "promo_click" ? omitEmpty({ cta_location: formatStringAdobe(promotion?.position) }) : void 0
  });
}
function buildPaymentError(event) {
  const { error, paymentType, items = [] } = event.payload;
  const push2 = {
    event: "payment_error",
    eventinfo: omitEmpty({ payment_status: formatStringAdobe(error?.status ?? "fail") }),
    componentes: omitEmpty({
      payment_error_code: formatStringAdobe(error?.code),
      error_type: formatStringAdobe(error?.type),
      payment_method: formatPaymentAdobe(paymentType)
    })
  };
  if (items.length > 0) {
    push2.product_list = items.map(
      (item) => omitEmpty({
        booking_id: formatStringAdobe(item.bookingId),
        experience_id: formatStringAdobe(item.id),
        experience_name: formatStringAdobe(item.name),
        price: formatNumberAdobe(item.price),
        quantity: formatNumberAdobe(item.quantity),
        prod_variant: formatStringAdobe(item.variant)
      })
    );
  }
  return push2;
}
function buildExperienceView(event) {
  const item = event.payload.items?.[0];
  return {
    event: "experience_view",
    componentes: omitEmpty({
      experience_id: formatStringAdobe(item?.id),
      experience_name: formatStringAdobe(item?.name),
      price: formatNumberAdobe(item?.price)
    })
  };
}
function buildExperienceRemove(event) {
  const { payload } = event;
  const item = payload.items?.[0];
  return omitEmpty({
    event: "experience_remove",
    eventinfo: {
      process_category: formatStringAdobe("Reserva"),
      process_name: formatStringAdobe("Quitar del carrito")
    },
    componentes: omitEmpty({
      experience_id: formatStringAdobe(item?.id),
      experience_name: formatStringAdobe(item?.name),
      price: formatNumberAdobe(item?.price),
      quantity: formatNumberAdobe(item?.quantity)
    })
  });
}
function buildListImpression(event) {
  const items = event.payload.items ?? [];
  const listName = items[0]?.listName?.replace(/-/g, " ");
  const push2 = {
    event: "list_impression",
    eventinfo: omitEmpty({
      process_category: formatStringAdobe("booking"),
      list_name: formatStringAdobe(listName)
    }),
    componentes: { list_size: items.length }
  };
  if (items.length > 0) {
    push2.product_list = items.map(
      (item) => omitEmpty({
        experience_id: formatStringAdobe(item.id),
        experience_name: formatStringAdobe(item.name),
        price: formatNumberAdobe(item.price),
        position: item.index
      })
    );
  }
  return push2;
}
function buildProductListPush(adobeEvent, event) {
  const { payload } = event;
  const items = payload.items ?? [];
  const push2 = { event: adobeEvent };
  if (adobeEvent === "booking_start" || adobeEvent === "booking_step" || adobeEvent === "add_payment_info") {
    const eventinfo = omitEmpty({
      process_category: formatStringAdobe(payload.processCategory),
      process_name: formatStringAdobe(payload.processName),
      process_step: formatStringAdobe(payload.stepName ?? String(payload.step ?? ""))
    });
    if (Object.keys(eventinfo).length > 0) push2.eventinfo = eventinfo;
  }
  if (adobeEvent === "booking_step") {
    push2.componentes = {
      payment_method: payload.paymentType ? formatPaymentAdobe(payload.paymentType) : void 0
    };
  }
  if (adobeEvent === "purchase_experience") {
    push2.componentes = omitEmpty({
      purchase_id: formatStringAdobe(payload.transactionId),
      payment_method: formatPaymentAdobe(payload.paymentType),
      payment_detail: formatPaymentAdobe(payload.paymentDetail),
      revenue: formatNumberAdobe(orderRevenue(payload)),
      quantity: formatNumberAdobe(totalQuantity(items)),
      // Literal dropdown text, (MEGA: ¿Cómo nos has conocido?)
      declared_source: payload.declaredSource || void 0,
      ...payload.attribution
    });
  }
  if (adobeEvent === "booking_expired") {
    push2.eventinfo = {
      process_category: formatStringAdobe("Reserva"),
      process_name: formatStringAdobe("Caducidad de reserva")
    };
    push2.componentes = omitEmpty({
      revenue: formatNumberAdobe(orderRevenue(payload)),
      quantity: formatNumberAdobe(totalQuantity(items))
    });
  }
  if (adobeEvent === "add_payment_info") {
    const first = items[0];
    push2.componentes = omitEmpty({
      experience_id: formatStringAdobe(first?.id),
      experience_name: formatStringAdobe(first?.name),
      payment_method: formatPaymentAdobe(payload.paymentType),
      payment_detail: formatPaymentAdobe(payload.paymentDetail),
      revenue: formatNumberAdobe(orderRevenue(payload)),
      quantity: formatNumberAdobe(totalQuantity(items))
    });
  }
  if (carriesProductList(adobeEvent) && items.length > 0) {
    push2.product_list = items.map((item) => buildProductLine(adobeEvent, item, payload));
  }
  return push2;
}
function buildProductLine(adobeEvent, item, payload) {
  if (adobeEvent === "booking_start") {
    return omitEmpty({
      experience_id: formatStringAdobe(item.id),
      experience_name: formatStringAdobe(item.name)
    });
  }
  if (adobeEvent === "booking_step") {
    return {
      ...omitEmpty({
        booking_id: formatStringAdobe(item.bookingId),
        experience_id: formatStringAdobe(item.id),
        experience_name: formatStringAdobe(item.name),
        price: formatNumberAdobe(item.price),
        quantity: formatNumberAdobe(item.quantity)
      }),
      // Kept OUT of omitEmpty (like `payment_method` in `componentes` above): the
      // client wants the key PRESENT with an undefined value while no buyer type
      // is selected yet, instead of the line missing `prod_variant` entirely.
      prod_variant: item.variant ? formatStringAdobe(item.variant) : void 0
    };
  }
  return omitEmpty({
    booking_id: formatStringAdobe(item.bookingId),
    experience_id: formatStringAdobe(item.id),
    experience_name: formatStringAdobe(item.name),
    price: formatNumberAdobe(item.price),
    quantity: formatNumberAdobe(item.quantity),
    prod_variant: formatStringAdobe(item.variant),
    // Visit data + buyer country, purchase_experience only (RLS-1); add_payment_info
    // doesn't get them, per the client's ask.
    ...adobeEvent === "purchase_experience" ? {
      visit_date: formatVisitDateAdobe(item.date),
      visit_time: item.time,
      buyer_country: formatStringAdobe(payload.buyerCountry)
    } : {}
  });
}
function orderRevenue(payload) {
  if (payload.total !== void 0) return payload.total;
  const items = payload.items ?? [];
  if (items.length === 0) return void 0;
  return items.reduce((sum, item) => sum + (item.price ?? 0) * (item.quantity ?? 1), 0);
}
function totalQuantity(items) {
  if (items.length === 0) return void 0;
  return items.reduce((sum, item) => sum + (item.quantity ?? 0), 0);
}
const DEFAULT_DATA_LAYER = "adobeDataLayer";
const DEDUPE_WINDOW_MS = 1500;
function createAdobeAdapter(config = {}) {
  const dataLayerName = config.dataLayerName ?? DEFAULT_DATA_LAYER;
  let lastKey = "";
  let lastAt = 0;
  return {
    id: "adobe",
    handle(event) {
      const pushes = buildAdobePushes(event);
      if (pushes.length === 0) return;
      const dataLayer = getDataLayer(dataLayerName);
      pushes.forEach((push2) => {
        const key = JSON.stringify(push2);
        const now = Date.now();
        if (key === lastKey && now - lastAt < DEDUPE_WINDOW_MS) return;
        lastKey = key;
        lastAt = now;
        dataLayer.push(push2);
      });
    }
  };
}
function getDataLayer(name) {
  const globalScope = window;
  globalScope[name] = globalScope[name] || [];
  return globalScope[name];
}
export {
  ADYEN_CHANNEL,
  ActionTypes,
  AdyenPaymentElement,
  BreadCrumbs,
  ButtonSelector,
  BuyerTypeItem$1 as BuyerTypeItem,
  BuyerTypeSelector$1 as BuyerTypeSelector,
  BuyerTypesContainer_default as BuyerTypesContainer,
  CALL_API,
  Calendar$1 as Calendar,
  CustomModal,
  DATETIME_FORMAT_DMYHM,
  DATETIME_FORMAT_DMYHM_COMMA,
  DATETIME_FORMAT_ISO_YMDHM,
  DATETIME_FORMAT_ISO_YMDHMS,
  DATETIME_FORMAT_ISO_YMDHMS_SPACE,
  DATETIME_FORMAT_YMDHM,
  DATETIME_FORMAT_YMDHMS,
  DATETIME_FORMAT_YMDHMS_COMPACT,
  DATETIME_PART_TO_SHOW,
  DATE_FORMAT_DAY_FULL,
  DATE_FORMAT_DAY_SHORT,
  DATE_FORMAT_DM,
  DATE_FORMAT_DMY,
  DATE_FORMAT_DMY_COMPACT,
  DATE_FORMAT_DM_LONG,
  DATE_FORMAT_MD_LONG,
  DATE_FORMAT_YEAR_MONTH,
  DATE_FORMAT_YMD,
  DATE_FORMAT_YMD_COMPACT,
  DateContainer_default as DateContainer,
  DateSelector$1 as DateSelector,
  Event,
  EventGroupSelector,
  EventSelector,
  EventUtils,
  EventsContainer_default as EventsContainer,
  FormField,
  FormSelectBasicField,
  FormattedDate_default as FormattedDate,
  FormattedDateTime_default as FormattedDateTime,
  FormattedPrice,
  FormattedTime$1 as FormattedTime,
  Forms,
  FormsContainer_default as FormsContainer,
  FrontendMainPanel$1 as FrontendMainPanel,
  InfoType,
  LOCALE_MAP,
  Login,
  MainContainerLayout,
  Overlay,
  PAYMENT_METHODS_ORIGINS,
  PayBoxForm,
  ProductCheckoutContainer_default as ProductCheckoutContainer,
  ProductItem,
  ProductSubscription,
  PromotionSelector,
  PromotionsContainer$1 as PromotionsContainer,
  PromotionsEditContainer_default as PromotionsEditContainer,
  ProsaPaymentForm_default as ProsaPaymentForm,
  RedsysForm,
  RedsysInlinePayment_default as RedsysInlinePayment,
  Reports,
  ReservationFormContainer$1 as ReservationFormContainer,
  SIBSPaymentForm,
  SearchBar,
  SelectMode,
  ServiceSelector,
  ServicesContainer_default as ServicesContainer,
  Steps$1 as Steps,
  TIME_FORMAT_24H,
  TermsAndConditionsItem,
  TermsAndConditionsList,
  TicketFormContainer$1 as TicketFormContainer,
  VenueCapacitySelector,
  YunoCheckoutLite,
  allowSendCookie,
  api,
  auth,
  autoSelectEvent as autoSelect,
  buyerTypes,
  camelCase,
  cart,
  catalogueToItem,
  checkPortugueseId,
  checkSpanishId,
  checkVATNumber,
  cleanServicePrices,
  clearAdyenPaymentStorage,
  createAdobeAdapter,
  createYunoPayment,
  decryptClientKey,
  editReservation,
  encryptWebCookie,
  ensureAdyenIdempotencyKey,
  events,
  fetchAdyenPaymentMethods,
  fetchAllServicePrices,
  fetchEvents,
  fetchEventsAvailability,
  fetchServicePrices,
  form,
  formatDateAdobe,
  formatInTimeZone,
  formatNumberAdobe,
  formatString,
  formatStringAdobe,
  generalValidationsMemo,
  getAdyenPaymentMethods,
  getAppLocale,
  getCalendarLocaleConfig,
  getDisplayFormat,
  getEditServicesEventDatetime,
  getFirstDayOfWeek,
  getIntlCountryLocale,
  getIntlLocale,
  getItemCategory2CB,
  getItemCategoryCB,
  getItemNameCB,
  getItemVariantCB,
  getMinMaxTickets,
  getMomentLocale,
  getNowInTimeZone,
  getPaymentDetail,
  getPaymentType,
  getProductInfoMap,
  getProductInfos,
  getReduxFormsStatus,
  getResponseCode,
  getServiceSelectionMap,
  getTicketExtrasServices,
  getTicketsByBuyerTypeAndPromotion,
  hasServiceAnswerRequired,
  hasTrackingConsent,
  initMomentLocale,
  initYunoCheckoutByReference,
  initYunoCheckoutByWebcookie,
  isProviderEnabled,
  isValidPostalCode,
  loader,
  mapBookingStep,
  mapPageView,
  mapProduct,
  mapProductList,
  mapPromotions,
  mapTransaction,
  parseDateWithTimeZone,
  postAdyenPayment,
  postAdyenPaymentDetails,
  products,
  promotions,
  regexValidator,
  registerAdapter,
  reservations,
  resetAdapters,
  resetAdyenPaymentMethodsCache,
  resetYunoCheckout,
  resolveProviders,
  servicePrices,
  setCookie,
  submitAdyenPaymentDetails,
  toAllowedPaymentMethods,
  toAnalyticsItem,
  toAnalyticsItems,
  track,
  useAdyenAdvancedFlow,
  user,
  validateAdyenCheckoutInputs,
  withoutIncompleteDeliveryAddress,
  yunoCheckout
};
